/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 268);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(275);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(74)(module)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Loading=function Loading(_ref){var message=_ref.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"this-is-loading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"is-5"},message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-spin fa-spinner fa-3x black-text"}));};Loading.propTypes={message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return API2_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACERVO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return LOGIN_OK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return LOGIN_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return LOGIN_AGENCIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return LOGIN_CDMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return LOGIN_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return FORGOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return FORGOT_OK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return RESET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return RESET_OK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return REGISTER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return REGISTER_VALIDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return REGISTER_NOT_VALIDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return REGISTER_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return REGISTER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return PROFILE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return PROFILE_AGENCIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return PROFILE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return MENU_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return MENU_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return USERS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return USERS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return USER_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return USER_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return USER_AGENCIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return USER_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return USER_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return USER_SET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return PERMISSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return PERMISSIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return PERMISSIONS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return PERMISSIONS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return PERMISSIONS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return PERMISSIONS_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return PERMISSION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return VERSIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return VERSIONS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return VERSIONS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return VERSIONS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return VERSION_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return VERSION_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return VERSION_GROUPS_PHASES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return VERSION_GROUPS_PHASES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return VERSION_GROUPS_PHASES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return VERSION_GROUPS_PHASES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return PHASES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return PHASES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return PHASES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return PHASE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return PHASES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return GROUPS_PHASES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return GROUPS_PHASES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return GROUPS_PHASES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return GROUPS_PHASES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return GROUPS_PHASES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DOCUMENTS_TYPES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DOCUMENTS_TYPES; });
/* unused harmony export DOCUMENTS_TYPES_EDIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DOCUMENTS_TYPES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return ROLES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return ROLES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return ROLES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return ROLE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return ROLE_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return ROLES_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return ROLES_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return ROLES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return ROLE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return GOALS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return GOALS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return GOALS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return GOAL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return GOAL_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return GOAL_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return GOAL_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return GOAL_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return GOAL_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return AXIS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return AXIS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return AXIS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return AXIS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return AXIS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return LINES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return LINES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return LINES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return LINES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return LINES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return LINES_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return OBJECTIVES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return OBJECTIVES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return OBJECTIVES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return OBJECTIVES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return OBJECTIVES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return STRATEGIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return STRATEGIES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return STRATEGIES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return STRATEGIES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return STRATEGIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return STATUS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return STATUS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return STATUS_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ACTIVITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTIVITIES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVITIES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACTIVITY_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ACTIVITY_VERIFICATION_MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACTIVITY_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACTIVITY_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ACTIVITY_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ACTIVITY_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ACTIVITY_GROUP_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ACTIVITY_GROUP_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CONCEPTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CONCEPTS_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CONCEPTS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CONCEPT_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CONCEPT_UNITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CONCEPT_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CONCEPT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return UNIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return UNITS_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return UNIT_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return UNIT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return VERIFICATION_MEDIA_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return VERIFICATION_MEDIA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return VERIFICATION_MEDIA_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return MODAL_NOTIFICATION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return MODAL_NOTIFICATION_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return NOTIFICATION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return NOTIFICATION_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return ENTITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return ENTITIES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return ENTITIES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return ENTITIES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return ENTITIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return MUNICIPALITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return MUNICIPALITIES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return MUNICIPALITIES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return MUNICIPALITIES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return MUNICIPALITIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return MUNICIPALITIES_FILTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return AGENCIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return AGENCIES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AGENCIES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return AGENCIES_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return AGENCIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return AGENCIES_MUNICIPALITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return AGENCIES_MUNICIPALITIES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return AMOUNTS_AGENCIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return AMOUNTS_AGENCIES_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return AMOUNTS_AGENCIES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return AMOUNTS_AGENCIES_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return AMOUNTS_AGENCIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return PROJECTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return PROJECTS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return PROJECTS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return PROJECTS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return PROJECTS_GOALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return PROJECTS_EXPENSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return PROJECTS_EMPLOYEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return PROJECTS_EMPLOYEES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return PROJECTS_COMMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return PROJECTS_PHASES_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return PROJECTS_PHASES_GROUPS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return PROJECTS_EDIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return PROJECT_SET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return PROJECTS_FOLIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return PROJECTS_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return PROJECTS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return PROJECTS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return PROJECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return PROJECT_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return PROJECT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return PROJECT_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return PROJECT_OWNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return PROJECT_OWNER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return PROJECT_OWNER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return PROJECT_OWNER_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return PROJECT_INSTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return PROJECT_INSTANCE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return PROJECT_INSTANCE_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return PROJECT_INSTANCE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return PROJECT_INSTANCE_CLEAR; });
/* unused harmony export PROJECT_REGISTRY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return PROJECT_REGISTRY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return PROJECT_REGISTRY_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return PROJECT_REGISTRY_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return PROJECT_REGISTRY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return PROJECT_REGISTRY_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return PROJECT_REGISTRY_DATA_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return PROJECT_REGISTRY_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return PROJECT_PROIGUALDAD_GOALS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return PROJECT_PROIGUALDAD_GOALS_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return PROJECT_PROIGUALDAD_GOALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return PROJECT_PROIGUALDAD_GOALS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return PROJECT_PROIGUALDAD_GOALS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return PROJECT_PROIGUALDAD_GOALS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return PROJECT_EXPENSES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return PROJECT_EXPENSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return PROJECT_EXPENSES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return PROJECT_EXPENSES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return PROJECT_EMPLOYEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return PROJECT_EMPLOYEES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return PROJECT_EMPLOYEES_EDIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return PROJECT_EMPLOYEES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return PROJECT_EMPLOYEES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return PROJECT_CONCLUSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return PROJECT_CONCLUSION_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return PROJECT_CONCLUSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return PROJECT_CONCLUSION_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return PROJECT_CONCLUSION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return PROJECT_AGREEMENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return PROJECT_AGREEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return PROJECT_AGREEMENTS_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return PROJECT_AGREEMENTS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return PROJECT_AGREEMENTS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return PROJECT_DISPERSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return PROJECT_DISPERSIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return PROJECT_DISPERSIONS_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return PROJECT_DISPERSIONS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return PROJECT_DISPERSIONS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DIRECTORIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DIRECTORIES_CONAGO_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return DIRECTORIES_ACTORS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return DIRECTORIES_ACTORS_GROUPS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return DIRECTORIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return RESOURCE_CONCEPT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return RESOURCE_CONCEPT_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return RESOURCE_CONCEPT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return REVISION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return REVISION_OWNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return REVISION_INSTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return REVISION_REGISTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return REVISION_EXPENSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return REVISION_PROFILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return REVISION_CONCLUSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return REVISION_CONCLUSION_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return REVISION_AGREEMENTS_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return REVISION_AGREEMENTS_ADMIN_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return REVISION_AGREEMENTS_LEGAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return REVISION_AGREEMENTS_LEGAL_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return REVISION_REPORTS_FINANCIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return REVISION_REPORTS_EXPENSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return REVISION_REPORTS_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return REVISION_COMMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return REVISION_COMMISSION_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return REVISION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return REVISION_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return REVISION_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return MODALITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return MODALITIES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return MODALITIES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return NOTIFICATION_MESSAGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return NOTIFICATION_MESSAGES_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return NOTIFICATION_STATES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return NOTIFICATION_STATES_SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return NOTIFICATION_MESSAGES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return NOTIFICATION_MESSAGES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return NOTIFICATION_MESSAGES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return NOTIFICATION_TYPES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return NOTIFICATION_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return NOTIFICATION_TYPE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return NOTIFICATION_TYPE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return NOTIFICATION_TYPE_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return NOTIFICATION_TYPE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return SURVEYS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return SURVEYS_TYPES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return SURVEYS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return SURVEYS_FETCH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return SURVEYS_FETCH_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return SURVEYS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return SURVEYS_QUESTIONS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return SURVEYS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return SURVEYS_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return SURVEYS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return REPORTS_FINANCIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return REPORTS_FINANCIAL_GOAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return REPORTS_FINANCIAL_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return REPORTS_FINANCIAL_EDIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return REPORTS_FINANCIAL_EDIT_FAIL; });
/* unused harmony export REPORTS_FINANCIAL_EDIT_INVOICE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return REPORTS_FINANCIAL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return REPORTS_FINANCIAL_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return REPORTS_FINANCIAL_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return REPORTS_EXPENSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return REPORTS_EXPENSES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return REPORTS_EXPENSES_EDIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return REPORTS_EXPENSES_EDIT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return REPORTS_EXPENSES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return REPORTS_EXPENSES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return REPORTS_EXPENSES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return REPORTS_EMPLOYEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return REPORTS_EMPLOYEES_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return REPORTS_EMPLOYEES_EDIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return REPORTS_EMPLOYEES_EDIT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return REPORTS_EMPLOYEES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return REPORTS_EMPLOYEES_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return REPORTS_EMPLOYEES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return REPORTS_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return REPORTS_SUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return REPORTS_SUMMARY_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return REPORTS_SUMMARY_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return REPORTS_SUMMARY_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return REPORTS_SURVEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return REPORTS_SURVEYS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return REPORTS_SURVEYS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return REPORTS_SURVEYS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CDM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CDM_EMPLOYEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CDM_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CDM_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return projectInitNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return projectsEditInitNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return reportsInitNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return revisionReportsInitNav; });
/* unused harmony export ETRANS */
/* API */var auth_url_config='';var api_url_config='';var api2_url_config='';console.log(window.location.hostname);if(window.location.hostname==='test.proequidad.inmujeres.gob.mx'||window.location.hostname==='proequidad2019.inmujeres.gob.mx'){auth_url_config='http://api.proequidad.inmujeres.gob.mx';api_url_config='http://api.proequidad.inmujeres.gob.mx/api/v1';api2_url_config='http://api.proequidad.inmujeres.gob.mx/api/v2';}else if(window.location.hostname==='proequidad.qa.cantaloop.mx'){auth_url_config='http://api.proequidad.qa.cantaloop.mx';api_url_config='http://api.proequidad.qa.cantaloop.mx/api/v1';api2_url_config='http://api.proequidad.qa.cantaloop.mx/api/v2';}else if(window.location.hostname==='proequidad.dev.cantaloop.mx'){auth_url_config='http://api.proequidad.dev.cantaloop.mx';api_url_config='http://api.proequidad.dev.cantaloop.mx/api/v1';api2_url_config='http://api.proequidad.dev.cantaloop.mx/api/v2';}else if(window.location.hostname==="proequidadqa.inmujeres.gob.mx"){auth_url_config='https://proequidadqa.inmujeres.gob.mx/api';api_url_config='https://proequidadqa.inmujeres.gob.mx/api/api/v1';api2_url_config='https://proequidadqa.inmujeres.gob.mx/api/api/v2';}else{auth_url_config='https://proequidadqa.inmujeres.gob.mx/api';api_url_config='https://proequidadqa.inmujeres.gob.mx/api/api/v1';api2_url_config='https://proequidadqa.inmujeres.gob.mx/api/api/v2';// auth_url_config = 'http://api.proequidad.dev.cantaloop.mx';
// api_url_config = 'http://api.proequidad.dev.cantaloop.mx/api/v1';
// api2_url_config = 'http://api.proequidad.dev.cantaloop.mx/api/v2';
}var AUTH_URL=auth_url_config;var API_URL=api_url_config;var API2_URL=api2_url_config;var ACERVO_URL=api2_url_config+'/acervo';/* LOGIN */var LOGIN_REQUEST='LOGIN_REQUEST';var LOGIN_OK='LOGIN_OK';var LOGIN_USER='LOGIN_USER';var LOGIN_AGENCIES='LOGIN_AGENCIES';var LOGIN_CDMS='LOGIN_CDMS';var LOGIN_FAIL='LOGIN_FAIL';var LOGOUT='LOGOUT';var FORGOT_REQUEST='FORGOT_REQUEST';var FORGOT_OK='FORGOT_OK';var RESET_REQUEST='RESET_REQUEST';var RESET_OK='RESET_OK';/*REGISTER*/var REGISTER_REQUEST='REGISTER_REQUEST';var REGISTER_VALIDATE='REGISTER_VALIDATE';var REGISTER_NOT_VALIDATE='REGISTER_NOT_VALIDATE';var REGISTER_COMPLETE='REGISTER_COMPLETE';var REGISTER_FAIL='REGISTER_FAIL';/* USER PROFILE */var PROFILE_REQUEST='PROFILE_REQUEST';var PROFILE_SHOW='PROFILE_SHOW';var PROFILE_AGENCIES='PROFILE_AGENCIES';var PROFILE_FAIL='PROFILE_FAIL';/* MENU */var MENU_SHOW='MENU_SHOW';var MENU_HIDE='MENU_HIDE';/* USERS */var USERS_REQUEST='USERS_REQUEST';var USERS_FAIL='USERS_FAIL';var USERS_SHOW='USERS_SHOW';var USER_EDIT='USER_EDIT';var USER_ROLE='USER_ROLE';var USER_AGENCIES='USER_AGENCIES';var USER_COMPLETE='USER_COMPLETE';var USER_CLEAR='USER_CLEAR';var USER_SET_SEARCH='USER_SET_SEARCH';/* PERMISSIONS */var PERMISSION_REQUEST='PERMISSION_REQUEST';var PERMISSIONS_SHOW='PERMISSIONS_SHOW';var PERMISSIONS_LIST='PERMISSIONS_LIST';var PERMISSIONS_EDIT='PERMISSIONS_EDIT';var PERMISSIONS_CLEAR='PERMISSIONS_CLEAR';var PERMISSIONS_DELETE='PERMISSIONS_DELETE';var PERMISSION_FAIL='PERMISSION_FAIL';/* VERSIONS */var VERSIONS_REQUEST='VERSIONS_REQUEST';var VERSIONS_SHOW='VERSIONS_SHOW';var VERSIONS_LIST='VERSIONS_LIST';var VERSIONS_FAIL='VERSIONS_FAIL';var VERSION_EDIT='VERSION_EDIT';var VERSION_CLEAR='VERSION_CLEAR';/*VERSION GROUPS PHASES*/var VERSION_GROUPS_PHASES_REQUEST='VERSION_GROUPS_PHASES_REQUEST';var VERSION_GROUPS_PHASES_EDIT='VERSION_GROUPS_PHASES_EDIT';var VERSION_GROUPS_PHASES_CLEAR='VERSION_GROUPS_PHASES_CLEAR';var VERSION_GROUPS_PHASES_FAIL='VERSION_GROUPS_PHASES_FAIL';/* PHASES */var PHASES_REQUEST='PHASES_REQUEST';var PHASES_SHOW='PHASES_SHOW';var PHASES_LIST='PHASES_LIST';var PHASE_EDIT='PHASE_EDIT';var PHASES_FAIL='PHASES_FAIL';/* GROUPS PHASES */var GROUPS_PHASES_REQUEST='GROUPS_PHASES_REQUEST';var GROUPS_PHASES_LIST='GROUPS_PHASES_LIST';var GROUPS_PHASES_EDIT='GROUPS_PHASES_EDIT';var GROUPS_PHASES_CLEAR='GROUPS_PHASES_CLEAR';var GROUPS_PHASES_FAIL='GROUPS_PHASES_FAIL';/*DOCUMENTS TYPES*/var DOCUMENTS_TYPES_REQUEST='DOCUMENTS_TYPES_REQUEST';var DOCUMENTS_TYPES='DOCUMENTS_TYPES';var DOCUMENTS_TYPES_EDIT='DOCUMENTS_TYPES_EDIT';var DOCUMENTS_TYPES_FAIL='DOCUMENTS_TYPES_FAIL';/* ROLES */var ROLES_REQUEST='ROLES_REQUEST';var ROLES_SHOW='ROLES_SHOW';var ROLES_LIST='ROLES_LIST';var ROLE_EDIT='ROLE_EDIT';var ROLE_PERMISSIONS='ROLE_PERMISSIONS';var ROLES_DELETE='ROLES_DELETE';var ROLES_COMPLETE='ROLES_COMPLETE';var ROLES_CLEAR='ROLES_CLEAR';var ROLE_FAIL='ROLE_FAIL';/* PROIGUALDAD GOALS*/var GOALS_REQUEST='GOALS_REQUEST';var GOALS_SHOW='GOALS_SHOW';var GOALS_FETCH='GOALS_FETCH';var GOAL_EDIT='GOAL_EDIT';var GOAL_ACTIVITIES='GOAL_ACTIVITIES';var GOAL_COMPLETE='GOAL_COMPLETE';var GOAL_DELETE='GOAL_DELETE';var GOAL_CLEAR='GOAL_CLEAR';var GOAL_FAIL='GOAL_FAIL';/*PROIGUALDAD AXIS */var AXIS_REQUEST='AXIS_REQUEST';var AXIS_SHOW='AXIS_SHOW';var AXIS_EDIT='AXIS_EDIT';var AXIS_CLEAR='AXIS_CLEAR';var AXIS_FAIL='AXIS_FAIL';/*PROIGUALDAD LINES */var LINES_REQUEST='LINES_REQUEST';var LINES_SHOW='LINES_SHOW';var LINES_EDIT='LINES_EDIT';var LINES_CLEAR='LINES_CLEAR';var LINES_FAIL='LINES_FAIL';var LINES_COMPLETE='LINES_COMPLETE';/*PROIGUALDAD OBJECTIVES*/var OBJECTIVES_REQUEST='OBJECTIVES_REQUEST';var OBJECTIVES_SHOW='OBJECTIVES_SHOW';var OBJECTIVES_EDIT='OBJECTIVES_EDIT';var OBJECTIVES_CLEAR='OBJECTIVES_CLEAR';var OBJECTIVES_FAIL='OBJECTIVES_FAIL';/*PROIGUALDAD STRATEGIES*/var STRATEGIES_REQUEST='STRATEGIES_REQUEST';var STRATEGIES_SHOW='STRATEGIES_SHOW';var STRATEGIES_EDIT='STRATEGIES_EDIT';var STRATEGIES_CLEAR='STRATEGIES_CLEAR';var STRATEGIES_FAIL='STRATEGIES_FAIL';/* STATUS */var STATUS_REQUEST='STATUS_REQUEST';var STATUS_FETCH='STATUS_FETCH';var STATUS_FAIL='STATUS_FAIL';var STATUS_GROUP='STATUS_GROUP';/*ACTIVITIES*/var ACTIVITY_REQUEST='ACTIVITY_REQUEST';var ACTIVITIES_SHOW='ACTIVITIES_SHOW';var ACTIVITIES_LIST='ACTIVITIES_LIST';var ACTIVITY_EDIT='ACTIVITY_EDIT';var ACTIVITY_VERIFICATION_MEDIA='ACTIVITY_VERIFICATION_MEDIA';var ACTIVITY_COMPLETE='ACTIVITY_COMPLETE';var ACTIVITY_CLEAR='ACTIVITY_CLEAR';var ACTIVITY_FAIL='ACTIVITY_FAIL';/*ACTIVITIES GROUPS*/var ACTIVITY_GROUP_REQUEST='ACTIVITY_GROUP_REQUEST';var ACTIVITY_GROUP_SHOW='ACTIVITY_SHOW';var ACTIVITY_GROUP_FAIL='ACTIVITY_FAIL';/*CONCEPTS*/var CONCEPTS_REQUEST='CONCEPTS_REQUEST';var CONCEPTS_COMPLETE='CONCEPTS_COMPLETE';var CONCEPTS_SHOW='CONCEPTS_SHOW';var CONCEPT_EDIT='CONCEPT_EDIT';var CONCEPT_UNITS='CONCEPT_UNITS';var CONCEPT_CLEAR='CONCEPT_CLEAR';var CONCEPT_FAIL='CONCEPT_FAIL';/*UNITS*/var UNIT_REQUEST='UNIT_REQUEST';var UNITS_SHOW='UNIT_SHOW';var UNIT_EDIT='UNIT_EDIT';var UNIT_FAIL='UNIT_FAIL';/*VERIFICATION-MEDIA*/var VERIFICATION_MEDIA_SHOW='VERIFICATION_MEDIA_SHOW';var VERIFICATION_MEDIA_REQUEST='VERIFICATION_MEDIA_REQUEST';var VERIFICATION_MEDIA_FAIL='VERIFICATION_MEDIA_FAIL';/*MODAL*/var MODAL_SHOW='MODAL_SHOW';var MODAL_HIDE='MODAL_HIDE';var MODAL_NOTIFICATION_SET='MODAL_NOTIFICATION_SET';var MODAL_NOTIFICATION_CLEAR='MODAL_NOTIFICATION_CLEAR';/* NOTIFICATIONS */var NOTIFICATION_SET='NOTIFICATION_SET';var NOTIFICATION_CLEAR='NOTIFICATION_CLEAR';/* STATES */var ENTITIES_REQUEST='ENTITIES_REQUEST';var ENTITIES_SHOW='ENTITIES_SHOW';var ENTITIES_FETCH='ENTITIES_FETCH';var ENTITIES_EDIT='ENTITIES_EDIT';var ENTITIES_FAIL='ENTITIES_FAIL';/* MUNICIPALITIES */var MUNICIPALITIES_REQUEST='MUNICIPALITIES_REQUEST';var MUNICIPALITIES_SHOW='MUNICIPALITIES_SHOW';var MUNICIPALITIES_FETCH='MUNICIPALITIES_FETCH';var MUNICIPALITIES_EDIT='MUNICIPALITIES_EDIT';var MUNICIPALITIES_FAIL='MUNICIPALITIES_FAIL';var MUNICIPALITIES_FILTERED='MUNICIPALITIES_FILTERED';/* AGENCIES */var AGENCIES_REQUEST='AGENCIES_REQUEST';var AGENCIES_SHOW='AGENCIES_SHOW';//export const AGENCIES_FETCH = 'AGENCIES_FETCH';
var AGENCIES_EDIT='AGENCIES_EDIT';var AGENCIES_COMPLETE='AGENCIES_COMPLETE';var AGENCIES_FAIL='AGENCIES_FAIL';/*AGENCIES MUNICIPALITIES*/var AGENCIES_MUNICIPALITIES_REQUEST='AGENCIES_MUNICIPALITIES_REQUEST';var AGENCIES_MUNICIPALITIES_FETCH='AGENCIES_MUNICIPALITIES_FETCH';/*AMOUNTS AGENCIES*/var AMOUNTS_AGENCIES_REQUEST='AMOUNTS_AGENCIES_REQUEST';var AMOUNTS_AGENCIES_SHOW='AMOUNTS_AGENCIES_SHOW';var AMOUNTS_AGENCIES_EDIT='AMOUNTS_AGENCIES_EDIT';var AMOUNTS_AGENCIES_COMPLETE='AMOUNTS_AGENCIES_COMPLETE';var AMOUNTS_AGENCIES_FAIL='AMOUNTS_AGENCIES_FAIL';/* PROJECTS CRUD */var PROJECTS_REQUEST='PROJECTS_REQUEST';var PROJECTS_FETCH='PROJECTS_FETCH';var PROJECTS_LIST='PROJECTS_LIST';var PROJECTS_EDIT='PROJECTS_EDIT';var PROJECTS_GOALS='PROJECTS_GOALS';var PROJECTS_EXPENSES='PROJECTS_EXPENSES';var PROJECTS_EMPLOYEES='PROJECTS_EMPLOYEES';var PROJECTS_EMPLOYEES_EDIT='PROJECTS_EMPLOYEES_EDIT';var PROJECTS_COMMISSIONS='PROJECTS_COMMISSIONS';var PROJECTS_PHASES_GROUPS='PROJECTS_PHASES_GROUPS';var PROJECTS_PHASES_GROUPS_EDIT='PROJECTS_PHASES_GROUPS_EDIT';//export const PROJECTS_COMMISSION = 'PROJECTS_COMMISSION';
var PROJECTS_EDIT_REQUEST='PROJECTS_EDIT_REQUEST';var PROJECT_SET_SEARCH='PROJECT_SET_SEARCH';//export const PROJECT_CHANGE_TAB_DATA = 'PROJECT_CHANGE_TAB_DATA';
var PROJECTS_FOLIOS='PROJECTS_FOLIOS';var PROJECTS_COMPLETE='PROJECTS_COMPLETE';var PROJECTS_CLEAR='PROJECTS_CLEAR';var PROJECTS_FAIL='PROJECTS_FAIL';/* PROJECTS REGISTER */var PROJECT_REQUEST='PROJECT_REQUEST';var PROJECT_CLEAR='PROJECT_CLEAR';var PROJECT_FAIL='PROJECT_FAIL';var PROJECT_LOADED='PROJECT_LOADED';var PROJECT_OWNER='PROJECT_OWNER';var PROJECT_OWNER_REQUEST='PROJECT_OWNER_REQUEST';var PROJECT_OWNER_FAIL='PROJECT_OWNER_FAIL';var PROJECT_OWNER_CLEAR='PROJECT_OWNER_CLEAR';var PROJECT_INSTANCE='PROJECT_INSTANCE';var PROJECT_INSTANCE_REQUEST='PROJECT_INSTANCE_REQUEST';var PROJECT_INSTANCE_LOADED='PROJECT_INSTANCE_LOADED';var PROJECT_INSTANCE_FAIL='PROJECT_INSTANCE_FAIL';var PROJECT_INSTANCE_CLEAR='PROJECT_INSTANCE_CLEAR';var PROJECT_REGISTRY='PROJECT_REGISTRY';var PROJECT_REGISTRY_REQUEST='PROJECT_REGISTRY_REQUEST';var PROJECT_REGISTRY_FAIL='PROJECT_REGISTRY_FAIL';var PROJECT_REGISTRY_CLEAR='PROJECT_REGISTRY_CLEAR';var PROJECT_REGISTRY_DATA='PROJECT_REGISTRY_DATA';var PROJECT_REGISTRY_DATA_REQUEST='PROJECT_REGISTRY_DATA_REQUEST';var PROJECT_REGISTRY_DATA_FAIL='PROJECT_REGISTRY_DATA_FAIL';var PROJECT_REGISTRY_LOADED='PROJECT_REGISTRY_LOADED';var PROJECT_PROIGUALDAD_GOALS_REQUEST='PROJECT_PROIGUALDAD_GOALS_REQUEST';var PROJECT_PROIGUALDAD_GOALS_COMPLETE='PROJECT_PROIGUALDAD_GOALS_COMPLETE';var PROJECT_PROIGUALDAD_GOALS='PROJECT_PROIGUALDAD_GOALS';var PROJECT_PROIGUALDAD_GOALS_EDIT='PROJECT_PROIGUALDAD_GOALS_EDIT';var PROJECT_PROIGUALDAD_GOALS_CLEAR='PROJECT_PROIGUALDAD_GOALS_CLEAR';var PROJECT_PROIGUALDAD_GOALS_FAIL='PROJECT_PROIGUALDAD_GOALS_FAIL';var PROJECT_EXPENSES_REQUEST='PROJECT_EXPENSES_REQUEST';var PROJECT_EXPENSES='PROJECT_EXPENSES';var PROJECT_EXPENSES_CLEAR='PROJECT_EXPENSES_CLEAR';var PROJECT_EXPENSES_FAIL='PROJECT_EXPENSES_FAIL';var PROJECT_EMPLOYEES='PROJECT_EMPLOYEES';var PROJECT_EMPLOYEES_REQUEST='PROJECT_EMPLOYEES_REQUEST';var PROJECT_EMPLOYEES_EDIT_REQUEST='PROJECT_EMPLOYEES_EDIT_REQUEST';var PROJECT_EMPLOYEES_FAIL='PROJECT_EMPLOYEES_FAIL';//export const PROJECT_EMPLOYEES_ROLES = 'PROJECT_EMPLOYEES_ROLES';
var PROJECT_EMPLOYEES_CLEAR='PROJECT_EMPLOYEES_CLEAR';var PROJECT_CONCLUSION='PROJECT_CONCLUSION';var PROJECT_CONCLUSION_LOADED='PROJECT_CONCLUSION_LOADED';var PROJECT_CONCLUSION_REQUEST='PROJECT_CONCLUSION_REQUEST';var PROJECT_CONCLUSION_CLEAR='PROJECT_CONCLUSION_CLEAR';var PROJECT_CONCLUSION_FAIL='PROJECT_CONCLUSION_FAIL';/*PROJECT AGREEMENTS*/var PROJECT_AGREEMENTS_REQUEST='PROJECT_AGREEMENTS_REQUEST';var PROJECT_AGREEMENTS='PROJECT_AGREEMENTS';var PROJECT_AGREEMENTS_LOADED='PROJECT_AGREEMENTS_LOADED';var PROJECT_AGREEMENTS_FAIL='PROJECT_AGREEMENTS_FAIL';var PROJECT_AGREEMENTS_CLEAR='PROJECT_AGREEMENTS_CLEAR';/*PROJECT TRACING AGREEMENTS DISPERSIONS*/var PROJECT_DISPERSIONS='PROJECT_DISPERSIONS';var PROJECT_DISPERSIONS_REQUEST='PROJECT_DISPERSIONS_REQUEST';var PROJECT_DISPERSIONS_LOADED='PROJECT_DISPERSIONS_LOADED';var PROJECT_DISPERSIONS_CLEAR='PROJECT_DISPERSIONS_CLEAR';var PROJECT_DISPERSIONS_FAIL='PROJECT_DISPERSIONS_FAIL';/*DIRECTORIES*/var DIRECTORIES_REQUEST='DIRECTORIES_CONAGO_REQUEST';var DIRECTORIES_CONAGO_FETCH='DIRECTORIES_CONAGO_FETCH';var DIRECTORIES_ACTORS_FETCH='DIRECTORIES_ACTORS_FETCH';var DIRECTORIES_ACTORS_GROUPS_FETCH='DIRECTORIES_ACTORS_GROUPS_FETCH';var DIRECTORIES_FAIL='DIRECTORIES_ACTORS_FAIL';/* RESOURCE_CONCEPT */var RESOURCE_CONCEPT_REQUEST='RESOURCE_CONCEPT_REQUEST';var RESOURCE_CONCEPT_FETCH='RESOURCE_CONCEPT_FETCH';var RESOURCE_CONCEPT_FAIL='RESOURCE_CONCEPT_FAIL';/* REVISION */var REVISION_REQUEST='REVISION_REQUEST';var REVISION_OWNER='REVISION_OWNER';var REVISION_INSTANCE='REVISION_INSTANCE';var REVISION_REGISTRY='REVISION_REGISTRY';var REVISION_EXPENSES='REVISION_EXPENSES';var REVISION_PROFILES='REVISION_PROFILES';var REVISION_CONCLUSION='REVISION_CONCLUSION';var REVISION_CONCLUSION_EDIT='REVISION_CONCLUSION_EDIT';var REVISION_AGREEMENTS_ADMIN='REVISION_AGREEMENTS_ADMIN';var REVISION_AGREEMENTS_ADMIN_EDIT='REVISION_AGREEMENTS_ADMIN_EDIT';var REVISION_AGREEMENTS_LEGAL='REVISION_AGREEMENTS_LEGAL';var REVISION_AGREEMENTS_LEGAL_EDIT='REVISION_AGREEMENTS_LEGAL_EDIT';var REVISION_REPORTS_FINANCIAL='REVISION_REPORTS_FINANCIAL';var REVISION_REPORTS_EXPENSES='REVISION_REPORTS_EXPENSES';var REVISION_REPORTS_SUMMARY='REVISION_REPORTS_SUMMARY';var REVISION_COMMISSION='REVISION_COMMISSION';//export const REVISION_COMMISSION_SAVE = 'REVISION_COMMISSION_SAVE';
var REVISION_COMMISSION_CLEAR='REVISION_COMMISSION_CLEAR';var REVISION_FAIL='REVISION_FAIL';var REVISION_CLEAR='REVISION_CLEAR';var REVISION_COMPLETE='REVISION_COMPLETE';/*MODALITIES*/var MODALITIES_REQUEST='MODALITIES_REQUEST';var MODALITIES_FETCH='MODALITIES_FETCH';var MODALITIES_FAIL='MODALITIES_FAIL';/*NOTIFICATION MESSAGES*/var NOTIFICATION_MESSAGES_REQUEST='NOTIFICATION_MESSAGES_REQUEST';var NOTIFICATION_MESSAGES_COMPLETE='NOTIFICATION_MESSAGES_COMPLETE';var NOTIFICATION_STATES_REQUEST='NOTIFICATION_STATES_REQUEST';var NOTIFICATION_STATES_SAVE='NOTIFICATION_STATES_SAVE';var NOTIFICATION_MESSAGES_FETCH='NOTIFICATION_MESSAGES_FETCH';var NOTIFICATION_MESSAGES_FAIL='NOTIFICATION_MESSAGES_FAIL';var NOTIFICATION_MESSAGES_CLEAR='NOTIFICATION_MESSAGES_CLEAR';var NOTIFICATION_TYPES_FETCH='NOTIFICATION_TYPES_FETCH';/*NOTIFICATIONS TYPES*/var NOTIFICATION_TYPE_REQUEST='NOTIFICATION_TYPE_REQUEST';var NOTIFICATION_TYPE_SHOW='NOTIFICATION_TYPE_SHOW';var NOTIFICATION_TYPE_EDIT='NOTIFICATION_TYPE_EDIT';var NOTIFICATION_TYPE_CLEAR='NOTIFICATION_TYPE_CLEAR';var NOTIFICATION_TYPE_FAIL='NOTIFICATION_TYPE_FAIL';/*SURVEYS*/var SURVEYS_REQUEST='SURVEYS_REQUEST';var SURVEYS_TYPES_REQUEST='SURVEYS_TYPES_REQUEST';var SURVEYS_FETCH='SURVEYS_FETCH';var SURVEYS_FETCH_LIST='SURVEYS_FETCH_LIST';var SURVEYS_FETCH_TYPES='SURVEYS_FETCH_TYPES';var SURVEYS_EDIT='SURVEYS_EDIT';var SURVEYS_QUESTIONS_EDIT='SURVEYS_QUESTIONS_EDIT';var SURVEYS_CLEAR='SURVEYS_CLEAR';var SURVEYS_COMPLETE='SURVEYS_COMPLETE';var SURVEYS_FAIL='SURVEYS_FAIL';//REPORTS;
//export const REPORTS_REQUEST = 'REPORTS_REQUEST';
var REPORTS_FINANCIAL='REPORTS_FINANCIAL';var REPORTS_FINANCIAL_GOAL='REPORTS_FINANCIAL_GOAL';var REPORTS_FINANCIAL_ACTIVITY='REPORTS_FINANCIAL_ACTIVITY';var REPORTS_FINANCIAL_EDIT_REQUEST='REPORTS_FINANCIAL_EDIT_REQUEST';var REPORTS_FINANCIAL_EDIT_FAIL='REPORTS_FINANCIAL_EDIT_FAIL';var REPORTS_FINANCIAL_EDIT_INVOICE_FAIL='REPORTS_FINANCIAL_EDIT_INVOICE_FAIL';var REPORTS_FINANCIAL_REQUEST='REPORTS_FINANCIAL_REQUEST';var REPORTS_FINANCIAL_CLEAR='REPORTS_FINANCIAL_CLEAR';var REPORTS_FINANCIAL_FAIL='REPORTS_FINANCIAL_FAIL';var REPORTS_EXPENSES='REPORTS_EXPENSES';var REPORTS_EXPENSES_EDIT='REPORTS_EXPENSES_EDIT';var REPORTS_EXPENSES_EDIT_REQUEST='REPORTS_EXPENSES_EDIT_REQUEST';var REPORTS_EXPENSES_EDIT_FAIL='REPORTS_EXPENSES_EDIT_FAIL';var REPORTS_EXPENSES_REQUEST='REPORTS_EXPENSES_REQUEST';var REPORTS_EXPENSES_CLEAR='REPORTS_EXPENSES_CLEAR';var REPORTS_EXPENSES_FAIL='REPORTS_EXPENSES_FAIL';var REPORTS_EMPLOYEES='REPORTS_EMPLOYEES';var REPORTS_EMPLOYEES_EDIT='REPORTS_EMPLOYEES_EDIT';var REPORTS_EMPLOYEES_EDIT_REQUEST='REPORTS_EMPLOYEES_EDIT_REQUEST';var REPORTS_EMPLOYEES_EDIT_FAIL='REPORTS_EMPLOYEES_EDIT_FAIL';var REPORTS_EMPLOYEES_REQUEST='REPORTS_EMPLOYEES_REQUEST';var REPORTS_EMPLOYEES_CLEAR='REPORTS_EMPLOYEES_CLEAR';var REPORTS_EMPLOYEES_FAIL='REPORTS_EMPLOYEES_FAIL';var REPORTS_SUMMARY='REPORTS_SUMMARY';var REPORTS_SUMMARY_REQUEST='REPORTS_SUMMARY_REQUEST';var REPORTS_SUMMARY_CLEAR='REPORTS_SUMMARY_CLEAR';var REPORTS_SUMMARY_FAIL='REPORTS_SUMMARY_FAIL';var REPORTS_SUMMARY_COMPLETE='REPORTS_SUMMARY_COMPLETE';var REPORTS_SURVEYS='REPORTS_SURVEYS';var REPORTS_SURVEYS_REQUEST='REPORTS_SURVEYS_REQUEST';var REPORTS_SURVEYS_CLEAR='REPORTS_SURVEYS_CLEAR';var REPORTS_SURVEYS_FAIL='REPORTS_SURVEYS_FAIL';//export const REPORTS_SURVEYS_COMPLETE = 'REPORTS_SURVEYS_COMPLETE';
//export const REPORTS_FAIL = 'REPORTS_FAIL';*/
var CDM_REQUEST='CDM_REQUEST';var CDM_EMPLOYEES='CDM_EMPLOYEES';var CDM_CLEAR='CDM_CLEAR';var CDM_FAIL='CDM_FAIL';/* PASOS CAPTURA DE PROYECTO *//* @todo: No sé si esto esté bien hardcodeado aquí, pero lo voy a poner en las configuraciones a menos que veamos que sea prudende hacer un endpoint o algo */var projectInitNav=[{step:1,url:'/proyecto/:modality/titular/:state?/:municipality?',title:'Datos del Titular'},{step:2,url:'/proyecto/:modality/instancia/:state?/:municipality?',title:'Datos de la Instancia'},{step:3,url:'/proyecto/:modality/metas/:state?/:municipality?',title:'Datos del Proyecto'},{step:4,url:'/proyecto/:modality/gastos/:state?/:municipality?',title:'Gastos de Coordinación'},{step:5,url:'/proyecto/:modality/adicionales/:state?/:municipality?',title:'Datos Adicionales'},{step:6,url:'/proyecto/:modality/conclusion/:state?/:municipality?',title:'Conclusión'}];var projectsEditInitNav=[{step:1,url:'/proyectos/editar/datos/:id',title:'Administrar información del proyecto'},{step:2,url:'/proyectos/editar/metas/:id',title:'Administrar metas del proyecto'},{step:3,url:'/proyectos/editar/gastos/:id',title:'Administrar gastos de coordinación'},{step:4,url:'/proyectos/editar/personal/:id',title:'Administrar personal'},{step:5,url:'/proyectos/editar/encuesta-comisiones/:id',title:'Encuesta de comisiones'},{step:6,url:'/proyectos/editar/procesos/:id',title:'Administrar procesos'}];var reportsInitNav=[{step:1,url:'/informes/:modality/avance-fisico-financiero/:state?/:municipality?',title:'Avance físico financiero'},{step:2,url:'/informes/:modality/gastos-coordinacion/:state?/:municipality?',title:'Gastos de coordinación'},{step:3,url:'/informes/:modality/personas-contratadas/:state?/:municipality?',title:'Personas contratadas'},{step:4,url:'/informes/:modality/encuesta-calidad/:state?/:municipality?',title:'Encuesta de satisfacción'},{step:5,url:'/informes/:modality/resumen/:state?/:municipality?',title:'Resumen general'}];var revisionReportsInitNav=[{step:1,url:'/revision/:modality/avance-fisico-financiero/:state?/:municipality?',title:'Revision Avance físico financiero'},{step:2,url:'/revision/:modality/gastos-coordinacion/:state?/:municipality?',title:'Revision Gastos de coordinación'},{step:3,url:'/revision/:modality/resumen/:state?/:municipality?',title:'Resumen de informe'}];var ETRANS={pagination:{per_page:20},agencies:{types:{'federal':'federal','imef':'imef','imm':'imm','cdm':'cdm'}}};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_notification__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_navigation_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_user_opts_dropdown__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_navigation_subnavigation__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_navigation_subnavigation_cdms__ = __webpack_require__(456);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(SecuredComponent,data){var BaseLayout=function(_Component){_inherits(BaseLayout,_Component);_createClass(BaseLayout,[{key:"render",value:function render(){var _this2=this;var _props=this.props,notifications=_props.notifications,location=_props.location,session=_props.session,menu=_props.menu;var _props$match$params=this.props.match.params,modality=_props$match$params.modality,municipality=_props$match$params.municipality,state=_props$match$params.state;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_navigation_navigation__["a" /* default */],{agencies:Object.assign({},session.user.agencies),cdms:Object.assign({},session.user.cdms),items:Object.assign({},session.user.menu),show:menu.view,location:Object.assign({},location),key:"app-navigation-sidebar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"main-content",key:"main-website-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",{className:"navbar is-dark secondary-navigation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-menu navbar-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default.a,alt:"gob.mx",className:"app-gov-logo--image"})),session.user.version?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-menu navbar-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"title is-6 has-text-centered has-text-white"},session.user.version.name)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"main-nav--close",onClick:function onClick(){return _this2.toggleMenu();}},menu.view?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-left"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-right"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_user_opts_dropdown__["a" /* default */],{data:Object.assign({},session.user.profile)})),data&&data.subnav&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_navigation_subnavigation__["a" /* default */],{icon:data.subnav.icon,name:data.subnav.name,actions:data.subnav.actions,stateNav:data.stateNav,modality:modality,filter:this.state.filterType,filterChange:this.filterChange,stateChange:this.stateChange,agencies:session.user.agencies,changeStates:this.changeStates,changeMuns:this.changeMuns,agenciable:{state:this.state.showState,municipality:municipality}}),data&&data.subcdmnav&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_navigation_subnavigation_cdms__["a" /* default */],{icon:data.subcdmnav.icon,name:data.subcdmnav.name,actions:data.subcdmnav.actions,stateNav:data.stateNav,stateChange:this.stateChange,cdms:session.user.cdms,changeStates:this.changeCdmStates,changeMuns:this.changeCdmMuns,agenciable:{state:state,municipality:municipality}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"app-layout--content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-1 main-title",dangerouslySetInnerHTML:{__html:data&&data.title?data.title:''}}),notifications.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10-desktop"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_notification__["a" /* default */],notifications))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecuredComponent,this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:'50px'}},"\xA0")))];}}]);function BaseLayout(props){_classCallCheck(this,BaseLayout);var _this=_possibleConstructorReturn(this,(BaseLayout.__proto__||Object.getPrototypeOf(BaseLayout)).call(this,props));_this.state={profileShow:false,showState:props.match.params.state,filterType:'all_projects'};_this.toggleMenu=_this.toggleMenu.bind(_this);_this.filterChange=_this.filterChange.bind(_this);_this.stateChange=_this.stateChange.bind(_this);_this.changeStates=_this.changeStates.bind(_this);_this.changeMuns=_this.changeMuns.bind(_this);_this.changeCdmStates=_this.changeCdmStates.bind(_this);_this.changeCdmMuns=_this.changeCdmMuns.bind(_this);return _this;}_createClass(BaseLayout,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.match.params.state!==this.props.match.params.state){this.stateChange(nextProps.match.params.state);}}},{key:"stateChange",value:function stateChange(entity){return this.setState({showState:entity});}},{key:"filterChange",value:function filterChange(e){return this.setState({filterType:e.target.value});}},{key:"changeStates",value:function changeStates(state){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].location.pathname,'/',5);if(url[4]==='administrativo'||url[4]==='juridica'){url[5]=state;}else{url[4]=state;}url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push(url);this.stateChange(state);}},{key:"changeMuns",value:function changeMuns(mun){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].location.pathname,'/',6);if(url[4]==='administrativo'||url[4]==='juridica'){url[5]=this.state.showState;url[6]=mun;}else{url[4]=this.state.showState;url[5]=mun;}url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push(url);}},{key:"changeCdmStates",value:function changeCdmStates(state){var cdms=this.props.session.user.cdms;var filterMun=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(cdms,{agenciable_state_short:state});var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].location.pathname,'/',5);url[3]=state;if(filterMun){url[4]=filterMun[0].agenciable_slug;}url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push(url);}},{key:"changeCdmMuns",value:function changeCdmMuns(state,mun){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].location.pathname,'/',5);url[3]=state;url[4]=mun;url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push(url);}},{key:"toggleMenu",value:function toggleMenu(){var view=this.props.menu.view;return view===true?this.props.hideMenu():this.props.showMenu();}}]);return BaseLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_4__secure__["a" /* default */])(BaseLayout);});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(281);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(286);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(162);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(287);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(290);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(292);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(294);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(295);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(276)();
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValid = exports.track = exports.getModel = exports.getField = exports.form = exports.batched = exports.modeled = exports.createFieldClass = exports.Fieldset = exports.Errors = exports.LocalForm = exports.Form = exports.Control = exports.Field = exports.controls = exports.actionTypes = exports.actions = exports.initialFieldState = exports.createForms = exports.combineForms = exports.modelReducer = exports.formReducer = undefined;

var _actions = __webpack_require__(47);

var _actions2 = _interopRequireDefault(_actions);

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _fieldComponent = __webpack_require__(338);

var _fieldComponent2 = _interopRequireDefault(_fieldComponent);

var _fieldsetComponent = __webpack_require__(349);

var _fieldsetComponent2 = _interopRequireDefault(_fieldsetComponent);

var _controlComponent = __webpack_require__(188);

var _controlComponent2 = _interopRequireDefault(_controlComponent);

var _formComponent = __webpack_require__(191);

var _formComponent2 = _interopRequireDefault(_formComponent);

var _localFormComponent = __webpack_require__(352);

var _localFormComponent2 = _interopRequireDefault(_localFormComponent);

var _errorsComponent = __webpack_require__(363);

var _errorsComponent2 = _interopRequireDefault(_errorsComponent);

var _controlPropsMap = __webpack_require__(108);

var _controlPropsMap2 = _interopRequireDefault(_controlPropsMap);

var _modeledEnhancer = __webpack_require__(194);

var _modeledEnhancer2 = _interopRequireDefault(_modeledEnhancer);

var _batchedEnhancer = __webpack_require__(110);

var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);

var _formReducer = __webpack_require__(82);

var _formReducer2 = _interopRequireDefault(_formReducer);

var _initialFieldState = __webpack_require__(34);

var _initialFieldState2 = _interopRequireDefault(_initialFieldState);

var _formsReducer = __webpack_require__(193);

var _formsReducer2 = _interopRequireDefault(_formsReducer);

var _modelReducer = __webpack_require__(109);

var _modelReducer2 = _interopRequireDefault(_modelReducer);

var _track = __webpack_require__(75);

var _track2 = _interopRequireDefault(_track);

var _isValid = __webpack_require__(60);

var _isValid2 = _interopRequireDefault(_isValid);

var _getFieldFromState = __webpack_require__(58);

var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _form = __webpack_require__(364);

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.formReducer = _formReducer2.default;
exports.modelReducer = _modelReducer2.default;
exports.combineForms = _formsReducer2.default;
exports.createForms = _formsReducer.createForms;
exports.initialFieldState = _initialFieldState2.default;
exports.actions = _actions2.default;
exports.actionTypes = _actionTypes2.default;
exports.controls = _controlPropsMap2.default;
exports.Field = _fieldComponent2.default;
exports.Control = _controlComponent2.default;
exports.Form = _formComponent2.default;
exports.LocalForm = _localFormComponent2.default;
exports.Errors = _errorsComponent2.default;
exports.Fieldset = _fieldsetComponent2.default;
exports.createFieldClass = _fieldComponent.createFieldClass;
exports.modeled = _modeledEnhancer2.default;
exports.batched = _batchedEnhancer2.default;
exports.form = _form2.default;
exports.getField = _getFieldFromState2.default;
exports.getModel = _get2.default;
exports.track = _track2.default;
exports.isValid = _isValid2.default;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isRequired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return maxLength; });
/* unused harmony export maxLength15 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return minLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return minLength2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return minValue; });
/* unused harmony export minValue18 */
/* unused harmony export passwordMinVal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return email; });
/* unused harmony export tooOld */
/* unused harmony export alphaNumeric */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return phoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCurp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isRfc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isRfcMoral; });
var required=function required(value){return!Boolean(value);};/* valida selects *///export const required = value => (Boolean(value) && value === undefined); /* valida selects */
var isRequired=function isRequired(val){return!Boolean(val);};var maxLength=function maxLength(max){return function(value){return value&&value.length>max?'Debe tener '+max+' caracteres o menos':undefined;};};var maxLength15=maxLength(15);var minLength=function minLength(min){return function(value){return value&&value.length<min;};};var minLength2=minLength(2);var number=function number(value){return value&&isNaN(Number(value))?'Must be a number':undefined;};var minValue=function minValue(min){return function(value){return value&&value<min?'Must be at least '+min:undefined;};};var minValue18=minValue(18);var passwordMinVal=function passwordMinVal(value){return value&&value.length<8?'Contraseña invalida':undefined;};var isEmail=function isEmail(value){return!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);};var email=function email(value){return value?!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)?'E-mail inválido. ':undefined:undefined;};var tooOld=function tooOld(value){return value&&value>65?'You might be too old for this':undefined;};var alphaNumeric=function alphaNumeric(value){return value&&/[^a-zA-Z0-9 ]/i.test(value)?'Only alphanumeric characters':undefined;};var phoneNumber=function phoneNumber(value){return value?!/^(0|[1-9][0-9]{9})$/i.test(value)?'Número de teléfono inválido.':undefined:undefined;};var isCurp=function isCurp(value){return value?!/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/.test(value)?'CURP Inválida. ':undefined:undefined;};var isRfc=function isRfc(value){return value?!/^[a-zA-Z]{3,4}([0-9]{2})(1[0-2]|0[1-9])([0-3][0-9])([a-zA-Z0-9]{3})$/.test(value)?'RFC Inválido':undefined:undefined;};var isRfcMoral=function isRfcMoral(value){return value?!/^[a-zA-Z]{3}([0-9]{2})(1[0-2]|0[1-9])([0-3][0-9])([a-zA-Z0-9]{3})$/.test(value)?'RFC Inválido':undefined:undefined;};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_login__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_users__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_projects__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_project__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_agreements__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_dispersions__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_status__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_roles__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_entities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_municipalities__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_agencies__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_amounts_agencies__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_versions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_version_groups_phases__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_permissions__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_profile__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_phases__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_modalities__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__actions_goals__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_objectives__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__actions_strategies__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__actions_axis__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__actions_lines__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__actions_activities__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__actions_concepts__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__actions_modal__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__actions_verification_media__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__actions_activity_groups__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__actions_directories__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__actions_resource_concept__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__actions_notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__actions_revision__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__actions_notification_messages__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__actions_notifications_types__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__actions_surveys__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__actions_groups_phases__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__actions_reports__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__actions_documents_types__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__actions_cdms__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__actions_menu__ = __webpack_require__(453);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(WrappedComponent){var SecureLayout=function(_Component){_inherits(SecureLayout,_Component);function SecureLayout(){_classCallCheck(this,SecureLayout);return _possibleConstructorReturn(this,(SecureLayout.__proto__||Object.getPrototypeOf(SecureLayout)).apply(this,arguments));}_createClass(SecureLayout,[{key:"render",/*componentWillMount() {
			this.props.validateSession();
		}*/value:function render(){var _props$session=this.props.session,checked=_props$session.checked,authenticated=_props$session.authenticated;return checked&&authenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({},this.props,{authenticated:authenticated})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Redirect */],{to:{pathname:"/",state:{from:this.props.location.pathname}}});}}]);return SecureLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SecureLayout));});var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{validateSession:function validateSession(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_login__["e" /* validateSession */])());},usersList:function usersList(page,filters/*, search*/){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_users__["g" /* usersList */])(page,filters/*, search*/));},fetchUsersList:function fetchUsersList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_users__["b" /* fetchUsersList */])());},projectConclusion:function projectConclusion(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["g" /* projectConclusion */])(modality,state,mun));},projectConclusionExport:function projectConclusionExport(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["h" /* projectConclusionExport */])(modality,state,mun));},projectConclusionSave:function projectConclusionSave(modality,state,mun,values,event){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["i" /* projectConclusionSave */])(modality,state,mun,values,event));},fetchUser:function fetchUser(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_users__["a" /* fetchUser */])(id));},usersFind:function usersFind(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_users__["f" /* usersFind */])(value));},usersExport:function usersExport(filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_users__["e" /* usersExport */])(filters));},userDelete:function userDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_users__["c" /* userDelete */])(id));},fetchStatus:function fetchStatus(group){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_status__["a" /* statusGroupList */])(group));},statusList:function statusList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_status__["b" /* statusList */])());},statusMotivesList:function statusMotivesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_status__["c" /* statusMotivesList */])());},rolesShow:function rolesShow(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_roles__["e" /* rolesShow */])(value));},fetchRolesList:function fetchRolesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_roles__["b" /* fetchRolesList */])());},userSave:function userSave(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_users__["d" /* userSave */])(data));},entitiesShow:function entitiesShow(value,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_entities__["b" /* entitiesShow */])(value,filters));},fetchEntities:function fetchEntities(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_entities__["a" /* entitiesList */])());},fetchEntity:function fetchEntity(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_entities__["d" /* entityEdit */])(id));},entitySave:function entitySave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_entities__["e" /* entitySave */])(values));},deleteEntity:function deleteEntity(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_entities__["c" /* entityDelete */])(id));},resetEntity:function resetEntity(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('entities.edit'));},fetchMunicipalities:function fetchMunicipalities(state){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_municipalities__["a" /* municipalitiesList */])(state));},filterMunicipalities:function filterMunicipalities(state){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_municipalities__["a" /* municipalitiesList */])(state,true));},municipalitiesShow:function municipalitiesShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_municipalities__["b" /* municipalitiesShow */])(page,filters));},deleteMunicipality:function deleteMunicipality(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_municipalities__["c" /* municipalityDelete */])(id));},municipalitySave:function municipalitySave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_municipalities__["e" /* municipalitySave */])(values));},resetMunicipalities:function resetMunicipalities(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('municipalities.edit'));dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('municipalities.list'));},agenciesShow:function agenciesShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_agencies__["a" /* agenciesShow */])(page,filters));},agencyEdit:function agencyEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_agencies__["c" /* agencyEdit */])(id));},agencyEditSave:function agencyEditSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_agencies__["d" /* agencyEditSave */])(values));},agencyDelete:function agencyDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_agencies__["b" /* agencyDelete */])(id));},fetchAgencyMunicipalities:function fetchAgencyMunicipalities(entity){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_agencies__["e" /* fetchAgencyMunicipalities */])(entity));},amountsAgenciesShow:function amountsAgenciesShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_amounts_agencies__["d" /* amountsAgenciesShow */])(page,filters));},amountsAgenciesEdit:function amountsAgenciesEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_amounts_agencies__["b" /* amountsAgenciesEdit */])(id));},amountsAgenciesEditSave:function amountsAgenciesEditSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_amounts_agencies__["c" /* amountsAgenciesEditSave */])(values));},amountAgencyDelete:function amountAgencyDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_amounts_agencies__["a" /* amountAgencyDelete */])(id));},resetUser:function resetUser(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('users.edit'));dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('users.list'));},fetchVersionsShow:function fetchVersionsShow(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_versions__["b" /* fetchVersionsShow */])(value));},versionsList:function versionsList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_versions__["e" /* versionsList */])());},fetchVersion:function fetchVersion(year){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_versions__["a" /* fetchVersion */])(year));},versionSave:function versionSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_versions__["d" /* versionSave */])(values));},versionDelete:function versionDelete(year){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_versions__["c" /* versionDelete */])(year));},resetVersions:function resetVersions(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('versions.edit'));dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('versions.list'));},fetchVersionGroupPhaseComplete:function fetchVersionGroupPhaseComplete(year,id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_version_groups_phases__["a" /* fetchVersionGroupPhaseComplete */])(year,id));},fetchVersionGroupsPhases:function fetchVersionGroupsPhases(year,id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_version_groups_phases__["b" /* fetchVersionGroupsPhases */])(year,id));},versionGroupsPhasesEditSave:function versionGroupsPhasesEditSave(year,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_version_groups_phases__["c" /* versionGroupsPhasesEditSave */])(year,values));},deleteRole:function deleteRole(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_roles__["c" /* roleDelete */])(id));},fetchPermissions:function fetchPermissions(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions_permissions__["d" /* permissionsList */])());},fetchRole:function fetchRole(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_roles__["a" /* fetchRole */])(id));},roleSave:function roleSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_roles__["d" /* roleSave */])(values));},resetRolesList:function resetRolesList(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('roles.edit'));dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('roles.list'));},fetchProfile:function fetchProfile(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_profile__["a" /* fetchProfile */])());},profileSave:function profileSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_profile__["b" /* profileUpdate */])(values));},phasesShow:function phasesShow(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_phases__["e" /* phasesShow */])(page));},phasesList:function phasesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_phases__["d" /* phasesList */])());},phaseDelete:function phaseDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_phases__["a" /* phaseDelete */])(id));},phaseEdit:function phaseEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_phases__["b" /* phaseEdit */])(id));},phaseSave:function phaseSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_phases__["c" /* phaseSave */])(values));},permissionsShow:function permissionsShow(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions_permissions__["e" /* permissionsShow */])(page));},deletePermission:function deletePermission(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions_permissions__["a" /* permissionDelete */])(id));},permissionEdit:function permissionEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions_permissions__["b" /* permissionEdit */])(id));},permissionsSave:function permissionsSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions_permissions__["c" /* permissionSave */])(values));},resetPermissionEdit:function resetPermissionEdit(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('permissions.edit'));dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('permissions.list'));},fetchMunicipality:function fetchMunicipality(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_municipalities__["d" /* municipalityEdit */])(id));},fetchModalities:function fetchModalities(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__actions_modalities__["a" /* modalitiesList */])());},goalsShow:function goalsShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions_goals__["e" /* goalsShow */])(page,filters));},fetchGoalsList:function fetchGoalsList(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions_goals__["d" /* goalsList */])(id));},deleteGoal:function deleteGoal(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions_goals__["b" /* goalDelete */])(id));},objectivesShow:function objectivesShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_objectives__["e" /* objectivesShow */])(page,filters));},objectivesList:function objectivesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_objectives__["d" /* objectivesList */])());},objectiveEdit:function objectiveEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_objectives__["b" /* objectiveEdit */])(id));},objectiveEditSave:function objectiveEditSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_objectives__["c" /* objectiveEditSave */])(values));},objectiveDelete:function objectiveDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions_objectives__["a" /* objectiveDelete */])(id));},strategiesShow:function strategiesShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions_strategies__["e" /* strategiesShow */])(page,filters));},strategiesList:function strategiesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions_strategies__["d" /* strategiesList */])());},strategieEdit:function strategieEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions_strategies__["b" /* strategieEdit */])(id));},strategieEditSave:function strategieEditSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions_strategies__["c" /* strategieEditSave */])(values));},strategieDelete:function strategieDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__actions_strategies__["a" /* strategieDelete */])(id));},linesShow:function linesShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_lines__["f" /* linesShow */])(page,filters));},linesList:function linesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_lines__["e" /* linesList */])());},lineEdit:function lineEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_lines__["c" /* lineEdit */])(id));},lineEditSave:function lineEditSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_lines__["d" /* lineEditSave */])(values));},lineDelete:function lineDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_lines__["b" /* lineDelete */])(id));},fetchLineComplete:function fetchLineComplete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions_lines__["a" /* fetchLineComplete */])(id));},axisShow:function axisShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions_axis__["e" /* axisShow */])(page,filters));},axisList:function axisList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions_axis__["d" /* axisList */])());},axisEdit:function axisEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions_axis__["b" /* axisEdit */])(id));},axisEditSave:function axisEditSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions_axis__["c" /* axisEditSave */])(values));},axisDelete:function axisDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__actions_axis__["a" /* axisDelete */])(id));},activitiesList:function activitiesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_activities__["a" /* activitiesList */])());},activitiesShow:function activitiesShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_activities__["b" /* activitiesShow */])(page,filters));},fetchActivityComplete:function fetchActivityComplete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_activities__["f" /* fetchActivityComplete */])(id));},fetchActivity:function fetchActivity(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_activities__["e" /* fetchActivity */])(id));},saveActivity:function saveActivity(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_activities__["d" /* activitySave */])(values));},deleteActivity:function deleteActivity(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_activities__["c" /* activityDelete */])(id));},mediaList:function mediaList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_31__actions_verification_media__["a" /* verificationMediaShow */])());},activityGroupShow:function activityGroupShow(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__actions_activity_groups__["a" /* activityGroupShow */])());},fetchGoalComplete:function fetchGoalComplete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions_goals__["a" /* fetchGoalComplete */])(id));},goalSave:function goalSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions_goals__["c" /* goalSave */])(values));},change:function change(model,value){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].change(model,value));},resetGoalActivities:function resetGoalActivities(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('activities.list'));dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('activities.pages'));},resetActivityEdit:function resetActivityEdit(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('activities.edit'));},resetGoalId:function resetGoalId(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('project.registry,goal_id'));},resetGoals:function resetGoals(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('goals.edit'));dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('goals.list'));},conceptsShow:function conceptsShow(page,filters){dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__actions_concepts__["d" /* conceptsShow */])(page,filters));},conceptsList:function conceptsList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__actions_concepts__["c" /* conceptsList */])());},deleteConcept:function deleteConcept(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__actions_concepts__["a" /* conceptDelete */])(id));},fetchConcept:function fetchConcept(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__actions_concepts__["e" /* fetchConcept */])(id));},resetConcepts:function resetConcepts(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('concepts.edit'));},conceptSave:function conceptSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_29__actions_concepts__["b" /* conceptSave */])(values));},showModal:function showModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_30__actions_modal__["b" /* showModal */])());},hideModal:function hideModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_30__actions_modal__["a" /* hideModal */])());},fetchState:function fetchState(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_entities__["d" /* entityEdit */])(id));},fetchOwner:function fetchOwner(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["n" /* projectOwner */])(modality,state,mun));},saveOwner:function saveOwner(modalidty,state,mun,data,event){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["o" /* projectOwnerSave */])(modalidty,state,mun,data,event));},fetchAgency:function fetchAgency(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["c" /* projectAgency */])(modality,state,mun));},projectAgencyExport:function projectAgencyExport(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["d" /* projectAgencyExport */])(modality,state,mun));},saveAgency:function saveAgency(modality,state,mun,values,event){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["e" /* projectAgencySave */])(modality,state,mun,values,event));},/*
		addProjectGoal: (value) => {
			dispatch(actions.push('project.registry.data.goals',value))
		},
		addProjectResourseConcept: (goal, value) => {
			dispatch(actions.change(`project.registry.data.goals[${goal}].resource_concept_id`, value))
		},
		addGeoArea: (goal, value) => {
			dispatch(actions.change(`project.registry.data.goals[${goal}].geographic_area`, value))
		},
		addProjectGoalMuns: (goal, mun) => {
			dispatch(actions.push(`project.registry.data.goals[${goal}].municipalities`, mun))
		},
		removeProjectGoalMuns: (goal, mun) => {
			dispatch(actions.remove(`project.registry.data.goals[${goal}].municipalities`, mun))
		},
		addProjectConagoClause: (goal, clause) => {
			dispatch(actions.push(`project.registry.data.goals[${goal}].conago_clauses`, clause))
		},
		removeProjectConagoClause: (goal, clause) => {
			dispatch(actions.remove(`project.registry.data.goals[${goal}].conago_clauses`, clause))
		},
		addProjectActor: (goal, actor) => {
			dispatch(actions.push(`project.registry.data.goals[${goal}].actors`, actor))
		},
		removeProjectActor: (goal, actor) => {
			dispatch(actions.remove(`project.registry.data.goals[${goal}].actors`, actor))
		},
		addProjectKey: (value) => {
			dispatch(actions.change('project.activity',value))
		},
		removeProjectGoal: (index) => {
			dispatch(actions.remove('project.registry.data.goals',index))
		},
		removeProjectActivity: (goal, activity) => {
			dispatch(actions.remove(`project.registry.data.goals[${goal}].activities`,activity))
		},*/fetchActorsList:function fetchActorsList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_33__actions_directories__["b" /* actorsList */])());},actorsGroups:function actorsGroups(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_33__actions_directories__["a" /* actorsGroups */])());},fetchConagoList:function fetchConagoList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_33__actions_directories__["c" /* conagoList */])());},fetchRegistry:function fetchRegistry(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["s" /* projectRegistry */])(modality,state,mun));},projectRegistryData:function projectRegistryData(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["t" /* projectRegistryData */])(modality,state,mun,undefined));},saveRegistry:function saveRegistry(modality,state,mun,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["u" /* projectRegistrySave */])(modality,state,mun,data));},fetchResourseConcepts:function fetchResourseConcepts(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_34__actions_resource_concept__["a" /* resourceConceptsList */])());},/*
		setProjectGoalTotal: (goal, total) => {
			dispatch(actions.change(`project.registry.goals[${goal}].total`, total))
		},
		addActivities: (model, value) => {
			dispatch(actions.push(model,value))
		},*/fetchGoalActivities:function fetchGoalActivities(goal){dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__actions_activities__["g" /* goalActivitiesList */])(goal));},projectProigualdadGoals:function projectProigualdadGoals(page,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["p" /* projectProigualdadGoals */])(page,modality,state,mun));},projectProigualdadGoalsEdit:function projectProigualdadGoalsEdit(goal,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["q" /* projectProigualdadGoalsEdit */])(goal,modality,state,mun));},projectProigualdadGoalsEditSave:function projectProigualdadGoalsEditSave(goal,modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["r" /* projectProigualdadGoalsEditSave */])(goal,modality,state,mun,values));},clearNotification:function clearNotification(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_35__actions_notifications__["a" /* clearNotification */])());},projectExpenses:function projectExpenses(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["l" /* projectExpenses */])(modality,state,mun));},projectExpensesSave:function projectExpensesSave(modality,state,mun,data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["m" /* projectExpensesSave */])(modality,state,mun,data));},/*fetchEmployeesRoles: (modality, state, mun) => {

			dispatch(projectEmployeesRoles(modality, state, mun));
		},*/projectEmployees:function projectEmployees(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["k" /* projectEmployees */])(modality,state,mun));},resetEmployee:function resetEmployee(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].change('project.profiles.data.employee.edit',{}));},projectEmployeeSave:function projectEmployeeSave(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["j" /* projectEmployeeSave */])(modality,state,mun,values));},fetchRevisions:function fetchRevisions(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["c" /* fetchRevision */])(modality,state,mun));},fetchRevisionLegal:function fetchRevisionLegal(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["e" /* fetchRevisionLegal */])(modality,state,mun));},fetchRevisionProject:function fetchRevisionProject(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["f" /* fetchRevisionProject */])(modality,state,mun));},fetchRevisionReports:function fetchRevisionReports(slug,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["g" /* fetchRevisionReports */])(slug,modality,state,mun));},saveLegalRevision:function saveLegalRevision(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["j" /* saveLegalRevision */])(modality,state,mun,values));},saveProjectRevision:function saveProjectRevision(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["k" /* saveProjectRevision */])(modality,state,mun,values));},fetchRevisionAgreements:function fetchRevisionAgreements(type,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["d" /* fetchRevisionAgreements */])(type,modality,state,mun));},saveAgreements:function saveAgreements(modality,state,mun,type,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["i" /* saveAgreements */])(modality,state,mun,type,values));},saveRevisionReportsFinancial:function saveRevisionReportsFinancial(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["m" /* saveRevisionReportsFinancial */])(modality,state,mun,values));},saveRevisionReportsExpenses:function saveRevisionReportsExpenses(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["l" /* saveRevisionReportsExpenses */])(modality,state,mun,values));},saveRevisionReportsSummary:function saveRevisionReportsSummary(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["n" /* saveRevisionReportsSummary */])(modality,state,mun,values));},fetchCompletProject:function fetchCompletProject(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_project__["a" /* fetchCompletProject */])(modality,state,mun));},fetchNotificationMessages:function fetchNotificationMessages(modality){dispatch(Object(__WEBPACK_IMPORTED_MODULE_37__actions_notification_messages__["c" /* notificationMessagesFetch */])(modality));},add:function add(model,item){return dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].push(model,item));},notificationMessagesSave:function notificationMessagesSave(values,modality){dispatch(Object(__WEBPACK_IMPORTED_MODULE_37__actions_notification_messages__["d" /* notificationMessagesSave */])(values,modality));},notificationStateReviewedSave:function notificationStateReviewedSave(value,modality,state){dispatch(Object(__WEBPACK_IMPORTED_MODULE_37__actions_notification_messages__["e" /* notificationStateReviewedSave */])(value,modality,state));},notificationAssignFolios:function notificationAssignFolios(modality){dispatch(Object(__WEBPACK_IMPORTED_MODULE_37__actions_notification_messages__["a" /* notificationAssignFolios */])(modality));},notificationMessagesExport:function notificationMessagesExport(modality){dispatch(Object(__WEBPACK_IMPORTED_MODULE_37__actions_notification_messages__["b" /* notificationMessagesExport */])(modality));},loadFormData:function loadFormData(model,values){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].resetErrors(model));dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].load(model,values));},setSystemNotification:function setSystemNotification(title,content,type){dispatch(Object(__WEBPACK_IMPORTED_MODULE_35__actions_notifications__["b" /* newNotification */])({title:title,content:content,type:type}));},surveysShow:function surveysShow(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_39__actions_surveys__["f" /* surveysShow */])(page));},fetchSurveysList:function fetchSurveysList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_39__actions_surveys__["b" /* fetchSurveysList */])());},surveysFetchTypes:function surveysFetchTypes(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_39__actions_surveys__["e" /* surveysFetchTypes */])());},fetchSurvey:function fetchSurvey(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_39__actions_surveys__["a" /* fetchSurvey */])(id));},/*
		surveysCreate: (values) => {
			dispatch(surveysCreate(values))
		},*/surveySave:function surveySave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_39__actions_surveys__["d" /* surveySave */])(values));},surveysClear:function surveysClear(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('surveys.edit'));},surveysSaveAnswer:function surveysSaveAnswer(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["o" /* surveysSaveAnswer */])(values));},surveyDelete:function surveyDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_39__actions_surveys__["c" /* surveyDelete */])(id));},remove:function remove(model,index){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].remove(model,index));},fetchCommission:function fetchCommission(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["b" /* fetchCommission */])());},assignCommission:function assignCommission(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["a" /* assignCommission */])());},fetchShowCommission:function fetchShowCommission(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__actions_revision__["h" /* fetchShowCommission */])(modality,state,mun));},notificationTypesFetch:function notificationTypesFetch(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_37__actions_notification_messages__["f" /* notificationTypesFetch */])());},fetchNotificationsTypes:function fetchNotificationsTypes(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_38__actions_notifications_types__["a" /* fetchNotificationsTypes */])(page));},fetchNotificationsTypesList:function fetchNotificationsTypesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_38__actions_notifications_types__["b" /* fetchNotificationsTypesList */])());},notificationTypeEdit:function notificationTypeEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_38__actions_notifications_types__["c" /* notificationTypeEdit */])(id));},notificationTypeEditSave:function notificationTypeEditSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_38__actions_notifications_types__["d" /* notificationTypeEditSave */])(values));},projectAgreements:function projectAgreements(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_agreements__["b" /* projectAgreements */])(modality,state,mun));},fetchProjectAgreementsWithRevision:function fetchProjectAgreementsWithRevision(modality,state,mun,type){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_agreements__["a" /* fetchProjectAgreementsWithRevision */])(modality,state,mun,type));},projectAgreementsSave:function projectAgreementsSave(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_agreements__["d" /* projectAgreementsSave */])(modality,state,mun,values));},projectAgreementsExport:function projectAgreementsExport(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_agreements__["c" /* projectAgreementsExport */])(modality,state,mun));},/*projectFiscalEntity: (modality, state, mun) => {
			dispatch(projectFiscalEntity(modality, state, mun))
		},
		projectFiscalEntitySave: (modality, state, mun, values) => {
			dispatch(projectFiscalEntitySave(modality, state, mun, values))
		},*//*fetchDispersions: (modality, state, mun) => {
			dispatch(fetchDispersions(modality, state, mun))
		},
		projectDispersionsSave: (modality, state, mun, values) => {
			dispatch(projectDispersionsSave(modality, state, mun, values))
		},*/projectDispersions:function projectDispersions(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_dispersions__["a" /* projectDispersions */])(modality,state,mun));},projectDispersionsExport:function projectDispersionsExport(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_dispersions__["b" /* projectDispersionsExport */])(modality,state,mun));},projectDispersionsSave:function projectDispersionsSave(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_dispersions__["c" /* projectDispersionsSave */])(modality,state,mun,values));},fetchProjects:function fetchProjects(page,filters,search){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["e" /* fetchProjects */])(page,filters,search));},fetchProjectsList:function fetchProjectsList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["h" /* fetchProjectsList */])(value));},projectsExport:function projectsExport(filters,options){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["p" /* projectsExport */])(filters,options));},fetchProjectEdit:function fetchProjectEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["b" /* fetchProjectEdit */])(id));},projectSave:function projectSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["n" /* projectSave */])(values));},fetchProjectsGoalsEdit:function fetchProjectsGoalsEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["g" /* fetchProjectsGoalsEdit */])(id));},projectGoalsSave:function projectGoalsSave(id,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["k" /* projectGoalsSave */])(id,values));},fetchProjectsExpensesEdit:function fetchProjectsExpensesEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["f" /* fetchProjectsExpensesEdit */])(id));},projectsExpensesSave:function projectsExpensesSave(id,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["o" /* projectsExpensesSave */])(id,values));},fetchProjectPhasesGroupsEdit:function fetchProjectPhasesGroupsEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["d" /* fetchProjectPhasesGroupsEdit */])(id));},projectPhaseSave:function projectPhaseSave(project_id,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["m" /* projectPhaseSave */])(project_id,values));},projectPhaseDelete:function projectPhaseDelete(id,phaseId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["l" /* projectPhaseDelete */])(id,phaseId));},fetchProjectEmployeesEdit:function fetchProjectEmployeesEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["c" /* fetchProjectEmployeesEdit */])(id));},projectEmployeeEditSave:function projectEmployeeEditSave(id,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["j" /* projectEmployeeEditSave */])(id,values));},projectEmployeeDelete:function projectEmployeeDelete(id,employee_id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["i" /* projectEmployeeDelete */])(id,employee_id));},fetchProjectCommission:function fetchProjectCommission(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["a" /* fetchProjectCommission */])(id));},projectsFolios:function projectsFolios(mod){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["q" /* projectsFolios */])(mod));},projectsFoliosAssign:function projectsFoliosAssign(mod){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_projects__["r" /* projectsFoliosAssign */])(mod));},fetchGroupsPhasesShow:function fetchGroupsPhasesShow(page){dispatch(Object(__WEBPACK_IMPORTED_MODULE_40__actions_groups_phases__["c" /* fetchGroupsPhasesShow */])(page));},fetchGroupsPhasesList:function fetchGroupsPhasesList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_40__actions_groups_phases__["b" /* fetchGroupsPhasesList */])());},fetchGroupPhaseEdit:function fetchGroupPhaseEdit(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_40__actions_groups_phases__["a" /* fetchGroupPhaseEdit */])(id));},resetGroupsPhases:function resetGroupsPhases(){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset('groupsPhases.edit'));},groupPhaseSave:function groupPhaseSave(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_40__actions_groups_phases__["e" /* groupPhaseSave */])(values));},groupPhaseDelete:function groupPhaseDelete(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_40__actions_groups_phases__["d" /* groupPhaseDelete */])(id));},reset:function reset(model){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].reset(model));},reportsFinancial:function reportsFinancial(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["t" /* reportsFinancial */])(modality,state,mun));},financialGoalStatusSave:function financialGoalStatusSave(values,data,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["n" /* financialGoalStatusSave */])(values,data,modality,state,mun));},financialGoalDocumentSave:function financialGoalDocumentSave(values,data,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["k" /* financialGoalDocumentSave */])(values,data,modality,state,mun));},financialActivityStatusSave:function financialActivityStatusSave(values,data,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["g" /* financialActivityStatusSave */])(values,data,modality,state,mun));},financialGoalInvoicesSave:function financialGoalInvoicesSave(values,data,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["m" /* financialGoalInvoicesSave */])(values,data,modality,state,mun));},financialActivityMediaSave:function financialActivityMediaSave(values,data,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["f" /* financialActivityMediaSave */])(values,data,modality,state,mun));},financialGoalDocumentDelete:function financialGoalDocumentDelete(values,data,id,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["j" /* financialGoalDocumentDelete */])(values,data,id,modality,state,mun));},financialGoalInvoiceDelete:function financialGoalInvoiceDelete(values,data,id,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["l" /* financialGoalInvoiceDelete */])(values,data,id,modality,state,mun));},financialActivityMediaDelete:function financialActivityMediaDelete(values,data,id,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["e" /* financialActivityMediaDelete */])(values,data,id,modality,state,mun));},financialGoalActorsSave:function financialGoalActorsSave(values,data,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["h" /* financialGoalActorsSave */])(values,data,modality,state,mun));},financialGoalConagoSave:function financialGoalConagoSave(values,data,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["i" /* financialGoalConagoSave */])(values,data,modality,state,mun));},reportsExpenses:function reportsExpenses(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["s" /* reportsExpenses */])(modality,state,mun));},expenseInvoicesSave:function expenseInvoicesSave(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["a" /* expenseInvoicesSave */])(modality,state,mun,values));},expensesInvoiceDelete:function expensesInvoiceDelete(values,id,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["c" /* expensesInvoiceDelete */])(values,id,modality,state,mun));},expenseReceiptsSave:function expenseReceiptsSave(modality,state,mun,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["b" /* expenseReceiptsSave */])(modality,state,mun,values));},expensesReceiptDelete:function expensesReceiptDelete(values,id,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["d" /* expensesReceiptDelete */])(values,id,modality,state,mun));},reportsEmployees:function reportsEmployees(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["r" /* reportsEmployees */])(modality,state,mun));},reportsEmployeeAdd:function reportsEmployeeAdd(values,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["o" /* reportsEmployeeAdd */])(values,modality,state,mun));},reportsEmployeeInvoicesSave:function reportsEmployeeInvoicesSave(values,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["q" /* reportsEmployeeInvoicesSave */])(values,modality,state,mun));},reportsEmployeeInvoiceDelete:function reportsEmployeeInvoiceDelete(values,id,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["p" /* reportsEmployeeInvoiceDelete */])(values,id,modality,state,mun));},reportsSummary:function reportsSummary(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["u" /* reportsSummary */])(modality,state,mun));},reportsSummaryExport:function reportsSummaryExport(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["v" /* reportsSummaryExport */])(modality,state,mun));},reportsSummarySave:function reportsSummarySave(values,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["w" /* reportsSummarySave */])(values,modality,state,mun));},reportsSurvey:function reportsSurvey(modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["x" /* reportsSurvey */])(modality,state,mun));},reportsSurveySave:function reportsSurveySave(values,modality,state,mun){dispatch(Object(__WEBPACK_IMPORTED_MODULE_41__actions_reports__["y" /* reportsSurveySave */])(values,modality,state,mun));},resetValidity:function resetValidity(model){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].resetValidity(model));},omit:function omit(model,props){dispatch(__WEBPACK_IMPORTED_MODULE_16_react_redux_form__["actions"].omit(model,props));},showMenu:function showMenu(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_44__actions_menu__["b" /* showMenu */])());},hideMenu:function hideMenu(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_44__actions_menu__["a" /* hideMenu */])());},documentsTypesShow:function documentsTypesShow(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions_documents_types__["a" /* documentsTypesShow */])());},cdmEmployees:function cdmEmployees(state){dispatch(Object(__WEBPACK_IMPORTED_MODULE_43__actions_cdms__["a" /* cdmEmployees */])(state));},cdmEmployeesSave:function cdmEmployeesSave(state,values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_43__actions_cdms__["b" /* cdmEmployeesSave */])(state,values));}};};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

exports.confirmAlert = confirmAlert;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var ReactConfirmAlert = (function (_Component) {
  _inherits(ReactConfirmAlert, _Component);

  function ReactConfirmAlert() {
    var _this = this;

    _classCallCheck(this, ReactConfirmAlert);

    _Component.apply(this, arguments);

    this.onClickConfirm = function () {
      _this.props.onConfirm();
      _this.close();
    };

    this.onClickCancel = function () {
      _this.props.onCancel();
      _this.close();
    };

    this.close = function () {
      removeElementReconfirm();
      removeSVGBlurReconfirm();
    };
  }

  ReactConfirmAlert.prototype.render = function render() {
    var _props = this.props;
    var title = _props.title;
    var message = _props.message;
    var confirmLabel = _props.confirmLabel;
    var cancelLabel = _props.cancelLabel;
    var childrenElement = _props.childrenElement;

    return _react2['default'].createElement(
      'div',
      { className: 'react-confirm-alert-overlay' },
      _react2['default'].createElement(
        'div',
        { className: 'react-confirm-alert' },
        title && _react2['default'].createElement(
          'h1',
          null,
          title
        ),
        message && _react2['default'].createElement(
          'h3',
          null,
          message
        ),
        childrenElement(),
        _react2['default'].createElement(
          'div',
          { className: 'react-confirm-alert-button-group' },
          cancelLabel && _react2['default'].createElement(
            'button',
            { onClick: this.onClickCancel },
            cancelLabel
          ),
          confirmLabel && _react2['default'].createElement(
            'button',
            { onClick: this.onClickConfirm },
            confirmLabel
          )
        )
      )
    );
  };

  _createClass(ReactConfirmAlert, null, [{
    key: 'propTypes',
    value: {
      title: _propTypes2['default'].string,
      message: _propTypes2['default'].string,
      confirmLabel: _propTypes2['default'].string,
      cancelLabel: _propTypes2['default'].string,
      onConfirm: _propTypes2['default'].func,
      onCancel: _propTypes2['default'].func,
      children: _propTypes2['default'].node
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      title: false,
      message: false,
      childrenElement: function childrenElement() {
        return null;
      },
      confirmLabel: false,
      cancelLabel: false,
      onConfirm: function onConfirm() {
        return null;
      },
      onCancel: function onCancel() {
        return null;
      }
    },
    enumerable: true
  }]);

  return ReactConfirmAlert;
})(_react.Component);

exports['default'] = ReactConfirmAlert;

function createSVGBlurReconfirm() {
  var svgNS = 'http://www.w3.org/2000/svg';
  var feGaussianBlur = document.createElementNS(svgNS, 'feGaussianBlur');
  feGaussianBlur.setAttribute('stdDeviation', '0.7');

  var filter = document.createElementNS(svgNS, 'filter');
  filter.setAttribute('id', 'gaussian-blur');
  filter.appendChild(feGaussianBlur);

  var svgElem = document.createElementNS(svgNS, 'svg');
  svgElem.setAttribute('id', 'react-confirm-alert-firm-svg');
  svgElem.setAttribute('class', 'react-confirm-alert-svg');
  svgElem.appendChild(filter);

  document.body.appendChild(svgElem);
}

function removeSVGBlurReconfirm() {
  var svg = document.getElementById('react-confirm-alert-firm-svg');
  svg.parentNode.removeChild(svg);
  document.body.children[0].classList.remove('react-confirm-alert-blur');
}

function createElementReconfirm(properties) {
  document.body.children[0].classList.add('react-confirm-alert-blur');
  var divTarget = document.createElement('div');
  divTarget.id = 'react-confirm-alert';
  document.body.appendChild(divTarget);
  _reactDom.render(_react2['default'].createElement(ReactConfirmAlert, properties), divTarget);
}

function removeElementReconfirm() {
  var target = document.getElementById('react-confirm-alert');
  _reactDom.unmountComponentAtNode(target);
  target.parentNode.removeChild(target);
}

function confirmAlert(properties) {
  createSVGBlurReconfirm();
  createElementReconfirm(properties);
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionReducer = exports.sessionService = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(372);

var _jsCookie = __webpack_require__(373);

var Cookies = _interopRequireWildcard(_jsCookie);

var _isPromise = __webpack_require__(374);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _actions = __webpack_require__(375);

var _reducer = __webpack_require__(376);

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var instance = void 0;

var sessionService = exports.sessionService = function () {
  function sessionService(store, options) {
    _classCallCheck(this, sessionService);

    instance = this;
    sessionService.setOptions(store, options);
    return instance;
  }

  _createClass(sessionService, null, [{
    key: 'setOptions',
    value: function setOptions(store) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          driver = _ref.driver,
          validateSession = _ref.validateSession,
          _ref$refreshOnCheckAu = _ref.refreshOnCheckAuth,
          refreshOnCheckAuth = _ref$refreshOnCheckAu === undefined ? false : _ref$refreshOnCheckAu,
          _ref$expires = _ref.expires,
          expires = _ref$expires === undefined ? 360 : _ref$expires,
          _ref$redirectPath = _ref.redirectPath,
          redirectPath = _ref$redirectPath === undefined ? 'login' : _ref$redirectPath,
          _ref$server = _ref.server,
          server = _ref$server === undefined ? false : _ref$server;

      instance.store = store;
      instance.refreshOnCheckAuth = refreshOnCheckAuth;
      instance.redirectPath = redirectPath;
      instance.expires = expires;
      instance.driver = driver;
      instance.server = server;
      instance.validateSession = validateSession;

      // configure the storage
      var storageOptions = {
        name: 'redux-react-session'
      };
      var localforage = __webpack_require__(377);
      if (driver && driver !== 'COOKIES') {
        storageOptions.driver = localforage[driver];
      }
      instance.storage = localforage.createInstance(storageOptions);
    }
  }, {
    key: 'initSessionService',
    value: function initSessionService(store, options) {
      instance = new sessionService(store, options);
      return sessionService.refreshFromLocalStorage();
    }
  }, {
    key: 'initServerSession',
    value: function initServerSession(store, req, options) {
      instance = new sessionService(store, _extends({}, options, { server: true }));
      var parseCookies = function parseCookies(req) {
        var list = {};
        var rc = req.get('cookie');
        rc && rc.split(';').forEach(function (cookie) {
          var parts = cookie.split('=');
          if (parts[0].trim() === _constants.USER_SESSION || parts[0].trim() === _constants.USER_DATA) {
            list[parts[0].trim()] = JSON.parse(decodeURIComponent(parts[1]));
          }
        });

        return list;
      };
      return sessionService.saveFromClient(parseCookies(req));
    }
  }, {
    key: 'saveFromClient',
    value: function saveFromClient(cookies) {
      return new Promise(function (resolve, reject) {
        if (cookies[_constants.USER_SESSION]) {
          sessionService.saveSession(cookies[_constants.USER_SESSION]).then(function () {
            if (cookies[_constants.USER_DATA]) {
              sessionService.saveUser(cookies[_constants.USER_DATA]).then(function () {
                return resolve();
              });
            } else {
              return resolve();
            }
          });
        } else {
          instance.store.dispatch((0, _actions.getSessionError)());
          reject('Session not found');
        }
      });
    }
  }, {
    key: 'invalidateSession',
    value: function invalidateSession() {
      instance.store.dispatch((0, _actions.invalidSession)());
      sessionService.deleteSession();
      sessionService.deleteUser();
    }
  }, {
    key: 'attemptLoadUser',
    value: function attemptLoadUser() {
      instance.store.dispatch((0, _actions.getSessionSuccess)());
      return sessionService.loadUser().then(function (user) {
        instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
      }).catch(function () {
        instance.store.dispatch((0, _actions.getUserSessionError)());
      });
    }
  }, {
    key: 'refreshFromLocalStorage',
    value: function refreshFromLocalStorage() {
      var _this = this;

      return sessionService.loadSession().then(function (session) {
        if (instance.validateSession) {
          var value = instance.validateSession(session);

          if ((0, _isPromise2.default)(value)) {
            return value.then(function (valid) {
              if (!valid) {
                throw new Error("Session is invalid");
              }
              return _this.attemptLoadUser();
            }).catch(function () {
              _this.invalidateSession();
            });
          } else if (!value) {
            _this.invalidateSession();
            return;
          }
        }
        return _this.attemptLoadUser();
      }).catch(function () {
        instance.store.dispatch((0, _actions.getSessionError)());
      });
    }
  }, {
    key: 'checkAuth',
    value: function checkAuth(nextState, replace, next) {
      var _instance = instance,
          refreshOnCheckAuth = _instance.refreshOnCheckAuth,
          store = _instance.store;

      sessionService.loadSession().then(function () {
        refreshOnCheckAuth && store.dispatch((0, _actions.getSessionSuccess)());
        sessionService.loadUser().then(function (user) {
          refreshOnCheckAuth && store.dispatch((0, _actions.getUserSessionSuccess)(user));
          next();
        }).catch(function () {
          return next();
        });
      }).catch(function () {
        refreshOnCheckAuth && store.dispatch((0, _actions.getSessionError)());
        refreshOnCheckAuth && store.dispatch((0, _actions.getUserSessionError)());
        replace({
          pathname: instance.redirectPath,
          state: { nextPathname: nextState.location.pathname }
        });
        next();
      });
    }
  }, {
    key: 'saveSession',
    value: function saveSession(session) {
      return new Promise(function (resolve) {
        if (instance.server) {
          instance[_constants.USER_SESSION] = session;
          instance.store.dispatch((0, _actions.getSessionSuccess)());
          resolve();
        } else if (instance.driver === 'COOKIES') {
          Cookies.set(_constants.USER_SESSION, session, { expires: instance.expires });
          instance.store.dispatch((0, _actions.getSessionSuccess)());
          resolve();
        } else {
          instance.storage.setItem(_constants.USER_SESSION, session).then(function () {
            instance.store.dispatch((0, _actions.getSessionSuccess)());
            resolve();
          }).catch(function () {
            Cookies.set(_constants.USER_SESSION, session, { expires: instance.expires });
            instance.store.dispatch((0, _actions.getSessionSuccess)());
            resolve();
          });
        }
      });
    }
  }, {
    key: 'loadSession',
    value: function loadSession() {
      return new Promise(function (resolve, reject) {
        if (instance.server) {
          instance[_constants.USER_SESSION] ? resolve(instance[_constants.USER_SESSION]) : reject();
        } else if (instance.driver === 'COOKIES') {
          var cookies = Cookies.getJSON(_constants.USER_SESSION);
          cookies ? resolve(cookies) : reject('Session not found');
        } else {
          instance.storage.getItem(_constants.USER_SESSION).then(function (currentSession) {
            if (currentSession) {
              resolve(currentSession);
            } else {
              var _cookies = Cookies.getJSON(_constants.USER_SESSION);
              _cookies ? resolve(_cookies) : reject('Session not found');
            }
          }).catch(function (err) {
            return reject(err);
          });
        }
      });
    }
  }, {
    key: 'deleteSession',
    value: function deleteSession() {
      return instance.storage.removeItem(_constants.USER_SESSION).then(function () {
        instance.store.dispatch((0, _actions.getSessionError)());
        Cookies.remove(_constants.USER_SESSION);
        delete instance[_constants.USER_SESSION];
      });
    }
  }, {
    key: 'saveUser',
    value: function saveUser(user) {
      return new Promise(function (resolve) {
        if (instance.server) {
          instance[_constants.USER_DATA] = user;
          instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
          resolve();
        } else if (instance.driver === 'COOKIES') {
          Cookies.set(_constants.USER_DATA, user, { expires: instance.expires });
          instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
          resolve();
        } else {
          instance.storage.setItem(_constants.USER_DATA, user).then(function (user) {
            instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
            resolve();
          }).catch(function () {
            instance.store.dispatch((0, _actions.getUserSessionSuccess)(user));
            Cookies.set(_constants.USER_DATA, user, { expires: instance.expires });
            resolve();
          });
        }
      });
    }
  }, {
    key: 'loadUser',
    value: function loadUser() {
      return new Promise(function (resolve, reject) {
        if (instance.server) {
          instance[_constants.USER_DATA] ? resolve(instance[_constants.USER_DATA]) : reject();
        } else if (instance.driver === 'COOKIES') {
          var cookies = Cookies.getJSON(_constants.USER_DATA);
          cookies ? resolve(cookies) : reject('User not found');
        } else {
          instance.storage.getItem(_constants.USER_DATA).then(function (currentUser) {
            if (currentUser) {
              resolve(currentUser);
            } else {
              var _cookies2 = Cookies.getJSON(_constants.USER_DATA);
              _cookies2 ? resolve(_cookies2) : reject('User not found');
            }
          }).catch(function (err) {
            return reject(err);
          });
        }
      });
    }
  }, {
    key: 'deleteUser',
    value: function deleteUser() {
      return instance.storage.removeItem(_constants.USER_DATA).then(function () {
        instance.store.dispatch((0, _actions.getUserSessionError)());
        Cookies.remove(_constants.USER_DATA);
        delete instance[_constants.USER_DATA];
      });
    }
  }]);

  return sessionService;
}();

var sessionReducer = exports.sessionReducer = _reducer2.default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(427);
module.exports = self.fetch.bind(self);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newNotification; });
/* unused harmony export setNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearNotification; });
/* unused harmony export unsetNotification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var newNotification=function newNotification(data){return function(dispatch){return dispatch(setNotification(data));};};var setNotification=function setNotification(data){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_54" /* NOTIFICATION_SET */],data:data,active:true,timestamp:Date.now()};};var clearNotification=function clearNotification(){return function(dispatch){return dispatch(unsetNotification());};};var unsetNotification=function unsetNotification(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_48" /* NOTIFICATION_CLEAR */],data:{},active:false,timestamp:Date.now()};};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toInt; });
/* unused harmony export toNum */
/* unused harmony export firstCapital */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allLower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allUpper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var toInt=function toInt(value){return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toInteger(value);};var toNum=function toNum(value){return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(value);};var firstCapital=function firstCapital(value){var values=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.words(value);__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(values,function(val,i){var v=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toLower(val);var u=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.upperFirst(v);values[i]=u;});return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.join(values,' ');};var allLower=function allLower(value){return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toLower(value);};var allUpper=function allUpper(value){return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toUpper(value);};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return history; });
/* unused harmony export location */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_index__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__monitor_reducer__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_react_session__);
/*const actionSanitizer = (action) => (
	action.type === 'FILE_DOWNLOAD_SUCCESS' && action.data ?
		{ ...action, data: '<<LONG_BLOB>>' } : action
);

const googleExtension = (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION__) ? window.__REDUX_DEVTOOLS_EXTENSION__({
	actionSanitizer,
	stateSanitizer: (state) => state.data ? { ...state, data: '<<LONG_BLOB>>' } : state,
	serialize: true
}) : null;*/var middlewareEnhancer=Object(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__["composeWithDevTools"])(Object(__WEBPACK_IMPORTED_MODULE_5_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]/*, logger*/));var configureStore=Object(__WEBPACK_IMPORTED_MODULE_5_redux__["compose"])(middlewareEnhancer,__WEBPACK_IMPORTED_MODULE_4__monitor_reducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5_redux__["createStore"]);var store=configureStore(__WEBPACK_IMPORTED_MODULE_0__reducers_index__["a" /* default */]);var history=Object(__WEBPACK_IMPORTED_MODULE_6_history__["a" /* createBrowserHistory */])();var location=history.location;__WEBPACK_IMPORTED_MODULE_7_redux_react_session__["sessionService"].initSessionService(store);/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.accounting = global.accounting || {})));
}(this, function (exports) { 'use strict';

	function __commonjs(fn, module) { return module = { exports: {} }, fn(module, module.exports), module.exports; }

	/**
	 * The library's settings configuration object.
	 *
	 * Contains default parameters for currency and number formatting
	 */
	var settings = {
	  symbol: '$', // default currency symbol is '$'
	  format: '%s%v', // controls output: %s = symbol, %v = value (can be object, see docs)
	  decimal: '.', // decimal point separator
	  thousand: ',', // thousands separator
	  precision: 2, // decimal places
	  grouping: 3, // digit grouping (not implemented yet)
	  stripZeros: false, // strip insignificant zeros from decimal part
	  fallback: 0 // value returned on unformat() failure
	};

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.decimal), so if the number uses a non-standard decimal
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. '$ (1.99)' => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 *
	 * ```js
	 *  accounting.unformat("£ 12,345,678.90 GBP"); // 12345678.9
	 * ```
	 *
	 * @method unformat
	 * @for accounting
	 * @param {String|Array<String>} value The string or array of strings containing the number/s to parse.
	 * @param {Number}               decimal Number of decimal digits of the resultant number
	 * @return {Float} The parsed number
	 */
	function unformat(value) {
	  var decimal = arguments.length <= 1 || arguments[1] === undefined ? settings.decimal : arguments[1];
	  var fallback = arguments.length <= 2 || arguments[2] === undefined ? settings.fallback : arguments[2];

	  // Recursively unformat arrays:
	  if (Array.isArray(value)) {
	    return value.map(function (val) {
	      return unformat(val, decimal, fallback);
	    });
	  }

	  // Return the value as-is if it's already a number:
	  if (typeof value === 'number') return value;

	  // Build regex to strip out everything except digits, decimal point and minus sign:
	  var regex = new RegExp('[^0-9-(-)-' + decimal + ']', ['g']);
	  var unformattedValueString = ('' + value).replace(regex, '') // strip out any cruft
	  .replace(decimal, '.') // make sure decimal point is standard
	  .replace(/\(([-]*\d*[^)]?\d+)\)/g, '-$1') // replace bracketed values with negatives
	  .replace(/\((.*)\)/, ''); // remove any brackets that do not have numeric value

	  /**
	   * Handling -ve number and bracket, eg.
	   * (-100) = 100, -(100) = 100, --100 = 100
	   */
	  var negative = (unformattedValueString.match(/-/g) || 2).length % 2,
	      absUnformatted = parseFloat(unformattedValueString.replace(/-/g, '')),
	      unformatted = absUnformatted * (negative ? -1 : 1);

	  // This will fail silently which may cause trouble, let's wait and see:
	  return !isNaN(unformatted) ? unformatted : fallback;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function _checkPrecision(val, base) {
	  val = Math.round(Math.abs(val));
	  return isNaN(val) ? base : val;
	}

	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	 * problems for accounting- and finance-related software.
	 *
	 * ```js
	 *  (0.615).toFixed(2);           // "0.61" (native toFixed has rounding issues)
	 *  accounting.toFixed(0.615, 2); // "0.62"
	 * ```
	 *
	 * @method toFixed
	 * @for accounting
	 * @param {Float}   value         The float to be treated as a decimal number.
	 * @param {Number} [precision=2] The number of decimal digits to keep.
	 * @return {String} The given number transformed into a string with the given precission
	 */
	function toFixed(value, precision) {
	  precision = _checkPrecision(precision, settings.precision);
	  var power = Math.pow(10, precision);

	  // Multiply up by precision, round accurately, then divide and use native toFixed():
	  return (Math.round((value + 1e-8) * power) / power).toFixed(precision);
	}

	var index = __commonjs(function (module) {
	/* eslint-disable no-unused-vars */
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	});

	var objectAssign = (index && typeof index === 'object' && 'default' in index ? index['default'] : index);

	function _stripInsignificantZeros(str, decimal) {
	  var parts = str.split(decimal);
	  var integerPart = parts[0];
	  var decimalPart = parts[1].replace(/0+$/, '');

	  if (decimalPart.length > 0) {
	    return integerPart + decimal + decimalPart;
	  }

	  return integerPart;
	}

	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 *
	 * ```js
	 * accounting.formatNumber(5318008);              // 5,318,008
	 * accounting.formatNumber(9876543.21, { precision: 3, thousand: " " }); // 9 876 543.210
	 * ```
	 *
	 * @method formatNumber
	 * @for accounting
	 * @param {Number}        number The number to be formatted.
	 * @param {Object}        [opts={}] Object containing all the options of the method.
	 * @return {String} The given number properly formatted.
	  */
	function formatNumber(number) {
	  var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	  // Resursively format arrays:
	  if (Array.isArray(number)) {
	    return number.map(function (val) {
	      return formatNumber(val, opts);
	    });
	  }

	  // Build options object from second param (if object) or all params, extending defaults:
	  opts = objectAssign({}, settings, opts);

	  // Do some calc:
	  var negative = number < 0 ? '-' : '';
	  var base = parseInt(toFixed(Math.abs(number), opts.precision), 10) + '';
	  var mod = base.length > 3 ? base.length % 3 : 0;

	  // Format the number:
	  var formatted = negative + (mod ? base.substr(0, mod) + opts.thousand : '') + base.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + opts.thousand) + (opts.precision > 0 ? opts.decimal + toFixed(Math.abs(number), opts.precision).split('.')[1] : '');

	  return opts.stripZeros ? _stripInsignificantZeros(formatted, opts.decimal) : formatted;
	}

	var index$1 = __commonjs(function (module) {
	'use strict';

	var strValue = String.prototype.valueOf;
	var tryStringObject = function tryStringObject(value) {
		try {
			strValue.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var strClass = '[object String]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

	module.exports = function isString(value) {
		if (typeof value === 'string') { return true; }
		if (typeof value !== 'object') { return false; }
		return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
	};
	});

	var isString = (index$1 && typeof index$1 === 'object' && 'default' in index$1 ? index$1['default'] : index$1);

	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 *
	 * @method _checkCurrencyFormat
	 * @for accounting
	 * @param {String}        [format="%s%v"] String with the format to apply, where %s is the currency symbol and %v is the value.
	 * @return {Object} object represnting format (with pos, neg and zero attributes)
	 */
	function _checkCurrencyFormat(format) {
	  // Format should be a string, in which case `value` ('%v') must be present:
	  if (isString(format) && format.match('%v')) {
	    // Create and return positive, negative and zero formats:
	    return {
	      pos: format,
	      neg: format.replace('-', '').replace('%v', '-%v'),
	      zero: format
	    };
	  }

	  // Otherwise, assume format was fine:
	  return format;
	}

	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, '$', 2, ',', '.', '%s%v')
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 *
	 * ```js
	 * // Default usage:
	 * accounting.formatMoney(12345678); // $12,345,678.00
	 *
	 * // European formatting (custom symbol and separators), can also use options object as second parameter:
	 * accounting.formatMoney(4999.99, { symbol: "€", precision: 2, thousand: ".", decimal: "," }); // €4.999,99
	 *
	 * // Negative values can be formatted nicely:
	 * accounting.formatMoney(-500000, { symbol: "£ ", precision: 0 }); // £ -500,000
	 *
	 * // Simple `format` string allows control of symbol position (%v = value, %s = symbol):
	 * accounting.formatMoney(5318008, { symbol: "GBP",  format: "%v %s" }); // 5,318,008.00 GBP
	 * ```
	 *
	 * @method formatMoney
	 * @for accounting
	 * @param {Number}        number Number to be formatted.
	 * @param {Object}        [opts={}] Object containing all the options of the method.
	 * @return {String} The given number properly formatted as money.
	 */
	function formatMoney(number) {
	  var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	  // Resursively format arrays:
	  if (Array.isArray(number)) {
	    return number.map(function (val) {
	      return formatMoney(val, opts);
	    });
	  }

	  // Build options object from second param (if object) or all params, extending defaults:
	  opts = objectAssign({}, settings, opts);

	  // Check format (returns object with pos, neg and zero):
	  var formats = _checkCurrencyFormat(opts.format);

	  // Choose which format to use for this value:
	  var useFormat = undefined;

	  if (number > 0) {
	    useFormat = formats.pos;
	  } else if (number < 0) {
	    useFormat = formats.neg;
	  } else {
	    useFormat = formats.zero;
	  }

	  // Return with currency symbol added:
	  return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), opts));
	}

	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 *
	 * ```js
	 * accounting.formatColumn([123.5, 3456.49, 777888.99, 12345678, -5432], { symbol: "$ " });
	 * ```
	 *
	 * @method formatColumn
	 * @for accounting
	 * @param {Array<Number>} list An array of numbers to format
	 * @param {Object}        [opts={}] Object containing all the options of the method.
	 * @param {Object|String} [symbol="$"] String with the currency symbol. For conveniency if can be an object containing all the options of the method.
	 * @param {Integer}       [precision=2] Number of decimal digits
	 * @param {String}        [thousand=','] String with the thousands separator.
	 * @param {String}        [decimal="."] String with the decimal separator.
	 * @param {String}        [format="%s%v"] String with the format to apply, where %s is the currency symbol and %v is the value.
	 * @return {Array<String>} array of accouting-formatted number strings of same length
	 */
	function formatColumn(list) {
	  var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	  if (!list) return [];

	  // Build options object from second param (if object) or all params, extending defaults:
	  opts = objectAssign({}, settings, opts);

	  // Check format (returns object with pos, neg and zero), only need pos for now:
	  var formats = _checkCurrencyFormat(opts.format);

	  // Whether to pad at start of string or after currency symbol:
	  var padAfterSymbol = formats.pos.indexOf('%s') < formats.pos.indexOf('%v');

	  // Store value for the length of the longest string in the column:
	  var maxLength = 0;

	  // Format the list according to options, store the length of the longest string:
	  var formatted = list.map(function (val) {
	    if (Array.isArray(val)) {
	      // Recursively format columns if list is a multi-dimensional array:
	      return formatColumn(val, opts);
	    }
	    // Clean up the value
	    val = unformat(val, opts.decimal);

	    // Choose which format to use for this value (pos, neg or zero):
	    var useFormat = undefined;

	    if (val > 0) {
	      useFormat = formats.pos;
	    } else if (val < 0) {
	      useFormat = formats.neg;
	    } else {
	      useFormat = formats.zero;
	    }

	    // Format this value, push into formatted list and save the length:
	    var fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), opts));

	    if (fVal.length > maxLength) {
	      maxLength = fVal.length;
	    }

	    return fVal;
	  });

	  // Pad each number in the list and send back the column of numbers:
	  return formatted.map(function (val) {
	    // Only if this is a string (not a nested array, which would have already been padded):
	    if (isString(val) && val.length < maxLength) {
	      // Depending on symbol position, pad after symbol or at index 0:
	      return padAfterSymbol ? val.replace(opts.symbol, opts.symbol + new Array(maxLength - val.length + 1).join(' ')) : new Array(maxLength - val.length + 1).join(' ') + val;
	    }
	    return val;
	  });
	}

	exports.settings = settings;
	exports.unformat = unformat;
	exports.toFixed = toFixed;
	exports.formatMoney = formatMoney;
	exports.formatNumber = formatNumber;
	exports.formatColumn = formatColumn;
	exports.format = formatMoney;
	exports.parse = unformat;

}));
//# sourceMappingURL=accounting.umd.js.map

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={current:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,total:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,nextPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,perPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};var defaultProps={perPage:20};var InmPagination=function(_Component){_inherits(InmPagination,_Component);_createClass(InmPagination,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default.a,{hideDisabled:true,activePage:this.props.current,itemsCountPerPage:this.props.perPage,totalItemsCount:this.props.total,prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-angle-left"}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-angle-right"}),firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-angle-double-left"}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-angle-double-right"}),onChange:this.handlePageChange.bind(this),key:"users-pages"});}}]);function InmPagination(){_classCallCheck(this,InmPagination);var _this=_possibleConstructorReturn(this,(InmPagination.__proto__||Object.getPrototypeOf(InmPagination)).call(this));_this.handlePageChange=_this.handlePageChange.bind(_this);return _this;}_createClass(InmPagination,[{key:"handlePageChange",value:function handlePageChange(values){this.props.nextPage(values);}}]);return InmPagination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InmPagination.propTypes=propTypes;InmPagination.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (InmPagination);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = get;

var _lodash = __webpack_require__(333);

var _lodash2 = _interopRequireDefault(_lodash);

var _endsWith = __webpack_require__(102);

var _endsWith2 = _interopRequireDefault(_endsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function get(object, path, defaultValue) {
  var modelString = path;

  if (typeof path === 'number') {
    var result = object[path];

    return result === undefined ? defaultValue : result;
  }

  if (!path.length) return object;

  if ((0, _endsWith2.default)(modelString, '.')) {
    modelString = modelString.slice(0, -1);
  } else if ((0, _endsWith2.default)(modelString, '[]')) {
    modelString = modelString.slice(0, -2);
  }

  return (0, _lodash2.default)(object, modelString, defaultValue);
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)(module)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isObjectLike = isObjectLike;
exports.default = isPlainObject;
// Adapted from https://github.com/jonschlinkert/is-plain-object
function isObjectLike(val) {
  return val != null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

function isObject(val) {
  return isObjectLike(val) && Array.isArray(val) === false;
}

function isObjectObject(o) {
  return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  var ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  var prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var defaultProps={disabled:false};var DatePick=function(_Component){_inherits(DatePick,_Component);function DatePick(){_classCallCheck(this,DatePick);return _possibleConstructorReturn(this,(DatePick.__proto__||Object.getPrototypeOf(DatePick)).apply(this,arguments));}_createClass(DatePick,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datepicker__["a" /* default */],{dateFormat:"YYYY-MM-DD",selected:this.props.value?__WEBPACK_IMPORTED_MODULE_3_moment__(this.props.value):undefined,onChange:function onChange(value){return _this2.props.onChange(value?__WEBPACK_IMPORTED_MODULE_3_moment__(value).format('YYYY-MM-DD'):"");},placeholderText:__WEBPACK_IMPORTED_MODULE_3_moment__().format('YYYY-MM-DD'),className:this.props.className,disabled:this.props.disabled});}}]);return DatePick;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DatePick.propTypes=propTypes;DatePick.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (DatePick);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function mapValues(object, iteratee) {
  var result = {};

  Object.keys(object || {}).forEach(function (key) {
    result[key] = iteratee(object[key], key, object);
  });

  return result;
}

exports.default = mapValues;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_notification__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_navigation_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_user_opts_dropdown__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cdm_frontend_elements_widgets_progress_bar__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(SecuredComponent,data){var CdmLayout=function(_Component){_inherits(CdmLayout,_Component);_createClass(CdmLayout,[{key:'render',value:function render(){var _this2=this;var _props=this.props,notifications=_props.notifications,location=_props.location,session=_props.session,menu=_props.menu;var municipality=this.props.match.params.municipality;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_navigation_navigation__["a" /* default */],{agencies:Object.assign({},session.user.agencies),items:Object.assign({},session.user.menu),show:menu.view,location:Object.assign({},location),key:'app-navigation-sidebar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content',key:'main-website-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'navbar is-dark secondary-navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-menu navbar-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_gobmxlogo_svg___default.a,alt:'gob.mx',className:'app-gov-logo--image'})),session.user.version?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-menu navbar-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'title is-6 has-text-centered has-text-white'},session.user.version.name)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'main-nav--close',onClick:function onClick(){return _this2.toggleMenu();}},menu.view?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-chevron-left'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-chevron-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_user_opts_dropdown__["a" /* default */],{data:Object.assign({},session.user.profile)})),data&&data.subnav&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subnavigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subnav-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa '+data.subnav.icon+' has-text-cdm-dark-blue'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,data.subnav.name))),data.subnav.actions&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data.subnav.actions,function(slot,key){var item=_this2._subnavbarItem(slot);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item',key:'subnav-'+key},item);}),data.progress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__cdm_frontend_elements_widgets_progress_bar__["a" /* default */],{total:70,detect:50,integrate:20,educate:10,followup:10,recognize:10})),data.stateNav&&data.stateNav===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item subnav-states'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small is-dark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'stateNav-statesMun',value:this.state.showState,onChange:function onChange(field){return _this2.setState({showState:field.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Estado ---'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(session.user.agencies.states,['name']),function(st,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:st.short,key:key},st.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small is-dark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'stateNav-muns',onChange:function onChange(){return _this2._changeMuns();},value:municipality},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Municipios ---'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(session.user.agencies.municipalities,{modality_id:3,state:{short:this.state.showState}}),['name']),'id'),function(mun,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:mun.slug,key:j},mun.name);})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'app-layout--content cdm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-1 main-title',dangerouslySetInnerHTML:{__html:data&&data.title?data.title:''}}),notifications.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_notification__["a" /* default */],notifications))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecuredComponent,this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'50px'}},'\xA0')))];}}]);function CdmLayout(props){_classCallCheck(this,CdmLayout);var _this=_possibleConstructorReturn(this,(CdmLayout.__proto__||Object.getPrototypeOf(CdmLayout)).call(this,props));_this.state={profileShow:false,showState:props.match.params.state,dataFind:''};_this.toggleMenu=_this.toggleMenu.bind(_this);return _this;}_createClass(CdmLayout,[{key:'_showProfile',value:function _showProfile(){this.setState({profileShow:!this.state.profileShow});}},{key:'_changeStates',value:function _changeStates(){var state=this.refs['stateNav-states'].value;var url=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_2__store_store__["b" /* history */].location.pathname,'/',5);if(url[4]==='administrativo'||url[4]==='juridica'){url[5]=state;}else{url[4]=state;}url=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.join(url,'/');__WEBPACK_IMPORTED_MODULE_2__store_store__["b" /* history */].push(url);}},{key:'_changeMuns',value:function _changeMuns(){var mun=this.refs['stateNav-muns'].value;var url=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_2__store_store__["b" /* history */].location.pathname,'/',6);if(url[4]==='administrativo'||url[4]==='juridica'){url[5]=this.state.showState;url[6]=mun;}else{url[4]=this.state.showState;url[5]=mun;}url=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.join(url,'/');__WEBPACK_IMPORTED_MODULE_2__store_store__["b" /* history */].push(url);}},{key:'_changeDataFind',value:function _changeDataFind(value){return this.setState({dataFind:value});}},{key:'_keyPress',value:function _keyPress(e,data){if(e.keyCode===13){this._handleSearch(e.target.value,data);}}},{key:'_handleSearch',value:function _handleSearch(value,data){if(value){switch(data){case'municipalities':return this.props.findMunicipalities(value);case'entities':return this.props.findEntities(value);case'users':return this.props.findUsers(value);default:return console.log('find: ',value);}}}},{key:'_subnavbarItem',value:function _subnavbarItem(item){switch(item.type){case'button':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subnav-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:item.url,className:'button is-small is-inm-purple'},item.name)));case'search':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subnav-actions'},item.element);case'component':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subnav-actions'},item.element);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subnav-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.name));}}},{key:'toggleMenu',value:function toggleMenu(){var view=this.props.menu.view;return view===true?this.props.hideMenu():this.props.showMenu();}}]);return CdmLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_5__secure__["a" /* default */])(CdmLayout);});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gobmxlogo.eed1d59c.svg";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var actionTypes = {
  BLUR: 'rrf/blur',
  CHANGE: 'rrf/change',
  FOCUS: 'rrf/focus',
  RESET: 'rrf/reset',
  VALIDATE: 'rrf/validate',
  SET_DIRTY: 'rrf/setDirty',
  SET_ERRORS: 'rrf/setErrors',
  SET_INITIAL: 'rrf/setInitial',
  SET_PENDING: 'rrf/setPending',
  SET_PRISTINE: 'rrf/setPristine',
  SET_SUBMITTED: 'rrf/setSubmitted',
  SET_SUBMIT_FAILED: 'rrf/setSubmitFailed',
  SET_TOUCHED: 'rrf/setTouched',
  SET_UNTOUCHED: 'rrf/setUntouched',
  SET_VALIDITY: 'rrf/setValidity',
  SET_VALIDATING: 'rrf/setValidating',
  SET_FIELDS_VALIDITY: 'rrf/setFieldsValidity',
  SET_VIEW_VALUE: 'rrf/setViewValue',
  RESET_VALIDITY: 'rrf/resetValidity',
  BATCH: 'rrf/batch',
  NULL: null,
  ADD_INTENT: 'rrf/addIntent',
  CLEAR_INTENTS: 'rrf/clearIntents'
};

exports.default = actionTypes;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(234);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,model:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,file:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any]),fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,validators:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,comment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,// comentario de la revisión
status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,// status de la revisión
accept:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,// extensiones que acepta
file_format:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string// formato adjunto
};var defaultProps={disabled:false,comment:undefined,status:undefined};var BigFileUpload=function(_Component){_inherits(BigFileUpload,_Component);function BigFileUpload(){_classCallCheck(this,BigFileUpload);return _possibleConstructorReturn(this,(BigFileUpload.__proto__||Object.getPrototypeOf(BigFileUpload)).apply(this,arguments));}_createClass(BigFileUpload,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control "+(this.props.fetching?'is-loading':'')},this.props.comment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"field-notification is-"+this.props.status},this.props.comment),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"file has-name is-boxed "+(this.props.size?'is-'+this.props.size:'')+" "+(this.props.status&&'is-'+this.props.status)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"file-label"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].file,{className:"file-input",model:this.props.model,id:"delegacy_majority_votes_constancy",accept:this.props.accept,disabled:this.props.disabled,errors:this.props.validators}),this.props.comment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-exclamation-circle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-cta"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-upload"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-label"},this.props.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:this.props.model,show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:this.props.message}),this.props.file?!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(this.props.file)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:this.props.file,className:"help is-success",target:"_blank"},"1 documento guardado ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-external-link","aria-hidden":"true"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"help is-info"},"Un nuevo archivo cargado"):'',this.props.file_format?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:this.props.file_format,className:"help is-info",target:"_blank"},"Descargar formato ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-external-link","aria-hidden":"true"})):'');}}]);return BigFileUpload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BigFileUpload.propTypes=propTypes;BigFileUpload.defaultPros=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (BigFileUpload);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(278);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */



var i = exports;

// we only care about objects or arrays for now
function weCareAbout(val) {
  return null !== val &&
    (Array.isArray(val) ||
      // This will skip objects created with `new Foo()`
      // and objects created with `Object.create(proto)`
      // The benefit is ignoring DOM elements and event emitters,
      // which are often circular.
      isObjectLike(val));
}

function isObjectLike(val) {
  return typeof val === "object" &&
    val.constructor === Object &&
    Object.getPrototypeOf(val) === Object.prototype;
}


function arrayClone(arr) {
  var index = 0,
    length = arr.length,
    result = Array(length);

  for (; index < length; index += 1) {
    result[index] = arr[index];
  }
  return result;
}

function objClone(obj) {
  var index = 0,
    keys = Object.keys(obj),
    length = keys.length,
    key,
    result = {};

  for (; index < length; index += 1) {
    key = keys[index];
    result[key] = obj[key];
  }
  return result;
}

function clone(coll) {
  if (Array.isArray(coll)) {
    return arrayClone(coll);
  } else {
    return objClone(coll);
  }
}

function freezeIfNeeded(coll) {
  if (
      weCareAbout(coll) &&
      (
        !Object.isFrozen(coll) &&
        "production" !== "production"
      )) {
    return baseFreeze(coll, []);
  }
  return coll;
}

function _freeze(coll) {
  if (true) {
    return coll;
  }
  if (typeof coll === "object") {
    return Object.freeze(coll);
  } else {
    return coll;
  }
}

function baseFreeze(coll, prevNodes) {
  if (prevNodes.some(function (node) { return node === coll; })) {
    throw new Error("object has a reference cycle");
  }

  Object.freeze(coll);
  prevNodes.push(coll);
  Object.keys(coll).forEach(function (key) {
    var prop = coll[key];
    if (weCareAbout(prop)) {
      baseFreeze(prop, prevNodes);
    }
  });
  prevNodes.pop();

  return coll;
}

/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */
exports.freeze = function freeze(coll) {
  if (true) {
    return coll;
  }
  return baseFreeze(coll, []);
};

/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */
exports.thaw = function thaw(coll) {
  if (weCareAbout(coll) && Object.isFrozen(coll)) {
    var newColl = clone(coll);
    Object.keys(newColl).forEach(function (key) {
      newColl[key] = thaw(newColl[key]);
    });
    return newColl;
  }
  return coll;
};

/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */
exports.assoc = function assoc(coll, key, value) {
  if (coll[key] === value) {
    return _freeze(coll);
  }

  var newObj = clone(coll);

  newObj[key] = freezeIfNeeded(value);

  return _freeze(newObj);

};
exports.set = exports.assoc;

/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */
exports.dissoc = function dissoc(coll, key) {
  var newObj = clone(coll);

  delete newObj[key];

  return _freeze(newObj);
};
exports.unset = exports.dissoc;

/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */
exports.assocIn = function assocIn(coll, path, value) {
  var key0 = path[0];
  if (path.length === 1) {
    // simplest case is a 1-element array.  Just a simple assoc.
    return i.assoc(coll, key0, value);
  } else {
    // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
  }
};
exports.setIn = exports.assocIn;

/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */
function baseGet(coll, path) {
  return (path || []).reduce(function (curr, key) {
    if (!curr) { return; }
    return curr[key];
  }, coll);
}

exports.getIn = baseGet;

/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */
exports.updateIn = function updateIn(coll, path, callback) {
  var existingVal = baseGet(coll, path);
  return i.assocIn(coll, path, callback(existingVal));
};


// generate wrappers for the mutative array methods
["push", "unshift", "pop", "shift", "reverse", "sort"]
.forEach(function (methodName) {
  exports[methodName] = function (arr, val) {
    var newArr = arrayClone(arr);

    newArr[methodName](freezeIfNeeded(val));

    return _freeze(newArr);
  };

  exports[methodName].displayName = "icepick." + methodName;
});

// splice is special because it is variadic
exports.splice = function splice(arr/*, args*/) {
  var newArr = arrayClone(arr),
    args = rest(arguments).map(freezeIfNeeded);

  newArr.splice.apply(newArr, args);

  return _freeze(newArr);
};

// slice is non-mutative
exports.slice = function slice(arr, arg1, arg2) {
  var newArr = arr.slice(arg1, arg2);

  return _freeze(newArr);
};

["map", "filter"].forEach(function (methodName) {
  exports[methodName] = function (fn, arr) {
    var newArr = arr[methodName](fn);

    return _freeze(newArr);
  };

  exports[methodName].displayName = "icepick." + methodName;
});

exports.extend =
exports.assign = function assign(/*...objs*/) {
  var newObj = rest(arguments).reduce(singleAssign, arguments[0]);

  return _freeze(newObj);
};

function singleAssign(obj1, obj2) {
  return Object.keys(obj2).reduce(function (obj, key) {
    return i.assoc(obj, key, obj2[key]);
  }, obj1);
}

exports.merge = merge;
function merge(target, source, resolver) {
  if (target == null || source == null) {
    return target;
  }
  return Object.keys(source).reduce(function (obj, key) {
    var sourceVal = source[key];
    var targetVal = obj[key];

    var resolvedSourceVal =
      resolver ? resolver(targetVal, sourceVal, key) : sourceVal;

    if (weCareAbout(sourceVal) && weCareAbout(targetVal)) {
      // if they are both frozen and reference equal, assume they are deep equal
      if ((
            (Object.isFrozen(resolvedSourceVal) &&
              Object.isFrozen(targetVal)) ||
            "production" === "production"
          ) &&
          resolvedSourceVal === targetVal) {
        return obj;
      }
      if (Array.isArray(sourceVal)) {
        return i.assoc(obj, key, resolvedSourceVal);
      }
      // recursively merge pairs of objects
      return assocIfDifferent(obj, key,
        merge(targetVal, resolvedSourceVal, resolver));
    }

    // primitive values, stuff with prototypes
    return assocIfDifferent(obj, key, resolvedSourceVal);
  }, target);
}

function assocIfDifferent(target, key, value) {
  if (target[key] === value) {
    return target;
  }
  return i.assoc(target, key, value);
}

function _slice(array, start) {
  var begin = start || 0;
  var len = array.length;
  len -= begin;
  len = len < 0 ? 0 : len;
  var result = new Array(len);
  for (var i = 0; i < len; i += 1) {
    result[i] = array[i + begin];
  }
  return result;
}


function rest(args) {
  return _slice(args, 1);
}


var chainProto = {
  value: function value() {
    return this.val;
  },
  thru: function thru(fn) {
    this.val = freezeIfNeeded(fn(this.val));
    return this;
  }
};

Object.keys(exports).forEach(function (methodName) {
  chainProto[methodName] = function (/*...args*/) {
    var args = _slice(arguments);
    args.unshift(this.val);
    this.val = exports[methodName].apply(null, args);
    return this;
  };
});

exports.chain = function chain(val) {
  var wrapped = Object.create(chainProto);
  wrapped.val = val;
  return wrapped;
};

// for testing
exports._weCareAbout = weCareAbout;
exports._slice = _slice;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var initialFieldState = {
  focus: false,
  pending: false,
  pristine: true,
  submitted: false,
  submitFailed: false,
  retouched: false,
  touched: false,
  valid: true,
  validating: false,
  validated: false,
  validity: {},
  errors: {},
  intents: []
};

exports.default = initialFieldState;

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return entitiesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return entitiesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return entityEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return entitySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return entityDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
var entitiesShow=function entitiesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(entitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/states?page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(entitiesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(entitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var entitiesList=function entitiesList(){return function(dispatch){dispatch(entitiesRequest());/*
	* Guarda las entidades en la sesion, para no mandarla a pedir al servidor, cada vez que se necesite.
	* */var storage=sessionStorage.getItem('etrans_entities');if(storage===null){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/states?per_page=40",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(entitiesListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(entitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});}else{storage=JSON.parse(storage);return dispatch(entitiesListData({data:storage}));}};};var entityEdit=function entityEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(entitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/states/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(entityEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(entitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var entitySave=function entitySave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(entitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/states"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La entidad se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/entidades/editar/"+json.data.id);}return dispatch(entityEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(entitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var entityDelete=function entityDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(entitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/states/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La entidad se ha guardado correctamente",type:"success"}));dispatch(entitiesShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(entitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var entitiesRequest=function entitiesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_2" /* ENTITIES_REQUEST */],isFetching:true,timestamp:Date.now()};};var entitiesFailed=function entitiesFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_0" /* ENTITIES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var entitiesData=function entitiesData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_3" /* ENTITIES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var entitiesListData=function entitiesListData(json){sessionStorage.setItem('etrans_entities',JSON.stringify(json.data));return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_1" /* ENTITIES_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};var entityEditData=function entityEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["Z" /* ENTITIES_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_quill__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_quill__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextEditor=function(_Component){_inherits(TextEditor,_Component);function TextEditor(){_classCallCheck(this,TextEditor);return _possibleConstructorReturn(this,(TextEditor.__proto__||Object.getPrototypeOf(TextEditor)).apply(this,arguments));}_createClass(TextEditor,[{key:'render',value:function render(){var modules={toolbar:[[{'header':[1,2,false]}],['bold','italic','underline','strike','blockquote'],[{'list':'ordered'},{'list':'bullet'},{'indent':'-1'},{'indent':'+1'}],['link'],['clean']]};var formats=['header','bold','italic','underline','strike','blockquote','list','bullet','indent','link'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_quill___default.a,Object.assign({},this.props,{theme:'snow',modules:modules,formats:formats}));}}]);return TextEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TextEditor);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var propTypes={total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,detect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,integrate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,educate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,followup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,recognize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,small:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var defaultProps={small:false};function ProgressBar(_ref){var total=_ref.total,detect=_ref.detect,integrate=_ref.integrate,educate=_ref.educate,followup=_ref.followup,recognize=_ref.recognize,small=_ref.small;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar '+(small?'small':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar--container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar--total'},total+'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar--sections'},total>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'total',style:{flexBasis:total+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detect',style:{flexBasis:detect+'%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'integrate',style:{flexBasis:integrate+'%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'educate',style:{flexBasis:educate+'%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'followup',style:{flexBasis:followup+'%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recognize',style:{flexBasis:recognize+'%'}})))));}ProgressBar.propTypes=propTypes;ProgressBar.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = {"data":[{"id":1,"title":"Identificar instituciones, programas y servicios públicos","purpose":"Conocer el universo de programas, servicios y recursos públicos disponibles a nivel municipal, estatal y nacional, particularmente dirigidos a las mujeres.","code":"CDM-D01","category":{"id":1,"name":"Detectar","style":"detect"},"date_start":"2018-08-14","date_finish":"2018-09-06","steps":7,"status":2,"locked":0,"parent":null,"duration":20,"rules":"<p>Cada que se requiera, verificar que la información de las instituciones, programas y servicios siga vigente; en caso contrario se complementará y/o actualizará.</p> <p>Integrar al catálogo de instituciones, todos aquellos programas y servicios nuevos que se identifiquen.</p>","report_info":"<p>Programs y servicios disponibles para las mujeres en el municipio.</p><ul><li>Descripción general</li><li>Dirección</li><li>Responsables: nombre completo, cargo, número de teléfono y cuenta de correo</li><li>Requisitos para participar</li></ul>","tasks":[{"id":11,"step":1,"title":"Realizar división territorial del municipio por polígonos","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"duration":1,"date_start":"2018-08-18","date_finish":"2018-08-19","output":[{"name":"Mapa del municipio con polígonos idenficados","type":"map-area","finished":1}],"files":[],"locked":1,"finished":1,"parent":null,"description":"<p>Revisar el mapa del municipio reconociendo sus características y lo dividirá en polígonos que le permitan trabajar en zonas más pequeñas, programar recorridos y actividades en cada uno.</p>"},{"id":6,"step":2,"title":"Programar recorridos de reconocimiento","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"duration":5,"date_start":"2018-08-27","date_finish":"2018-09-04","output":[{"name":"Calendario de actividades","type":"activities-calendar","finished":1}],"files":[],"locked":0,"parent":5,"finished":1,"description":"<p>Programar las fechas en que se realizarán los recorridos de reconocimiento en cada polígono identificado y los registrará en el formato Calendario general de actividades del CDM.</p>"},{"id":7,"step":3,"title":"Identificar infraestructura del Municipio","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"date_start":"2018-08-27","date_finish":"2018-09-04","duration":5,"output":[{"name":"Datos de infraestructura","type":"infrastructure-directory","finished":0},{"name":"Evidencia fotográfica","type":"photo-gallery","finished":0}],"files":[],"parent":6,"locked":0,"finished":0,"description":"<p>Visitar y recorrer el polígono programado con base al Calendario general de actividades del CDM. Al realizar el recorrido, recopilará los datos requeridos en el formato Catálogo de Infraestructura, de cada uno de los lugares y les tomará fotografía.</p><p>Es fundamental identificar a las y los responsables del espacio para futura referencia y registrar la información en el mismo formato.</p>"},{"id":8,"step":4,"title":"Elaborar catálogo de infraestructura del municipio","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"duration":5,"date_start":"2018-08-27","date_finish":"2018-09-04","output":[{"name":"Datos de infraestructura","type":"infrastructure-directory","finished":0},{"name":"Evidencia fotográfica","type":"photo-gallery","finished":0}],"files":[],"locked":0,"parent":7,"finished":0,"description":"<p>Integrar la información recabada en el Catálogo de infraestructura. En caso de que el catálogo ya cuente con elementos estructurales previamente registrados, se validará que la información esté actualizada y completa.</p><p>Es importante generar un archivo nuevo del Catálogo de infraestructura por cada polígono definido.</p>"},{"id":1,"step":5,"title":"Identificar instituciones a nivel municipal y estatal","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"duration":5,"date_start":"2018-08-14","date_finish":"2018-08-21","output":[{"name":"Directorio de instituciones","type":"places-directory","finished":1}],"files":[],"locked":0,"finished":1,"parent":null,"description":"<p>Realizar una investigación sobre las instituciones públicas que ofrecen programas y servicios particularmente dirigidos a las mujeres del municipio, a nivel federal, estatal y municipal.</p><p>Se apoyará en los catálogos y directorios oficiales existentes de cada institución.</p>"},{"id":2,"step":2,"title":"Solicitar información a los programas y servicios a nivel municipales y estatales","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"duration":5,"date_start":"2018-08-22","date_finish":"2018-08-29","output":[{"name":"Directorio de programas y servicios","type":"services-directory","finished":0}],"files":[],"locked":0,"finished":0,"parent":1,"description":"<p>Solicitar a cada una de las instituciones, información de sus servicios y programas, así como los requerimientos para acceder a ellos y los datos de contacto del responsable. En caso de visitar la institución, recopilar material de información y difusión.</p>"},{"id":3,"step":3,"title":"Validar y consolidar el \"Catálogo de instituciones\"","role":{"id":1,"name":"Coordinador/a","slug":"coordinadora"},"duration":5,"output":[{"name":"Directorios de instituciones","type":"places-directory","finished":0}],"files":[{"name":"CDM-DT-01A","file":"/cdm/files/cdm-dt-01a.docx"}],"locked":1,"finished":0,"parent":1,"description":"<p>Validar que la información esté completa y actualizada, de acuerdo con lo solicitado en el catálogo de instituciones. Una vez realizado lo anterior, se integrará en el formato catálogo de instituciones.</p> <p>En caso contrario, deberá solicitar los datos específicos a la Institución correspondiente.</p>"},{"id":4,"step":4,"title":"Validar y consolidar el \"Catálogo de programas y servicios\"","role":{"id":1,"name":"Coordinador/a","slug":"coordinadora"},"duration":5,"output":[{"name":"Directorio de programas y servicios","type":"services-directory","finished":0}],"files":[{"name":"CDM-DT-01B","file":"/cdm/files/cdm-dt-01b.docx"}],"locked":1,"finished":0,"parent":2,"description":"<p>Verificar que la información recibida de cada uno de los servicios y programas identificados, esté completa y actualizada de acuerdo con lo solicitado en el catálogo de programas  y servicios. Una vez realizado lo anterior, se integrará en el formato catálogo de programas y servicios.</p> <p>En caso contrario, deberá solicitar los datos específicos a la Institución correspondiente.</p>"}]},{"id":2,"title":"Identificar actores sociales, usuarios con potencial de líder","purpose":"Convocar a actores/as sociales, líderes y lideresas para integrar una red de mujeres.","code":"CDM-D02","category":{"id":1,"name":"Detectar","style":"detect"},"date_start":"2018-09-07","date_finish":"2018-11-25","steps":6,"status":1,"locked":1,"parent":1,"duration":42,"rules":"<p>Recabar evidencia fotográfica de la infraestructura identificada e integrarse al Catálogo.</p> <p>El “Directorio de usuarias/os identificadas con potencial de líder y actores/as sociales”, deberá contener sólo información previamente validada.</p> <p>Identificar usuarias/os con potencial de líder y actores/as sociales adicionales en el municipio. Al menos una mujer líder y un actor social por cada uno de los polígonos del municipio o con alcance en cada uno de éstos.</p>","report_info":"<p>Registros de usuarias/os identificadas con potencial de líder y actores/as sociales detectados</p><ul><li>Nombre completo, número de teléfono y cuenta de correo, así como  indicar las temáticas en las que incide a favor de las mujeres preferentemente y/o de la comunidad.</li></ul><p><em>Es importante tomar en cuenta a las mujeres que tengan facilidad de convocatoria en la comunidad y que puedan ser aliadas estratégicas para el cumplimiento de las actividades de los centros.</em></p>","tasks":[{"id":9,"step":1,"title":"Identificar y contactar usuarias/os identificadas con potencial de líder y actores/as sociales de la comunidad","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"duration":5,"date_start":"2018-08-27","date_finish":"2018-09-04","output":[{"name":"Directorio de usuarias/os","type":"people-directory","finished":0}],"files":[{"name":"CDM-DT-02","file":"cdm/files/cdm-dt-02.docx"}],"locked":0,"parent":8,"finished":0,"description":"<p>Contactar a las instituciones públicas locales identificadas previamente con el fin de indagar sobre aquellas usuarias/os identificadas con potencial de líder y otros actores/as sociales que residan en los distintos polígonos del municipio. Al momento de realizar los recorridos de reconocimiento, deberá contactar a las usuarias/os identificadas con potencial de líder y actores/as sociales recomendados por las instituciones. En esta etapa es posible identificar nuevas usuarias/os con potencial de líder y actores/as sociales, mediante la interacción con personas de la comunidad. Es importante que en este primer contacto, se les informe la visión del CDM para integrarlas a la red de mujeres y deberá registrar los datos de contacto.</p>"},{"id":10,"step":2,"title":"Validar Directorio de Usuarias/os identificadas con potencial de líder y actores/as sociales","role":{"id":1,"name":"Coordinador/a","slug":"coordinadora"},"duration":5,"date_start":"2018-08-27","date_finish":"2018-09-04","output":[{"name":"Directorio de usuarias/os","type":"people-directory","finished":0}],"files":[{"name":"CDM-DT-03","file":"cdm/files/cdm-dt-03.docx"}],"locked":0,"parent":9,"finished":0,"description":"<p>Registrar y/o actualizar la información recabada y validada en el formato Directorio de usuarias/os identificadas con potencial de líder y actores/as sociales.</p>"}]},{"id":3,"title":"Incluir a la comunidad","purpose":"Promover las actividades de los centros a la ciudadana e identificar prioridades y oportunidades para emprender acciones.","code":"CDM-I01","category":{"id":2,"name":"Integrar","style":"integrate"},"date_start":"2018-11-25","date_finish":"2018-01-03","steps":6,"status":1,"locked":1,"parent":2,"duration":42,"rules":"<p>Establecer en el Plan de Trabajo del periodo, las temáticas a explorar durante los diagnósticos participativos.</p><p>Planear y realizar los diagnósticos en los distintos polígonos del municipio para contar con cobertura territorial.</p><p>Garantizar una participación máxima de 20 personas por actividad.</p><p>Extender la invitación a hombres y mujeres de la comunidad, entre los cuales, deberá considerar entre un 50% y 60% de asistentes mujeres.</p><p>Apoyarse en la red de mujeres del CDM para convocar a nuevos grupos de personas.</p><p>Contar con registro de asistencia y recabar evidencia fotográfica del diagnóstico participativo.</p><p>En caso de requerir la participación de una persona especializada, deberán gestionarlo con la coordinador/a del CDM.</p>","report_info":"<p>Documento que describe los resultados de los diagnósticos participativos realizados.</p><p>Registros de usuarias/os identificadas con potencial de líder, actores/as sociales y usuarias/os asistentes, desagregados por sexo.</p><ul><li>Nombre completo, número de teléfono y cuenta de correo, así como  indicar las temáticas en las que incide a favor de las mujeres preferentemente y/o de la comunidad.</li></ul>","tasks":[{"id":11,"step":1,"title":"Seleccionar y asegurar el espacio","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"duration":5,"date_start":"2018-08-27","date_finish":"2018-09-04","output":[{"name":"Calendario de actividades","type":"activities-calendar","finished":1}],"files":[{"name":"CDM-DT-03","file":"cdm/files/cdm-dt-03.docx"}],"locked":0,"parent":9,"finished":0,"description":"<p>Definir el lugar (apoyándose del Catálogo de infraestructura), fecha y hora para llevar a cabo la actividad de diagnóstico con la comunidad, de acuerdo al Calendario general de actividades del CDM.</p><p>Gestionar el espacio para realizar el Diagnóstico participativo.</p>"},{"id":12,"step":2,"title":"Verificar materiales y recursos","role":{"id":2,"name":"Promotor/a","slug":"promotora"},"duration":1,"date_start":"2018-08-27","date_finish":"2018-09-04","output":[{"name":"Directorio de usuarias/os","type":"people-directory","finished":0}],"files":[{"name":"CDM-DT-03","file":"cdm/files/cdm-dt-03.docx"}],"locked":0,"parent":9,"finished":0,"description":"<p>Definir el lugar (apoyándose del Catálogo de infraestructura), fecha y hora para llevar a cabo la actividad de diagnóstico con la comunidad, de acuerdo al Calendario general de actividades del CDM.</p><p>Gestionar el espacio para realizar el Diagnóstico participativo.</p>"}]}]}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(285);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(437) !== null) && (__webpack_require__(438) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
    return saveAs;
  }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modalitiesList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
var modalitiesList=function modalitiesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(modalitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/modalities?status_id=1",options).then(function(result){if(result.status>=200&&result.status<=300){return result.json();}else{result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(modalitiesListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(modalitiesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var modalitiesRequest=function modalitiesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_37" /* MODALITIES_REQUEST */],isFetching:true,timestamp:Date.now()};};var modalitiesFail=function modalitiesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_35" /* MODALITIES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var modalitiesListData=function modalitiesListData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_36" /* MODALITIES_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_notifications__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notification=function(_Component){_inherits(Notification,_Component);function Notification(){_classCallCheck(this,Notification);return _possibleConstructorReturn(this,(Notification.__proto__||Object.getPrototypeOf(Notification)).apply(this,arguments));}_createClass(Notification,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inm-global-notification notification is-'+this.props.data.type,style:{display:this.props.active?'block':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete',onClick:function onClick(){return _this2.props.clearThis();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.data.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:this.props.data.content}}));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _this3=this;if(newprops.active){setTimeout(function(){_this3.props.clearThis();},5000);}}}]);return Notification;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){var notifications=state.notifications;return{notifications:notifications};}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{clearThis:function clearThis(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_notifications__["a" /* clearNotification */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Notification));

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_proequidad_logo_svg__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_proequidad_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_proequidad_logo_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Navigation=function(_Component){_inherits(Navigation,_Component);_createClass(Navigation,[{key:'render',value:function render(){var _this2=this;var _props=this.props,isFetching=_props.isFetching,items=_props.items,location=_props.location,show=_props.show;return isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-navigation loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'animated-background'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-masker'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'main-nav '+(show?'':'closed'),key:'main-website-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_proequidad_logo_svg___default.a,alt:'InMujeres',className:'app-logo--image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'app-logo--text'},'INM')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'app-navigation',role:'navigation'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(items,function(row,k){var selected=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(row,function(o){return o===location.pathname?true:false;})!==undefined?'selected':'';var g=row.menu;var group=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(g?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(g,function(o){return location.pathname.indexOf(o.url)!==-1;}):'')?'active':'';return row.menu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:k,className:row.menu?'group '+group+(_this2.state.selected===row.id?'active':''):group,onClick:function onClick(){return _this2.selectGroup(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'group--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(row.icon)?row.icon:'sliders')}),row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'app-navigation--submenu'},row.menu.map(function(sub,j){var url=_this2._setNavUrl(sub.url);var regex=new RegExp(url,"g");var sel=regex.test(location.pathname)?'selected':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:j,className:sel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:''+url,activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+sub.icon}),sub.name));}))):row.url!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:k,className:row.menu?'group '+selected:selected},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:''+row.url,activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+row.icon}),row.name));})));}}]);function Navigation(props){_classCallCheck(this,Navigation);var _this=_possibleConstructorReturn(this,(Navigation.__proto__||Object.getPrototypeOf(Navigation)).call(this,props));_this.state={selected:undefined};return _this;}_createClass(Navigation,[{key:'selectGroup',value:function selectGroup(row){return this.setState({selected:row});}},{key:'_setNavUrl',value:function _setNavUrl(url){var urlArray=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(url,'/',8);var urlFinal='';var agencies=this.props.agencies;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(this.props.agencies)){if(!/(notificacion)+/i.test(urlArray[1])){if(/(administrativo)+/i.test(urlArray[4])||/(juridica)+/i.test(urlArray[4])){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(urlArray,function(o){return o==='modalidad-i'||o==='modalidad-iii';})>-1&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agencies['modalidad-i'])){urlArray[5]=agencies['modalidad-i'][0].agenciable_short;urlFinal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(urlArray,'/');}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(urlArray,function(o){return o==='modalidad-ii';})>-1&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agencies['modalidad-ii'])){urlArray[5]=agencies['modalidad-ii'][0].agenciable_state_short;urlArray[6]=agencies['modalidad-ii'][0].agenciable_slug;urlFinal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(urlArray,'/');}else{urlFinal=url;}}else if(/(cdms)+/i.test(urlArray[1])){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(this.props.cdms)){urlArray[3]=this.props.cdms[0].agenciable_state_short;urlArray[4]=this.props.cdms[0].agenciable_slug;urlFinal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(urlArray,'/');}else{urlFinal=url;}}else if(/(proyectos)+/i.test(urlArray[1])){urlFinal=url;}else{if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(urlArray,function(o){return o==='modalidad-i';})>-1&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agencies['modalidad-i'])){urlArray[4]=agencies['modalidad-i'][0].agenciable_short;;urlFinal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(urlArray,'/');}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(urlArray,function(o){return o==='modalidad-ii';})>-1&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agencies['modalidad-ii'])){urlArray[4]=agencies['modalidad-ii'][0].agenciable_state_short;urlArray[5]=agencies['modalidad-ii'][0].agenciable_slug;urlFinal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(urlArray,'/');}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(urlArray,function(o){return o==='modalidad-i'||o==='modalidad-iii';})>-1&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agencies['modalidad-i'])){urlArray[4]=agencies['modalidad-i'][0].agenciable_short;urlFinal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(urlArray,'/');}else{urlFinal=url;}}}else{urlFinal=url;}}else{urlFinal=url;}return urlFinal;}}]);return Navigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Navigation);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_user_profile_male_jpg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_user_profile_male_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_user_profile_male_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};var defaultProps={data:{image:__WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg___default.a,name:'[Error]',sex:'F'}};var UserDropdown=function(_Component){_inherits(UserDropdown,_Component);_createClass(UserDropdown,[{key:"render",value:function render(){var _props$data=this.props.data,name=_props$data.name,sex=_props$data.sex,image=_props$data.image;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-menu navbar-end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-item has-dropdown "+(this.state.profileShow?'is-active':null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"navbar-link",onClick:this.showProfile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"profile-pic"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:image?image:sex==='H'?__WEBPACK_IMPORTED_MODULE_4__assets_images_user_profile_male_jpg___default.a:__WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg___default.a,alt:"Usuario"})),name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-dropdown"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/perfil",activeClassName:"active",className:"navbar-item"},"Mi perfil"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"navbar-divider"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/logout",activeClassName:"active",className:"navbar-item"},"Cerrar sesi\xF3n"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"navbar-item"}));}}]);function UserDropdown(){_classCallCheck(this,UserDropdown);var _this=_possibleConstructorReturn(this,(UserDropdown.__proto__||Object.getPrototypeOf(UserDropdown)).call(this));_this.state={profileShow:false};_this.showProfile=_this.showProfile.bind(_this);return _this;}_createClass(UserDropdown,[{key:"showProfile",value:function showProfile(){this.setState({profileShow:!this.state.profileShow});}}]);return UserDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserDropdown.propTypes=propTypes;UserDropdown.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (UserDropdown);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fieldActions = __webpack_require__(185);

var _fieldActions2 = _interopRequireDefault(_fieldActions);

var _modelActions = __webpack_require__(337);

var _modelActions2 = _interopRequireDefault(_modelActions);

var _batchActions = __webpack_require__(103);

var _batchActions2 = _interopRequireDefault(_batchActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actions = _extends({}, _fieldActions2.default, _modelActions2.default, {
  batch: _batchActions2.default
});

exports.default = actions;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = identity;
function identity(a) {
  return a;
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = omit;
function omit(object, props) {
  if (object == null) {
    return {};
  }
  var newObject = _extends({}, object);

  if (typeof props === 'string') {
    delete newObject[props];
  } else {
    props.forEach(function (prop) {
      delete newObject[prop];
    });
  }

  return newObject;
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable */

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  if (objA instanceof Date && objB instanceof Date) {
    return objA === objB;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var omitKeys = options.omitKeys,
      deepKeys = options.deepKeys;

  // Test for A's keys different from B.

  for (var i = 0; i < keysA.length; i++) {
    // if key is an omitted key, skip comparison
    if (omitKeys && omitKeys.length && ~omitKeys.indexOf(keysA[i])) continue;

    if (deepKeys && deepKeys.length && ~deepKeys.indexOf(keysA[i])) {
      var result = shallowEqual(objA[keysA[i]], objB[keysA[i]]);

      if (!result) return false;
    } else if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

exports.default = shallowEqual;

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return statusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return statusGroupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return statusMotivesList; });
/* unused harmony export statusActivitiesList */
/* unused harmony export statusRequest */
/* unused harmony export statusDetails */
/* unused harmony export statusFailed */
/* unused harmony export statusGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
var statusList=function statusList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(statusRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/status?include[0]=groups&group_id=1",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(statusDetails(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(statusFailed(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var statusGroupList=function statusGroupList(){var group=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(statusRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/status?group_id="+group,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(statusGroup(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(statusFailed(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var statusMotivesList=function statusMotivesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(statusRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/status/groups?include[0]=statuses.motives",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(statusDetails(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(statusFailed(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var statusActivitiesList=function statusActivitiesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(statusRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/status/groups?slug=activities&include[0]=statuses.motives",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(statusDetails(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(statusFailed(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var statusRequest=function statusRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_224" /* STATUS_REQUEST */],isFetching:true,timestamp:Date.now()};};var statusDetails=function statusDetails(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_222" /* STATUS_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};var statusFailed=function statusFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_221" /* STATUS_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var statusGroup=function statusGroup(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_223" /* STATUS_GROUP */],isFetching:false,payload:json.data,timestamp:Date.now()};};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(545),
    getValue = __webpack_require__(550);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_notification__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_navigation_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_user_opts_dropdown__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_projects_edit_subnav__ = __webpack_require__(649);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(SecuredComponent,data){var ProjectsEditLayout=function(_Component){_inherits(ProjectsEditLayout,_Component);_createClass(ProjectsEditLayout,[{key:'render',value:function render(){var _this2=this;var _props=this.props,notifications=_props.notifications,match=_props.match,location=_props.location,session=_props.session,projects=_props.projects,menu=_props.menu;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_navigation_navigation__["a" /* default */],{agencies:Object.assign({},session.user.agencies),cdms:Object.assign({},session.user.cdms),items:Object.assign({},session.user.menu),show:menu.view,location:Object.assign({},location),key:'app-navigation-sidebar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-content',key:'project-website-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'navbar is-dark secondary-navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-menu navbar-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_gobmxlogo_svg___default.a,alt:'gob.mx',className:'app-gov-logo--image'})),session.user.version?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-menu navbar-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'title is-6 has-text-centered has-text-white'},session.user.version.name)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'main-nav--close',onClick:function onClick(){return _this2.toggleMenu();}},menu.view?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-chevron-left'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-chevron-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_user_opts_dropdown__["a" /* default */],{data:Object.assign({},session.user.profile)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_projects_edit_subnav__["a" /* default */],{step:data.subnav,params:match.params,projects:projects}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'app-layout--content'},notifications.data.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_notification__["a" /* default */],notifications))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecuredComponent,this.props))))];}}]);function ProjectsEditLayout(){_classCallCheck(this,ProjectsEditLayout);var _this=_possibleConstructorReturn(this,(ProjectsEditLayout.__proto__||Object.getPrototypeOf(ProjectsEditLayout)).call(this));_this.toggleMenu=_this.toggleMenu.bind(_this);return _this;}_createClass(ProjectsEditLayout,[{key:'toggleMenu',value:function toggleMenu(){var view=this.props.menu.view;return view===true?this.props.hideMenu():this.props.showMenu();}}]);return ProjectsEditLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_1__secure__["a" /* default */])(ProjectsEditLayout);});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_notification__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_navigation_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_user_opts_dropdown__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_navigation_project_control__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_navigation_project_navigation__ = __webpack_require__(148);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(SecuredComponent,data){var ProjectsLayout=function(_Component){_inherits(ProjectsLayout,_Component);_createClass(ProjectsLayout,[{key:'render',value:function render(){var _this2=this;var _props=this.props,userLogin=_props.userLogin,notifications=_props.notifications,match=_props.match,location=_props.location,session=_props.session,menu=_props.menu,project=_props.project;var agencies=session.user.agencies;var agency=this.setAgencyName(match.params.modality,agencies);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_navigation_navigation__["a" /* default */],{agencies:Object.assign({},session.user.agencies),cdms:Object.assign({},session.user.cdms),items:Object.assign({},session.user.menu),show:menu.view,location:Object.assign({},location),key:'app-navigation-sidebar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-content',key:'project-website-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'navbar is-dark secondary-navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-menu navbar-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default.a,alt:'gob.mx',className:'app-gov-logo--image'})),session.user.version?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-menu navbar-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'title is-6 has-text-centered has-text-white'},session.user.version.name)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'main-nav--close',onClick:function onClick(){return _this2.toggleMenu();}},menu.view?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-chevron-left'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-chevron-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_user_opts_dropdown__["a" /* default */],{data:Object.assign({},session.user.profile)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_navigation_project_navigation__["a" /* default */],{isFetching:userLogin.isFetching,filter:this.state.filterType,filterChange:this.filterChange,modality:match.params.modality,entity:match.params.state,agencies:session.user.agencies,municipalityFilter:this.municipalityFilter,municipalityChange:this.municipalityChange,stateChange:this.stateChange,agenciable:{state:this.state.modState,municipality:match.params.municipality}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_navigation_project_control__["a" /* default */],{step:data.subnav,params:match.params,agency:agency,phase:project.phase,version:project.version}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'app-layout--content'},notifications.data.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_notification__["a" /* default */],notifications))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecuredComponent,this.props))))];}}]);function ProjectsLayout(props){_classCallCheck(this,ProjectsLayout);var _this=_possibleConstructorReturn(this,(ProjectsLayout.__proto__||Object.getPrototypeOf(ProjectsLayout)).call(this,props));_this.state={modState:props.match.params.state,filterType:'all_projects'};_this.municipalityFilter=_this.municipalityFilter.bind(_this);_this.municipalityChange=_this.municipalityChange.bind(_this);_this.stateChange=_this.stateChange.bind(_this);_this.filterChange=_this.filterChange.bind(_this);_this.toggleMenu=_this.toggleMenu.bind(_this);return _this;}_createClass(ProjectsLayout,[{key:'filterChange',value:function filterChange(e){return this.setState({filterType:e.target.value});}},{key:'stateChange',value:function stateChange(state){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(this.props.location.pathname,'/',5);url[4]=state;url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');return this.props.history.push(url);}},{key:'municipalityFilter',value:function municipalityFilter(state){return this.setState({modState:state});}},{key:'municipalityChange',value:function municipalityChange(municipality){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(this.props.location.pathname,'/',6);url[4]=this.state.modState;url[5]=municipality;url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');return this.props.history.push(url);}},{key:'setAgencyName',value:function setAgencyName(mod,agencies){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality;var agency=undefined;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agencies)){switch(mod){case'modalidad-i':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-i'],{agenciable_short:state});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;case'modalidad-ii':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-ii'],{agenciable_slug:municipality});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;case'modalidad-iii':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-iii'],{agenciable_short:state});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;default:return undefined;}}else{return null;}}},{key:'toggleMenu',value:function toggleMenu(){var view=this.props.menu.view;return view===true?this.props.hideMenu():this.props.showMenu();}}]);return ProjectsLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_1__secure__["a" /* default */])(ProjectsLayout);});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationStatus=function(_Component){_inherits(NotificationStatus,_Component);function NotificationStatus(){_classCallCheck(this,NotificationStatus);return _possibleConstructorReturn(this,(NotificationStatus.__proto__||Object.getPrototypeOf(NotificationStatus)).apply(this,arguments));}_createClass(NotificationStatus,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",this.props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Estatus ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"success",className:"has-text-success"},"Correcto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"danger",className:"has-text-danger"},"Incorrecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"warning",className:"has-text-warning"},"Observaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"info",className:"has-text-info"},"Comentario"));}}]);return NotificationStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NotificationStatus);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditStatus=function(_Component){_inherits(EditStatus,_Component);function EditStatus(){_classCallCheck(this,EditStatus);return _possibleConstructorReturn(this,(EditStatus.__proto__||Object.getPrototypeOf(EditStatus)).apply(this,arguments));}_createClass(EditStatus,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",this.props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:undefined},"--- Edici\xF3n ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:true},"Permitir edici\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:false},"No permitir edici\xF3n"));}}]);return EditStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EditStatus);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFieldFromState;

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _toPath = __webpack_require__(80);

var _toPath2 = _interopRequireDefault(_toPath);

var _getForm = __webpack_require__(79);

var _getForm2 = _interopRequireDefault(_getForm);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStrategy = {
  getForm: _getForm2.default
};

function getFieldFromState(state, modelString) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;

  var form = state && '$form' in state ? state : s.getForm(state, modelString);

  if (!form || !form.$form) return null;

  if (!modelString.length) return form;

  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', modelString);

  var formPath = (0, _toPath2.default)(form.$form.model);
  var fieldPath = (0, _toPath2.default)(modelString).slice(formPath.length);
  var field = (0, _get2.default)(form, fieldPath);

  if (!field) return null;
  if ((0, _isPlainObject2.default)(field) && '$form' in field) return field.$form;

  return field;
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getModel;
function getModel(model, state) {
  return typeof model === 'function' && state ? model(state) : model;
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValid;
exports.fieldsValid = fieldsValid;

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValid(formState) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };

  if (!formState) return true;

  if (!formState.$form) {
    var errors = formState.errors;


    if (!Array.isArray(errors) && !(0, _isPlainObject2.default)(errors)) {
      // If asyncKeys = true and the error is not an
      // array or object (e.g. string), form errors are entirely async
      // and should be ignored when async = true.
      return !options.async && formState.asyncKeys || !errors;
    }

    return Object.keys(formState.errors).every(function (errorKey) {
      // if specified to ignore async validator keys and
      // current error key is an async validator key,
      // treat key as valid
      if (!options.async && Array.isArray(formState.asyncKeys) && !!~formState.asyncKeys.indexOf(errorKey)) {
        return true;
      }

      var valid = !formState.errors[errorKey];

      return valid;
    });
  }

  return Object.keys(formState).every(function (key) {
    return isValid(formState[key], options);
  });
}

function fieldsValid(formState) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };

  return Object.keys(formState).every(function (key) {
    return key === '$form' || isValid(formState[key], options);
  });
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assoc = assoc;
exports.default = assocIn;

var _identity = __webpack_require__(48);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function objClone(obj) {
  var keys = Object.keys(obj);
  var length = keys.length;
  var result = {};
  var index = 0;
  var key = void 0;

  for (; index < length; index += 1) {
    key = keys[index];
    result[key] = obj[key];
  }
  return result;
}

function assoc(state, key, value) {
  var newState = objClone(state);

  newState[key] = value;

  return newState;
}

function assocIn(state, path, value) {
  var fn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _identity2.default;

  if (!path.length) return value;

  var key0 = path[0];

  if (path.length === 1) {
    return fn(assoc(state, key0, value));
  }

  return fn(assoc(state, key0, assocIn(state[key0] || {}, path.slice(1), value, fn)));
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return conagoList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actorsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actorsGroups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
var conagoList=function conagoList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(directoriesRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/directories/conago-clauses?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(conagoData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(directoriesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var conagoData=function conagoData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["T" /* DIRECTORIES_CONAGO_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};var actorsList=function actorsList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(directoriesRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/directories/actors?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(actorsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(directoriesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var actorsData=function actorsData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["R" /* DIRECTORIES_ACTORS_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};var actorsGroups=function actorsGroups(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(directoriesRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/directories/actors/groups?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(actorsGroupsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(directoriesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var actorsGroupsData=function actorsGroupsData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["S" /* DIRECTORIES_ACTORS_GROUPS_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};var directoriesRequest=function directoriesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["V" /* DIRECTORIES_REQUEST */],isFetching:true,timestamp:Date.now()};};var directoriesFail=function directoriesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["U" /* DIRECTORIES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var style = {
  display: 'inline-block',
  borderRadius: '50%',
  border: '5px double white',
  width: 30,
  height: 30
};
var Style = {
  empty: _objectSpread({}, style, {
    backgroundColor: '#ccc'
  }),
  full: _objectSpread({}, style, {
    backgroundColor: 'black'
  }),
  placeholder: _objectSpread({}, style, {
    backgroundColor: 'red'
  })
};

// Return the corresponding React node for an icon.
var _iconNode = function _iconNode(icon) {
  // If it is already a React Element just return it.
  if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(icon)) {
    return icon;
  } // If it is an object, try to use it as a CSS style object.


  if (_typeof(icon) === 'object' && icon !== null) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      style: icon
    });
  } // If it is a string, use it as class names.


  if (Object.prototype.toString.call(icon) === '[object String]') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: icon
    });
  }
};

var RatingSymbol =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RatingSymbol, _React$PureComponent);

  function RatingSymbol() {
    _classCallCheck(this, RatingSymbol);

    return _possibleConstructorReturn(this, _getPrototypeOf(RatingSymbol).apply(this, arguments));
  }

  _createClass(RatingSymbol, [{
    key: "render",
    value: function render() {
      var _iconContainerStyle;

      var _this$props = this.props,
          index = _this$props.index,
          inactiveIcon = _this$props.inactiveIcon,
          activeIcon = _this$props.activeIcon,
          percent = _this$props.percent,
          direction = _this$props.direction,
          readonly = _this$props.readonly,
          onClick = _this$props.onClick,
          onMouseMove = _this$props.onMouseMove;

      var backgroundNode = _iconNode(inactiveIcon);

      var iconNode = _iconNode(activeIcon);

      var iconContainerStyle = (_iconContainerStyle = {
        display: 'inline-block',
        position: 'absolute',
        overflow: 'hidden',
        top: 0
      }, _defineProperty(_iconContainerStyle, direction === 'rtl' ? 'right' : 'left', 0), _defineProperty(_iconContainerStyle, "width", "".concat(percent, "%")), _iconContainerStyle);
      var style = {
        cursor: !readonly ? 'pointer' : 'inherit',
        display: 'inline-block',
        position: 'relative'
      };

      function handleMouseMove(e) {
        if (onMouseMove) {
          onMouseMove(index, e);
        }
      }

      function handleMouseClick(e) {
        if (onClick) {
          // [Supporting both TouchEvent and MouseEvent](https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent)
          // We must prevent firing click event twice on touch devices.
          e.preventDefault();
          onClick(index, e);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        style: style,
        onClick: handleMouseClick,
        onMouseMove: handleMouseMove,
        onTouchMove: handleMouseMove,
        onTouchEnd: handleMouseClick
      }, backgroundNode, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        style: iconContainerStyle
      }, iconNode));
    }
  }]);

  return RatingSymbol;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent); // Define propTypes only in development. They will be void in production.

var Rating =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Rating, _React$PureComponent);

  function Rating(props) {
    var _this;

    _classCallCheck(this, Rating);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rating).call(this, props));
    _this.state = {
      // Indicates the value that is displayed to the user in the form of symbols.
      // It can be either 0 (for no displayed symbols) or (0, end]
      displayValue: _this.props.value,
      // Indicates if the user is currently hovering over the rating element
      interacting: false
    };
    _this.onMouseLeave = _this.onMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.symbolMouseMove = _this.symbolMouseMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.symbolClick = _this.symbolClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Rating, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var valueChanged = this.props.value !== nextProps.value;
      this.setState(function (prevState) {
        return {
          displayValue: valueChanged ? nextProps.value : prevState.displayValue
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Ignore state update due to value changed from props.
      // Usually originated through an onClick event.
      if (prevProps.value !== this.props.value) {
        return;
      } // When hover ends, call this.props.onHover with no value.


      if (prevState.interacting && !this.state.interacting) {
        return this.props.onHover();
      } // When hover over.


      if (this.state.interacting) {
        this.props.onHover(this.state.displayValue);
      }
    }
  }, {
    key: "symbolClick",
    value: function symbolClick(symbolIndex, event) {
      var value = this.calculateDisplayValue(symbolIndex, event);
      this.props.onClick(value, event);
    }
  }, {
    key: "symbolMouseMove",
    value: function symbolMouseMove(symbolIndex, event) {
      var value = this.calculateDisplayValue(symbolIndex, event); // This call should cause an update only if the state changes.
      // Mainly the first time the mouse enters and whenever the value changes.
      // So DidComponentUpdate is NOT called for every mouse movement.

      this.setState({
        interacting: !this.props.readonly,
        displayValue: value
      });
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.setState({
        displayValue: this.props.value,
        interacting: false
      });
    }
  }, {
    key: "calculateDisplayValue",
    value: function calculateDisplayValue(symbolIndex, event) {
      var percentage = this.calculateHoverPercentage(event); // Get the closest top fraction.

      var fraction = Math.ceil(percentage % 1 * this.props.fractions) / this.props.fractions; // Truncate decimal trying to avoid float precission issues.

      var precision = Math.pow(10, 3);
      var displayValue = symbolIndex + (Math.floor(percentage) + Math.floor(fraction * precision) / precision); // ensure the returned value is greater than 0 and lower than totalSymbols

      return displayValue > 0 ? displayValue > this.props.totalSymbols ? this.props.totalSymbols : displayValue : 1 / this.props.fractions;
    }
  }, {
    key: "calculateHoverPercentage",
    value: function calculateHoverPercentage(event) {
      var clientX = event.nativeEvent.type.indexOf("touch") > -1 ? event.nativeEvent.type.indexOf("touchend") > -1 ? event.changedTouches[0].clientX : event.touches[0].clientX : event.clientX;
      var targetRect = event.target.getBoundingClientRect();
      var delta = this.props.direction === 'rtl' ? targetRect.right - clientX : clientX - targetRect.left; // Returning 0 if the delta is negative solves the flickering issue

      return delta < 0 ? 0 : delta / targetRect.width;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          readonly = _this$props.readonly,
          quiet = _this$props.quiet,
          totalSymbols = _this$props.totalSymbols,
          value = _this$props.value,
          placeholderValue = _this$props.placeholderValue,
          direction = _this$props.direction,
          emptySymbol = _this$props.emptySymbol,
          fullSymbol = _this$props.fullSymbol,
          placeholderSymbol = _this$props.placeholderSymbol,
          className = _this$props.className,
          id = _this$props.id,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex;
      var _this$state = this.state,
          displayValue = _this$state.displayValue,
          interacting = _this$state.interacting;
      var symbolNodes = [];
      var empty = [].concat(emptySymbol);
      var full = [].concat(fullSymbol);
      var placeholder = [].concat(placeholderSymbol);
      var shouldDisplayPlaceholder = placeholderValue !== 0 && value === 0 && !interacting; // The value that will be used as base for calculating how to render the symbols

      var renderedValue;

      if (shouldDisplayPlaceholder) {
        renderedValue = placeholderValue;
      } else {
        renderedValue = quiet ? value : displayValue;
      } // The amount of full symbols


      var fullSymbols = Math.floor(renderedValue);

      for (var i = 0; i < totalSymbols; i++) {
        var percent = void 0; // Calculate each symbol's fullness percentage

        if (i - fullSymbols < 0) {
          percent = 100;
        } else if (i - fullSymbols === 0) {
          percent = (renderedValue - i) * 100;
        } else {
          percent = 0;
        }

        symbolNodes.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RatingSymbol, _extends({
          key: i,
          index: i,
          readonly: readonly,
          inactiveIcon: empty[i % empty.length],
          activeIcon: shouldDisplayPlaceholder ? placeholder[i % full.length] : full[i % full.length],
          percent: percent,
          direction: direction
        }, !readonly && {
          onClick: this.symbolClick,
          onMouseMove: this.symbolMouseMove,
          onTouchMove: this.symbolMouseMove,
          onTouchEnd: this.symbolClick
        })));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({
        id: id,
        style: _objectSpread({}, style, {
          display: 'inline-block',
          direction: direction
        }),
        className: className,
        tabIndex: tabIndex,
        "aria-label": this.props['aria-label']
      }, !readonly && {
        onMouseLeave: this.onMouseLeave
      }), symbolNodes);
    }
  }]);

  return Rating;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent); // Define propTypes only in development.

function noop() {}

noop._name = 'react_rating_noop';

var RatingAPILayer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RatingAPILayer, _React$PureComponent);

  function RatingAPILayer(props) {
    var _this;

    _classCallCheck(this, RatingAPILayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RatingAPILayer).call(this, props));
    _this.state = {
      value: props.initialRating
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleHover = _this.handleHover.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(RatingAPILayer, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.initialRating
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(value, e) {
      var _this2 = this;

      var newValue = this.translateDisplayValueToValue(value);
      this.props.onClick(newValue); // Avoid calling setState if not necessary. Micro optimisation.

      if (this.state.value !== newValue) {
        // If we have a new value trigger onChange callback.
        this.setState({
          value: newValue
        }, function () {
          return _this2.props.onChange(_this2.state.value);
        });
      }
    }
  }, {
    key: "handleHover",
    value: function handleHover(displayValue) {
      var value = displayValue === undefined ? displayValue : this.translateDisplayValueToValue(displayValue);
      this.props.onHover(value);
    }
  }, {
    key: "translateDisplayValueToValue",
    value: function translateDisplayValueToValue(displayValue) {
      var translatedValue = displayValue * this.props.step + this.props.start; // minimum value cannot be equal to start, since it's exclusive

      return translatedValue === this.props.start ? translatedValue + 1 / this.props.fractions : translatedValue;
    }
  }, {
    key: "tranlateValueToDisplayValue",
    value: function tranlateValueToDisplayValue(value) {
      if (value === undefined) {
        return 0;
      }

      return (value - this.props.start) / this.props.step;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          step = _this$props.step,
          emptySymbol = _this$props.emptySymbol,
          fullSymbol = _this$props.fullSymbol,
          placeholderSymbol = _this$props.placeholderSymbol,
          readonly = _this$props.readonly,
          quiet = _this$props.quiet,
          fractions = _this$props.fractions,
          direction = _this$props.direction,
          start = _this$props.start,
          stop = _this$props.stop,
          id = _this$props.id,
          className = _this$props.className,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex;

      function calculateTotalSymbols(start, stop, step) {
        return Math.floor((stop - start) / step);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Rating, {
        id: id,
        style: style,
        className: className,
        tabIndex: tabIndex,
        "aria-label": this.props['aria-label'],
        totalSymbols: calculateTotalSymbols(start, stop, step),
        value: this.tranlateValueToDisplayValue(this.state.value),
        placeholderValue: this.tranlateValueToDisplayValue(this.props.placeholderRating),
        readonly: readonly,
        quiet: quiet,
        fractions: fractions,
        direction: direction,
        emptySymbol: emptySymbol,
        fullSymbol: fullSymbol,
        placeholderSymbol: placeholderSymbol,
        onClick: this.handleClick,
        onHover: this.handleHover
      });
    }
  }]);

  return RatingAPILayer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

RatingAPILayer.defaultProps = {
  start: 0,
  stop: 5,
  step: 1,
  readonly: false,
  quiet: false,
  fractions: 1,
  direction: 'ltr',
  onHover: noop,
  onClick: noop,
  onChange: noop,
  emptySymbol: Style.empty,
  fullSymbol: Style.full,
  placeholderSymbol: Style.placeholder
}; // Define propTypes only in development.

/* harmony default export */ __webpack_exports__["a"] = (RatingAPILayer);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var GreetingsSelect=function GreetingsSelect(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",Object.assign({},props,{disabled:props.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"-- Saludo --"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Sr"},"Se\xF1or"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Sra"},"Se\xF1ora"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Srita"},"Se\xF1orita"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Lic"},"Licenciado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Licda"},"Licenciada"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Ing"},"Ingeniero"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Ingra"},"Ingeniera"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Dr"},"Doctor"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Dra"},"Doctora"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Mtro"},"Maestro"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"Mtra"},"Maestra"));};/* harmony default export */ __webpack_exports__["a"] = (GreetingsSelect);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CalendarContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_popper__ = __webpack_require__(496);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var YearDropdownOptions = function (_React$Component) {
  inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    classCallCheck(this, YearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          },
          selectedYear === year ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__year-option--selected" },
            "\u2713"
          ) : "",
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  YearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__year-dropdown": true,
      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return YearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var dayOfWeekCodes = {
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
  7: "sun"
};

// These functions are not exported so
// that we avoid magic strings like 'days'
function set$1(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get$1(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

// ** Date Constructors **

function newDate(point) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(point);
}

function newDateWithOffset(utcOffset) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, dateFormat, locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isMoment(date);
}

function isDate(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set$1(date, "month", month);
}

function setYear(date, year) {
  return set$1(date, "year", year);
}



// ** Date Getters **

function getSecond(date) {
  return get$1(date, "second");
}

function getMinute(date) {
  return get$1(date, "minute");
}

function getHour(date) {
  return get$1(date, "hour");
}

// Returns day of week
function getDay(date) {
  return get$1(date, "day");
}

function getWeek(date) {
  return get$1(date, "week");
}

function getMonth(date) {
  return get$1(date, "month");
}

function getYear(date) {
  return get$1(date, "year");
}

// Returns day of month
function getDate(date) {
  return get$1(date, "date");
}



function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, "day");
}

function getStartOfWeek(date) {
  return getStartOf(date, "week");
}
function getStartOfMonth(date) {
  return getStartOf(date, "month");
}

function getStartOfDate(date) {
  return getStartOf(date, "date");
}

// *** End of ***





// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, "minutes");
}

function addHours(date, amount) {
  return add(date, amount, "hours");
}

function addDays(date, amount) {
  return add(date, amount, "days");
}

function addWeeks(date, amount) {
  return add(date, amount, "weeks");
}

function addMonths(date, amount) {
  return add(date, amount, "months");
}

function addYears(date, amount) {
  return add(date, amount, "years");
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, "days");
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, "weeks");
}

function subtractMonths(date, amount) {
  return subtract(date, amount, "months");
}

function subtractYears(date, amount) {
  return subtract(date, amount, "years");
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}

function equals(date1, date2) {
  return date1.isSame(date2);
}

function isSameYear(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "year");
  } else {
    return !date1 && !date2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "month");
  } else {
    return !date1 && !date2;
  }
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, "day");
  } else {
    return !moment1 && !moment2;
  }
}



function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf("day").subtract(1, "seconds");
  var after = endDate.clone().startOf("day").add(1, "seconds");
  return day.clone().startOf("day").isBetween(before, after);
}

// *** Diffing ***



// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale());
}







function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.localeData(locale);
}

function getFormattedWeekdayInLocale(locale, date, formatFunc) {
  return formatFunc(locale.weekdays(date));
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

function getMonthShortInLocale(locale, date) {
  return locale.monthsShort(date);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isOutOfBounds(day) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref5.minDate,
      maxDate = _ref5.maxDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day");
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref6) {
  var minTime = _ref6.minTime,
      maxTime = _ref6.maxTime;

  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }

  var base = __WEBPACK_IMPORTED_MODULE_4_moment___default()().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref7.minDate,
      includeDates = _ref7.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref8.maxDate,
      includeDates = _ref8.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref9) {
  var minDate = _ref9.minDate,
      includeDates = _ref9.includeDates;

  if (includeDates && minDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref10) {
  var maxDate = _ref10.maxDate,
      includeDates = _ref10.includeDates;

  if (includeDates && maxDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates);
  } else {
    return maxDate;
  }
}

function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";

  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isMoment(obj)) {
      var key = obj.format("MM.DD.YYYY");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfMoments = obj[keys[0]];
      if (typeof className === "string" && arrOfMoments.constructor === Array) {
        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
          var _key = arrOfMoments[k].format("MM.DD.YYYY");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }

  return dateClasses;
}

function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);

    if (injectedTime.isBetween(currentTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }

  return times;
}

var WrappedYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(YearDropdownOptions);

var YearDropdown = function (_React$Component) {
  inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__year-read-view--selected-year" },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    }, _this.handleYearChange = function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    }, _this.onSelect = function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    }, _this.setOpen = function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  YearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return YearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdown.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var MonthDropdownOptions = function (_React$Component) {
  inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          },
          _this.props.month === i ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-option--selected" },
            "\u2713"
          ) : "",
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdownOptions.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__month-dropdown" },
      this.renderOptions()
    );
  };

  return MonthDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdownOptions.propTypes = {
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  monthNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired).isRequired
};

var WrappedMonthDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthDropdownOptions);

var MonthDropdown = function (_React$Component) {
  inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-read-view--selected-month" },
          monthNames[_this.props.month]
        )
      );
    }, _this.renderDropdown = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        ref: "options",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdown.prototype.render = function render() {
    var _this2 = this;

    var localeData = getLocaleDataForLocale(this.props.locale);
    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
      return getMonthShortInLocale(localeData, newDate({ M: M }));
    } : function (M) {
      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
    });

    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode(monthNames);
        break;
      case "select":
        renderedDropdown = this.renderSelectMode(monthNames);
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function generateMonthYears(minDate, maxDate) {
  var list = [];

  var currDate = getStartOfMonth(cloneDate(minDate));
  var lastDate = getStartOfMonth(cloneDate(maxDate));

  while (!isAfter(currDate, lastDate)) {
    list.push(cloneDate(currDate));

    addMonths(currDate, 1);
  }

  return list;
}

var MonthYearDropdownOptions = function (_React$Component) {
  inherits(MonthYearDropdownOptions, _React$Component);

  function MonthYearDropdownOptions(props) {
    classCallCheck(this, MonthYearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = monthYear.valueOf();

        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          },
          isSameMonthYear ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-year-option--selected" },
            "\u2713"
          ) : "",
          formatDate(monthYear, _this.props.dateFormat)
        );
      });
    };

    _this.onChange = function (monthYear) {
      return _this.props.onChange(monthYear);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  MonthYearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__month-year-dropdown": true,
      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return MonthYearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var WrappedMonthYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthYearDropdownOptions);

var MonthYearDropdown = function (_React$Component) {
  inherits(MonthYearDropdown, _React$Component);

  function MonthYearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthYearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));

      var options = [];

      while (!isAfter(currDate, lastDate)) {
        var timepoint = currDate.valueOf();
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: timepoint, value: timepoint },
          formatDate(currDate, _this.props.dateFormat)
        ));

        addMonths(currDate, 1);
      }

      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-year-read-view--selected-month-year" },
          yearMonth
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: localizeDate(_this.props.minDate, _this.props.locale),
        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (monthYearPoint) {
      _this.toggleDropdown();

      var changedDate = newDate(parseInt(monthYearPoint));

      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }

      _this.props.onChange(changedDate);
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthYearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthYearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Day = function (_React$Component) {
  inherits(Day, _React$Component);

  function Day() {
    var _temp, _this, _ret;

    classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return isSameDay(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return isDayDisabled(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = day.format("MM.DD.YYYY");
      return highlightDates.get(dayStr);
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return isDayInRange(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return isDayInRange(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isOutsideMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      },
      this.props.renderDayContents ? this.props.renderDayContents(getDate(this.props.day)) : getDate(this.props.day)
    );
  };

  return Day;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Day.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var WeekNumber = function (_React$Component) {
  inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _temp, _this, _ret;

    classCallCheck(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  WeekNumber.prototype.render = function render() {
    var weekNumberClasses = {
      "react-datepicker__week-number": true,
      "react-datepicker__week-number--clickable": !!this.props.onClick
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      },
      this.props.weekNumber
    );
  };

  return WeekNumber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WeekNumber.propTypes = {
  weekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Week = function (_React$Component) {
  inherits(Week, _React$Component);

  function Week() {
    var _temp, _this, _ret;

    classCallCheck(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Day, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset,
          renderDayContents: _this.props.renderDayContents,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
        });
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Week.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__week" },
      this.renderDays()
    );
  };

  return Week;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Week.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var Month = function (_React$Component) {
  inherits(Month, _React$Component);

  function Month() {
    var _temp, _this, _ret;

    classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Week, {
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderDayContents: _this.props.renderDayContents
        }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Month.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox",
        "aria-label": "month-" + this.props.day.format("YYYY-MM")
      },
      this.renderWeeks()
    );
  };

  return Month;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Month.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Time = function (_React$Component) {
  inherits(Time, _React$Component);

  function Time() {
    var _temp, _this, _ret;

    classCallCheck(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ["react-datepicker__time-list-item"];

      if (currH === getHour(time) && currM === getMinute(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }

      return classes.join(" ");
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "hh:mm A";
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : newDate();
      var currH = getHour(activeTime);
      var currM = getMinute(activeTime);
      var base = getStartOfDay(newDate());
      var multiplier = 1440 / intervals;
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(cloneDate(base), i * intervals);
        times.push(currentTime);

        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      return times.map(function (time, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM),
            ref: function ref(li) {
              if (currH === getHour(time) && currM === getMinute(time) || currH === getHour(time) && !_this.centerLi) {
                _this.centerLi = li;
              }
            }
          },
          formatDate(time, format)
        );
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Time.prototype.componentDidMount = function componentDidMount() {
    // code to ensure selected time will always be in focus within time window when it first appears
    this.list.scrollTop = Time.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi);
  };

  Time.prototype.render = function render() {
    var _this2 = this;

    var height = null;
    if (this.props.monthRef && this.header) {
      height = this.props.monthRef.clientHeight - this.header.clientHeight;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__header react-datepicker__header--time",
          ref: function ref(header) {
            _this2.header = header;
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker-time__header" },
          this.props.timeCaption
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__time-box" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            {
              className: "react-datepicker__time-list",
              ref: function ref(list) {
                _this2.list = list;
              },
              style: height ? { height: height } : {}
            },
            this.renderTimes.bind(this)()
          )
        )
      )
    );
  };

  createClass(Time, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
  return Time;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Time.propTypes = {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  intervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  monthRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

Time.calcCenterPosition = function (listHeight, centerLiRef) {
  return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
};

function CalendarContainer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$arrowProps = _ref.arrowProps,
      arrowProps = _ref$arrowProps === undefined ? {} : _ref$arrowProps;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({ className: "react-datepicker__triangle" }, arrowProps)),
    children
  );
}

CalendarContainer.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  arrowProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object // react-popper arrow props
};

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var Calendar = function (_React$Component) {
  inherits(Calendar, _React$Component);
  createClass(Calendar, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month"
      };
    }
  }]);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = now(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return localizeDate(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: addMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: subtractMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleYearChange = function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
      }
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
    };

    _this.handleMonthYearChange = function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: setYear(cloneDate(_this.state.date), year)
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: setMonth(cloneDate(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.changeMonthYear = function (monthYear) {
      _this.setState({
        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = getStartOfWeek(cloneDate(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name" },
          _this.props.weekLabel || "#"
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        var localeData = getLocaleData(day);
        var weekDayName = _this.formatWeekday(localeData, day);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: offset, className: "react-datepicker__day-name" },
          weekDayName
        );
      }));
    };

    _this.formatWeekday = function (localeData, day) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
    };

    _this.renderPreviousMonthButton = function () {
      if (_this.props.renderCustomHeader) {
        return;
      }

      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.previousMonthButtonLabel
      );
    };

    _this.renderNextMonthButton = function () {
      if (_this.props.renderCustomHeader) {
        return;
      }

      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }

      var clickHandler = _this.increaseMonth;

      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.nextMonthButtonLabel
      );
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ["react-datepicker__current-month"];

      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes.join(" ") },
        formatDate(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    };

    _this.renderMonthYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        },
        _this.props.todayButton
      );
    };

    _this.renderDefaultHeader = function (_ref) {
      var monthDate = _ref.monthDate,
          i = _ref.i;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__header" },
        _this.renderCurrentMonth(monthDate),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
            onFocus: _this.handleDropdownFocus
          },
          _this.renderMonthDropdown(i !== 0),
          _this.renderMonthYearDropdown(i !== 0),
          _this.renderYearDropdown(i !== 0)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__day-names" },
          _this.header(monthDate)
        )
      );
    };

    _this.renderCustomHeader = function (_ref2) {
      var monthDate = _ref2.monthDate,
          i = _ref2.i;

      if (i !== 0) {
        return null;
      }

      var prevMonthButtonDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      var nextMonthButtonDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__header react-datepicker__header--custom",
          onFocus: _this.props.onDropdownFocus
        },
        _this.props.renderCustomHeader(_extends({}, _this.state, {
          changeMonth: _this.changeMonth,
          changeYear: _this.changeYear,
          decreaseMonth: _this.decreaseMonth,
          increaseMonth: _this.increaseMonth,
          prevMonthButtonDisabled: prevMonthButtonDisabled,
          nextMonthButtonDisabled: nextMonthButtonDisabled
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__day-names" },
          _this.header(monthDate)
        )
      );
    };

    _this.renderMonths = function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }

      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = addMonths(cloneDate(_this.state.date), i);
        var monthKey = "month-" + i;
        monthList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          },
          _this.props.renderCustomHeader ? _this.renderCustomHeader({ monthDate: monthDate, i: i }) : _this.renderDefaultHeader({ monthDate: monthDate, i: i }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset,
            renderDayContents: _this.props.renderDayContents,
            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
          })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes
        });
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: null
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // monthContainer height is needed in time component
    // to determine the height for the ul in the time component
    // setState here so height is given after final component
    // layout is rendered
    if (this.props.showTimeSelect) {
      this.assignMonthContainer = function () {
        _this2.setState({ monthContainer: _this2.monthContainer });
      }();
    }
  };

  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
      this.setState({
        date: this.localizeDate(this.props.preSelection)
      });
    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
      this.setState({
        date: this.localizeDate(this.props.openToDate)
      });
    }
  };

  Calendar.prototype.render = function render() {
    var Container = this.props.container || CalendarContainer;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Container,
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      },
      this.renderPreviousMonthButton(),
      this.renderNextMonthButton(),
      this.renderMonths(),
      this.renderTodayButton(),
      this.renderTimeSection(),
      this.props.children
    );
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Calendar.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]),
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDropdownFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onTimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  renderCustomHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var popperPlacementPositions = ["bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];

var PopperComponent = function (_React$Component) {
  inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    classCallCheck(this, PopperComponent);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PopperComponent.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        popperProps = _props.popperProps,
        targetComponent = _props.targetComponent;


    var popper = void 0;

    if (!hidePopper) {
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker-popper", className);
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["b" /* Popper */],
        _extends({
          modifiers: popperModifiers,
          placement: popperPlacement
        }, popperProps),
        function (_ref) {
          var ref = _ref.ref,
              style = _ref.style,
              placement = _ref.placement,
              arrowProps = _ref.arrowProps;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            _extends({ ref: ref, style: style }, {
              className: classes,
              "data-placement": placement
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(popperComponent, { arrowProps: arrowProps })
          );
        }
      );
    }

    if (this.props.popperContainer) {
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.popperContainer, {}, popper);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_popper__["a" /* Manager */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["c" /* Reference */],
        null,
        function (_ref2) {
          var ref = _ref2.ref;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { ref: ref, className: "react-datepicker-wrapper" },
            targetComponent
          );
        }
      ),
      popper
    );
  };

  createClass(PopperComponent, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: "viewport"
          }
        },
        popperProps: {},
        popperPlacement: "bottom-start"
      };
    }
  }]);
  return PopperComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperComponent.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hidePopper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  popperComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <datepicker/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  targetComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }

  return date1 !== date2;
}

function hasSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return !equals(date1, date2);
  }

  return false;
}

/**
 * General datepicker component.
 */
var INPUT_ERR_1 = "Date input not valid.";

var DatePicker = function (_React$Component) {
  inherits(DatePicker, _React$Component);
  createClass(DatePicker, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        allowSameDay: false,
        dateFormat: "L",
        dateFormatCalendar: "MMMM YYYY",
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onInputClick: function onInputClick() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside$$1() {},
        onMonthChange: function onMonthChange() {},

        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},
        onInputError: function onInputError() {},

        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next month",
        renderDayContents: function renderDayContents(date) {
          return date;
        }
      };
    }
  }]);

  function DatePicker(props) {
    classCallCheck(this, DatePicker);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus();
      }
    };

    _this.setBlur = function () {
      if (_this.input && _this.input.blur) {
        _this.input.blur();
      }

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }

      _this.cancelFocusInput();
    };

    _this.setOpen = function (open) {
      var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      }, function () {
        if (!open) {
          _this.setState(function (prev) {
            return {
              focused: skipSetBlur ? prev.focused : false
            };
          }, function () {
            !skipSetBlur && _this.setBlur();

            _this.setState({ inputValue: null });
          });
        }
      });
    };

    _this.inputOk = function () {
      return isMoment(_this.state.preSelection) || isDate(_this.state.preSelection);
    };

    _this.isCalendarOpen = function () {
      return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({ focused: true });
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open && !_this.props.withPortal) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
      _this.setState({ focused: false });
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function () {
      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }

      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
        if (isOutOfBounds(changedDate, _this.props)) {
          _this.props.onChange(date, event);
          _this.props.onSelect(changedDate, event);
        }

        return;
      }

      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            var selected = _this.props.selected;
            if (keepInput) selected = newDate(changedDate);
            changedDate = setTime(newDate(changedDate), {
              hour: getHour(selected),
              minute: getMinute(selected),
              second: getSecond(selected)
            });
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = setTime(cloneDate(selected), {
        hour: getHour(time),
        minute: getMinute(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
      if (_this.props.shouldCloseOnSelect) {
        _this.setOpen(false);
      }
      _this.setState({ inputValue: null });
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }

      _this.props.onInputClick();
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          _this.onInputClick();
        }
        return;
      }
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === "Escape") {
        event.preventDefault();

        _this.setOpen(false);
        if (!_this.inputOk()) {
          _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
        }
      } else if (eventKey === "Tab") {
        _this.setOpen(false, true);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case "ArrowLeft":
            newSelection = subtractDays(copy, 1);
            break;
          case "ArrowRight":
            newSelection = addDays(copy, 1);
            break;
          case "ArrowUp":
            newSelection = subtractWeeks(copy, 1);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            newSelection = subtractMonths(copy, 1);
            break;
          case "PageDown":
            newSelection = addMonths(copy, 1);
            break;
          case "Home":
            newSelection = subtractYears(copy, 1);
            break;
          case "End":
            newSelection = addYears(copy, 1);
            break;
        }
        if (!newSelection) {
          if (_this.props.onInputError) {
            _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
          }
          return; // Let the input component handle this keydown
        }
        event.preventDefault();
        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.clear = function () {
      _this.onClearClick();
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && !_this.isCalendarOpen()) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
          nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderCustomHeader: _this.props.renderCustomHeader,
          popperProps: _this.props.popperProps,
          renderDayContents: _this.props.renderDayContents
        },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var _classnames, _React$cloneElement;

      var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));

      var customInput = _this.props.customInput || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text" });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
        _this.input = input;
      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          onClick: _this.onClearClick,
          title: _this.props.clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setPreSelection(this.props.selected);
    }
    if (prevProps.highlightDates !== this.props.highlightDates) {
      this.setState({
        highlightDates: getHightLightDaysMap(this.props.highlightDates)
      });
    }
    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setState({ inputValue: null });
    }
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearPreventFocusTimeout();
  };

  DatePicker.prototype.render = function render() {
    var calendar = this.renderCalendar();

    if (this.props.inline && !this.props.withPortal) {
      return calendar;
    }

    if (this.props.withPortal) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        !this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__input-container" },
          this.renderDateInput(),
          this.renderClearButton()
        ) : null,
        this.state.open || this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__portal" },
          calendar
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopperComponent, {
      className: this.props.popperClassName,
      hidePopper: !this.isCalendarOpen(),
      popperModifiers: this.props.popperModifiers,
      targetComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__input-container" },
        this.renderDateInput(),
        this.renderClearButton()
      ),
      popperContainer: this.props.popperContainer,
      popperComponent: calendar,
      popperPlacement: this.props.popperPlacement,
      popperProps: this.props.popperProps
    });
  };

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowSameDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  calendarClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  calendarContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  customInputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  dateFormatCalendar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isClearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeRaw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInputClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInputError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // <PopperComponent/> props
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <PopperComponent/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <PopperComponent/> props
  popperProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  preventOpenOnFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  startOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  shouldCloseOnSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clearButtonTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  renderCustomHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";


/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89),
    getRawTag = __webpack_require__(546),
    objectToString = __webpack_require__(547);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_notification__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_navigation_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_user_opts_dropdown__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_navigation_reports_subnav__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_navigation_project_navigation__ = __webpack_require__(148);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(SecuredComponent,data){var ReportsLayout=function(_Component){_inherits(ReportsLayout,_Component);_createClass(ReportsLayout,[{key:"render",value:function render(){var _this2=this;var _props=this.props,userLogin=_props.userLogin,notifications=_props.notifications,match=_props.match,location=_props.location,session=_props.session,menu=_props.menu;var agencies=session.user.agencies;var agency=this.setAgencyName(match.params.modality,agencies);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_navigation_navigation__["a" /* default */],{agencies:Object.assign({},agencies),cdms:Object.assign({},session.user.cdms),items:Object.assign({},session.user.menu),show:menu.view,location:Object.assign({},location),key:"app-navigation-sidebar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"project-content",key:"project-website-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",{className:"navbar is-dark secondary-navigation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-menu navbar-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default.a,alt:"gob.mx",className:"app-gov-logo--image"})),session.user.version?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-menu navbar-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"title is-6 has-text-centered has-text-white"},session.user.version.name)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"main-nav--close",onClick:function onClick(){return _this2.toggleMenu();}},menu.view?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-left"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-right"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_user_opts_dropdown__["a" /* default */],{data:Object.assign({},session.user.profile)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_navigation_project_navigation__["a" /* default */],{isFetching:userLogin.isFetching,filter:this.state.filterType,filterChange:this.filterChange,modality:match.params.modality,entity:match.params.state,agencies:agencies,municipalityFilter:this.municipalityFilter,municipalityChange:this.municipalityChange,stateChange:this.stateChange,agenciable:{state:this.state.modState,municipality:match.params.municipality}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_navigation_reports_subnav__["a" /* default */],{step:data.subnav,params:match.params,agency:agency,reports:this.props.reports}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"app-layout--content",style:{padding:'0rem 0rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-1 main-title",dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_8__store_config__["_268" /* reportsInitNav */],{step:data.subnav}).title}}),notifications.data.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10-desktop"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_notification__["a" /* default */],notifications))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecuredComponent,this.props))))];}}]);function ReportsLayout(props){_classCallCheck(this,ReportsLayout);var _this=_possibleConstructorReturn(this,(ReportsLayout.__proto__||Object.getPrototypeOf(ReportsLayout)).call(this));_this.state={modState:props.match.params.state,filterType:'all_projects'};_this.municipalityFilter=_this.municipalityFilter.bind(_this);_this.municipalityChange=_this.municipalityChange.bind(_this);_this.stateChange=_this.stateChange.bind(_this);_this.toggleMenu=_this.toggleMenu.bind(_this);_this.filterChange=_this.filterChange.bind(_this);return _this;}_createClass(ReportsLayout,[{key:"toggleMenu",value:function toggleMenu(){var view=this.props.menu.view;return view===true?this.props.hideMenu():this.props.showMenu();}},{key:"filterChange",value:function filterChange(e){return this.setState({filterType:e.target.value});}},{key:"stateChange",value:function stateChange(state){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(this.props.location.pathname,'/',5);url[4]=state;url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');return this.props.history.push(url);}},{key:"municipalityFilter",value:function municipalityFilter(state){return this.setState({modState:state});}},{key:"municipalityChange",value:function municipalityChange(municipality){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(this.props.location.pathname,'/',6);url[4]=this.state.modState;url[5]=municipality;url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');return this.props.history.push(url);}},{key:"setAgencyName",value:function setAgencyName(mod,agencies){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality;var agency=undefined;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agencies)){switch(mod){case'modalidad-i':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-i'],{agenciable_short:state});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;case'modalidad-ii':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-ii'],{agenciable_slug:municipality});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;case'modalidad-iii':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-iii'],{agenciable_short:state});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;default:return undefined;}}else{return null;}}}]);return ReportsLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_1__secure__["a" /* default */])(ReportsLayout);});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.String = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var camelize = exports.camelize = function camelize(str) {
    return str.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('');
  };
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackable = exports.createTrack = undefined;

var _findKey2 = __webpack_require__(335);

var _findKey3 = _interopRequireDefault(_findKey2);

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _iteratee = __webpack_require__(104);

var _isMulti = __webpack_require__(76);

var _isMulti2 = _interopRequireDefault(_isMulti);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var defaultStrategy = {
  findKey: _findKey3.default,
  get: _get3.default
};

function createTrack() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;

  var iteratee = (0, _iteratee.createIteratee)(s);

  return function track(model) {
    for (var _len = arguments.length, predicates = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      predicates[_key - 1] = arguments[_key];
    }

    var isPartial = model[0] === '.';

    return function (fullState, parentModel) {
      var childModel = isPartial ? model.slice(1) : model;
      var state = isPartial ? s.get(fullState, parentModel) : fullState;

      var _childModel$split = childModel.split(/\[\]\.?/),
          _childModel$split2 = _toArray(_childModel$split),
          parentModelPath = _childModel$split2[0],
          childModelPaths = _childModel$split2.slice(1);

      var fullPath = parentModelPath;
      var subState = s.get(state, fullPath);

      predicates.forEach(function (predicate, i) {
        var childModelPath = childModelPaths[i];
        var predicateIteratee = iteratee(predicate);

        var subPath = childModelPath ? s.findKey(subState, predicateIteratee) + '.' + childModelPath : '' + s.findKey(subState, predicateIteratee);

        subState = s.get(subState, subPath);
        fullPath += '.' + subPath;
      });

      if ((0, _isMulti2.default)(childModel) && predicates.length < childModelPaths.length) {
        fullPath += '[]';
      }

      return isPartial ? parentModel + '.' + fullPath : fullPath;
    };
  };
}

var track = createTrack();

function trackable(actionCreator) {
  return function (model) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    if (typeof model === 'function') {
      return function (dispatch, getState) {
        var modelPath = model(getState());

        dispatch(actionCreator.apply(undefined, [modelPath].concat(args)));
      };
    }

    return actionCreator.apply(undefined, [model].concat(args));
  };
}

exports.default = track;
exports.createTrack = createTrack;
exports.trackable = trackable;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMulti;

var _endsWith = __webpack_require__(102);

var _endsWith2 = _interopRequireDefault(_endsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMulti(model) {
  return (0, _endsWith2.default)(model, '[]');
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NULL_ACTION = { type: null };

exports.default = NULL_ACTION;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getValue;
exports.getCheckboxValue = getCheckboxValue;

var _isMulti = __webpack_require__(76);

var _isMulti2 = _interopRequireDefault(_isMulti);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function isEvent(event) {
  return !!(event && event.stopPropagation && event.preventDefault);
}

function getEventValue(event) {
  var target = event.target;


  if (!target) {
    if (!event.nativeEvent) {
      return undefined;
    }

    return event.nativeEvent.text;
  }

  if (target.type === 'file') {
    return [].concat(_toConsumableArray(target.files)) || target.dataTransfer && [].concat(_toConsumableArray(target.dataTransfer.files));
  }

  if (target.multiple) {
    return [].concat(_toConsumableArray(target.selectedOptions)).map(function (option) {
      return option.value;
    });
  }

  return target.value;
}

function getValue(value) {
  return isEvent(value) ? getEventValue(value) : value;
}

function getCheckboxValue(_, props) {
  var controlProps = props.controlProps;


  if ((0, _isMulti2.default)(props.model)) {
    return controlProps.value;
  }

  return !props.modelValue;
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearGetFormCacheForModel = exports.clearGetFormCache = undefined;
exports.getFormStateKey = getFormStateKey;

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _pathStartsWith = __webpack_require__(336);

var _pathStartsWith2 = _interopRequireDefault(_pathStartsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStrategy = {
  get: _get2.default,
  keys: function keys(state) {
    return Object.keys(state);
  },
  isObject: function isObject(state) {
    return (0, _isPlainObject2.default)(state);
  }
};

function joinPaths() {
  for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  return paths.filter(function (path) {
    return !!path && path.length;
  }).join('.');
}

function getFormStateKey(state, model) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
  var currentPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var deepCandidateKeys = [];
  var result = null;

  s.keys(state).some(function (key) {
    if (key === '') {
      console.warn('react-redux-form skipped over an empty property key: %s', currentPath);
      return false;
    }
    var subState = s.get(state, key);

    if (subState && s.get(subState, '$form')) {
      var subStateModel = s.get(subState, '$form.model');

      if ((0, _pathStartsWith2.default)(model, subStateModel) || subStateModel === '') {
        var localPath = (0, _pathStartsWith.pathDifference)(model, subStateModel);

        var resultPath = [currentPath, key];
        var currentState = subState;

        localPath.every(function (segment) {
          if (s.get(currentState, segment) && s.get(currentState, segment + '.$form')) {
            currentState = s.get(currentState, segment);
            resultPath.push(segment);

            return true;
          }

          return false;
        });

        result = joinPaths.apply(undefined, resultPath);

        return true;
      }

      return false;
    }

    if (s.isObject(subState)) {
      deepCandidateKeys.push(key);
    }

    return false;
  });

  if (result) return result;

  deepCandidateKeys.some(function (key) {
    result = getFormStateKey(s.get(state, key), model, s, joinPaths(currentPath, key));

    return !!result;
  });

  if (result) return result;

  return null;
}

var formStateKeyCache = {};

var clearGetFormCache = exports.clearGetFormCache = function clearGetFormCache() {
  return formStateKeyCache = {};
}; // eslint-disable-line no-return-assign

var clearGetFormCacheForModel =
// eslint-disable-next-line
exports.clearGetFormCacheForModel = function clearGetFormCacheForModel(modelString) {
  return delete formStateKeyCache[modelString];
};

var getFormStateKeyCached = function () {
  return function (state, modelString) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;

    if (formStateKeyCache[modelString]) return formStateKeyCache[modelString];

    var result = getFormStateKey(state, modelString, s);

    formStateKeyCache[modelString] = result; // eslint-disable-line no-return-assign

    return result;
  };
}();

function getForm(state, modelString) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;

  var formStateKey = getFormStateKeyCached(state, modelString, s);

  if (!formStateKey) {
    return null;
  }

  var form = s.get(state, formStateKey);

  return form;
}

exports.default = getForm;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toPath;

var _lodash = __webpack_require__(187);

var _lodash2 = _interopRequireDefault(_lodash);

var _endsWith = __webpack_require__(102);

var _endsWith2 = _interopRequireDefault(_endsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toPath(value) {
  var path = value;

  if ((0, _endsWith2.default)(path, '.')) {
    path = path.slice(0, -1);
  } else if ((0, _endsWith2.default)(path, '[]')) {
    path = path.slice(0, -2);
  }

  return (0, _lodash2.default)(path);
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = wrapWithModelResolver;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function resolveModel(model, parentModel) {
  if (parentModel) {
    if (model[0] === '.' || model[0] === '[') {
      return '' + parentModel + model;
    }

    if (typeof model === 'function') {
      return function (state) {
        return model(state, parentModel);
      };
    }
  }

  return model;
}

function wrapWithModelResolver(WrappedComponent) {
  var ResolvedModelWrapper = function (_PureComponent) {
    _inherits(ResolvedModelWrapper, _PureComponent);

    function ResolvedModelWrapper() {
      _classCallCheck(this, ResolvedModelWrapper);

      return _possibleConstructorReturn(this, (ResolvedModelWrapper.__proto__ || Object.getPrototypeOf(ResolvedModelWrapper)).apply(this, arguments));
    }

    _createClass(ResolvedModelWrapper, [{
      key: 'render',
      value: function render() {
        var _context = this.context,
            parentModel = _context.model,
            localStore = _context.localStore;

        var resolvedModel = resolveModel(this.props.model, parentModel);

        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
          model: resolvedModel,
          store: localStore || undefined
        }));
      }
    }]);

    return ResolvedModelWrapper;
  }(_react.PureComponent);

  ResolvedModelWrapper.displayName = 'Modeled(' + WrappedComponent.displayName + ')';

   false ? ResolvedModelWrapper.propTypes = {
    model: _propTypes2.default.any
  } : void 0;

  ResolvedModelWrapper.contextTypes = {
    model: _propTypes2.default.any,
    localStore: _propTypes2.default.shape({
      subscribe: _propTypes2.default.func,
      dispatch: _propTypes2.default.func,
      getState: _propTypes2.default.func
    })
  };

  return ResolvedModelWrapper;
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInitialState = createInitialState;
exports.default = createFormReducer;

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _arraysEqual = __webpack_require__(195);

var _arraysEqual2 = _interopRequireDefault(_arraysEqual);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _toPath = __webpack_require__(80);

var _toPath2 = _interopRequireDefault(_toPath);

var _composeReducers = __webpack_require__(353);

var _composeReducers2 = _interopRequireDefault(_composeReducers);

var _batchedEnhancer = __webpack_require__(110);

var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);

var _changeActionReducer = __webpack_require__(354);

var _changeActionReducer2 = _interopRequireDefault(_changeActionReducer);

var _formActionsReducer = __webpack_require__(356);

var _createField = __webpack_require__(83);

var _createField2 = _interopRequireDefault(_createField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createInitialState(model, state) {
  var customInitialFieldState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (Array.isArray(state) || (0, _isPlainObject2.default)(state)) {
    return (0, _createField.createFormState)(model, state, customInitialFieldState, options);
  }

  return (0, _createField2.default)(model, state, customInitialFieldState, options);
}

function wrapFormReducer(plugin, modelPath, initialState) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!action.model) return state;

    var path = (0, _toPath2.default)(action.model);

    if (modelPath.length && !(0, _arraysEqual2.default)(path.slice(0, modelPath.length), modelPath)) {
      return state;
    }

    var localPath = path.slice(modelPath.length);

    return plugin(state, action, localPath);
  };
}

function createFormReducer(model) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$plugins = options.plugins,
      plugins = _options$plugins === undefined ? [] : _options$plugins,
      customInitialFieldState = options.initialFieldState,
      _options$transformAct = options.transformAction,
      transformAction = _options$transformAct === undefined ? null : _options$transformAct;

  var modelPath = (0, _toPath2.default)(model);
  var initialFormState = createInitialState(model, initialState, customInitialFieldState, options);

  var defaultPlugins = [_changeActionReducer2.default, (0, _formActionsReducer.createFormActionsReducer)({ initialFieldState: customInitialFieldState })];

  var wrappedPlugins = plugins.concat(defaultPlugins).map(function (plugin) {
    return wrapFormReducer(plugin, modelPath, initialFormState);
  });

  return (0, _batchedEnhancer2.default)(_composeReducers2.default.apply(undefined, _toConsumableArray(wrappedPlugins)), undefined, {
    transformAction: transformAction
  });
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fieldOrForm = fieldOrForm;
exports.getMeta = getMeta;
exports.updateFieldState = updateFieldState;
exports.default = createFieldState;
exports.createFormState = createFormState;

var _initialFieldState = __webpack_require__(34);

var _initialFieldState2 = _interopRequireDefault(_initialFieldState);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-use-before-define */
function fieldOrForm(model, value, customInitialFieldState) {
  // TODO: create toModel()
  var stringModel = Array.isArray(model) ? model.join('.') : model;

  if (Array.isArray(value) || (0, _isPlainObject2.default)(value)) {
    return createFormState(stringModel, value, customInitialFieldState);
  }

  return createFieldState(stringModel, value, customInitialFieldState);
}
/* eslint-enable no-use-before-define */

function getMeta(fieldLike, prop) {
  if (fieldLike && fieldLike.$form) return fieldLike.$form[prop];

  return fieldLike[prop];
}

function getSubModelString(model, subModel) {
  if (!model) return subModel;

  return model + '.' + subModel;
}

function updateFieldState(existingFieldState, updatedFieldState) {
  var newField = _extends({}, existingFieldState, updatedFieldState);

  return newField;
}

function createFieldState(model, value, customInitialFieldState) {
  return _extends({
    initialValue: value
  }, _initialFieldState2.default, customInitialFieldState, {
    model: model,
    value: value
  });
}

function createFormState(model, values, customInitialFieldState) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return _extends({
    $form: createFieldState(model, values, customInitialFieldState, options)
  }, options.lazy ? undefined : (0, _mapValues2.default)(values, function (value, key) {
    var subModel = getSubModelString(model, key);

    return fieldOrForm(subModel, value, customInitialFieldState);
  }));
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchVersionsShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return versionsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return versionSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return versionDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
var fetchVersionsShow=function fetchVersionsShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(versionsRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/versions?page="+page,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(versionsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(versionsFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var versionsList=function versionsList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(versionsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/versions?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(versionsListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(versionsFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Section VERSION_EDIT*/var fetchVersion=function fetchVersion(year){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(versionsRequest());dispatch(versionClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/versions/"+year+"?include[0]=phases_groups.version_phase_group",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(versionEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(versionsFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Section VERSION_SAVE*/var versionSave=function versionSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(versionsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/versions"+(values.id?"/"+values.year+"?include[0]=phases_groups.version_phase_group&_method=PUT":'?include[0]=phases_groups.version_phase_group'),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:"La version se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/versiones/editar/"+json.data.year);}return dispatch(versionEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(versionsFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Section VERSION_DELETE*/var versionDelete=function versionDelete(year){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(versionsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/versions/"+year,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:"Versión eliminada correctamente",type:"success"}));dispatch(fetchVersionsShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(versionsFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var versionsRequest=function versionsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_258" /* VERSIONS_REQUEST */],isFetching:true,timestamp:Date.now()};};var versionsData=function versionsData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_259" /* VERSIONS_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var versionsListData=function versionsListData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_257" /* VERSIONS_LIST */],isFetching:false,payload:json.data,timestamp:Date.now()};};var versionEditData=function versionEditData(json){var phases_groups=[];var response=json.data;__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(json.data.phases_groups,function(item){return phases_groups.push({id:item.id,name:item.name,start_date:item.version_phase_group.start_date,end_date:item.version_phase_group.end_date,version_phase_group:item.version_phase_group});});response.phases_groups=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(phases_groups,['id']);return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_261" /* VERSION_EDIT */],isFetching:false,payload:response,permissions:json.permissions,timestamp:Date.now()};};var versionClear=function versionClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_260" /* VERSION_CLEAR */],payload:{phases_groups:[]},timestamp:Date.now()};};var versionsFailed=function versionsFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_256" /* VERSIONS_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return municipalitiesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return municipalitiesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return municipalityEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return municipalitySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return municipalityDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
var municipalitiesShow=function municipalitiesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(municipalitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/municipalities?include[0]=state&include[1]=modality&page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(municipalitiesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(municipalitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var municipalitiesList=function municipalitiesList(entity){var filter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;/*
	* Guarda las entidades en la sesion, para no mandarla a pedir al servidor, cada vez que se necesite.
	* *//*let storage = sessionStorage.getItem("etrans_municipalities_"+entity);

    if (storage === null) {

    }
    else{
        storage=JSON.parse(storage);
        return dispatch => {
            filter === true ? dispatch(municipalitiesFilteredRequest()) : dispatch(municipalitiesRequest());
            if (filter === true) {
                dispatch(municipalitiesFilteredData(storage,entity))
            } else {
                dispatch(municipalitiesAllData(storage,entity))
            }
        }
	}*/return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};filter===true?dispatch(municipalitiesFilteredRequest()):dispatch(municipalitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/municipalities?state_id="+entity+"&order_by[field]=name&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){if(filter===true){dispatch(municipalitiesFilteredData(json,entity));}else{dispatch(municipalitiesAllData(json,entity));}},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(municipalitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var municipalityEdit=function municipalityEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(municipalitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/municipalities/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(municipalityEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(municipalitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var municipalitySave=function municipalitySave(formData){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(formData)};dispatch(municipalitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/municipalities"+(formData.id?"/"+formData.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El municipio se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(formData.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/municipios/editar/"+json.data.id);}return dispatch(municipalityEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(municipalitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var municipalityDelete=function municipalityDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(municipalitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/municipalities/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"Esto no es un simulacro",content:json.message?json.message:"Se elimin\xF3 el siguiente municipio: <strong>"+json.name+"</strong>",type:"warning"}));dispatch(municipalitiesShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(municipalitiesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var municipalitiesRequest=function municipalitiesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_46" /* MUNICIPALITIES_REQUEST */],isFetching:true,timestamp:Date.now()};};var municipalitiesFailed=function municipalitiesFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_43" /* MUNICIPALITIES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var municipalitiesAllData=function municipalitiesAllData(json,entity){//sessionStorage.setItem("etrans_municipalities_"+entity,JSON.stringify(json));
return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_44" /* MUNICIPALITIES_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};var municipalitiesFilteredData=function municipalitiesFilteredData(json,entity){//sessionStorage.setItem("etrans_municipalities_"+entity,JSON.stringify(json));
return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_45" /* MUNICIPALITIES_FILTERED */],isFetching:false,payload:json.data,timestamp:Date.now()};};var municipalitiesFilteredRequest=function municipalitiesFilteredRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_45" /* MUNICIPALITIES_FILTERED */],isFetching:true,payload:[],timestamp:Date.now()};};var municipalitiesData=function municipalitiesData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_47" /* MUNICIPALITIES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var municipalityEditData=function municipalityEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_42" /* MUNICIPALITIES_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resourceConceptsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
var resourceConceptsList=function resourceConceptsList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(resourceConceptsRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_3__store_config__["y" /* API2_URL */]+"/resources/concepts",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(resourceConceptsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(resourceConceptsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var resourceConceptsData=function resourceConceptsData(json){return{type:__WEBPACK_IMPORTED_MODULE_3__store_config__["_190" /* RESOURCE_CONCEPT_FETCH */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},timestamp:Date.now()};};var resourceConceptsFail=function resourceConceptsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_3__store_config__["_189" /* RESOURCE_CONCEPT_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var resourceConceptsRequest=function resourceConceptsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__store_config__["_191" /* RESOURCE_CONCEPT_REQUEST */],isFetching:true,timestamp:Date.now()};};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(535),
    listCacheDelete = __webpack_require__(536),
    listCacheGet = __webpack_require__(537),
    listCacheHas = __webpack_require__(538),
    listCacheSet = __webpack_require__(539);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(136);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(29);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(559);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(579),
    baseKeys = __webpack_require__(586),
    isArrayLike = __webpack_require__(93);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(233),
    isLength = __webpack_require__(141);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(66),
    isObjectLike = __webpack_require__(68);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(94);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = {"data":[{"id":1,"name":"Centro de Apoyo de la mujer","owner":"Lucía Bazán","area":"Empoderamiento económico","address":"Miguel de la Madrid Hurtado #55 int 5","address2":"Col. Esmeralda Norte","city":"Colima","state":"Colima","zipcode":28017,"phone":"3123236334","url":"http://mipagina.com","email":"mail@dominio.com","status":1,"services":[{"id":1,"type":"Programa","name":"Becas para eduación continua","start_date":"2017-01-01","end_date":"2019-12-31","description":"","objective":[{"name":"Adultos Mayores"},{"name":"Migrantes"}],"offers":"","level":"Municipal"},{"id":2,"type":"Servicio","name":"Guardería pública","start_date":"2017-01-01","end_date":"2019-12-31","description":"","objective":[{"name":"Madres solteras"}],"offers":"","level":"Municipal"}],"infrastructure":{"polygon":1,"use":[{"name":"Diagnóstico"},{"name":"Formación"}],"type":"Centro de acopio","notes":""}},{"id":2,"name":"Asociación de apoyo integral","owner":"Lucía Bazán","area":"Seguridad","address":"Miguel de la Madrid Hurtado #55 int 5","address2":"Col. Esmeralda Norte","city":"Colima","state":"Colima","zipcode":28017,"phone":"3123236334","url":"http://mipagina.com","email":"mail@dominio.com","status":1,"services":[],"infrastructure":{"polygon":2,"use":[{"name":"Formación"}],"type":"Plaza","notes":""}}]}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(72);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = endsWith;
function endsWith(string, subString) {
  if (typeof string !== 'string') return false;

  var lastIndex = string.lastIndexOf(subString);

  return lastIndex !== -1 && lastIndex + subString.length === string.length;
}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchBatchIfNeeded = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _partition3 = __webpack_require__(334);

var _partition4 = _interopRequireDefault(_partition3);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _track = __webpack_require__(75);

var _nullAction = __webpack_require__(77);

var _nullAction2 = _interopRequireDefault(_nullAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batch = (0, _track.trackable)(function (model, actions) {
  var dispatchableActions = actions.filter(function (action) {
    return !!action;
  });

  if (!dispatchableActions.length) return _nullAction2.default;

  if (dispatchableActions.length && dispatchableActions.every(_isPlainObject2.default)) {
    if (dispatchableActions.length === 1) {
      return dispatchableActions[0];
    }

    return {
      type: _actionTypes2.default.BATCH,
      model: model,
      actions: dispatchableActions
    };
  }

  var _partition = (0, _partition4.default)(dispatchableActions, function (action) {
    return typeof action !== 'function';
  }),
      _partition2 = _slicedToArray(_partition, 2),
      plainActions = _partition2[0],
      actionThunks = _partition2[1];

  if (!actionThunks.length) {
    if (plainActions.length > 1) {
      return {
        type: _actionTypes2.default.BATCH,
        model: model,
        actions: plainActions
      };
    } else if (plainActions.length === 1) {
      return plainActions[0];
    }
  }

  return function (dispatch) {
    if (plainActions.length > 1) {
      dispatch({
        type: _actionTypes2.default.BATCH,
        model: model,
        actions: plainActions
      });
    } else if (plainActions.length === 1) {
      dispatch(plainActions[0]);
    }
    actionThunks.forEach(dispatch);
  };
});

function dispatchBatchIfNeeded(model, actions, dispatch) {
  if (!actions.length) return void 0;

  var dispatchableActions = actions.filter(function (action) {
    return !!action;
  });

  if (!dispatchableActions.length) return void 0;

  return dispatch(batch(model, dispatchableActions));
}

exports.default = batch;
exports.dispatchBatchIfNeeded = dispatchBatchIfNeeded;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.createIteratee = createIteratee;
exports.iterateeValue = iterateeValue;

var _identity = __webpack_require__(48);

var _identity2 = _interopRequireDefault(_identity);

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStrategy = {
  get: _get3.default
};

function createIteratee() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;

  function matcher(object) {
    return function (compareObject) {
      if (compareObject === object) return true;

      return Object.keys(object).every(function (key) {
        return s.get(object, key) === s.get(compareObject, key);
      });
    };
  }

  function propChecker(prop) {
    return function (object) {
      return object && !!s.get(object, prop);
    };
  }

  return function (value) {
    if (typeof value === 'function') {
      return value;
    }

    if (value === null) {
      return _identity2.default;
    }

    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      return matcher(value);
    }

    return propChecker(value);
  };
}

var iteratee = createIteratee();

function iterateeValue(data, value) {
  if (typeof value === 'function') {
    return value(data);
  }

  if (!Array.isArray(value) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' && typeof value !== 'string') {
    return !!value;
  }

  return iteratee(value)(data);
}

exports.default = iteratee;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getValidity;

var _getValue = __webpack_require__(78);

var _getValue2 = _interopRequireDefault(_getValue);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getValidity(validators, value) {
  var modelValue = (0, _getValue2.default)(value);

  if (typeof validators === 'function') {
    return validators(modelValue);
  }

  return (0, _mapValues2.default)(validators, function (validator) {
    return getValidity(validator, modelValue);
  });
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidityInvalid;

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidityInvalid(errors) {
  if (Array.isArray(errors)) {
    return errors.some(isValidityInvalid);
  }

  if ((0, _isPlainObject2.default)(errors)) {
    return Object.keys(errors).some(function (key) {
      return isValidityInvalid(errors[key]);
    });
  }

  return !!errors;
}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invertValidity;

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function invertValidity(validity) {
  if ((0, _isPlainObject2.default)(validity)) {
    return (0, _mapValues2.default)(validity, invertValidity);
  }

  return !validity;
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isMulti = __webpack_require__(76);

var _isMulti2 = _interopRequireDefault(_isMulti);

var _iteratee = __webpack_require__(104);

var _actions = __webpack_require__(47);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTextValue(value) {
  if (typeof value === 'string') {
    return '' + value;
  }

  return value;
}

function isChecked(props) {
  if ((0, _isMulti2.default)(props.model)) {
    if (!props.modelValue) return false;

    return props.modelValue.some(function (item) {
      return item === props.value;
    });
  }
  if (typeof props.modelValue === 'undefined') {
    if (typeof props.defaultChecked !== 'undefined') {
      return props.defaultChecked;
    }
  }

  return !!props.modelValue;
}

var standardPropsMap = {
  name: function name(props) {
    return props.name || props.model;
  },
  disabled: function disabled(_ref) {
    var fieldValue = _ref.fieldValue,
        _disabled = _ref.disabled;
    return (0, _iteratee.iterateeValue)(fieldValue, _disabled);
  },
  onChange: function onChange(_ref2) {
    var _onChange = _ref2.onChange;
    return _onChange;
  },
  onBlur: function onBlur(_ref3) {
    var _onBlur = _ref3.onBlur;
    return _onBlur;
  },
  onFocus: function onFocus(_ref4) {
    var _onFocus = _ref4.onFocus;
    return _onFocus;
  },
  onKeyPress: function onKeyPress(_ref5) {
    var _onKeyPress = _ref5.onKeyPress;
    return _onKeyPress;
  }
};

var textPropsMap = _extends({}, standardPropsMap, {
  // the value passed into the control is either the original control's
  // value prop (if the control is controlled) or the value controlled by
  // <Control>.
  value: function value(props) {
    if (props.hasOwnProperty('value')) {
      return props.value;
    }

    var value = getTextValue(props.viewValue);

    return value === undefined ? '' : value;
  }
});

var getModelValue = function getModelValue(_ref6) {
  var modelValue = _ref6.modelValue;
  return modelValue;
};
var getViewValue = function getViewValue(props) {
  return props.hasOwnProperty('value') ? props.value : props.viewValue;
};

var controlPropsMap = {
  default: _extends({}, standardPropsMap, {
    value: getViewValue
  }),
  checkbox: _extends({}, standardPropsMap, {
    checked: isChecked
  }),
  radio: _extends({}, standardPropsMap, {
    checked: function checked(props) {
      return props.defaultChecked ? props.checked : props.modelValue === props.value;
    },
    value: function value(props) {
      return props.value;
    }
  }),
  select: _extends({}, standardPropsMap, {
    value: getViewValue
  }),
  text: textPropsMap,
  textarea: textPropsMap,
  file: standardPropsMap,
  button: _extends({}, standardPropsMap, {
    value: getModelValue
  }),
  reset: _extends({}, standardPropsMap, {
    onClick: function onClick(props) {
      return function (event) {
        event.preventDefault();
        props.dispatch(_actions2.default.reset(props.model));
      };
    }
  })
};

exports.default = controlPropsMap;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModeler = undefined;

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _icepick = __webpack_require__(33);

var _icepick2 = _interopRequireDefault(_icepick);

var _arraysEqual = __webpack_require__(195);

var _arraysEqual2 = _interopRequireDefault(_arraysEqual);

var _toPath = __webpack_require__(80);

var _toPath2 = _interopRequireDefault(_toPath);

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _batchedEnhancer = __webpack_require__(110);

var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function icepickSet(state, path, value) {
  return _icepick2.default.setIn(state, path, value);
}

var defaultStrategy = {
  get: _get3.default,
  set: icepickSet,
  object: {}
};

function createModeler() {
  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
  var getter = strategy.get,
      setter = strategy.set,
      object = strategy.object;


  return function _createModelReducer(model) {
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var modelPath = (0, _toPath2.default)(model);

    var modelReducer = function modelReducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      var action = arguments[1];

      if (!action.model) {
        return state;
      }

      var path = (0, _toPath2.default)(action.model);

      if (!(0, _arraysEqual2.default)(path.slice(0, modelPath.length), modelPath)) {
        return state;
      }

      var localPath = path.slice(modelPath.length);

      switch (action.type) {
        case _actionTypes2.default.CHANGE:
          if (!localPath.length) {
            return action.value;
          }

          if (getter(state, localPath) === action.value) {
            return state;
          }

          return setter(state, localPath, action.value);

        case _actionTypes2.default.RESET:
          if (!localPath.length) {
            return initialState;
          }

          if (getter(state, localPath) === getter(initialState, localPath)) {
            return state;
          }

          return setter(state, localPath, getter(initialState, localPath));

        default:
          return state;
      }
    };

    return (0, _batchedEnhancer2.default)(modelReducer, initialState, options);
  };
}

var modelReducer = createModeler();

exports.createModeler = createModeler;
exports.default = modelReducer;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createBatchReducer(reducer, initialState) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var transformAction = options.transformAction;


  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var transformedAction = transformAction ? transformAction(action) : action;

    if (transformedAction.type === _actionTypes2.default.BATCH) {
      return transformedAction.actions.reduce(reducer, state);
    }

    return reducer(state, transformedAction);
  };
}

exports.default = createBatchReducer;

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validateSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return recover; });
/* harmony export (immutable) */ __webpack_exports__["d"] = userReset;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logout; });
/* unused harmony export fetchUserAgencies */
/* unused harmony export fetchUserCdms */
/* unused harmony export loginUserProfile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__register__ = __webpack_require__(202);
var validateSession=function validateSession(){var session=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadSession).then(function(response){return saveSession(response);}).catch(function(error){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(session)){return dispatch(fetchUserInfo(session));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__register__["d" /* validateRegister */])());return dispatch(loginFail(''));}});};};var login=function login(data){var body={grant_type:"password",client_id:"1",client_secret:"FzTk5zx5mFpGroBeQvrYqwAZPVVEgt1pQ0kTSsLr",username:data.username,password:data.password};var options={headers:{'Accept':'application/json','Content-Type':'application/json'},method:'post',body:JSON.stringify(body)};return function(dispatch){dispatch(loginRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_4__store_config__["y" /* API2_URL */]+'/oauth/token',options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){var session=Object.assign({},json,{remember:data.remember?true:false});return dispatch(validateSession(session));},function(error){return dispatch(loginFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});};};var recover=function recover(data){var body={email:data.username};var options={headers:{'Accept':'application/json','Content-Type':'application/json'},method:'post',body:JSON.stringify(body)};return function(dispatch){dispatch(recoverRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_4__store_config__["y" /* API2_URL */]+'/password/email',options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(recoverUserData(json));},function(error){return dispatch(loginFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});};};function userReset(data,query){var tmp=query.split("&");var token=tmp[1].split("=");token=token[1];var body={email:data.username,token:token,password:data.password,password_confirmation:data.password_confirmation};var options={headers:{'Accept':'application/json','Content-Type':'application/json'},method:'post',body:JSON.stringify(body)};return function(dispatch){dispatch(resetRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_4__store_config__["y" /* API2_URL */]+'/password/reset',options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){setTimeout(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push('/'),1000);return dispatch(resetUserData(json));},function(error){return dispatch(loginFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});};}var logout=function logout(){__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].deleteSession();__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].deleteUser();return function(dispatch){dispatch(logoutUserData());__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push('/');};};/*const renew = (token) => {
	const body = {
		client_id: "1",
		client_secret: "FzTk5zx5mFpGroBeQvrYqwAZPVVEgt1pQ0kTSsLr",
		refresh_token: token.refresh_token,
		grant_type: 'refresh_token'
	}

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'post',
		body: JSON.stringify(body)
	}

	return dispatch => {
		return fetch(`${API2_URL}/oauth/token`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => {
					return dispatch(validateSession(json))
				},
				error => {
					dispatch(loginFail(_.values(error)))
					history.push('/');
				}
			);
	}
}*/var fetchUserInfo=function fetchUserInfo(token){return function(dispatch){dispatch(loginRequest());return dispatch(fetchUserAgencies(token.access_token)).then(function(agencies){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(agencies.payload)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(agencies.payload)){return dispatch(fetchUserCdms(token.access_token)).then(function(cdms){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(cdms.payload)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(cdms.payload)){return dispatch(fetchUserProfile(token)).then(function(profile){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(profile.payload)){return dispatch(fetchUserMenu(token.access_token)).then(function(menu){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(menu.payload)){return saveSession({agencies:agencies.payload,cdms:cdms.payload,profile:profile.payload,menu:menu.payload,version:menu.version});}});}});}});}});};};var fetchUserMenu=function fetchUserMenu(token){var options={headers:{'Accept':'application/json','Authorization':'Bearer '+token},method:'get'};return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_4__store_config__["y" /* API2_URL */]+'/profile/menu',options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(loginUserMenu(json));},function(error){return dispatch(loginFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});};};var fetchUserProfile=function fetchUserProfile(token){var options={headers:{'Accept':'application/json','Authorization':'Bearer '+token.access_token},method:'get'};return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_4__store_config__["y" /* API2_URL */]+'/profile',options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){var profile=Object.assign({},json.data,token);return dispatch(loginUserProfile(profile));},function(error){return dispatch(loginFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});};};var fetchUserAgencies=function fetchUserAgencies(token){var options={headers:{'Accept':'application/json','Authorization':'Bearer '+token},method:'get'};return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_4__store_config__["y" /* API2_URL */]+'/profile/agencies',options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(loginUserAgencies(json.data));},function(error){return dispatch(loginFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});};};var fetchUserCdms=function fetchUserCdms(token){var options={headers:{'Accept':'application/json','Authorization':'Bearer '+token},method:'get'};return function(dispatch){return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_4__store_config__["y" /* API2_URL */]+'/profile/cdms',options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(loginUserCdms(json.data));},function(error){return dispatch(loginFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});};};/*const setLoginState = (agencies, profile) => {
	return dispatch => {
		dispatch(loginUserAgencies(agencies));
		dispatch(loginUserProfile(profile));
		return dispatch(fetchUserMenu(profile.access_token))
			.then(response => {
				if(response.error) {
					dispatch(loginFail(response.error));
					history.push('/');
				}else{
					return response;
				}
			});
	}
}*/var saveSession=function saveSession(session){__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].saveSession(session);__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].saveUser(session).then(function(){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].location.state)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].location.state.from)){__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].location.state.from);}else{__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push('/inicio');}}).catch(function(error){return console.warn('error',error);});};var logoutUserData=function logoutUserData(){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_32" /* LOGOUT */],timestamp:Date.now()};};var loginRequest=function loginRequest(){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_30" /* LOGIN_REQUEST */],isFetching:true,timestamp:Date.now(),message:'Iniciando sesión'};};var loginFail=function loginFail(error){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_28" /* LOGIN_FAIL */],isFetching:false,error:error,payload:undefined,timestamp:Date.now()};};var loginUserAgencies=function loginUserAgencies(data){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_26" /* LOGIN_AGENCIES */],payload:data,message:'Cargando estados y municipios'};};var loginUserCdms=function loginUserCdms(data){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_27" /* LOGIN_CDMS */],payload:data,message:'Cargando cdms'};};var loginUserProfile=function loginUserProfile(data){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_31" /* LOGIN_USER */],payload:data,message:'Cargando perfil de usuario'};};var loginUserMenu=function loginUserMenu(json){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_29" /* LOGIN_OK */],isFetching:false,payload:json.data,version:json.version,timestamp:Date.now(),message:'¡Bienvenido!'};};var recoverUserData=function recoverUserData(data){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_4" /* FORGOT_OK */],isFetching:false,payload:data.data.message,timestamp:Date.now()};};var recoverRequest=function recoverRequest(){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_5" /* FORGOT_REQUEST */],isFetching:true,payload:'Buscando tu usuario',timestamp:Date.now()};};var resetRequest=function resetRequest(){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_188" /* RESET_REQUEST */],isFetching:true,payload:'Guardando cambios',timestamp:Date.now()};};var resetUserData=function resetUserData(data){return{type:__WEBPACK_IMPORTED_MODULE_4__store_config__["_187" /* RESET_OK */],isFetching:false,payload:data.data.message,timestamp:Date.now()};};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchGoalComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return goalsShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return goalsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return goalSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return goalDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axis__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lines__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__activities__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modalities__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__entities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__status__ = __webpack_require__(51);
//import {statusList} from "./status";
var fetchGoalComplete=function fetchGoalComplete(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(goalsRequest());dispatch(goalsClear());dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__entities__["a" /* entitiesList */])());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__axis__["d" /* axisList */])()).then(function(axis){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(axis.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__lines__["e" /* linesList */])()).then(function(lines){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(lines.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__activities__["a" /* activitiesList */])()).then(function(activities){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(activities.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__modalities__["a" /* modalitiesList */])()).then(function(modalities){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(modalities.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__status__["a" /* statusGroupList */])()).then(function(status){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(status.payload)){if(id){return dispatch(fetchGoal(id));}else{return dispatch(goalsComplete());}}else{return dispatch(goalsFail('Carga incompleta'));}});}else{return dispatch(goalsFail('Carga incompleta'));}});}else{return dispatch(goalsFail('Carga incompleta'));}});}else{return dispatch(goalsFail('Carga incompleta'));}});}else{return dispatch(goalsFail('Carga incompleta'));}});};};var goalsShow=function goalsShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(goalsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/goals?page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(goalsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(goalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var goalsList=function goalsList(){var modality_id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;var agenciable_id=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(goalsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/goals?include[0]=modality&include[1]=activities.verification_media"+(modality_id?"&modality_id="+modality_id:'')+(agenciable_id?"&agenciable_id="+agenciable_id:'')+"&status_id=1&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(goalsListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(goalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Fetch Goal Edit*/var fetchGoal=function fetchGoal(id){return function(dispatch){//dispatch(goalsRequest());
return dispatch(goalEdit(id)).then(function(goal){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goal.payload)){return dispatch(goalActivities(id)).then(function(activities){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(activities.payload)){return dispatch(goalsComplete());}else{return dispatch(goalsFail(activities.error));}});}else{return dispatch(goalsFail(goal.error));}});};};var goalEdit=function goalEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/goals/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(goalEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(goalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Goals Activities*/var goalActivities=function goalActivities(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/goals/"+id+"/activities?include[0]=goal_activity",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(activitiesGoalEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(goalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Save Goal*/var goalSave=function goalSave(values){return function(dispatch){dispatch(goalsRequest());if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.activities)){return dispatch(goalEditSave(values)).then(function(goal){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goal.payload)){return dispatch(goalActivitiesSave(values,goal.payload.id/*, activities*/)).then(function(activity){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(activity.payload)){if(values.id){return dispatch(goalsComplete());}}});}});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:"La Meta debe de contener minimo una actividad",type:"danger"}));return dispatch(goalsFail("La Meta debe de contener minimo una actividad"));}};};var goalEditSave=function goalEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/goals"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La meta se ha guardado correctamente",type:"success"}));return dispatch(goalEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(goalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Goal Activities Save*/var goalActivitiesSave=function goalActivitiesSave(goal,id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({activities:goal.activities})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/goals/"+id+"/activities?include[0]=goal_activity"+(goal.id?'&_method=PUT':''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goal.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/proigualdad/metas/editar/"+id);}return dispatch(activitiesGoalEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(goalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var goalDelete=function goalDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(goalsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/goals/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"Se elimin\xF3 la siguiente meta: <strong>"+json.data.name+"</strong>",type:"success"}));dispatch(goalsShow());return dispatch(goalDeleted());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(goalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var goalsRequest=function goalsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_7" /* GOALS_REQUEST */],isFetching:true,timestamp:Date.now()};};var goalsListData=function goalsListData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_6" /* GOALS_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};var goalsData=function goalsData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_8" /* GOALS_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var goalEditData=function goalEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_13" /* GOAL_EDIT */],payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var activitiesGoalEditData=function activitiesGoalEditData(json){var activities=[];//_.mapKeys(json.data, (o) => activities[o.id] = {activity:true,mandatory:(o.goal_activity.mandatory ===1 ? true:false)});
__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(json.data,function(o){return activities.push(Object.assign({},o,{mandatory:o.goal_activity.mandatory===1?true:false}));});return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_9" /* GOAL_ACTIVITIES */],payload:activities,timestamp:Date.now()};};var goalsComplete=function goalsComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_11" /* GOAL_COMPLETE */],isFetching:false,timestamp:Date.now()};};var goalDeleted=function goalDeleted(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_12" /* GOAL_DELETE */],isFetching:false,timestamp:Date.now()};};var goalsClear=function goalsClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_10" /* GOAL_CLEAR */],payload:{activities:[]},timestamp:Date.now()};};var goalsFail=function goalsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_14" /* GOAL_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return axisShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return axisList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return axisEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return axisEditSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axisDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__status__ = __webpack_require__(51);
var axisShow=function axisShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(axisRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/axis?page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(axisData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(axisFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var axisList=function axisList(status_id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(axisRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/axis?per_page=all"+(!isNaN(status_id)?'&status_id='+status_id:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(axisData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(axisFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var axisEdit=function axisEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(axisRequest());dispatch(axisClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__status__["a" /* statusGroupList */])()).then(function(status){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(status.payload)){return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/axis/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(axisEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(axisFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});}else{return dispatch(axisFail('Carga incompleta'));}});});};};var axisEditSave=function axisEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(axisRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/axis"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El eje se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_5__store_store__["b" /* history */].push("/proigualdad/ejes/editar/"+json.data.id);}return dispatch(axisEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(axisFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var axisDelete=function axisDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(axisRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/axis/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El eje se ha borrado correctamente",type:"success"}));dispatch(axisShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(axisFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var axisData=function axisData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["F" /* AXIS_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var axisEditData=function axisEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["C" /* AXIS_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var axisRequest=function axisRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["E" /* AXIS_REQUEST */],isFetching:true,timestamp:Date.now()};};var axisClear=function axisClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["B" /* AXIS_CLEAR */],payload:{},timestamp:Date.now()};};var axisFail=function axisFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["D" /* AXIS_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return linesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return linesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchLineComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return lineEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lineEditSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lineDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__status__ = __webpack_require__(51);
var linesShow=function linesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(linesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/lines?page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(linesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(linesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var linesList=function linesList(){var status_id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(linesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/lines?per_page=all"+(!isNaN(status_id)?'&status_id='+status_id:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(linesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(linesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var fetchLineComplete=function fetchLineComplete(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(linesRequest());dispatch(linesClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__status__["a" /* statusGroupList */])()).then(function(status){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(status.payload)){if(id){return dispatch(lineEdit(id));}else{return dispatch(linesComplete());}}else{return dispatch(linesFail('Carga incompleta'));}});};};var lineEdit=function lineEdit(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(linesRequest());dispatch(linesClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/lines/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(linesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(linesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var lineEditSave=function lineEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(linesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/lines"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La linea se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_5__store_store__["b" /* history */].push("/proigualdad/lineas/editar/"+json.data.id);}return dispatch(linesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(linesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var lineDelete=function lineDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(linesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/lines/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La linea se ha borrado correctamente",type:"success"}));dispatch(linesShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(linesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var linesData=function linesData(json){var lines=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(json.data,['code'],['asc']);return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_25" /* LINES_SHOW */],isFetching:false,payload:lines,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var linesEditData=function linesEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_22" /* LINES_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var linesRequest=function linesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_24" /* LINES_REQUEST */],isFetching:true,timestamp:Date.now()};};var linesClear=function linesClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_20" /* LINES_CLEAR */],payload:{},timestamp:Date.now()};};var linesComplete=function linesComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_21" /* LINES_COMPLETE */],isFetching:false,timestamp:Date.now()};};var linesFail=function linesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_23" /* LINES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activitiesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activitiesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return goalActivitiesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchActivityComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return activitySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return activityDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__activity_groups__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__verification_media__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__status__ = __webpack_require__(51);
/*Activities Show*/var activitiesShow=function activitiesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(activityRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/activities?include[0]=status&page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(activitiesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(activityFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Activities List*/var activitiesList=function activitiesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(activityRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/activities/groups?include[0]=activities&include[1]=modalities",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(activitiesListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(activityFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Goal Activities List*/var goalActivitiesList=function goalActivitiesList(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(activityRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/goals/"+id+"/activities",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(activitiesListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(activityFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var fetchActivityComplete=function fetchActivityComplete(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(activityRequest());dispatch(activityClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__activity_groups__["a" /* activityGroupShow */])()).then(function(groups){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(groups.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__verification_media__["a" /* verificationMediaShow */])()).then(function(verification){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(verification.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__status__["a" /* statusGroupList */])()).then(function(status){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(status.payload)){if(id){return dispatch(fetchActivity(id));}else{return dispatch(activityComplete());}}else{return dispatch(activityFail('Carga incompleta'));}});}else{return dispatch(activityFail('Carga incompleta'));}});}else{return dispatch(activityFail('Carga incompleta'));}});};};/*Edit*/var fetchActivity=function fetchActivity(id){return function(dispatch){//dispatch(activityRequest());
return dispatch(activityEdit(id)).then(function(activity){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(activity.payload)){return dispatch(activityComplete());}else{return dispatch(activityFail(activity.error));}});};};var activityEdit=function activityEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/activities/"+id+"?include[0]=verification_media",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(activityEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(activityFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Activity Save*/var activitySave=function activitySave(values){return function(dispatch){dispatch(activityRequest());return dispatch(activityEditSave(values)).then(function(activity){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(activity.payload)){return dispatch(activityMediaSave(values,activity.payload.id)).then(function(media){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(media.payload)){return dispatch(activityComplete());}else{return dispatch(activityFail(media.error));}});}else{return dispatch(activityFail(activity.error));}});};};var activityEditSave=function activityEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/activities"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(activityEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(activityFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Activity Media Save*/var activityMediaSave=function activityMediaSave(values,id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({verification_media_id:values.verification_media_id})};dispatch(activityRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/activities/"+id+"/verification-media?_method=PUT",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La actividad se guardó correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/proigualdad/actividades/editar/"+id);}return dispatch(verificationActivityEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(activityFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Activity Delete */var activityDelete=function activityDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'DELETE'};dispatch(activityRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/activities/"+id,options).then(function(result){return result.json();},function(error){return error;}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message,type:"success"}));dispatch(activitiesShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(activityFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Activity Request*/var activityRequest=function activityRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["k" /* ACTIVITY_REQUEST */],isFetching:true,timestamp:Date.now()};};/*Activity List*/var activitiesData=function activitiesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["c" /* ACTIVITIES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};/*Goal Activities List*/var activitiesListData=function activitiesListData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["b" /* ACTIVITIES_LIST */],isFetching:false,payload:json.data,timestamp:Date.now()};};/*Activity Edit*/var activityEditData=function activityEditData(json){var response={};if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.verification_media)){response={id:json.data.id,name:json.data.name,amount:json.data.amount,group_id:json.data.group_id,status_id:json.data.status_id,verification_media_id:json.data.verification_media[0].id};}else{response={id:json.data.id,name:json.data.name,amount:json.data.amount,group_id:json.data.group_id,status_id:json.data.status_id};}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["f" /* ACTIVITY_EDIT */],isFetching:false,payload:response,permissions:json.permissions,timestamp:Date.now()};};var verificationActivityEditData=function verificationActivityEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["l" /* ACTIVITY_VERIFICATION_MEDIA */],payload:{verification_media_id:json.data[0].id},timestamp:Date.now};};/*
const activityEditMediaData = (data) => {
	return {
		type: ACTIVITY_EDIT,
		isFetching: false,
		edit: data[0],
		timestamp: Date.now()
	}
};*/var activityComplete=function activityComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["e" /* ACTIVITY_COMPLETE */],isFetching:false,timestamp:Date.now()};};/*Activity Clear*/var activityClear=function activityClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["d" /* ACTIVITY_CLEAR */],payload:{},timestamp:Date.now()};};/*Activity Fail*/var activityFail=function activityFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["g" /* ACTIVITY_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return conceptsShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return conceptsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchConcept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return conceptSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return conceptDelete; });
/* unused harmony export conceptsData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
/*Concepts Show*/var conceptsShow=function conceptsShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(conceptRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/expenses/concepts?include[0]=status&page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(conceptsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(conceptFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var conceptsList=function conceptsList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(conceptRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/expenses/concepts?include[0]=status&include[1]=units&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(conceptsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(conceptFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/**Fetch Concepts Expenses */var fetchConcept=function fetchConcept(id){return function(dispatch){dispatch(conceptRequest());dispatch(conceptsClear());return dispatch(conceptEdit(id)).then(function(concept){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(concept.payload)){return dispatch(conceptComplete());}else{return dispatch(conceptFail(concept.error));}});};};/*Concept Edit*/var conceptEdit=function conceptEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/expenses/concepts/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(conceptEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(conceptFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Concept Save*/var conceptSave=function conceptSave(values){return function(dispatch){dispatch(conceptRequest());return dispatch(conceptEditSave(values)).then(function(concept){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(concept.payload)){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.units)){return dispatch(unitsConceptEditSave(values,concept.payload.id)).then(function(units){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(units.payload)){if(values.id){return dispatch(conceptComplete());}}else{return dispatch(conceptFail(units.error));}});}else{return dispatch(conceptComplete());}}else{return dispatch(conceptFail(concept.error));}});};};var conceptEditSave=function conceptEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({name:values.name,status_id:values.status_id})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/expenses/concepts"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.units)){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El concepto de gasto se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/gastos/conceptos/editar/"+json.data.id);}}return dispatch(conceptEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(conceptFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var unitsConceptEditSave=function unitsConceptEditSave(values,id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var units=[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(values.units,function(row){return units.push({name:row.name,invoiceable:row.invoiceable,status_id:row.status_id});});var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({units:units})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/expenses/concepts/"+id+"/units"+(values.id?'?_method=PUT':''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El concepto de gasto se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/gastos/conceptos/editar/"+id);}return dispatch(unitsConceptData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(conceptFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Concept Delete*/var conceptDelete=function conceptDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'DELETE'};dispatch(conceptRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/expenses/concepts/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El Concepto se ha borrado Exitosamente",type:"success"}));return dispatch(conceptsShow(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(conceptFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Concepts Show*/var conceptsData=function conceptsData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["M" /* CONCEPTS_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions?json.permissions:[],timestamp:Date.now()};};/*Concept Edit*/var conceptEditData=function conceptEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["O" /* CONCEPT_EDIT */],//isFetching: false,
payload:json.data,permissions:json.permissions?json.permissions:[],timestamp:Date.now()};};/*Units Concept List*/var unitsConceptData=function unitsConceptData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["Q" /* CONCEPT_UNITS */],payload:json.data,timestamp:Date.now()};};/*Fetch complete*/var conceptComplete=function conceptComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["K" /* CONCEPTS_COMPLETE */],isFetching:false,timestamp:Date.now()};};/*Concepts Clear*/var conceptsClear=function conceptsClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["N" /* CONCEPT_CLEAR */],payload:{edit:{units:[]},permissions:[]}};};/*Concept Fail*/var conceptFail=function conceptFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["P" /* CONCEPT_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};/*Concept Request*/var conceptRequest=function conceptRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["L" /* CONCEPTS_REQUEST */],isFetching:true,timestamp:Date.now()};};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/user_profile_female.d7a3ec35.jpg";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/user_profile_male.bec872e6.jpg";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalsAdd=function(_Component){_inherits(GoalsAdd,_Component);function GoalsAdd(){_classCallCheck(this,GoalsAdd);return _possibleConstructorReturn(this,(GoalsAdd.__proto__||Object.getPrototypeOf(GoalsAdd)).apply(this,arguments));}_createClass(GoalsAdd,[{key:'render',value:function render(){var goals=this.props.goals;var gc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(goals.permissions,function(o){return o==='Create';});return gc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/metas/crear',className:'button is-small is-inm-purple'},'Agregar Meta')):'';}}]);return GoalsAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(GoalsAdd));

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ObjectivesAdd=function(_Component){_inherits(ObjectivesAdd,_Component);function ObjectivesAdd(){_classCallCheck(this,ObjectivesAdd);return _possibleConstructorReturn(this,(ObjectivesAdd.__proto__||Object.getPrototypeOf(ObjectivesAdd)).apply(this,arguments));}_createClass(ObjectivesAdd,[{key:'render',value:function render(){var objectives=this.props.objectives;var oc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(objectives.permissions,function(o){return o==='Create';});return oc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/objetivos/crear',className:'button is-small is-inm-purple'},'Agregar objetivo')):'';}}]);return ObjectivesAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(ObjectivesAdd));

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StrategiesAdd=function(_Component){_inherits(StrategiesAdd,_Component);function StrategiesAdd(){_classCallCheck(this,StrategiesAdd);return _possibleConstructorReturn(this,(StrategiesAdd.__proto__||Object.getPrototypeOf(StrategiesAdd)).apply(this,arguments));}_createClass(StrategiesAdd,[{key:'render',value:function render(){var strategies=this.props.strategies;var sc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(strategies.permissions,function(o){return o==='Create';});return sc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/estrategias/crear',className:'button is-small is-inm-purple'},'Agregar estrategia')):'';}}]);return StrategiesAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(StrategiesAdd));

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LinesAdd=function(_Component){_inherits(LinesAdd,_Component);function LinesAdd(){_classCallCheck(this,LinesAdd);return _possibleConstructorReturn(this,(LinesAdd.__proto__||Object.getPrototypeOf(LinesAdd)).apply(this,arguments));}_createClass(LinesAdd,[{key:'render',value:function render(){var lines=this.props.lines;var lc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(lines.permissions,function(o){return o==='Create';});return lc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/lineas/crear',className:'button is-small is-inm-purple'},'Agregar linea')):'';}}]);return LinesAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(LinesAdd));

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AxisAdd=function(_Component){_inherits(AxisAdd,_Component);function AxisAdd(){_classCallCheck(this,AxisAdd);return _possibleConstructorReturn(this,(AxisAdd.__proto__||Object.getPrototypeOf(AxisAdd)).apply(this,arguments));}_createClass(AxisAdd,[{key:'render',value:function render(){var axis=this.props.axis;var ac=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(axis.permissions,function(o){return o==='Create';});return ac?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/ejes/crear',className:'button is-small is-inm-purple'},'Agregar eje')):'';}}]);return AxisAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(AxisAdd));

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivityAdd=function(_Component){_inherits(ActivityAdd,_Component);function ActivityAdd(){_classCallCheck(this,ActivityAdd);return _possibleConstructorReturn(this,(ActivityAdd.__proto__||Object.getPrototypeOf(ActivityAdd)).apply(this,arguments));}_createClass(ActivityAdd,[{key:'render',value:function render(){var activities=this.props.activities;var ac=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(activities.permissions,function(o){return o==='Create';});return ac?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/actividades/crear',className:'button is-small is-inm-purple'},'Agregar Actividad')):'';}}]);return ActivityAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(ActivityAdd));

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConceptsAdd=function(_Component){_inherits(ConceptsAdd,_Component);function ConceptsAdd(){_classCallCheck(this,ConceptsAdd);return _possibleConstructorReturn(this,(ConceptsAdd.__proto__||Object.getPrototypeOf(ConceptsAdd)).apply(this,arguments));}_createClass(ConceptsAdd,[{key:'render',value:function render(){var concepts=this.props.concepts;var cc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(concepts.permissions,function(o){return o==='Create';});return cc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/gastos/conceptos/crear',className:'button is-small is-inm-purple'},'Agregar Concepto')):'';}}]);return ConceptsAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(ConceptsAdd));

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VersionsAdd=function(_Component){_inherits(VersionsAdd,_Component);function VersionsAdd(){_classCallCheck(this,VersionsAdd);return _possibleConstructorReturn(this,(VersionsAdd.__proto__||Object.getPrototypeOf(VersionsAdd)).apply(this,arguments));}_createClass(VersionsAdd,[{key:'render',value:function render(){var versions=this.props.versions;var vc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(versions.permissions,function(o){return o==='Create';});return vc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/versiones/crear',className:'button is-small is-inm-purple'},'Agregar versión')):'';}}]);return VersionsAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(VersionsAdd));

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var defaultProps={disabled:false,value:undefined};var DateTimePick=function(_Component){_inherits(DateTimePick,_Component);function DateTimePick(){_classCallCheck(this,DateTimePick);return _possibleConstructorReturn(this,(DateTimePick.__proto__||Object.getPrototypeOf(DateTimePick)).apply(this,arguments));}_createClass(DateTimePick,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datepicker__["a" /* default */],{name:this.props.name,id:this.props.id,selected:this.props.value?__WEBPACK_IMPORTED_MODULE_3_moment__(this.props.value):undefined,onChange:function onChange(value){return _this2.props.onChange(value?__WEBPACK_IMPORTED_MODULE_3_moment__(value).format('YYYY-MM-DD HH:mm:ss'):"");},placeholderText:__WEBPACK_IMPORTED_MODULE_3_moment__().format('YYYY-MM-DD HH:mm:ss'),className:this.props.className,disabled:this.props.disabled,value:this.props.value?this.props.value:"",showTimeSelect:true,timeFormat:'HH:mm:ss',injectTimes:[__WEBPACK_IMPORTED_MODULE_3_moment__().hours(23).minutes(59).seconds(59)],timeIntervals:15,timeCaption:'Hora',dateFormat:'YYYY-MM-DD HH:mm:ss',isClearable:true});}}]);return DateTimePick;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DateTimePick.propTypes=propTypes;DateTimePick.defaultPros=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (DateTimePick);

/***/ }),
/* 129 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 131 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(505);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(223);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Manager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_context__);





var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "referenceNode", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);



/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(533),
    baseMatchesProperty = __webpack_require__(596),
    identity = __webpack_require__(607),
    isArray = __webpack_require__(30),
    property = __webpack_require__(608);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(29);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(551),
    mapCacheDelete = __webpack_require__(558),
    mapCacheGet = __webpack_require__(560),
    mapCacheHas = __webpack_require__(561),
    mapCacheSet = __webpack_require__(562);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(563),
    isObjectLike = __webpack_require__(68);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(30),
    isSymbol = __webpack_require__(94);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupsAdd=function(_Component){_inherits(GroupsAdd,_Component);function GroupsAdd(){_classCallCheck(this,GroupsAdd);return _possibleConstructorReturn(this,(GroupsAdd.__proto__||Object.getPrototypeOf(GroupsAdd)).apply(this,arguments));}_createClass(GroupsAdd,[{key:'render',value:function render(){var groupsPhases=this.props.groupsPhases;var gc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(groupsPhases.permissions,function(o){return o==='Create';});return gc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/fases/grupos/crear',className:'button is-small is-inm-purple'},'Agregar Grupo')):'';}}]);return GroupsAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(GroupsAdd));

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PermissionsAdd=function(_Component){_inherits(PermissionsAdd,_Component);function PermissionsAdd(){_classCallCheck(this,PermissionsAdd);return _possibleConstructorReturn(this,(PermissionsAdd.__proto__||Object.getPrototypeOf(PermissionsAdd)).apply(this,arguments));}_createClass(PermissionsAdd,[{key:'render',value:function render(){var permissions=this.props.permissions;var pc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(permissions.permissions,function(o){return o==='Create';});return pc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/permisos/crear',className:'button is-small is-inm-purple'},'Agregar permiso')):'';}}]);return PermissionsAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(PermissionsAdd));

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RolesAdd=function(_Component){_inherits(RolesAdd,_Component);function RolesAdd(){_classCallCheck(this,RolesAdd);return _possibleConstructorReturn(this,(RolesAdd.__proto__||Object.getPrototypeOf(RolesAdd)).apply(this,arguments));}_createClass(RolesAdd,[{key:'render',value:function render(){var roles=this.props.roles;var rc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(roles.permissions,function(o){return o==='Create';});return rc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/perfiles/crear',className:'button is-small is-inm-purple'},'Agregar perfil')):'';}}]);return RolesAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(RolesAdd));

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersAdd=function(_Component){_inherits(UsersAdd,_Component);function UsersAdd(){_classCallCheck(this,UsersAdd);return _possibleConstructorReturn(this,(UsersAdd.__proto__||Object.getPrototypeOf(UsersAdd)).apply(this,arguments));}_createClass(UsersAdd,[{key:'render',value:function render(){var users=this.props.users;var uc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(users.permissions,function(o){return o==='Create';});return uc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/usuarios/crear',className:'button is-small is-inm-purple'},'Agregar Usuario')):'';}}]);return UsersAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(UsersAdd));

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollToTopOnMount=function(_Component){_inherits(ScrollToTopOnMount,_Component);function ScrollToTopOnMount(){_classCallCheck(this,ScrollToTopOnMount);return _possibleConstructorReturn(this,(ScrollToTopOnMount.__proto__||Object.getPrototypeOf(ScrollToTopOnMount)).apply(this,arguments));}_createClass(ScrollToTopOnMount,[{key:'componentDidMount',value:function componentDidMount(prevProps){window.scrollTo(0,0);}},{key:'render',value:function render(){return null;}}]);return ScrollToTopOnMount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ScrollToTopOnMount);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PropTypes={isFetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,filterChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,modality:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,entity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,agencies:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,municipalityFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,municipalityChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,stateChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,agenciable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};var ProjectNavigation=function(_Component){_inherits(ProjectNavigation,_Component);function ProjectNavigation(){_classCallCheck(this,ProjectNavigation);return _possibleConstructorReturn(this,(ProjectNavigation.__proto__||Object.getPrototypeOf(ProjectNavigation)).apply(this,arguments));}_createClass(ProjectNavigation,[{key:"render",value:function render(){var _this2=this;var _props=this.props,filter=_props.filter,modality=_props.modality,entity=_props.entity,isFetching=_props.isFetching,agenciable=_props.agenciable;var states=this.stateList();var municipalities=this.municipalityList();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnavigation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"psn-projects",className:"label is-small"},"Navegaci\xF3n por"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark"+(isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"psn-projects",value:filter,onChange:function onChange(e){return _this2.props.filterChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{disabled:true},"--- Tipo de proyecto ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"all_projects",defaultValue:true},"Todas las instancias"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"registred"},"Proyectos registrados"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"code"},"Proyectos con folio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"benefited"},"Proyectos beneficiados")))),modality!=='modalidad-ii'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"psn-states",className:"label is-small"},"Estado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark"+(isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"psn-state",onChange:function onChange(e){return _this2.props.stateChange(e.target.value);},value:entity?entity:undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{disabled:true,defaultValue:true},"--- Estados ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(states,function(st,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:st.agenciable_short,key:k},st.agenciable_name);})))),modality==='modalidad-ii'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"psn-states",className:"label is-small"},"Estado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark"+(isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"psn-states",onChange:function onChange(e){return _this2.props.municipalityFilter(e.target.value);},value:agenciable.state},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{disabled:true,defaultValue:true},"--- Estados ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(states,function(mn,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:mn.agenciable_state_short,key:j},mn.agenciable_state_name);})))),modality==='modalidad-ii'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"psn-mun",className:"label is-small"},"Municipio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark "+(isFetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"psn-mun",onChange:function onChange(e){return _this2.props.municipalityChange(e.target.value);},value:agenciable.municipality?agenciable.municipality:undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{defaultValue:true},"--- Municipios ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(municipalities,function(mn,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:mn.agenciable_slug,key:j},mn.agenciable_name);}))))));}},{key:"stateList",value:function stateList(){var _props2=this.props,modality=_props2.modality,agencies=_props2.agencies,filter=_props2.filter;switch(filter){case'registred':if(modality!=='modalidad-ii'){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_id;}),['agenciable_name']);}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_id;}),'agenciable_state_id'),['agenciable_state_name']);}case'code':if(modality!=='modalidad-ii'){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_code;}),['agenciable_name']);}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_code;}),'agenciable_state_id'),['agenciable_state_name']);}case'benefited':if(modality!=='modalidad-ii'){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_benefited===1;}),['agenciable_name']);}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_benefited===1;}),'agenciable_state_id'),['agenciable_state_name']);}default:if(modality!=='modalidad-ii'){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(agencies[modality],['agenciable_name']);}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(agencies[modality],'agenciable_state_id'),['agenciable_state_name']);}}}},{key:"municipalityList",value:function municipalityList(){var _props3=this.props,agencies=_props3.agencies,modality=_props3.modality,filter=_props3.filter,agenciable=_props3.agenciable;switch(filter){case'registred':return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_id;}),{agenciable_state_short:agenciable.state}),['agenciable_name']);case'code':return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_code;}),{agenciable_state_short:agenciable.state}),['agenciable_name']);case'benefited':return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_benefited===1;}),{agenciable_state_short:agenciable.state}),['agenciable_name']);default:return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],{agenciable_state_short:agenciable.state}),['agenciable_name']);}}}]);return ProjectNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectNavigation.propTypes=PropTypes;/* harmony default export */ __webpack_exports__["a"] = (ProjectNavigation);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActorsModal=function(_Component){_inherits(ActorsModal,_Component);function ActorsModal(){_classCallCheck(this,ActorsModal);return _possibleConstructorReturn(this,(ActorsModal.__proto__||Object.getPrototypeOf(ActorsModal)).apply(this,arguments));}_createClass(ActorsModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,conclusion=_props.conclusion,active=_props.active,closeModal=_props.closeModal,actors=_props.actors,fetching=_props.fetching,selectedActors=_props.selectedActors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:function onClick(){return closeModal();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Seleccione los actores estrat\xE9gicos que aplican'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return closeModal();},className:'delete is-medium','aria-label':'delete'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},fetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline conago-checkboxes'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(actors,function(actor,k){var selectedIndex=undefined;var shouldCheck=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(selectedActors,function(o,sel){if(o.id===actor.id){selectedIndex=sel;return true;}})!==undefined?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'actor-'+actor.id,className:'checkbox',disabled:conclusion},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'actor-'+actor.id,ref:'g-actor-'+actor.id,value:actor.id,type:'checkbox',checked:shouldCheck,className:'checkbox',onChange:function onChange(){return _this2._saveActor(actor.id,actor,selectedIndex);},disabled:conclusion}),actor.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:function onClick(){return closeModal();}},'Cerrar')))))));}},{key:'_saveActor',value:function _saveActor(id,actor,index){if(this.refs['g-actor-'+id].checked){this.props.add('project.registry.data.project_goals['+this.props.selectedGoal+'].actors',actor);}else{this.props.remove('project.registry.data.project_goals['+this.props.selectedGoal+'].actors',index);}}}]);return ActorsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActorsModal);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivityWidget=function(_Component){_inherits(ActivityWidget,_Component);function ActivityWidget(){_classCallCheck(this,ActivityWidget);return _possibleConstructorReturn(this,(ActivityWidget.__proto__||Object.getPrototypeOf(ActivityWidget)).apply(this,arguments));}_createClass(ActivityWidget,[{key:"render",value:function render(){var _this2=this;var _props=this.props,disabled=_props.disabled,activities=_props.activities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"activityAdd",className:"label"},"Seleccionar actividades"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{ref:"activitySelect",disabled:disabled,id:"activityAdd",onChange:function onChange(){return _this2._activityValue();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:0,defaultValue:true},"--- Actividades ---"),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(activities)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(activities.activities)&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(activities.activities,function(item,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:item.id,key:j},item.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",ref:"quantity",id:"quantity",placeholder:"Cantidad",className:"input",min:"1",step:"1",defaultValue:1,onChange:function onChange(){return _this2._activityValue();},disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",ref:"total",id:"total",placeholder:"0.00",className:"input",readOnly:true,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this2._addActivity();},disabled:disabled},"Agregar"))));}},{key:"_addActivity",value:function _addActivity(){var _props2=this.props,goal=_props2.goal,goals=_props2.goals,activities=_props2.activities;var selected=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(goals,{proigualdad_goal_id:goal.proigualdad_goal_id});var activity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(activities.activities,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.activitySelect.value)});var hasIt=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goal.project_goal_activities,{proigualdad_activity_id:activity.id});var activitySize=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.proigualdad_goal_id);if(hasIt===undefined&&activitySize<=4){this.props.add("project.registry.data.project_goals["+selected+"].project_goal_activities",{id:activity.id,proigualdad_activity_id:activity.id,name:activity.name,quantity:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.quantity.value),amount:activity.amount,total:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.quantity.value)*activity.amount,mandatory:activity.mandatory,verification_media:activity.verification_media[0]});var newTotal=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(goal.total)+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.quantity.value)*activity.amount;this.props.change("project.registry.project_goals["+goal.proigualdad_goal_id+"].total",newTotal);this.refs.activitySelect.value=0;this.refs.quantity.value=1;this.refs.total.value='';}else if(activitySize>=5){alert('Cada meta puede tener un máximo de 5 actividades');}else{alert('No se pueden duplicar actividades');}}},{key:"_activityValue",value:function _activityValue(){var activities=this.props.activities;var activity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(activities.activities,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.activitySelect.value)});if(activity){this.refs.total.value=Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.refs.quantity.value*activity.amount));}}}]);return ActivityWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActivityWidget);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_notification__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_navigation_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_user_opts_dropdown__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_navigation_revision_reports_subnav__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_navigation_project_navigation__ = __webpack_require__(148);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(SecuredComponent,data){var RevisionReportsLayout=function(_Component){_inherits(RevisionReportsLayout,_Component);_createClass(RevisionReportsLayout,[{key:"render",value:function render(){var _this2=this;var _props=this.props,userLogin=_props.userLogin,notifications=_props.notifications,match=_props.match,location=_props.location,session=_props.session,revision=_props.revision,menu=_props.menu;var agencies=session.user.agencies;var agency=this.setAgencyName(match.params.modality,agencies);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_navigation_navigation__["a" /* default */],{agencies:Object.assign({},session.user.agencies),cdms:Object.assign({},session.user.cdms),items:Object.assign({},session.user.menu),show:menu.view,location:Object.assign({},location),key:"app-navigation-sidebar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"project-content",key:"project-website-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",{className:"navbar is-dark secondary-navigation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-menu navbar-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default.a,alt:"gob.mx",className:"app-gov-logo--image"})),session.user.version?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-menu navbar-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"title is-6 has-text-centered has-text-white"},session.user.version.name)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"main-nav--close",onClick:function onClick(){return _this2.toggleMenu();}},menu.view?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-left"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-right"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_user_opts_dropdown__["a" /* default */],{data:Object.assign({},session.user.profile)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_navigation_project_navigation__["a" /* default */],{isFetching:userLogin.isFetching,filter:this.state.filterType,filterChange:this.filterChange,modality:match.params.modality,entity:match.params.state,agencies:session.user.agencies,municipalityFilter:this.municipalityFilter,municipalityChange:this.municipalityChange,stateChange:this.stateChange,agenciable:{state:this.state.modState,municipality:match.params.municipality}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_navigation_revision_reports_subnav__["a" /* default */],{step:data.subnav,params:match.params,agency:agency}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"app-layout--content",style:{padding:'0rem 0rem'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-1 main-title",dangerouslySetInnerHTML:{__html:!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revision.phase_group)?"Revisi\xF3n - "+revision.phase_group.name:'Revisión'}}),notifications.data.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10-desktop"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_notification__["a" /* default */],notifications))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecuredComponent,this.props))))];}}]);function RevisionReportsLayout(props){_classCallCheck(this,RevisionReportsLayout);var _this=_possibleConstructorReturn(this,(RevisionReportsLayout.__proto__||Object.getPrototypeOf(RevisionReportsLayout)).call(this));_this.state={modState:props.match.params.state,filterType:'all_projects'};_this.municipalityFilter=_this.municipalityFilter.bind(_this);_this.municipalityChange=_this.municipalityChange.bind(_this);_this.stateChange=_this.stateChange.bind(_this);_this.filterChange=_this.filterChange.bind(_this);_this.toggleMenu=_this.toggleMenu.bind(_this);return _this;}_createClass(RevisionReportsLayout,[{key:"toggleMenu",value:function toggleMenu(){var view=this.props.menu.view;return view===true?this.props.hideMenu():this.props.showMenu();}},{key:"filterChange",value:function filterChange(e){return this.setState({filterType:e.target.value});}},{key:"stateChange",value:function stateChange(state){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(this.props.location.pathname,'/',5);url[4]=state;url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');return this.props.history.push(url);}},{key:"municipalityFilter",value:function municipalityFilter(municipality){return this.setState({modState:municipality});}},{key:"municipalityChange",value:function municipalityChange(municipality){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(this.props.location.pathname,'/',6);url[4]=this.state.modState;url[5]=municipality;url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');return this.props.history.push(url);}},{key:"setAgencyName",value:function setAgencyName(mod,agencies){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality;var agency=undefined;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agencies)){switch(mod){case'modalidad-i':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-i'],{agenciable_short:state});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;case'modalidad-ii':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-ii'],{agenciable_slug:municipality});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;case'modalidad-iii':agency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies['modalidad-iii'],{agenciable_short:state});return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agency)&&agency.agenciable_name;default:return undefined;}}else{return null;}}}]);return RevisionReportsLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_1__secure__["a" /* default */])(RevisionReportsLayout);});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EntityAdd=function(_Component){_inherits(EntityAdd,_Component);function EntityAdd(){_classCallCheck(this,EntityAdd);return _possibleConstructorReturn(this,(EntityAdd.__proto__||Object.getPrototypeOf(EntityAdd)).apply(this,arguments));}_createClass(EntityAdd,[{key:'render',value:function render(){var entities=this.props.entities;var ec=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(entities.permissions,function(o){return o==='Create';});return ec?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/entidades/crear',className:'button is-small is-inm-purple'},'Agregar Entidad')):'';}}]);return EntityAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(EntityAdd));

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MunicipalityAdd=function(_Component){_inherits(MunicipalityAdd,_Component);function MunicipalityAdd(){_classCallCheck(this,MunicipalityAdd);return _possibleConstructorReturn(this,(MunicipalityAdd.__proto__||Object.getPrototypeOf(MunicipalityAdd)).apply(this,arguments));}_createClass(MunicipalityAdd,[{key:'render',value:function render(){var municipalities=this.props.municipalities;var mc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(municipalities.permissions,function(o){return o==='Create';});return mc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/municipios/crear',className:'button is-small is-inm-purple'},'Agregar Municipio')):'';}}]);return MunicipalityAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(MunicipalityAdd));

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AgenciesAdd=function(_Component){_inherits(AgenciesAdd,_Component);function AgenciesAdd(){_classCallCheck(this,AgenciesAdd);return _possibleConstructorReturn(this,(AgenciesAdd.__proto__||Object.getPrototypeOf(AgenciesAdd)).apply(this,arguments));}_createClass(AgenciesAdd,[{key:'render',value:function render(){var agencies=this.props.agencies;var ac=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(agencies.permissions,function(o){return o==='Create';});return ac?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/instancias/crear',className:'button is-small is-inm-purple'},'Agregar Instancia')):'';}}]);return AgenciesAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(AgenciesAdd));

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AmountsAgenciesAdd=function(_Component){_inherits(AmountsAgenciesAdd,_Component);function AmountsAgenciesAdd(){_classCallCheck(this,AmountsAgenciesAdd);return _possibleConstructorReturn(this,(AmountsAgenciesAdd.__proto__||Object.getPrototypeOf(AmountsAgenciesAdd)).apply(this,arguments));}_createClass(AmountsAgenciesAdd,[{key:'render',value:function render(){var amounts_agencies=this.props.amounts_agencies;var ac=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(amounts_agencies.permissions,function(o){return o==='Create';});return ac?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/instancias/montos/crear',className:'button is-small is-inm-purple'},'Agregar Monto de Instancia')):'';}}]);return AmountsAgenciesAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(AmountsAgenciesAdd));

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationAdd=function(_Component){_inherits(NotificationAdd,_Component);function NotificationAdd(){_classCallCheck(this,NotificationAdd);return _possibleConstructorReturn(this,(NotificationAdd.__proto__||Object.getPrototypeOf(NotificationAdd)).apply(this,arguments));}_createClass(NotificationAdd,[{key:'render',value:function render(){var notifications_types=this.props.notifications_types;var nc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(notifications_types.permissions,function(o){return o==='Create';});return nc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/notificaciones/crear',className:'button is-small is-inm-purple'},'Agregar notificación')):'';}}]);return NotificationAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(NotificationAdd));

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from 'lodash';
var SurveysAdd=function(_Component){_inherits(SurveysAdd,_Component);function SurveysAdd(){_classCallCheck(this,SurveysAdd);return _possibleConstructorReturn(this,(SurveysAdd.__proto__||Object.getPrototypeOf(SurveysAdd)).apply(this,arguments));}_createClass(SurveysAdd,[{key:'render',value:function render(){//const {goals} =this.props;
//let gc = _.find(goals.permissions, (o) => {return o==='Create'});
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/encuestas/crear',className:'button is-small is-inm-purple'},'Agregar encuesta'));}}]);return SurveysAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(SurveysAdd));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(802);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  thousandSeparator: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf([true])]),
  thousandSpacing: _propTypes2.default.oneOf(['2', '2s', '3', '4']),
  decimalSeparator: _propTypes2.default.string,
  decimalScale: _propTypes2.default.number,
  fixedDecimalScale: _propTypes2.default.bool,
  displayType: _propTypes2.default.oneOf(['input', 'text']),
  prefix: _propTypes2.default.string,
  suffix: _propTypes2.default.string,
  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  removeFormatting: _propTypes2.default.func,
  mask: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  isNumericString: _propTypes2.default.bool,
  customInput: _propTypes2.default.func,
  allowNegative: _propTypes2.default.bool,
  onValueChange: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  type: _propTypes2.default.oneOf(['text', 'tel']),
  isAllowed: _propTypes2.default.func,
  renderText: _propTypes2.default.func
};

var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandSpacing: '3',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  isNumericString: false,
  type: 'text',
  onValueChange: _utils.noop,
  onChange: _utils.noop,
  onKeyDown: _utils.noop,
  onMouseUp: _utils.noop,
  onFocus: _utils.noop,
  onBlur: _utils.noop,
  isAllowed: _utils.returnTrue
};

var CurrencyFormat = function (_React$Component) {
  _inherits(CurrencyFormat, _React$Component);

  function CurrencyFormat(props) {
    _classCallCheck(this, CurrencyFormat);

    //validate props
    var _this = _possibleConstructorReturn(this, (CurrencyFormat.__proto__ || Object.getPrototypeOf(CurrencyFormat)).call(this, props));

    _this.validateProps();

    var formattedValue = _this.formatValueProp();

    _this.state = {
      value: formattedValue,
      numAsString: _this.removeFormatting(formattedValue)
    };

    _this.onChange = _this.onChange.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    return _this;
  }

  _createClass(CurrencyFormat, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.updateValueIfRequired(prevProps);
    }
  }, {
    key: 'updateValueIfRequired',
    value: function updateValueIfRequired(prevProps) {
      var props = this.props,
          state = this.state;


      if (prevProps !== props) {
        //validate props
        this.validateProps();

        var stateValue = state.value;

        var lastNumStr = state.numAsString || '';

        var formattedValue = props.value === undefined ? this.formatNumString(lastNumStr) : this.formatValueProp();

        if (formattedValue !== stateValue) {
          this.setState({
            value: formattedValue,
            numAsString: this.removeFormatting(formattedValue)
          });
        }
      }
    }

    /** Misc methods **/

  }, {
    key: 'getFloatString',
    value: function getFloatString() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _getSeparators = this.getSeparators(),
          decimalSeparator = _getSeparators.decimalSeparator;

      var numRegex = this.getNumberRegex(true);

      //remove negation for regex check
      var hasNegation = num[0] === '-';
      if (hasNegation) num = num.replace('-', '');

      num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

      //remove extra decimals
      var firstDecimalIndex = num.indexOf('.');

      if (firstDecimalIndex !== -1) {
        num = num.substring(0, firstDecimalIndex) + '.' + num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, _utils.escapeRegExp)(decimalSeparator), 'g'), '');
      }

      //add negation back
      if (hasNegation) num = '-' + num;

      return num;
    }

    //returned regex assumes decimalSeparator is as per prop

  }, {
    key: 'getNumberRegex',
    value: function getNumberRegex(g, ignoreDecimalSeparator) {
      var _props = this.props,
          format = _props.format,
          decimalScale = _props.decimalScale;

      var _getSeparators2 = this.getSeparators(),
          decimalSeparator = _getSeparators2.decimalSeparator;

      return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, _utils.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
    }
  }, {
    key: 'getSeparators',
    value: function getSeparators() {
      var _props2 = this.props,
          decimalSeparator = _props2.decimalSeparator,
          thousandSpacing = _props2.thousandSpacing;
      var thousandSeparator = this.props.thousandSeparator;


      if (thousandSeparator === true) {
        thousandSeparator = ',';
      }

      return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        thousandSpacing: thousandSpacing
      };
    }
  }, {
    key: 'getMaskAtIndex',
    value: function getMaskAtIndex(index) {
      var _props$mask = this.props.mask,
          mask = _props$mask === undefined ? ' ' : _props$mask;

      if (typeof mask === 'string') {
        return mask;
      }

      return mask[index] || ' ';
    }
  }, {
    key: 'validateProps',
    value: function validateProps() {
      var mask = this.props.mask;

      //validate decimalSeparator and thousandSeparator

      var _getSeparators3 = this.getSeparators(),
          decimalSeparator = _getSeparators3.decimalSeparator,
          thousandSeparator = _getSeparators3.thousandSeparator;

      if (decimalSeparator === thousandSeparator) {
        throw new Error('\n          Decimal separator can\'t be same as thousand separator.\n\n          thousandSeparator: ' + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n          decimalSeparator: ' + decimalSeparator + ' (default value for decimalSeparator is .)\n       ');
      }

      //validate mask
      if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) {
          throw new Error('\n          Mask ' + mask + ' should not contain numeric character;\n        ');
        }
      }
    }
  }, {
    key: 'splitDecimal',
    value: function splitDecimal(numStr) {
      var allowNegative = this.props.allowNegative;

      var hasNagation = numStr[0] === '-';
      var addNegation = hasNagation && allowNegative;
      numStr = numStr.replace('-', '');

      var parts = numStr.split('.');
      var beforeDecimal = parts[0];
      var afterDecimal = parts[1] || '';

      return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNagation: hasNagation,
        addNegation: addNegation
      };
    }

    /** Misc methods end **/

    /** caret specific methods **/

  }, {
    key: 'setPatchedCaretPosition',
    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
      /* setting caret position within timeout of 0ms is required for mobile chrome,
      otherwise browser resets the caret position after we set it
      We are also setting it without timeout so that in normal browser we don't see the flickering */
      (0, _utils.setCaretPosition)(el, caretPos);
      setTimeout(function () {
        if (el.value === currentValue) (0, _utils.setCaretPosition)(el, caretPos);
      }, 0);
    }

    /* This keeps the caret within typing area so people can't type in between prefix or suffix */

  }, {
    key: 'correctCaretPosition',
    value: function correctCaretPosition(value, caretPos, direction) {
      var _props3 = this.props,
          prefix = _props3.prefix,
          suffix = _props3.suffix,
          format = _props3.format;

      //in case of format as number limit between prefix and suffix

      if (!format) {
        var hasNegation = value[0] === '-';
        return Math.min(Math.max(caretPos, prefix.length + (hasNegation ? 1 : 0)), value.length - suffix.length);
      }

      //in case if custom format method don't do anything
      if (typeof format === 'function') return caretPos;

      /* in case format is string find the closest # position from the caret position */

      //in case the caretPos have input value on it don't do anything
      if (format[caretPos] === '#' && (0, _utils.charIsNumber)(value[caretPos])) return caretPos;

      //if caretPos is just after input value don't do anything
      if (format[caretPos - 1] === '#' && (0, _utils.charIsNumber)(value[caretPos - 1])) return caretPos;

      //find the nearest caret position
      var firstHashPosition = format.indexOf('#');
      var lastHashPosition = format.lastIndexOf('#');

      //limit the cursor between the first # position and the last # position
      caretPos = Math.min(Math.max(caretPos, firstHashPosition), lastHashPosition + 1);

      var nextPos = format.substring(caretPos, format.length).indexOf('#');
      var caretLeftBound = caretPos;
      var caretRightBoud = caretPos + (nextPos === -1 ? 0 : nextPos);

      //get the position where the last number is present
      while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, _utils.charIsNumber)(value[caretLeftBound]))) {
        caretLeftBound -= 1;
      }

      var goToLeft = !(0, _utils.charIsNumber)(value[caretRightBoud]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBoud - caretPos;

      return goToLeft ? caretLeftBound + 1 : caretRightBoud;
    }
  }, {
    key: 'getCaretPosition',
    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
      var format = this.props.format;

      var stateValue = this.state.value;
      var numRegex = this.getNumberRegex(true);
      var inputNumber = (inputValue.match(numRegex) || []).join('');
      var formattedNumber = (formattedValue.match(numRegex) || []).join('');
      var j = void 0,
          i = void 0;

      j = 0;

      for (i = 0; i < caretPos; i++) {
        var currentInputChar = inputValue[i] || '';
        var currentFormatChar = formattedValue[j] || '';
        //no need to increase new cursor position if formatted value does not have those characters
        //case inputValue = 1a23 and formattedValue =  123
        if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue;

        //When we are striping out leading zeros maintain the new cursor position
        //Case inputValue = 00023 and formattedValue = 23;
        if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue;

        //we are not using currentFormatChar because j can change here
        while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
          j++;
        }j++;
      }

      if (typeof format === 'string' && !stateValue) {
        //set it to the maximum value so it goes after the last number
        j = formattedValue.length;
      }

      //correct caret position if its outside of editable area
      j = this.correctCaretPosition(formattedValue, j);

      return j;
    }
    /** caret specific methods ends **/

    /** methods to remove formattting **/

  }, {
    key: 'removePrefixAndSuffix',
    value: function removePrefixAndSuffix(val) {
      var _props4 = this.props,
          format = _props4.format,
          prefix = _props4.prefix,
          suffix = _props4.suffix;

      //remove prefix and suffix

      if (!format && val) {
        var isNegative = val[0] === '-';

        //remove negation sign
        if (isNegative) val = val.substring(1, val.length);

        //remove prefix
        val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

        //remove suffix
        var suffixLastIndex = val.lastIndexOf(suffix);
        val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;

        //add negation sign back
        if (isNegative) val = '-' + val;
      }

      return val;
    }
  }, {
    key: 'removePatternFormatting',
    value: function removePatternFormatting(val) {
      var format = this.props.format;

      var formatArray = format.split('#').filter(function (str) {
        return str !== '';
      });
      var start = 0;
      var numStr = '';

      for (var i = 0, ln = formatArray.length; i <= ln; i++) {
        var part = formatArray[i] || '';

        //if i is the last fragment take the index of end of the value
        //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
        var index = i === ln ? val.length : val.indexOf(part, start);

        /* in any case if we don't find the pattern part in the value assume the val as numeric string
        This will be also in case if user has started typing, in any other case it will not be -1
        unless wrong prop value is provided */
        if (index === -1) {
          numStr = val;
          break;
        } else {
          numStr += val.substring(start, index);
          start = index + part.length;
        }
      }

      return (numStr.match(/\d/g) || []).join('');
    }
  }, {
    key: 'removeFormatting',
    value: function removeFormatting(val) {
      var _props5 = this.props,
          format = _props5.format,
          removeFormatting = _props5.removeFormatting;

      if (!val) return val;

      if (!format) {
        val = this.removePrefixAndSuffix(val);
        val = this.getFloatString(val);
      } else if (typeof format === 'string') {
        val = this.removePatternFormatting(val);
      } else if (typeof removeFormatting === 'function') {
        //condition need to be handled if format method is provide,
        val = removeFormatting(val);
      } else {
        val = (val.match(/\d/g) || []).join('');
      }
      return val;
    }
    /** methods to remove formattting end **/

    /*** format specific methods start ***/
    /**
     * Format when # based string is provided
     * @param  {string} numStr Numeric String
     * @return {string}        formatted Value
     */

  }, {
    key: 'formatWithPattern',
    value: function formatWithPattern(numStr) {
      var format = this.props.format;

      var hashCount = 0;
      var formattedNumberAry = format.split('');
      for (var i = 0, ln = format.length; i < ln; i++) {
        if (format[i] === '#') {
          formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
          hashCount += 1;
        }
      }
      return formattedNumberAry.join('');
    }
    /**
     * Format the given string according to thousand separator and thousand spacing
     * @param {*} beforeDecimal 
     * @param {*} thousandSeparator 
     * @param {*} thousandSpacing 
     */

  }, {
    key: 'formatThousand',
    value: function formatThousand(beforeDecimal, thousandSeparator, thousandSpacing) {
      var digitalGroup = void 0;
      switch (thousandSpacing) {
        case _utils.thousandGroupSpacing.two:
          digitalGroup = /(\d)(?=(\d{2})+(?!\d))/g;
          break;
        case _utils.thousandGroupSpacing.twoScaled:
          digitalGroup = /(\d)(?=(((\d{2})+)(\d{1})(?!\d)))/g;
          break;
        case _utils.thousandGroupSpacing.four:
          digitalGroup = /(\d)(?=(\d{4})+(?!\d))/g;
          break;
        default:
          digitalGroup = /(\d)(?=(\d{3})+(?!\d))/g;
      }

      return beforeDecimal.replace(digitalGroup, '$1' + thousandSeparator);
    }
    /**
     * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
     * @return {string} formatted Value
     */

  }, {
    key: 'formatAsNumber',
    value: function formatAsNumber(numStr) {
      var _props6 = this.props,
          decimalScale = _props6.decimalScale,
          fixedDecimalScale = _props6.fixedDecimalScale,
          prefix = _props6.prefix,
          suffix = _props6.suffix;

      var _getSeparators4 = this.getSeparators(),
          thousandSeparator = _getSeparators4.thousandSeparator,
          decimalSeparator = _getSeparators4.decimalSeparator,
          thousandSpacing = _getSeparators4.thousandSpacing;

      var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;

      var _splitDecimal = this.splitDecimal(numStr),
          beforeDecimal = _splitDecimal.beforeDecimal,
          afterDecimal = _splitDecimal.afterDecimal,
          addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const

      //apply decimal precision if its defined


      if (decimalScale !== undefined) afterDecimal = (0, _utils.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);

      if (thousandSeparator) {
        beforeDecimal = this.formatThousand(beforeDecimal, thousandSeparator, thousandSpacing);
      }

      //add prefix and suffix
      if (prefix) beforeDecimal = prefix + beforeDecimal;
      if (suffix) afterDecimal = afterDecimal + suffix;

      //restore negation sign
      if (addNegation) beforeDecimal = '-' + beforeDecimal;

      numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;

      return numStr;
    }
  }, {
    key: 'formatNumString',
    value: function formatNumString() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var format = this.props.format;

      var formattedValue = value;

      if (value === '') {
        formattedValue = '';
      } else if (value === '-' && !format) {
        formattedValue = '-';
        value = '';
      } else if (typeof format === 'string') {
        formattedValue = this.formatWithPattern(formattedValue);
      } else if (typeof format === 'function') {
        formattedValue = format(formattedValue);
      } else {
        formattedValue = this.formatAsNumber(formattedValue);
      }

      return formattedValue;
    }
  }, {
    key: 'formatValueProp',
    value: function formatValueProp() {
      var _props7 = this.props,
          format = _props7.format,
          decimalScale = _props7.decimalScale,
          fixedDecimalScale = _props7.fixedDecimalScale;
      var _props8 = this.props,
          value = _props8.value,
          isNumericString = _props8.isNumericString;

      // if value is not defined return empty string

      if (value === undefined) return '';

      if (typeof value === 'number') {
        value = value.toString();
        isNumericString = true;
      }

      //round the number based on decimalScale
      //format only if non formatted value is provided
      if (isNumericString && !format && typeof decimalScale === 'number') {
        value = (0, _utils.roundToPrecision)(value, decimalScale, fixedDecimalScale);
      }

      var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

      return formattedValue;
    }
  }, {
    key: 'formatNegation',
    value: function formatNegation() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var allowNegative = this.props.allowNegative;

      var negationRegex = new RegExp('(-)');
      var doubleNegationRegex = new RegExp('(-)(.)*(-)');

      // Check number has '-' value
      var hasNegation = negationRegex.test(value);

      // Check number has 2 or more '-' values
      var removeNegation = doubleNegationRegex.test(value);

      //remove negation
      value = value.replace(/-/g, '');

      if (hasNegation && !removeNegation && allowNegative) {
        value = '-' + value;
      }

      return value;
    }
  }, {
    key: 'formatInput',
    value: function formatInput() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var format = this.props.format;

      //format negation only if we are formatting as number

      if (!format) {
        value = this.formatNegation(value);
      }

      //remove formatting from number
      value = this.removeFormatting(value);

      return this.formatNumString(value);
    }

    /*** format specific methods end ***/

  }, {
    key: 'isCharacterAFormat',
    value: function isCharacterAFormat(caretPos, value) {
      var _props9 = this.props,
          format = _props9.format,
          prefix = _props9.prefix,
          suffix = _props9.suffix,
          decimalScale = _props9.decimalScale,
          fixedDecimalScale = _props9.fixedDecimalScale;

      var _getSeparators5 = this.getSeparators(),
          decimalSeparator = _getSeparators5.decimalSeparator;

      //check within format pattern


      if (typeof format === 'string' && format[caretPos] !== '#') return true;

      //check in number format
      if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'checkIfFormatGotDeleted',
    value: function checkIfFormatGotDeleted(start, end, value) {
      for (var i = start; i < end; i++) {
        if (this.isCharacterAFormat(i, value)) return true;
      }
      return false;
    }

    /**
     * This will check if any formatting got removed by the delete or backspace and reset the value
     * It will also work as fallback if android chome keyDown handler does not work
     **/

  }, {
    key: 'correctInputValue',
    value: function correctInputValue(caretPos, lastValue, value) {
      var format = this.props.format;

      var lastNumStr = this.state.numAsString || '';

      //don't do anyhting if something got added, or if value is empty string (when whole input is cleared)
      if (value.length >= lastValue.length || !value.length) {
        return value;
      }

      var start = caretPos;
      var lastValueParts = (0, _utils.splitString)(lastValue, caretPos);
      var newValueParts = (0, _utils.splitString)(value, caretPos);
      var deletedIndex = lastValueParts[1].lastIndexOf(newValueParts[1]);
      var diff = deletedIndex !== -1 ? lastValueParts[1].substring(0, deletedIndex) : '';
      var end = start + diff.length;

      //if format got deleted reset the value to last value
      if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
        value = lastValue;
      }

      //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
      //clear all numbers in such case while keeping the - sign
      if (!format) {
        var numericString = this.removeFormatting(value);

        var _splitDecimal2 = this.splitDecimal(numericString),
            beforeDecimal = _splitDecimal2.beforeDecimal,
            afterDecimal = _splitDecimal2.afterDecimal,
            addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const

        //clear only if something got deleted


        if (numericString.length < lastNumStr.length && beforeDecimal === '' && !parseFloat(afterDecimal)) {
          return addNegation ? '-' : '';
        }
      }

      return value;
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      e.persist();
      var el = e.target;
      var inputValue = el.value;
      var state = this.state,
          props = this.props;
      var isAllowed = props.isAllowed;

      var lastValue = state.value || '';

      /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
      var currentCaretPosition = Math.max(el.selectionStart, el.selectionEnd);

      inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

      var formattedValue = this.formatInput(inputValue) || '';
      var numAsString = this.removeFormatting(formattedValue);

      var valueObj = {
        formattedValue: formattedValue,
        value: numAsString,
        floatValue: parseFloat(numAsString)
      };

      if (!isAllowed(valueObj)) {
        formattedValue = lastValue;
      }

      //set the value imperatively, this is required for IE fix
      el.value = formattedValue;

      //get the caret position
      var caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);

      //set caret position
      this.setPatchedCaretPosition(el, caretPos, formattedValue);

      //change the state
      if (formattedValue !== lastValue) {
        this.setState({ value: formattedValue, numAsString: numAsString }, function () {
          props.onValueChange(valueObj);
          props.onChange(e);
        });
      } else {
        props.onChange(e);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var props = this.props,
          state = this.state;
      var format = props.format,
          onBlur = props.onBlur;
      var numAsString = state.numAsString;

      var lastValue = state.value;
      if (!format) {
        numAsString = (0, _utils.fixLeadingZero)(numAsString);
        var formattedValue = this.formatNumString(numAsString);
        var valueObj = {
          formattedValue: formattedValue,
          value: numAsString,
          floatValue: parseFloat(numAsString)
        };

        //change the state
        if (formattedValue !== lastValue) {
          // the event needs to be persisted because its properties can be accessed in an asynchronous way
          e.persist();
          this.setState({ value: formattedValue, numAsString: numAsString }, function () {
            props.onValueChange(valueObj);
            onBlur(e);
          });
          return;
        }
      }
      onBlur(e);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var el = e.target;
      var key = e.key;
      var selectionEnd = el.selectionEnd,
          value = el.value;
      var selectionStart = el.selectionStart;

      var expectedCaretPosition = void 0;
      var _props10 = this.props,
          decimalScale = _props10.decimalScale,
          fixedDecimalScale = _props10.fixedDecimalScale,
          prefix = _props10.prefix,
          suffix = _props10.suffix,
          format = _props10.format,
          onKeyDown = _props10.onKeyDown;

      var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
      var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
      var negativeRegex = new RegExp('-');
      var isPatternFormat = typeof format === 'string';

      //Handle backspace and delete against non numerical/decimal characters or arrow keys
      if (key === 'ArrowLeft' || key === 'Backspace') {
        expectedCaretPosition = selectionStart - 1;
      } else if (key === 'ArrowRight') {
        expectedCaretPosition = selectionStart + 1;
      } else if (key === 'Delete') {
        expectedCaretPosition = selectionStart;
      }

      //if expectedCaretPosition is not set it means we don't want to Handle keyDown
      //also if multiple characters are selected don't handle
      if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
        onKeyDown(e);
        return;
      }

      var newCaretPosition = expectedCaretPosition;
      var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
      var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

      if (key === 'ArrowLeft' || key === 'ArrowRight') {
        var direction = key === 'ArrowLeft' ? 'left' : 'right';
        newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
      } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
          newCaretPosition++;
        }
      } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }

      if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
        e.preventDefault();
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
              Remove this when you find different solution */
      if (e.isUnitTestRun) {
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      this.props.onKeyDown(e);
    }

    /** required to handle the caret position when click anywhere within the input **/

  }, {
    key: 'onMouseUp',
    value: function onMouseUp(e) {
      var el = e.target;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          value = el.value;


      if (selectionStart === selectionEnd) {
        var caretPostion = this.correctCaretPosition(value, selectionStart);
        if (caretPostion !== selectionStart) {
          this.setPatchedCaretPosition(el, caretPostion, value);
        }
      }

      this.props.onMouseUp(e);
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      var _this2 = this;

      // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
      // (onFocus event target selectionStart is always 0 before setTimeout)
      e.persist();
      setTimeout(function () {
        var el = e.target;
        var selectionStart = el.selectionStart,
            value = el.value;


        var caretPosition = _this2.correctCaretPosition(value, selectionStart);
        if (caretPosition !== selectionStart) {
          _this2.setPatchedCaretPosition(el, caretPosition, value);
        }

        _this2.props.onFocus(e);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props11 = this.props,
          type = _props11.type,
          displayType = _props11.displayType,
          customInput = _props11.customInput,
          renderText = _props11.renderText;
      var value = this.state.value;


      var otherProps = (0, _utils.omit)(this.props, propTypes);

      var inputProps = _extends({}, otherProps, {
        type: type,
        value: value,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onMouseUp: this.onMouseUp,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      });

      if (displayType === 'text') {
        return renderText ? renderText(value) || null : _react2.default.createElement(
          'span',
          otherProps,
          value
        );
      } else if (customInput) {
        var CustomInput = customInput;
        return _react2.default.createElement(CustomInput, inputProps);
      }

      return _react2.default.createElement('input', inputProps);
    }
  }]);

  return CurrencyFormat;
}(_react2.default.Component);

CurrencyFormat.propTypes = propTypes;
CurrencyFormat.defaultProps = defaultProps;

module.exports = CurrencyFormat;

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LabelDetail=function LabelDetail(props){var title=props.title,description=props.description;title=title==='null'?'':title;description=description==='null'?'':description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'description'},description));};/* harmony default export */ __webpack_exports__["a"] = (LabelDetail);

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(271);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(72);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(98);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(289)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(99);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(72);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(73);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(98);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(174);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(307);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(320);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(319);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(313);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(183);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(100);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_inm.27cc5dd4.svg";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFieldActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _batchActions = __webpack_require__(103);

var _batchActions2 = _interopRequireDefault(_batchActions);

var _getValidity = __webpack_require__(105);

var _getValidity2 = _interopRequireDefault(_getValidity);

var _isValidityValid = __webpack_require__(186);

var _isValidityValid2 = _interopRequireDefault(_isValidityValid);

var _isValidityInvalid = __webpack_require__(106);

var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);

var _invertValidity = __webpack_require__(107);

var _invertValidity2 = _interopRequireDefault(_invertValidity);

var _track = __webpack_require__(75);

var _getForm = __webpack_require__(79);

var _getForm2 = _interopRequireDefault(_getForm);

var _getFieldFromState = __webpack_require__(58);

var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);

var _nullAction = __webpack_require__(77);

var _nullAction2 = _interopRequireDefault(_nullAction);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStrategies = {
  get: _get3.default,
  getForm: _getForm2.default,
  getFieldFromState: _getFieldFromState2.default
};

function createFieldActions() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategies;

  var addIntent = function addIntent(model, intent) {
    return {
      type: _actionTypes2.default.ADD_INTENT,
      model: model,
      intent: intent
    };
  };

  var clearIntents = function clearIntents(model, intents) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return {
      type: _actionTypes2.default.CLEAR_INTENTS,
      model: model,
      intents: intents,
      options: options
    };
  };

  var focus = function focus(model, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _extends({
      type: _actionTypes2.default.FOCUS,
      model: model,
      value: value
    }, options);
  };

  var silentFocus = function silentFocus(model, value) {
    return focus(model, value, {
      silent: true
    });
  };

  var blur = function blur(model) {
    return {
      type: _actionTypes2.default.BLUR,
      model: model
    };
  };

  var setPristine = function setPristine(model) {
    return {
      type: _actionTypes2.default.SET_PRISTINE,
      model: model
    };
  };

  var setDirty = function setDirty(model) {
    return {
      type: _actionTypes2.default.SET_DIRTY,
      model: model
    };
  };

  var setInitial = function setInitial(model) {
    return {
      type: _actionTypes2.default.SET_INITIAL,
      model: model
    };
  };

  var setPending = function setPending(model) {
    var pending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var options = arguments[2];
    return _extends({
      type: _actionTypes2.default.SET_PENDING,
      model: model,
      pending: pending
    }, options);
  };

  var setValidating = function setValidating(model) {
    var validating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return {
      type: _actionTypes2.default.SET_VALIDATING,
      model: model,
      validating: validating
    };
  };

  var setValidity = function setValidity(model, validity) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _extends({
      type: options.errors ? _actionTypes2.default.SET_ERRORS : _actionTypes2.default.SET_VALIDITY,
      model: model
    }, options, _defineProperty({}, options.errors ? 'errors' : 'validity', validity));
  };

  var resetValidity = function resetValidity(model) {
    var omitKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
      type: _actionTypes2.default.RESET_VALIDITY,
      model: model,
      omitKeys: omitKeys
    };
  };

  var setFieldsValidity = function setFieldsValidity(model, fieldsValidity) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return {
      type: _actionTypes2.default.SET_FIELDS_VALIDITY,
      model: model,
      fieldsValidity: fieldsValidity,
      options: options
    };
  };

  var setErrors = function setErrors(model, errors) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return setValidity(model, errors, _extends({}, options, {
      errors: true
    }));
  };

  var setFieldsErrors = function setFieldsErrors(model, fieldsErrors, options) {
    return setFieldsValidity(model, fieldsErrors, _extends({}, options, {
      errors: true
    }));
  };

  var resetErrors = resetValidity;

  var setTouched = function setTouched(model) {
    return {
      type: _actionTypes2.default.SET_TOUCHED,
      model: model
    };
  };

  var setUntouched = function setUntouched(model) {
    return {
      type: _actionTypes2.default.SET_UNTOUCHED,
      model: model
    };
  };

  var asyncSetValidity = function asyncSetValidity(model, validator) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return function (dispatch, getState) {
      var value = s.get(getState(), model);

      dispatch(setValidating(model, true));

      var done = function done(validity) {
        dispatch(setValidity(model, validity, _extends({
          async: true
        }, options)));
      };

      var immediateResult = validator(value, done);

      if (typeof immediateResult !== 'undefined') {
        done(immediateResult);
      }
    };
  };

  var asyncSetErrors = function asyncSetErrors(model, validator) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return asyncSetValidity(model, validator, _extends({
      errors: true
    }, options));
  };

  var setSubmitted = function setSubmitted(model) {
    var submitted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return {
      type: _actionTypes2.default.SET_SUBMITTED,
      model: model,
      submitted: submitted
    };
  };

  var setSubmitFailed = function setSubmitFailed(model) {
    var submitFailed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var options = arguments[2];
    return _extends({
      type: _actionTypes2.default.SET_SUBMIT_FAILED,
      model: model,
      submitFailed: submitFailed
    }, options);
  };

  var submit = function submit(model, promise) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (typeof promise === 'undefined') {
      return addIntent(model, { type: 'submit' });
    }

    return function (dispatch, getState) {
      if (options.validate) {
        var form = s.getForm(getState(), model);

        (0, _invariant2.default)(form, 'Unable to submit form with validation. ' + 'Could not find form for "%s" in the store.', model);

        if (!form.$form.valid) {
          return dispatch(_nullAction2.default);
        }

        dispatch(setPending(model, true));
      } else if (options.validators || options.errors) {
        var validators = options.validators || options.errors;
        var isErrors = options.errors;
        var value = s.get(getState(), model);
        var validity = (0, _getValidity2.default)(validators, value);
        var valid = options.errors ? !(0, _isValidityInvalid2.default)(validity) : (0, _isValidityValid2.default)(validity);

        if (!valid) {
          return dispatch(isErrors ? setErrors(model, validity) : setValidity(model, validity));
        }

        dispatch((0, _batchActions2.default)(model, [setValidity(model, isErrors ? (0, _invertValidity2.default)(validity) : validity), setPending(model, true)]));
      } else {
        dispatch(setPending(model, true));
      }

      var errorsAction = options.fields ? setFieldsErrors : setErrors;

      promise.then(function (response) {
        dispatch((0, _batchActions2.default)(model, [setSubmitted(model, true), setValidity(model, response)]));
      }).catch(function (rejection) {
        var error = rejection instanceof Error ? rejection.message : rejection;

        dispatch((0, _batchActions2.default)(model, [setSubmitFailed(model), errorsAction(model, error, { async: true })]));
      });

      return promise;
    };
  };

  var submitFields = function submitFields(model, promise) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return submit(model, promise, _extends({}, options, {
      fields: true
    }));
  };

  var validSubmit = function validSubmit(model, promise) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return submit(model, promise, _extends({}, options, {
      validate: true
    }));
  };

  var validate = function validate(model, validators) {
    return function (dispatch, getState) {
      var value = s.get(getState(), model);
      var validity = (0, _getValidity2.default)(validators, value);

      dispatch(setValidity(model, validity));
    };
  };

  var validateErrors = function validateErrors(model, errorValidators) {
    return function (dispatch, getState) {
      var value = s.get(getState(), model);
      var errors = (0, _getValidity2.default)(errorValidators, value);

      dispatch(setValidity(model, errors, { errors: true }));
    };
  };

  var validateFields = function validateFields(model, fieldValidators) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return function (dispatch, getState) {
      var modelValue = s.get(getState(), model);

      var fieldsValidity = (0, _mapValues2.default)(fieldValidators, function (validator, field) {
        var fieldValue = field ? s.get(modelValue, field) : modelValue;

        var fieldValidity = (0, _getValidity2.default)(validator, fieldValue);

        return fieldValidity;
      });

      var fieldsValiditySetter = options.errors ? setFieldsErrors : setFieldsValidity;

      dispatch(fieldsValiditySetter(model, fieldsValidity));
    };
  };

  var validateFieldsErrors = function validateFieldsErrors(model, fieldErrorsValidators) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return validateFields(model, fieldErrorsValidators, _extends({}, options, {
      errors: true
    }));
  };

  return (0, _mapValues2.default)({
    blur: blur,
    focus: focus,
    silentFocus: silentFocus,
    submit: submit,
    submitFields: submitFields,
    validSubmit: validSubmit,
    setDirty: setDirty,
    setErrors: setErrors,
    setInitial: setInitial,
    setPending: setPending,
    setValidating: setValidating,
    setPristine: setPristine,
    setSubmitted: setSubmitted,
    setSubmitFailed: setSubmitFailed,
    setTouched: setTouched,
    setUntouched: setUntouched,
    setValidity: setValidity,
    setFieldsValidity: setFieldsValidity,
    setFieldsErrors: setFieldsErrors,
    resetValidity: resetValidity,
    resetErrors: resetErrors,
    validate: validate,
    validateErrors: validateErrors,
    validateFields: validateFields,
    validateFieldsErrors: validateFieldsErrors,
    asyncSetValidity: asyncSetValidity,
    asyncSetErrors: asyncSetErrors,
    addIntent: addIntent,
    clearIntents: clearIntents
  }, _track.trackable);
}

exports.createFieldActions = createFieldActions;
exports.default = createFieldActions();

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidityValid;

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidityValid(validity) {
  if ((0, _isPlainObject2.default)(validity)) {
    return Object.keys(validity).every(function (key) {
      return isValidityValid(validity[key]);
    });
  }

  return !!validity;
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
}

module.exports = toPath;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createControlClass = undefined;

var _actions = __webpack_require__(47);

var _actions2 = _interopRequireDefault(_actions);

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _getFieldFromState = __webpack_require__(58);

var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);

var _controlComponentFactory = __webpack_require__(340);

var _controlComponentFactory2 = _interopRequireDefault(_controlComponentFactory);

var _reactDom = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStrategy = {
  get: _get3.default,
  getFieldFromState: _getFieldFromState2.default,
  actions: _actions2.default,
  findDOMNode: _reactDom.findDOMNode
};

exports.createControlClass = _controlComponentFactory2.default;
exports.default = (0, _controlComponentFactory2.default)(defaultStrategy);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = containsEvent;
function containsEvent(events, event) {
  if (typeof events === 'string') {
    return events === event;
  }

  return !!~events.indexOf(event);
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareChildren = compareChildren;
exports.default = deepCompareChildren;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowCompare = __webpack_require__(347);

var _shallowCompare2 = _interopRequireDefault(_shallowCompare);

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function compareChildren(props, nextProps) {
  var children = props.children;
  var nextChildren = nextProps.children;

  // If the number of children changed, then children are different.
  // If there are no children, use shallowCompare in parent function
  // to determine if component should update (false && true == false)

  if (_react2.default.Children.count(children) !== _react2.default.Children.count(nextChildren) || !_react2.default.Children.count(children) || !_react2.default.Children.count(nextChildren)) {
    return true;
  }

  var childrenArray = _react2.default.Children.toArray(children);
  var nextChildrenArray = _react2.default.Children.toArray(nextChildren);

  // React.Children.toArray strip's `false` children so lengths
  // can change
  if (childrenArray.length !== nextChildrenArray.length) {
    return false;
  }

  return [].concat(childrenArray).some(function (child, i) {
    var nextChild = nextChildrenArray[i];

    if (!child.props || !nextChild.props) {
      return !(0, _shallowEqual2.default)(child, nextChild);
    }

    /* eslint-disable no-use-before-define */
    return deepCompareChildren(child, nextChild.props, nextChild.state);
  });
}

function deepCompareChildren(instance, nextProps, nextState) {
  if (!instance.props.children) return (0, _shallowCompare2.default)(instance, nextProps, nextState);

  return (0, _shallowCompare2.default)(instance, nextProps, nextState) || compareChildren(instance.props, nextProps);
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFormClass = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(24);

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _omit = __webpack_require__(49);

var _omit2 = _interopRequireDefault(_omit);

var _actions = __webpack_require__(47);

var _actions2 = _interopRequireDefault(_actions);

var _getValidity = __webpack_require__(105);

var _getValidity2 = _interopRequireDefault(_getValidity);

var _invertValidators = __webpack_require__(350);

var _invertValidators2 = _interopRequireDefault(_invertValidators);

var _isValidityInvalid = __webpack_require__(106);

var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);

var _isValid = __webpack_require__(60);

var _isValid2 = _interopRequireDefault(_isValid);

var _getForm = __webpack_require__(79);

var _getForm2 = _interopRequireDefault(_getForm);

var _getModel = __webpack_require__(59);

var _getModel2 = _interopRequireDefault(_getModel);

var _getField = __webpack_require__(351);

var _getField2 = _interopRequireDefault(_getField);

var _deepCompareChildren = __webpack_require__(190);

var _deepCompareChildren2 = _interopRequireDefault(_deepCompareChildren);

var _containsEvent = __webpack_require__(189);

var _containsEvent2 = _interopRequireDefault(_containsEvent);

var _mergeValidity = __webpack_require__(192);

var _mergeValidity2 = _interopRequireDefault(_mergeValidity);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  validators: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  errors: _propTypes2.default.object,
  validateOn: _propTypes2.default.oneOf(['change', 'submit']),
  model: _propTypes2.default.string.isRequired,
  modelValue: _propTypes2.default.any,
  formValue: _propTypes2.default.object,
  onSubmit: _propTypes2.default.func,
  onSubmitFailed: _propTypes2.default.func,
  dispatch: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  store: _propTypes2.default.shape({
    subscribe: _propTypes2.default.func,
    dispatch: _propTypes2.default.func,
    getState: _propTypes2.default.func
  }),
  storeSubscription: _propTypes2.default.any,
  onUpdate: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  getRef: _propTypes2.default.func,
  getDispatch: _propTypes2.default.func,
  onBeforeSubmit: _propTypes2.default.func,
  hideNativeErrors: _propTypes2.default.bool,

  // standard HTML attributes
  action: _propTypes2.default.string,
  noValidate: _propTypes2.default.bool
};

var htmlAttributes = ['action', 'noValidate'];
var disallowedPropTypeKeys = Object.keys(propTypes).filter(function (key) {
  return htmlAttributes.indexOf(key) === -1;
});

var defaultStrategy = {
  get: _get3.default,
  getForm: _getForm2.default,
  actions: _actions2.default
};

function createFormClass() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;

  var Form = function (_Component) {
    _inherits(Form, _Component);

    function Form(props) {
      _classCallCheck(this, Form);

      var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

      _this.handleSubmit = _this.handleSubmit.bind(_this);
      _this.handleReset = _this.handleReset.bind(_this);
      _this.handleValidSubmit = _this.handleValidSubmit.bind(_this);
      _this.handleInvalidSubmit = _this.handleInvalidSubmit.bind(_this);
      _this.attachNode = _this.attachNode.bind(_this);

      _this.state = {
        lastSubmitEvent: null
      };
      return _this;
    }

    _createClass(Form, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          model: this.props.model,
          localStore: this.props.store
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if ((0, _containsEvent2.default)(this.props.validateOn, 'change')) {
          this.validate(this.props, true);
        }

        if (this.props.getDispatch) {
          this.props.getDispatch(this.props.dispatch);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if ((0, _containsEvent2.default)(nextProps.validateOn, 'change')) {
          this.validate(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return (0, _deepCompareChildren2.default)(this, nextProps, nextState);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        this.handleIntents();

        if (!(0, _shallowEqual2.default)(prevProps.formValue, this.props.formValue)) {
          this.handleUpdate();
        }

        if (!(0, _shallowEqual2.default)(prevProps.modelValue, this.props.modelValue)) {
          this.handleChange();
        }
      }
    }, {
      key: 'handleUpdate',
      value: function handleUpdate() {
        if (this.props.onUpdate) {
          this.props.onUpdate(this.props.formValue);
        }
      }
    }, {
      key: 'handleChange',
      value: function handleChange() {
        if (this.props.onChange) {
          this.props.onChange(this.props.modelValue);
        }
      }
    }, {
      key: 'attachNode',
      value: function attachNode(node) {
        if (!node) return;

        this._node = node;

        this._node.submit = this.handleSubmit;
        if (this.props.getRef) this.props.getRef(node);
      }
    }, {
      key: 'validate',
      value: function validate(nextProps) {
        var _this2 = this;

        var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var submit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var _props = this.props,
            model = _props.model,
            dispatch = _props.dispatch,
            formValue = _props.formValue,
            modelValue = _props.modelValue;
        var validators = nextProps.validators,
            errors = nextProps.errors;


        if (!formValue) return;

        if (!validators && !errors && modelValue !== nextProps.modelValue) {
          return;
        }

        var validatorsChanged = validators !== this.props.validators || errors !== this.props.errors;
        var fieldKeys = (validators ? Object.keys(validators) : []).concat(errors ? Object.keys(errors) : []);

        var fieldsErrors = {};
        var validityChanged = false;

        var keysToValidate = [];

        fieldKeys.forEach(function (key) {
          if (!!~keysToValidate.indexOf(key)) return;

          var valuesChanged = key === '' ? modelValue !== nextProps.modelValue : s.get(modelValue, key) !== s.get(nextProps.modelValue, key);

          if (submit || initial || valuesChanged || validators && _this2.props.validators[key] !== validators[key] || errors && _this2.props.errors[key] !== errors[key] || !!~key.indexOf('[]')) {
            keysToValidate.push(key);
          }
        });

        var validateField = function validateField(field, errorValidator) {
          if (!!~field.indexOf('[]')) {
            var _field$split = field.split('[]'),
                _field$split2 = _slicedToArray(_field$split, 2),
                parentModel = _field$split2[0],
                childModel = _field$split2[1];

            var nextValue = parentModel ? s.get(nextProps.modelValue, parentModel) : nextProps.modelValue;

            nextValue.forEach(function (subValue, index) {
              validateField(parentModel + '[' + index + ']' + childModel, errorValidator);
            });
          } else {
            var _nextValue = field ? s.get(nextProps.modelValue, field) : nextProps.modelValue;

            var currentErrors = (0, _getField2.default)(formValue, field).errors;
            var fieldErrors = (0, _getValidity2.default)(errorValidator, _nextValue);

            if (!validityChanged && !(0, _shallowEqual2.default)(fieldErrors, currentErrors)) {
              validityChanged = true;
            }

            fieldsErrors[field] = (0, _mergeValidity2.default)(fieldsErrors[field], fieldErrors);
          }
        };

        keysToValidate.forEach(function (field) {
          if (validators && validators[field]) {
            validateField(field, (0, _invertValidators2.default)(validators[field]));
          }
          if (errors && errors[field]) {
            validateField(field, errors[field]);
          }
        });

        if (typeof validators === 'function') {
          var nextValue = nextProps.modelValue;
          var currentValue = modelValue;

          if (!submit && !initial && !validatorsChanged && nextValue === currentValue) {
            // If neither the validators nor the values have changed,
            // the validity didn't change.
            return;
          }

          var multiFieldErrors = (0, _getValidity2.default)(validators, nextValue);

          if (multiFieldErrors) {
            Object.keys(multiFieldErrors).forEach(function (key) {
              // key will be the model value to apply errors to.
              var fieldErrors = multiFieldErrors[key];
              var currentErrors = (0, _getField2.default)(formValue, key).errors;

              // Invert validators
              Object.keys(fieldErrors).forEach(function (validationName) {
                fieldErrors[validationName] = !fieldErrors[validationName];
              });

              if (!validityChanged && !(0, _shallowEqual2.default)(fieldErrors, currentErrors)) {
                validityChanged = true;
              }

              fieldsErrors[key] = (0, _mergeValidity2.default)(fieldsErrors[key], fieldErrors);
            });
          }
        }

        // Compute form-level validity
        if (!fieldsErrors.hasOwnProperty('') && !~fieldKeys.indexOf('')) {
          fieldsErrors[''] = false;
          validityChanged = validityChanged || (0, _isValidityInvalid2.default)(formValue.$form.errors);
        }

        if (validityChanged) {
          dispatch(s.actions.setFieldsErrors(model, fieldsErrors, { merge: true }));
        }

        if (submit) {
          dispatch(s.actions.addIntent(model, { type: 'submit' }));
        }
      }
    }, {
      key: 'handleValidSubmit',
      value: function handleValidSubmit(options) {
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            model = _props2.model,
            modelValue = _props2.modelValue,
            onSubmit = _props2.onSubmit;


        dispatch(s.actions.setPending(model, true, options));

        if (onSubmit) onSubmit(modelValue, this.state.lastSubmitEvent);
      }
    }, {
      key: 'handleInvalidSubmit',
      value: function handleInvalidSubmit(options) {
        var _props3 = this.props,
            onSubmitFailed = _props3.onSubmitFailed,
            formValue = _props3.formValue,
            dispatch = _props3.dispatch;


        if (onSubmitFailed) {
          onSubmitFailed(formValue);
        }

        dispatch(s.actions.setSubmitFailed(this.props.model, true, options));
      }
    }, {
      key: 'handleReset',
      value: function handleReset(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.props.dispatch(s.actions.reset(this.props.model));
      }
    }, {
      key: 'handleIntents',
      value: function handleIntents() {
        var _this3 = this;

        var _props4 = this.props,
            formValue = _props4.formValue,
            noValidate = _props4.noValidate;


        formValue.$form.intents.forEach(function (intent) {
          switch (intent.type) {
            case 'submit':
              {
                if (noValidate || (0, _isValid2.default)(formValue, { async: false })) {
                  _this3.handleValidSubmit({ clearIntents: intent });
                } else {
                  _this3.handleInvalidSubmit({ clearIntents: intent });
                }

                return;
              }

            default:
              return;
          }
        });
      }
    }, {
      key: 'handleSubmit',
      value: function handleSubmit(e) {
        if (e) {
          if (!this.props.action) e.preventDefault();
          e.stopPropagation();
        }
        if (e && e.persist) e.persist();

        var _props5 = this.props,
            modelValue = _props5.modelValue,
            formValue = _props5.formValue,
            onSubmit = _props5.onSubmit,
            validators = _props5.validators,
            onBeforeSubmit = _props5.onBeforeSubmit;


        if (onBeforeSubmit) onBeforeSubmit(e);

        var formValid = formValue ? formValue.$form.valid : true;

        if (!validators && onSubmit && formValid) {
          onSubmit(modelValue, e);

          return modelValue;
        }

        this.setState({ lastSubmitEvent: e });

        this.validate(this.props, false, true);

        return modelValue;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props6 = this.props,
            component = _props6.component,
            children = _props6.children,
            formValue = _props6.formValue,
            hideNativeErrors = _props6.hideNativeErrors,
            noValidate = _props6.noValidate;


        var allowedProps = (0, _omit2.default)(this.props, disallowedPropTypeKeys);
        var renderableChildren = typeof children === 'function' ? children(formValue) : children;

        return _react2.default.createElement(component, _extends({}, allowedProps, {
          onSubmit: this.handleSubmit,
          onReset: this.handleReset,
          ref: this.attachNode,
          noValidate: hideNativeErrors || noValidate
        }), renderableChildren);
      }
    }]);

    return Form;
  }(_react.Component);

   false ? Form.propTypes = propTypes : void 0;

  Form.defaultProps = {
    validateOn: 'change',
    component: 'form'
  };

  Form.childContextTypes = {
    model: _propTypes2.default.any,
    localStore: _propTypes2.default.shape({
      subscribe: _propTypes2.default.func,
      dispatch: _propTypes2.default.func,
      getState: _propTypes2.default.func
    })
  };

  function mapStateToProps(state, _ref) {
    var model = _ref.model;

    var modelString = (0, _getModel2.default)(model, state);
    (0, _getForm.clearGetFormCacheForModel)(modelString);
    var form = s.getForm(state, modelString);

    (0, _invariant2.default)(form, 'Unable to create Form component. ' + 'Could not find form for "%s" in the store.', modelString);

    return {
      model: modelString,
      modelValue: s.get(state, modelString),
      formValue: form
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)(Form);
}

exports.createFormClass = createFormClass;
exports.default = createFormClass();

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mergeValidity;

var _isPlainObject = __webpack_require__(21);

var _icepick = __webpack_require__(33);

function mergeValidity(fieldValidity, actionValidity) {
  if (!(0, _isPlainObject.isObjectLike)(fieldValidity) || !(0, _isPlainObject.isObjectLike)(actionValidity)) {
    // can't merge string/boolean validity with keyed validity
    return actionValidity;
  }

  return (0, _icepick.merge)(fieldValidity, actionValidity);
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createForms = exports.createFormCombiner = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _modeledEnhancer = __webpack_require__(194);

var _modeledEnhancer2 = _interopRequireDefault(_modeledEnhancer);

var _modelReducer = __webpack_require__(109);

var _modelReducer2 = _interopRequireDefault(_modelReducer);

var _formReducer = __webpack_require__(82);

var _formReducer2 = _interopRequireDefault(_formReducer);

var _redux = __webpack_require__(40);

var _identity = __webpack_require__(48);

var _identity2 = _interopRequireDefault(_identity);

var _nullAction = __webpack_require__(77);

var _nullAction2 = _interopRequireDefault(_nullAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaults = {
  key: 'forms',
  plugins: []
};

function getSubModelString(model, subModel) {
  if (!model) return subModel;

  return model + '.' + subModel;
}

var defaultStrategy = {
  modelReducer: _modelReducer2.default,
  formReducer: _formReducer2.default,
  modeled: _modeledEnhancer2.default,
  toJS: _identity2.default
};

function createFormCombiner() {
  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;

  function createForms(forms) {
    var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var formKeys = Object.keys(forms);
    var modelReducers = {};
    var initialFormState = {};
    var optionsWithDefaults = _extends({}, defaults, options);

    var key = optionsWithDefaults.key,
        plugins = optionsWithDefaults.plugins,
        formOptions = _objectWithoutProperties(optionsWithDefaults, ['key', 'plugins']);

    formKeys.forEach(function (formKey) {
      var formValue = forms[formKey];
      var subModel = getSubModelString(model, formKey);

      if (typeof formValue === 'function') {
        var initialState = void 0;
        try {
          initialState = formValue(undefined, _nullAction2.default);
        } catch (error) {
          initialState = null;
        }

        modelReducers[formKey] = strategy.modeled(formValue, subModel);
        initialFormState[formKey] = strategy.toJS(initialState);
      } else {
        modelReducers[formKey] = strategy.modelReducer(subModel, formValue);
        initialFormState[formKey] = strategy.toJS(formValue);
      }
    });

    return _extends({}, modelReducers, _defineProperty({}, key, function (state, action) {
      return strategy.formReducer(model, initialFormState, _extends({
        plugins: plugins
      }, formOptions))(state, action);
    }));
  }

  function combineForms(forms) {
    var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var mappedReducers = createForms(forms, model, options);

    return (0, _redux.combineReducers)(mappedReducers);
  }

  return {
    createForms: createForms,
    combineForms: combineForms
  };
}

var _createFormCombiner = createFormCombiner(),
    defaultCombineForms = _createFormCombiner.combineForms,
    defaultCreateForms = _createFormCombiner.createForms;

exports.default = defaultCombineForms;
exports.createFormCombiner = createFormCombiner;
exports.createForms = defaultCreateForms;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModelReducerEnhancer = undefined;

var _modelReducer2 = __webpack_require__(109);

var _modelReducer3 = _interopRequireDefault(_modelReducer2);

var _nullAction = __webpack_require__(77);

var _nullAction2 = _interopRequireDefault(_nullAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createModelReducerEnhancer() {
  var modelReducerCreator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _modelReducer3.default;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function modelReducerEnhancer(reducer, model) {
    var initialState = void 0;
    try {
      initialState = reducer(undefined, _nullAction2.default);
    } catch (error) {
      initialState = null;
    }

    var _modelReducer = modelReducerCreator(model, initialState, options);

    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      var action = arguments[1];

      var updatedState = _modelReducer(state, action);

      return reducer(updatedState, action);
    };
  };
}

var modelReducerEnhancer = createModelReducerEnhancer(_modelReducer3.default);

exports.createModelReducerEnhancer = createModelReducerEnhancer;
exports.default = modelReducerEnhancer;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arraysEqual;
function arraysEqual(firstArray, secondArray) {
  return firstArray && secondArray && firstArray.length === secondArray.length && firstArray.every(function (item, index) {
    return item === secondArray[index];
  });
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFormValue;

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _toArray = __webpack_require__(355);

var _toArray2 = _interopRequireDefault(_toArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFormValue(form) {
  if (form && !form.$form) {
    return typeof form.loadedValue !== 'undefined' ? form.loadedValue : form.initialValue;
  }

  var result = (0, _mapValues2.default)(form, function (field, key) {
    if (key === '$form') return undefined;

    return getFormValue(field);
  });

  delete result.$form;

  var isArray = form && form.$form && Array.isArray(form.$form.value);

  return isArray ? (0, _toArray2.default)(result) : result;
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = map;
function map(values, iteratee) {
  if (Array.isArray(values)) {
    return values.map(iteratee);
  }

  var result = Object.keys(values).map(function (key) {
    return iteratee(values[key], key, values);
  });

  return result;
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_SESSION_SUCCESS = exports.GET_SESSION_SUCCESS = '@@redux-react-session/GET_SESSION_SUCCESS';
var GET_SESSION_ERROR = exports.GET_SESSION_ERROR = '@@redux-react-session/GET_SESSION_ERROR';
var GET_USER_SESSION_SUCCESS = exports.GET_USER_SESSION_SUCCESS = '@@redux-react-session/GET_USER_SESSION_SUCCESS';
var GET_USER_SESSION_ERROR = exports.GET_USER_SESSION_ERROR = '@@redux-react-session/GET_USER_SESSION_ERROR';
var INVALID_SESSION = exports.INVALID_SESSION = '@@redux-react-session/INVALID_SESSION';

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginLoading=function(_Component){_inherits(LoginLoading,_Component);function LoginLoading(){_classCallCheck(this,LoginLoading);return _possibleConstructorReturn(this,(LoginLoading.__proto__||Object.getPrototypeOf(LoginLoading)).apply(this,arguments));}_createClass(LoginLoading,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-6 has-text-centered has-text-inm-dark-purple"},this.props.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-5 has-text-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-spin fa-spinner"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null));}}]);return LoginLoading;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginLoading);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validateRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return validateEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return registerUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
var validateRegister=function validateRegister(){return function(dispatch){dispatch(registerRequest(undefined));var options={headers:{'Accept':'application/json','Content-Type':'application/json'},method:'get'};return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/register",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(validateRegisterData());},function(error){return dispatch(registerFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});};};var validateEmail=function validateEmail(email){return function(dispatch){dispatch(registerRequest('Validando Email'));var options={headers:{'Accept':'application/json','Content-Type':'application/json'},method:'get'};return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/register/email-validation?email="+email,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(json.data)){return dispatch(registerValidate(json));}else{return dispatch(registerNotValidate(json,email));}},function(error){return dispatch(registerFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});};};var registerUser=function registerUser(values){return function(dispatch){dispatch(registerRequest('Registrando'));var body=Object.assign({},values,{agenciable_id:values.modality_id!==2?values.state_id:values.municipality_id});var options={headers:{'Accept':'application/json','Content-Type':'application/json'},method:'post',body:JSON.stringify(body)};return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/register/user",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push('/');return dispatch(registerComplete(json));},function(error){return dispatch(registerFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});};};var registerEmail=function registerEmail(values){return function(dispatch){dispatch(registerRequest('Registrando'));var body=Object.assign({},values,{agenciable_id:values.modality_id!==2?values.state_id:values.municipality_id,user_id:values.id});var options={headers:{'Accept':'application/json','Content-Type':'application/json'},method:'post',body:JSON.stringify(body)};return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/register/agency",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push('/');return dispatch(registerComplete(json));},function(error){return dispatch(registerFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});};};var registerRequest=function registerRequest(status){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_154" /* REGISTER_REQUEST */],isFetching:true,status:status,timestamp:Date.now()};};var registerValidate=function registerValidate(json){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_155" /* REGISTER_VALIDATE */],isFetching:false,error:undefined,status:undefined,payload:{data:json.data,modalities:json.modalities,state:'open',action:'register_validate',style:'is-8'},timestamp:Date.now()};};var validateRegisterData=function validateRegisterData(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_155" /* REGISTER_VALIDATE */],isFetching:false,error:undefined,status:undefined,message:undefined,payload:{data:{validate:true},modalities:[],state:'open',action:undefined,style:'is-one-third'},timestamp:Date.now()};};var registerNotValidate=function registerNotValidate(json,email){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_153" /* REGISTER_NOT_VALIDATE */],isFetching:false,error:undefined,status:undefined,message:undefined,payload:{data:{email:email},modalities:json.modalities,state:'open',action:'register_not_validate',style:'is-10'},timestamp:Date.now()};};var registerComplete=function registerComplete(json){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_151" /* REGISTER_COMPLETE */],error:undefined,status:undefined,message:json.message,isFetching:false,payload:{data:{},modalities:[],state:'open',action:undefined,style:'is-one-third'},timestamp:Date.now()};};var registerFail=function registerFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_152" /* REGISTER_FAIL */],isFetching:false,status:undefined,message:undefined,error:error,timestamp:Date.now()};};

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return projectsExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchProjectsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return projectSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchProjectsGoalsEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return projectGoalsSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchProjectsExpensesEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return projectsExpensesSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchProjectEmployeesEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return projectEmployeeEditSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return projectEmployeeDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchProjectPhasesGroupsEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return projectPhaseSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return projectPhaseDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchProjectCommission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return projectsFolios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return projectsFoliosAssign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__status__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modalities__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__versions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__entities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__municipalities__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__goals__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directories__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__resource_concept__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__concepts__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_file_saver__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_file_saver__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* Projects Show*/var fetchProjects=function fetchProjects(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectsRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects?page="+page+"&include[0]=modality&include[1]=agency.agenciable&include[2]=amounts"+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};/* Projects Export*/var projectsExport=function projectsExport(){var filters=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var optionsExport=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectsRequest());var options={headers:{'Accept':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','Content-Type':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';var include_exports='';__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(optionsExport,function(value,key){if(value){include_exports=include_exports+"&include_export["+key+"]="+value;}});var fileName=undefined;return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects?include[0]=modality&include[1]=agency.agenciable&include[2]=amounts"+params+"&export=1"+include_exports,options).then(function(result){if(result.status>=200&&result.status<300){var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){//let today = new Date();
//let date = today.getFullYear() + ((today.getMonth() + 1) <10 ? `0${today.getMonth() + 1}`:today.getMonth() + 1) + (today.getDate()<10 ? `0${today.getDate()}`:today.getDate()) + today.getHours() + today.getMinutes() + today.getSeconds();
//FileSaver.saveAs(blob,`reporte_usuarios_${date}.xls`);
__WEBPACK_IMPORTED_MODULE_15_file_saver___default.a.saveAs(blob,fileName);dispatch(projectsComplete());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var fetchProjectsList=function fetchProjectsList(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectsRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects?include[0]=status&include[agency][0]=agenciable&include[agency][1]=owner"+(value?"&version_id="+value:'')+"&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectsListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectsData=function projectsData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_93" /* PROJECTS_FETCH */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},timestamp:Date.now()};};var projectsListData=function projectsListData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_96" /* PROJECTS_LIST */],isFetching:false,payload:json.data,timestamp:Date.now()};};/*
const projectsSetSearch = (q) => {
	return {
		type: PROJECT_SET_SEARCH,
		search: q,
		timestamp: Date.now()
	}
}*/var fetchProjectEdit=function fetchProjectEdit(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(projectsRequest());dispatch(projectsClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__status__["a" /* statusGroupList */])()).then(function(status){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(status.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__modalities__["a" /* modalitiesList */])()).then(function(mod){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(mod.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__versions__["e" /* versionsList */])()).then(function(versions){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(versions.payload)){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__entities__["a" /* entitiesList */])());if(id){return dispatch(projectEdit(id)).then(function(data){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.payload)){if(data.payload.modality_id===2){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__municipalities__["a" /* municipalitiesList */])(data.payload.agency.agenciable.state_id));}return dispatch(projectsComplete());}});}else{return dispatch(projectsComplete());}}else{return dispatch(projectsFail('Carga incompleta'));}});}else{return dispatch(projectsFail('Carga incompleta'));}});}else{return dispatch(projectsFail('Carga incompleta'));}});};};/*Projects Edit*/var projectEdit=function projectEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"?include[0]=agency.agenciable&include[1]=modality",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};/*Projects Save*/var projectSave=function projectSave(values){return function(dispatch){dispatch(projectsRequest());return dispatch(projectEditSave(values)).then(function(data){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.payload)){if(values.id){return dispatch(projectsComplete());}}});};};var projectEditSave=function projectEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){//dispatch(projectsRequest());
var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects"+(values.id?"/"+values.id+"?_method=PUT&include[0]=agency.agenciable&include[1]=modality":'?include[0]=agency.agenciable&include[1]=modality'),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El Proyecto se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_14__store_store__["b" /* history */].push('/proyectos/editar/datos/'+json.data.id);}return dispatch(projectEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectEditData=function projectEditData(json){var response={};if(json.data&&json.data.modality&&json.data.modality.agenciable_type==='imm'){response=Object.assign({},json.data,{version_id:json.data.agency.version_id,state_id:json.data.agency.agenciable.state_id?json.data.agency.agenciable.state_id:json.data.agency.agenciable.id,municipality_id:json.data.agency.municipality_id});}else{response=Object.assign({},json.data,{version_id:json.data.agency?json.data.agency.version_id:undefined,state_id:json.data.agency?json.data.agency.agenciable.id:undefined});}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_87" /* PROJECTS_EDIT */],payload:response,permissions:json.permissions,timestamp:Date.now()};};/*Goals*/var fetchProjectsGoalsEdit=function fetchProjectsGoalsEdit(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(projectsRequest());dispatch(projectsClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__directories__["b" /* actorsList */])()).then(function(actors){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(actors.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__directories__["c" /* conagoList */])()).then(function(conago){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(conago.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__resource_concept__["a" /* resourceConceptsList */])()).then(function(concepts){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(concepts.payload)){return dispatch(projectEdit(id)).then(function(data){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__goals__["d" /* goalsList */])(data.payload.modality_id,data.payload.agency.agenciable_id)).then(function(goals){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(goals.payload)){return dispatch(projectGoals(id)).then(function(goalsData){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(goalsData.payload)){return dispatch(projectsComplete());}});}else{return dispatch(projectsFail('Carga incompleta'));}});}});}else{return dispatch(projectsFail('Carga incompleta'));}});}else{return dispatch(projectsFail('Carga incompleta'));}});}else{return dispatch(projectsFail('Carga incompleta'));}});};};var projectGoals=function projectGoals(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/goals",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectGoalsEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectGoalsSave=function projectGoalsSave(id,values){return function(dispatch){dispatch(projectsRequest());return dispatch(projectGoalsEditSave(id,values)).then(function(goals){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(goals.payload)){return dispatch(projectsComplete());}});};};var projectGoalsEditSave=function projectGoalsEditSave(id,values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var goals=[];__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(values,function(data){goals.push(Object.assign({},data,{activities:data.project_goal_activities}));});var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({goals:goals})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/goals",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"Las metas se han guardado correctamente",type:"success"}));return dispatch(projectGoalsEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectGoalsEditData=function projectGoalsEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_95" /* PROJECTS_GOALS */],payload:json.data,permissions:json.permissions,timestamp:Date.now()};};/*Expenses*/var fetchProjectsExpensesEdit=function fetchProjectsExpensesEdit(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(projectsRequest());dispatch(projectsClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__concepts__["c" /* conceptsList */])()).then(function(concepts){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(concepts.payload)){return dispatch(projectExpensesEdit(id)).then(function(expenses){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(expenses.payload)){return dispatch(projectsComplete());}});}});};};var projectExpensesEdit=function projectExpensesEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/expenses",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectExpensesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectsExpensesSave=function projectsExpensesSave(id,values){return function(dispatch){dispatch(projectsRequest());return dispatch(projectExpensesEditSave(id,values)).then(function(expenses){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(expenses.payload)){return dispatch(projectsComplete());}});};};var projectExpensesEditSave=function projectExpensesEditSave(id,values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({expenses:values})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/expenses",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"Los gastos se han guardado correctamente",type:"success"}));return dispatch(projectExpensesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectExpensesEditData=function projectExpensesEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_91" /* PROJECTS_EXPENSES */],payload:json.data,permissions:json.permissions,timestamp:Date.now()};};/*Employees*/var fetchProjectEmployeesEdit=function fetchProjectEmployeesEdit(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(projectsRequest());dispatch(projectsClear());return dispatch(projectEmployeesEdit(id)).then(function(phases){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.payload)){return dispatch(projectsComplete());}});};};var projectEmployeesEdit=function projectEmployeesEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/employees",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectEmployeesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};/*export const projectEmployeeEditSave = (id, values) => (dispatch) => {
	dispatch(projectsRequest());

	return dispatch(projectEmployeeSave(id, values))
		.then((phases) => {
			if(!_.isEmpty(phases.payload)){
				return dispatch(projectsComplete())
			}
		})
}*/var projectEmployeeEditSave=function projectEmployeeEditSave(id,values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectEditRequest());var body={period_start:values.period_start,period_end:values.period_end,status_id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(values.status_id)};var param='';if(values.type==='agency'){param='agency';body=Object.assign({},body,{user_id:values.user_id,role_id:values.role_id});}else{param='project-goal-agency';body=Object.assign({},body,{job_function:values.job_function,rfc_invoices:values.rfc_invoices,wage:values.wage});}var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(body)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/"+param+"/employees"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"Los datos se han guardado correctamente",type:"success"}));return dispatch(projectEmployeesEditData(json));//return dispatch(projectsComplete())
},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectEmployeeDelete=function projectEmployeeDelete(id,employeeId){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectsRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/project-goal-agency/employees/"+employeeId,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El empleado se ah eliminado correctamente",type:"success"}));//return dispatch(projectEmployeesEditData(json));
//return dispatch(projectsComplete())
dispatch(fetchProjectEmployeesEdit(id));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectEmployeesData=function projectEmployeesData(json){var employees=[];if(json.data&&json.data.project_goals){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(json.data.project_goals,function(item){if(item.project_goal_agencies){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item.project_goal_agencies,function(goal){if(goal.employees){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(goal.employees,function(emp){var data={};__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(emp,function(i,k){data=Object.assign({},data,_defineProperty({},k,i?i:undefined));});employees.push(Object.assign({},data,{agency_id:goal.agency_id,project_goal_id:goal.project_goal_id,agency:Object.assign({},goal.agency),project_goal:{name:item.name,code:item.code}}));});}});}});}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_89" /* PROJECTS_EMPLOYEES */],payload:Object.assign({},json.data,{employees:employees}),roles:json.roles,permissions:json.permissions,timestamp:Date.now()};};var projectEmployeesEditData=function projectEmployeesEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_90" /* PROJECTS_EMPLOYEES_EDIT */],isFetching:false,payload:Object.assign({},json.data,{action:'close'}),timestamp:Date.now()};};/*Phases*/var fetchProjectPhasesGroupsEdit=function fetchProjectPhasesGroupsEdit(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(projectsRequest());dispatch(projectsClear());return dispatch(projectPhasesGroupsEdit(id)).then(function(phases){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.payload)){return dispatch(projectsComplete());}});};};var projectPhasesGroupsEdit=function projectPhasesGroupsEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/version-phases-groups",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectPhasesGroupsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectPhaseSave=function projectPhaseSave(id,values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectEditRequest());var body={star_date:values.start_date,end_date:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(values.end_date)?values.end_date:null};var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(body)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/version-phases-groups/"+values.id+"?_method=PUT",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"Los datos se han guardado correctamente",type:"success"}));//return dispatch(projectPhasesGroupsEditData(json));
return dispatch(projectPhasesGroupsEditData());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectPhaseDelete=function projectPhaseDelete(id,phaseId){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectsRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/version-phases-groups/"+phaseId,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El proceso se elimino correctamente",type:"success"}));//return dispatch(projectPhasesGroupsEditData(json));
return dispatch(fetchProjectPhasesGroupsEdit(id));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectPhasesGroupsData=function projectPhasesGroupsData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_97" /* PROJECTS_PHASES_GROUPS */],payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var projectPhasesGroupsEditData=function projectPhasesGroupsEditData(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_98" /* PROJECTS_PHASES_GROUPS_EDIT */],isFetching:false,payload:{action:'close'},timestamp:Date.now()};};var fetchProjectCommission=function fetchProjectCommission(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectsRequest());dispatch(projectsClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/projects/"+id+"/commissions",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectCommissionData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectCommissionData=function projectCommissionData(json){var answers=[];if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(json.data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(json.data.comissions_review)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(json.data.comissions_review.survey_version_phase)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(json.data.comissions_review.survey_version_phase.survey)){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(json.data.comissions_review.survey_version_phase.survey.children_questions,function(q){if(q.type==='group'){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(q.children_questions,function(item){if(item.answer){//let answer = _.find(q.answers,{question_id: q.id});
answers.push({spvpu_id:item.answer.spvpu_id,question_id:item.answer.question_id,answer_number:item.answer.answer_number,answer_text:item.answer.answer_text});}});}else{if(q.answer){//let answer = _.find(q.answers,{question_id: q.id});
answers.push({spvpu_id:q.answer.spvpu_id,question_id:q.answer.question_id,answer_number:q.answer.answer_number,answer_text:q.answer.answer_text});}}});}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_85" /* PROJECTS_COMMISSIONS */],isFetching:false,payload:Object.assign({},json.data,{answers:answers}),permissions:json.permissions,timestamp:Date.now()};};var projectsFolios=function projectsFolios(mod){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectsRequest());if(mod==='modalidad-ii'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__entities__["a" /* entitiesList */])());}dispatch(projectsClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/codes/"+mod,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectsFoliosData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectsFoliosAssign=function projectsFoliosAssign(mod){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectsRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/codes/"+mod,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:'Folios asignados correctamente',type:"success"}));return dispatch(projectsFoliosData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:'danger'}));return dispatch(projectsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var projectsFoliosData=function projectsFoliosData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_94" /* PROJECTS_FOLIOS */],isFetching:false,payload:json.data,codes_assigned:json.codes_assigned,version:json.version,permissions:json.permissions,timestamp:Date.now()};};/*Fetching*/var projectEditRequest=function projectEditRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_88" /* PROJECTS_EDIT_REQUEST */],isFetching:true,timestamp:Date.now()};};/*Fetching*/var projectsRequest=function projectsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_99" /* PROJECTS_REQUEST */],isFetching:true,timestamp:Date.now()};};/*Complete*/var projectsComplete=function projectsComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_86" /* PROJECTS_COMPLETE */],isFetching:false,timestamp:Date.now()};};/*Clear*/var projectsClear=function projectsClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_84" /* PROJECTS_CLEAR */],payload:{project:{},goals:[],expenses:[],phases_groups:[],employees:{},roles:[],folios:[],edit:{isFetching:false},codes_assigned:false,version:{}},timestamp:Date.now()};};/*Fails*/var projectsFail=function projectsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_92" /* PROJECTS_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activityGroupShow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/*Group List*/var activityGroupShow=function activityGroupShow(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(activityGroupRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/activities/groups?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(activityGroupData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(activityGroupFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var activityGroupData=function activityGroupData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["j" /* ACTIVITY_GROUP_SHOW */],isFetching:false,payload:json.data,timestamp:Date.now()};};/*Group Request*/var activityGroupRequest=function activityGroupRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["i" /* ACTIVITY_GROUP_REQUEST */],isFetching:true,timestamp:Date.now()};};/*Group Fail*/var activityGroupFail=function activityGroupFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["h" /* ACTIVITY_GROUP_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return verificationMediaShow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__);
/*List Show*/var verificationMediaShow=function verificationMediaShow(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(verificationMediaRequest());return fetch(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/proigualdad/verification-media?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(verficationMediaData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(verificationMediaFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};/*List Data*/var verficationMediaData=function verficationMediaData(json){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_255" /* VERIFICATION_MEDIA_SHOW */],isFetching:false,payload:json.data,timestamp:Date.now()};};/*Request*/var verificationMediaRequest=function verificationMediaRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_254" /* VERIFICATION_MEDIA_REQUEST */],isFetching:true,timestamp:Date.now()};};/*Fail*/var verificationMediaFail=function verificationMediaFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_253" /* VERIFICATION_MEDIA_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return projectOwner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return projectOwnerSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return projectAgency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProjectAgency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return projectAgencyExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return projectAgencySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return projectRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return projectRegistryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return projectRegistrySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return projectProigualdadGoals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return projectProigualdadGoalsEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return projectProigualdadGoalsEditSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return projectExpenses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return projectExpensesSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return projectEmployees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return projectEmployeeSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return projectClear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return projectConclusion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return projectConclusionExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return projectConclusionSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCompletProject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__goals__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directories__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_concept__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__entities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modalities__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__concepts__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_file_saver__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__axis__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lines__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__activities__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__municipalities__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_store__ = __webpack_require__(15);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* project owner */var projectOwner=function projectOwner(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(projectOwnerRequest());dispatch(projectOwnerClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/owner/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectOwnerData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectOwnerFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectOwnerSave=function projectOwnerSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var data=arguments[3];var event=arguments[4];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var body=new FormData(event);__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(data,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};dispatch(projectOwnerRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/owner/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:"La información del titular se ha guardado correctamente",type:"success"}));return dispatch(projectOwnerData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(projectOwnerFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectOwnerData=function projectOwnerData(json){var documents={};var data={};if(json.data){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(json.data,function(item,key){data=Object.assign({},data,_defineProperty({},key,item?item:undefined));});if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data.documents)){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(json.data.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_132" /* PROJECT_OWNER */],isFetching:false,payload:Object.assign({},data,documents),documents_items:json.documents_items,editable:json.editable,revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},permissions:json.permissions,phase:json.phase,version:json.version,timestamp:Date.now()};};var projectOwnerRequest=function projectOwnerRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_135" /* PROJECT_OWNER_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectOwnerFail=function projectOwnerFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_134" /* PROJECT_OWNER_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var projectOwnerClear=function projectOwnerClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_133" /* PROJECT_OWNER_CLEAR */],payload:{},timestamp:Date.now()};};/* project instance */var projectAgency=function projectAgency(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){dispatch(projectAgencyRequest());dispatch(projectAgencyClear());dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__entities__["a" /* entitiesList */])());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__modalities__["a" /* modalitiesList */])()).then(function(modalities){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(modalities.payload)){return dispatch(projectOwner(modality,state,mun)).then(function(owner){if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(owner.payload)||!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(owner.payload)){return dispatch(fetchProjectAgency(modality,state,mun)).then(function(agency){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(agency.payload)){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__municipalities__["a" /* municipalitiesList */])(agency.payload.state_id));}});}else{return dispatch(projectAgencyFail('Carga de instancia incompleta'));}});}else{return dispatch(projectAgencyFail('Carga de instancia incompleta'));}});};};var fetchProjectAgency=function fetchProjectAgency(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/agency/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectAgencyData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectAgencyFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectAgencyExport=function projectAgencyExport(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var fileName=undefined;dispatch(projectAgencyRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/agency/participation-request-pdf/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){__WEBPACK_IMPORTED_MODULE_11_file_saver___default.a.saveAs(blob,fileName);dispatch(projectAgencyLoaded());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectAgencyFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectAgencySave=function projectAgencySave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var data=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectAgencyRequest());var body=new FormData();__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(data,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};//dispatch(projectRequest());
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/agency/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:"La información de la instancia se ha guardado correctamente",type:"success"}));return dispatch(projectAgencyData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(projectFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectAgencyData=function projectAgencyData(json){var documents={};var data={};if(json.data){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(json.data,function(item,key){data=Object.assign({},data,_defineProperty({},key,item?item:undefined));});data=Object.assign({},data,{state_id:!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data.municipality)?json.data.municipality.state_id:undefined});if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data.documents)){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(json.data.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_126" /* PROJECT_INSTANCE */],isFetching:false,payload:Object.assign({},data,documents),documents_items:json.documents_items,editable:json.editable,revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},phase:json.phase,version:json.version,permissions:json.permissions,timestamp:Date.now()};};var projectAgencyRequest=function projectAgencyRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_130" /* PROJECT_INSTANCE_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectAgencyLoaded=function projectAgencyLoaded(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_129" /* PROJECT_INSTANCE_LOADED */],isFetching:false,timestamp:Date.now()};};var projectAgencyFail=function projectAgencyFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_128" /* PROJECT_INSTANCE_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var projectAgencyClear=function projectAgencyClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_127" /* PROJECT_INSTANCE_CLEAR */],payload:{},timestamp:Date.now()};};/* project registry */var projectRegistry=function projectRegistry(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){dispatch(projectRegistryRequest());dispatch(projectRegistryClear());dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__entities__["a" /* entitiesList */])());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__directories__["b" /* actorsList */])()).then(function(actors){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(actors.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__directories__["c" /* conagoList */])()).then(function(conago){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(conago.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__resource_concept__["a" /* resourceConceptsList */])()).then(function(resources){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(resources.payload)){return dispatch(projectRegistryData(modality,state,mun/*, goals.payload*/)).then(function(registry){var modality=!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registry.payload)&&registry.payload.modality_id?registry.payload.modality_id:undefined;var agenciable=!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registry.payload)&&registry.payload.agency&&registry.payload.agency.agenciable_id?registry.payload.agency.agenciable_id:undefined;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registry.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__goals__["d" /* goalsList */])(modality,agenciable)).then(function(goals){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goals.payload)){return dispatch(projectRegistryLoaded());}else{return dispatch(projectRegistryFail('Carga de registro incompleta'));}});}else{return dispatch(projectRegistryFail('Carga de registro incompleta'));}});}else{return dispatch(projectRegistryFail('Carga de registro incompleta'));}});}else{return dispatch(projectRegistryFail('Carga de registro incompleta'));}});}else{return dispatch(projectRegistryFail('Carga de registro incompleta'));}});};};var projectRegistryRequest=function projectRegistryRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_148" /* PROJECT_REGISTRY_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectRegistryFail=function projectRegistryFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_146" /* PROJECT_REGISTRY_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var projectRegistryLoaded=function projectRegistryLoaded(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_147" /* PROJECT_REGISTRY_LOADED */],isFetching:false,payload:true,timestamp:Date.now()};};var projectRegistryClear=function projectRegistryClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_142" /* PROJECT_REGISTRY_CLEAR */],payload:{isFetching:false,error:undefined,project_goals:[],amounts:{}},timestamp:Date.now()};};/* project registry data */var projectRegistryData=function projectRegistryData(modality,state)/*, goals*/{var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(projectRegistryDataRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/project/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectRegistryDataInfo(json/*, goals*/));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectRegistryDataFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectRegistrySave=function projectRegistrySave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var data=arguments[3];return function(dispatch){dispatch(projectRegistryRequest());return dispatch(projectRegistryEditSave(modality,state,mun,data)).then(function(registry){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registry.payload)){return dispatch(projectRegistryLoaded());}else{return dispatch(projectRegistryFail(registry.error));}});};};var projectRegistryEditSave=function projectRegistryEditSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var data=arguments[3];var newData={execution_end:data.execution_end,execution_start:data.execution_start,id:data.id,justification:data.justification,modality_id:data.modality_id,name:data.name,objective:data.objective,status_id:data.status_id,goals:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(data.project_goals,function(goal){return{geographic_area:goal.geographic_area,goal_document:goal.goal_document,id:goal.id,is_continuing:goal.is_continuing,line_id:goal.line_id,mandatory:goal.mandatory,proigualdad_goal_id:goal.proigualdad_goal_id,project_id:goal.project_id,total:goal.total,actors:goal.actors,resource_concept_id:goal.resource_concept_id,conago_clauses:goal.conago_clauses,municipalities:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(goal.agencies,function(mun){return{id:mun.agenciable_id};}),activities:[].concat(_toConsumableArray(goal.project_goal_activities))};})};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(newData)};dispatch(projectRegistryDataRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/project/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Éxito!',content:json.message?json.message:'Se guardaron correctamente los cambios',type:'success'}));return dispatch(projectRegistryDataInfo(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectRegistryDataFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectRegistryDataRequest=function projectRegistryDataRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_145" /* PROJECT_REGISTRY_DATA_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectRegistryDataInfo=function projectRegistryDataInfo(json){var data=json.data;var revisions=[];var total=0;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data)){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(json.data.project_goals,function(item){return total+=item.amounts.total;});}if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.revisions)){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(json.revisions,function(item){revisions.push(Object.assign({},item,{body:JSON.parse(item.body)}));});}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_143" /* PROJECT_REGISTRY_DATA */],isFetching:false,payload:Object.assign({},data,{amounts:total}),documents_items:json.documents_items,editable:json.editable,revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},revisions:revisions,phase:json.phase,version:json.version,permissions:json.permissions,timestamp:Date.now()};};var projectRegistryDataFail=function projectRegistryDataFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_144" /* PROJECT_REGISTRY_DATA_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};/*Project registry goals proigualdad*/var projectProigualdadGoals=function projectProigualdadGoals(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var modality=arguments[1];var state=arguments[2];var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(projectProigualdadGoalsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/proigualdad-goals/project/"+modality+"/"+state+(mun?'/'+mun:'')+"?page="+page+"&per_page=10",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectProigualdadGoalsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectProigualdadGoalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectProigualdadGoalsEdit=function projectProigualdadGoalsEdit(goal,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){dispatch(projectProigualdadGoalsRequest());dispatch(projectProigualdadGoalsEditClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__axis__["d" /* axisList */])(1)).then(function(axis){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(axis.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__lines__["e" /* linesList */])(1)).then(function(lines){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(lines.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__activities__["a" /* activitiesList */])()).then(function(activities){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(activities.payload)){if(goal){return dispatch(fetchProjectProigualdadGoalsEdit(goal,modality,state,mun));}else{return dispatch(projectProigualdadGoalsComplete());}}else{return dispatch(projectProigualdadGoalsFail('Carga incompleta'));}});}else{return dispatch(projectProigualdadGoalsFail('Carga incompleta'));}});}else{return dispatch(projectProigualdadGoalsFail('Carga incompleta'));}});};};var fetchProjectProigualdadGoalsEdit=function fetchProjectProigualdadGoalsEdit(goal,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(projectProigualdadGoalsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/proigualdad-goals/"+goal+"/project/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectProigualdadGoalsEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectProigualdadGoalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectProigualdadGoalsEditSave=function projectProigualdadGoalsEditSave(){var goal=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;var modality=arguments[1];var state=arguments[2];var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;var values=arguments[4];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(projectProigualdadGoalsRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/proigualdad-goals"+(goal?"/"+goal:'')+"/project/"+modality+"/"+state+(mun?'/'+mun:'')+(goal?'?_method=PUT':''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Éxito!',content:json.message?json.message:'Se guardaron correctamente los cambios',type:'success'}));if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goal)){__WEBPACK_IMPORTED_MODULE_16__store_store__["b" /* history */].push("/proyecto/"+modality+"/proigualdad-meta/editar/"+json.data.id+"/"+state+(mun?'/'+mun:''));}return dispatch(projectProigualdadGoalsEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectProigualdadGoalsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectProigualdadGoalsData=function projectProigualdadGoalsData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_136" /* PROJECT_PROIGUALDAD_GOALS */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var projectProigualdadGoalsEditData=function projectProigualdadGoalsEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_139" /* PROJECT_PROIGUALDAD_GOALS_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var projectProigualdadGoalsComplete=function projectProigualdadGoalsComplete(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_138" /* PROJECT_PROIGUALDAD_GOALS_COMPLETE */],isFetching:false,timestamp:Date.now()};};var projectProigualdadGoalsRequest=function projectProigualdadGoalsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_141" /* PROJECT_PROIGUALDAD_GOALS_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectProigualdadGoalsEditClear=function projectProigualdadGoalsEditClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_137" /* PROJECT_PROIGUALDAD_GOALS_CLEAR */],payload:{},timestamp:Date.now()};};var projectProigualdadGoalsFail=function projectProigualdadGoalsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_140" /* PROJECT_PROIGUALDAD_GOALS_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};/*Project Expenses*/var projectExpenses=function projectExpenses(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){dispatch(projectExpensesRequest());dispatch(projectExpensesClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__concepts__["c" /* conceptsList */])()).then(function(concepts){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(concepts.payload)){return dispatch(fetchProjectExpenses(modality,state,mun));}});};};var fetchProjectExpenses=function fetchProjectExpenses(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/expenses/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectExpensesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(projectExpensesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectExpensesSave=function projectExpensesSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectExpensesRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({expenses:values.project_expenses})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/expenses/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"Los gastos se han guardado correctamente",type:"success"}));return dispatch(projectExpensesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(projectExpensesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectExpensesData=function projectExpensesData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_121" /* PROJECT_EXPENSES */],isFetching:false,editable:json.editable,payload:json.data,revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},phase:json.phase,version:json.version,permissions:json.permissions,timestamp:Date.now()};};var projectExpensesRequest=function projectExpensesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_124" /* PROJECT_EXPENSES_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectExpensesClear=function projectExpensesClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_122" /* PROJECT_EXPENSES_CLEAR */],payload:{},timestamp:Date.now()};};var projectExpensesFail=function projectExpensesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_123" /* PROJECT_EXPENSES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};/* project profiles */var projectEmployees=function projectEmployees(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return(/*, role, agency*/function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectEmployeeRequest());dispatch(projectEmployeesRolesClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/employees/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else if(result.status>=500){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:'Respuesta erronea del servidor',type:'danger'}));}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectEmployeesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(projectEmployeeFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});});};var projectEmployeeSave=function projectEmployeeSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(projectEmployeeEditRequest());__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/employees/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El Perfil se ha guardado correctamente",type:"success"}));return dispatch(projectEmployeesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(projectEmployeeFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectEmployeesRolesClear=function projectEmployeesRolesClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_117" /* PROJECT_EMPLOYEES_CLEAR */],payload:{data:{employees:[],roles:[]},edit:{isFetching:false}},phase:{},timestamp:Date.now()};};var projectEmployeesData=function projectEmployeesData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_116" /* PROJECT_EMPLOYEES */],isFetching:false,editable:json.editable,payload:Object.assign({},json.data,{roles:!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.roles)?json.roles:[]}),revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},phase:json.phase,version:json.version,permissions:json.permissions,timestamp:Date.now()};};var projectEmployeeRequest=function projectEmployeeRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_120" /* PROJECT_EMPLOYEES_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectEmployeeEditRequest=function projectEmployeeEditRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_118" /* PROJECT_EMPLOYEES_EDIT_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectEmployeeFail=function projectEmployeeFail(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_119" /* PROJECT_EMPLOYEES_FAIL */],isFetching:false,timestamp:Date.now()};};var projectClear=function projectClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_105" /* PROJECT_CLEAR */],payload:{owner:{isFetching:false,editable:false,data:{},revision:{},documents_items:[]},instance:{isFetching:false,editable:false,data:{},list:[],revision:{},documents_items:[]},registry:{isFetching:false,editable:false,data:{isFetching:false,error:undefined,goals:[],amounts:{}},revision:{},revisions:[],documents_items:[]},goals:{isFetching:false,editable:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},edit:{}},expenses:{isFetching:false,editable:false,edit:{},data:{},revision:{}},profiles:{isFetching:false,editable:false,data:{employees:[],roles:[]},edit:{isFetching:false},revision:{}},conclusion:{isFetching:false,finished:false,editable:false,data:{},revision:{},documents_items:[],version:{}},agreements:{isFetching:false,admin:{isFetching:false,data:{}},legal:{isFetching:false,data:{}}},dispersions:{isFetching:false,list:[],data:[],budgets:{},permissions:{}},phase:{},version:{}},timestamp:Date.now()};};var projectRequest=function projectRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_149" /* PROJECT_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectFail=function projectFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_125" /* PROJECT_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var projectLoaded=function projectLoaded(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_131" /* PROJECT_LOADED */],isFetching:false,payload:'loaded',timestamp:Date.now()};};/* project conclusion */var projectConclusion=function projectConclusion(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(projectConclusionRequest());dispatch(projectConclusionClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/summary/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectConclusionData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectConclusionFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectConclusionExport=function projectConclusionExport(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var fileName=undefined;dispatch(projectConclusionRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/summary/summary-pdf/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){__WEBPACK_IMPORTED_MODULE_11_file_saver___default.a.saveAs(blob,fileName);dispatch(projectConclusionLoaded());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectConclusionFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectConclusionSave=function projectConclusionSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var data=arguments[3];var event=arguments[4];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectConclusionRequest());var body=new FormData(event);__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(data,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/projects/register/summary/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Éxito!',content:json.message?json.message:'Los cambios se guardaron correctamente',type:'success'}));return dispatch(projectConclusionData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:'danger'}));return dispatch(projectConclusionFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var projectConclusionData=function projectConclusionData(json){var documents={};if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data)){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data.project_version_phase_group)){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(json.data.project_version_phase_group.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}if(json.data.agency){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(json.data.agency.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_106" /* PROJECT_CONCLUSION */],isFetching:false,editable:json.editable,payload:Object.assign({},json.data,{documents:documents,finished:json.finished?true:false}),documents_items:json.documents_items,revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},phase:json.phase,permissions:json.permissions,version:json.version,timestamp:Date.now()};};var projectConclusionClear=function projectConclusionClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_107" /* PROJECT_CONCLUSION_CLEAR */],payload:{finished:false,editable:false,data:{},revision:{},documents_items:[]},phase:{},timestamp:Date.now()};};var projectConclusionLoaded=function projectConclusionLoaded(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_109" /* PROJECT_CONCLUSION_LOADED */],isFetching:false,timestamp:Date.now()};};var projectConclusionRequest=function projectConclusionRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_110" /* PROJECT_CONCLUSION_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectConclusionFail=function projectConclusionFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_108" /* PROJECT_CONCLUSION_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};/* project get all info */var fetchCompletProject=function fetchCompletProject(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){dispatch(projectRequest());dispatch(projectClear());return dispatch(projectOwner(modality,state,mun)).then(function(owner){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(owner.payload)){return dispatch(fetchProjectAgency(modality,state,mun)).then(function(instance){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(instance.payload)){return dispatch(projectRegistryData(modality,state,mun)).then(function(registry){if(registry.payload){return dispatch(fetchProjectExpenses(modality,state,mun)).then(function(expenses){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(expenses.payload)){return dispatch(projectEmployees(modality,state,mun)).then(function(employees){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(employees.payload)){return dispatch(projectConclusion(modality,state,mun)).then(function(conclusion){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(conclusion.payload)){return dispatch(projectLoaded());}else{return dispatch(projectFail(conclusion.error));}});}else{return dispatch(projectFail(employees.error));}});}else{return dispatch(projectFail(expenses.error));}});}else{return dispatch(projectFail(registry.error));}});}else{return dispatch(projectFail(instance.error));}});}else{return dispatch(projectFail(owner.error));}});};};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchRevision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchRevisionLegal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return saveLegalRevision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchRevisionProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return saveProjectRevision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRevisionAgreements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return saveAgreements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchRevisionReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return saveRevisionReportsFinancial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return saveRevisionReportsExpenses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return saveRevisionReportsSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCommission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchShowCommission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assignCommission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return surveysSaveAnswer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modalities__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_concept__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__project__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reports__ = __webpack_require__(208);
var fetchRevision=function fetchRevision(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(requestRevision());dispatch(revisionClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/"+modality+"/"+state+(mun!==undefined?'/'+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options)//return fetch(`${API2_URL}/revisions/${modality}/${state}${mun !== undefined ? '/'+mun : ''}`, options)
.then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(revisionOwner(json));dispatch(revisionInstance(json));dispatch(revisionRegistry(json));dispatch(revisionExpenses(json));dispatch(revisionProfiles(json));dispatch(revisionConclusion(json));dispatch(revisionAgreementsAdmin(json));dispatch(revisionAgreementsLegal(json));dispatch(revisionComplete());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var fetchRevisionLegal=function fetchRevisionLegal(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){dispatch(requestRevision());dispatch(revisionClear());dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__project__["f" /* projectClear */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__entities__["a" /* entitiesList */])());return dispatch(fetchRevisionOwner(modality,state,mun)).then(function(revOwner){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(revOwner.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__project__["n" /* projectOwner */])(modality,state,mun)).then(function(owner){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(owner.payload)){return dispatch(fetchRevisionInstance(modality,state,mun)).then(function(revInstance){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(revInstance.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__project__["b" /* fetchProjectAgency */])(modality,state,mun)).then(function(instance){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(instance.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__modalities__["a" /* modalitiesList */])()).then(function(mods){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(mods.payload)){return dispatch(revisionComplete());}else{return dispatch(failedRevision('Carga incompleta'));}});}else{return dispatch(failedRevision('Carga incompleta'));}});}});}else{return dispatch(failedRevision('Carga incompleta'));}});}});};};var fetchRevisionOwner=function fetchRevisionOwner(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//return fetch(`${API2_URL}/revisions/project/register/legal/project-owner/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/legal/project-owner/"+modality+"/"+state+(mun?"/"+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionOwner(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var fetchRevisionInstance=function fetchRevisionInstance(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//return fetch(`${API2_URL}/revisions/project/register/legal/project-agency/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/legal/project-agency/"+modality+"/"+state+(mun?"/"+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionInstance(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveLegalRevision=function saveLegalRevision(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){var ownerSave=values.owner;var instanceSave=values.instance;dispatch(requestRevision());return dispatch(saveRevisionOwner(modality,state,mun,ownerSave)).then(function(owner){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(owner.payload)){return dispatch(saveRevisionInstance(modality,state,mun,instanceSave)).then(function(instance){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(instance.payload)){return dispatch(revisionComplete());}});}});};};var saveRevisionOwner=function saveRevisionOwner(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id:values.status_id})
body:JSON.stringify({body:JSON.stringify(values.body)})};//dispatch(requestRevision());
//return fetch(`${API_URL}/revisions/${modality}/${state}${mun ? '/'+ mun : ''}/revision${values.id ? '/'+values.id+'?_method=PUT' : ''}`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/legal/project-owner/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));return dispatch(revisionOwner(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveRevisionInstance=function saveRevisionInstance(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id: values.status_id})
body:JSON.stringify({notification_type_id:values.notification_type_id,body:JSON.stringify(values.body)})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/legal/project-agency/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));return dispatch(revisionInstance(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var fetchRevisionProject=function fetchRevisionProject(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){dispatch(requestRevision());dispatch(revisionClear());return dispatch(fetchRevisionRegistry(modality,state,mun)).then(function(registry){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registry.payload)){return dispatch(fetchRevisionExpenses(modality,state,mun)).then(function(expenses){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(expenses.payload)){return dispatch(fetchRevisionProfiles(modality,state,mun)).then(function(profiles){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(profiles.payload)){return dispatch(fetchRevisionConclusion(modality,state,mun)).then(function(summary){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summary.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__project__["a" /* fetchCompletProject */])(modality,state,mun)).then(function(project){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(project.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__resource_concept__["a" /* resourceConceptsList */])()).then(function(concepts){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(concepts.payload)){return dispatch(fetchShowCommission(modality,state,mun));}else{return dispatch(failedRevision('Carga incompleta'));}});}else{return dispatch(failedRevision('Carga incompleta'));}});}});}});}});}});};};var fetchRevisionRegistry=function fetchRevisionRegistry(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//return fetch(`${API2_URL}/revisions/project/register/project/project-goals/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/project/project-goals/"+modality+"/"+state+(mun?"/"+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionRegistry(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var fetchRevisionExpenses=function fetchRevisionExpenses(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//return fetch(`${API2_URL}/revisions/project/register/project/project-expenses/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/project/project-expenses/"+modality+"/"+state+(mun?"/"+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionExpenses(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var fetchRevisionProfiles=function fetchRevisionProfiles(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//return fetch(`${API2_URL}/revisions/project/register/project/project-profiles/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/project/project-profiles/"+modality+"/"+state+(mun?"/"+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionProfiles(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var fetchRevisionConclusion=function fetchRevisionConclusion(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//return fetch(`${API2_URL}/revisions/project/register/project/project-conclusion/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/project/project-conclusion/"+modality+"/"+state+(mun?"/"+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionConclusion(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveProjectRevision=function saveProjectRevision(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var values=arguments[3];return function(dispatch){var registrySave=values.registry;var profilesSave=values.profiles;var expensesSave=values.expenses;var conclusionSave=values.conclusion;dispatch(requestRevision());return dispatch(saveRevisionRegistry(modality,state,mun?mun:null,registrySave)).then(function(registry){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registry.payload)){return dispatch(saveRevisionExpenses(modality,state,mun?mun:null,expensesSave)).then(function(expenses){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(expenses.payload)){return dispatch(saveRevisionProfiles(modality,state,mun?mun:null,profilesSave)).then(function(profiles){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(profiles.payload)){return dispatch(saveRevisionConclusion(modality,state,mun?mun:null,conclusionSave)).then(function(conclusion){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(conclusion.payload)){return dispatch(revisionComplete());}});}});}});}});};};var saveRevisionRegistry=function saveRevisionRegistry(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id:values.status_id})
body:JSON.stringify({body:JSON.stringify(values.body)})};//dispatch(requestRevision());
//return fetch(`${API_URL}/revisions/${modality}/${state}${mun ? '/'+ mun : ''}/revision${values.id ? '/'+values.id+'?_method=PUT' : ''}`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/project/project-goals/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));return dispatch(revisionRegistry(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveRevisionExpenses=function saveRevisionExpenses(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id:values.status_id})
body:JSON.stringify({body:JSON.stringify(values.body)})};//dispatch(requestRevision());
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/project/project-expenses/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));return dispatch(revisionExpenses(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveRevisionProfiles=function saveRevisionProfiles(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id:values.status_id})
body:JSON.stringify({body:JSON.stringify(values.body)})};//dispatch(requestRevision());
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/project/project-profiles/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));;return dispatch(revisionProfiles(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveRevisionConclusion=function saveRevisionConclusion(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({notification_type_id:values.notification_type_id,body:JSON.stringify(values.body)})};//dispatch(requestRevision());
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/register/project/project-conclusion/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:'La revisión se guardó correctamente',type:"success"}));;return dispatch(revisionConclusion(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var fetchRevisionAgreements=function fetchRevisionAgreements(type,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(requestRevision());dispatch(revisionClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/agreements/"+type+"/project-agreements-agency/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){if(type==='admin'){return dispatch(revisionAgreementsAdmin(json));}else{return dispatch(revisionAgreementsLegal(json));}},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveAgreements=function saveAgreements(type,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;var values=arguments[4];return function(dispatch){var agreementsSave={};if(type==='admin'){agreementsSave=values.agreements.admin;}else{agreementsSave=values.agreements.legal;}/*if(type==='administrativo'){
		dispatch(saveRevisionAgreementsAdmin(modality, state, mun, agreementsSave))
	}else {
		dispatch(saveRevisionAgreementsLegal(modality, state, mun, agreementsSave))
	}*/return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(requestRevision());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({body:JSON.stringify(agreementsSave.body),notification_type_id:agreementsSave.notification_type_id})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/agreements/"+type+"/project-agreements-agency/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));if(type==='admin'){return dispatch(revisionAgreementsAdmin(json));}else{return dispatch(revisionAgreementsLegal(json));}},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};/*const saveRevisionAgreementsAdmin = (modality, state, mun = null, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id: values.status_id , notification_type_id: values.notification_type_id})
				body: JSON.stringify({body: JSON.stringify(values.body), notification_type_id: values.notification_type_id})
			};

			dispatch(requestRevision());
			//return fetch(`${API_URL}/revisions/${modality}/${state}${mun ? '/'+ mun : ''}/revision${values.id ? '/'+values.id+'?_method=PUT' : ''}`, options)
			return fetch(`${API2_URL}/revisions/project/agreements/admin/project-agreements-agency/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionAgreementsAdmin(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const saveRevisionAgreementsLegal = (modality, state, mun = null, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id: values.status_id, notification_type_id: values.notification_type_id})
				body: JSON.stringify({body: JSON.stringify(values.body), notification_type_id: values.notification_type_id})
			};

			dispatch(requestRevision());
			//return fetch(`${API_URL}/revisions/${modality}/${state}${mun ? '/'+ mun : ''}/revision${values.id ? '/'+values.id+'?_method=PUT' : ''}`, options)
			//return fetch(`${API2_URL}/revisions/project/register/legal/project-agency-fiscal-entity-legal/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/agreements/legal/project-agreements-agency/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionAgreementsLegal(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}*/var fetchRevisionReports=function fetchRevisionReports(slug,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){dispatch(requestRevision());dispatch(revisionClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reports__["u" /* reportsSummary */])(modality,state,mun)).then(function(summary){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summary.payload)){switch(slug){case'project-report-goals':return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reports__["t" /* reportsFinancial */])(modality,state,mun)).then(function(financial){if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(financial.payload)){if(modality==='modalidad-ii'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__entities__["a" /* entitiesList */])());return dispatch(revisionReports(slug,modality,state,mun));}else{return dispatch(revisionReports(slug,modality,state,mun));}}else{return dispatch(failedRevision('Carga Incompleta'));}});case'project-report-expenses':if(modality==='modalidad-ii'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__entities__["a" /* entitiesList */])());return dispatch(revisionReports(slug,modality,state,mun));}else{return dispatch(revisionReports(slug,modality,state,mun));}default:if(modality==='modalidad-ii'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__entities__["a" /* entitiesList */])());return dispatch(revisionReports(slug,modality,state,mun));}else{return dispatch(revisionReports(slug,modality,state,mun));}}}else{return dispatch(failedRevision('Carga Incompleta'));}});};};var revisionReports=function revisionReports(slug,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){//dispatch(requestRevision());
//dispatch(revisionClear());
var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//return fetch(`${API2_URL}/revisions/${modality}/${state}${mun !== undefined ? '/'+mun : ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/report/"+slug+"/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){switch(slug){case'project-report-goals':return dispatch(revisionReportsFinancial(json));case'project-report-expenses':return dispatch(revisionReportsExpenses(json));default:return dispatch(revisionReportsSummary(json));}},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveRevisionReportsFinancial=function saveRevisionReportsFinancial(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(requestRevision());var financialSave=values.reports.financial;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({notification_type_id:financialSave.notification_type_id,body:JSON.stringify(financialSave.body)})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/report/project-report-goals/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options)//return fetch(`${API2_URL}/revisions/project/report/project-report-goals/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
.then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));return dispatch(revisionReportsFinancial(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveRevisionReportsExpenses=function saveRevisionReportsExpenses(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(requestRevision());var expensesSave=values.reports.expenses;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({notification_type_id:expensesSave.notification_type_id,body:JSON.stringify(expensesSave.body)})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/report/project-report-expenses/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options)//return fetch(`${API2_URL}/revisions/project/report/project-report-expenses/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
.then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));return dispatch(revisionReportsExpenses(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var saveRevisionReportsSummary=function saveRevisionReportsSummary(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(requestRevision());var summarySave=values.reports.summary;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({notification_type_id:summarySave.notification_type_id,body:JSON.stringify(summarySave.body)})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/project/report/project-report-summary/"+modality+"/"+state+(mun?"/"+mun:'')+"?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La revisión se guardó correctamente',type:"success"}));return dispatch(revisionReportsSummary(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var revisionOwner=function revisionOwner(json){var phase='project-owner';var owner=undefined;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(json.data)){owner=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(json.data,{project_version_phase:{version_phase:{phase:{slug:phase}}}});}else{owner=json.data;}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_205" /* REVISION_OWNER */],payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(owner)?{body:undefined,phase_slug:phase}:Object.assign({},owner,{body:JSON.parse(owner.body),phase_slug:phase}),phase_group:json.phase_group,permissions:json.permissions,timestamp:Date.now()};};var revisionInstance=function revisionInstance(json){var phase='project-agency';var instance=undefined;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(json.data)){instance=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(json.data,{project_version_phase:{version_phase:{phase:{slug:phase}}}});}else{instance=json.data;}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_204" /* REVISION_INSTANCE */],payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(instance)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},instance,{body:JSON.parse(instance.body),phase_slug:phase}),phase_group:json.phase_group,notifications_types:json.notifications_types,permissions:json.permissions,timestamp:Date.now()};};var revisionRegistry=function revisionRegistry(json){var phase='project-goals';var registry=undefined;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(json.data)){registry=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(json.data,{project_version_phase:{version_phase:{phase:{slug:phase}}}});}else{registry=json.data;}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_207" /* REVISION_REGISTRY */],payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registry)?{body:undefined,phase_slug:phase}:Object.assign({},registry,{body:JSON.parse(registry.body),phase_slug:phase}),permissions:json.permissions,timestamp:Date.now()};};var revisionExpenses=function revisionExpenses(json){var phase='project-expenses';var expenses=undefined;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(json.data)){expenses=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(json.data,{project_version_phase:{version_phase:{phase:{slug:phase}}}});}else{expenses=json.data;}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_202" /* REVISION_EXPENSES */],payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(expenses)?{body:undefined,phase_slug:phase}:Object.assign({},expenses,{body:JSON.parse(expenses.body),phase_slug:phase}),permissions:json.permissions,timestamp:Date.now()};};var revisionProfiles=function revisionProfiles(json){var phase='project-profiles';var profiles=undefined;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(json.data)){profiles=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(json.data,{project_version_phase:{version_phase:{phase:{slug:phase}}}});}else{profiles=json.data;}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_206" /* REVISION_PROFILES */],payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(profiles)?{body:undefined,phase_slug:phase}:Object.assign({},profiles,{body:JSON.parse(profiles.body),phase_slug:phase}),permissions:json.permissions,timestamp:Date.now()};};var revisionConclusion=function revisionConclusion(json){var phase='project-conclusion';var conclusion=undefined;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(json.data)){conclusion=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(json.data,{project_version_phase:{version_phase:{phase:{slug:phase}}}});return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_200" /* REVISION_CONCLUSION */],payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(conclusion)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},conclusion,{body:JSON.parse(conclusion.body),phase_slug:phase}),phase_group:json.phase_group,notifications_types:json.notifications_types,permissions:json.permissions,timestamp:Date.now()};}else{conclusion=json.data;return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_201" /* REVISION_CONCLUSION_EDIT */],payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(conclusion)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},conclusion,{body:JSON.parse(conclusion.body),phase_slug:phase}),phase_group:json.phase_group,notifications_types:json.notifications_types,permissions:json.permissions,timestamp:Date.now()};}};var revisionAgreementsAdmin=function revisionAgreementsAdmin(json){//let phase = 'project-agency-fiscal-entity-admin';
var phase='project-agreements-agency';var agreements=undefined;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(json.data)){agreements=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(json.data,{project_version_phase:{version_phase:{phase:{slug:phase}}}});//console.log('agreements===>', agreements);
return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_192" /* REVISION_AGREEMENTS_ADMIN */],isFetching:false,payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(agreements)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},agreements,{body:JSON.parse(agreements.body),phase_slug:phase}),phase_group:json.phase_group,notifications_types:json.notifications_types,permissions:json.permissions,timestamp:Date.now()};}else{agreements=json.data;return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_193" /* REVISION_AGREEMENTS_ADMIN_EDIT */],isFetching:false,payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(agreements)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},agreements,{body:JSON.parse(agreements.body),phase_slug:phase}),phase_group:json.phase_group,permissions:json.permissions,timestamp:Date.now()};}};var revisionAgreementsLegal=function revisionAgreementsLegal(json){var phase='project-agency-fiscal-entity-legal';var agreements=undefined;if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(json.data)){agreements=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(json.data,{project_version_phase:{version_phase:{phase:{slug:phase}}}});return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_194" /* REVISION_AGREEMENTS_LEGAL */],isFetching:false,payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(agreements)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},agreements,{body:JSON.parse(agreements.body),phase_slug:phase}),phase_group:json.phase_group,notifications_types:json.notifications_types,permissions:json.permissions,timestamp:Date.now()};}else{agreements=json.data;return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_195" /* REVISION_AGREEMENTS_LEGAL_EDIT */],isFetching:false,payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(agreements)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},agreements,{body:JSON.parse(agreements.body),phase_slug:phase}),phase_group:json.phase_group,permissions:json.permissions,timestamp:Date.now()};}};var revisionReportsFinancial=function revisionReportsFinancial(json){var phase='project-report-goals';var financial=json.data;return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_209" /* REVISION_REPORTS_FINANCIAL */],isFetching:false,payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(financial)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},financial,{body:JSON.parse(financial.body),phase_slug:phase}),phase_group:json.phase_group,notifications_types:json.notifications_types,permissions:json.permissions,timestamp:Date.now()};};var revisionReportsExpenses=function revisionReportsExpenses(json){var phase='project-report-expenses';var expenses=undefined;expenses=json.data;return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_208" /* REVISION_REPORTS_EXPENSES */],isFetching:false,payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(expenses)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},expenses,{body:JSON.parse(expenses.body),phase_slug:phase}),phase_group:json.phase_group,notifications_types:json.notifications_types,permissions:json.permissions,timestamp:Date.now()};};var revisionReportsSummary=function revisionReportsSummary(json){var phase='project-report-summary';var summary=undefined;summary=json.data;return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_210" /* REVISION_REPORTS_SUMMARY */],isFetching:false,payload:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summary)?{notification_type_id:undefined,body:undefined,phase_slug:phase}:Object.assign({},summary,{body:JSON.parse(summary.body),phase_slug:phase}),phase_group:json.phase_group,notifications_types:json.notifications_types,permissions:json.permissions,timestamp:Date.now()};};var failedRevision=function failedRevision(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_203" /* REVISION_FAIL */],isFetching:false,error:error};};var requestRevision=function requestRevision(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_211" /* REVISION_REQUEST */],isFetching:true,timestamp:Date.now()};};var revisionClear=function revisionClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_196" /* REVISION_CLEAR */],payload:{owner:{body:undefined,phase_slug:undefined},instance:{body:[],phase_slug:undefined,notification_type_id:undefined},registry:{body:{},phase_slug:undefined},expenses:{body:{},phase_slug:undefined},profiles:{body:{},phase_slug:undefined},conclusion:{body:{},phase_slug:undefined,notification_type_id:undefined},commission:{spvpu:{},projects:{},project:{},answers:[],finished:false,comments:undefined,revision:undefined},agreements:{admin:{body:{},phase_slug:undefined,notification_type_id:undefined},legal:{body:{},phase_slug:undefined,notification_type_id:undefined}},reports:{financial:{notification_type_id:undefined,body:{},phase_slug:undefined,agency:[]},expenses:{notification_type_id:undefined,body:{},phase_slug:undefined,agency:[]},summary:{notification_type_id:undefined,body:{},phase_slug:undefined}},phase_group:{},notifications_types:[],permissions:[],surveyShow:false},timestamp:Date.now()};};var revisionComplete=function revisionComplete(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_199" /* REVISION_COMPLETE */],isFetching:false,timestamp:Date.now()};};/*Sección para comisiones*/var fetchCommission=function fetchCommission(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(requestRevision());dispatch(commisionsClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/commissions",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionCommission(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var fetchShowCommission=function fetchShowCommission(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//dispatch(commisionsClear());
//dispatch(requestRevision());
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/commissions/"+modality+"/"+state+(mun!==null?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionDataCommission(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var assignCommission=function assignCommission(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post'};dispatch(requestRevision());dispatch(commisionsClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/commissions",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(revisionCommission(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var surveysSaveAnswer=function surveysSaveAnswer(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){/*let answers = [];
			_.map(values.answers,(item) => {
				if(item){
					return answers.push(item)
				}
			})*/var data={};if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(values.answers)){if(values.finished){data={answers:values.answers,finished:values.finished,comments:values.comments!==undefined?values.comments:null};}else{data={answers:values.answers,comments:values.comments!==undefined?values.comments:null};}}var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(data)};dispatch(requestRevision());//return fetch((`${API_URL}/surveys/questions-answers`), options)
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/revisions/commissions?_method=PUT",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La revisión se guardó correctamente",type:"success"}));return dispatch(revisionCommission(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error),type:"danger"}));return dispatch(failedRevision(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(error)));});});};};var revisionCommission=function revisionCommission(json){var answers=[];if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data.spvpu)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data.spvpu.survey_version_phase)){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(json.data.spvpu.survey_version_phase.survey.children_questions,function(q,k){if(q.type==='group'){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(q.children_questions,function(item){if(item.answer){//let answer = _.find(q.answers,{question_id: q.id});
answers.push({spvpu_id:item.answer.spvpu_id,question_id:item.answer.question_id,answer_number:item.answer.answer_number,answer_text:item.answer.answer_text});}});}else{if(q.answer){//let answer = _.find(q.answers,{question_id: q.id});
answers.push({spvpu_id:q.answer.spvpu_id,question_id:q.answer.question_id,answer_number:q.answer.answer_number,answer_text:q.answer.answer_text});}}});}//console.log('answers===>',answers);
return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_197" /* REVISION_COMMISSION */],isFetching:false,payload:Object.assign({},json.data,{answers:answers,project:json.data&&json.data.spvpu?json.data.spvpu.project_version_phase.project:{},comments:json.data&&json.data.spvpu&&json.data.spvpu.comments?json.data.spvpu.comments:undefined,revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{}}),permissions:json.permissions,timestamp:Date.now()};};var revisionDataCommission=function revisionDataCommission(json){var answers=[];if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(json.data.survey_version_phase)){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(json.data.survey_version_phase.survey.children_questions,function(q){if(q.type==='group'){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(q.children_questions,function(item){if(item.answer){//let answer = _.find(q.answers,{question_id: q.id});
answers.push({spvpu_id:item.answer.spvpu_id,question_id:item.answer.question_id,answer_number:item.answer.answer_number,answer_text:item.answer.answer_text});}});}else{if(q.answer){//let answer = _.find(q.answers,{question_id: q.id});
answers.push({spvpu_id:q.answer.spvpu_id,question_id:q.answer.question_id,answer_number:q.answer.answer_number,answer_text:q.answer.answer_text});}}});}//console.log('answers===>',answers);
return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_197" /* REVISION_COMMISSION */],isFetching:false,payload:{spvpu:json.data,answers:answers,project:json.data?json.data.project_version_phase.project:{},comments:json.data&&json.data.comments?json.data.comments:undefined,revision:{}},permissions:json.permissions,timestamp:Date.now()};};var commisionsClear=function commisionsClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_198" /* REVISION_COMMISSION_CLEAR */],isFetching:false,payload:{spvpu:{},projects:{},project:{},answers:[],finished:false,comments:undefined,revision:undefined},timestamp:Date.now()};};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return reportsFinancial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return financialGoalStatusSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return financialGoalDocumentSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return financialGoalDocumentDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return financialGoalInvoicesSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return financialGoalInvoiceDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return financialActivityStatusSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return financialActivityMediaSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return financialActivityMediaDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return financialGoalActorsSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return financialGoalConagoSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return reportsExpenses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expenseInvoicesSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expensesInvoiceDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return expenseReceiptsSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return expensesReceiptDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return reportsEmployees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return reportsEmployeeAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return reportsEmployeeInvoicesSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return reportsEmployeeInvoiceDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return reportsSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return reportsSummaryExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return reportsSummarySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return reportsSurvey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return reportsSurveySave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reportsFinancial=function reportsFinancial(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialRequest());dispatch(reportsFinancialClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(reportsFinancialData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialGoalStatusSave=function financialGoalStatusSave(values,data,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/status/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'El estatus de la meta se guardó correctamente',type:"success"}));return dispatch(financialGoalData(json,values,data,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialGoalDocumentSave=function financialGoalDocumentSave(values,data,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var body=new FormData();__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(values.documents,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startsWith(o,'http://')){body.append("documents["+j+"]",o);}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append("documents["+j+"]",o[0]);}}});if(modality==='modalidad-iii'){if(values.agency_id!==undefined){body.append("agency_id",values.agency_id);}}if(values.comply_rules!==undefined){body.append("comply_rules",values.comply_rules);}if(values.comply_topics!==undefined){body.append("comply_topics",values.comply_topics);}var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/documents/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Archivos guardados correctamente',type:"success"}));return dispatch(financialGoalData(json,values,data,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialGoalDocumentDelete=function financialGoalDocumentDelete(values,data,id,modality,state){var mun=arguments.length>5&&arguments[5]!==undefined?arguments[5]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/documents/"+id+"/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Archivo eliminado correctamente',type:"success"}));return dispatch(financialGoalData(json,values,data,modality,'delete'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialGoalInvoicesSave=function financialGoalInvoicesSave(values,data,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var body=new FormData();var countCdm=0;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys({pdf:values.pdf,xml:values.xml,sat:values.sat},function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});if(modality==='modalidad-iii'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(values.agencies,function(o){var agencyId=undefined;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(o,function(v,k){if(k==='id'){agencyId=v;}if(k==='amount'){if(v!==undefined&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(v)){body.append("agencies["+countCdm+"][agency_id]",agencyId);body.append("agencies["+countCdm+"]["+k+"]",v);countCdm+=1;}}});});}var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/invoices/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{//dispatch(reportsFinancialEditInvoiceFail());
return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));return dispatch(financialGoalInvoiceData(json,values,data,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialGoalInvoiceDelete=function financialGoalInvoiceDelete(values,data,id,modality,state){var mun=arguments.length>5&&arguments[5]!==undefined?arguments[5]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/invoices/"+id+"/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La factura se elimino correctamente',type:"success"}));return dispatch(financialGoalInvoiceData(json,values,data,modality,'delete'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialActivityStatusSave=function financialActivityStatusSave(values,data,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/activity/"+values.pga_id+"/status/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'El estatus de la actividad se guardó correctamente',type:"success"}));return dispatch(financialActivityData(json,values,data,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialActivityMediaSave=function financialActivityMediaSave(values,data,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var body=new FormData();__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(values.documents,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startsWith(o,'http://')){body.append("documents["+j+"]",o);}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append("documents["+j+"]",o[0]);}}});if(modality==='modalidad-iii'){if(values.agency_id!==undefined){body.append("agency_id",values.agency_id);}}var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/activity/"+values.pga_id+"/documents/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Archivos de verificacion correctamente guardados',type:"success"}));return dispatch(financialActivityData(json,values,data,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialActivityMediaDelete=function financialActivityMediaDelete(values,data,id,modality,state){var mun=arguments.length>5&&arguments[5]!==undefined?arguments[5]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/activity/"+values.pga_id+"/documents/"+id+"/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'El archivo se elimino correctamente',type:"success"}));return dispatch(financialActivityData(json,values,data,modality,'delete'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialGoalActorsSave=function financialGoalActorsSave(values,data,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;var actors=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(values.actors,function(item){return actors.push({id:item.id});});return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({actors:actors})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/actors/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Actores guardados correctamente',type:"success"}));return dispatch(financialGoalActorsData(json,values,data,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var financialGoalConagoSave=function financialGoalConagoSave(values,data,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;var conago_clauses=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(values.conago_clauses,function(item){return conago_clauses.push({id:item.id});});return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsFinancialEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({conago_clauses:conago_clauses})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/financial/goal/"+values.project_goal_id+"/conago-clauses/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Clausulas guardados correctamente',type:"success"}));return dispatch(financialGoalConagoData(json,values,data,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsFinancialEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsFinancialData=function reportsFinancialData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_170" /* REPORTS_FINANCIAL */],isFetching:false,payload:Object.assign({},json.data,{editable:json.editable}),revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},version:json.version,permissions:json.permissions,timestamp:Date.now()};};var reportsFinancialRequest=function reportsFinancialRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_177" /* REPORTS_FINANCIAL_REQUEST */],isFetching:true,timestamp:Date.now()};};var financialGoalData=function financialGoalData(json,values,data,mod,action){var response=data;var edit={};response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal]=json.data;if(mod!=='modalidad-iii'){edit=response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_version_phase_goal;}else{var findAgency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_version_phase_goal,{agency_id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(values.agency_id)});edit=findAgency?findAgency:{};}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_176" /* REPORTS_FINANCIAL_GOAL */],isFetching:false,payload:response,edit:Object.assign({},edit,{indexAxis:values.indexAxis,indexGoal:values.indexGoal,action:action}),permissions:json.permissions,timestamp:Date.now()};};var financialGoalInvoiceData=function financialGoalInvoiceData(json,values,data,mod,action){var response=data;var edit={};response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal]=json.data;if(mod!=='modalidad-iii'){edit=response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_version_phase_goal;}else{var findAgency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_version_phase_goal,{agency_id:values.agency_id});edit=findAgency?Object.assign({},findAgency,{agencies:response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].agencies}):{};}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_176" /* REPORTS_FINANCIAL_GOAL */],isFetching:false,payload:response,edit:Object.assign({},edit,{indexAxis:values.indexAxis,indexGoal:values.indexGoal,pdf:undefined,xml:undefined,sat:undefined,action:action}),permissions:json.permissions,timestamp:Date.now()};};var financialActivityData=function financialActivityData(json,values,data,mod,action){var response=data;var edit={};response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_goal_activities[values.indexActivity]=json.data;if(mod!=='modalidad-iii'){edit=response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_goal_activities[values.indexActivity].project_version_phase_goal_activity;}else{var findAgency=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].project_goal_activities[values.indexActivity].project_version_phase_goal_activity,{agency_id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(values.agency_id)});edit=findAgency?findAgency:{};}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_171" /* REPORTS_FINANCIAL_ACTIVITY */],isFetching:false,payload:response,edit:Object.assign({},edit,{project_goal_id:values.project_goal_id,indexAxis:values.indexAxis,indexGoal:values.indexGoal,indexActivity:values.indexActivity,action:action}),permissions:json.permissions,timestamp:Date.now()};};var financialGoalActorsData=function financialGoalActorsData(json,values,data,mod,action){var response=data;response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal]=json.data;var edit=response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].actors;return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_176" /* REPORTS_FINANCIAL_GOAL */],isFetching:false,payload:response,edit:Object.assign({},edit,{indexAxis:values.indexAxis,indexGoal:values.indexGoal,action:action}),permissions:json.permissions,timestamp:Date.now()};};var financialGoalConagoData=function financialGoalConagoData(json,values,data,mod,action){var response=data;response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal]=json.data;var edit=response.proigualdad_axis[values.indexAxis].project_goals[values.indexGoal].conago_clauses;return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_176" /* REPORTS_FINANCIAL_GOAL */],isFetching:false,payload:response,edit:Object.assign({},edit,{indexAxis:values.indexAxis,indexGoal:values.indexGoal,action:action}),permissions:json.permissions,timestamp:Date.now()};};var reportsFinancialEditRequest=function reportsFinancialEditRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_174" /* REPORTS_FINANCIAL_EDIT_REQUEST */],isFetching:true,timestamp:Date.now()};};/*
const reportsFinancialEditInvoiceFail = () => {
	return{
		type: REPORTS_FINANCIAL_EDIT_INVOICE_FAIL,
		show: true,
		timestamp: Date.now()
	}
};*/var reportsFinancialEditFail=function reportsFinancialEditFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_173" /* REPORTS_FINANCIAL_EDIT_FAIL */],isFetching:false,payload:error,timestamp:Date.now()};};var reportsFinancialClear=function reportsFinancialClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_172" /* REPORTS_FINANCIAL_CLEAR */],payload:{},timestamp:Date.now()};};var reportsFinancialFail=function reportsFinancialFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_175" /* REPORTS_FINANCIAL_FAIL */],isFetching:false,payload:error,timestamp:Date.now()};};var reportsExpenses=function reportsExpenses(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsExpensesRequest());dispatch(reportsExpensesClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/expenses/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(reportsExpensesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsExpensesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var expenseInvoicesSave=function expenseInvoicesSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsExpensesEditRequest());var body=new FormData();var countCdm=0;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys({pdf:values.pdf,xml:values.xml,sat:values.sat},function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});if(modality==='modalidad-iii'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(values.agencies,function(o){var agencyId=undefined;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(o,function(v,k){if(k==='id'){agencyId=v;}if(k==='amount'){if(v!==undefined&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(v)){body.append("agencies["+countCdm+"][agency_id]",agencyId);body.append("agencies["+countCdm+"]["+k+"]",v);countCdm+=1;}}});});}var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/expenses/"+values.project_expense_id+"/invoices/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Factura guardada correctamente',type:"success"}));return dispatch(reportsExpensesEditData(json,values,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsExpensesEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var expensesInvoiceDelete=function expensesInvoiceDelete(values,id,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsExpensesEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/expenses/"+values.project_expense_id+"/invoices/"+id+"/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La factura se elimino correctamente',type:"success"}));return dispatch(reportsExpensesEditData(json,values,modality,'delete'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsExpensesEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var expenseReceiptsSave=function expenseReceiptsSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsExpensesEditRequest());var body=new FormData();var countCdm=0;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys({file:values.file,total:values.total,date:values.date,concepts:values.concepts},function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});if(modality==='modalidad-iii'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(values.agencies,function(o){var agencyId=undefined;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(o,function(v,k){if(k==='id'){agencyId=v;}if(k==='amount'){if(v!==undefined&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(v)){body.append("agencies["+countCdm+"][agency_id]",agencyId);body.append("agencies["+countCdm+"]["+k+"]",v);countCdm+=1;}}});});}var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/expenses/"+values.project_expense_id+"/receipts/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Comprobante guardada correctamente',type:"success"}));return dispatch(reportsExpensesEditData(json,values,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsExpensesEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var expensesReceiptDelete=function expensesReceiptDelete(values,id,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsExpensesEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/expenses/"+values.project_expense_id+"/receipts/"+id+"/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La factura se elimino correctamente',type:"success"}));return dispatch(reportsExpensesEditData(json,values,modality,'delete'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsExpensesEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsExpensesData=function reportsExpensesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_163" /* REPORTS_EXPENSES */],isFetching:false,payload:Object.assign({},json.data,{editable:json.editable}),revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},version:json.version,permissions:json.permissions,timestamp:Date.now()};};var reportsExpensesRequest=function reportsExpensesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_169" /* REPORTS_EXPENSES_REQUEST */],isFetching:true,timestamp:Date.now()};};var reportsExpensesClear=function reportsExpensesClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_164" /* REPORTS_EXPENSES_CLEAR */],payload:{},timestamp:Date.now()};};var reportsExpensesFail=function reportsExpensesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_168" /* REPORTS_EXPENSES_FAIL */],isFetching:false,payload:error,timestamp:Date.now()};};var reportsExpensesEditData=function reportsExpensesEditData(json,values,mod,action){var edit={};if(mod!=='modalidad-iii'){edit=json.data.project_expenses[values.indexExpense].project_version_phase_expense;}else{edit=Object.assign({},json.data.project_expenses[values.indexExpense].project_version_phase_expense,{agencies:json.data.agencies});}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_165" /* REPORTS_EXPENSES_EDIT */],isFetching:false,payload:Object.assign({},json.data,{editable:json.editable}),edit:Object.assign({},edit,{indexExpense:values.indexExpense,pdf:undefined,xml:undefined,sat:undefined,file:undefined,total:undefined,date:undefined,concepts:undefined,action:action}),permissions:json.permissions,timestamp:Date.now()};};var reportsExpensesEditRequest=function reportsExpensesEditRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_167" /* REPORTS_EXPENSES_EDIT_REQUEST */],isFetching:true,timestamp:Date.now()};};var reportsExpensesEditFail=function reportsExpensesEditFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_166" /* REPORTS_EXPENSES_EDIT_FAIL */],isFetching:false,payload:error,timestamp:Date.now()};};var reportsEmployees=function reportsEmployees(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsEmployeesRequest());dispatch(reportsEmployeesClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/employees/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(reportsEmployeesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsEmployeesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsEmployeeAdd=function reportsEmployeeAdd(values,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsEmployeesEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/employees/goal/"+values.project_goal_id+"/employee/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'El registro se guardó correctamente',type:"success"}));return dispatch(reportsEmployeesEditData(json,values,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsEmployeesEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsEmployeeInvoicesSave=function reportsEmployeeInvoicesSave(values,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsEmployeesEditRequest());var body=new FormData();__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys({pdf:values.pdf,xml:values.xml,sat:values.sat},function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});if(modality==='modalidad-iii'){if(values.agency_id!==undefined){body.append("agency_id",values.agency_id);}}var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/employees/employee/"+values.id+"/invoices/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{//dispatch(reportsFinancialEditInvoiceFail());
return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));return dispatch(reportsEmployeesEditData(json,values,modality,'close'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsEmployeesEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsEmployeeInvoiceDelete=function reportsEmployeeInvoiceDelete(values,id,modality,state){var mun=arguments.length>4&&arguments[4]!==undefined?arguments[4]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsEmployeesEditRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/employees/employee/"+values.id+"/invoices/"+id+"/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'La factura se elimino correctamente',type:"success"}));return dispatch(reportsEmployeesEditData(json,values,modality,'delete'));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsEmployeesEditFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsEmployeesData=function reportsEmployeesData(json){var revision=json.revision;var employees=[];var agencies=[];if(json.data&&json.data.project_goals){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(json.data.project_goals,function(item){if(item.project_goal_agencies){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(item.project_goal_agencies,function(goal){if(goal.agency){agencies.push(Object.assign({},goal.agency));}if(goal.employees){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(goal.employees,function(emp){var data={};__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(emp,function(i,k){data=Object.assign({},data,_defineProperty({},k,i?i:undefined));});employees.push(Object.assign({},data,{agency_id:goal.agency_id,project_goal_id:goal.project_goal_id,agency:Object.assign({},goal.agency)}));});}});}});}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(json.revision)){revision=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(json.revisions,{project_version_phase:{version_phase:{phase:{slug:'project-report-goals'}}}});}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_156" /* REPORTS_EMPLOYEES */],isFetching:false,payload:Object.assign({},json.data,{employees:employees,agencies:agencies,editable:json.editable}),revision:revision?Object.assign({},revision,{body:JSON.parse(revision.body)}):{},version:json.version,permissions:json.permissions,timestamp:Date.now()};};var reportsEmployeesRequest=function reportsEmployeesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_162" /* REPORTS_EMPLOYEES_REQUEST */],isFetching:true,timestamp:Date.now()};};var reportsEmployeesClear=function reportsEmployeesClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_157" /* REPORTS_EMPLOYEES_CLEAR */],payload:{},timestamp:Date.now()};};var reportsEmployeesFail=function reportsEmployeesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_161" /* REPORTS_EMPLOYEES_FAIL */],isFetching:false,payload:error,timestamp:Date.now()};};var reportsEmployeesEditData=function reportsEmployeesEditData(json,values,mod,action){var index=undefined;var employees=[];var agencies=[];if(json.data&&json.data.project_goals){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(json.data.project_goals,function(item){if(item.project_goal_agencies){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(item.project_goal_agencies,function(goal){if(goal.agency){agencies.push(Object.assign({},goal.agency));}if(goal.employees){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(goal.employees,function(emp){var data={};__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(emp,function(i,k){data=Object.assign({},data,_defineProperty({},k,i?i:undefined));});employees.push(Object.assign({},data,{agency_id:goal.agency_id,project_goal_id:goal.project_goal_id,agency:Object.assign({},goal.agency)}));});}});}});}if(values.indexEmployees){index=values.indexEmployees;}else{index=employees.length-1;}var edit={};edit=employees[index];return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_158" /* REPORTS_EMPLOYEES_EDIT */],isFetching:false,payload:Object.assign({},json.data,{employees:employees,agencies:agencies,editable:json.editable}),edit:Object.assign({},edit,{indexEmployees:values.indexEmployees,pdf:undefined,xml:undefined,sat:undefined,action:action}),permissions:json.permissions,timestamp:Date.now()};};var reportsEmployeesEditRequest=function reportsEmployeesEditRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_160" /* REPORTS_EMPLOYEES_EDIT_REQUEST */],isFetching:true,timestamp:Date.now()};};var reportsEmployeesEditFail=function reportsEmployeesEditFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_159" /* REPORTS_EMPLOYEES_EDIT_FAIL */],isFetching:false,payload:error,timestamp:Date.now()};};var reportsSummary=function reportsSummary(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsSummaryRequest());dispatch(reportsSummaryClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/summary/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(reportsSummaryData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsSummaryFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsSummaryExport=function reportsSummaryExport(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsSummaryRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/summary/"+modality+"/"+state+(mun!==undefined?'/'+mun:'')+"?export=1",options).then(function(result){if(result.status>=200&&result.status<300){return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){var today=new Date();var date=today.getFullYear()+(today.getMonth()+1<10?"0"+(today.getMonth()+1):today.getMonth()+1)+(today.getDate()<10?"0"+today.getDate():today.getDate())+today.getHours()+today.getMinutes()+today.getSeconds();__WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(blob,"resumen_informe_de_vance_f\xEDsico_y_financiero_"+state+(mun!==undefined?'_'+mun:'')+"_"+date+".pdf");dispatch(reportsSummaryComplete());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsSummaryFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsSummarySave=function reportsSummarySave(values,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsSummaryRequest());var body=new FormData();__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapKeys(values,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/summary/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Resumen guardado exitosamente',type:"success"}));return dispatch(reportsSummaryData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsSummaryFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsSummaryData=function reportsSummaryData(json){var documents={};if(json.data.project_version_phase_group&&json.data.project_version_phase_group.documents){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(json.data.project_version_phase_group.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_178" /* REPORTS_SUMMARY */],isFetching:false,payload:Object.assign({},json.data,{editable:json.editable,finished:json.finished,documents_items:json.documents_items}),edit:Object.assign({},documents,{finished:json.finished}),revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},phase_group:json.phase_group,permissions:json.permissions,version:json.version,timestamp:Date.now()};};var reportsSummaryRequest=function reportsSummaryRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_182" /* REPORTS_SUMMARY_REQUEST */],isFetching:true,timestamp:Date.now()};};var reportsSummaryComplete=function reportsSummaryComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_180" /* REPORTS_SUMMARY_COMPLETE */],isFetching:false,timestamp:Date.now()};};var reportsSummaryClear=function reportsSummaryClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_179" /* REPORTS_SUMMARY_CLEAR */],payload:{},timestamp:Date.now()};};var reportsSummaryFail=function reportsSummaryFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_181" /* REPORTS_SUMMARY_FAIL */],isFetching:false,payload:error,timestamp:Date.now()};};var reportsSurvey=function reportsSurvey(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsSurveyRequest());dispatch(reportsSurveyClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/survey/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(reportsSurveyData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsSurveyFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});};};var reportsSurveySave=function reportsSurveySave(values,modality,state){var mun=arguments.length>3&&arguments[3]!==undefined?arguments[3]:undefined;return function(dispatch){var answers=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(values.children_questions,function(item){if(item.type==="group"){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(item.children_questions,function(q){if(q.answer!==null&&q.answer!==undefined){return answers.push({question_id:q.id,answer:q.answer});}});}else{if(item.answer!==null&&item.answer!==undefined){return answers.push({question_id:item.id,answer:item.answer});}}});if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(answers)){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(reportsSurveyRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({answers:answers})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/projects/reports/survey/"+modality+"/"+state+(mun!==undefined?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));return dispatch(reportsSurveyData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error),type:"danger"}));return dispatch(reportsSurveyFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(error)));});});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:'Favor de contestar las preguntas antes de guardar',type:'danger'}));return dispatch(reportsSurveyFail('Favor de contestar las preguntas antes de guardar'));}};};var reportsSurveyData=function reportsSurveyData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_183" /* REPORTS_SURVEYS */],isFetching:false,payload:Object.assign({},json.data,{editable:json.editable}),version:json.version,permissions:json.permissions,timestamp:Date.now()};};var reportsSurveyRequest=function reportsSurveyRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_186" /* REPORTS_SURVEYS_REQUEST */],isFetching:true,timestamp:Date.now()};};var reportsSurveyClear=function reportsSurveyClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_184" /* REPORTS_SURVEYS_CLEAR */],payload:{},timestamp:Date.now()};};var reportsSurveyFail=function reportsSurveyFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_185" /* REPORTS_SURVEYS_FAIL */],isFetching:false,payload:error,timestamp:Date.now()};};

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return phasesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return phasesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phaseEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return phaseSave; });
/* harmony export (immutable) */ __webpack_exports__["a"] = phaseDelete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
/* Phases Show */var phasesShow=function phasesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(phasesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/phases?include[0]=status&page="+page,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(phasesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(phasesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Phases Show */var phasesList=function phasesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(phasesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/phases?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(phasesListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(phasesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Phase Edit */var phaseEdit=function phaseEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(phasesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/phases/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(phasesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(phasesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Phase Save */var phaseSave=function phaseSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(phasesRequest());var body=new FormData();__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(values,function(o,j){if(j==='documents_items'){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(values.documents_items,function(item,key){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(item,function(d,n){if(n==='documents_types'){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(d,function(i,k){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(i,function(t,s){if(t!==undefined&&t!==null){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(t)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.startsWith(t,'http://')){body.append(j+"["+key+"]["+n+"]["+k+"]["+s+"]",t);}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(t)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(t)&&t[0]!==undefined){body.append(j+"["+key+"]["+n+"]["+k+"]["+s+"]",t[0]);}}});});}else{if(d!==undefined&&d!==null){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(d)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.startsWith(d,'http://')){body.append(j+"["+key+"]["+n+"]",d);}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(d)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(d)&&d[0]!==undefined){body.append(j+"["+key+"]["+n+"]",d[0]);}}}});});}else{if(o!==undefined&&o!==null){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}}});var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/phases"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El Sub-proceso se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/fases/editar/"+json.data.id);}return dispatch(phasesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(phasesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Section Delete */function phaseDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'DELETE'};dispatch(phasesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/phases/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El Sub-proceso se ha borrado Exitosamente",type:"success"}));dispatch(phasesShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(phasesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};}/*Request*/var phasesRequest=function phasesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_77" /* PHASES_REQUEST */],isFetching:true,timestamp:Date.now()};};var phasesData=function phasesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_78" /* PHASES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var phasesListData=function phasesListData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_76" /* PHASES_LIST */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var phasesEditData=function phasesEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_79" /* PHASE_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};/*Fail*/var phasesFail=function phasesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_75" /* PHASES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGroupsPhasesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGroupsPhasesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchGroupPhaseEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return groupPhaseSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return groupPhaseDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
var fetchGroupsPhasesShow=function fetchGroupsPhasesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(groupsRequest());return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/phases/groups?include[0]=status&page="+page,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(groupsListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(groupsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var fetchGroupsPhasesList=function fetchGroupsPhasesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(groupsRequest());return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/phases/groups?include[0]=status&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(groupsListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(groupsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var fetchGroupPhaseEdit=function fetchGroupPhaseEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(groupsRequest());dispatch(groupsClear());return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/phases/groups/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(groupsEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(groupsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var groupPhaseSave=function groupPhaseSave(data){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(data)};dispatch(groupsRequest());return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/phases/groups"+(data.id?"/"+data.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message,type:"success"}));if(data.id){return dispatch(groupsEditData(json));}else{__WEBPACK_IMPORTED_MODULE_4__store_store__["b" /* history */].push("/fases/grupos/editar/"+json.data.id);}},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(groupsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var groupPhaseDelete=function groupPhaseDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(groupsRequest());return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/phases/groups/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(fetchGroupsPhasesShow());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message,type:"success"}));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(groupsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var groupsRequest=function groupsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_19" /* GROUPS_PHASES_REQUEST */],isFetching:true,timestamp:Date.now()};};var groupsListData=function groupsListData(json){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_18" /* GROUPS_PHASES_LIST */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var groupsEditData=function groupsEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_16" /* GROUPS_PHASES_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var groupsClear=function groupsClear(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_15" /* GROUPS_PHASES_CLEAR */],payload:{},timestamp:Date.now()};};var groupsFail=function groupsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_17" /* GROUPS_PHASES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchNotificationsTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchNotificationsTypesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return notificationTypeEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notificationTypeEditSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(15);
var fetchNotificationsTypes=function fetchNotificationsTypes(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(NotificationTypeRequest());return __WEBPACK_IMPORTED_MODULE_3_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/notifications/types?include[0]=status&page="+page,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(NotificationTypeData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(NotificationTypeFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var fetchNotificationsTypesList=function fetchNotificationsTypesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(NotificationTypeRequest());return __WEBPACK_IMPORTED_MODULE_3_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/notifications/types?include[0]=status&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(NotificationTypeData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(NotificationTypeFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var notificationTypeEdit=function notificationTypeEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(NotificationTypeRequest());dispatch(NotificationTypeClear());return __WEBPACK_IMPORTED_MODULE_3_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/notifications/types/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(NotificationTypeEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(NotificationTypeFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var notificationTypeEditSave=function notificationTypeEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(NotificationTypeRequest());return __WEBPACK_IMPORTED_MODULE_3_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/notifications/types"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message,type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_5__store_store__["b" /* history */].push("/notificaciones/editar/"+json.data.id);}return dispatch(NotificationTypeEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(NotificationTypeFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var NotificationTypeRequest=function NotificationTypeRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_61" /* NOTIFICATION_TYPE_REQUEST */],isFetching:true,timestamp:Date.now()};};var NotificationTypeData=function NotificationTypeData(json){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_62" /* NOTIFICATION_TYPE_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var NotificationTypeEditData=function NotificationTypeEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_59" /* NOTIFICATION_TYPE_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var NotificationTypeClear=function NotificationTypeClear(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_58" /* NOTIFICATION_TYPE_CLEAR */],payload:{},timestamp:Date.now()};};var NotificationTypeFail=function NotificationTypeFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_60" /* NOTIFICATION_TYPE_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return surveysShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSurveysList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return surveysFetchTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchSurvey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return surveySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return surveyDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
var surveysShow=function surveysShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(surveysRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/surveys?page="+page,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(surveysData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(surveysFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var fetchSurveysList=function fetchSurveysList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(surveysRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/surveys?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(surveysListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(surveysFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var surveysFetchTypes=function surveysFetchTypes(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(surveysTypesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/surveys/types",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(surveysTypes(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(surveysFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var fetchSurvey=function fetchSurvey(id){return function(dispatch){dispatch(surveysRequest());dispatch(surveysClear());return dispatch(surveysEdit(id)).then(function(survey){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(survey.payload)){return dispatch(surveysComplete());}});};};var surveysEdit=function surveysEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/surveys/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(surveysEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(surveysFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var surveySave=function surveySave(values){return function(dispatch){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.children_questions)){dispatch(surveysRequest());return dispatch(surveyEditSave(values)).then(function(surveys){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(surveys.payload)){return dispatch(surveysComplete());/*return dispatch(surveyQuestionsEditSave(values, questions, surveys.payload.id))
						.then((questions) => {
							if(!_.isEmpty(questions.payload)){
								if(values.id){
									return dispatch(surveysComplete())
								}
							}
						})*/}});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:"La Encuesta debe de contener minimo una pregunta",type:"danger"}));return dispatch(surveysFail("La Encuesta debe de contener minimo una pregunta"));}};};var surveyEditSave=function surveyEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/surveys"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La Encuesta se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/encuestas/editar/"+json.data.id);}return dispatch(surveysEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(surveysFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var surveyDelete=function surveyDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'Delete'};dispatch(surveysRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/surveys/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.messaje:"La Encuesta se ha borrado correctamente",type:"success"}));dispatch(surveysComplete());dispatch(surveysShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(surveysFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var surveysRequest=function surveysRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_238" /* SURVEYS_REQUEST */],isFetching:true,timestamp:Date.now()};};var surveysTypesRequest=function surveysTypesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_239" /* SURVEYS_TYPES_REQUEST */],isFetching:true,timestamp:Date.now()};};var surveysData=function surveysData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_234" /* SURVEYS_FETCH */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var surveysListData=function surveysListData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_235" /* SURVEYS_FETCH_LIST */],isFetching:false,payload:json.data,timestamp:Date.now()};};var surveysTypes=function surveysTypes(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_236" /* SURVEYS_FETCH_TYPES */],isFetching:false,payload:json.data,timestamp:Date.now()};};var surveysEditData=function surveysEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_232" /* SURVEYS_EDIT */],payload:json.data,permissions:json.permissions,timestamp:Date.now()};};/*const surveysQuestionsEditData = (json) => {
	return {
		type: SURVEYS_QUESTIONS_EDIT,
		payload: json,
		timestamp: Date.now()
	};
}*/var surveysClear=function surveysClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_230" /* SURVEYS_CLEAR */],payload:{questions:[]},timestamp:Date.now()};};var surveysComplete=function surveysComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_231" /* SURVEYS_COMPLETE */],isFetching:false,timestamp:Date.now()};};var surveysFail=function surveysFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_233" /* SURVEYS_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var _createClass=function(){function e(e,a){for(var t=0;t<a.length;t++){var s=a[t];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,s.key,s)}}return function(a,t,s){return t&&e(a.prototype,t),s&&e(a,s),a}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(6),_propTypes2=_interopRequireDefault(_propTypes),_paginator=__webpack_require__(462),_paginator2=_interopRequireDefault(_paginator),_Page=__webpack_require__(463),_Page2=_interopRequireDefault(_Page),_classnames=__webpack_require__(119),_classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _classCallCheck(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,a){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!a||"object"!=typeof a&&"function"!=typeof a?e:a}function _inherits(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function, not "+typeof a);e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),a&&(Object.setPrototypeOf?Object.setPrototypeOf(e,a):e.__proto__=a)}var Pagination=function(e){function a(){return _classCallCheck(this,a),_possibleConstructorReturn(this,(a.__proto__||Object.getPrototypeOf(a)).apply(this,arguments))}return _inherits(a,_react2.default.Component),_createClass(a,[{key:"isFirstPageVisible",value:function(e){var a=this.props,t=a.hideDisabled;a.hideNavigation;return!(a.hideFirstLastPages||t&&!e)}},{key:"isPrevPageVisible",value:function(e){var a=this.props,t=a.hideDisabled;return!(a.hideNavigation||t&&!e)}},{key:"isNextPageVisible",value:function(e){var a=this.props,t=a.hideDisabled;return!(a.hideNavigation||t&&!e)}},{key:"isLastPageVisible",value:function(e){var a=this.props,t=a.hideDisabled;a.hideNavigation;return!(a.hideFirstLastPages||t&&!e)}},{key:"buildPages",value:function(){for(var e=[],a=this.props,t=a.itemsCountPerPage,s=a.pageRangeDisplayed,i=a.activePage,r=a.prevPageText,l=a.nextPageText,n=a.firstPageText,u=a.lastPageText,o=a.totalItemsCount,p=a.onChange,c=a.activeClass,g=a.itemClass,_=a.itemClassFirst,f=a.itemClassPrev,d=a.itemClassNext,h=a.itemClassLast,C=a.activeLinkClass,P=a.disabledClass,b=(a.hideDisabled,a.hideNavigation,a.linkClass),v=a.linkClassFirst,m=a.linkClassPrev,k=a.linkClassNext,y=a.linkClassLast,x=(a.hideFirstLastPages,a.getPageUrl),T=new _paginator2.default(t,s).build(o,i),D=T.first_page;D<=T.last_page;D++)e.push(_react2.default.createElement(_Page2.default,{isActive:D===i,key:D,href:x(D),pageNumber:D,pageText:D+"",onClick:p,itemClass:g,linkClass:b,activeClass:c,activeLinkClass:C}));return this.isPrevPageVisible(T.has_previous_page)&&e.unshift(_react2.default.createElement(_Page2.default,{key:"prev"+T.previous_page,pageNumber:T.previous_page,onClick:p,pageText:r,isDisabled:!T.has_previous_page,itemClass:(0,_classnames2.default)(g,f),linkClass:(0,_classnames2.default)(b,m),disabledClass:P})),this.isFirstPageVisible(T.has_previous_page)&&e.unshift(_react2.default.createElement(_Page2.default,{key:"first",pageNumber:1,onClick:p,pageText:n,isDisabled:!T.has_previous_page,itemClass:(0,_classnames2.default)(g,_),linkClass:(0,_classnames2.default)(b,v),disabledClass:P})),this.isNextPageVisible(T.has_next_page)&&e.push(_react2.default.createElement(_Page2.default,{key:"next"+T.next_page,pageNumber:T.next_page,onClick:p,pageText:l,isDisabled:!T.has_next_page,itemClass:(0,_classnames2.default)(g,d),linkClass:(0,_classnames2.default)(b,k),disabledClass:P})),this.isLastPageVisible(T.has_next_page)&&e.push(_react2.default.createElement(_Page2.default,{key:"last",pageNumber:T.total_pages,onClick:p,pageText:u,isDisabled:T.current_page===T.total_pages,itemClass:(0,_classnames2.default)(g,h),linkClass:(0,_classnames2.default)(b,y),disabledClass:P})),e}},{key:"render",value:function(){var e=this.buildPages();return _react2.default.createElement("ul",{className:this.props.innerClass},e)}}]),a}();Pagination.defaultProps={itemsCountPerPage:10,pageRangeDisplayed:5,activePage:1,prevPageText:"⟨",firstPageText:"«",nextPageText:"⟩",lastPageText:"»",innerClass:"pagination",itemClass:void 0,linkClass:void 0,activeLinkClass:void 0,hideFirstLastPages:!1,getPageUrl:function(e){return"#"}},exports.default=Pagination;

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_rating__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalEditForm=function(_Component){_inherits(GoalEditForm,_Component);_createClass(GoalEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,goals=_props.goals,activities=_props.activities,entities=_props.entities,axis=_props.axis,lines=_props.lines,modalities=_props.modalities,status=_props.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'goals.edit',onSubmit:function onSubmit(goals){return _this2._submitForm(goals);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre de la Meta ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.name',id:'name',className:'textarea',placeholder:'Nombre de la Meta',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'type',className:'label'},'Tipo de meta ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.type',id:'type',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Tipo de meta ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'RI'},'Rumbo a la Igualdad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'MT'},'Meta Tipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'MI'},'Meta IMEF'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.type',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar el tipo de meta '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'modality_id',className:'label'},'Categor\xEDa ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.modality_id',id:'modality_id',parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],changeAction:function changeAction(model,value){_this2.props.change(model,value);_this2.props.reset('goals.edit.activities');},errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Categor\xEDa ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(modalities.list,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:option.id,key:k},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.modality_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar una modalidad.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'agenciable_id',className:'label'},'Estado '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.agenciable_id',id:'agenciable_id',parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Estado ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(entities.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.agenciable_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estado es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'status',className:'label'},'Estatus ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.status_id',id:'status',className:'select',validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.status_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'goal_document',className:'label'},'Documento Meta '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.goal_document',id:'goal_document',className:'input',placeholder:'Documento Meta'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'axis_id',className:'label'},'Eje tem\xE1tico ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.axis_id',id:'axis_id',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Eje tem\xE1tico ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(axis.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.axis_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar un eje temático. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'line_id',className:'label'},'L\xEDneas de Acci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.line_id',id:'line_id',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- L\xEDneas de Acci\xF3n ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(lines.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.code+' '+(option.name.length>100?option.name.substring(0,100)+'...':option.name));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.line_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar una línea de acción. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'requires_employees',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.requires_employees',id:'requires_employees',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Requiere contratar personas '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'mandatory',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.mandatory',id:'mandatory',isToggle:true,changeAction:function changeAction(model,value){return _this2._handleChangeMandatory(model,value,goals.edit.activities);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Obligatorio ')))))))),goals.edit.modality_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Listado de Actividades de la Meta ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(activities.list,{modalities:[{id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toInteger(goals.edit.modality_id)}]}),function(item,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box is-radiusless',onClick:function onClick(){_this2._showGroup(item.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'heading'},'Grupo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title is-6 has-text-primary'},item.name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-grey',style:{fontWeight:'normal'}},'(',__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(item.activities),')'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon',style:{color:'#fff'}},_this2.state.groupId===item.id&&_this2.state.showGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-up fa-lg'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-down fa-lg'})))))),_this2.state.groupId===item.id&&_this2.state.showGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth',style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(item.activities,function(row,k){var initial=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findKey(goals.edit.activities,{id:row.id})!==undefined?1:0;var initialMandatory=undefined;if(goals.edit.mandatory){initialMandatory=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findKey(goals.edit.activities,{id:row.id,mandatory:true})!==undefined?1:0;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',onClick:function onClick(){return _this2._addActivity(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_rating__["a" /* default */],{ref:'activity-'+row.id,id:'activity-'+row.id,initialRating:initial,start:0,stop:1,step:1,emptySymbol:'fa fa-square-o fa-lg',fullSymbol:'fa fa-check-square-o fa-lg',className:'has-text-primary'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'activity-'+row.id},row.name)),goals.edit.mandatory?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:15+'%'}},initial?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-text-centered',onClick:function onClick(){return _this2._addMandatory(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_rating__["a" /* default */],{ref:'mandatory-'+row.id,id:'mandatory-'+row.id,initialRating:initialMandatory,start:0,stop:1,step:1,emptySymbol:'fa fa-square-o fa-2x',fullSymbol:'fa fa-check-square-o fa-2x',className:'has-text-inm-purple'})):''):null);}))):'');}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proigualdad/metas');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'goals.edit',className:'button is-large is-inm-purple',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);function GoalEditForm(){_classCallCheck(this,GoalEditForm);var _this=_possibleConstructorReturn(this,(GoalEditForm.__proto__||Object.getPrototypeOf(GoalEditForm)).call(this));_this.state={groupId:undefined,showGroup:false};return _this;}_createClass(GoalEditForm,[{key:'_showGroup',value:function _showGroup(id){if(id!==this.state.groupId){this.setState({groupId:id,showGroup:true});}else{this.setState({groupId:undefined,showGroup:false});}}},{key:'_submitForm',value:function _submitForm(values){this.props.goalSave(values);}},{key:'_handleChangeMandatory',value:function _handleChangeMandatory(model,value,activities){var _this3=this;this.props.change(model,value);if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(activities)){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(activities,function(item,key){return _this3.props.change('goals.edit.activities['+key+'].mandatory',false);});}}},{key:'_addActivity',value:function _addActivity(activityId){var activities=this.props.goals.edit.activities;var activityIndex=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(activities,{id:activityId});if(this.refs['activity-'+activityId].state.value===0){if(activityIndex===-1){this.props.add('goals.edit.activities',{id:activityId});}else{this.props.change('goals.edit.activities['+activityIndex+']',{id:activityId});}}else{if(activityIndex!==-1){this.props.remove('goals.edit.activities',activityIndex);}}}},{key:'_addMandatory',value:function _addMandatory(activityId){var activities=this.props.goals.edit.activities;var activityIndex=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(activities,{id:activityId});if(this.refs['mandatory-'+activityId].state.value===0){this.props.change('goals.edit.activities['+activityIndex+'].mandatory',true);}else{this.props.change('goals.edit.activities['+activityIndex+'].mandatory',false);}}},{key:'_validateSave',value:function _validateSave(){var goals=this.props.goals;var gc=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(goals.permissions,function(o){return o==='Create';});var gu=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(goals.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goals.edit)&&goals.edit.id){if(gu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goals.edit)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goals.edit.id)){if(gc){return false;}else{return true;}}else{return true;}}}]);return GoalEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GoalEditForm);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ObjectiveEditForm=function(_Component){_inherits(ObjectiveEditForm,_Component);function ObjectiveEditForm(){_classCallCheck(this,ObjectiveEditForm);return _possibleConstructorReturn(this,(ObjectiveEditForm.__proto__||Object.getPrototypeOf(ObjectiveEditForm)).apply(this,arguments));}_createClass(ObjectiveEditForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'objectives.edit',onSubmit:function onSubmit(goals){return _this2._submitForm(goals);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del Objetivo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.name',id:'name',rows:2,className:'textarea',placeholder:'Nombre de la Meta',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'code',className:'label'},'C\xF3digo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.code',id:'code',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.code',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Campo Requerido',minLength2:'Codigo no valido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proigualdad/objetivos');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'objectives.edit',className:'button is-primary is-large',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'_submitForm',value:function _submitForm(values){this.props.objectiveEditSave(values);}},{key:'_validateSave',value:function _validateSave(){var objectives=this.props.objectives;var oc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(objectives.permissions,function(o){return o==='Create';});var ou=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(objectives.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(objectives.edit)&&objectives.edit.id){if(ou){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(objectives.edit)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(objectives.edit.id)){if(oc){return false;}else{return true;}}else{return true;}}}]);return ObjectiveEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ObjectiveEditForm);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StrategieEditForm=function(_Component){_inherits(StrategieEditForm,_Component);function StrategieEditForm(){_classCallCheck(this,StrategieEditForm);return _possibleConstructorReturn(this,(StrategieEditForm.__proto__||Object.getPrototypeOf(StrategieEditForm)).apply(this,arguments));}_createClass(StrategieEditForm,[{key:'render',value:function render(){var _this2=this;var objectives=this.props.objectives;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'strategies.edit',onSubmit:function onSubmit(goals){return _this2._submitForm(goals);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre de la estrategia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.name',id:'name',rows:2,className:'textarea',placeholder:'Nombre de la Meta',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective_id',className:'label'},'Objetivo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.objective_id',id:'objective_id',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Objetivo ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(objectives.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.code+' '+(option.name.length>100?option.name.substring(0,100)+'...':option.name));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.objective_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar un eje temático. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'code',className:'label'},'C\xF3digo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.code',id:'code',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.code',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Campo Requerido',minLength2:'Codigo no valido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proigualdad/estrategias');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'strategies.edit',className:'button is-primary is-large',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'_submitForm',value:function _submitForm(values){this.props.strategieEditSave(values);}},{key:'_validateSave',value:function _validateSave(){var strategies=this.props.strategies;var sc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(strategies.permissions,function(o){return o==='Create';});var su=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(strategies.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(strategies.edit)&&strategies.edit.id){if(su){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(strategies.edit)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(strategies.edit.id)){if(sc){return false;}else{return true;}}else{return true;}}}]);return StrategieEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (StrategieEditForm);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LineEditForm=function(_Component){_inherits(LineEditForm,_Component);function LineEditForm(){_classCallCheck(this,LineEditForm);return _possibleConstructorReturn(this,(LineEditForm.__proto__||Object.getPrototypeOf(LineEditForm)).apply(this,arguments));}_createClass(LineEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,strategies=_props.strategies,status=_props.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'lines.edit',onSubmit:function onSubmit(goals){return _this2._submitForm(goals);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del Objetivo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.name',id:'name',rows:2,className:'textarea',placeholder:'Nombre de la Meta',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'strategy_id',className:'label'},'Estrategia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.strategy_id',id:'strategy_id',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Estrategia ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(strategies.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.code+' '+(option.name.length>100?option.name.substring(0,100)+'...':option.name));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.strategy_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar un eje temático. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'code',className:'label'},'C\xF3digo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.code',id:'code',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.code',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Campo Requerido',minLength2:'Codigo no valido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'status',className:'label'},'Estatus ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.status_id',id:'status',className:'select',validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.status_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proigualdad/lineas');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'lines.edit',className:'button is-primary is-large',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'_submitForm',value:function _submitForm(values){this.props.lineEditSave(values);}},{key:'_validateSave',value:function _validateSave(){var lines=this.props.lines;var lc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(lines.permissions,function(o){return o==='Create';});var lu=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(lines.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(lines.edit)&&lines.edit.id){if(lu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(lines.edit)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(lines.edit.id)){if(lc){return false;}else{return true;}}else{return true;}}}]);return LineEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LineEditForm);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AxisEditForm=function(_Component){_inherits(AxisEditForm,_Component);function AxisEditForm(){_classCallCheck(this,AxisEditForm);return _possibleConstructorReturn(this,(AxisEditForm.__proto__||Object.getPrototypeOf(AxisEditForm)).apply(this,arguments));}_createClass(AxisEditForm,[{key:'render',value:function render(){var _this2=this;var status=this.props.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'axis.edit',onSubmit:function onSubmit(goals){return _this2._submitForm(goals);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del Objetivo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.name',id:'name',rows:2,className:'textarea',placeholder:'Nombre de la Meta',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'code',className:'label'},'C\xF3digo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.code',id:'code',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.code',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Campo Requerido',minLength2:'Codigo no valido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'status',className:'label'},'Estatus ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.status_id',id:'status',className:'select',validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.status_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proigualdad/ejes');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'axis.edit',className:'button is-primary is-large',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'_submitForm',value:function _submitForm(values){this.props.axisEditSave(values);}},{key:'_validateSave',value:function _validateSave(){var axis=this.props.axis;var ac=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(axis.permissions,function(o){return o==='Create';});var au=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(axis.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(axis.edit)&&axis.edit.id){if(au){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(axis.edit)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(axis.edit.id)){if(ac){return false;}else{return true;}}else{return true;}}}]);return AxisEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AxisEditForm);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentFormActivity=function(_Component){_inherits(ContentFormActivity,_Component);function ContentFormActivity(){_classCallCheck(this,ContentFormActivity);return _possibleConstructorReturn(this,(ContentFormActivity.__proto__||Object.getPrototypeOf(ContentFormActivity)).apply(this,arguments));}_createClass(ContentFormActivity,[{key:"render",value:function render(){var _this2=this;var _props=this.props,activityGroup=_props.activityGroup,verificationMedia=_props.verificationMedia,status=_props.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"activities.edit",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"group_id",className:"label"},"Grupo de Actividades ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".group_id",id:"group_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- Grupo de Actividades ---"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(activityGroup.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".group_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes seleccionar un grupo de actividades '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"amount",className:"label"},"Monto ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icons-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".amount",id:"amount",className:"input",type:"number",step:".01",min:"0",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_2__field_validations__["j" /* minValue */])(0)},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".amount",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre de la Actividad ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:".name",id:"name",className:"textarea",placeholder:"Nombre de la Actividad",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"verification_media_id",className:"label"},"Medio de Verificaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".verification_media_id",id:"verification_media_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Medio de Verificaci\xF3n ---"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(verificationMedia.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".verification_media_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Seleccionar un Medio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"status",className:"label"},"Estatus ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".status_id",id:"status",className:"select",validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Estatus ---"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".status_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"activities",className:"button is-large",onClick:function onClick(){return _this2.props.history.push('/proigualdad/actividades');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"activities",className:"button is-primary is-large",type:"submit",disabled:this._validateSave()},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.saveActivity(values);}},{key:"_validateSave",value:function _validateSave(){var activities=this.props.activities;var ac=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(activities.permissions,function(o){return o==='Create';});var au=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(activities.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(activities.edit)&&activities.edit.id){if(au){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(activities.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(activities.edit.id)){if(ac){return false;}else{return true;}}else{return true;}}}]);return ContentFormActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ContentFormActivity);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConceptFormEdit=function(_Component){_inherits(ConceptFormEdit,_Component);_createClass(ConceptFormEdit,[{key:'render',value:function render(){var _this2=this;var concepts=this.props.concepts;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'concepts.edit',onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del concepto de gasto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.name',id:'name',className:'input',placeholder:'Nombre',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'A\xF1adir Unidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'unit_name',className:'label'},'Nombre de la unidad ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.unit_name',id:'unit_name',className:'input'}),concepts.edit.unit_name?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'El nombre es obligatorio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'unit_invoiceable',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.unit_invoiceable',id:'unit_invoiceable',className:'checkbox',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Facturable ')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-primary',onClick:function onClick(){return _this2._unitAdd();}},'Agregar Unidad')))),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(concepts.edit.units)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title is-6'},'Listado de Unidades del Concepto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Unidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Facturable'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'.units',component:'tbody'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(concepts.edit.units,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name),_this2.state.unitEdit&&_this2.state.unitIndex===k?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'['+k+'].invoiceable',className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'['+k+'].invoiceable',id:'['+k+'].invoiceable',isToggle:true}),'Facturable'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,row.invoiceable?'Facturable':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},_this2.state.unitEdit&&_this2.state.unitIndex===k?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._closeEdit();},className:'button is-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this2._editUnit(k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},_this2.state.unitEdit&&_this2.state.unitIndex===k?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._getConfirm(k,row.name);},className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))))));}))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/gastos/conceptos');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'concepts.edit',className:'button is-primary is-large',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);function ConceptFormEdit(){_classCallCheck(this,ConceptFormEdit);var _this=_possibleConstructorReturn(this,(ConceptFormEdit.__proto__||Object.getPrototypeOf(ConceptFormEdit)).call(this));_this.state={modalShow:false,unitEdit:false,unitIndex:undefined};return _this;}_createClass(ConceptFormEdit,[{key:'_handleSubmit',value:function _handleSubmit(values){this.props.conceptSave(values);}},{key:'_unitAdd',value:function _unitAdd(){var concepts=this.props.concepts;if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(concepts.edit.unit_name)/*&& !_.isEmpty(concepts.edit.unit_status)*/){this.props.add('concepts.edit.units',{name:concepts.edit.unit_name,/*status_id: concepts.edit.unit_status,*/invoiceable:concepts.edit.unit_invoiceable});this.props.change('concepts.edit.unit_name',undefined);/*this.props.change('concepts.edit.unit_status', undefined);*/this.props.change('concepts.edit.unit_invoiceable',undefined);}}},{key:'_editUnit',value:function _editUnit(index){this.setState({unitEdit:true,unitIndex:index});}},{key:'_closeEdit',value:function _closeEdit(){this.setState({unitEdit:false,unitIndex:undefined});}},{key:'_getConfirm',value:function _getConfirm(index,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la unidad "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3._removeUnit(index);}});}},{key:'_removeUnit',value:function _removeUnit(index){this.props.remove('concepts.edit.units',index);}},{key:'_validateSave',value:function _validateSave(){var concepts=this.props.concepts;var cc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(concepts.permissions,function(o){return o==='Create';});var cu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(concepts.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(concepts.edit)&&concepts.edit.id){if(cu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(concepts.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(concepts.edit.id)){if(cc){return false;}else{return true;}}else{return true;}}}]);return ConceptFormEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ConceptFormEdit);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentFormVersions=function(_Component){_inherits(ContentFormVersions,_Component);_createClass(ContentFormVersions,[{key:'render',value:function render(){var _this2=this;var _props=this.props,versions=_props.versions,groupsPhases=_props.groupsPhases;var gc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(groupsPhases.permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{className:'column is-10',model:'versions.edit',onSubmit:function onSubmit(values){return _this2._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'year',className:'label'},'A\xF1o ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.year',name:'year',type:'number',className:'input',min:2000,max:3000,errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.year',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El año es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Titulo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.name',name:'name',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'start_date',className:'label'},'Inicia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.start_date',name:'start_date',id:'start_date',component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.start_date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'end_date',className:'label'},'Termina ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.end_date',name:'end_date',id:'end_date',component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.end_date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'finished',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.finished',id:'finished',className:'checkbox',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Finalizado ')))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'A\xF1adir Proceso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_g_start_date',className:'label'},'Inicia proceso ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.temp_g_start_date',name:'temp_g_start_date',id:'temp_g_start_date',value:versions.edit.temp_g_start_date?versions.edit.temp_g_start_date:undefined,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'}),versions.edit.temp_g_start_date?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Fecha requerida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_g_end_date',className:'label'},'Termina proceso ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.temp_g_end_date',name:'temp_g_end_date',id:'temp_g_end_date',value:versions.edit.temp_g_end_date?versions.edit.temp_g_end_date:undefined,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'}),versions.edit.temp_g_end_date?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Fecha requerida')),gc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* NavLink */],{to:'/fases/grupos/crear',className:'button is-primary is-outlined'},'Nuevo proceso'))):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'groups_phase',className:'label'},'Procesos ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'group_phase',id:'group_phase',ref:'group_phase',value:this.state.group_phase?this.state.group_phase:"ninguno",onChange:this._changeGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'ninguno'},'-- Seleccionar proceso --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(groupsPhases.list,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.id},opt.name);}))),!this.state.group_phase&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Proceso requerido')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-primary',onClick:function onClick(){_this2._addGroups();}},'Agregar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(versions.edit.phases_groups)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Listado de procesos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth is-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proceso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Inicia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Termina'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(versions.edit.phases_groups,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.start_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.end_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(row.version_phase_group)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* NavLink */],{to:'/versiones/editar/'+versions.edit.year+'/grupo/'+row.id,className:'button is-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._getConfirm(k,row.name);},className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))))));})))):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/versiones');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'versions.edit',className:'button is-large is-inm-purple',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.')));}}]);function ContentFormVersions(){_classCallCheck(this,ContentFormVersions);var _this=_possibleConstructorReturn(this,(ContentFormVersions.__proto__||Object.getPrototypeOf(ContentFormVersions)).call(this));_this.state={canAdd:false,group_phase:undefined};_this._changeGroup=_this._changeGroup.bind(_this);return _this;}_createClass(ContentFormVersions,[{key:'_submitForm',value:function _submitForm(values){//console.log('values: ',values);
this.props.versionSave(values);}},{key:'_changeGroup',value:function _changeGroup(e){//console.log('e===>', e.target.value);
if(e.target.value){return this.setState({group_phase:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toInteger(e.target.value)});}}},{key:'_getConfirm',value:function _getConfirm(index,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el Grupo "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3._removeGroup(index);}});}},{key:'_removeGroup',value:function _removeGroup(index){this.props.remove('versions.edit.phases_groups',index);}},{key:'_addGroups',value:function _addGroups(){var _props2=this.props,groupsPhases=_props2.groupsPhases,versions=_props2.versions;if(this.state.group_phase!==undefined&&versions.edit.temp_g_start_date!==undefined&&versions.edit.temp_g_end_date!==undefined){var group=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(groupsPhases.list,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toInteger(this.state.group_phase)});this.props.add('versions.edit.phases_groups',Object.assign({},group,{start_date:versions.edit.temp_g_start_date,end_date:versions.edit.temp_g_end_date}));this.props.change('versions.edit.temp_g_start_date',undefined);this.props.change('versions.edit.temp_g_end_date',undefined);return this.setState({group_phase:undefined});//console.log(`agregar ==>`, group);
}}},{key:'_validateSave',value:function _validateSave(){var versions=this.props.versions;var vc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(versions.permissions,function(o){return o==='Create';});var vu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(versions.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(versions.edit)&&versions.edit.id){if(vu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(versions.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(versions.edit.id)){if(vc){return false;}else{return true;}}else{return true;}}}]);return ContentFormVersions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ContentFormVersions);

/***/ }),
/* 222 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(224);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(500);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(225);

var supportsDescriptors = __webpack_require__(133).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRef; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Quill"] = factory();
	else
		root["Quill"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 109);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var format_1 = __webpack_require__(18);
var leaf_1 = __webpack_require__(19);
var scroll_1 = __webpack_require__(45);
var inline_1 = __webpack_require__(46);
var block_1 = __webpack_require__(47);
var embed_1 = __webpack_require__(48);
var text_1 = __webpack_require__(49);
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var store_1 = __webpack_require__(31);
var Registry = __webpack_require__(1);
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParchmentError = /** @class */ (function (_super) {
    __extends(ParchmentError, _super);
    function ParchmentError(message) {
        var _this = this;
        message = '[Parchment] ' + message;
        _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ParchmentError;
}(Error));
exports.ParchmentError = ParchmentError;
var attributes = {};
var classes = {};
var tags = {};
var types = {};
exports.DATA_KEY = '__blot';
var Scope;
(function (Scope) {
    Scope[Scope["TYPE"] = 3] = "TYPE";
    Scope[Scope["LEVEL"] = 12] = "LEVEL";
    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
    Scope[Scope["BLOT"] = 14] = "BLOT";
    Scope[Scope["INLINE"] = 7] = "INLINE";
    Scope[Scope["BLOCK"] = 11] = "BLOCK";
    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
    Scope[Scope["ANY"] = 15] = "ANY";
})(Scope = exports.Scope || (exports.Scope = {}));
function create(input, value) {
    var match = query(input);
    if (match == null) {
        throw new ParchmentError("Unable to create " + input + " blot");
    }
    var BlotClass = match;
    var node = 
    // @ts-ignore
    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
    return new BlotClass(node, value);
}
exports.create = create;
function find(node, bubble) {
    if (bubble === void 0) { bubble = false; }
    if (node == null)
        return null;
    // @ts-ignore
    if (node[exports.DATA_KEY] != null)
        return node[exports.DATA_KEY].blot;
    if (bubble)
        return find(node.parentNode, bubble);
    return null;
}
exports.find = find;
function query(query, scope) {
    if (scope === void 0) { scope = Scope.ANY; }
    var match;
    if (typeof query === 'string') {
        match = types[query] || attributes[query];
        // @ts-ignore
    }
    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
        match = types['text'];
    }
    else if (typeof query === 'number') {
        if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
        }
        else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
        }
    }
    else if (query instanceof HTMLElement) {
        var names = (query.getAttribute('class') || '').split(/\s+/);
        for (var i in names) {
            match = classes[names[i]];
            if (match)
                break;
        }
        match = match || tags[query.tagName];
    }
    if (match == null)
        return null;
    // @ts-ignore
    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
        return match;
    return null;
}
exports.query = query;
function register() {
    var Definitions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Definitions[_i] = arguments[_i];
    }
    if (Definitions.length > 1) {
        return Definitions.map(function (d) {
            return register(d);
        });
    }
    var Definition = Definitions[0];
    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
        throw new ParchmentError('Invalid definition');
    }
    else if (Definition.blotName === 'abstract') {
        throw new ParchmentError('Cannot register abstract class');
    }
    types[Definition.blotName || Definition.attrName] = Definition;
    if (typeof Definition.keyName === 'string') {
        attributes[Definition.keyName] = Definition;
    }
    else {
        if (Definition.className != null) {
            classes[Definition.className] = Definition;
        }
        if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
                Definition.tagName = Definition.tagName.map(function (tagName) {
                    return tagName.toUpperCase();
                });
            }
            else {
                Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
                if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                }
            });
        }
    }
    return Definition;
}
exports.register = register;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var diff = __webpack_require__(51);
var equal = __webpack_require__(11);
var extend = __webpack_require__(3);
var op = __webpack_require__(20);


var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


var Delta = function (ops) {
  // Assume we are given a well formed ops
  if (Array.isArray(ops)) {
    this.ops = ops;
  } else if (ops != null && Array.isArray(ops.ops)) {
    this.ops = ops.ops;
  } else {
    this.ops = [];
  }
};


Delta.prototype.insert = function (text, attributes) {
  var newOp = {};
  if (text.length === 0) return this;
  newOp.insert = text;
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype['delete'] = function (length) {
  if (length <= 0) return this;
  return this.push({ 'delete': length });
};

Delta.prototype.retain = function (length, attributes) {
  if (length <= 0) return this;
  var newOp = { retain: length };
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype.push = function (newOp) {
  var index = this.ops.length;
  var lastOp = this.ops[index - 1];
  newOp = extend(true, {}, newOp);
  if (typeof lastOp === 'object') {
    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
      return this;
    }
    // Since it does not matter if we insert before or after deleting at the same index,
    // always prefer to insert first
    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
      index -= 1;
      lastOp = this.ops[index - 1];
      if (typeof lastOp !== 'object') {
        this.ops.unshift(newOp);
        return this;
      }
    }
    if (equal(newOp.attributes, lastOp.attributes)) {
      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      }
    }
  }
  if (index === this.ops.length) {
    this.ops.push(newOp);
  } else {
    this.ops.splice(index, 0, newOp);
  }
  return this;
};

Delta.prototype.chop = function () {
  var lastOp = this.ops[this.ops.length - 1];
  if (lastOp && lastOp.retain && !lastOp.attributes) {
    this.ops.pop();
  }
  return this;
};

Delta.prototype.filter = function (predicate) {
  return this.ops.filter(predicate);
};

Delta.prototype.forEach = function (predicate) {
  this.ops.forEach(predicate);
};

Delta.prototype.map = function (predicate) {
  return this.ops.map(predicate);
};

Delta.prototype.partition = function (predicate) {
  var passed = [], failed = [];
  this.forEach(function(op) {
    var target = predicate(op) ? passed : failed;
    target.push(op);
  });
  return [passed, failed];
};

Delta.prototype.reduce = function (predicate, initial) {
  return this.ops.reduce(predicate, initial);
};

Delta.prototype.changeLength = function () {
  return this.reduce(function (length, elem) {
    if (elem.insert) {
      return length + op.length(elem);
    } else if (elem.delete) {
      return length - elem.delete;
    }
    return length;
  }, 0);
};

Delta.prototype.length = function () {
  return this.reduce(function (length, elem) {
    return length + op.length(elem);
  }, 0);
};

Delta.prototype.slice = function (start, end) {
  start = start || 0;
  if (typeof end !== 'number') end = Infinity;
  var ops = [];
  var iter = op.iterator(this.ops);
  var index = 0;
  while (index < end && iter.hasNext()) {
    var nextOp;
    if (index < start) {
      nextOp = iter.next(start - index);
    } else {
      nextOp = iter.next(end - index);
      ops.push(nextOp);
    }
    index += op.length(nextOp);
  }
  return new Delta(ops);
};


Delta.prototype.compose = function (other) {
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var ops = [];
  var firstOther = otherIter.peek();
  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
    var firstLeft = firstOther.retain;
    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
      firstLeft -= thisIter.peekLength();
      ops.push(thisIter.next());
    }
    if (firstOther.retain - firstLeft > 0) {
      otherIter.next(firstOther.retain - firstLeft);
    }
  }
  var delta = new Delta(ops);
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else if (thisIter.peekType() === 'delete') {
      delta.push(thisIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (typeof otherOp.retain === 'number') {
        var newOp = {};
        if (typeof thisOp.retain === 'number') {
          newOp.retain = length;
        } else {
          newOp.insert = thisOp.insert;
        }
        // Preserve null when composing with a retain, otherwise remove it for inserts
        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
        if (attributes) newOp.attributes = attributes;
        delta.push(newOp);

        // Optimization if rest of other is just retain
        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
          var rest = new Delta(thisIter.rest());
          return delta.concat(rest).chop();
        }

      // Other op should be delete, we could be an insert or retain
      // Insert + delete cancels out
      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
        delta.push(otherOp);
      }
    }
  }
  return delta.chop();
};

Delta.prototype.concat = function (other) {
  var delta = new Delta(this.ops.slice());
  if (other.ops.length > 0) {
    delta.push(other.ops[0]);
    delta.ops = delta.ops.concat(other.ops.slice(1));
  }
  return delta;
};

Delta.prototype.diff = function (other, index) {
  if (this.ops === other.ops) {
    return new Delta();
  }
  var strings = [this, other].map(function (delta) {
    return delta.map(function (op) {
      if (op.insert != null) {
        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
      }
      var prep = (delta === other) ? 'on' : 'with';
      throw new Error('diff() called ' + prep + ' non-document');
    }).join('');
  });
  var delta = new Delta();
  var diffResult = diff(strings[0], strings[1], index);
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  diffResult.forEach(function (component) {
    var length = component[1].length;
    while (length > 0) {
      var opLength = 0;
      switch (component[0]) {
        case diff.INSERT:
          opLength = Math.min(otherIter.peekLength(), length);
          delta.push(otherIter.next(opLength));
          break;
        case diff.DELETE:
          opLength = Math.min(length, thisIter.peekLength());
          thisIter.next(opLength);
          delta['delete'](opLength);
          break;
        case diff.EQUAL:
          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
          var thisOp = thisIter.next(opLength);
          var otherOp = otherIter.next(opLength);
          if (equal(thisOp.insert, otherOp.insert)) {
            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
          } else {
            delta.push(otherOp)['delete'](opLength);
          }
          break;
      }
      length -= opLength;
    }
  });
  return delta.chop();
};

Delta.prototype.eachLine = function (predicate, newline) {
  newline = newline || '\n';
  var iter = op.iterator(this.ops);
  var line = new Delta();
  var i = 0;
  while (iter.hasNext()) {
    if (iter.peekType() !== 'insert') return;
    var thisOp = iter.peek();
    var start = op.length(thisOp) - iter.peekLength();
    var index = typeof thisOp.insert === 'string' ?
      thisOp.insert.indexOf(newline, start) - start : -1;
    if (index < 0) {
      line.push(iter.next());
    } else if (index > 0) {
      line.push(iter.next(index));
    } else {
      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
        return;
      }
      i += 1;
      line = new Delta();
    }
  }
  if (line.length() > 0) {
    predicate(line, {}, i);
  }
};

Delta.prototype.transform = function (other, priority) {
  priority = !!priority;
  if (typeof other === 'number') {
    return this.transformPosition(other, priority);
  }
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
      delta.retain(op.length(thisIter.next()));
    } else if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (thisOp['delete']) {
        // Our delete either makes their delete redundant or removes their retain
        continue;
      } else if (otherOp['delete']) {
        delta.push(otherOp);
      } else {
        // We retain either their retain or insert
        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
      }
    }
  }
  return delta.chop();
};

Delta.prototype.transformPosition = function (index, priority) {
  priority = !!priority;
  var thisIter = op.iterator(this.ops);
  var offset = 0;
  while (thisIter.hasNext() && offset <= index) {
    var length = thisIter.peekLength();
    var nextType = thisIter.peekType();
    thisIter.next();
    if (nextType === 'delete') {
      index -= Math.min(length, index - offset);
      continue;
    } else if (nextType === 'insert' && (offset < index || !priority)) {
      index += length;
    }
    offset += length;
  }
  return index;
};


module.exports = Delta;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWLINE_LENGTH = 1;

var BlockEmbed = function (_Parchment$Embed) {
  _inherits(BlockEmbed, _Parchment$Embed);

  function BlockEmbed() {
    _classCallCheck(this, BlockEmbed);

    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
  }

  _createClass(BlockEmbed, [{
    key: 'attach',
    value: function attach() {
      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
    }
  }, {
    key: 'delta',
    value: function delta() {
      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = _parchment2.default.create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
      }
    }
  }]);

  return BlockEmbed;
}(_parchment2.default.Embed);

BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements


var Block = function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);

  function Block(domNode) {
    _classCallCheck(this, Block);

    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

    _this2.cache = {};
    return _this2;
  }

  _createClass(Block, [{
    key: 'delta',
    value: function delta() {
      if (this.cache.delta == null) {
        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
          if (leaf.length() === 0) {
            return delta;
          } else {
            return delta.insert(leaf.value(), bubbleFormats(leaf));
          }
        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
      }
      return this.cache.delta;
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
      this.cache = {};
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length <= 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
        if (index + length === this.length()) {
          this.format(name, value);
        }
      } else {
        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
      }
      this.cache = {};
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
      if (value.length === 0) return;
      var lines = value.split('\n');
      var text = lines.shift();
      if (text.length > 0) {
        if (index < this.length() - 1 || this.children.tail == null) {
          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
        } else {
          this.children.tail.insertAt(this.children.tail.length(), text);
        }
        this.cache = {};
      }
      var block = this;
      lines.reduce(function (index, line) {
        block = block.split(index, true);
        block.insertAt(0, line);
        return line.length;
      }, index + text.length);
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      var head = this.children.head;
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
      if (head instanceof _break2.default) {
        head.remove();
      }
      this.cache = {};
    }
  }, {
    key: 'length',
    value: function length() {
      if (this.cache.length == null) {
        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
      }
      return this.cache.length;
    }
  }, {
    key: 'moveChildren',
    value: function moveChildren(target, ref) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
      this.cache = {};
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
      this.cache = {};
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
    }
  }, {
    key: 'removeChild',
    value: function removeChild(child) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
      this.cache = {};
    }
  }, {
    key: 'split',
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
        var clone = this.clone();
        if (index === 0) {
          this.parent.insertBefore(clone, this);
          return this;
        } else {
          this.parent.insertBefore(clone, this.next);
          return clone;
        }
      } else {
        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
        this.cache = {};
        return next;
      }
    }
  }]);

  return Block;
}(_parchment2.default.Block);

Block.blotName = 'block';
Block.tagName = 'P';
Block.defaultChild = 'break';
Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (blot == null) return formats;
  if (typeof blot.formats === 'function') {
    formats = (0, _extend2.default)(formats, blot.formats());
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}

exports.bubbleFormats = bubbleFormats;
exports.BlockEmbed = BlockEmbed;
exports.default = Block;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.overload = exports.expandConfig = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(50);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _editor = __webpack_require__(14);

var _editor2 = _interopRequireDefault(_editor);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _selection = __webpack_require__(15);

var _selection2 = _interopRequireDefault(_selection);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill');

var Quill = function () {
  _createClass(Quill, null, [{
    key: 'debug',
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      _logger2.default.level(limit);
    }
  }, {
    key: 'find',
    value: function find(node) {
      return node.__quill || _parchment2.default.find(node);
    }
  }, {
    key: 'import',
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
      }
      return this.imports[name];
    }
  }, {
    key: 'register',
    value: function register(path, target) {
      var _this = this;

      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof path !== 'string') {
        var name = path.attrName || path.blotName;
        if (typeof name === 'string') {
          // register(Blot | Attributor, overwrite)
          this.register('formats/' + name, path, target);
        } else {
          Object.keys(path).forEach(function (key) {
            _this.register(key, path[key], target);
          });
        }
      } else {
        if (this.imports[path] != null && !overwrite) {
          debug.warn('Overwriting ' + path + ' with', target);
        }
        this.imports[path] = target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
          _parchment2.default.register(target);
        } else if (path.startsWith('modules') && typeof target.register === 'function') {
          target.register();
        }
      }
    }
  }]);

  function Quill(container) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Quill);

    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      return debug.error('Invalid Quill container', container);
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    this.container.__quill = this;
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.root.setAttribute('data-gramm', false);
    this.scrollingContainer = this.options.scrollingContainer || this.root;
    this.emitter = new _emitter4.default();
    this.scroll = _parchment2.default.create(this.root, {
      emitter: this.emitter,
      whitelist: this.options.formats
    });
    this.editor = new _editor2.default(this.scroll);
    this.selection = new _selection2.default(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options);
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.theme.init();
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
      if (type === _emitter4.default.events.TEXT_CHANGE) {
        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
      var range = _this2.selection.lastRange;
      var index = range && range.length === 0 ? range.index : undefined;
      modify.call(_this2, function () {
        return _this2.editor.update(null, mutations, index);
      }, source);
    });
    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
    this.setContents(contents);
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
  }

  _createClass(Quill, [{
    key: 'addContainer',
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length, source) {
      var _this3 = this;

      var _overload = overload(index, length, source);

      var _overload2 = _slicedToArray(_overload, 4);

      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];

      return modify.call(this, function () {
        return _this3.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var scrollTop = this.scrollingContainer.scrollTop;
      this.selection.focus();
      this.scrollingContainer.scrollTop = scrollTop;
      this.scrollIntoView();
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var _this4 = this;

      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        var range = _this4.getSelection(true);
        var change = new _quillDelta2.default();
        if (range == null) {
          return change;
        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this4.selection.format(name, value);
          return change;
        } else {
          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this4.setSelection(range, _emitter4.default.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length, name, value, source) {
      var _this5 = this;

      var formats = void 0;

      var _overload3 = overload(index, length, name, value, source);

      var _overload4 = _slicedToArray(_overload3, 4);

      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];

      return modify.call(this, function () {
        return _this5.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length, name, value, source) {
      var _this6 = this;

      var formats = void 0;

      var _overload5 = overload(index, length, name, value, source);

      var _overload6 = _slicedToArray(_overload5, 4);

      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];

      return modify.call(this, function () {
        return _this6.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bounds = void 0;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: 'getContents',
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload7 = overload(index, length);

      var _overload8 = _slicedToArray(_overload7, 2);

      index = _overload8[0];
      length = _overload8[1];

      return this.editor.getContents(index, length);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      } else {
        return this.editor.getFormat(index.index, index.length);
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: 'getLength',
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: 'getLeaf',
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: 'getLine',
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: 'getLines',
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      } else {
        return this.scroll.lines(index, length);
      }
    }
  }, {
    key: 'getModule',
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: 'getText',
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload9 = overload(index, length);

      var _overload10 = _slicedToArray(_overload9, 2);

      index = _overload10[0];
      length = _overload10[1];

      return this.editor.getText(index, length);
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      var _this7 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

      return modify.call(this, function () {
        return _this7.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text, name, value, source) {
      var _this8 = this;

      var formats = void 0;

      var _overload11 = overload(index, 0, name, value, source);

      var _overload12 = _slicedToArray(_overload11, 4);

      index = _overload12[0];
      formats = _overload12[2];
      source = _overload12[3];

      return modify.call(this, function () {
        return _this8.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.container.classList.contains('ql-disabled');
    }
  }, {
    key: 'off',
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: 'on',
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: 'once',
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: 'pasteHTML',
    value: function pasteHTML(index, html, source) {
      this.clipboard.dangerouslyPasteHTML(index, html, source);
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length, source) {
      var _this9 = this;

      var _overload13 = overload(index, length, source);

      var _overload14 = _slicedToArray(_overload13, 4);

      index = _overload14[0];
      length = _overload14[1];
      source = _overload14[3];

      return modify.call(this, function () {
        return _this9.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      this.selection.scrollIntoView(this.scrollingContainer);
    }
  }, {
    key: 'setContents',
    value: function setContents(delta) {
      var _this10 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        var length = _this10.getLength();
        var deleted = _this10.editor.deleteText(0, length);
        var applied = _this10.editor.applyDelta(delta);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this10.editor.deleteText(_this10.getLength() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: 'setSelection',
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        var _overload15 = overload(index, length, source);

        var _overload16 = _slicedToArray(_overload15, 4);

        index = _overload16[0];
        length = _overload16[1];
        source = _overload16[3];

        this.selection.setRange(new _selection.Range(index, length), source);
        if (source !== _emitter4.default.sources.SILENT) {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      var delta = new _quillDelta2.default().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      return change;
    }
  }, {
    key: 'updateContents',
    value: function updateContents(delta) {
      var _this11 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        return _this11.editor.applyDelta(delta, source);
      }, source, true);
    }
  }]);

  return Quill;
}();

Quill.DEFAULTS = {
  bounds: null,
  formats: null,
  modules: {},
  placeholder: '',
  readOnly: false,
  scrollingContainer: null,
  strict: true,
  theme: 'default'
};
Quill.events = _emitter4.default.events;
Quill.sources = _emitter4.default.sources;
// eslint-disable-next-line no-undef
Quill.version =  false ? 'dev' : "1.3.7";

Quill.imports = {
  'delta': _quillDelta2.default,
  'parchment': _parchment2.default,
  'core/module': _module2.default,
  'core/theme': _theme2.default
};

function expandConfig(container, userConfig) {
  userConfig = (0, _extend2.default)(true, {
    container: container,
    modules: {
      clipboard: true,
      keyboard: true,
      history: true
    }
  }, userConfig);
  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
    userConfig.theme = _theme2.default;
  } else {
    userConfig.theme = Quill.import('themes/' + userConfig.theme);
    if (userConfig.theme == null) {
      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
    }
  }
  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
  [themeConfig, userConfig].forEach(function (config) {
    config.modules = config.modules || {};
    Object.keys(config.modules).forEach(function (module) {
      if (config.modules[module] === true) {
        config.modules[module] = {};
      }
    });
  });
  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
  var moduleConfig = moduleNames.reduce(function (config, name) {
    var moduleClass = Quill.import('modules/' + name);
    if (moduleClass == null) {
      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
    } else {
      config[name] = moduleClass.DEFAULTS || {};
    }
    return config;
  }, {});
  // Special case toolbar shorthand
  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
    userConfig.modules.toolbar = {
      container: userConfig.modules.toolbar
    };
  }
  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
    if (typeof userConfig[key] === 'string') {
      userConfig[key] = document.querySelector(userConfig[key]);
    }
  });
  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
    if (userConfig.modules[name]) {
      config[name] = userConfig.modules[name];
    }
    return config;
  }, {});
  return userConfig;
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
    return new _quillDelta2.default();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) index = range.index;
    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, _emitter4.default.sources.SILENT);
  }
  if (change.length() > 0) {
    var _emitter;

    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
    if (source !== _emitter4.default.sources.SILENT) {
      var _emitter2;

      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
    }
  }
  return change;
}

function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || _emitter4.default.sources.API;
  return [index, length, formats, source];
}

function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start = void 0,
      end = void 0;
  if (index instanceof _quillDelta2.default) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
    });

    var _map2 = _slicedToArray(_map, 2);

    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });

    var _map4 = _slicedToArray(_map3, 2);

    start = _map4[0];
    end = _map4[1];
  }
  return new _selection.Range(start, end - start);
}

exports.expandConfig = expandConfig;
exports.overload = overload;
exports.default = Quill;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inline = function (_Parchment$Inline) {
  _inherits(Inline, _Parchment$Inline);

  function Inline() {
    _classCallCheck(this, Inline);

    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  _createClass(Inline, [{
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }], [{
    key: 'compare',
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);

  return Inline;
}(_parchment2.default.Inline);

Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['cursor', 'inline', // Must be lower
'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
];

exports.default = Inline;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlot = function (_Parchment$Text) {
  _inherits(TextBlot, _Parchment$Text);

  function TextBlot() {
    _classCallCheck(this, TextBlot);

    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
  }

  return TextBlot;
}(_parchment2.default.Text);

exports.default = TextBlot;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = __webpack_require__(54);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:events');

var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

EVENTS.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
      // TODO use WeakMap
      if (node.__quill && node.__quill.emitter) {
        var _node$__quill$emitter;

        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
      }
    });
  });
});

var Emitter = function (_EventEmitter) {
  _inherits(Emitter, _EventEmitter);

  function Emitter() {
    _classCallCheck(this, Emitter);

    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

    _this.listeners = {};
    _this.on('error', debug.error);
    return _this;
  }

  _createClass(Emitter, [{
    key: 'emit',
    value: function emit() {
      debug.log.apply(debug, arguments);
      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
    }
  }, {
    key: 'handleDOM',
    value: function handleDOM(event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
            handler = _ref.handler;

        if (event.target === node || node.contains(event.target)) {
          handler.apply(undefined, [event].concat(args));
        }
      });
    }
  }, {
    key: 'listenDOM',
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({ node: node, handler: handler });
    }
  }]);

  return Emitter;
}(_eventemitter2.default);

Emitter.events = {
  EDITOR_CHANGE: 'editor-change',
  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
  SCROLL_OPTIMIZE: 'scroll-optimize',
  SCROLL_UPDATE: 'scroll-update',
  SELECTION_CHANGE: 'selection-change',
  TEXT_CHANGE: 'text-change'
};
Emitter.sources = {
  API: 'api',
  SILENT: 'silent',
  USER: 'user'
};

exports.default = Emitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function Module(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Module);

  this.quill = quill;
  this.options = options;
};

Module.DEFAULTS = {};

exports.default = Module;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var levels = ['error', 'warn', 'log', 'info'];
var level = 'warn';

function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}

debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};

exports.default = namespace;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(52);
var isArguments = __webpack_require__(53);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var Attributor = /** @class */ (function () {
    function Attributor(attrName, keyName, options) {
        if (options === void 0) { options = {}; }
        this.attrName = attrName;
        this.keyName = keyName;
        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
        if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
        }
        else {
            this.scope = Registry.Scope.ATTRIBUTE;
        }
        if (options.whitelist != null)
            this.whitelist = options.whitelist;
    }
    Attributor.keys = function (node) {
        return [].map.call(node.attributes, function (item) {
            return item.name;
        });
    };
    Attributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        node.setAttribute(this.keyName, value);
        return true;
    };
    Attributor.prototype.canAdd = function (node, value) {
        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
        if (match == null)
            return false;
        if (this.whitelist == null)
            return true;
        if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
        }
        else {
            return this.whitelist.indexOf(value) > -1;
        }
    };
    Attributor.prototype.remove = function (node) {
        node.removeAttribute(this.keyName);
    };
    Attributor.prototype.value = function (node) {
        var value = node.getAttribute(this.keyName);
        if (this.canAdd(node, value) && value) {
            return value;
        }
        return '';
    };
    return Attributor;
}());
exports.default = Attributor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Code = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(_inline2.default);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock = function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: 'delta',
    value: function delta() {
      var _this3 = this;

      var text = this.domNode.textContent;
      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }
      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this3.formats());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _descendant = this.descendant(_text2.default, this.length() - 1),
          _descendant2 = _slicedToArray(_descendant, 1),
          text = _descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }
      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);
      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _descendant3 = this.descendant(_text2.default, index),
          _descendant4 = _slicedToArray(_descendant3, 2),
          text = _descendant4[0],
          offset = _descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: 'length',
    value: function length() {
      var length = this.domNode.textContent.length;
      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }
      return length;
    }
  }, {
    key: 'newlineIndex',
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(_parchment2.default.create('text', '\n'));
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = _parchment2.default.find(node);
        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof _parchment2.default.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(_block2.default);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';

exports.Code = Code;
exports.default = CodeBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ASCII = /^[ -~]*$/;

var Editor = function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: 'applyDelta',
    value: function applyDelta(delta) {
      var _this = this;

      var consumeNextNewline = false;
      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      delta = normalizeDelta(delta);
      delta.reduce(function (index, op) {
        var length = op.retain || op.delete || op.insert.length || 1;
        var attributes = op.attributes || {};
        if (op.insert != null) {
          if (typeof op.insert === 'string') {
            var text = op.insert;
            if (text.endsWith('\n') && consumeNextNewline) {
              consumeNextNewline = false;
              text = text.slice(0, -1);
            }
            if (index >= scrollLength && !text.endsWith('\n')) {
              consumeNextNewline = true;
            }
            _this.scroll.insertAt(index, text);

            var _scroll$line = _this.scroll.line(index),
                _scroll$line2 = _slicedToArray(_scroll$line, 2),
                line = _scroll$line2[0],
                offset = _scroll$line2[1];

            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
            if (line instanceof _block2.default) {
              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
            }
            attributes = _op2.default.attributes.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key
            if (key == null) return index;
            _this.scroll.insertAt(index, key, op.insert[key]);
          }
          scrollLength += length;
        }
        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        return index + length;
      }, 0);
      delta.reduce(function (index, op) {
        if (typeof op.delete === 'number') {
          _this.scroll.deleteAt(index, op.delete);
          return index;
        }
        return index + (op.retain || op.insert.length || 1);
      }, 0);
      this.scroll.batchEnd();
      return this.update(delta);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new _quillDelta2.default().retain(index).delete(length));
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
        var lines = _this2.scroll.lines(index, Math.max(length, 1));
        var lengthRemaining = length;
        lines.forEach(function (line) {
          var lineLength = line.length();
          if (!(line instanceof _code2.default)) {
            line.format(format, formats[format]);
          } else {
            var codeIndex = index - line.offset(_this2.scroll);
            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
            line.formatAt(codeIndex, codeLength, format, formats[format]);
          }
          lengthRemaining -= lineLength;
        });
      });
      this.scroll.optimize();
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'getContents',
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: 'getDelta',
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'getFormat',
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var lines = [],
          leaves = [];
      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof _block2.default) {
            lines.push(blot);
          } else if (blot instanceof _parchment2.default.Leaf) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
      }
      var formatsArr = [lines, leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = (0, _block.bubbleFormats)(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot == null) return formats;
          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
        }
        return formats;
      });
      return _extend2.default.apply(_extend2.default, formatsArr);
    }
  }, {
    key: 'getText',
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'isBlank',
    value: function isBlank() {
      if (this.scroll.children.length == 0) return true;
      if (this.scroll.children.length > 1) return false;
      var block = this.scroll.children.head;
      if (block.statics.blotName !== _block2.default.blotName) return false;
      if (block.children.length > 1) return false;
      return block.children.head instanceof _break2.default;
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _scroll$line3 = this.scroll.line(index + length),
          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
          line = _scroll$line4[0],
          offset = _scroll$line4[1];

      var suffixLength = 0,
          suffix = new _quillDelta2.default();
      if (line != null) {
        if (!(line instanceof _code2.default)) {
          suffixLength = line.length() - offset;
        } else {
          suffixLength = line.newlineIndex(offset) - offset + 1;
        }
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }
      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
      var delta = new _quillDelta2.default().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: 'update',
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var oldDelta = this.delta;
      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = _parchment2.default.find(mutations[0].target);
        var formats = (0, _block.bubbleFormats)(textBlot);
        var index = textBlot.offset(this.scroll);
        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
        var oldText = new _quillDelta2.default().insert(oldValue);
        var newText = new _quillDelta2.default().insert(textBlot.value());
        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, formats);
          } else {
            return delta.push(op);
          }
        }, new _quillDelta2.default());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();
        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, cursorIndex);
        }
      }
      return change;
    }
  }]);

  return Editor;
}();

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

function normalizeDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = (0, _clone2.default)(op.attributes);
      delete attributes['image'];
      return delta.insert({ image: op.attributes.image }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = (0, _clone2.default)(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new _quillDelta2.default());
}

exports.default = Editor;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill:selection');

var Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, Range);

  this.index = index;
  this.length = length;
};

var Selection = function () {
  function Selection(scroll, emitter) {
    var _this = this;

    _classCallCheck(this, Selection);

    this.emitter = emitter;
    this.scroll = scroll;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    this.cursor = _parchment2.default.create('cursor', this);
    // savedRange is last non-null range
    this.lastRange = this.savedRange = new Range(0, 0);
    this.handleComposition();
    this.handleDragging();
    this.emitter.listenDOM('selectionchange', document, function () {
      if (!_this.mouseDown) {
        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
      }
    });
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
        _this.update(_emitter4.default.sources.SILENT);
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
      if (!_this.hasFocus()) return;
      var native = _this.getNativeRange();
      if (native == null) return;
      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
        try {
          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
      if (context.range) {
        var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;

        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
      }
    });
    this.update(_emitter4.default.sources.SILENT);
  }

  _createClass(Selection, [{
    key: 'handleComposition',
    value: function handleComposition() {
      var _this2 = this;

      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging() {
      var _this3 = this;

      this.emitter.listenDOM('mousedown', document.body, function () {
        _this3.mouseDown = true;
      });
      this.emitter.listenDOM('mouseup', document.body, function () {
        _this3.mouseDown = false;
        _this3.update(_emitter4.default.sources.USER);
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.hasFocus()) return;
      this.root.focus();
      this.setRange(this.savedRange);
    }
  }, {
    key: 'format',
    value: function format(_format, value) {
      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = _parchment2.default.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof _parchment2.default.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }
        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
      this.update();
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node = void 0,
          _scroll$leaf = this.scroll.leaf(index),
          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
          leaf = _scroll$leaf2[0],
          offset = _scroll$leaf2[1];
      if (leaf == null) return null;

      var _leaf$position = leaf.position(offset, true);

      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

      node = _leaf$position2[0];
      offset = _leaf$position2[1];

      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);

        var _scroll$leaf3 = this.scroll.leaf(index + length);

        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

        leaf = _scroll$leaf4[0];
        offset = _scroll$leaf4[1];

        if (leaf == null) return null;

        var _leaf$position3 = leaf.position(offset, true);

        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

        node = _leaf$position4[0];
        offset = _leaf$position4[1];

        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect = void 0;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: 'getNativeRange',
    value: function getNativeRange() {
      var selection = document.getSelection();
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      debug.info('getNativeRange', range);
      return range;
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var normalized = this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = this.normalizedToRange(normalized);
      return [range, normalized];
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return document.activeElement === this.root;
    }
  }, {
    key: 'normalizedToRange',
    value: function normalizedToRange(range) {
      var _this4 = this;

      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = _slicedToArray(position, 2),
            node = _position[0],
            offset = _position[1];

        var blot = _parchment2.default.find(node, true);
        var index = blot.offset(_this4.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof _parchment2.default.Container) {
          return index + blot.length();
        } else {
          return index + blot.index(node, offset);
        }
      });
      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
      return new Range(start, end - start);
    }
  }, {
    key: 'normalizeNative',
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var range = {
        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
            offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: 'rangeToNative',
    value: function rangeToNative(range) {
      var _this5 = this;

      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        index = Math.min(scrollLength - 1, index);
        var node = void 0,
            _scroll$leaf5 = _this5.scroll.leaf(index),
            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
            leaf = _scroll$leaf6[0],
            offset = _scroll$leaf6[1];
        var _leaf$position5 = leaf.position(offset, i !== 0);

        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

        node = _leaf$position6[0];
        offset = _leaf$position6[1];

        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(scrollingContainer) {
      var range = this.lastRange;
      if (range == null) return;
      var bounds = this.getBounds(range.index, range.length);
      if (bounds == null) return;
      var limit = this.scroll.length() - 1;

      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _scroll$line2 = _slicedToArray(_scroll$line, 1),
          first = _scroll$line2[0];

      var last = first;
      if (range.length > 0) {
        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

        last = _scroll$line4[0];
      }
      if (first == null || last == null) return;
      var scrollBounds = scrollingContainer.getBoundingClientRect();
      if (bounds.top < scrollBounds.top) {
        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
      } else if (bounds.bottom > scrollBounds.bottom) {
        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
      }
    }
  }, {
    key: 'setNativeRange',
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document.getSelection();
      if (selection == null) return;
      if (startNode != null) {
        if (!this.hasFocus()) this.root.focus();
        var native = (this.getNativeRange() || {}).native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

          if (startNode.tagName == "BR") {
            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
            endNode = endNode.parentNode;
          }
          var range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
      }
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      debug.info('setRange', range);
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var oldRange = this.lastRange;

      var _getRange = this.getRange(),
          _getRange2 = _slicedToArray(_getRange, 2),
          lastRange = _getRange2[0],
          nativeRange = _getRange2[1];

      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
        var _emitter;

        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
          this.cursor.restore();
        }
        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
        if (source !== _emitter4.default.sources.SILENT) {
          var _emitter2;

          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
        }
      }
    }
  }]);

  return Selection;
}();

function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

exports.Range = Range;
exports.default = Selection;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Break = function (_Parchment$Embed) {
  _inherits(Break, _Parchment$Embed);

  function Break() {
    _classCallCheck(this, Break);

    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
  }

  _createClass(Break, [{
    key: 'insertInto',
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: 'length',
    value: function length() {
      return 0;
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }], [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  return Break;
}(_parchment2.default.Embed);

Break.blotName = 'break';
Break.tagName = 'BR';

exports.default = Break;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var linked_list_1 = __webpack_require__(44);
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var ContainerBlot = /** @class */ (function (_super) {
    __extends(ContainerBlot, _super);
    function ContainerBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.build();
        return _this;
    }
    ContainerBlot.prototype.appendChild = function (other) {
        this.insertBefore(other);
    };
    ContainerBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        this.children.forEach(function (child) {
            child.attach();
        });
    };
    ContainerBlot.prototype.build = function () {
        var _this = this;
        this.children = new linked_list_1.default();
        // Need to be reversed for if DOM nodes already in order
        [].slice
            .call(this.domNode.childNodes)
            .reverse()
            .forEach(function (node) {
            try {
                var child = makeBlot(node);
                _this.insertBefore(child, _this.children.head || undefined);
            }
            catch (err) {
                if (err instanceof Registry.ParchmentError)
                    return;
                else
                    throw err;
            }
        });
    };
    ContainerBlot.prototype.deleteAt = function (index, length) {
        if (index === 0 && length === this.length()) {
            return this.remove();
        }
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
        });
    };
    ContainerBlot.prototype.descendant = function (criteria, index) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if ((criteria.blotName == null && criteria(child)) ||
            (criteria.blotName != null && child instanceof criteria)) {
            return [child, offset];
        }
        else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
        }
        else {
            return [null, -1];
        }
    };
    ContainerBlot.prototype.descendants = function (criteria, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = Number.MAX_VALUE; }
        var descendants = [];
        var lengthLeft = length;
        this.children.forEachAt(index, length, function (child, index, length) {
            if ((criteria.blotName == null && criteria(child)) ||
                (criteria.blotName != null && child instanceof criteria)) {
                descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
        });
        return descendants;
    };
    ContainerBlot.prototype.detach = function () {
        this.children.forEach(function (child) {
            child.detach();
        });
        _super.prototype.detach.call(this);
    };
    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
        });
    };
    ContainerBlot.prototype.insertAt = function (index, value, def) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if (child) {
            child.insertAt(offset, value, def);
        }
        else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
        }
    };
    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
        if (this.statics.allowedChildren != null &&
            !this.statics.allowedChildren.some(function (child) {
                return childBlot instanceof child;
            })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
        }
        childBlot.insertInto(this, refBlot);
    };
    ContainerBlot.prototype.length = function () {
        return this.children.reduce(function (memo, child) {
            return memo + child.length();
        }, 0);
    };
    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
        this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
        });
    };
    ContainerBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                var child = Registry.create(this.statics.defaultChild);
                this.appendChild(child);
                child.optimize(context);
            }
            else {
                this.remove();
            }
        }
    };
    ContainerBlot.prototype.path = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
        var position = [[this, index]];
        if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
        }
        else if (child != null) {
            position.push([child, offset]);
        }
        return position;
    };
    ContainerBlot.prototype.removeChild = function (child) {
        this.children.remove(child);
    };
    ContainerBlot.prototype.replace = function (target) {
        if (target instanceof ContainerBlot) {
            target.moveChildren(this);
        }
        _super.prototype.replace.call(this, target);
    };
    ContainerBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = this.clone();
        this.parent.insertBefore(after, this.next);
        this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
        });
        return after;
    };
    ContainerBlot.prototype.unwrap = function () {
        this.moveChildren(this.parent, this.next);
        this.remove();
    };
    ContainerBlot.prototype.update = function (mutations, context) {
        var _this = this;
        var addedNodes = [];
        var removedNodes = [];
        mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
                addedNodes.push.apply(addedNodes, mutation.addedNodes);
                removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
        });
        removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
                // @ts-ignore
                node.tagName !== 'IFRAME' &&
                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return;
            }
            var blot = Registry.find(node);
            if (blot == null)
                return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                blot.detach();
            }
        });
        addedNodes
            .filter(function (node) {
            return node.parentNode == _this.domNode;
        })
            .sort(function (a, b) {
            if (a === b)
                return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return 1;
            }
            return -1;
        })
            .forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
                refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
                if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                }
                _this.insertBefore(blot, refBlot || undefined);
            }
        });
    };
    return ContainerBlot;
}(shadow_1.default));
function makeBlot(node) {
    var blot = Registry.find(node);
    if (blot == null) {
        try {
            blot = Registry.create(node);
        }
        catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
                // @ts-ignore
                blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
                node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
        }
    }
    return blot;
}
exports.default = ContainerBlot;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var store_1 = __webpack_require__(31);
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var FormatBlot = /** @class */ (function (_super) {
    __extends(FormatBlot, _super);
    function FormatBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.attributes = new store_1.default(_this.domNode);
        return _this;
    }
    FormatBlot.formats = function (domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    };
    FormatBlot.prototype.format = function (name, value) {
        var format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    };
    FormatBlot.prototype.formats = function () {
        var formats = this.attributes.values();
        var format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    };
    FormatBlot.prototype.replaceWith = function (name, value) {
        var replacement = _super.prototype.replaceWith.call(this, name, value);
        this.attributes.copy(replacement);
        return replacement;
    };
    FormatBlot.prototype.update = function (mutations, context) {
        var _this = this;
        _super.prototype.update.call(this, mutations, context);
        if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    };
    FormatBlot.prototype.wrap = function (name, value) {
        var wrapper = _super.prototype.wrap.call(this, name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    };
    return FormatBlot;
}(container_1.default));
exports.default = FormatBlot;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var LeafBlot = /** @class */ (function (_super) {
    __extends(LeafBlot, _super);
    function LeafBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafBlot.value = function (domNode) {
        return true;
    };
    LeafBlot.prototype.index = function (node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    };
    LeafBlot.prototype.position = function (index, inclusive) {
        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    };
    LeafBlot.prototype.value = function () {
        var _a;
        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
    };
    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
    return LeafBlot;
}(shadow_1.default));
exports.default = LeafBlot;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var equal = __webpack_require__(11);
var extend = __webpack_require__(3);


var lib = {
  attributes: {
    compose: function (a, b, keepNull) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = extend(true, {}, b);
      if (!keepNull) {
        attributes = Object.keys(attributes).reduce(function (copy, key) {
          if (attributes[key] != null) {
            copy[key] = attributes[key];
          }
          return copy;
        }, {});
      }
      for (var key in a) {
        if (a[key] !== undefined && b[key] === undefined) {
          attributes[key] = a[key];
        }
      }
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    diff: function(a, b) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
        if (!equal(a[key], b[key])) {
          attributes[key] = b[key] === undefined ? null : b[key];
        }
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    transform: function (a, b, priority) {
      if (typeof a !== 'object') return b;
      if (typeof b !== 'object') return undefined;
      if (!priority) return b;  // b simply overwrites us without priority
      var attributes = Object.keys(b).reduce(function (attributes, key) {
        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
  },

  iterator: function (ops) {
    return new Iterator(ops);
  },

  length: function (op) {
    if (typeof op['delete'] === 'number') {
      return op['delete'];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
};


function Iterator(ops) {
  this.ops = ops;
  this.index = 0;
  this.offset = 0;
};

Iterator.prototype.hasNext = function () {
  return this.peekLength() < Infinity;
};

Iterator.prototype.next = function (length) {
  if (!length) length = Infinity;
  var nextOp = this.ops[this.index];
  if (nextOp) {
    var offset = this.offset;
    var opLength = lib.length(nextOp)
    if (length >= opLength - offset) {
      length = opLength - offset;
      this.index += 1;
      this.offset = 0;
    } else {
      this.offset += length;
    }
    if (typeof nextOp['delete'] === 'number') {
      return { 'delete': length };
    } else {
      var retOp = {};
      if (nextOp.attributes) {
        retOp.attributes = nextOp.attributes;
      }
      if (typeof nextOp.retain === 'number') {
        retOp.retain = length;
      } else if (typeof nextOp.insert === 'string') {
        retOp.insert = nextOp.insert.substr(offset, length);
      } else {
        // offset should === 0, length should === 1
        retOp.insert = nextOp.insert;
      }
      return retOp;
    }
  } else {
    return { retain: Infinity };
  }
};

Iterator.prototype.peek = function () {
  return this.ops[this.index];
};

Iterator.prototype.peekLength = function () {
  if (this.ops[this.index]) {
    // Should never return 0 if our index is being managed correctly
    return lib.length(this.ops[this.index]) - this.offset;
  } else {
    return Infinity;
  }
};

Iterator.prototype.peekType = function () {
  if (this.ops[this.index]) {
    if (typeof this.ops[this.index]['delete'] === 'number') {
      return 'delete';
    } else if (typeof this.ops[this.index].retain === 'number') {
      return 'retain';
    } else {
      return 'insert';
    }
  }
  return 'retain';
};

Iterator.prototype.rest = function () {
  if (!this.hasNext()) {
    return [];
  } else if (this.offset === 0) {
    return this.ops.slice(this.index);
  } else {
    var offset = this.offset;
    var index = this.index;
    var next = this.next();
    var rest = this.ops.slice(this.index);
    this.offset = offset;
    this.index = index;
    return [next].concat(rest);
  }
};


module.exports = lib;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isLine(blot) {
  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
}

var Scroll = function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

    _this.emitter = config.emitter;
    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }
    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    _this.domNode.addEventListener('DOMNodeInserted', function () {});
    _this.optimize();
    _this.enable();
    return _this;
  }

  _createClass(Scroll, [{
    key: 'batchStart',
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: 'batchEnd',
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      var _line = this.line(index),
          _line2 = _slicedToArray(_line, 2),
          first = _line2[0],
          offset = _line2[1];

      var _line3 = this.line(index + length),
          _line4 = _slicedToArray(_line3, 1),
          last = _line4[0];

      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
      if (last != null && first !== last && offset > 0) {
        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
          this.optimize();
          return;
        }
        if (first instanceof _code2.default) {
          var newlineIndex = first.newlineIndex(first.length(), true);
          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);
            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof _code2.default) {
          var _newlineIndex = last.newlineIndex(0);
          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }
        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }
      this.optimize();
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
      this.optimize();
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
      if (index >= this.length()) {
        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
          var blot = _parchment2.default.create(this.statics.defaultChild);
          this.appendChild(blot);
          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }
          blot.insertAt(0, value, def);
        } else {
          var embed = _parchment2.default.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
      }
      this.optimize();
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
        var wrapper = _parchment2.default.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
    }
  }, {
    key: 'leaf',
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: 'line',
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: 'lines',
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof _parchment2.default.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.batch === true) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: 'update',
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = _emitter2.default.sources.USER;
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(_parchment2.default.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

exports.default = Scroll;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORTKEY = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:keyboard');

var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

var Keyboard = function (_Module) {
  _inherits(Keyboard, _Module);

  _createClass(Keyboard, null, [{
    key: 'match',
    value: function match(evt, binding) {
      binding = normalize(binding);
      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
        return !!binding[key] !== evt[key] && binding[key] !== null;
      })) {
        return false;
      }
      return binding.key === (evt.which || evt.keyCode);
    }
  }]);

  function Keyboard(quill, options) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

    _this.bindings = {};
    Object.keys(_this.options.bindings).forEach(function (name) {
      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
        return;
      }
      if (_this.options.bindings[name]) {
        _this.addBinding(_this.options.bindings[name]);
      }
    });
    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
    if (/Firefox/i.test(navigator.userAgent)) {
      // Need to handle delete and backspace for Firefox in the general case #1171
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
    } else {
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
    }
    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
    _this.listen();
    return _this;
  }

  _createClass(Keyboard, [{
    key: 'addBinding',
    value: function addBinding(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var binding = normalize(key);
      if (binding == null || binding.key == null) {
        return debug.warn('Attempted to add invalid keyboard binding', binding);
      }
      if (typeof context === 'function') {
        context = { handler: context };
      }
      if (typeof handler === 'function') {
        handler = { handler: handler };
      }
      binding = (0, _extend2.default)(binding, context, handler);
      this.bindings[binding.key] = this.bindings[binding.key] || [];
      this.bindings[binding.key].push(binding);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (evt) {
        if (evt.defaultPrevented) return;
        var which = evt.which || evt.keyCode;
        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
          return Keyboard.match(evt, binding);
        });
        if (bindings.length === 0) return;
        var range = _this2.quill.getSelection();
        if (range == null || !_this2.quill.hasFocus()) return;

        var _quill$getLine = _this2.quill.getLine(range.index),
            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
            line = _quill$getLine2[0],
            offset = _quill$getLine2[1];

        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
            leafStart = _quill$getLeaf2[0],
            offsetStart = _quill$getLeaf2[1];

        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
            _ref2 = _slicedToArray(_ref, 2),
            leafEnd = _ref2[0],
            offsetEnd = _ref2[1];

        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
        var curContext = {
          collapsed: range.length === 0,
          empty: range.length === 0 && line.length() <= 1,
          format: _this2.quill.getFormat(range),
          offset: offset,
          prefix: prefixText,
          suffix: suffixText
        };
        var prevented = bindings.some(function (binding) {
          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
          if (binding.empty != null && binding.empty !== curContext.empty) return false;
          if (binding.offset != null && binding.offset !== curContext.offset) return false;
          if (Array.isArray(binding.format)) {
            // any format is present
            if (binding.format.every(function (name) {
              return curContext.format[name] == null;
            })) {
              return false;
            }
          } else if (_typeof(binding.format) === 'object') {
            // all formats must match
            if (!Object.keys(binding.format).every(function (name) {
              if (binding.format[name] === true) return curContext.format[name] != null;
              if (binding.format[name] === false) return curContext.format[name] == null;
              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
            })) {
              return false;
            }
          }
          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
          return binding.handler.call(_this2, range, curContext) !== true;
        });
        if (prevented) {
          evt.preventDefault();
        }
      });
    }
  }]);

  return Keyboard;
}(_module2.default);

Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

Keyboard.DEFAULTS = {
  bindings: {
    'bold': makeFormatHandler('bold'),
    'italic': makeFormatHandler('italic'),
    'underline': makeFormatHandler('underline'),
    'indent': {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: Keyboard.keys.TAB,
      format: ['blockquote', 'indent', 'list'],
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '+1', _quill2.default.sources.USER);
      }
    },
    'outdent': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      format: ['blockquote', 'indent', 'list'],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '-1', _quill2.default.sources.USER);
      }
    },
    'outdent backspace': {
      key: Keyboard.keys.BACKSPACE,
      collapsed: true,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ['indent', 'list'],
      offset: 0,
      handler: function handler(range, context) {
        if (context.format.indent != null) {
          this.quill.format('indent', '-1', _quill2.default.sources.USER);
        } else if (context.format.list != null) {
          this.quill.format('list', false, _quill2.default.sources.USER);
        }
      }
    },
    'indent code-block': makeCodeBlockHandler(true),
    'outdent code-block': makeCodeBlockHandler(false),
    'remove tab': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      collapsed: true,
      prefix: /\t$/,
      handler: function handler(range) {
        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
      }
    },
    'tab': {
      key: Keyboard.keys.TAB,
      handler: function handler(range) {
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
      }
    },
    'list empty enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['list'],
      empty: true,
      handler: function handler(range, context) {
        this.quill.format('list', false, _quill2.default.sources.USER);
        if (context.format.indent) {
          this.quill.format('indent', false, _quill2.default.sources.USER);
        }
      }
    },
    'checklist enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: { list: 'checked' },
      handler: function handler(range) {
        var _quill$getLine3 = this.quill.getLine(range.index),
            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
            line = _quill$getLine4[0],
            offset = _quill$getLine4[1];

        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'header enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['header'],
      suffix: /^$/,
      handler: function handler(range, context) {
        var _quill$getLine5 = this.quill.getLine(range.index),
            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
            line = _quill$getLine6[0],
            offset = _quill$getLine6[1];

        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'list autofill': {
      key: ' ',
      collapsed: true,
      format: { list: false },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler: function handler(range, context) {
        var length = context.prefix.length;

        var _quill$getLine7 = this.quill.getLine(range.index),
            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
            line = _quill$getLine8[0],
            offset = _quill$getLine8[1];

        if (offset > length) return true;
        var value = void 0;
        switch (context.prefix.trim()) {
          case '[]':case '[ ]':
            value = 'unchecked';
            break;
          case '[x]':
            value = 'checked';
            break;
          case '-':case '*':
            value = 'bullet';
            break;
          default:
            value = 'ordered';
        }
        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
      }
    },
    'code exit': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['code-block'],
      prefix: /\n\n$/,
      suffix: /^\s+$/,
      handler: function handler(range) {
        var _quill$getLine9 = this.quill.getLine(range.index),
            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
            line = _quill$getLine10[0],
            offset = _quill$getLine10[1];

        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
        this.quill.updateContents(delta, _quill2.default.sources.USER);
      }
    },
    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
  }
};

function makeEmbedArrowHandler(key, shiftKey) {
  var _ref3;

  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
  return _ref3 = {
    key: key,
    shiftKey: shiftKey,
    altKey: null
  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
    var index = range.index;
    if (key === Keyboard.keys.RIGHT) {
      index += range.length + 1;
    }

    var _quill$getLeaf3 = this.quill.getLeaf(index),
        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
        leaf = _quill$getLeaf4[0];

    if (!(leaf instanceof _parchment2.default.Embed)) return true;
    if (key === Keyboard.keys.LEFT) {
      if (shiftKey) {
        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
      }
    } else {
      if (shiftKey) {
        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
      }
    }
    return false;
  }), _ref3;
}

function handleBackspace(range, context) {
  if (range.index === 0 || this.quill.getLength() <= 1) return;

  var _quill$getLine11 = this.quill.getLine(range.index),
      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
      line = _quill$getLine12[0];

  var formats = {};
  if (context.offset === 0) {
    var _quill$getLine13 = this.quill.getLine(range.index - 1),
        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
        prev = _quill$getLine14[0];

    if (prev != null && prev.length() > 1) {
      var curFormats = line.formats();
      var prevFormats = this.quill.getFormat(range.index - 1, 1);
      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
    }
  }
  // Check for astral symbols
  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
  }
  this.quill.focus();
}

function handleDelete(range, context) {
  // Check for astral symbols
  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
  if (range.index >= this.quill.getLength() - length) return;
  var formats = {},
      nextLength = 0;

  var _quill$getLine15 = this.quill.getLine(range.index),
      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
      line = _quill$getLine16[0];

  if (context.offset >= line.length() - 1) {
    var _quill$getLine17 = this.quill.getLine(range.index + 1),
        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
        next = _quill$getLine18[0];

    if (next) {
      var curFormats = line.formats();
      var nextFormats = this.quill.getFormat(range.index, 1);
      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
      nextLength = next.length();
    }
  }
  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
  }
}

function handleDeleteRange(range) {
  var lines = this.quill.getLines(range);
  var formats = {};
  if (lines.length > 1) {
    var firstFormats = lines[0].formats();
    var lastFormats = lines[lines.length - 1].formats();
    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
  }
  this.quill.deleteText(range, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
  }
  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
  this.quill.focus();
}

function handleEnter(range, context) {
  var _this3 = this;

  if (range.length > 0) {
    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
  }
  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
      lineFormats[format] = context.format[format];
    }
    return lineFormats;
  }, {});
  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
  // Earlier scroll.deleteAt might have messed up our selection,
  // so insertText's built in selection preservation is not reliable
  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
  this.quill.focus();
  Object.keys(context.format).forEach(function (name) {
    if (lineFormats[name] != null) return;
    if (Array.isArray(context.format[name])) return;
    if (name === 'link') return;
    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
  });
}

function makeCodeBlockHandler(indent) {
  return {
    key: Keyboard.keys.TAB,
    shiftKey: !indent,
    format: { 'code-block': true },
    handler: function handler(range) {
      var CodeBlock = _parchment2.default.query('code-block');
      var index = range.index,
          length = range.length;

      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
          block = _quill$scroll$descend2[0],
          offset = _quill$scroll$descend2[1];

      if (block == null) return;
      var scrollIndex = this.quill.getIndex(block);
      var start = block.newlineIndex(offset, true) + 1;
      var end = block.newlineIndex(scrollIndex + offset + length);
      var lines = block.domNode.textContent.slice(start, end).split('\n');
      offset = 0;
      lines.forEach(function (line, i) {
        if (indent) {
          block.insertAt(start + offset, CodeBlock.TAB);
          offset += CodeBlock.TAB.length;
          if (i === 0) {
            index += CodeBlock.TAB.length;
          } else {
            length += CodeBlock.TAB.length;
          }
        } else if (line.startsWith(CodeBlock.TAB)) {
          block.deleteAt(start + offset, CodeBlock.TAB.length);
          offset -= CodeBlock.TAB.length;
          if (i === 0) {
            index -= CodeBlock.TAB.length;
          } else {
            length -= CodeBlock.TAB.length;
          }
        }
        offset += line.length + 1;
      });
      this.quill.update(_quill2.default.sources.USER);
      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
    }
  };
}

function makeFormatHandler(format) {
  return {
    key: format[0].toUpperCase(),
    shortKey: true,
    handler: function handler(range, context) {
      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
    }
  };
}

function normalize(binding) {
  if (typeof binding === 'string' || typeof binding === 'number') {
    return normalize({ key: binding });
  }
  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
    binding = (0, _clone2.default)(binding, false);
  }
  if (typeof binding.key === 'string') {
    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
      binding.key = Keyboard.keys[binding.key.toUpperCase()];
    } else if (binding.key.length === 1) {
      binding.key = binding.key.toUpperCase().charCodeAt(0);
    } else {
      return null;
    }
  }
  if (binding.shortKey) {
    binding[SHORTKEY] = binding.shortKey;
    delete binding.shortKey;
  }
  return binding;
}

exports.default = Keyboard;
exports.SHORTKEY = SHORTKEY;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cursor = function (_Parchment$Embed) {
  _inherits(Cursor, _Parchment$Embed);

  _createClass(Cursor, null, [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  function Cursor(domNode, selection) {
    _classCallCheck(this, Cursor);

    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    return _this;
  }

  _createClass(Cursor, [{
    key: 'detach',
    value: function detach() {
      // super.detach() will also clear domNode.__blot
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (this._length !== 0) {
        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
      }
      var target = this,
          index = 0;
      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: 'index',
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'length',
    value: function length() {
      return this._length;
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: 'remove',
    value: function remove() {
      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
      this.parent = null;
    }
  }, {
    key: 'restore',
    value: function restore() {
      if (this.selection.composing || this.parent == null) return;
      var textNode = this.textNode;
      var range = this.selection.getNativeRange();
      var restoreText = void 0,
          start = void 0,
          end = void 0;
      if (range != null && range.start.node === textNode && range.end.node === textNode) {
        var _ref = [textNode, range.start.offset, range.end.offset];
        restoreText = _ref[0];
        start = _ref[1];
        end = _ref[2];
      }
      // Link format will insert text outside of anchor tag
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      if (this.textNode.data !== Cursor.CONTENTS) {
        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
        if (this.next instanceof _text2.default) {
          restoreText = this.next.domNode;
          this.next.insertAt(0, text);
          this.textNode.data = Cursor.CONTENTS;
        } else {
          this.textNode.data = text;
          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
          this.textNode = document.createTextNode(Cursor.CONTENTS);
          this.domNode.appendChild(this.textNode);
        }
      }
      this.remove();
      if (start != null) {
        var _map = [start, end].map(function (offset) {
          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
        });

        var _map2 = _slicedToArray(_map, 2);

        start = _map2[0];
        end = _map2[1];

        return {
          startNode: restoreText,
          startOffset: start,
          endNode: restoreText,
          endOffset: end
        };
      }
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) context.range = range;
      }
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }]);

  return Cursor;
}(_parchment2.default.Embed);

Cursor.blotName = 'cursor';
Cursor.className = 'ql-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


exports.default = Cursor;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Parchment$Container) {
  _inherits(Container, _Parchment$Container);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_parchment2.default.Container);

Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

exports.default = Container;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorAttributor = function (_Parchment$Attributor) {
  _inherits(ColorAttributor, _Parchment$Attributor);

  function ColorAttributor() {
    _classCallCheck(this, ColorAttributor);

    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
  }

  _createClass(ColorAttributor, [{
    key: 'value',
    value: function value(domNode) {
      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);

  return ColorAttributor;
}(_parchment2.default.Attributor.Style);

var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
  scope: _parchment2.default.Scope.INLINE
});
var ColorStyle = new ColorAttributor('color', 'color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.ColorAttributor = ColorAttributor;
exports.ColorClass = ColorClass;
exports.ColorStyle = ColorStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Inline) {
  _inherits(Link, _Inline);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
  }]);

  return Link;
}(_inline2.default);

Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function _sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

exports.default = Link;
exports.sanitize = _sanitize;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _dropdown = __webpack_require__(107);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var optionsCounter = 0;

function toggleAriaAttribute(element, attribute) {
  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
}

var Picker = function () {
  function Picker(select) {
    var _this = this;

    _classCallCheck(this, Picker);

    this.select = select;
    this.container = document.createElement('span');
    this.buildPicker();
    this.select.style.display = 'none';
    this.select.parentNode.insertBefore(this.container, this.select);

    this.label.addEventListener('mousedown', function () {
      _this.togglePicker();
    });
    this.label.addEventListener('keydown', function (event) {
      switch (event.keyCode) {
        // Allows the "Enter" key to open the picker
        case _keyboard2.default.keys.ENTER:
          _this.togglePicker();
          break;

        // Allows the "Escape" key to close the picker
        case _keyboard2.default.keys.ESCAPE:
          _this.escape();
          event.preventDefault();
          break;
        default:
      }
    });
    this.select.addEventListener('change', this.update.bind(this));
  }

  _createClass(Picker, [{
    key: 'togglePicker',
    value: function togglePicker() {
      this.container.classList.toggle('ql-expanded');
      // Toggle aria-expanded and aria-hidden to make the picker accessible
      toggleAriaAttribute(this.label, 'aria-expanded');
      toggleAriaAttribute(this.options, 'aria-hidden');
    }
  }, {
    key: 'buildItem',
    value: function buildItem(option) {
      var _this2 = this;

      var item = document.createElement('span');
      item.tabIndex = '0';
      item.setAttribute('role', 'button');

      item.classList.add('ql-picker-item');
      if (option.hasAttribute('value')) {
        item.setAttribute('data-value', option.getAttribute('value'));
      }
      if (option.textContent) {
        item.setAttribute('data-label', option.textContent);
      }
      item.addEventListener('click', function () {
        _this2.selectItem(item, true);
      });
      item.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          // Allows the "Enter" key to select an item
          case _keyboard2.default.keys.ENTER:
            _this2.selectItem(item, true);
            event.preventDefault();
            break;

          // Allows the "Escape" key to close the picker
          case _keyboard2.default.keys.ESCAPE:
            _this2.escape();
            event.preventDefault();
            break;
          default:
        }
      });

      return item;
    }
  }, {
    key: 'buildLabel',
    value: function buildLabel() {
      var label = document.createElement('span');
      label.classList.add('ql-picker-label');
      label.innerHTML = _dropdown2.default;
      label.tabIndex = '0';
      label.setAttribute('role', 'button');
      label.setAttribute('aria-expanded', 'false');
      this.container.appendChild(label);
      return label;
    }
  }, {
    key: 'buildOptions',
    value: function buildOptions() {
      var _this3 = this;

      var options = document.createElement('span');
      options.classList.add('ql-picker-options');

      // Don't want screen readers to read this until options are visible
      options.setAttribute('aria-hidden', 'true');
      options.tabIndex = '-1';

      // Need a unique id for aria-controls
      options.id = 'ql-picker-options-' + optionsCounter;
      optionsCounter += 1;
      this.label.setAttribute('aria-controls', options.id);

      this.options = options;

      [].slice.call(this.select.options).forEach(function (option) {
        var item = _this3.buildItem(option);
        options.appendChild(item);
        if (option.selected === true) {
          _this3.selectItem(item);
        }
      });
      this.container.appendChild(options);
    }
  }, {
    key: 'buildPicker',
    value: function buildPicker() {
      var _this4 = this;

      [].slice.call(this.select.attributes).forEach(function (item) {
        _this4.container.setAttribute(item.name, item.value);
      });
      this.container.classList.add('ql-picker');
      this.label = this.buildLabel();
      this.buildOptions();
    }
  }, {
    key: 'escape',
    value: function escape() {
      var _this5 = this;

      // Close menu and return focus to trigger label
      this.close();
      // Need setTimeout for accessibility to ensure that the browser executes
      // focus on the next process thread and after any DOM content changes
      setTimeout(function () {
        return _this5.label.focus();
      }, 1);
    }
  }, {
    key: 'close',
    value: function close() {
      this.container.classList.remove('ql-expanded');
      this.label.setAttribute('aria-expanded', 'false');
      this.options.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = this.container.querySelector('.ql-selected');
      if (item === selected) return;
      if (selected != null) {
        selected.classList.remove('ql-selected');
      }
      if (item == null) return;
      item.classList.add('ql-selected');
      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
      if (item.hasAttribute('data-value')) {
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
      } else {
        this.label.removeAttribute('data-value');
      }
      if (item.hasAttribute('data-label')) {
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
      } else {
        this.label.removeAttribute('data-label');
      }
      if (trigger) {
        if (typeof Event === 'function') {
          this.select.dispatchEvent(new Event('change'));
        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
          // IE11
          var event = document.createEvent('Event');
          event.initEvent('change', true, true);
          this.select.dispatchEvent(event);
        }
        this.close();
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var option = void 0;
      if (this.select.selectedIndex > -1) {
        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
        option = this.select.options[this.select.selectedIndex];
        this.selectItem(item);
      } else {
        this.selectItem(null);
      }
      var isActive = option != null && option !== this.select.querySelector('option[selected]');
      this.label.classList.toggle('ql-active', isActive);
    }
  }]);

  return Picker;
}();

exports.default = Picker;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _scroll = __webpack_require__(22);

var _scroll2 = _interopRequireDefault(_scroll);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _clipboard = __webpack_require__(55);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _history = __webpack_require__(42);

var _history2 = _interopRequireDefault(_history);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_quill2.default.register({
  'blots/block': _block2.default,
  'blots/block/embed': _block.BlockEmbed,
  'blots/break': _break2.default,
  'blots/container': _container2.default,
  'blots/cursor': _cursor2.default,
  'blots/embed': _embed2.default,
  'blots/inline': _inline2.default,
  'blots/scroll': _scroll2.default,
  'blots/text': _text2.default,

  'modules/clipboard': _clipboard2.default,
  'modules/history': _history2.default,
  'modules/keyboard': _keyboard2.default
});

_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

exports.default = _quill2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var ShadowBlot = /** @class */ (function () {
    function ShadowBlot(domNode) {
        this.domNode = domNode;
        // @ts-ignore
        this.domNode[Registry.DATA_KEY] = { blot: this };
    }
    Object.defineProperty(ShadowBlot.prototype, "statics", {
        // Hack for accessing inherited static methods
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    ShadowBlot.create = function (value) {
        if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
        }
        var node;
        if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
                value = value.toUpperCase();
                if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                }
            }
            if (typeof value === 'number') {
                node = document.createElement(this.tagName[value - 1]);
            }
            else if (this.tagName.indexOf(value) > -1) {
                node = document.createElement(value);
            }
            else {
                node = document.createElement(this.tagName[0]);
            }
        }
        else {
            node = document.createElement(this.tagName);
        }
        if (this.className) {
            node.classList.add(this.className);
        }
        return node;
    };
    ShadowBlot.prototype.attach = function () {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    };
    ShadowBlot.prototype.clone = function () {
        var domNode = this.domNode.cloneNode(false);
        return Registry.create(domNode);
    };
    ShadowBlot.prototype.detach = function () {
        if (this.parent != null)
            this.parent.removeChild(this);
        // @ts-ignore
        delete this.domNode[Registry.DATA_KEY];
    };
    ShadowBlot.prototype.deleteAt = function (index, length) {
        var blot = this.isolate(index, length);
        blot.remove();
    };
    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
        var blot = this.isolate(index, length);
        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
        }
        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
        }
    };
    ShadowBlot.prototype.insertAt = function (index, value, def) {
        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
        var ref = this.split(index);
        this.parent.insertBefore(blot, ref);
    };
    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
        if (refBlot === void 0) { refBlot = null; }
        if (this.parent != null) {
            this.parent.children.remove(this);
        }
        var refDomNode = null;
        parentBlot.children.insertBefore(this, refBlot);
        if (refBlot != null) {
            refDomNode = refBlot.domNode;
        }
        if (this.domNode.parentNode != parentBlot.domNode ||
            this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
        }
        this.parent = parentBlot;
        this.attach();
    };
    ShadowBlot.prototype.isolate = function (index, length) {
        var target = this.split(index);
        target.split(length);
        return target;
    };
    ShadowBlot.prototype.length = function () {
        return 1;
    };
    ShadowBlot.prototype.offset = function (root) {
        if (root === void 0) { root = this.parent; }
        if (this.parent == null || this == root)
            return 0;
        return this.parent.children.offset(this) + this.parent.offset(root);
    };
    ShadowBlot.prototype.optimize = function (context) {
        // TODO clean up once we use WeakMap
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
        }
    };
    ShadowBlot.prototype.remove = function () {
        if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.detach();
    };
    ShadowBlot.prototype.replace = function (target) {
        if (target.parent == null)
            return;
        target.parent.insertBefore(this, target.next);
        target.remove();
    };
    ShadowBlot.prototype.replaceWith = function (name, value) {
        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
        replacement.replace(this);
        return replacement;
    };
    ShadowBlot.prototype.split = function (index, force) {
        return index === 0 ? this : this.next;
    };
    ShadowBlot.prototype.update = function (mutations, context) {
        // Nothing to do by default
    };
    ShadowBlot.prototype.wrap = function (name, value) {
        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
        if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
        }
        wrapper.appendChild(this);
        return wrapper;
    };
    ShadowBlot.blotName = 'abstract';
    return ShadowBlot;
}());
exports.default = ShadowBlot;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var Registry = __webpack_require__(1);
var AttributorStore = /** @class */ (function () {
    function AttributorStore(domNode) {
        this.attributes = {};
        this.domNode = domNode;
        this.build();
    }
    AttributorStore.prototype.attribute = function (attribute, value) {
        // verb
        if (value) {
            if (attribute.add(this.domNode, value)) {
                if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                }
                else {
                    delete this.attributes[attribute.attrName];
                }
            }
        }
        else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
        }
    };
    AttributorStore.prototype.build = function () {
        var _this = this;
        this.attributes = {};
        var attributes = attributor_1.default.keys(this.domNode);
        var classes = class_1.default.keys(this.domNode);
        var styles = style_1.default.keys(this.domNode);
        attributes
            .concat(classes)
            .concat(styles)
            .forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
                _this.attributes[attr.attrName] = attr;
            }
        });
    };
    AttributorStore.prototype.copy = function (target) {
        var _this = this;
        Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
        });
    };
    AttributorStore.prototype.move = function (target) {
        var _this = this;
        this.copy(target);
        Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
        });
        this.attributes = {};
    };
    AttributorStore.prototype.values = function () {
        var _this = this;
        return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
        }, {});
    };
    return AttributorStore;
}());
exports.default = AttributorStore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function match(node, prefix) {
    var className = node.getAttribute('class') || '';
    return className.split(/\s+/).filter(function (name) {
        return name.indexOf(prefix + "-") === 0;
    });
}
var ClassAttributor = /** @class */ (function (_super) {
    __extends(ClassAttributor, _super);
    function ClassAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassAttributor.keys = function (node) {
        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name
                .split('-')
                .slice(0, -1)
                .join('-');
        });
    };
    ClassAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        this.remove(node);
        node.classList.add(this.keyName + "-" + value);
        return true;
    };
    ClassAttributor.prototype.remove = function (node) {
        var matches = match(node, this.keyName);
        matches.forEach(function (name) {
            node.classList.remove(name);
        });
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    };
    ClassAttributor.prototype.value = function (node) {
        var result = match(node, this.keyName)[0] || '';
        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
        return this.canAdd(node, value) ? value : '';
    };
    return ClassAttributor;
}(attributor_1.default));
exports.default = ClassAttributor;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function camelize(name) {
    var parts = name.split('-');
    var rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
var StyleAttributor = /** @class */ (function (_super) {
    __extends(StyleAttributor, _super);
    function StyleAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleAttributor.keys = function (node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
        });
    };
    StyleAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    };
    StyleAttributor.prototype.remove = function (node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    };
    StyleAttributor.prototype.value = function (node) {
        // @ts-ignore
        var value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    };
    return StyleAttributor;
}(attributor_1.default));
exports.default = StyleAttributor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: 'addModule',
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import('modules/' + name);
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};

exports.default = Theme;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUARD_TEXT = '\uFEFF';

var Embed = function (_Parchment$Embed) {
  _inherits(Embed, _Parchment$Embed);

  function Embed(node) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    _this.leftGuard = document.createTextNode(GUARD_TEXT);
    _this.rightGuard = document.createTextNode(GUARD_TEXT);
    _this.domNode.appendChild(_this.leftGuard);
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    return _this;
  }

  _createClass(Embed, [{
    key: 'index',
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'restore',
    value: function restore(node) {
      var range = void 0,
          textNode = void 0;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof _text2.default) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof _text2.default) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        }
      });
    }
  }]);

  return Embed;
}(_parchment2.default.Embed);

exports.default = Embed;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};

var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

exports.AlignAttribute = AlignAttribute;
exports.AlignClass = AlignClass;
exports.AlignStyle = AlignStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundStyle = exports.BackgroundClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _color = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
  scope: _parchment2.default.Scope.INLINE
});
var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.BackgroundClass = BackgroundClass;
exports.BackgroundStyle = BackgroundStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['rtl']
};

var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

exports.DirectionAttribute = DirectionAttribute;
exports.DirectionClass = DirectionClass;
exports.DirectionStyle = DirectionStyle;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontClass = exports.FontStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var config = {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['serif', 'monospace']
};

var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

var FontStyleAttributor = function (_Parchment$Attributor) {
  _inherits(FontStyleAttributor, _Parchment$Attributor);

  function FontStyleAttributor() {
    _classCallCheck(this, FontStyleAttributor);

    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
  }

  _createClass(FontStyleAttributor, [{
    key: 'value',
    value: function value(node) {
      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
    }
  }]);

  return FontStyleAttributor;
}(_parchment2.default.Attributor.Style);

var FontStyle = new FontStyleAttributor('font', 'font-family', config);

exports.FontStyle = FontStyle;
exports.FontClass = FontClass;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeStyle = exports.SizeClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['small', 'large', 'huge']
});
var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['10px', '18px', '32px']
});

exports.SizeClass = SizeClass;
exports.SizeStyle = SizeStyle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  'align': {
    '': __webpack_require__(76),
    'center': __webpack_require__(77),
    'right': __webpack_require__(78),
    'justify': __webpack_require__(79)
  },
  'background': __webpack_require__(80),
  'blockquote': __webpack_require__(81),
  'bold': __webpack_require__(82),
  'clean': __webpack_require__(83),
  'code': __webpack_require__(58),
  'code-block': __webpack_require__(58),
  'color': __webpack_require__(84),
  'direction': {
    '': __webpack_require__(85),
    'rtl': __webpack_require__(86)
  },
  'float': {
    'center': __webpack_require__(87),
    'full': __webpack_require__(88),
    'left': __webpack_require__(89),
    'right': __webpack_require__(90)
  },
  'formula': __webpack_require__(91),
  'header': {
    '1': __webpack_require__(92),
    '2': __webpack_require__(93)
  },
  'italic': __webpack_require__(94),
  'image': __webpack_require__(95),
  'indent': {
    '+1': __webpack_require__(96),
    '-1': __webpack_require__(97)
  },
  'link': __webpack_require__(98),
  'list': {
    'ordered': __webpack_require__(99),
    'bullet': __webpack_require__(100),
    'check': __webpack_require__(101)
  },
  'script': {
    'sub': __webpack_require__(102),
    'super': __webpack_require__(103)
  },
  'strike': __webpack_require__(104),
  'underline': __webpack_require__(105),
  'video': __webpack_require__(106)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastChangeIndex = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_Module) {
  _inherits(History, _Module);

  function History(quill, options) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

    _this.lastRecorded = 0;
    _this.ignoreChange = false;
    _this.clear();
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
        _this.record(delta, oldDelta);
      } else {
        _this.transform(delta);
      }
    });
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
    if (/Win/i.test(navigator.platform)) {
      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
    }
    return _this;
  }

  _createClass(History, [{
    key: 'change',
    value: function change(source, dest) {
      if (this.stack[source].length === 0) return;
      var delta = this.stack[source].pop();
      this.stack[dest].push(delta);
      this.lastRecorded = 0;
      this.ignoreChange = true;
      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
      this.ignoreChange = false;
      var index = getLastChangeIndex(delta[source]);
      this.quill.setSelection(index);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stack = { undo: [], redo: [] };
    }
  }, {
    key: 'cutoff',
    value: function cutoff() {
      this.lastRecorded = 0;
    }
  }, {
    key: 'record',
    value: function record(changeDelta, oldDelta) {
      if (changeDelta.ops.length === 0) return;
      this.stack.redo = [];
      var undoDelta = this.quill.getContents().diff(oldDelta);
      var timestamp = Date.now();
      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
        var delta = this.stack.undo.pop();
        undoDelta = undoDelta.compose(delta.undo);
        changeDelta = delta.redo.compose(changeDelta);
      } else {
        this.lastRecorded = timestamp;
      }
      this.stack.undo.push({
        redo: changeDelta,
        undo: undoDelta
      });
      if (this.stack.undo.length > this.options.maxStack) {
        this.stack.undo.shift();
      }
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.change('redo', 'undo');
    }
  }, {
    key: 'transform',
    value: function transform(delta) {
      this.stack.undo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
      this.stack.redo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
    }
  }, {
    key: 'undo',
    value: function undo() {
      this.change('undo', 'redo');
    }
  }]);

  return History;
}(_module2.default);

History.DEFAULTS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false
};

function endsWithNewlineChange(delta) {
  var lastOp = delta.ops[delta.ops.length - 1];
  if (lastOp == null) return false;
  if (lastOp.insert != null) {
    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
  }
  if (lastOp.attributes != null) {
    return Object.keys(lastOp.attributes).some(function (attr) {
      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
    });
  }
  return false;
}

function getLastChangeIndex(delta) {
  var deleteLength = delta.reduce(function (length, op) {
    length += op.delete || 0;
    return length;
  }, 0);
  var changeIndex = delta.length() - deleteLength;
  if (endsWithNewlineChange(delta)) {
    changeIndex -= 1;
  }
  return changeIndex;
}

exports.default = History;
exports.getLastChangeIndex = getLastChangeIndex;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGNS = [false, 'center', 'right', 'justify'];

var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

var FONTS = [false, 'serif', 'monospace'];

var HEADERS = ['1', '2', '3', false];

var SIZES = ['small', false, 'large', 'huge'];

var BaseTheme = function (_Theme) {
  _inherits(BaseTheme, _Theme);

  function BaseTheme(quill, options) {
    _classCallCheck(this, BaseTheme);

    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

    var listener = function listener(e) {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
        _this.tooltip.hide();
      }
      if (_this.pickers != null) {
        _this.pickers.forEach(function (picker) {
          if (!picker.container.contains(e.target)) {
            picker.close();
          }
        });
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
    return _this;
  }

  _createClass(BaseTheme, [{
    key: 'addModule',
    value: function addModule(name) {
      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
      if (name === 'toolbar') {
        this.extendToolbar(module);
      }
      return module;
    }
  }, {
    key: 'buildButtons',
    value: function buildButtons(buttons, icons) {
      buttons.forEach(function (button) {
        var className = button.getAttribute('class') || '';
        className.split(/\s+/).forEach(function (name) {
          if (!name.startsWith('ql-')) return;
          name = name.slice('ql-'.length);
          if (icons[name] == null) return;
          if (name === 'direction') {
            button.innerHTML = icons[name][''] + icons[name]['rtl'];
          } else if (typeof icons[name] === 'string') {
            button.innerHTML = icons[name];
          } else {
            var value = button.value || '';
            if (value != null && icons[name][value]) {
              button.innerHTML = icons[name][value];
            }
          }
        });
      });
    }
  }, {
    key: 'buildPickers',
    value: function buildPickers(selects, icons) {
      var _this2 = this;

      this.pickers = selects.map(function (select) {
        if (select.classList.contains('ql-align')) {
          if (select.querySelector('option') == null) {
            fillSelect(select, ALIGNS);
          }
          return new _iconPicker2.default(select, icons.align);
        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
          var format = select.classList.contains('ql-background') ? 'background' : 'color';
          if (select.querySelector('option') == null) {
            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
          }
          return new _colorPicker2.default(select, icons[format]);
        } else {
          if (select.querySelector('option') == null) {
            if (select.classList.contains('ql-font')) {
              fillSelect(select, FONTS);
            } else if (select.classList.contains('ql-header')) {
              fillSelect(select, HEADERS);
            } else if (select.classList.contains('ql-size')) {
              fillSelect(select, SIZES);
            }
          }
          return new _picker2.default(select);
        }
      });
      var update = function update() {
        _this2.pickers.forEach(function (picker) {
          picker.update();
        });
      };
      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
    }
  }]);

  return BaseTheme;
}(_theme2.default);

BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula: function formula() {
          this.quill.theme.tooltip.edit('formula');
        },
        image: function image() {
          var _this3 = this;

          var fileInput = this.container.querySelector('input.ql-image[type=file]');
          if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', function () {
              if (fileInput.files != null && fileInput.files[0] != null) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var range = _this3.quill.getSelection(true);
                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                  fileInput.value = "";
                };
                reader.readAsDataURL(fileInput.files[0]);
              }
            });
            this.container.appendChild(fileInput);
          }
          fileInput.click();
        },
        video: function video() {
          this.quill.theme.tooltip.edit('video');
        }
      }
    }
  }
});

var BaseTooltip = function (_Tooltip) {
  _inherits(BaseTooltip, _Tooltip);

  function BaseTooltip(quill, boundsContainer) {
    _classCallCheck(this, BaseTooltip);

    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

    _this4.textbox = _this4.root.querySelector('input[type="text"]');
    _this4.listen();
    return _this4;
  }

  _createClass(BaseTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this5 = this;

      this.textbox.addEventListener('keydown', function (event) {
        if (_keyboard2.default.match(event, 'enter')) {
          _this5.save();
          event.preventDefault();
        } else if (_keyboard2.default.match(event, 'escape')) {
          _this5.cancel();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.hide();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.root.classList.remove('ql-hidden');
      this.root.classList.add('ql-editing');
      if (preview != null) {
        this.textbox.value = preview;
      } else if (mode !== this.root.getAttribute('data-mode')) {
        this.textbox.value = '';
      }
      this.position(this.quill.getBounds(this.quill.selection.savedRange));
      this.textbox.select();
      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
      this.root.setAttribute('data-mode', mode);
    }
  }, {
    key: 'restoreFocus',
    value: function restoreFocus() {
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.quill.focus();
      this.quill.scrollingContainer.scrollTop = scrollTop;
    }
  }, {
    key: 'save',
    value: function save() {
      var value = this.textbox.value;
      switch (this.root.getAttribute('data-mode')) {
        case 'link':
          {
            var scrollTop = this.quill.root.scrollTop;
            if (this.linkRange) {
              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
              delete this.linkRange;
            } else {
              this.restoreFocus();
              this.quill.format('link', value, _emitter2.default.sources.USER);
            }
            this.quill.root.scrollTop = scrollTop;
            break;
          }
        case 'video':
          {
            value = extractVideoUrl(value);
          } // eslint-disable-next-line no-fallthrough
        case 'formula':
          {
            if (!value) break;
            var range = this.quill.getSelection(true);
            if (range != null) {
              var index = range.index + range.length;
              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
              if (this.root.getAttribute('data-mode') === 'formula') {
                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
              }
              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
            }
            break;
          }
        default:
      }
      this.textbox.value = '';
      this.hide();
    }
  }]);

  return BaseTooltip;
}(_tooltip2.default);

function extractVideoUrl(url) {
  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (match) {
    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
    // eslint-disable-line no-cond-assign
    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  return url;
}

function fillSelect(select, values) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

exports.BaseTooltip = BaseTooltip;
exports.default = BaseTheme;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.head = this.tail = null;
        this.length = 0;
    }
    LinkedList.prototype.append = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.insertBefore(nodes[0], null);
        if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
        }
    };
    LinkedList.prototype.contains = function (node) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            if (cur === node)
                return true;
        }
        return false;
    };
    LinkedList.prototype.insertBefore = function (node, refNode) {
        if (!node)
            return;
        node.next = refNode;
        if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
                refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
                this.head = node;
            }
        }
        else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
        }
        else {
            node.prev = null;
            this.head = this.tail = node;
        }
        this.length += 1;
    };
    LinkedList.prototype.offset = function (target) {
        var index = 0, cur = this.head;
        while (cur != null) {
            if (cur === target)
                return index;
            index += cur.length();
            cur = cur.next;
        }
        return -1;
    };
    LinkedList.prototype.remove = function (node) {
        if (!this.contains(node))
            return;
        if (node.prev != null)
            node.prev.next = node.next;
        if (node.next != null)
            node.next.prev = node.prev;
        if (node === this.head)
            this.head = node.next;
        if (node === this.tail)
            this.tail = node.prev;
        this.length -= 1;
    };
    LinkedList.prototype.iterator = function (curNode) {
        if (curNode === void 0) { curNode = this.head; }
        // TODO use yield when we can
        return function () {
            var ret = curNode;
            if (curNode != null)
                curNode = curNode.next;
            return ret;
        };
    };
    LinkedList.prototype.find = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var cur, next = this.iterator();
        while ((cur = next())) {
            var length = cur.length();
            if (index < length ||
                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                return [cur, index];
            }
            index -= length;
        }
        return [null, 0];
    };
    LinkedList.prototype.forEach = function (callback) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            callback(cur);
        }
    };
    LinkedList.prototype.forEachAt = function (index, length, callback) {
        if (length <= 0)
            return;
        var _a = this.find(index), startNode = _a[0], offset = _a[1];
        var cur, curIndex = index - offset, next = this.iterator(startNode);
        while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            }
            else {
                callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
        }
    };
    LinkedList.prototype.map = function (callback) {
        return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
        }, []);
    };
    LinkedList.prototype.reduce = function (callback, memo) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            memo = callback(memo, cur);
        }
        return memo;
    };
    return LinkedList;
}());
exports.default = LinkedList;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true,
};
var MAX_OPTIMIZE_ITERATIONS = 100;
var ScrollBlot = /** @class */ (function (_super) {
    __extends(ScrollBlot, _super);
    function ScrollBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.scroll = _this;
        _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
        });
        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
        _this.attach();
        return _this;
    }
    ScrollBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.observer.disconnect();
    };
    ScrollBlot.prototype.deleteAt = function (index, length) {
        this.update();
        if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
                child.remove();
            });
        }
        else {
            _super.prototype.deleteAt.call(this, index, length);
        }
    };
    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
        this.update();
        _super.prototype.formatAt.call(this, index, length, name, value);
    };
    ScrollBlot.prototype.insertAt = function (index, value, def) {
        this.update();
        _super.prototype.insertAt.call(this, index, value, def);
    };
    ScrollBlot.prototype.optimize = function (mutations, context) {
        var _this = this;
        if (mutations === void 0) { mutations = []; }
        if (context === void 0) { context = {}; }
        _super.prototype.optimize.call(this, context);
        // We must modify mutations directly, cannot make copy and then modify
        var records = [].slice.call(this.observer.takeRecords());
        // Array.push currently seems to be implemented by a non-tail recursive function
        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
        while (records.length > 0)
            mutations.push(records.pop());
        // TODO use WeakMap
        var mark = function (blot, markParent) {
            if (markParent === void 0) { markParent = true; }
            if (blot == null || blot === _this)
                return;
            if (blot.domNode.parentNode == null)
                return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent)
                mark(blot.parent);
        };
        var optimize = function (blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations == null) {
                return;
            }
            if (blot instanceof container_1.default) {
                blot.children.forEach(optimize);
            }
            blot.optimize(context);
        };
        var remaining = mutations;
        for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
                throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                    return;
                if (blot.domNode === mutation.target) {
                    if (mutation.type === 'childList') {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function (node) {
                            var child = Registry.find(node, false);
                            mark(child, false);
                            if (child instanceof container_1.default) {
                                child.children.forEach(function (grandChild) {
                                    mark(grandChild, false);
                                });
                            }
                        });
                    }
                    else if (mutation.type === 'attributes') {
                        mark(blot.prev);
                    }
                }
                mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0)
                mutations.push(records.pop());
        }
    };
    ScrollBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        mutations = mutations || this.observer.takeRecords();
        // TODO use WeakMap
        mutations
            .map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null)
                return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                return blot;
            }
            else {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                return null;
            }
        })
            .forEach(function (blot) {
            if (blot == null ||
                blot === _this ||
                //@ts-ignore
                blot.domNode[Registry.DATA_KEY] == null)
                return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
        });
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
        }
        this.optimize(mutations, context);
    };
    ScrollBlot.blotName = 'scroll';
    ScrollBlot.defaultChild = 'block';
    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
    ScrollBlot.tagName = 'DIV';
    return ScrollBlot;
}(container_1.default));
exports.default = ScrollBlot;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
// Shallow object comparison
function isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    // @ts-ignore
    for (var prop in obj1) {
        // @ts-ignore
        if (obj1[prop] !== obj2[prop])
            return false;
    }
    return true;
}
var InlineBlot = /** @class */ (function (_super) {
    __extends(InlineBlot, _super);
    function InlineBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineBlot.formats = function (domNode) {
        if (domNode.tagName === InlineBlot.tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    InlineBlot.prototype.format = function (name, value) {
        var _this = this;
        if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
                if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot.blotName, true);
                }
                _this.attributes.copy(child);
            });
            this.unwrap();
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    InlineBlot.prototype.formatAt = function (index, length, name, value) {
        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    InlineBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        var formats = this.formats();
        if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
        }
        var next = this.next;
        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
        }
    };
    InlineBlot.blotName = 'inline';
    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
    InlineBlot.tagName = 'SPAN';
    return InlineBlot;
}(format_1.default));
exports.default = InlineBlot;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
var BlockBlot = /** @class */ (function (_super) {
    __extends(BlockBlot, _super);
    function BlockBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockBlot.formats = function (domNode) {
        var tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    BlockBlot.prototype.format = function (name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    BlockBlot.prototype.formatAt = function (index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    BlockBlot.prototype.insertAt = function (index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
        }
        else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    };
    BlockBlot.prototype.update = function (mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            _super.prototype.update.call(this, mutations, context);
        }
    };
    BlockBlot.blotName = 'block';
    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
    BlockBlot.tagName = 'P';
    return BlockBlot;
}(format_1.default));
exports.default = BlockBlot;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var EmbedBlot = /** @class */ (function (_super) {
    __extends(EmbedBlot, _super);
    function EmbedBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedBlot.formats = function (domNode) {
        return undefined;
    };
    EmbedBlot.prototype.format = function (name, value) {
        // super.formatAt wraps, which is what we want in general,
        // but this allows subclasses to overwrite for formats
        // that just apply to particular embeds
        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
    };
    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
        if (index === 0 && length === this.length()) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    EmbedBlot.prototype.formats = function () {
        return this.statics.formats(this.domNode);
    };
    return EmbedBlot;
}(leaf_1.default));
exports.default = EmbedBlot;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var Registry = __webpack_require__(1);
var TextBlot = /** @class */ (function (_super) {
    __extends(TextBlot, _super);
    function TextBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.text = _this.statics.value(_this.domNode);
        return _this;
    }
    TextBlot.create = function (value) {
        return document.createTextNode(value);
    };
    TextBlot.value = function (domNode) {
        var text = domNode.data;
        // @ts-ignore
        if (text['normalize'])
            text = text['normalize']();
        return text;
    };
    TextBlot.prototype.deleteAt = function (index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    };
    TextBlot.prototype.index = function (node, offset) {
        if (this.domNode === node) {
            return offset;
        }
        return -1;
    };
    TextBlot.prototype.insertAt = function (index, value, def) {
        if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
        }
        else {
            _super.prototype.insertAt.call(this, index, value, def);
        }
    };
    TextBlot.prototype.length = function () {
        return this.text.length;
    };
    TextBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        this.text = this.statics.value(this.domNode);
        if (this.text.length === 0) {
            this.remove();
        }
        else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
        }
    };
    TextBlot.prototype.position = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        return [this.domNode, index];
    };
    TextBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = Registry.create(this.domNode.splitText(index));
        this.parent.insertBefore(after, this.next);
        this.text = this.statics.value(this.domNode);
        return after;
    };
    TextBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
        })) {
            this.text = this.statics.value(this.domNode);
        }
    };
    TextBlot.prototype.value = function () {
        return this.text;
    };
    TextBlot.blotName = 'text';
    TextBlot.scope = Registry.Scope.INLINE_BLOT;
    return TextBlot;
}(leaf_1.default));
exports.default = TextBlot;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elem = document.createElement('div');
elem.classList.toggle('test-class', false);
if (elem.classList.contains('test-class')) {
  var _toggle = DOMTokenList.prototype.toggle;
  DOMTokenList.prototype.toggle = function (token, force) {
    if (arguments.length > 1 && !this.contains(token) === !force) {
      return force;
    } else {
      return _toggle.call(this, token);
    }
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Disable resizing in Firefox
  document.execCommand("enableObjectResizing", false, false);
  // Disable automatic linkifying in IE11
  document.execCommand("autoUrlDetect", false, false);
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos) {
  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  // Check cursor_pos within bounds
  if (cursor_pos < 0 || text1.length < cursor_pos) {
    cursor_pos = null;
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs);
  if (cursor_pos != null) {
    diffs = fix_cursor(diffs, cursor_pos);
  }
  diffs = fix_emoji(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i),
                                           shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                           shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */
function diff_cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs);
  }
};


var diff = diff_main;
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;

/*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */
function cursor_normalize_diff (diffs, cursor_pos) {
  if (cursor_pos === 0) {
    return [DIFF_EQUAL, diffs];
  }
  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
    var d = diffs[i];
    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
      var next_pos = current_pos + d[1].length;
      if (cursor_pos === next_pos) {
        return [i + 1, diffs];
      } else if (cursor_pos < next_pos) {
        // copy to prevent side effects
        diffs = diffs.slice();
        // split d into two diff changes
        var split_pos = cursor_pos - current_pos;
        var d_left = [d[0], d[1].slice(0, split_pos)];
        var d_right = [d[0], d[1].slice(split_pos)];
        diffs.splice(i, 1, d_left, d_right);
        return [i + 1, diffs];
      } else {
        current_pos = next_pos;
      }
    }
  }
  throw new Error('cursor_pos is out of bounds!')
}

/*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */
function fix_cursor (diffs, cursor_pos) {
  var norm = cursor_normalize_diff(diffs, cursor_pos);
  var ndiffs = norm[1];
  var cursor_pointer = norm[0];
  var d = ndiffs[cursor_pointer];
  var d_next = ndiffs[cursor_pointer + 1];

  if (d == null) {
    // Text was deleted from end of original string,
    // cursor is now out of bounds in new string
    return diffs;
  } else if (d[0] !== DIFF_EQUAL) {
    // A modification happened at the cursor location.
    // This is the expected outcome, so we can return the original diff.
    return diffs;
  } else {
    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
      // Case 1)
      // It is possible to perform a naive shift
      ndiffs.splice(cursor_pointer, 2, d_next, d)
      return merge_tuples(ndiffs, cursor_pointer, 2)
    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
      // Case 2)
      // d[1] is a prefix of d_next[1]
      // We can assume that d_next[0] !== 0, since d[0] === 0
      // Shift edit locations..
      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
      var suffix = d_next[1].slice(d[1].length);
      if (suffix.length > 0) {
        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
      }
      return merge_tuples(ndiffs, cursor_pointer, 3)
    } else {
      // Not possible to perform any modification
      return diffs;
    }
  }
}

/*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */
function fix_emoji (diffs) {
  var compact = false;
  var starts_with_pair_end = function(str) {
    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
  }
  var ends_with_pair_start = function(str) {
    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
  }
  for (var i = 2; i < diffs.length; i += 1) {
    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
      compact = true;

      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
    }
  }
  if (!compact) {
    return diffs;
  }
  var fixed_diffs = [];
  for (var i = 0; i < diffs.length; i += 1) {
    if (diffs[i][1].length > 0) {
      fixed_diffs.push(diffs[i]);
    }
  }
  return fixed_diffs;
}

/*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */
function merge_tuples (diffs, start, length) {
  // Check from (start-1) to (start+length).
  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
    if (i + 1 < diffs.length) {
      var left_d = diffs[i];
      var right_d = diffs[i+1];
      if (left_d[0] === right_d[1]) {
        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
      }
    }
  }
  return diffs;
}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __webpack_require__(3);

var _extend3 = _interopRequireDefault(_extend2);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _align = __webpack_require__(36);

var _background = __webpack_require__(37);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _color = __webpack_require__(26);

var _direction = __webpack_require__(38);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:clipboard');

var DOM_KEY = '__ql-matcher';

var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var Clipboard = function (_Module) {
  _inherits(Clipboard, _Module);

  function Clipboard(quill, options) {
    _classCallCheck(this, Clipboard);

    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
    _this.container = _this.quill.addContainer('ql-clipboard');
    _this.container.setAttribute('contenteditable', true);
    _this.container.setAttribute('tabindex', -1);
    _this.matchers = [];
    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          selector = _ref2[0],
          matcher = _ref2[1];

      if (!options.matchVisual && matcher === matchSpacing) return;
      _this.addMatcher(selector, matcher);
    });
    return _this;
  }

  _createClass(Clipboard, [{
    key: 'addMatcher',
    value: function addMatcher(selector, matcher) {
      this.matchers.push([selector, matcher]);
    }
  }, {
    key: 'convert',
    value: function convert(html) {
      if (typeof html === 'string') {
        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
        return this.convert();
      }
      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
      if (formats[_code2.default.blotName]) {
        var text = this.container.innerText;
        this.container.innerHTML = '';
        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
      }

      var _prepareMatching = this.prepareMatching(),
          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
          elementMatchers = _prepareMatching2[0],
          textMatchers = _prepareMatching2[1];

      var delta = traverse(this.container, elementMatchers, textMatchers);
      // Remove trailing newline
      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
      }
      debug.log('convert', this.container.innerHTML, delta);
      this.container.innerHTML = '';
      return delta;
    }
  }, {
    key: 'dangerouslyPasteHTML',
    value: function dangerouslyPasteHTML(index, html) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

      if (typeof index === 'string') {
        this.quill.setContents(this.convert(index), html);
        this.quill.setSelection(0, _quill2.default.sources.SILENT);
      } else {
        var paste = this.convert(html);
        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;
      var range = this.quill.getSelection();
      var delta = new _quillDelta2.default().retain(range.index);
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(_quill2.default.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
        // range.length contributes to delta.length()
        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'prepareMatching',
    value: function prepareMatching() {
      var _this3 = this;

      var elementMatchers = [],
          textMatchers = [];
      this.matchers.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            selector = _pair[0],
            matcher = _pair[1];

        switch (selector) {
          case Node.TEXT_NODE:
            textMatchers.push(matcher);
            break;
          case Node.ELEMENT_NODE:
            elementMatchers.push(matcher);
            break;
          default:
            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
              // TODO use weakmap
              node[DOM_KEY] = node[DOM_KEY] || [];
              node[DOM_KEY].push(matcher);
            });
            break;
        }
      });
      return [elementMatchers, textMatchers];
    }
  }]);

  return Clipboard;
}(_module2.default);

Clipboard.DEFAULTS = {
  matchers: [],
  matchVisual: true
};

function applyFormat(delta, format, value) {
  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
    return Object.keys(format).reduce(function (delta, key) {
      return applyFormat(delta, key, format[key]);
    }, delta);
  } else {
    return delta.reduce(function (delta, op) {
      if (op.attributes && op.attributes[format]) {
        return delta.push(op);
      } else {
        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
      }
    }, new _quillDelta2.default());
  }
}

function computeStyle(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return {};
  var DOM_KEY = '__ql-computed-style';
  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
}

function deltaEndsWith(delta, text) {
  var endText = "";
  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
    var op = delta.ops[i];
    if (typeof op.insert !== 'string') break;
    endText = op.insert + endText;
  }
  return endText.slice(-1 * text.length) === text;
}

function isLine(node) {
  if (node.childNodes.length === 0) return false; // Exclude embed blocks
  var style = computeStyle(node);
  return ['block', 'list-item'].indexOf(style.display) > -1;
}

function traverse(node, elementMatchers, textMatchers) {
  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new _quillDelta2.default());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new _quillDelta2.default());
  } else {
    return new _quillDelta2.default();
  }
}

function matchAlias(format, node, delta) {
  return applyFormat(delta, format, true);
}

function matchAttributor(node, delta) {
  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
  var classes = _parchment2.default.Attributor.Class.keys(node);
  var styles = _parchment2.default.Attributor.Style.keys(node);
  var formats = {};
  attributes.concat(classes).concat(styles).forEach(function (name) {
    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
    if (attr != null) {
      formats[attr.attrName] = attr.value(node);
      if (formats[attr.attrName]) return;
    }
    attr = ATTRIBUTE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      formats[attr.attrName] = attr.value(node) || undefined;
    }
    attr = STYLE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      attr = STYLE_ATTRIBUTORS[name];
      formats[attr.attrName] = attr.value(node) || undefined;
    }
  });
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  return delta;
}

function matchBlot(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null) return delta;
  if (match.prototype instanceof _parchment2.default.Embed) {
    var embed = {};
    var value = match.value(node);
    if (value != null) {
      embed[match.blotName] = value;
      delta = new _quillDelta2.default().insert(embed, match.formats(node));
    }
  } else if (typeof match.formats === 'function') {
    delta = applyFormat(delta, match.blotName, match.formats(node));
  }
  return delta;
}

function matchBreak(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    delta.insert('\n');
  }
  return delta;
}

function matchIgnore() {
  return new _quillDelta2.default();
}

function matchIndent(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
    return delta;
  }
  var indent = -1,
      parent = node.parentNode;
  while (!parent.classList.contains('ql-clipboard')) {
    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
      indent += 1;
    }
    parent = parent.parentNode;
  }
  if (indent <= 0) return delta;
  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
}

function matchNewline(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchSpacing(node, delta) {
  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchStyles(node, delta) {
  var formats = {};
  var style = node.style || {};
  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
    formats.italic = true;
  }
  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
    formats.bold = true;
  }
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  if (parseFloat(style.textIndent || 0) > 0) {
    // Could be 0.5in
    delta = new _quillDelta2.default().insert('\t').concat(delta);
  }
  return delta;
}

function matchText(node, delta) {
  var text = node.data;
  // Word represents empty line with <o:p>&nbsp;</o:p>
  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }
  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }
  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
    // eslint-disable-next-line func-style
    var replacer = function replacer(collapse, match) {
      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
      return match.length < 1 && collapse ? ' ' : match;
    };
    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
      text = text.replace(/^\s+/, replacer.bind(replacer, false));
    }
    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
      text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
  }
  return delta.insert(text);
}

exports.default = Clipboard;
exports.matchAttributor = matchAttributor;
exports.matchBlot = matchBlot;
exports.matchNewline = matchNewline;
exports.matchSpacing = matchSpacing;
exports.matchText = matchText;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bold = function (_Inline) {
  _inherits(Bold, _Inline);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: 'optimize',
    value: function optimize(context) {
      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: 'create',
    value: function create() {
      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return Bold;
}(_inline2.default);

Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];

exports.default = Bold;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:toolbar');

var Toolbar = function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var container = document.createElement('div');
      addControls(container, _this.options.container);
      quill.container.parentNode.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }
    if (!(_this.container instanceof HTMLElement)) {
      var _ret;

      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
    }
    _this.container.classList.add('ql-toolbar');
    _this.controls = [];
    _this.handlers = {};
    Object.keys(_this.options.handlers).forEach(function (format) {
      _this.addHandler(format, _this.options.handlers[format]);
    });
    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
      _this.attach(input);
    });
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
      if (type === _quill2.default.events.SELECTION_CHANGE) {
        _this.update(range);
      }
    });
    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'addHandler',
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: 'attach',
    value: function attach(input) {
      var _this2 = this;

      var format = [].find.call(input.classList, function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);
      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }
      if (this.handlers[format] == null) {
        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
          debug.warn('ignoring attaching to disabled format', format, input);
          return;
        }
        if (_parchment2.default.query(format) == null) {
          debug.warn('ignoring attaching to nonexistent format', format, input);
          return;
        }
      }
      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value = void 0;
        if (input.tagName === 'SELECT') {
          if (input.selectedIndex < 0) return;
          var selected = input.options[input.selectedIndex];
          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            value = input.value || !input.hasAttribute('value');
          }
          e.preventDefault();
        }
        _this2.quill.focus();

        var _quill$selection$getR = _this2.quill.selection.getRange(),
            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
            range = _quill$selection$getR2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
          value = prompt('Enter ' + format);
          if (!value) return;
          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
        } else {
          _this2.quill.format(format, value, _quill2.default.sources.USER);
        }
        _this2.update(range);
      });
      // TODO use weakmap
      this.controls.push([format, input]);
    }
  }, {
    key: 'update',
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = void 0;
          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];
            if (typeof value === 'string') {
              value = value.replace(/\"/g, '\\"');
            }
            option = input.querySelector('option[value="' + value + '"]');
          }
          if (option == null) {
            input.value = ''; // TODO make configurable?
            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else {
          if (range == null) {
            input.classList.remove('ql-active');
          } else if (input.hasAttribute('value')) {
            // both being null should match (default values)
            // '1' should match with 1 (headers)
            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
            input.classList.toggle('ql-active', isActive);
          } else {
            input.classList.toggle('ql-active', formats[format] != null);
          }
        }
      });
    }
  }]);

  return Toolbar;
}(_module2.default);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add('ql-' + format);
  if (value != null) {
    input.value = value;
  }
  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    groups = [groups];
  }
  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];
        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add('ql-' + format);
  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value !== false) {
      option.setAttribute('value', value);
    } else {
      option.setAttribute('selected', 'selected');
    }
    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;
      if (range.length == 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
            _this3.quill.format(name, false);
          }
        });
      } else {
        this.quill.removeFormat(range, _quill2.default.sources.USER);
      }
    },
    direction: function direction(value) {
      var align = this.quill.getFormat()['align'];
      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', _quill2.default.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, _quill2.default.sources.USER);
      }
      this.quill.format('direction', value, _quill2.default.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      var indent = parseInt(formats.indent || 0);
      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:');
      }
      this.quill.format('link', value, _quill2.default.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      if (value === 'check') {
        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
          this.quill.format('list', false, _quill2.default.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
        }
      } else {
        this.quill.format('list', value, _quill2.default.sources.USER);
      }
    }
  }
};

exports.default = Toolbar;
exports.addControls = addControls;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Picker) {
  _inherits(ColorPicker, _Picker);

  function ColorPicker(select, label) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

    _this.label.innerHTML = label;
    _this.container.classList.add('ql-color-picker');
    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
      item.classList.add('ql-primary');
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'buildItem',
    value: function buildItem(option) {
      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
      item.style.backgroundColor = option.getAttribute('value') || '';
      return item;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
      var colorLabel = this.label.querySelector('.ql-color-label');
      var value = item ? item.getAttribute('data-value') || '' : '';
      if (colorLabel) {
        if (colorLabel.tagName === 'line') {
          colorLabel.style.stroke = value;
        } else {
          colorLabel.style.fill = value;
        }
      }
    }
  }]);

  return ColorPicker;
}(_picker2.default);

exports.default = ColorPicker;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPicker = function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

    _this.container.classList.add('ql-icon-picker');
    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');
    _this.selectItem(_this.defaultItem);
    return _this;
  }

  _createClass(IconPicker, [{
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(_picker2.default);

exports.default = IconPicker;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tooltip = function () {
  function Tooltip(quill, boundsContainer) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.quill = quill;
    this.boundsContainer = boundsContainer || document.body;
    this.root = quill.addContainer('ql-tooltip');
    this.root.innerHTML = this.constructor.TEMPLATE;
    if (this.quill.root === this.quill.scrollingContainer) {
      this.quill.root.addEventListener('scroll', function () {
        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
      });
    }
    this.hide();
  }

  _createClass(Tooltip, [{
    key: 'hide',
    value: function hide() {
      this.root.classList.add('ql-hidden');
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
      // root.scrollTop should be 0 if scrollContainer !== root
      var top = reference.bottom + this.quill.root.scrollTop;
      this.root.style.left = left + 'px';
      this.root.style.top = top + 'px';
      this.root.classList.remove('ql-flip');
      var containerBounds = this.boundsContainer.getBoundingClientRect();
      var rootBounds = this.root.getBoundingClientRect();
      var shift = 0;
      if (rootBounds.right > containerBounds.right) {
        shift = containerBounds.right - rootBounds.right;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.left < containerBounds.left) {
        shift = containerBounds.left - rootBounds.left;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.bottom > containerBounds.bottom) {
        var height = rootBounds.bottom - rootBounds.top;
        var verticalShift = reference.bottom - reference.top + height;
        this.root.style.top = top - verticalShift + 'px';
        this.root.classList.add('ql-flip');
      }
      return shift;
    }
  }, {
    key: 'show',
    value: function show() {
      this.root.classList.remove('ql-editing');
      this.root.classList.remove('ql-hidden');
    }
  }]);

  return Tooltip;
}();

exports.default = Tooltip;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

var SnowTheme = function (_BaseTheme) {
  _inherits(SnowTheme, _BaseTheme);

  function SnowTheme(quill, options) {
    _classCallCheck(this, SnowTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-snow');
    return _this;
  }

  _createClass(SnowTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      toolbar.container.classList.add('ql-snow');
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
      if (toolbar.container.querySelector('.ql-link')) {
        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
          toolbar.handlers['link'].call(toolbar, !context.format.link);
        });
      }
    }
  }]);

  return SnowTheme;
}(_base2.default);

SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (value) {
            var range = this.quill.getSelection();
            if (range == null || range.length == 0) return;
            var preview = this.quill.getText(range);
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview;
            }
            var tooltip = this.quill.theme.tooltip;
            tooltip.edit('link', preview);
          } else {
            this.quill.format('link', false);
          }
        }
      }
    }
  }
});

var SnowTooltip = function (_BaseTooltip) {
  _inherits(SnowTooltip, _BaseTooltip);

  function SnowTooltip(quill, bounds) {
    _classCallCheck(this, SnowTooltip);

    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

    _this2.preview = _this2.root.querySelector('a.ql-preview');
    return _this2;
  }

  _createClass(SnowTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
        if (_this3.root.classList.contains('ql-editing')) {
          _this3.save();
        } else {
          _this3.edit('link', _this3.preview.textContent);
        }
        event.preventDefault();
      });
      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
        if (_this3.linkRange != null) {
          var range = _this3.linkRange;
          _this3.restoreFocus();
          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
          delete _this3.linkRange;
        }
        event.preventDefault();
        _this3.hide();
      });
      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
        if (range == null) return;
        if (range.length === 0 && source === _emitter2.default.sources.USER) {
          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
              link = _quill$scroll$descend2[0],
              offset = _quill$scroll$descend2[1];

          if (link != null) {
            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
            var preview = _link2.default.formats(link.domNode);
            _this3.preview.textContent = preview;
            _this3.preview.setAttribute('href', preview);
            _this3.show();
            _this3.position(_this3.quill.getBounds(_this3.linkRange));
            return;
          }
        } else {
          delete _this3.linkRange;
        }
        _this3.hide();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
      this.root.removeAttribute('data-mode');
    }
  }]);

  return SnowTooltip;
}(_base.BaseTooltip);

SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

exports.default = SnowTheme;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = __webpack_require__(29);

var _core2 = _interopRequireDefault(_core);

var _align = __webpack_require__(36);

var _direction = __webpack_require__(38);

var _indent = __webpack_require__(64);

var _blockquote = __webpack_require__(65);

var _blockquote2 = _interopRequireDefault(_blockquote);

var _header = __webpack_require__(66);

var _header2 = _interopRequireDefault(_header);

var _list = __webpack_require__(67);

var _list2 = _interopRequireDefault(_list);

var _background = __webpack_require__(37);

var _color = __webpack_require__(26);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __webpack_require__(68);

var _italic2 = _interopRequireDefault(_italic);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _script = __webpack_require__(69);

var _script2 = _interopRequireDefault(_script);

var _strike = __webpack_require__(70);

var _strike2 = _interopRequireDefault(_strike);

var _underline = __webpack_require__(71);

var _underline2 = _interopRequireDefault(_underline);

var _image = __webpack_require__(72);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(73);

var _video2 = _interopRequireDefault(_video);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _formula = __webpack_require__(74);

var _formula2 = _interopRequireDefault(_formula);

var _syntax = __webpack_require__(75);

var _syntax2 = _interopRequireDefault(_syntax);

var _toolbar = __webpack_require__(57);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _bubble = __webpack_require__(108);

var _bubble2 = _interopRequireDefault(_bubble);

var _snow = __webpack_require__(62);

var _snow2 = _interopRequireDefault(_snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core2.default.register({
  'attributors/attribute/direction': _direction.DirectionAttribute,

  'attributors/class/align': _align.AlignClass,
  'attributors/class/background': _background.BackgroundClass,
  'attributors/class/color': _color.ColorClass,
  'attributors/class/direction': _direction.DirectionClass,
  'attributors/class/font': _font.FontClass,
  'attributors/class/size': _size.SizeClass,

  'attributors/style/align': _align.AlignStyle,
  'attributors/style/background': _background.BackgroundStyle,
  'attributors/style/color': _color.ColorStyle,
  'attributors/style/direction': _direction.DirectionStyle,
  'attributors/style/font': _font.FontStyle,
  'attributors/style/size': _size.SizeStyle
}, true);

_core2.default.register({
  'formats/align': _align.AlignClass,
  'formats/direction': _direction.DirectionClass,
  'formats/indent': _indent.IndentClass,

  'formats/background': _background.BackgroundStyle,
  'formats/color': _color.ColorStyle,
  'formats/font': _font.FontClass,
  'formats/size': _size.SizeClass,

  'formats/blockquote': _blockquote2.default,
  'formats/code-block': _code2.default,
  'formats/header': _header2.default,
  'formats/list': _list2.default,

  'formats/bold': _bold2.default,
  'formats/code': _code.Code,
  'formats/italic': _italic2.default,
  'formats/link': _link2.default,
  'formats/script': _script2.default,
  'formats/strike': _strike2.default,
  'formats/underline': _underline2.default,

  'formats/image': _image2.default,
  'formats/video': _video2.default,

  'formats/list/item': _list.ListItem,

  'modules/formula': _formula2.default,
  'modules/syntax': _syntax2.default,
  'modules/toolbar': _toolbar2.default,

  'themes/bubble': _bubble2.default,
  'themes/snow': _snow2.default,

  'ui/icons': _icons2.default,
  'ui/picker': _picker2.default,
  'ui/icon-picker': _iconPicker2.default,
  'ui/color-picker': _colorPicker2.default,
  'ui/tooltip': _tooltip2.default
}, true);

exports.default = _core2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndentClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentAttributor = function (_Parchment$Attributor) {
  _inherits(IdentAttributor, _Parchment$Attributor);

  function IdentAttributor() {
    _classCallCheck(this, IdentAttributor);

    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
  }

  _createClass(IdentAttributor, [{
    key: 'add',
    value: function add(node, value) {
      if (value === '+1' || value === '-1') {
        var indent = this.value(node) || 0;
        value = value === '+1' ? indent + 1 : indent - 1;
      }
      if (value === 0) {
        this.remove(node);
        return true;
      } else {
        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
      }
    }
  }, {
    key: 'canAdd',
    value: function canAdd(node, value) {
      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
    }
  }, {
    key: 'value',
    value: function value(node) {
      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
    }
  }]);

  return IdentAttributor;
}(_parchment2.default.Attributor.Class);

var IndentClass = new IdentAttributor('indent', 'ql-indent', {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});

exports.IndentClass = IndentClass;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Blockquote = function (_Block) {
  _inherits(Blockquote, _Block);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
  }

  return Blockquote;
}(_block2.default);

Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';

exports.default = Blockquote;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Block) {
  _inherits(Header, _Block);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, null, [{
    key: 'formats',
    value: function formats(domNode) {
      return this.tagName.indexOf(domNode.tagName) + 1;
    }
  }]);

  return Header;
}(_block2.default);

Header.blotName = 'header';
Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

exports.default = Header;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Block) {
  _inherits(ListItem, _Block);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'format',
    value: function format(name, value) {
      if (name === List.blotName && !value) {
        this.replaceWith(_parchment2.default.create(this.statics.scope));
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (this.prev == null && this.next == null) {
        this.parent.remove();
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
      }
    }
  }, {
    key: 'replaceWith',
    value: function replaceWith(name, value) {
      this.parent.isolate(this.offset(this.parent), this.length());
      if (name === this.parent.statics.blotName) {
        this.parent.replaceWith(name, value);
        return this;
      } else {
        this.parent.unwrap();
        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
      }
    }
  }], [{
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
    }
  }]);

  return ListItem;
}(_block2.default);

ListItem.blotName = 'list-item';
ListItem.tagName = 'LI';

var List = function (_Container) {
  _inherits(List, _Container);

  _createClass(List, null, [{
    key: 'create',
    value: function create(value) {
      var tagName = value === 'ordered' ? 'OL' : 'UL';
      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
      if (value === 'checked' || value === 'unchecked') {
        node.setAttribute('data-checked', value === 'checked');
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'OL') return 'ordered';
      if (domNode.tagName === 'UL') {
        if (domNode.hasAttribute('data-checked')) {
          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
        } else {
          return 'bullet';
        }
      }
      return undefined;
    }
  }]);

  function List(domNode) {
    _classCallCheck(this, List);

    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

    var listEventHandler = function listEventHandler(e) {
      if (e.target.parentNode !== domNode) return;
      var format = _this2.statics.formats(domNode);
      var blot = _parchment2.default.find(e.target);
      if (format === 'checked') {
        blot.format('list', 'unchecked');
      } else if (format === 'unchecked') {
        blot.format('list', 'checked');
      }
    };

    domNode.addEventListener('touchstart', listEventHandler);
    domNode.addEventListener('mousedown', listEventHandler);
    return _this2;
  }

  _createClass(List, [{
    key: 'format',
    value: function format(name, value) {
      if (this.children.length > 0) {
        this.children.tail.format(name, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      // We don't inherit from FormatBlot
      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot instanceof ListItem) {
        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
      } else {
        var index = ref == null ? this.length() : ref.offset(this);
        var after = this.split(index);
        after.parent.insertBefore(blot, after);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = _parchment2.default.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
    }
  }]);

  return List;
}(_container2.default);

List.blotName = 'list';
List.scope = _parchment2.default.Scope.BLOCK_BLOT;
List.tagName = ['OL', 'UL'];
List.defaultChild = 'list-item';
List.allowedChildren = [ListItem];

exports.ListItem = ListItem;
exports.default = List;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Italic = function (_Bold) {
  _inherits(Italic, _Bold);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
  }

  return Italic;
}(_bold2.default);

Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

exports.default = Italic;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_Inline) {
  _inherits(Script, _Inline);

  function Script() {
    _classCallCheck(this, Script);

    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
  }

  _createClass(Script, null, [{
    key: 'create',
    value: function create(value) {
      if (value === 'super') {
        return document.createElement('sup');
      } else if (value === 'sub') {
        return document.createElement('sub');
      } else {
        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'SUB') return 'sub';
      if (domNode.tagName === 'SUP') return 'super';
      return undefined;
    }
  }]);

  return Script;
}(_inline2.default);

Script.blotName = 'script';
Script.tagName = ['SUB', 'SUP'];

exports.default = Script;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Strike = function (_Inline) {
  _inherits(Strike, _Inline);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
  }

  return Strike;
}(_inline2.default);

Strike.blotName = 'strike';
Strike.tagName = 'S';

exports.default = Strike;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Underline = function (_Inline) {
  _inherits(Underline, _Inline);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
  }

  return Underline;
}(_inline2.default);

Underline.blotName = 'underline';
Underline.tagName = 'U';

exports.default = Underline;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _link = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['alt', 'height', 'width'];

var Image = function (_Parchment$Embed) {
  _inherits(Image, _Parchment$Embed);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
      if (typeof value === 'string') {
        node.setAttribute('src', this.sanitize(value));
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'match',
    value: function match(url) {
      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
      );
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Image;
}(_parchment2.default.Embed);

Image.blotName = 'image';
Image.tagName = 'IMG';

exports.default = Image;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _block = __webpack_require__(4);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['height', 'width'];

var Video = function (_BlockEmbed) {
  _inherits(Video, _BlockEmbed);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
      node.setAttribute('frameborder', '0');
      node.setAttribute('allowfullscreen', true);
      node.setAttribute('src', this.sanitize(value));
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _link2.default.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Video;
}(_block.BlockEmbed);

Video.blotName = 'video';
Video.className = 'ql-video';
Video.tagName = 'IFRAME';

exports.default = Video;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormulaBlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaBlot = function (_Embed) {
  _inherits(FormulaBlot, _Embed);

  function FormulaBlot() {
    _classCallCheck(this, FormulaBlot);

    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
  }

  _createClass(FormulaBlot, null, [{
    key: 'create',
    value: function create(value) {
      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
      if (typeof value === 'string') {
        window.katex.render(value, node, {
          throwOnError: false,
          errorColor: '#f00'
        });
        node.setAttribute('data-value', value);
      }
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('data-value');
    }
  }]);

  return FormulaBlot;
}(_embed2.default);

FormulaBlot.blotName = 'formula';
FormulaBlot.className = 'ql-formula';
FormulaBlot.tagName = 'SPAN';

var Formula = function (_Module) {
  _inherits(Formula, _Module);

  _createClass(Formula, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(FormulaBlot, true);
    }
  }]);

  function Formula() {
    _classCallCheck(this, Formula);

    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    return _this2;
  }

  return Formula;
}(_module2.default);

exports.FormulaBlot = FormulaBlot;
exports.default = Formula;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeToken = exports.CodeBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntaxCodeBlock = function (_CodeBlock) {
  _inherits(SyntaxCodeBlock, _CodeBlock);

  function SyntaxCodeBlock() {
    _classCallCheck(this, SyntaxCodeBlock);

    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
  }

  _createClass(SyntaxCodeBlock, [{
    key: 'replaceWith',
    value: function replaceWith(block) {
      this.domNode.textContent = this.domNode.textContent;
      this.attach();
      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
    }
  }, {
    key: 'highlight',
    value: function highlight(_highlight) {
      var text = this.domNode.textContent;
      if (this.cachedText !== text) {
        if (text.trim().length > 0 || this.cachedText == null) {
          this.domNode.innerHTML = _highlight(text);
          this.domNode.normalize();
          this.attach();
        }
        this.cachedText = text;
      }
    }
  }]);

  return SyntaxCodeBlock;
}(_code2.default);

SyntaxCodeBlock.className = 'ql-syntax';

var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
  scope: _parchment2.default.Scope.INLINE
});

var Syntax = function (_Module) {
  _inherits(Syntax, _Module);

  _createClass(Syntax, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(CodeToken, true);
      _quill2.default.register(SyntaxCodeBlock, true);
    }
  }]);

  function Syntax(quill, options) {
    _classCallCheck(this, Syntax);

    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

    if (typeof _this2.options.highlight !== 'function') {
      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
    }
    var timer = null;
    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        _this2.highlight();
        timer = null;
      }, _this2.options.interval);
    });
    _this2.highlight();
    return _this2;
  }

  _createClass(Syntax, [{
    key: 'highlight',
    value: function highlight() {
      var _this3 = this;

      if (this.quill.selection.composing) return;
      this.quill.update(_quill2.default.sources.USER);
      var range = this.quill.getSelection();
      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
        code.highlight(_this3.options.highlight);
      });
      this.quill.update(_quill2.default.sources.SILENT);
      if (range != null) {
        this.quill.setSelection(range, _quill2.default.sources.SILENT);
      }
    }
  }]);

  return Syntax;
}(_module2.default);

Syntax.DEFAULTS = {
  highlight: function () {
    if (window.hljs == null) return null;
    return function (text) {
      var result = window.hljs.highlightAuto(text);
      return result.value;
    };
  }(),
  interval: 1000
};

exports.CodeBlock = SyntaxCodeBlock;
exports.CodeToken = CodeToken;
exports.default = Syntax;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BubbleTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

var BubbleTheme = function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);

  function BubbleTheme(quill, options) {
    _classCallCheck(this, BubbleTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-bubble');
    return _this;
  }

  _createClass(BubbleTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      this.tooltip.root.appendChild(toolbar.container);
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
    }
  }]);

  return BubbleTheme;
}(_base2.default);

BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false);
          } else {
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});

var BubbleTooltip = function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);

  function BubbleTooltip(quill, bounds) {
    _classCallCheck(this, BubbleTooltip);

    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
        _this2.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this2.root.style.left = '0px';
        _this2.root.style.width = '';
        _this2.root.style.width = _this2.root.offsetWidth + 'px';
        var lines = _this2.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          _this2.position(_this2.quill.getBounds(range));
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this2.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
          _this2.position(_bounds);
        }
      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
        _this2.hide();
      }
    });
    return _this2;
  }

  _createClass(BubbleTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this3.root.classList.remove('ql-editing');
      });
      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this3.root.classList.contains('ql-hidden')) return;
          var range = _this3.quill.getSelection();
          if (range != null) {
            _this3.position(_this3.quill.getBounds(range));
          }
        }, 1);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.show();
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      arrow.style.marginLeft = '';
      if (shift === 0) return shift;
      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
    }
  }]);

  return BubbleTooltip;
}(_base.BaseTooltip);

BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

exports.BubbleTooltip = BubbleTooltip;
exports.default = BubbleTheme;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ })
/******/ ])["default"];
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(524).Buffer))

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(529);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Quill = __webpack_require__(228);

var QuillMixin = {

	/**
	Creates an editor on the given element. The editor will
	be passed the configuration, have its events bound,
	*/
	createEditor: function($el, config) {
		var editor = new Quill($el, config);
		if (config.tabIndex !== undefined) {
			this.setEditorTabIndex(editor, config.tabIndex);
		}
		this.hookEditor(editor);
		return editor;
	},

	hookEditor: function(editor) {
		// Expose the editor on change events via a weaker,
		// unprivileged proxy object that does not allow
		// accidentally modifying editor state.
		var unprivilegedEditor = this.makeUnprivilegedEditor(editor);

		this.handleTextChange = function(delta, oldDelta, source) {
			if (this.onEditorChangeText) {
				this.onEditorChangeText(
					editor.root.innerHTML, delta, source,
					unprivilegedEditor
				);
				this.onEditorChangeSelection(
					editor.getSelection(), source,
					unprivilegedEditor
				);
			}
		}.bind(this);

		this.handleSelectionChange = function(range, oldRange, source) {
			if (this.onEditorChangeSelection) {
				this.onEditorChangeSelection(
					range, source,
					unprivilegedEditor
				);
			}
		}.bind(this);

		editor.on('editor-change', function(eventType, rangeOrDelta, oldRangeOrOldDelta, source) {
			if (eventType === Quill.events.SELECTION_CHANGE) {
				this.handleSelectionChange(rangeOrDelta, oldRangeOrOldDelta, source);
			}
			
			if (eventType === Quill.events.TEXT_CHANGE) {
				this.handleTextChange(rangeOrDelta, oldRangeOrOldDelta, source);
			}
		}.bind(this));
	},

	unhookEditor: function(editor) {
		editor.off('selection-change');
		editor.off('text-change');
	},

	setEditorReadOnly: function(editor, value) {
		value? editor.disable()
		     : editor.enable();
	},

	/*
	Replace the contents of the editor, but keep
	the previous selection hanging around so that
	the cursor won't move.
	*/
	setEditorContents: function(editor, value) {
		var sel = editor.getSelection();

		if (typeof value === 'string') {
			editor.setContents(editor.clipboard.convert(value));
		} else {
			editor.setContents(value);
		}

		if (sel && editor.hasFocus()) this.setEditorSelection(editor, sel);
	},

	setEditorSelection: function(editor, range) {
		if (range) {
			// Validate bounds before applying.
			var length = editor.getLength();
			range.index = Math.max(0, Math.min(range.index, length-1));
			range.length = Math.max(0, Math.min(range.length, (length-1) - range.index));
		}
		editor.setSelection(range);
	},

	setEditorTabIndex: function(editor, tabIndex) {
		if (editor.editor && editor.editor.scroll && editor.editor.scroll.domNode) {
			editor.editor.scroll.domNode.tabIndex = tabIndex;
		}
	},

	/*
	Returns an weaker, unprivileged proxy object that only
	exposes read-only accessors found on the editor instance,
	without any state-modificating methods.
	*/
	makeUnprivilegedEditor: function(editor) {
		var e = editor;
		return {
			getLength:    function(){ return e.getLength.apply(e, arguments); },
			getText:      function(){ return e.getText.apply(e, arguments); },
			getHTML:      function(){ return e.root.innerHTML },
			getContents:  function(){ return e.getContents.apply(e, arguments); },
			getSelection: function(){ return e.getSelection.apply(e, arguments); },
			getBounds:    function(){ return e.getBounds.apply(e, arguments); },
		};
	}

};

module.exports = QuillMixin;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(532),
    findIndex = __webpack_require__(611);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(87),
    stackClear = __webpack_require__(540),
    stackDelete = __webpack_require__(541),
    stackGet = __webpack_require__(542),
    stackHas = __webpack_require__(543),
    stackSet = __webpack_require__(544);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(66),
    isObject = __webpack_require__(67);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 235 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(564),
    arraySome = __webpack_require__(237),
    cacheHas = __webpack_require__(567);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(581),
    isObjectLike = __webpack_require__(68);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(29),
    stubFalse = __webpack_require__(582);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)(module)))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(583),
    baseUnary = __webpack_require__(584),
    nodeUtil = __webpack_require__(585);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(244),
    toKey = __webpack_require__(95);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(30),
    isKey = __webpack_require__(142),
    stringToPath = __webpack_require__(598),
    toString = __webpack_require__(601);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(139);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function(f) {
  if (true) {
    module.exports = f(__webpack_require__(0));
    /* global define */
  } else if (typeof define === 'function' && define.amd) {
    define(['react'], f);
  } else {
    var g;
    if (typeof window !== 'undefined') {
      g = window;
    } else if (typeof global !== 'undefined') {
      g = global;
    } else if (typeof self !== 'undefined') {
      g = self;
    } else {
      g = this;
    }

    if (typeof g.React === 'undefined') {
      throw Error('React module should be required before ReactDOMFactories');
    }

    g.ReactDOMFactories = f(g.React);
  }
})(function(React) {
  /**
   * Create a factory that creates HTML tag elements.
   */
  function createDOMFactory(type) {
    var factory = React.createElement.bind(null, type);
    // Expose the type on the factory and the prototype so that it can be
    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
    // This should not be named `constructor` since this may not be the function
    // that created the element, and it may not even be a constructor.
    factory.type = type;
    return factory;
  };

  /**
   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
   */
  var ReactDOMFactories = {
    a: createDOMFactory('a'),
    abbr: createDOMFactory('abbr'),
    address: createDOMFactory('address'),
    area: createDOMFactory('area'),
    article: createDOMFactory('article'),
    aside: createDOMFactory('aside'),
    audio: createDOMFactory('audio'),
    b: createDOMFactory('b'),
    base: createDOMFactory('base'),
    bdi: createDOMFactory('bdi'),
    bdo: createDOMFactory('bdo'),
    big: createDOMFactory('big'),
    blockquote: createDOMFactory('blockquote'),
    body: createDOMFactory('body'),
    br: createDOMFactory('br'),
    button: createDOMFactory('button'),
    canvas: createDOMFactory('canvas'),
    caption: createDOMFactory('caption'),
    cite: createDOMFactory('cite'),
    code: createDOMFactory('code'),
    col: createDOMFactory('col'),
    colgroup: createDOMFactory('colgroup'),
    data: createDOMFactory('data'),
    datalist: createDOMFactory('datalist'),
    dd: createDOMFactory('dd'),
    del: createDOMFactory('del'),
    details: createDOMFactory('details'),
    dfn: createDOMFactory('dfn'),
    dialog: createDOMFactory('dialog'),
    div: createDOMFactory('div'),
    dl: createDOMFactory('dl'),
    dt: createDOMFactory('dt'),
    em: createDOMFactory('em'),
    embed: createDOMFactory('embed'),
    fieldset: createDOMFactory('fieldset'),
    figcaption: createDOMFactory('figcaption'),
    figure: createDOMFactory('figure'),
    footer: createDOMFactory('footer'),
    form: createDOMFactory('form'),
    h1: createDOMFactory('h1'),
    h2: createDOMFactory('h2'),
    h3: createDOMFactory('h3'),
    h4: createDOMFactory('h4'),
    h5: createDOMFactory('h5'),
    h6: createDOMFactory('h6'),
    head: createDOMFactory('head'),
    header: createDOMFactory('header'),
    hgroup: createDOMFactory('hgroup'),
    hr: createDOMFactory('hr'),
    html: createDOMFactory('html'),
    i: createDOMFactory('i'),
    iframe: createDOMFactory('iframe'),
    img: createDOMFactory('img'),
    input: createDOMFactory('input'),
    ins: createDOMFactory('ins'),
    kbd: createDOMFactory('kbd'),
    keygen: createDOMFactory('keygen'),
    label: createDOMFactory('label'),
    legend: createDOMFactory('legend'),
    li: createDOMFactory('li'),
    link: createDOMFactory('link'),
    main: createDOMFactory('main'),
    map: createDOMFactory('map'),
    mark: createDOMFactory('mark'),
    menu: createDOMFactory('menu'),
    menuitem: createDOMFactory('menuitem'),
    meta: createDOMFactory('meta'),
    meter: createDOMFactory('meter'),
    nav: createDOMFactory('nav'),
    noscript: createDOMFactory('noscript'),
    object: createDOMFactory('object'),
    ol: createDOMFactory('ol'),
    optgroup: createDOMFactory('optgroup'),
    option: createDOMFactory('option'),
    output: createDOMFactory('output'),
    p: createDOMFactory('p'),
    param: createDOMFactory('param'),
    picture: createDOMFactory('picture'),
    pre: createDOMFactory('pre'),
    progress: createDOMFactory('progress'),
    q: createDOMFactory('q'),
    rp: createDOMFactory('rp'),
    rt: createDOMFactory('rt'),
    ruby: createDOMFactory('ruby'),
    s: createDOMFactory('s'),
    samp: createDOMFactory('samp'),
    script: createDOMFactory('script'),
    section: createDOMFactory('section'),
    select: createDOMFactory('select'),
    small: createDOMFactory('small'),
    source: createDOMFactory('source'),
    span: createDOMFactory('span'),
    strong: createDOMFactory('strong'),
    style: createDOMFactory('style'),
    sub: createDOMFactory('sub'),
    summary: createDOMFactory('summary'),
    sup: createDOMFactory('sup'),
    table: createDOMFactory('table'),
    tbody: createDOMFactory('tbody'),
    td: createDOMFactory('td'),
    textarea: createDOMFactory('textarea'),
    tfoot: createDOMFactory('tfoot'),
    th: createDOMFactory('th'),
    thead: createDOMFactory('thead'),
    time: createDOMFactory('time'),
    title: createDOMFactory('title'),
    tr: createDOMFactory('tr'),
    track: createDOMFactory('track'),
    u: createDOMFactory('u'),
    ul: createDOMFactory('ul'),
    var: createDOMFactory('var'),
    video: createDOMFactory('video'),
    wbr: createDOMFactory('wbr'),

    // SVG
    circle: createDOMFactory('circle'),
    clipPath: createDOMFactory('clipPath'),
    defs: createDOMFactory('defs'),
    ellipse: createDOMFactory('ellipse'),
    g: createDOMFactory('g'),
    image: createDOMFactory('image'),
    line: createDOMFactory('line'),
    linearGradient: createDOMFactory('linearGradient'),
    mask: createDOMFactory('mask'),
    path: createDOMFactory('path'),
    pattern: createDOMFactory('pattern'),
    polygon: createDOMFactory('polygon'),
    polyline: createDOMFactory('polyline'),
    radialGradient: createDOMFactory('radialGradient'),
    rect: createDOMFactory('rect'),
    stop: createDOMFactory('stop'),
    svg: createDOMFactory('svg'),
    text: createDOMFactory('text'),
    tspan: createDOMFactory('tspan'),
  };

  // due to wrapper and conditionals at the top, this will either become
  // `module.exports ReactDOMFactories` if that is available,
  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
  // if that is available,
  // otherwise it will be defined as global variable.
  return ReactDOMFactories;
});



/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(625);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentFormPhase=function(_Component){_inherits(ContentFormPhase,_Component);_createClass(ContentFormPhase,[{key:'render',value:function render(){var _this2=this;var _props=this.props,phases=_props.phases,modalities=_props.modalities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'phases.edit',onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},this.state.documentEditForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DocumentEditForm,Object.assign({document_index:this.state.document_index,active:this.state.documentEditForm,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del Sub-proceso ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.name',id:'name',className:'input',placeholder:'Nombre de la Meta',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-primary',onClick:function onClick(){return _this2._addDocument();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Agregar Documento')))),phases.edit&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.edit.documents_items)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Lista de Documentos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth is-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Categor\xEDa'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(phases.edit.documents_items,function(row,k){var type=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(phases.edit.documentables_types,{slug:row.documentable_type});var modality=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(modalities.list,{id:row.modality_id});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,type?type.name:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modality?modality.name:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this2._editDocument(row,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._getConfirm(k,row.name);},className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))))));}))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/fases');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'phases.edit',className:'button is-primary is-large',type:'submit',disabled:this._validateSave()},'Guardar'))))));}}]);function ContentFormPhase(){_classCallCheck(this,ContentFormPhase);var _this=_possibleConstructorReturn(this,(ContentFormPhase.__proto__||Object.getPrototypeOf(ContentFormPhase)).call(this));_this.state={document_index:undefined,documentEditForm:false};return _this;}_createClass(ContentFormPhase,[{key:'_handleSubmit',value:function _handleSubmit(values){this.props.phaseSave(values);//console.log('values==>', values);
}},{key:'_addDocument',value:function _addDocument(){this.setState({documentEditForm:true});}},{key:'_editDocument',value:function _editDocument(data,index){this.props.change('phases.edit.document',Object.assign({},data));this.setState({document_index:index,documentEditForm:true});}},{key:'_getConfirm',value:function _getConfirm(index,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el documento "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.remove('phases.edit.documents_items',index);}});}},{key:'_toggleModal',value:function _toggleModal(){this.setState({document_index:undefined,documentEditForm:false});this.props.change('phases.edit.document',{});}},{key:'_validateSave',value:function _validateSave(){var phases=this.props.phases;var pc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(phases.permissions,function(o){return o==='Create';});var pu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(phases.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.edit)&&phases.edit.id){if(pu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.edit.id)){if(pc){return false;}else{return true;}}else{return true;}}}]);return ContentFormPhase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default ContentFormPhase;
/* harmony default export */ __webpack_exports__["a"] = (ContentFormPhase);var DocumentEditForm=function(_Component2){_inherits(DocumentEditForm,_Component2);_createClass(DocumentEditForm,[{key:'render',value:function render(){var _this5=this;var _props2=this.props,phases=_props2.phases,modalities=_props2.modalities,documents_types=_props2.documents_types;console.log('phases.edit ====>',phases);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Editar Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'.document',className:'modal-card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del documento ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.name',id:'name',className:'input',placeholder:'Nombre del documento'}),phases.edit.document&&phases.edit.document.name?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'El nombre es obligatorio')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'documentable_type',className:'label'},'Tipo de documento ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.documentable_type',id:'documentable_type'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},' -- Tipo de documento --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(phases.edit.documentables_types,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.slug},opt.name);}))),phases.edit.document&&phases.edit.document.documentable_type?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'El tipo de documento es obligatorio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'description',className:'label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.description',id:'description',className:'textarea',value:phases.edit.document&&phases.edit.document.description?phases.edit.document.description:'',placeholder:'Descripci\xF3n'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__["a" /* default */],{name:'Formato',model:'.file_format',file:phases.edit.document&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.edit.document.file_format)?phases.edit.document.file_format:undefined}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'all_mods',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'all_mods',type:'checkbox',className:'checkbox',checked:this.state.all_mods,onChange:function onChange(){return _this5._changeAllMods();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Todas las modalidades'))))))),!this.state.all_mods?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'modality_id',className:'label'},'Modalidad '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(modalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.modality_id',id:'modality_id',parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["c" /* toInt */],disabled:modalities.isFetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Modalidad ---'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(modalities.list,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:option.id,key:k},option.name);})))):''),!this.state.all_mods&&phases.edit.document&&phases.edit.document.modality_id===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'agency_type',className:'label'},'Tipo de Instancia '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.agency_type',id:'agency_type'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Tipo de Instancia ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'centralized'},'Centralizada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'decentralized'},'Descentralizada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'delegacy'},'Delegaci\xF3n'))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Extensiones admitidas ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(documents_types.list,function(item,k){var checked=phases.edit.document&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.edit.document.documents_types)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(phases.edit.document.documents_types,{id:item.id})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'extensions-'+item.id,className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'extensions-'+item.id,type:'checkbox',className:'checkbox',checked:checked,onChange:function onChange(){return _this5._changeExtension(item.id,checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},item.name)))))));})),phases.edit.document&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.edit.document.documents_types)?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Seleccionar una extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-primary',onClick:function onClick(){return _this5._saveDocument();}},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);function DocumentEditForm(){_classCallCheck(this,DocumentEditForm);var _this4=_possibleConstructorReturn(this,(DocumentEditForm.__proto__||Object.getPrototypeOf(DocumentEditForm)).call(this));_this4.state={all_mods:true};return _this4;}_createClass(DocumentEditForm,[{key:'componentWillMount',value:function componentWillMount(){var phases=this.props.phases;if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(phases.edit.document)&&phases.edit.document.modality_id){this.setState({all_mods:false});}}},{key:'_changeAllMods',value:function _changeAllMods(){this.props.change('phases.edit.document.modality_id',undefined);this.setState({all_mods:!this.state.all_mods});}},{key:'_changeExtension',value:function _changeExtension(typeId,checked){var _props3=this.props,documents_types=_props3.documents_types,phases=_props3.phases;if(checked){var index=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(phases.edit.document.documents_types,{id:typeId});this.props.remove('phases.edit.document.documents_types',index);}else{var extension=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(documents_types.list,{id:typeId});this.props.add('phases.edit.document.documents_types',extension);}}},{key:'_saveDocument',value:function _saveDocument(){var _props4=this.props,phases=_props4.phases,document_index=_props4.document_index;var document=phases.edit.document;if(document.name&&document.documentable_type&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(document.documents_types)){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNumber(document_index)){this.props.change('phases.edit.documents_items['+document_index+']',Object.assign({},phases.edit.documents_items[document_index],phases.edit.document));}else{this.props.add('phases.edit.documents_items',Object.assign({},phases.edit.document));}this.props.closeModal();}else{alert('Hay errores en el formulario');}}}]);return DocumentEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentFormGroupsPhases=function(_Component){_inherits(ContentFormGroupsPhases,_Component);function ContentFormGroupsPhases(){_classCallCheck(this,ContentFormGroupsPhases);return _possibleConstructorReturn(this,(ContentFormGroupsPhases.__proto__||Object.getPrototypeOf(ContentFormGroupsPhases)).apply(this,arguments));}_createClass(ContentFormGroupsPhases,[{key:'render',value:function render(){var _this2=this;//const { status } = this.props;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'groupsPhases.edit',onSubmit:function onSubmit(values){return _this2._handleSubmit(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre de grupo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.name',id:'name',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'is_registry',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.is_registry',id:'is_registry',className:'checkbox',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Proceso de registro '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'is_closing',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.is_closing',id:'is_closing',className:'checkbox',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Proceso de cierre ')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'groupsPhases.edit',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/fases/grupos');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'groupsPhases.edit',className:'button is-primary is-large',type:'submit',disabled:this._validateSave()},'Guardar'))))));}},{key:'_handleSubmit',value:function _handleSubmit(values){this.props.groupPhaseSave(values);}},{key:'_validateSave',value:function _validateSave(){var groupsPhases=this.props.groupsPhases;var gc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(groupsPhases.permissions,function(o){return o==='Create';});var gu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(groupsPhases.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(groupsPhases.edit)&&groupsPhases.edit.id){if(gu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(groupsPhases.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(groupsPhases.edit.id)){if(gc){return false;}else{return true;}}else{return true;}}}]);return ContentFormGroupsPhases;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ContentFormGroupsPhases);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Loading from './../../elements/loading';
var ContentFormPermissions=function(_Component){_inherits(ContentFormPermissions,_Component);function ContentFormPermissions(){_classCallCheck(this,ContentFormPermissions);return _possibleConstructorReturn(this,(ContentFormPermissions.__proto__||Object.getPrototypeOf(ContentFormPermissions)).apply(this,arguments));}_createClass(ContentFormPermissions,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"permissions.edit",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title is-5"},"Permisos del Sistema"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"display",className:"label"},"Descripci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".display",id:"display",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".display",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El campo es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".name",id:"name",className:"input"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-danger",onClick:function onClick(){return _this2.props.history.push('/permisos');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"permissions.edit",className:"button is-success",type:"submit",disabled:{pristine:true}},"Guardar"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.permissionsSave(values);}}]);return ContentFormPermissions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ContentFormPermissions);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_rating__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoleEditForm=function(_Component){_inherits(RoleEditForm,_Component);_createClass(RoleEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,roles=_props.roles,permissions=_props.permissions;var roleDisabled=roles.edit&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNumber(roles.edit.editable)?!roles.edit.editable:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"roles.edit",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"display",className:"label"},"Nombre del perfil ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".display",id:"display",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".display",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El nombre del perfil es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"agenciable_type",className:"label"},"Tipo de perfil"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".agenciable_type",id:"agenciable_type",disabled:roleDisabled,value:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(roles.edit.agenciable_type)?roles.edit.agenciable_type:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-Todos-"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"federal"},"Federal"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"imef"},"IMEF"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"imm"},"IMM"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero is-light"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"title is-5"},"Listado de Permisos del Perfil ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(permissions.list)?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(permissions.list,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"box is-radiusless",onClick:function onClick(){_this2._showGroup(item.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"heading"},"Grupo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title is-6 has-text-inm-purple"},item.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},_this2.state.groupId===item.id&&_this2.state.showGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-angle-up fa-lg"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-angle-down fa-lg"})))))),_this2.state.groupId===item.id&&_this2.state.showGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth",style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item.permissions,function(p,i){var initial=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findKey(roles.edit.permissions,{id:p.id})!==undefined?1:0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",onClick:function onClick(){return _this2._addPermission(p.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_rating__["a" /* default */],{ref:"permission-"+p.id,id:"permission-"+p.id,initialRating:initial,start:0,stop:1,step:1,emptySymbol:"fa fa-square-o fa-lg",fullSymbol:"fa fa-check-square-o fa-lg",className:"has-text-primary"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"permission-"+p.id},p.display?p.display:p.name)));}))):'');}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-light is-large",onClick:function onClick(){return _this2.props.history.push('/perfiles');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"roles.edit",className:"button is-primary is-large",type:"submit",disabled:this._validateSave()},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}}]);function RoleEditForm(){_classCallCheck(this,RoleEditForm);var _this=_possibleConstructorReturn(this,(RoleEditForm.__proto__||Object.getPrototypeOf(RoleEditForm)).call(this));_this.state={groupId:undefined,showGroup:false};return _this;}_createClass(RoleEditForm,[{key:"_showGroup",value:function _showGroup(id){if(id!==this.state.groupId){this.setState({groupId:id,showGroup:true});}else{this.setState({groupId:undefined,showGroup:false});}}},{key:"_addPermission",value:function _addPermission(permisionId){var permissions=this.props.roles.edit.permissions;var permissionIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(permissions,{id:permisionId});if(this.refs["permission-"+permisionId].state.value===0){if(permissionIndex===-1){this.props.add("roles.edit.permissions",{id:permisionId});}else{this.props.change("roles.edit.permissions["+permissionIndex+"]",{id:permisionId});}}else{if(permissionIndex!==-1){this.props.remove("roles.edit.permissions",permissionIndex);}}}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.roleSave(values);}},{key:"_validateSave",value:function _validateSave(){var roles=this.props.roles;var rc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(roles.permissions,function(o){return o==='Create';});var ru=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(roles.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(roles.edit)&&roles.edit.id){if(ru){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(roles.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(roles.edit.id)){if(rc){return false;}else{return true;}}else{return true;}}}]);return RoleEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RoleEditForm);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_user_profile_female_jpg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_user_profile_female_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_user_profile_female_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_male_jpg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_male_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_male_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_greeting_select__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserEditForm=function(_Component){_inherits(UserEditForm,_Component);_createClass(UserEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,status=_props.status,roles=_props.roles,users=_props.users,entities=_props.entities,match=_props.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Form"],{model:'users.edit',validators:{'':{passwordsMatch:function passwordsMatch(vals){return vals.password===vals.password_confirmation;}}},onSubmit:function onSubmit(users){return _this2._handleSubmit(users);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered is-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-3 has-text-centered'},users.edit.image?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(users.edit.image)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-picture-o fa-4x'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'image is-1by1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:users.edit.image+'?'+Date.now(),alt:users.edit.name})):users.edit.sex==='H'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'image is-1by1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_male_jpg___default.a,alt:users.edit.name})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'image is-1by1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_user_profile_female_jpg___default.a,alt:users.edit.name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'title',className:'label'},'Saludo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"],{model:'.title',id:'title',component:__WEBPACK_IMPORTED_MODULE_8__forms_greeting_select__["a" /* default */],validateOn:'change',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.title',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre(s) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.name',className:'input',id:'name',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'last_name',className:'label'},'Primer Apellido ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.last_name',className:'input',id:'last_name',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.last_name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El apellido es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'slast_name',className:'label'},'Segundo Apellido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.slast_name',className:'input',id:'slast_name',value:users.edit.slast_name?users.edit.slast_name:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'sex',className:'label'},'Sexo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Field"],{model:'.sex',className:'select',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'sex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Sexo ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'M'},'Mujer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'H'},'Hombre'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.sex',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El sexo es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'scholarship',className:'label'},'Escolaridad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.scholarship',className:'input',id:'scholarship',value:users.edit.scholarship?users.edit.scholarship:''})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rfc',className:'label'},'RFC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.rfc',className:'input',id:'rfc',value:users.edit.rfc?users.edit.rfc:'',errors:{isRfc:__WEBPACK_IMPORTED_MODULE_6__field_validations__["e" /* isRfc */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.rfc',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRfc:'RFC inválido. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'curp',className:'label'},'CURP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.curp',className:'input',id:'curp',value:users.edit.curp?users.edit.curp:'',errors:{isCurp:__WEBPACK_IMPORTED_MODULE_6__field_validations__["b" /* isCurp */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.curp',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isCurp:'CURP inválida. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email',className:'label'},'Email principal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'has-text-grey'},'(para ingresar a la plataforma)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.email',className:'input',id:'email',placeholder:'usuario@dominio.com',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */],isEmail:__WEBPACK_IMPORTED_MODULE_6__field_validations__["c" /* isEmail */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.email',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El email es obligatorio. ',isEmail:'El email es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email_2',className:'label'},'Email secundario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{className:'input',type:'email',model:'.email_2',id:'email_2',placeholder:'usuario@dominio.com',errors:{email:__WEBPACK_IMPORTED_MODULE_6__field_validations__["a" /* email */]}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.email_2',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{email:'El email es inválido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'password',className:'label'},'Contrase\xF1a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].password,{model:'.password',id:'password',name:'password',className:'input',placeholder:'Contrase\xF1a'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'password_confirmation',className:'label'},'Confirmar Contrase\xF1a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].password,{model:'.password_confirmation',id:'password_confirmation',name:'password_confirmation',className:'input'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'users.edit',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{passwordsMatch:'Las contraseñas no coinciden'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-dark is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},'Si no deseas alterar tu contrase\xF1a, deja en blanco los campos de contrase\xF1a.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone',className:'label'},'Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.telephone',className:'input',id:'telephone',value:users.edit.telephone?users.edit.telephone:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'extension',className:'label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.extension',className:'input',id:'extension',value:users.edit.extension?users.edit.extension:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone_2',className:'label'},'Tel\xE9fono secundario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:'.telephone_2',id:'telephone_2',className:'input',value:users.edit.telephone_2?users.edit.telephone_2:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},match.params.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'roles',className:'label'},'Perfil ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].select,{id:'roles',model:'.role_id',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */],validateOn:'change',changeAction:function changeAction(model,values){return _this2._changeProfile(model,values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Perfil ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(roles.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:row.id},row.display?row.display:row.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.role_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El perfil es obligatorio'}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'status',className:'label'},'Estatus ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Field"],{model:'.status_id',className:'select',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:true},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.status_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}}))),entities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__loading__["a" /* default */],null):this._instances(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this2.props.history.push('/usuarios');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].button,{model:'users.edit',className:'button is-success',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);function UserEditForm(){_classCallCheck(this,UserEditForm);var _this=_possibleConstructorReturn(this,(UserEditForm.__proto__||Object.getPrototypeOf(UserEditForm)).call(this));_this.state={type:null};return _this;}_createClass(UserEditForm,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){var users=props.users,roles=props.roles;var role=users.edit.role_id;var type=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(roles.list,{id:role});if(type){this.setState({type:type.agenciable_type});}}},{key:'_instances',value:function _instances(){switch(this.state.type){case'imef':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StateSelect,{states:Object.assign({},this.props.entities.list)});case'imm':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MunicipalitySelect,{states:Object.assign({},this.props.entities.list),municipalities:Object.assign({},this.props.municipalities),func:this.props.fetchMunicipalities,change:this.props.change,state:this.props.users.agencies?this.props.users.agencies.state_id:undefined});case'cdm':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MunicipalitySelectCdm,{states:Object.assign({},this.props.entities.list),municipalities:Object.assign({},this.props.municipalities),func:this.props.fetchMunicipalities,change:this.props.change,state:this.props.users.agencies?this.props.users.agencies.state_id:undefined});case'federal':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatesCombo,{states:Object.assign({},this.props.entities.list)});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null);}}},{key:'_handleSubmit',value:function _handleSubmit(values){var agencies=this.props.users.agencies;this.props.userSave({edit:Object.assign({},values),agencies:agencies});}},{key:'_changeProfile',value:function _changeProfile(model,value){var roles=this.props.roles;var id=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(roles.list,function(o){return o.id===value;});if(id>-1){var type=roles.list[id].agenciable_type;this.props.fetchEntities();this.setState({type:type});}this.props.change(model,value);this.props.change('users.agencies','');/*return dispatch => {
			dispatch(actions.change('users.agencies', ''));
			dispatch(actions.change(model, value));
		}*/}},{key:'_validateSave',value:function _validateSave(){var users=this.props.users;var uc=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(users.permissions,function(o){return o==='Create';});var uu=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(users.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(users.edit)&&users.edit.id){if(uu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(users.edit)&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(users.edit.id)){if(uc){return false;}else{return true;}}else{return true;}}}]);return UserEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StateSelect=function(_Component2){_inherits(StateSelect,_Component2);function StateSelect(){_classCallCheck(this,StateSelect);return _possibleConstructorReturn(this,(StateSelect.__proto__||Object.getPrototypeOf(StateSelect)).apply(this,arguments));}_createClass(StateSelect,[{key:'render',value:function render(){var states=this.props.states;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Fieldset"],{model:'users.agencies',className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'label'},'Entidades'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].select,{id:'state',model:'.id',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Estados ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(states,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:row.id},row.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir una entidad.'}}))));}}]);return StateSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StatesCombo=function(_Component3){_inherits(StatesCombo,_Component3);function StatesCombo(){_classCallCheck(this,StatesCombo);return _possibleConstructorReturn(this,(StatesCombo.__proto__||Object.getPrototypeOf(StatesCombo)).apply(this,arguments));}_createClass(StatesCombo,[{key:'render',value:function render(){var states=this.props.states;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Fieldset"],{model:'users.agencies'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(states,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label',htmlFor:'state-'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].checkbox,{model:'['+row.id+']',id:'state-'+row.id,value:row.id}),row.name));})));}}]);return StatesCombo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var MunicipalitySelect=function(_Component4){_inherits(MunicipalitySelect,_Component4);function MunicipalitySelect(){_classCallCheck(this,MunicipalitySelect);return _possibleConstructorReturn(this,(MunicipalitySelect.__proto__||Object.getPrototypeOf(MunicipalitySelect)).apply(this,arguments));}_createClass(MunicipalitySelect,[{key:'render',value:function render(){var _this6=this;var _props2=this.props,states=_props2.states,municipalities=_props2.municipalities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Fieldset"],{model:'users.agencies',className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'state-select',className:'label'},'Estados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Field"],{model:'.state_id',className:'select',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},changeAction:function changeAction(model,values){return _this6._stateFilter(model,values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'state-select',ref:'states'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Estados ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(states,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:row.id},row.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.state_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir una entidad.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'municipality',className:'label'},'Municipios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(municipalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].select,{id:'municipality',model:'.id',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */],disabled:municipalities.isFetching||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(municipalities.list)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Municipios ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(municipalities.list,{modality_id:2}),function(mun,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:j,value:mun.id},mun.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir un municipio.'}}))));}},{key:'_stateFilter',value:function _stateFilter(model,value){this.props.func(value);this.props.change('users.agencies',{state_id:value});/*return dispatch => {
			dispatch(actions.change('users.agencies', {state_id: value}));
		}*/}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.state){this.props.func(this.props.state);}}}]);return MunicipalitySelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var MunicipalitySelectCdm=function(_Component5){_inherits(MunicipalitySelectCdm,_Component5);function MunicipalitySelectCdm(){_classCallCheck(this,MunicipalitySelectCdm);return _possibleConstructorReturn(this,(MunicipalitySelectCdm.__proto__||Object.getPrototypeOf(MunicipalitySelectCdm)).apply(this,arguments));}_createClass(MunicipalitySelectCdm,[{key:'render',value:function render(){var _this8=this;var _props3=this.props,states=_props3.states,municipalities=_props3.municipalities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Fieldset"],{model:'users.agencies',className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'state-select',className:'label'},'Estados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Field"],{model:'.state_id',className:'select',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},changeAction:function changeAction(model,values){return _this8._stateFilter(model,values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'state-select',ref:'states'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Estados ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(states,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:row.id},row.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.state_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir una entidad.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'municipality',className:'label'},'Municipios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(municipalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].select,{id:'municipality',model:'.id',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */],disabled:municipalities.isFetching||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(municipalities.list)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Municipios ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(municipalities.list,{modality_id:3}),function(mun,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:j,value:mun.id},mun.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:'.id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir un municipio.'}}))));}},{key:'_stateFilter',value:function _stateFilter(model,value){this.props.func(value);this.props.change('users.agencies',{state_id:value});/*return dispatch => {
			dispatch(actions.change('users.agencies', {state_id: value}));
		}*/}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.state){this.props.func(this.props.state);}}}]);return MunicipalitySelectCdm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserEditForm);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MunsModal=function(_Component){_inherits(MunsModal,_Component);function MunsModal(){_classCallCheck(this,MunsModal);return _possibleConstructorReturn(this,(MunsModal.__proto__||Object.getPrototypeOf(MunsModal)).apply(this,arguments));}_createClass(MunsModal,[{key:"render",value:function render(){var _this2=this;var _props=this.props,conclusion=_props.conclusion,modality=_props.modality,muns=_props.muns,show=_props.show,selectedMuns=_props.selectedMuns;var municipalities=modality===3?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(muns.list,{modality_id:3}):muns.list;return show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:function onClick(){return _this2.props.closeModal();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Seleccione los municipios participantes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2.props.closeModal();},className:"delete is-medium","aria-label":"delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},muns.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__loading__["a" /* default */],{message:"Cargando municipios..."}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline"},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(municipalities,function(municipality,k){var shouldCheck=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(selectedMuns,{agenciable_id:municipality.id})!==undefined?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"mun-"+municipality.id,className:"checkbox",disabled:conclusion},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"mun-"+municipality.id,ref:"g-mun-"+municipality.id,value:municipality.id,type:"checkbox",checked:shouldCheck,className:"checkbox",onChange:function onChange(){return _this2._saveMuns(municipality,k);},disabled:conclusion}),municipality.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-info",type:"button",onClick:function onClick(){return _this2.props.closeModal();}},"Cerrar"))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null);}},{key:"_saveMuns",value:function _saveMuns(agency,index){if(this.refs["g-mun-"+agency.id].checked){this.props.add("project.registry.data.project_goals["+this.props.selectedGoal+"].agencies",{agenciable:Object.assign({},agency),agenciable_id:agency.id,id:agency.id});}else{this.props.remove("project.registry.data.project_goals["+this.props.selectedGoal+"].agencies",index);}}}]);return MunsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MunsModal);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_rating__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { toInt } from "../parsers";
var GoalEditForm=function(_Component){_inherits(GoalEditForm,_Component);_createClass(GoalEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,project=_props.project,activities=_props.activities,axis=_props.axis,lines=_props.lines,match=_props.match;var _match$params=match.params,modality=_match$params.modality,state=_match$params.state,municipality=_match$params.municipality;var goals=project.goals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'project.goals.edit',onSubmit:function onSubmit(goals){return _this2._submitForm(goals);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre de la Meta ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.name',id:'name',className:'textarea',placeholder:'Nombre de la Meta',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'type',className:'label'},'Tipo de meta ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.type',id:'type',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Tipo de meta ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'RI'},'Rumbo a la Igualdad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'MT'},'Meta Tipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'MI'},'Meta IMEF'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.type',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar el tipo de meta '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'goal_document',className:'label'},'Documento Meta '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.goal_document',id:'goal_document',className:'input',placeholder:'Documento Meta'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'axis_id',className:'label'},'Eje tem\xE1tico ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.axis_id',id:'axis_id',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Eje tem\xE1tico ---'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(axis.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.axis_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar un eje temático. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'line_id',className:'label'},'L\xEDneas de Acci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.line_id',id:'line_id',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- L\xEDneas de Acci\xF3n ---'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(lines.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.code+' '+(option.name.length>100?option.name.substring(0,100)+'...':option.name));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.line_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes seleccionar una línea de acción. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-inm-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'requires_employees',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.requires_employees',id:'requires_employees',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Requiere contratar personas ')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Listado de Actividades de la Meta ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(activities.list,{modalities:[{slug:modality}]}),function(item,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box',style:{cursor:'pointer',backgroundColor:'#a864a9'},onClick:function onClick(){_this2._showGroup(item.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'subtitle is-7',style:{color:'#fff',paddingBottom:'25px'}},'Grupo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title is-6',style:{color:'#fff'}},item.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon',style:{color:'#fff'}},_this2.state.groupId===item.id&&_this2.state.showGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-up'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-down'})))))),_this2.state.groupId===item.id&&_this2.state.showGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Agregar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actividad'),goals.edit.mandatory?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Obligatorio'):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item.activities,function(row,k){var initial=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findKey(goals.edit.activities,{id:row.id})!==undefined?1:0;var initialMandatory=undefined;if(goals.edit.mandatory){initialMandatory=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findKey(goals.edit.activities,{id:row.id,mandatory:true})!==undefined?1:0;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-text-centered',onClick:function onClick(){return _this2._addActivity(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_rating__["a" /* default */],{ref:'activity-'+row.id,id:'activity-'+row.id,initialRating:initial,start:0,stop:1,step:1,emptySymbol:'fa fa-square-o fa-2x',fullSymbol:'fa fa-check-square-o fa-2x',className:'has-text-white'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'activity-'+row.id},row.name)),goals.edit.mandatory?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:15+'%'}},initial?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-text-centered',onClick:function onClick(){return _this2._addMandatory(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_rating__["a" /* default */],{ref:'mandatory-'+row.id,id:'mandatory-'+row.id,initialRating:initialMandatory,start:0,stop:1,step:1,emptySymbol:'fa fa-square-o fa-2x',fullSymbol:'fa fa-check-square-o fa-2x',className:'has-text-inm-purple'})):''):null);}))):'');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proyecto/'+modality+'/metas/'+state+(municipality?'/'+municipality:''));}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'goals.edit',className:'button is-large is-primary',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);function GoalEditForm(){_classCallCheck(this,GoalEditForm);var _this=_possibleConstructorReturn(this,(GoalEditForm.__proto__||Object.getPrototypeOf(GoalEditForm)).call(this));_this.state={groupId:undefined,showGroup:false};return _this;}_createClass(GoalEditForm,[{key:'_showGroup',value:function _showGroup(id){if(id!==this.state.groupId){this.setState({groupId:id,showGroup:true});}else{this.setState({groupId:undefined,showGroup:false});}}},{key:'_submitForm',value:function _submitForm(values){var _props$match$params=this.props.match.params,goal=_props$match$params.goal,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;console.log('state===>',state);this.props.projectProigualdadGoalsEditSave(goal,modality,state,municipality,values);}},{key:'_handleChangeMandatory',value:function _handleChangeMandatory(model,value,activities){var _this3=this;this.props.change(model,value);if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(activities)){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(activities,function(item,key){return _this3.props.change('project.goals.edit.activities['+key+'].mandatory',false);});}}},{key:'_addActivity',value:function _addActivity(activityId){var activities=this.props.project.goals.edit.activities;var activityIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(activities,{id:activityId});if(this.refs['activity-'+activityId].state.value===0){if(activityIndex===-1){this.props.add('project.goals.edit.activities',{id:activityId});}else{this.props.change('project.goals.edit.activities['+activityIndex+']',{id:activityId});}}else{if(activityIndex!==-1){this.props.remove('project.goals.edit.activities',activityIndex);}}}},{key:'_addMandatory',value:function _addMandatory(activityId){var activities=this.props.project.goals.edit.activities;var activityIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(activities,{id:activityId});if(this.refs['mandatory-'+activityId].state.value===0){this.props.change('project.goals.edit.activities['+activityIndex+'].mandatory',true);}else{this.props.change('project.goals.edit.activities['+activityIndex+'].mandatory',false);}}},{key:'_validateSave',value:function _validateSave(){/*const {goals} = this.props;
		let gc = _.find(goals.permissions, (o) => {return o==='Create'});
		let gu = _.find(goals.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(goals.edit) && goals.edit.id){
			if(gu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(goals.edit) && _.isEmpty(goals.edit.id)){
			if(gc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}*/return false;}}]);return GoalEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GoalEditForm);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalsAdd=function(_Component){_inherits(GoalsAdd,_Component);function GoalsAdd(){_classCallCheck(this,GoalsAdd);return _possibleConstructorReturn(this,(GoalsAdd.__proto__||Object.getPrototypeOf(GoalsAdd)).apply(this,arguments));}_createClass(GoalsAdd,[{key:'render',value:function render(){var _props=this.props,project=_props.project,match=_props.match;var _match$params=match.params,modality=_match$params.modality,state=_match$params.state,municipality=_match$params.municipality;var gc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(project.permissions,function(o){return o==='Create';});return gc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:'/proyecto/'+modality+'/proigualdad-meta/crear/'+state+(municipality?'/'+municipality:''),className:'button is-small is-inm-purple'},'Agregar Meta')):'';}}]);return GoalsAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(GoalsAdd));

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EntityEditForm=function(_Component){_inherits(EntityEditForm,_Component);function EntityEditForm(){_classCallCheck(this,EntityEditForm);return _possibleConstructorReturn(this,(EntityEditForm.__proto__||Object.getPrototypeOf(EntityEditForm)).apply(this,arguments));}_createClass(EntityEditForm,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"entities.edit",onSubmit:function onSubmit(entity){return _this2._handleSubmit(entity);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".name",id:".name",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Campo Requerido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"short",className:"label"},"Abreviatura ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".short",id:"short",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],minLength:Object(__WEBPACK_IMPORTED_MODULE_2__field_validations__["h" /* minLength */])(3)},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".short",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Campo Requerido',minLength:'Abreviatura no valido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"code",className:"label"},"C\xF3digo ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".code",id:"code",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],minLength2:__WEBPACK_IMPORTED_MODULE_2__field_validations__["i" /* minLength2 */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".code",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Campo Requerido',minLength2:'Codigo no valido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message is-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"accessibility",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:".accessibility",id:"accessibility",className:"checkbox",isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{whiteSpace:'normal'}}," Requiere ayuda visual ")))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"entities.edit",className:"button is-large",onClick:function onClick(){return _this2.props.history.push('/entidades');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"entities.edit",className:"button is-primary is-large",type:"submit",disabled:this._validateSave()},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.entitySave(values);}},{key:"_validateSave",value:function _validateSave(){var entities=this.props.entities;var ec=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(entities.permissions,function(o){return o==='Create';});var eu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(entities.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(entities.edit)&&entities.edit.id){if(eu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(entities.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(entities.edit.id)){if(ec){return false;}else{return true;}}else{return true;}}}]);return EntityEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EntityEditForm);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Loading from './../loading';
var MunicipalityEditForm=function(_Component){_inherits(MunicipalityEditForm,_Component);function MunicipalityEditForm(){_classCallCheck(this,MunicipalityEditForm);return _possibleConstructorReturn(this,(MunicipalityEditForm.__proto__||Object.getPrototypeOf(MunicipalityEditForm)).apply(this,arguments));}_createClass(MunicipalityEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,entities=_props.entities,modalities=_props.modalities;var states=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(entities.list);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"municipalities.edit",onSubmit:function onSubmit(municipality){return _this2._handleSubmit(municipality);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".name",id:"name",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Campo Requerido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"state_id",className:"label"},"Estado ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".state_id",id:"state_id",className:"select",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- Estado ---"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(states,function(state,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:state.id,key:k},state.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".state_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El Estado es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"code",className:"label"},"C\xF3digo ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".code",id:"code",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],minLength:Object(__WEBPACK_IMPORTED_MODULE_2__field_validations__["h" /* minLength */])(5)},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".code",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Campo Requerido',minLength:'Codigo no valido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"modality_id",className:"label"},"Modalidad ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".modality_id",id:"modality_id",parser:__WEBPACK_IMPORTED_MODULE_4__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- Modalidad ---"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(modalities.list,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:option.id,key:k},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".modality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes seleccionar una modalidad.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message is-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"accessibility",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:".accessibility",id:"accessibility",className:"checkbox",isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{whiteSpace:'normal'}}," Requiere ayuda visual ")))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-danger",onClick:function onClick(){return _this2.props.history.push('/municipios');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"municipalities.edit",className:"button is-success",type:"submit",disabled:this._validateSave()},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.municipalitySave(values);}},{key:"_validateSave",value:function _validateSave(){var municipalities=this.props.municipalities;var mc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(municipalities.permissions,function(o){return o==='Create';});var mu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(municipalities.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(municipalities.edit)&&municipalities.edit.id){if(mu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(municipalities.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(municipalities.edit.id)){if(mc){return false;}else{return true;}}else{return true;}}}]);return MunicipalityEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MunicipalityEditForm);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AgencyEditForm=function(_Component){_inherits(AgencyEditForm,_Component);function AgencyEditForm(){_classCallCheck(this,AgencyEditForm);return _possibleConstructorReturn(this,(AgencyEditForm.__proto__||Object.getPrototypeOf(AgencyEditForm)).apply(this,arguments));}_createClass(AgencyEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,agencies=_props.agencies,entities=_props.entities,municipalities=_props.municipalities,versions=_props.versions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"agencies.edit",onSubmit:function onSubmit(values){return _this2._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos de la instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"version_id",className:"label"},"A\xF1o ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".version_id",id:"version_id",className:"select",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change",parser:__WEBPACK_IMPORTED_MODULE_4__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- A\xF1o ---"),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(versions.list,function(version,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:version.id,key:k},version.year);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".version_id",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes elegir una año.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"agenciable_type",className:"label"},"Tipo de instancia ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".agenciable_type",id:"agenciable_type",changeAction:function changeAction(m,v){return _this2._changeAgenciableType(m,v,agencies.edit.agenciable_state_id);},errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Tipo de instancia ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"imm"},"Instituto Municipal de la Mujer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"imef"}," Instancia de la Mujer en la Entidad Federativa"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".agenciable_type",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes seleccionar el tipo de meta '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"creation_date",className:"label"},"Fecha de creaci\xF3n "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".creation_date",id:"creation_date",className:"input",value:agencies.edit.creation_date?agencies.edit.creation_date:'',component:__WEBPACK_IMPORTED_MODULE_3__forms_datepicker__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".creation_date",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La fecha de creación es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"agenciable_state_id",className:"label"},"Estado ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".agenciable_state_id",id:"agenciable_state_id",value:agencies.edit.agenciable_state_id?agencies.edit.agenciable_state_id:'',changeAction:function changeAction(model,value){return _this2._changeAgencyState(model,value,agencies.edit.agenciable_type);},parser:__WEBPACK_IMPORTED_MODULE_4__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Estado ---"),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(entities.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".agenciable_state_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estado es obligatorio'}})),agencies.edit.agenciable_type==='imm'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"agenciable_municipality_id",className:"label"},"Municipio ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select "+(agencies.municipalities.isFetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".agenciable_municipality_id",id:"agenciable_municipality_id",value:agencies.edit.agenciable_municipality_id?agencies.edit.agenciable_municipality_id:'',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change",disabled:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agencies.municipalities.list)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Municipio ---"),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(agencies.municipalities.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".agenciable_municipality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El municipio o delegación es obligatorio'}})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre de la instancia "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".name",id:"name",autoFocus:true,className:"input",placeholder:"Nombre de Instancia"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El nombre de la instancia es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"legal_nature",className:"label"},"Naturaleza jur\xEDdica "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".legal_nature",id:"legal_nature",className:"input",placeholder:"Naturaleza jur\xEDdica",value:agencies.edit.legal_nature?agencies.edit.legal_nature:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".legal_nature",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La naturaleza jurídica de la instancia es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"management_period_start",className:"label"},"Inicio de gesti\xF3n "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".management_period_start",className:"input",value:agencies.edit.management_period_start?agencies.edit.management_period_start:'',component:__WEBPACK_IMPORTED_MODULE_3__forms_datepicker__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".management_period_start",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La fecha de inicio de gestión es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"management_period_end",className:"label"},"Fin de gesti\xF3n "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".management_period_end",className:"input",id:"management_period_end",value:agencies.edit.management_period_end?agencies.edit.management_period_end:'',component:__WEBPACK_IMPORTED_MODULE_3__forms_datepicker__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".management_period_end",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La fecha de fin de gestión es obligatoria'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos generales de la instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"street",className:"label"},"Direcci\xF3n "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".street",id:"street",className:"input",value:agencies.edit.street?agencies.edit.street:'',placeholder:"Calle"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".street",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La dirección es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"num_ext",className:"label"},"N\xFAmero "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".num_ext",id:"num_ext",className:"input",value:agencies.edit.num_ext?agencies.edit.num_ext:'',placeholder:"N\xFAmero exterior"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".num_ext",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El número exterior es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"num_int",className:"label"},"Interior "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".num_int",type:"text",id:"num_int",value:agencies.edit.num_int?agencies.edit.num_int:'',className:"input",placeholder:"N\xFAmero interior"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"colony",className:"label"},"Colonia "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".colony",id:"colony",className:"input",value:agencies.edit.colony?agencies.edit.colony:'',placeholder:"Colonia o Localidad"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".colony",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La colonia es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"cp",className:"label"},"C\xF3digo postal "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".cp",id:"cp",className:"input",value:agencies.edit.cp?agencies.edit.cp:'',type:"number",max:"99999",step:"1",min:"1",placeholder:"55555"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".cp",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El código postal es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"road_type",className:"label"},"Tipo de vialidad "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".road_type",id:"road_type",className:"input",value:agencies.edit.road_type?agencies.edit.road_type:'',placeholder:"Tipo de Vialidad"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"state_id",className:"label"},"Estado "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".state_id",id:"state_id",value:agencies.edit.state_id?agencies.edit.state_id:'',changeAction:function changeAction(m,v){return _this2._changeState(m,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toNumber(v));},disabled:entities.isFetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Estado ---"),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(entities.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".state_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estado es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"municipality_id",className:"label"},"Municipio "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select "+(municipalities.isFetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".municipality_id",id:"municipality_id",value:agencies.edit.municipality_id?agencies.edit.municipality_id:'',disabled:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(municipalities.list)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Municipio ---"),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(municipalities.list,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".municipality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El municipio o delegación es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"telephone",className:"label"},"Tel\xE9fono principal "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".telephone",id:"telephone",className:"input",value:agencies.edit.telephone?agencies.edit.telephone:'',placeholder:"Tel\xE9fono principal",errors:{phoneNumber:__WEBPACK_IMPORTED_MODULE_2__field_validations__["l" /* phoneNumber */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".telephone",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El teléfono es obligatorio',phoneNumber:'El número de teléfono es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"telephone_2",className:"label"},"Tel\xE9fono alterno"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".telephone_2",id:"telephone_2",className:"input",value:agencies.edit.telephone_2?agencies.edit.telephone_2:'',placeholder:"Tel\xE9fono alterno",errors:{phoneNumber:__WEBPACK_IMPORTED_MODULE_2__field_validations__["l" /* phoneNumber */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".telephone_2",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{phoneNumber:'El número de teléfono es inválido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"email",className:"label"},"Email principal"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".email",className:"input",value:agencies.edit.email?agencies.edit.email:'',placeholder:"Email principal",errors:{email:__WEBPACK_IMPORTED_MODULE_2__field_validations__["a" /* email */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".email",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El email principal es obligatorio',email:'El email es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"email_2",className:"label"},"Email secundario "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".email_2",id:"email_2",className:"input",value:agencies.edit.email_2?agencies.edit.email_2:'',placeholder:"Email secundario",errors:{email:__WEBPACK_IMPORTED_MODULE_2__field_validations__["a" /* email */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".email_2",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{email:'El email es inválido'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.push('/instancias');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"agencies.edit",className:"button is-primary is-large",disabled:this._validateSave()},"Guardar"))))));}},{key:"componentWillMount",value:function componentWillMount(){var agencies=this.props.agencies;if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agencies.edit)&&agencies.edit.state_id){this.props.fetchMunicipalities(agencies.edit.state_id);}}},{key:"_submitForm",value:function _submitForm(values){//console.log('values: ',values);
this.props.agencyEditSave(values);}},{key:"_changeAgenciableType",value:function _changeAgenciableType(model,value,state){this.props.change(model,value);this.props.change('agencies.edit.agenciable_municipality_id',undefined);if(value==='imm'&&state){this.props.fetchAgencyMunicipalities(state);}}},{key:"_changeAgencyState",value:function _changeAgencyState(model,value,type){this.props.change(model,value);if(value&&type==='imm'){this.props.fetchAgencyMunicipalities(value);}}},{key:"_changeState",value:function _changeState(model,value){this.props.change(model,value);if(value){this.props.fetchMunicipalities(value);}}},{key:"_validateSave",value:function _validateSave(){var agencies=this.props.agencies;var ac=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(agencies.permissions,function(o){return o==='Create';});var au=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(agencies.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agencies.edit)&&agencies.edit.id){if(au){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agencies.edit)&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agencies.edit.id)){if(ac){return false;}else{return true;}}else{return true;}}}]);return AgencyEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AgencyEditForm);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AmountAgencyEditForm=function(_Component){_inherits(AmountAgencyEditForm,_Component);function AmountAgencyEditForm(){_classCallCheck(this,AmountAgencyEditForm);return _possibleConstructorReturn(this,(AmountAgencyEditForm.__proto__||Object.getPrototypeOf(AmountAgencyEditForm)).apply(this,arguments));}_createClass(AmountAgencyEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,amounts_agencies=_props.amounts_agencies,entities=_props.entities,versions=_props.versions,modalities=_props.modalities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"amounts_agencies.edit",onSubmit:function onSubmit(values){return _this2._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"version_id",className:"label"},"A\xF1o ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".version_id",id:"version_id",className:"select",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change",parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- A\xF1o ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(versions.list,function(version,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:version.id,key:k},version.year);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".version_id",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes elegir una año.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"modality_id",className:"label"},"Categor\xEDa ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".modality_id",id:"modality_id",parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],changeAction:function changeAction(model,value){return _this2._modalityChange(model,value);},errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- Categor\xEDa ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(modalities.list,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:option.id,key:k},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".modality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes seleccionar una modalidad.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"expenses_percent",className:"label"},"Porcentaje de gasto Maximo ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icons-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".expenses_percent",type:"number",step:1,min:1,max:100,className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_2__field_validations__["j" /* minValue */])(0)},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-percent"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".expenses_percent",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"amount_max",className:"label"},"Monto ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icons-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".amount_max",id:"amount_max",className:"input",type:"number",step:".01",min:"0",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_2__field_validations__["j" /* minValue */])(0)},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".amount_max",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))))),amounts_agencies.edit.modality_id!==2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"state",className:"label"},"Estado ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".state_id",id:"state",value:amounts_agencies.edit.state_id?amounts_agencies.edit.state_id:''//changeAction={(model, value) => this.changeMuns(model, value)}
,parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{defaultValue:entities.isFetching},"--- Estado ---"),entities.list.map(function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".state_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estado es obligatorio'}})),amounts_agencies.edit.modality_id===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"agencies_max",className:"label"},"Maximo CDMS ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".agencies_max",type:"number",step:1,min:1,className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_2__field_validations__["j" /* minValue */])(1)},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".amount_max",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}})):''):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.push('/instancias/montos');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"amounts_agencies.edit",className:"button is-primary is-large"},"Guardar"))))));}},{key:"_submitForm",value:function _submitForm(values){//console.log('values: ',values);
this.props.amountsAgenciesEditSave(values);}},{key:"componentWillMount",value:function componentWillMount(){var amounts_agencies=this.props.amounts_agencies;if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(amounts_agencies.edit)&&amounts_agencies.edit.state_id){//this.props.fetchMunicipalities(amounts_agencies.edit.state_id);
}}},{key:"_modalityChange",value:function _modalityChange(model,value){this.props.change(model,value);this.props.change('amounts_agencies.edit.state_id',undefined);this.props.change('amounts_agencies.edit.agencies_max',undefined);}}]);return AmountAgencyEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AmountAgencyEditForm);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificaciontTypeEditForm=function(_Component){_inherits(NotificaciontTypeEditForm,_Component);function NotificaciontTypeEditForm(){_classCallCheck(this,NotificaciontTypeEditForm);return _possibleConstructorReturn(this,(NotificaciontTypeEditForm.__proto__||Object.getPrototypeOf(NotificaciontTypeEditForm)).apply(this,arguments));}_createClass(NotificaciontTypeEditForm,[{key:"render",value:function render(){var _this2=this;var status=this.props.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"notifications_types.edit",onSubmit:function onSubmit(entity){return _this2._handleSubmit(entity);},onSubmitFailed:function onSubmitFailed(error){_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".name",id:".name",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Campo Requerido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"status",className:"label"},"Estatus ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".status_id",id:"status",className:"select",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Estatus ---"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".status_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"priority",className:"label"},"Prioridad ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".priority",id:"priority",parser:__WEBPACK_IMPORTED_MODULE_4__parsers__["c" /* toInt */],type:"number",min:1,step:1,className:"input",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".priority",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El campo es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notification is-warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-info"}),"\xA0 Si se tienen dos tipos de revisiones, se tomar\xE1 en cuenta "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"la notificaci\xF3n con mayor prioridad, donde 1 es la menor prioridad posible.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message is-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"assign_codes",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:".assign_codes",id:"assign_codes",className:"checkbox",isToggle:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{whiteSpace:'normal'}}," Asignaci\xF3n de folios ")))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"description",className:"label"},"Descripci\xF3n "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:".description",id:".description",className:"textarea"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".description",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Campo Requerido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"notifications_types.edit",className:"button is-danger",onClick:function onClick(){return _this2.props.history.push('/notificaciones');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"notifications_types.edit",className:"button is-success",type:"submit",disabled:this._validateSave()},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.notificationTypeEditSave(values);}},{key:"_validateSave",value:function _validateSave(){var notifications_types=this.props.notifications_types;var nc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(notifications_types.permissions,function(o){return o==='Create';});var nu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(notifications_types.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(notifications_types.edit)&&notifications_types.edit.id){if(nu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(notifications_types.edit)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(notifications_types.edit.id)){if(nc){return false;}else{return true;}}else{return true;}}}]);return NotificaciontTypeEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NotificaciontTypeEditForm);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SurveysEditForm=function(_Component){_inherits(SurveysEditForm,_Component);_createClass(SurveysEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,surveys=_props.surveys,status=_props.status;var surveyType=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(surveys.types.list,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(surveys.edit.survey_type_id)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},this.state.modalShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuestionModal,Object.assign({active:this.state.modalShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"surveys.edit",onSubmit:function onSubmit(values){_this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){console.log('error: ',error);_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero is-light"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre de Encuesta ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".name",id:"name",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"survey_type_id",className:"label"},"Tipo de Encuesta ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".survey_type_id",id:"survey_type_id",ref:"survey_type_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-- Tipo --"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(surveys.types.list,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:option.id,key:k},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".survey_type_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes seleccionar el tipo de Encuesta '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"status_id",className:"label"},"Estatus ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".status_id",id:"status_id",className:"select",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Estatus ---"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".status_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero is-light"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero-subsection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"question",className:"label"},this.state.type==='group'?'Nombre de grupo':'Pregunta',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{name:"question",ref:"question",id:"question",rows:2,className:"textarea",placeholder:this.state.type==='group'?'Nombre de grupo':'Pregunta',value:this.state.question,onChange:this._changeData}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"type",className:"label"},"Tipo ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"type",id:"type",ref:"type",value:this.state.type,onChange:this._changeData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{defaultValue:true,disabled:true},"-- Tipo --"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"question"},"Pregunta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"group"},"Grupo")))),this.state.type==='question'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"typeQuestion",className:"label"},"Tipo de pregunta ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"typeQuestion",ref:"typeQuestion",id:"typeQuestion",value:this.state.typeQuestion,onChange:this._changeData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-- Tipo de pregunta --"),surveyType&&surveyType.slug==='validacion-de-comisiones'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"sum"},"Suma"):'',surveyType&&surveyType.slug==='encuesta-satisfaccion-informes'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"rating"},"Calificaci\xF3n (1 al 5)"):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"text"},"Area de texto")))):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-primary",onClick:function onClick(){_this2._addQuestion();},disabled:this._validAdd()},"Agregar")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(surveys.edit.children_questions)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero-subsection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"title is-5"},"Listado de preguntas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth is-bordered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"#"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Pregunta/Grupo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Tipo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Acciones"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(surveys.edit.children_questions,function(row,k){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,_this2._getType(row.type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this2._editQuestion(k,undefined,row);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2._removeQuestion(k);},className:"button is-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash"})))))),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(row.children_questions)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"questions-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-activity-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"#"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"PREGUNTA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"TIPO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ACCIONES"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(row.children_questions,function(children,q){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:q},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-centered",style:{width:'10%'}},q+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,children.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,_this2._getType(children.type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this2._editQuestion(k,q,children);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2._removeQuestion(k,q);},className:"button is-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash"}))))));}))))):null];})))):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",model:"surveys",className:"button is-large",onClick:function onClick(){return _this2.props.history.push('/encuestas');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"surveys.edit",className:"button is-primary is-large",type:"submit"},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}}]);function SurveysEditForm(){_classCallCheck(this,SurveysEditForm);var _this=_possibleConstructorReturn(this,(SurveysEditForm.__proto__||Object.getPrototypeOf(SurveysEditForm)).call(this));_this.state={modalShow:false,type:'question',question:'',typeQuestion:'',questionIndex:0};_this._changeData=_this._changeData.bind(_this);return _this;}_createClass(SurveysEditForm,[{key:"_changeData",value:function _changeData(event){this.setState(_defineProperty({},event.target.name,event.target.value));}},{key:"_validAdd",value:function _validAdd(){var _state=this.state,type=_state.type,typeQuestion=_state.typeQuestion,question=_state.question;var response=true;if(type&&question){if(type==='group'){response=false;}else if(typeQuestion){response=false;}}return response;}},{key:"_addQuestion",value:function _addQuestion(){var _state2=this.state,type=_state2.type,typeQuestion=_state2.typeQuestion,question=_state2.question;if(type&&question){if(type==='group'){this.props.add('surveys.edit.children_questions',{name:question,type:type,children_questions:[]});this.setState({type:'question',question:'',typeQuestion:''});}else if(typeQuestion){this.props.add('surveys.edit.children_questions',{name:question,type:typeQuestion,options:[]});this.setState({type:'question',question:'',typeQuestion:''});}}}},{key:"_removeQuestion",value:function _removeQuestion(indexQuestion,IndexChildren){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNumber(IndexChildren)){this.props.remove("surveys.edit.children_questions["+indexQuestion+"].children_questions",IndexChildren);}else{this.props.remove("surveys.edit.children_questions",indexQuestion);}}},{key:"_editQuestion",value:function _editQuestion(indexFhather,indexChildren,data){this.props.change("surveys.edit.question",Object.assign({},data,{indexFhather:indexFhather,indexChildren:indexChildren}));this.setState({modalShow:true});}},{key:"_toggleModal",value:function _toggleModal(){this.setState({modalShow:!this.state.modalShow});}},{key:"_getType",value:function _getType(type){switch(type){case'group':return'Grupo';case'number':return'Número';case'sum':return'Suma';case'average':return'Promedio';case'percentage':return'Porcentaje';case'interval':return'Intervalo';case'rating':return'Calificación (1 al 5)';case'input':return'Texto Simple';case'text':return'Área de Texto';case'boolean':return'Verdadero/Falso';case'multiple':return'Opción multiple';default:return'';}}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.surveySave(values);}}]);return SurveysEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var QuestionModal=function(_Component2){_inherits(QuestionModal,_Component2);_createClass(QuestionModal,[{key:"render",value:function render(){var _this4=this;var surveys=this.props.surveys;var question=surveys.edit.question;var surveyType=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(surveys.types.list,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(surveys.edit.survey_type_id)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Edicion de "+(question.type==='group'?'grupo':'pregunta')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:this.props.closeModal,className:"delete is-medium","aria-label":"delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:"surveys.edit.question"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},question.type==='group'?'Grupo':'Pregunta'," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:".name",id:"name",rows:2,className:"textarea"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Campo obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"type",className:"label"},"Tipo de Pregunta ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".type",id:"type",changeAction:function changeAction(model,value){return _this4._changeType(model,value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{defaultValue:true,disabled:true},"-- Tipo --"),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNumber(question.indexChildren)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"group"},"Grupo"):null,surveyType&&surveyType.slug==='validacion-de-comisiones'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"sum"},"Suma"):'',surveyType&&surveyType.slug==='encuesta-satisfaccion-informes'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"rating"},"Calificaci\xF3n (1 al 5)"):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"text"},"Area de texto"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".type",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Seleccionar el tipo'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"position",className:"label"},"Posici\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".position",id:"position",type:"number",min:1,step:1,className:"input",changeAction:function changeAction(m,v){return _this4._changePosition(m,v);}}))),question.type==='sum'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"Opci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"option_number",ref:"option_number",id:"option_number",parser:__WEBPACK_IMPORTED_MODULE_4__parsers__["c" /* toInt */],type:"number",min:1,step:1,className:"input",placeholder:"valor"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"option_text",ref:"option_text",id:"option_text",className:"input",placeholder:"Texto"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this4._addOption();}},"Agregar"))))):'',question.type==='group'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"Pregunta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"question",ref:"question",id:"question",type:"text",className:"input",placeholder:"Pregunta",value:this.state.question,onChange:this._changeData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"typeQuestion",ref:"typeQuestion",id:"typeQuestion",value:this.state.typeQuestion,onChange:this._changeData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-- Tipo --"),surveyType&&surveyType.slug==='validacion-de-comisiones'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"sum"},"Suma"):'',surveyType&&surveyType.slug==='encuesta-satisfaccion-informes'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"rating"},"Calificaci\xF3n (1 al 5)"):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"text"},"Area de texto")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){_this4._addQuestion();},disabled:this._validAddQuestion()},"Agregar"))))):'',!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(question.options)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"VALOR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"TEXTO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ACCIONES"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(question.options,function(opc,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,k+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,opc.option_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'60%'}},opc.option_text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-danger",onClick:function onClick(){return _this4._removeOption(k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash"}))))));}))):'',!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(question.children_questions)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"#"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"PREGUNTA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"TIPO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ACCIONES"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(question.children_questions,function(children,q){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:q},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell",style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,q+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,children.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,_this4._getType(children.type))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this4._removeQuestion(q);},className:"button is-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash"}))))));}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{model:"surveys",className:"button is-info",onClick:this.props.closeModal},"Cerrar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-success",onClick:function onClick(){return _this4._saveQuestion();}},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))))));}}]);function QuestionModal(){_classCallCheck(this,QuestionModal);var _this3=_possibleConstructorReturn(this,(QuestionModal.__proto__||Object.getPrototypeOf(QuestionModal)).call(this));_this3.state={question:'',typeQuestion:''};_this3._changeData=_this3._changeData.bind(_this3);return _this3;}_createClass(QuestionModal,[{key:"_changeData",value:function _changeData(event){this.setState(_defineProperty({},event.target.name,event.target.value));}},{key:"_saveQuestion",value:function _saveQuestion(){var question=this.props.surveys.edit.question;if(question.name&&question.type){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNumber(question.indexChildren)){this.props.change("surveys.edit.children_questions["+question.indexFhather+"].children_questions["+question.indexChildren+"]",Object.assign({},question));}else{this.props.change("surveys.edit.children_questions["+question.indexFhather+"]",Object.assign({},question));}this.props.closeModal();}else{alert('Hay errores en el formulario');}}},{key:"_changeType",value:function _changeType(model,value){this.props.change(model,value);this.props.change('surveys.edit.question.options',[]);this.props.change('surveys.edit.question.children_questions',[]);}},{key:"_changePosition",value:function _changePosition(model,value){this.props.change(model,value?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(value):undefined);}},{key:"_addOption",value:function _addOption(){this.props.add("surveys.edit.question.options",{option_number:this.refs.option_number.value,option_text:this.refs.option_text.value});this.refs.option_number.value='';this.refs.option_text.value='';}},{key:"_removeOption",value:function _removeOption(index){this.props.remove("surveys.edit.question.options",index);}},{key:"_addQuestion",value:function _addQuestion(){var _state3=this.state,typeQuestion=_state3.typeQuestion,question=_state3.question;if(typeQuestion&&question){this.props.add('surveys.edit.question.children_questions',{name:question,type:typeQuestion,options:[]});this.setState({question:'',typeQuestion:''});}}},{key:"_validAddQuestion",value:function _validAddQuestion(){var _state4=this.state,typeQuestion=_state4.typeQuestion,question=_state4.question;var response=true;if(typeQuestion&&question){response=false;}return response;}},{key:"_removeQuestion",value:function _removeQuestion(index){this.props.remove("surveys.edit.question.children_questions",index);}},{key:"_getType",value:function _getType(type){switch(type){case'group':return'Grupo';case'number':return'Número';case'sum':return'Suma';case'average':return'Promedio';case'percentage':return'Porcentaje';case'interval':return'Intervalo';case'rating':return'Calificación (1 al 5)';case'input':return'Texto Simple';case'text':return'Área de Texto';case'boolean':return'Verdadero/Falso';case'multiple':return'Opción multiple';default:return'';}}}]);return QuestionModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SurveysEditForm);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PlaceDirectoryForm=function(_Component){_inherits(PlaceDirectoryForm,_Component);function PlaceDirectoryForm(){_classCallCheck(this,PlaceDirectoryForm);return _possibleConstructorReturn(this,(PlaceDirectoryForm.__proto__||Object.getPrototypeOf(PlaceDirectoryForm)).apply(this,arguments));}_createClass(PlaceDirectoryForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'directory-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'placeForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre / Raz\xF3n social'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'name',ref:'name',className:'input',placeholder:'Nombre de la instituci\xF3n'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'owner',className:'label'},'Titular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'owner',ref:'owner',className:'input',placeholder:'Nombre del titular'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'area',className:'label'},'\xC1rea de incidencia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'area',id:'area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{selected:true,disabled:true},'--- Area ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Alimentaci\xF3n'},'Alimentaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Educaci\xF3n'},'Educaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Participaci\xF3n pol\xEDtica'},'Participaci\xF3n pol\xEDtica'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Seguridad'},'Seguridad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Cohesi\xF3n social'},'Cohesi\xF3n social'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Empoderamiento econ\xF3mico'},'Empoderamiento econ\xF3mico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Salud'},'Salud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Vivienda'},'Vivienda'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'address',className:'label'},'Calle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'address',ref:'address',className:'input',placeholder:'Calle y n\xFAmero'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'address2',className:'label'},'Colonia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'address2',ref:'address2',className:'input',placeholder:'Colonia'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'zipcode',className:'label'},'C\xF3digo postal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',id:'zipcode',ref:'zipcode',className:'input',placeholder:'00000'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'state',className:'label'},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'state',ref:'state',className:'input',placeholder:'Estado'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'city',className:'label'},'Municipio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'city',ref:'city',className:'input',placeholder:'Municipio'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'url',className:'label'},'P\xE1gina web'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'url',ref:'url',id:'url',className:'input',placeholder:'http://'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'phone',className:'label'},'Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'tel',ref:'phone',id:'phone',className:'input',placeholder:'5555555555'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email',className:'label'},'E-mail'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',id:'email',ref:'email',className:'input',placeholder:'ejemplo@dominio.com'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(e){return _this2.saveEntry(e);},className:'button is-cdm-blue',type:'button'},'Guardar')))));}},{key:'saveEntry',value:function saveEntry(e){e.preventDefault();this.props.addEntry({id:this.props.nextId,area:this.refs.area.value,name:this.refs.name.value,owner:this.refs.owner.value,address:this.refs.address.value,address2:this.refs.address2.value,zipcode:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.zipcode.value),state:this.refs.state.value,city:this.refs.city.value,url:this.refs.url.value,phone:this.refs.phone.value,email:this.refs.email.value});this.refs.area.value='';this.refs.name.value='';this.refs.owner.value='';this.refs.address.value='';this.refs.address2.value='';this.refs.zipcode.value='';this.refs.state.value='';this.refs.city.value='';this.refs.url.value='';this.refs.phone.value='';this.refs.email.value='';}}]);return PlaceDirectoryForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PlaceDirectoryForm);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.arePathsEqual = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  /**
   * Compares two path arrays of LatLng objects.
   */

  var arePathsEqual = exports.arePathsEqual = function arePathsEqual(pathA, pathB) {
    if (pathA === pathB) {
      return true;
    }
    if (!Array.isArray(pathA) || !Array.isArray(pathB)) {
      return false;
    }
    if (pathA.length !== pathB.length) {
      return false;
    }
    for (var i = 0; i < pathA.length; ++i) {
      if (pathA[i] === pathB[i]) {
        continue;
      }
      if (!isValidLatLng(pathA[i]) || !isValidLatLng(pathB[i])) {
        return false;
      }
      if (pathB[i].lat !== pathA[i].lat || pathB[i].lng !== pathA[i].lng) {
        return false;
      }
    }
    return true;
  };

  /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */
  var isValidLatLng = function isValidLatLng(elem) {
    return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('lat') && elem.hasOwnProperty('lng');
  };
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_notification__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_navigation_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_user_opts_dropdown__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acervo_components_Sections_Main_Migrations__ = __webpack_require__(793);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(SecuredComponent,data){var AcervoLayout=function(_Component){_inherits(AcervoLayout,_Component);_createClass(AcervoLayout,[{key:"render",value:function render(){var _this2=this;var _props=this.props,notifications=_props.notifications,location=_props.location,session=_props.session,menu=_props.menu;var showModalMigrate=this.state.showModalMigrate;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_navigation_navigation__["a" /* default */],{agencies:Object.assign({},session.user.agencies),items:Object.assign({},session.user.menu),show:menu.view,location:Object.assign({},location),key:"app-navigation-sidebar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"main-content acervo",key:"main-website-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",{className:"navbar is-dark secondary-navigation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"navbar-menu navbar-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_gobmxlogo_svg___default.a,alt:"gob.mx",className:"app-gov-logo--image"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"main-nav--close",onClick:function onClick(){return _this2.toggleMenu();}},menu.view?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-left"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-chevron-right"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_user_opts_dropdown__["a" /* default */],{data:Object.assign({},session.user.profile)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"app-layout--content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-vertical-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-1 main-title",dangerouslySetInnerHTML:{__html:data&&data.title?data.title:''}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-2 is-offset-6 has-text-centered new-acervo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-fullwidth is-button-acervo is-uppercase",onClick:this._migrateAcervo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-plus"}))," migrar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"subtitle-small is-fullwidth"},"Entrega proyecto al acervo")))),notifications.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10-desktop"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_notification__["a" /* default */],notifications))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecuredComponent,this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:'50px'}},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__acervo_components_Sections_Main_Migrations__["a" /* default */],Object.assign({},this.props,{visible:showModalMigrate,closeModal:this._closeModal}))))];}}]);function AcervoLayout(props){_classCallCheck(this,AcervoLayout);var _this=_possibleConstructorReturn(this,(AcervoLayout.__proto__||Object.getPrototypeOf(AcervoLayout)).call(this,props));_this._migrateAcervo=function(){_this.setState({showModalMigrate:true});};_this._closeModal=function(){_this.setState({showModalMigrate:false});};_this.state={profileShow:false,showState:props.match.params.state,showModalMigrate:false};_this.toggleMenu=_this.toggleMenu.bind(_this);return _this;}_createClass(AcervoLayout,[{key:"changeMuns",value:function changeMuns(mun){var url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].location.pathname,'/',6);if(url[4]==='administrativo'||url[4]==='juridica'){url[5]=this.state.showState;url[6]=mun;}else{url[4]=this.state.showState;url[5]=mun;}url=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(url,'/');__WEBPACK_IMPORTED_MODULE_1__store_store__["b" /* history */].push(url);}},{key:"toggleMenu",value:function toggleMenu(){var view=this.props.menu.view;return view===true?this.props.hideMenu():this.props.showMenu();}}]);return AcervoLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_4__secure__["a" /* default */])(AcervoLayout);});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Select=function Select(props){var items=props.items,placeholder=props.placeholder,name=props.name,value=props.value,onChange=props.onChange;var array=Object.entries(items);var defaultValue=props.defaultValue?props.defaultValue:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:name,value:value,defaultValue:defaultValue,onChange:onChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},placeholder),array.map(function(item){return item?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:item[0],value:item[0]},item[1]):'';}));};/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination__);
var Paginator=function Paginator(props){var activePage=props.activePage,itemsCountPerPage=props.itemsCountPerPage,totalItemsCount=props.totalItemsCount,onChange=props.onChange;var PER_PAGE=5;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default.a,{hideDisabled:true,activePage:activePage,itemsCountPerPage:itemsCountPerPage,totalItemsCount:totalItemsCount,pageRangeDisplayed:PER_PAGE,prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-right'}),firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-double-left'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-double-right'}),onChange:onChange});};/* harmony default export */ __webpack_exports__["a"] = (Paginator);

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = {"data":[{"id":1,"name":"Persona","last_name":"Ejemplo","slast_name":"Ejemplo","polygon":{"id":2,"name":"Zona 2"},"code":"06-06001-2018-00005","type":"Actor social","job":"Periodista","traits":[{"id":1,"name":"Activismo político"},{"id":2,"name":"Periodismo"}],"represents":"Periodista independiente","influence":"Zona metropolitana","address":"Miguel de la Madrid Hurtado #55 int 15","address2":"Col. Residencial Esmeralda","municipality":"Colima","state":"Colima","zipcode":"28017","phone":"5555555555","email":"persona@dominio.com","interested":true,"status":"Contactada"},{"id":2,"name":"Persona 2","last_name":"Ejemplo","slast_name":"Ejemplo","polygon":{"id":2,"name":"Zona 2"},"code":"06-06001-2018-00005","type":"Actor social","job":"Periodista","traits":[{"id":1,"name":"Activismo político"},{"id":2,"name":"Periodismo"}],"represents":"Independiente","influence":"Zona metropolitana","address":"Miguel de la Madrid Hurtado #55 int 15","address2":"Col. Residencial Esmeralda","municipality":"Colima","state":"Colima","zipcode":"28017","phone":"5555555555","email":"persona@dominio.com","interested":true,"status":"Interesada"}]}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(269);
module.exports = __webpack_require__(274);


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(270).enable();
  window.Promise = __webpack_require__(272);
}

// fetch() polyfill for making API calls.
__webpack_require__(273);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(57);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(160);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(160);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 273 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_bulma_min_css__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_bulma_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_bulma_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_styles_min_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_styles_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_styles_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_acervo_css__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_acervo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_acervo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__registerServiceWorker__ = __webpack_require__(816);
var Root=function Root(_ref){var store=_ref.store;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_5__store_store__["b" /* history */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{children:__WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */].props.children})));};Root.propTypes={store:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root,{store:__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */]}),document.getElementById('root'));console.log('%cProEquidad','color: #426858; font-weight:bold;font-size:2rem;');console.log('%cPrograma ProEquidad','font-weight:bold;');console.info('%cTodos los derechos reservados © 2019','color:#000000,font-size:1.4rem;');Object(__WEBPACK_IMPORTED_MODULE_10__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(57),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(277);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(57),q=__webpack_require__(279);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(280);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(97);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(97);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(163);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(162);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(166);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(167);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(168);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(169);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(99);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(73);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(170);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loginapp__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logoutapp__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerapp__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layouts_welcome_index__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layouts_dashboard_index__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layouts_helps_index__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layouts_goals_index__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layouts_goals_edit__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layouts_goals_create__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__layouts_objectives_index__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layouts_objectives_edit__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__layouts_objectives_create__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__layouts_strategies_index__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__layouts_strategies_edit__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__layouts_strategies_create__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__layouts_lines_index__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__layouts_lines_edit__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__layouts_lines_create__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__layouts_axis_index__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__layouts_axis_edit__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__layouts_axis_create__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__layouts_activities_index__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__layouts_activities_edit__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__layouts_activities_create__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__layouts_concepts_index__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__layouts_concepts_edit__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__layouts_concepts_create__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__layouts_profile_index__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__layouts_versions_index__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__layouts_versions_edit__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__layouts_versions_create__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__layouts_versions_version_groups_phases__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__layouts_phases_index__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__layouts_phases_edit__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__layouts_phases_create__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__layouts_group_phases_index__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__layouts_group_phases_edit__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__layouts_group_phases_create__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__layouts_permissions_index__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__layouts_permissions_edit__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__layouts_permissions_create__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__layouts_roles_index__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__layouts_roles_edit__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__layouts_roles_create__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__layouts_users_index__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__layouts_users_edit__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__layouts_users_create__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__layouts_projects_index__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__layouts_projects_project__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__layouts_projects_goals__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__layouts_projects_expenses__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__layouts_projects_commissions__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__layouts_projects_phases__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__layouts_projects_employees__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__layouts_projects_folios__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__layouts_project_owner__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__layouts_project_instance__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__layouts_project_registry__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__layouts_project_goals_create__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__layouts_project_goals_edit__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__layouts_project_profiles__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__layouts_project_expenses__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__layouts_project_conclusion__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__layouts_revision_project__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__layouts_revision_legal__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__layouts_revision_agreements__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__layouts_revision_reports_financial__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__layouts_revision_reports_expenses__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__layouts_revision_reports_summary__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__layouts_entities_index__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__layouts_entities_edit__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__layouts_entities_create__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__layouts_municipalities_index__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__layouts_municipalities_edit__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__layouts_municipalities_create__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__layouts_agencies_index__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__layouts_agencies_edit__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__layouts_agencies_create__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__layouts_amounts_agencies_index__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__layouts_amounts_agencies_edit__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__layouts_amounts_agencies_create__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__layouts_notifications_index__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__layouts_notifications_edit__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__layouts_notifications_create__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__layouts_notifications_messages__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__layouts_revision_commission__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__layouts_reports_revisions__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__layouts_reports_financial__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__layouts_reports_expenses__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__layouts_reports_employees__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__layouts_reports_surveys__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__layouts_reports_summary__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__layouts_surveys_index__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__layouts_surveys_create__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__layouts_surveys_edit__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__layouts_tracing_agreements__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__layouts_tracing_dispersions__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__layouts_cdms_employees__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__cdm_frontend_pages_index__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__cdm_frontend_pages_detail__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__cdm_frontend_pages_substantial_directory_places__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__cdm_frontend_pages_substantial_directory_services__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__cdm_frontend_pages_substantial_calendar_activities__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__cdm_frontend_pages_substantial_directory_zones__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__cdm_frontend_pages_substantial_directory_infrastructure__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__acervo_containers_Home_Home__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__acervo_containers_Detail_Detail__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__layouts_notfound__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__cdm_frontend_pages_support_planning__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__cdm_frontend_pages_support_planning_edit__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__cdm_frontend_pages_directory__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__cdm_frontend_pages_directory_edit__ = __webpack_require__(814);
/* RUTAS CDMS *//* RUTAS Acervo *//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'app',component:__WEBPACK_IMPORTED_MODULE_2__app__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'login',path:'/',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__loginapp__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'logout',path:'/logout',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__logoutapp__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'register',path:'/registro',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__registerapp__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'dashboard',path:'/dashboard',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__layouts_dashboard_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'welcome',path:'/inicio',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__layouts_welcome_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'profile',path:'/perfil',onEnter:__WEBPACK_IMPORTED_MODULE_101_redux_react_session__["sessionService"].checkAuth,exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30__layouts_profile_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'helps',path:'/ayuda',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__layouts_helps_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-goals',path:'/proigualdad/metas',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__layouts_goals_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-goals-edit',path:'/proigualdad/metas/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__layouts_goals_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-goals-create',path:'/proigualdad/metas/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__layouts_goals_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-objectives',path:'/proigualdad/objetivos',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__layouts_objectives_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-objectives-edit',path:'/proigualdad/objetivos/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__layouts_objectives_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-objectives-create',path:'/proigualdad/objetivos/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__layouts_objectives_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-strategies',path:'/proigualdad/estrategias',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__layouts_strategies_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-strategies-edit',path:'/proigualdad/estrategias/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__layouts_strategies_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-strategies-create',path:'/proigualdad/estrategias/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__layouts_strategies_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-lines',path:'/proigualdad/lineas',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__layouts_lines_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-lines-edit',path:'/proigualdad/lineas/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__layouts_lines_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-lines-create',path:'/proigualdad/lineas/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__layouts_lines_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-axis',path:'/proigualdad/ejes',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__layouts_axis_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-axis-edit',path:'/proigualdad/ejes/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__layouts_axis_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-axis-create',path:'/proigualdad/ejes/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__layouts_axis_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-activities',path:'/proigualdad/actividades',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__layouts_activities_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-activities-Edit',path:'/proigualdad/actividades/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__layouts_activities_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'proigualdad-activities-create',path:'/proigualdad/actividades/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26__layouts_activities_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'concepts',path:'/gastos/conceptos',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__layouts_concepts_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'concept-edit',path:'/gastos/conceptos/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__layouts_concepts_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'concept-create',path:'/gastos/conceptos/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29__layouts_concepts_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'versions',path:'/versiones',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__layouts_versions_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'version-edit',path:'/versiones/editar/:year',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32__layouts_versions_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'version-create',path:'/versiones/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_33__layouts_versions_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'version-groups-phases',path:'/versiones/editar/:year/grupo/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_34__layouts_versions_version_groups_phases__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'phases',path:'/fases',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35__layouts_phases_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'phases-edit',path:'/fases/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_36__layouts_phases_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'phases-create',path:'/fases/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_37__layouts_phases_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'groups-phases',path:'/fases/grupos',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_38__layouts_group_phases_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'groups-phases-edit',path:'/fases/grupos/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_39__layouts_group_phases_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'groups-phases-create',path:'/fases/grupos/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_40__layouts_group_phases_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'permissions',path:'/permisos',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_41__layouts_permissions_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'permissions-edit',path:'/permisos/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_42__layouts_permissions_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'permissions-create',path:'/permisos/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_43__layouts_permissions_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'roles',path:'/perfiles',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_44__layouts_roles_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'roles-edit',path:'/perfiles/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_45__layouts_roles_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'roles-create',path:'/perfiles/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_46__layouts_roles_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'users',path:'/usuarios',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_47__layouts_users_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'users-edit',path:'/usuarios/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_48__layouts_users_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'users-create',path:'/usuarios/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_49__layouts_users_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'projects',path:'/proyectos',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_50__layouts_projects_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'projects-edit',path:'/proyectos/editar/datos/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_51__layouts_projects_project__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'projects-goals-edit',path:'/proyectos/editar/metas/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_52__layouts_projects_goals__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'projects-expenses-edit',path:'/proyectos/editar/gastos/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_53__layouts_projects_expenses__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'projects-commissions',path:'/proyectos/editar/encuesta-comisiones/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_54__layouts_projects_commissions__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'projects-phases-groups-edit',path:'/proyectos/editar/procesos/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_55__layouts_projects_phases__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'projects-employees-edit',path:'/proyectos/editar/personal/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_56__layouts_projects_employees__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'projects-folios',path:'/proyectos/folios/:modality',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_57__layouts_projects_folios__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'project-owner',path:'/proyecto/:modality/titular/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_58__layouts_project_owner__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'project-agency',path:'/proyecto/:modality/instancia/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_59__layouts_project_instance__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'project-goals',path:'/proyecto/:modality/metas/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_60__layouts_project_registry__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'project-goal-create',path:'/proyecto/:modality/proigualdad-meta/crear/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_61__layouts_project_goals_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'project-goal-edit',path:'/proyecto/:modality/proigualdad-meta/editar/:goal?/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_62__layouts_project_goals_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'project-expenses',path:'/proyecto/:modality/gastos/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_64__layouts_project_expenses__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'project-profiles',path:'/proyecto/:modality/adicionales/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_63__layouts_project_profiles__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'project-conclusion',path:'/proyecto/:modality/conclusion/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_65__layouts_project_conclusion__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'entities',path:'/entidades',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_72__layouts_entities_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'entities-edit',path:'/entidades/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_73__layouts_entities_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'entities-create',path:'/entidades/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_74__layouts_entities_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'municipalities',path:'/municipios',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_75__layouts_municipalities_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'municipalities-edit',path:'/municipios/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_76__layouts_municipalities_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'municipalities-create',path:'/municipios/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_77__layouts_municipalities_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'agencies',path:'/instancias',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_78__layouts_agencies_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'agencies-edit',path:'/instancias/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_79__layouts_agencies_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'agencies-create',path:'/instancias/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_80__layouts_agencies_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'amounts-agencies',path:'/instancias/montos',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_81__layouts_amounts_agencies_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'amounts-agencies-edit',path:'/instancias/montos/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_82__layouts_amounts_agencies_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'amounts-agencies-create',path:'/instancias/montos/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_83__layouts_amounts_agencies_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'revision-project',path:'/revision/:modality/proyecto/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_66__layouts_revision_project__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'revision-legal',path:'/revision/:modality/juridica/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_67__layouts_revision_legal__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'revision-commission',path:'/revision/comisiones',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_88__layouts_revision_commission__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'revision-agreements',path:'/revision/:modality/convenios/:type/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_68__layouts_revision_agreements__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'revision-reports-financial',path:'/revision/:modality/avance-fisico-financiero/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_69__layouts_revision_reports_financial__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'revision-reports-expenses',path:'/revision/:modality/gastos-coordinacion/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_70__layouts_revision_reports_expenses__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'revision-reports-summary',path:'/revision/:modality/resumen/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_71__layouts_revision_reports_summary__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'notifications',path:'/notificaciones',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_84__layouts_notifications_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'notifications-edit',path:'/notificaciones/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_85__layouts_notifications_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'notifications-create',path:'/notificaciones/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_86__layouts_notifications_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'notification-messages',path:'/notificacion/:modality',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_87__layouts_notifications_messages__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'report-revisions',path:'/reporte/:modality/revisiones/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_89__layouts_reports_revisions__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'surveys',path:'/encuestas',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_95__layouts_surveys_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'surveys-create',path:'/encuestas/crear',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_96__layouts_surveys_create__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'surveys-edit',path:'/encuestas/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_97__layouts_surveys_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'agreements',path:'/seguimiento/:modality/convenios/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_98__layouts_tracing_agreements__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'dispersions',path:'/seguimiento/:modality/dispersion/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_99__layouts_tracing_dispersions__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'report-financial',path:'/informes/:modality/avance-fisico-financiero/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_90__layouts_reports_financial__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'report-expenses',path:'/informes/:modality/gastos-coordinacion/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_91__layouts_reports_expenses__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'report-people-hired',path:'/informes/:modality/personas-contratadas/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_92__layouts_reports_employees__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'report-surveys',path:'/informes/:modality/encuesta-calidad/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_93__layouts_reports_surveys__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'report-summary',path:'/informes/:modality/resumen/:state?/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_94__layouts_reports_summary__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-employees',path:'/cdms/personal/:state/:municipality?',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_100__layouts_cdms_employees__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-home',path:'/cdm/inicio',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_102__cdm_frontend_pages_index__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-places-directory',path:'/cdm/tarea/:id/places-directory/:step',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_104__cdm_frontend_pages_substantial_directory_places__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-services-directory',path:'/cdm/tarea/:id/services-directory/:step',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_105__cdm_frontend_pages_substantial_directory_services__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-activities-directory',path:'/cdm/tarea/:id/activities-calendar/:step',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_106__cdm_frontend_pages_substantial_calendar_activities__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-map-area',path:'/cdm/tarea/:id/map-area/:step',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_107__cdm_frontend_pages_substantial_directory_zones__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-infrastructure-directory',path:'/cdm/tarea/:id/infrastructure-directory/:step',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_108__cdm_frontend_pages_substantial_directory_infrastructure__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-detail',path:'/cdm/tarea/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_103__cdm_frontend_pages_detail__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-planning-home',path:'/cdm/planeacion',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_112__cdm_frontend_pages_support_planning__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-planning-edit',path:'/cdm/planeacion/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_113__cdm_frontend_pages_support_planning_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-directory-users',path:'/cdm/directorio/personas',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_114__cdm_frontend_pages_directory__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'cdm-directory-users-edit',path:'/cdm/directorio/personas/editar/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_115__cdm_frontend_pages_directory_edit__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'acervo-home',path:'/acervo',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_109__acervo_containers_Home_Home__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'acervo-detail',path:'/acervo/proyectos/:id',exact:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_110__acervo_containers_Detail_Detail__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'not-found',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_111__layouts_notfound__["a" /* default */],null);}}))));

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_bulma_min_css__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_bulma_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_bulma_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_quill_dist_quill_snow_css__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_es__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_styles_min_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_styles_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_styles_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppContainer=function(_Component){_inherits(AppContainer,_Component);function AppContainer(){_classCallCheck(this,AppContainer);return _possibleConstructorReturn(this,(AppContainer.__proto__||Object.getPrototypeOf(AppContainer)).apply(this,arguments));}_createClass(AppContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children,this.props));}}]);return AppContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AppContainer);

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(20)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_inm_svg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_inm_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_inm_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_login_login__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_login_welcome__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_login__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginLayout=function(_Component){_inherits(LoginLayout,_Component);_createClass(LoginLayout,[{key:'render',value:function render(){var _props$userLogin$data=this.props.userLogin.data,menu=_props$userLogin$data.menu,profile=_props$userLogin$data.profile;var _props$session=this.props.session,checked=_props$session.checked,authenticated=_props$session.authenticated;var register=this.props.register;return checked&&authenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'hero is-fullheight is-black login-layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'nav',style:{backgroundColor:'#393c3e'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_gobmxlogo_svg___default.a,alt:'Logo'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_inm_svg___default.a,alt:'Instituto Nacional de la Mujer',className:'logo-inm'}))),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(menu)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_login_welcome__["a" /* default */],{userLogin:profile}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_login_login__["a" /* default */],{action:this.state.action,setActionType:this._setActionType,query:this.props.location.search,userRecover:this.props.userRecover,userReset:this.props.userReset,login:this.props.login,userLogin:this.props.userLogin,register:register}))))));}}]);function LoginLayout(){_classCallCheck(this,LoginLayout);var _this=_possibleConstructorReturn(this,(LoginLayout.__proto__||Object.getPrototypeOf(LoginLayout)).call(this));_this._setActionType=function(action){return _this.setState({action:action});};_this.state={action:'login'};_this._setActionType=_this._setActionType.bind(_this);return _this;}_createClass(LoginLayout,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.location.pathname==='/'&&this.props.location.search.indexOf('reset')!==-1){this._setActionType('reset');//query = this.props.location.search
}else{this.props.validateSession();}}}]);return LoginLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;var mapStateToProps=function mapStateToProps(state){var userLogin=state.userLogin,session=state.session,register=state.register;return{userLogin:userLogin,session:session,register:register};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{validateSession:function validateSession(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_login__["e" /* validateSession */])());},login:function login(values){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_login__["a" /* login */])(values));},userRecover:function userRecover(email){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_login__["c" /* recover */])(email));},userReset:function userReset(values,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_login__["d" /* userReset */])(values,query));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(LoginLayout)));

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(100);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(176);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(329);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(182);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(316);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(314);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(179);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(318);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(322);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22), __webpack_require__(321)(module)))

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(180);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(181);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(182);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(183);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(330);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(100);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userLogin__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userResetPassword__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userForgotPassword__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loading__ = __webpack_require__(201);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginBox=function(_Component){_inherits(LoginBox,_Component);function LoginBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LoginBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LoginBox.__proto__||Object.getPrototypeOf(LoginBox)).call.apply(_ref,[this].concat(args))),_this),_this._actionPane=function(){switch(_this.props.action){case'reset':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__userResetPassword__["a" /* default */],{setActionType:_this.props.setActionType,userReset:_this.props.userReset,error:_this.props.userLogin.error,message:_this.props.userLogin.message,query:_this.props.query});case'forgot':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__userForgotPassword__["a" /* default */],{setActionType:_this.props.setActionType,userRecover:_this.props.userRecover,message:_this.props.userLogin.message,error:_this.props.userLogin.error});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__userLogin__["a" /* default */],{setActionType:_this.props.setActionType,user:_this.props.user,login:_this.props.login,register:_this.props.register,error:_this.props.userLogin.error,message:_this.props.userLogin.message});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoginBox,[{key:"render",value:function render(){var content=this._actionPane();var _props$userLogin=this.props.userLogin,isFetching=_props$userLogin.isFetching,message=_props$userLogin.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns login-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__loading__["a" /* default */],{message:message}):content))));}}]);return LoginBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginBox);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserLogin=function(_Component){_inherits(UserLogin,_Component);function UserLogin(){_classCallCheck(this,UserLogin);return _possibleConstructorReturn(this,(UserLogin.__proto__||Object.getPrototypeOf(UserLogin)).apply(this,arguments));}_createClass(UserLogin,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-5 has-text-centered"},"Iniciar Sesi\xF3n"),this.props.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-danger"},this.props.error),this.props.message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-success"},this.props.message),this.props.register.message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-success"},this.props.register.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["LocalForm"],{onSubmit:function onSubmit(values){return _this2._handleSubmit(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icon has-icon-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{type:"email",model:".username",className:"input",placeholder:"Usuario",autoFocus:true,validateOn:"change",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],isEmail:__WEBPACK_IMPORTED_MODULE_2__field_validations__["c" /* isEmail */]}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-envelope"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".username",show:"touched",messages:{isRequired:'Ingresa tu usuario. ',isEmail:'El usuario que ingresaste es inválido. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icon has-icon-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].password,{model:".password",className:"input",placeholder:"Contrase\xF1a",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lock"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".password",show:"touched",messages:{isRequired:'Ingresa tu contraseña'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"remember",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:".remember",id:"remember",name:"remember"}),"Recordarme"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Ingresar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-sign-in"}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},this.props.register.state==='open'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push('/registro');},className:"button is-small"},"Registrarse")):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.props.setActionType('forgot');},className:"button is-small"},"\xBFOlvidaste tu contrase\xF1a?")))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.login(values);}}]);return UserLogin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserLogin);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = partition;
function partition(collection, predicate) {
  var result = [[], []];

  collection.forEach(function (item, index) {
    if (predicate(item, index, collection)) {
      result[0].push(item);
    } else {
      result[1].push(item);
    }
  });

  return result;
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findKey;
function findKey(object, predicate) {
  var resultKey = void 0;

  Object.keys(object).some(function (key) {
    var isKey = predicate(object[key], key, object);

    if (isKey) {
      resultKey = key;
      return true;
    }

    return false;
  });

  return resultKey;
}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pathStartsWith;
exports.pathDifference = pathDifference;

var _lodash = __webpack_require__(187);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pathStartsWith(pathString, subPathString) {
  if (pathString === subPathString) return true;

  var path = (0, _lodash2.default)(pathString);
  var subPath = (0, _lodash2.default)(subPathString);

  var startsWithSubPath = subPath.every(function (segment, index) {
    return path[index] === segment;
  });

  return startsWithSubPath;
}

function pathDifference(pathString, subPathString) {
  if (pathString === subPathString) return [];

  var path = (0, _lodash2.default)(pathString);
  var subPath = (0, _lodash2.default)(subPathString);

  var difference = path.reduce(function (acc, segment, index) {
    if (segment === subPath[index]) return acc;

    acc.push(segment);

    return acc;
  }, []);

  return difference;
}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createModelActions = createModelActions;

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _identity = __webpack_require__(48);

var _identity2 = _interopRequireDefault(_identity);

var _icepick = __webpack_require__(33);

var _icepick2 = _interopRequireDefault(_icepick);

var _getValue = __webpack_require__(78);

var _getValue2 = _interopRequireDefault(_getValue);

var _isMulti = __webpack_require__(76);

var _isMulti2 = _interopRequireDefault(_isMulti);

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _track = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStrategies = {
  get: _get3.default,
  getValue: _getValue2.default,
  splice: _icepick2.default.splice,
  merge: _icepick2.default.merge,
  remove: _icepick2.default.dissoc,
  push: _icepick2.default.push,
  length: function length(value) {
    return value.length;
  },
  object: {},
  array: []
};

function optionsFromArgs(args, index) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof index === 'undefined') return undefined;

  return _extends({}, options, args[index]);
}

function createModelActions() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategies;

  var change = function change(model, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // option defaults
    var changeOptions = _extends({
      silent: false,
      multi: (0, _isMulti2.default)(model),
      external: true
    }, options);

    if (typeof value === 'function') {
      return function (dispatch, getState) {
        var modelValue = s.get(getState(), model);

        return dispatch(change(model, value(modelValue), options));
      };
    }

    return _extends({
      type: _actionTypes2.default.CHANGE,
      model: model,
      value: s.getValue(value)
    }, changeOptions);
  };

  function createModifierAction(modifier, defaultValue, optionsIndex, getOptions) {
    var actionCreator = function actionCreator(model) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return function (dispatch, getState) {
        var modelValue = s.get(getState(), model, defaultValue);
        var value = modifier.apply(undefined, [modelValue].concat(args));

        var options = getOptions ? getOptions.apply(undefined, [value].concat(args)) : undefined;

        dispatch(change(model, value, optionsFromArgs(args, optionsIndex - 1, options)));
      };
    };

    return actionCreator;
  }

  var xor = createModifierAction(function (value, item) {
    var iteratee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (_item) {
      return _item === item;
    };

    var valueWithoutItem = value.filter(function (_item) {
      return !iteratee(_item);
    });

    return s.length(value) === s.length(valueWithoutItem) ? s.push(value, item) : valueWithoutItem;
  }, s.array, 3);

  var push = createModifierAction(function (value, item) {
    return s.push(value || s.array, item);
  }, s.array, 2);

  var toggle = createModifierAction(function (value) {
    return !value;
  }, undefined, 1);

  var checkWithValue = function checkWithValue(model, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var currentValue = options.currentValue;


    if ((0, _isMulti2.default)(model)) {
      var valueWithItem = currentValue || s.array;
      var valueWithoutItem = (valueWithItem || s.array).filter(function (item) {
        return item !== value;
      });
      var multiValue = s.length(valueWithoutItem) === s.length(valueWithItem) ? s.push(valueWithItem, value) : valueWithoutItem;

      return change(model, multiValue);
    }

    if (typeof value === 'undefined') {
      return change(model, !currentValue);
    }
    return change(model, value);
  };

  var check = function check(model, value) {
    return function (dispatch, getState) {
      var modelValue = s.get(getState(), model);

      var action = checkWithValue(model, value, {
        currentValue: modelValue
      });

      dispatch(action);
    };
  };

  var filter = createModifierAction(function (value, iteratee) {
    return value.filter(iteratee);
  }, s.array, 2);

  var reset = function reset(model) {
    return {
      type: _actionTypes2.default.RESET,
      model: model
    };
  };

  var map = createModifierAction(function (value) {
    var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
    return value.map(iteratee);
  }, s.array, 2);

  var remove = createModifierAction(function (value, index) {
    return s.splice(value, index, 1);
  }, s.array, 2, function (_, index) {
    return { removeKeys: [index] };
  });

  var move = createModifierAction(function (value, indexFrom, indexTo) {
    if (indexFrom >= s.length(value) || indexTo >= s.length(value)) {
      throw new Error('Error moving array item: invalid bounds ' + indexFrom + ', ' + indexTo);
    }

    var item = s.get(value, indexFrom);
    var removed = s.splice(value, indexFrom, 1);
    var inserted = s.splice(removed, indexTo, 0, item);

    return inserted;
  }, s.array, 3);

  var merge = createModifierAction(s.merge, {}, 3);

  var omit = createModifierAction(function (value) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var propsArray = typeof props === 'string' ? [props] : props;

    var newValue = propsArray.reduce(function (acc, prop) {
      return s.remove(acc, prop);
    }, value);

    return newValue;
  }, {}, 2, function (_, props) {
    return { removeKeys: props };
  });

  var load = function load(model, values, options) {
    return change(model, values, _extends({
      silent: true,
      load: true
    }, options));
  };

  return (0, _mapValues2.default)({
    change: change,
    xor: xor,
    push: push,
    toggle: toggle,
    check: check,
    checkWithValue: checkWithValue,
    filter: filter,
    reset: reset,
    map: map,
    remove: remove,
    move: move,
    merge: merge,
    omit: omit,
    load: load
  }, _track.trackable);
}

exports.default = createModelActions();

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFieldClass = exports.controlPropsMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _identity = __webpack_require__(48);

var _identity2 = _interopRequireDefault(_identity);

var _omit = __webpack_require__(49);

var _omit2 = _interopRequireDefault(_omit);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _pick = __webpack_require__(339);

var _pick2 = _interopRequireDefault(_pick);

var _reactRedux = __webpack_require__(24);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _actions = __webpack_require__(47);

var _actions2 = _interopRequireDefault(_actions);

var _controlComponent = __webpack_require__(188);

var _controlComponent2 = _interopRequireDefault(_controlComponent);

var _controlPropsMap2 = __webpack_require__(108);

var _controlPropsMap3 = _interopRequireDefault(_controlPropsMap2);

var _deepCompareChildren = __webpack_require__(190);

var _deepCompareChildren2 = _interopRequireDefault(_deepCompareChildren);

var _shallowCompareWithoutChildren = __webpack_require__(348);

var _shallowCompareWithoutChildren2 = _interopRequireDefault(_shallowCompareWithoutChildren);

var _getModel = __webpack_require__(59);

var _getModel2 = _interopRequireDefault(_getModel);

var _getFieldFromState = __webpack_require__(58);

var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);

var _resolveModel = __webpack_require__(81);

var _resolveModel2 = _interopRequireDefault(_resolveModel);

var _getValue = __webpack_require__(78);

var _initialFieldState = __webpack_require__(34);

var _initialFieldState2 = _interopRequireDefault(_initialFieldState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fieldPropTypes = {
  model: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  parser: _propTypes2.default.func,
  formatter: _propTypes2.default.func,
  updateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  changeAction: _propTypes2.default.func,
  validators: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  asyncValidators: _propTypes2.default.object,
  validateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  asyncValidateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  errors: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  mapProps: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  componentMap: _propTypes2.default.object,
  dynamic: _propTypes2.default.bool,
  dispatch: _propTypes2.default.func,
  getRef: _propTypes2.default.func,

  // Calculated props
  fieldValue: _propTypes2.default.object,
  store: _propTypes2.default.shape({
    subscribe: _propTypes2.default.func,
    dispatch: _propTypes2.default.func,
    getState: _propTypes2.default.func
  }),
  storeSubscription: _propTypes2.default.any
};

function getControlType(control, props, options) {
  var _controlPropsMap = options.controlPropsMap;


  var controlDisplayNames = Object.keys(_controlPropsMap).filter(function (controlKey) {
    var propsMap = _controlPropsMap[controlKey];

    if ((0, _isPlainObject2.default)(propsMap) && propsMap.component) {
      return control.type === propsMap.component;
    }

    return false;
  });

  if (controlDisplayNames.length) return controlDisplayNames[0];

  try {
    var controlDisplayName = control.constructor.displayName || control.type.displayName || control.type.name || control.type;

    if (controlDisplayName === 'input') {
      controlDisplayName = _controlPropsMap[control.props.type] ? control.props.type : 'text';
    }

    return _controlPropsMap[controlDisplayName] ? controlDisplayName : null;
  } catch (error) {
    return undefined;
  }
}

var defaultStrategy = {
  Control: _controlComponent2.default,
  controlPropTypes: fieldPropTypes,
  getFieldFromState: _getFieldFromState2.default,
  actions: _actions2.default
};

function createFieldClass() {
  var customControlPropsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultStrategy;

  // Use the fieldPropTypes if no controlProptypes have been defined to
  // maintain backwards compatibiltiy.
  var controlPropTypes = s.controlPropTypes || fieldPropTypes;

  function mapStateToProps(state, props) {
    var model = props.model;


    var modelString = (0, _getModel2.default)(model, state);
    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;

    return {
      model: modelString,
      fieldValue: fieldValue
    };
  }

  var options = {
    controlPropsMap: _extends({}, _controlPropsMap3.default, customControlPropsMap)
  };

  // TODO: refactor
  var defaultControlPropsMap = {
    checkbox: {
      changeAction: s.actions.checkWithValue,
      getValue: _getValue.getCheckboxValue,
      isToggle: true
    },
    radio: {
      isToggle: true
    }
  };

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field() {
      _classCallCheck(this, Field);

      return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
    }

    _createClass(Field, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        var dynamic = this.props.dynamic;


        if (dynamic) {
          return (0, _deepCompareChildren2.default)(this, nextProps, nextState);
        }

        return (0, _shallowCompareWithoutChildren2.default)(this, nextProps);
      }
    }, {
      key: 'createControlComponent',
      value: function createControlComponent(control) {
        var props = this.props;


        if (!control || !control.props || control instanceof _controlComponent2.default) {
          return control;
        }

        var controlType = getControlType(control, props, options);
        var _props$mapProps = props.mapProps,
            mapProps = _props$mapProps === undefined ? options.controlPropsMap[controlType] : _props$mapProps;


        var controlProps = (0, _pick2.default)(props, Object.keys(controlPropTypes));

        if (!mapProps) {
          return _react2.default.cloneElement(control, null, this.mapChildrenToControl(control.props.children));
        }

        return _react2.default.createElement(s.Control, _extends({}, controlProps, {
          control: control,
          controlProps: control.props,
          component: control.type,
          mapProps: mapProps
        }, defaultControlPropsMap[controlType] || {}));
      }
    }, {
      key: 'mapChildrenToControl',
      value: function mapChildrenToControl(children) {
        var _this2 = this;

        if (_react2.default.Children.count(children) > 1) {
          return _react2.default.Children.map(children, function (child) {
            return _this2.createControlComponent(child);
          });
        }

        return this.createControlComponent(children);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            children = _props.children,
            fieldValue = _props.fieldValue;


        var allowedProps = (0, _omit2.default)(this.props, Object.keys(controlPropTypes));
        var renderableChildren = typeof children === 'function' ? children(fieldValue) : children;

        if (!component) {
          (0, _invariant2.default)(_react2.default.Children.count(renderableChildren) === 1, 'Empty wrapper components for <Field> are only possible' + 'when there is a single child. Please check the children' + ('passed into <Field model="' + this.props.model + '">.'));

          return this.createControlComponent(renderableChildren);
        }

        return _react2.default.createElement(component, allowedProps, this.mapChildrenToControl(renderableChildren));
      }
    }]);

    return Field;
  }(_react.Component);

  if (false) {
    process.env.NODE_ENV !== "production" ? Field.propTypes = fieldPropTypes : void 0;
  }

  Field.defaultProps = {
    updateOn: 'change',
    asyncValidateOn: 'blur',
    parser: _identity2.default,
    formatter: _identity2.default,
    changeAction: _actions2.default.change,
    dynamic: true,
    component: 'div'
  };

  return (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Field));
}

exports.controlPropsMap = _controlPropsMap3.default;
exports.createFieldClass = createFieldClass;
exports.default = createFieldClass(_controlPropsMap3.default);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pick;
function pick(object, props) {
  var result = {};

  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    result[prop] = object[prop];
  }

  return result;
}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createControlClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(24);

var _redux = __webpack_require__(40);

var _identity = __webpack_require__(48);

var _identity2 = _interopRequireDefault(_identity);

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _merge = __webpack_require__(341);

var _merge2 = _interopRequireDefault(_merge);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _icepick = __webpack_require__(33);

var _icepick2 = _interopRequireDefault(_icepick);

var _omit = __webpack_require__(49);

var _omit2 = _interopRequireDefault(_omit);

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _debounce = __webpack_require__(342);

var _debounce2 = _interopRequireDefault(_debounce);

var _getValue2 = __webpack_require__(78);

var _getValue3 = _interopRequireDefault(_getValue2);

var _getValidity = __webpack_require__(105);

var _getValidity2 = _interopRequireDefault(_getValidity);

var _invertValidity = __webpack_require__(107);

var _invertValidity2 = _interopRequireDefault(_invertValidity);

var _getModel = __webpack_require__(59);

var _getModel2 = _interopRequireDefault(_getModel);

var _persistEventWithCallback = __webpack_require__(343);

var _persistEventWithCallback2 = _interopRequireDefault(_persistEventWithCallback);

var _actions = __webpack_require__(47);

var _actions2 = _interopRequireDefault(_actions);

var _controlPropsMap = __webpack_require__(108);

var _controlPropsMap2 = _interopRequireDefault(_controlPropsMap);

var _validityKeys = __webpack_require__(344);

var _validityKeys2 = _interopRequireDefault(_validityKeys);

var _batchActions = __webpack_require__(103);

var _resolveModel = __webpack_require__(81);

var _resolveModel2 = _interopRequireDefault(_resolveModel);

var _isNative = __webpack_require__(345);

var _isNative2 = _interopRequireDefault(_isNative);

var _initialFieldState = __webpack_require__(34);

var _initialFieldState2 = _interopRequireDefault(_initialFieldState);

var _containsEvent = __webpack_require__(189);

var _containsEvent2 = _interopRequireDefault(_containsEvent);

var _controlStripDefaultsComponent = __webpack_require__(346);

var _controlStripDefaultsComponent2 = _interopRequireDefault(_controlStripDefaultsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var disallowedProps = ['changeAction', 'getFieldFromState', 'store'];

function mergeOrSetErrors(model, errors, options) {
  return _actions2.default.setErrors(model, errors, _extends({
    merge: (0, _isPlainObject.isObjectLike)(errors)
  }, options));
}

var propTypes = {
  model: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
  modelValue: _propTypes2.default.any,
  viewValue: _propTypes2.default.any,
  defaultValue: _propTypes2.default.any,
  control: _propTypes2.default.any,
  onLoad: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  fieldValue: _propTypes2.default.object,
  mapProps: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  changeAction: _propTypes2.default.func,
  updateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  validateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  validators: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  asyncValidateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  asyncValidators: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  errors: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  controlProps: _propTypes2.default.object,
  component: _propTypes2.default.any,
  dispatch: _propTypes2.default.func,
  parser: _propTypes2.default.func,
  formatter: _propTypes2.default.func,
  ignore: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  dynamic: _propTypes2.default.bool,
  store: _propTypes2.default.shape({
    subscribe: _propTypes2.default.func,
    dispatch: _propTypes2.default.func,
    getState: _propTypes2.default.func
  }),
  getRef: _propTypes2.default.func,
  withField: _propTypes2.default.bool,
  debounce: _propTypes2.default.number,
  persist: _propTypes2.default.bool,
  getValue: _propTypes2.default.func,
  isToggle: _propTypes2.default.bool,
  updateOnEnter: _propTypes2.default.bool,
  render: _propTypes2.default.func,

  // HTML5 attributes
  formNoValidate: _propTypes2.default.bool
};

var htmlAttributes = ['formNoValidate'];
var disallowedPropTypeKeys = Object.keys(propTypes).filter(function (key) {
  return htmlAttributes.indexOf(key) === -1;
});

function createControlClass(s) {
  var emptyControlProps = {};
  var emptyMapProps = {};

  var Control = function (_Component) {
    _inherits(Control, _Component);

    function Control(props) {
      _classCallCheck(this, Control);

      var _this = _possibleConstructorReturn(this, (Control.__proto__ || Object.getPrototypeOf(Control)).call(this, props));

      _this.getChangeAction = _this.getChangeAction.bind(_this);
      _this.getValidateAction = _this.getValidateAction.bind(_this);

      _this.handleKeyPress = _this.handleKeyPress.bind(_this);
      _this.createEventHandler = _this.createEventHandler.bind(_this);
      _this.handleFocus = _this.createEventHandler('focus').bind(_this);
      _this.handleBlur = _this.createEventHandler('blur').bind(_this);
      _this.handleUpdate = _this.createEventHandler('change').bind(_this);
      _this.forceHandleUpdate = _this.createEventHandler('change', true).bind(_this);
      _this.handleChange = _this.handleChange.bind(_this);
      _this.handleLoad = _this.handleLoad.bind(_this);
      _this.getMappedProps = _this.getMappedProps.bind(_this);
      _this.getRenderProps = _this.getRenderProps.bind(_this);
      _this.attachNode = _this.attachNode.bind(_this);

      if (props.debounce) {
        _this.handleUpdate = (0, _debounce2.default)(_this.handleUpdate, props.debounce);
        var oldHandleBlur = _this.handleBlur;
        _this.handleBlur = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this.handleUpdate.flush();
          oldHandleBlur.call.apply(oldHandleBlur, [_this].concat(args));
        };
      }

      _this.willValidate = false;

      _this.state = {
        viewValue: _this.format(props.modelValue)
      };
      return _this;
    }

    _createClass(Control, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.attachNode();
        this.handleLoad();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(_ref) {
        var modelValue = _ref.modelValue;

        if (modelValue !== this.props.modelValue) {
          this.setViewValue(modelValue);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !(0, _shallowEqual2.default)(this.props, nextProps, {
          deepKeys: ['controlProps'],
          omitKeys: ['mapProps']
        }) || !(0, _shallowEqual2.default)(this.state.viewValue, nextState.viewValue);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.handleIntents();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props = this.props,
            model = _props.model,
            fieldValue = _props.fieldValue,
            dispatch = _props.dispatch,
            _props$validators = _props.validators,
            validators = _props$validators === undefined ? {} : _props$validators,
            _props$errors = _props.errors,
            errors = _props$errors === undefined ? {} : _props$errors,
            persist = _props.persist;


        if (!persist && fieldValue && !fieldValue.valid) {
          var keys = Object.keys(validators).concat(Object.keys(errors), this.willValidate ? _validityKeys2.default : []);

          dispatch(_actions2.default.resetValidity(model, keys));
        }

        // flush debounced model changes
        if (this.handleUpdate.flush) {
          this.handleUpdate.flush();
        }
      }
    }, {
      key: 'getRenderProps',
      value: function getRenderProps() {
        var props = this.props;
        var viewValue = this.state.viewValue;

        return {
          modelValue: props.modelValue,
          fieldValue: props.fieldValue,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onKeyPress: this.handleKeyPress,
          viewValue: viewValue
        };
      }
    }, {
      key: 'getMappedProps',
      value: function getMappedProps() {
        var props = this.props;
        var mapProps = props.mapProps;
        var viewValue = this.state.viewValue;

        var originalProps = _extends({}, props, props.controlProps, {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onKeyPress: this.handleKeyPress,
          viewValue: viewValue
        });

        if ((0, _isPlainObject2.default)(mapProps)) {
          return (0, _mapValues2.default)(mapProps, function (value, key) {
            if (typeof value === 'function' && key !== 'component') {
              return value(originalProps);
            }

            return value;
          });
        } else if (typeof mapProps === 'function') {
          return mapProps(originalProps);
        }

        return emptyMapProps;
      }
    }, {
      key: 'getChangeAction',
      value: function getChangeAction(event) {
        return this.props.changeAction(this.props.model, this.getValue(event), {
          currentValue: this.props.modelValue,
          external: false
        });
      }
    }, {
      key: 'getValidateAction',
      value: function getValidateAction(value, eventName) {
        var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var _props2 = this.props,
            validators = _props2.validators,
            errors = _props2.errors,
            model = _props2.model,
            modelValue = _props2.modelValue,
            updateOn = _props2.updateOn,
            fieldValue = _props2.fieldValue;


        if (!validators && !errors && !this.willValidate) return false;

        var nodeErrors = this.getNodeErrors();

        // If it is not a change event, use the model value.
        var valueToValidate = forceUpdate || (0, _containsEvent2.default)(updateOn, eventName) ? value : modelValue;

        if (validators || errors) {
          var fieldValidity = (0, _getValidity2.default)(validators, valueToValidate);
          var fieldErrors = (0, _merge2.default)((0, _getValidity2.default)(errors, valueToValidate), nodeErrors);

          var mergedErrors = validators ? (0, _merge2.default)((0, _invertValidity2.default)(fieldValidity), fieldErrors) : fieldErrors;

          if (!fieldValue || !(0, _shallowEqual2.default)(mergedErrors, fieldValue.errors)) {
            return mergeOrSetErrors(model, mergedErrors);
          }
        } else if (nodeErrors && Object.keys(nodeErrors).length) {
          return mergeOrSetErrors(model, nodeErrors);
        }

        return false;
      }
    }, {
      key: 'getAsyncValidateAction',
      value: function getAsyncValidateAction(value, eventName) {
        var _this2 = this;

        var _props3 = this.props,
            asyncValidators = _props3.asyncValidators,
            fieldValue = _props3.fieldValue,
            model = _props3.model,
            modelValue = _props3.modelValue,
            updateOn = _props3.updateOn,
            _props3$validateOn = _props3.validateOn,
            validateOn = _props3$validateOn === undefined ? updateOn : _props3$validateOn,
            asyncValidateOn = _props3.asyncValidateOn,
            dispatch = _props3.dispatch,
            getValue = _props3.getValue;

        // If there are no async validators,
        // do not run async validation

        if (!asyncValidators) return false;

        // If it is not a change event, use the model value.
        var valueToValidate = (0, _containsEvent2.default)(updateOn, eventName) ? value : modelValue;

        // If any sync validity is invalid,
        // do not run async validation
        // unless sync and async validation occur simultaneously
        if (validateOn !== asyncValidateOn) {
          var asyncValidatorKeys = Object.keys(asyncValidators);
          var syncValid = Object.keys(fieldValue.validity).every(function (key) {
            // If validity is based on async validator, skip
            if (!!~asyncValidatorKeys.indexOf(key)) return true;

            return fieldValue.validity[key];
          });

          if (!syncValid) return false;
        }

        dispatch(_actions2.default.setValidating(model, true));

        (0, _mapValues2.default)(asyncValidators, function (validator, key) {
          var outerDone = function outerDone(valid) {
            // get current fieldValue as another validator may have already been processed.
            var currentFieldValue = _this2.props.fieldValue;
            var validity = _icepick2.default.merge(currentFieldValue.validity, _defineProperty({}, key, valid));

            dispatch(_actions2.default.setValidity(model, validity));
          };

          validator(getValue(valueToValidate, _this2.props), outerDone);
        });

        return valueToValidate;
      }
    }, {
      key: 'getNodeErrors',
      value: function getNodeErrors() {
        var node = this.node,
            _props4 = this.props,
            fieldValue = _props4.fieldValue,
            formNoValidate = _props4.formNoValidate;


        if (formNoValidate || !node || node && !node.willValidate) {
          this.willValidate = false;
          return null;
        }

        this.willValidate = true;

        var nodeErrors = {};

        _validityKeys2.default.forEach(function (key) {
          var errorValidity = node.validity[key];

          // If the key is invalid or they key was
          // previously invalid and is now valid,
          // set its validity
          if (errorValidity || fieldValue && fieldValue.errors[key]) {
            nodeErrors[key] = errorValidity;
          }
        });

        return nodeErrors;
      }
    }, {
      key: 'setViewValue',
      value: function setViewValue(viewValue) {
        if (!this.props.isToggle) {
          if (this.props.formatter) {
            var parsedValue = this.parse(viewValue);
            this.setState({ viewValue: this.format(parsedValue) });
          } else {
            this.setState({ viewValue: this.parse(viewValue) });
          }
        }
      }
    }, {
      key: 'getValue',
      value: function getValue(event) {
        return this.props.getValue(event, this.props);
      }
    }, {
      key: 'handleIntents',
      value: function handleIntents() {
        var _this3 = this;

        var _props5 = this.props,
            model = _props5.model,
            modelValue = _props5.modelValue,
            fieldValue = _props5.fieldValue,
            intents = _props5.fieldValue.intents,
            controlProps = _props5.controlProps,
            dispatch = _props5.dispatch,
            updateOn = _props5.updateOn,
            _props5$validateOn = _props5.validateOn,
            validateOn = _props5$validateOn === undefined ? updateOn : _props5$validateOn;


        if (!Array.isArray(intents) || !intents.length) return;

        intents.forEach(function (intent) {
          switch (intent.type) {
            case _actionTypes2.default.FOCUS:
              {
                if (_isNative2.default) return;

                var focused = fieldValue.focus;

                if (focused && _this3.node.focus && (!_this3.props.isToggle || typeof intent.value === 'undefined' || intent.value === controlProps.value)) {
                  _this3.node.focus();

                  dispatch(_actions2.default.clearIntents(model, intent));
                }

                return;
              }
            case 'validate':
              if ((0, _containsEvent2.default)(validateOn, 'change')) {
                _this3.validate({ clearIntents: intent });
              }
              return;
            case 'reset':
              _this3.setViewValue(modelValue);
              if (_this3.handleUpdate.cancel) {
                _this3.handleUpdate.cancel();
              }
              dispatch(_actions2.default.clearIntents(model, intent));
              if ((0, _containsEvent2.default)(validateOn, 'change')) {
                _this3.validate({});
              }
              return;

            case 'load':
              if (!(0, _shallowEqual2.default)(modelValue, fieldValue.value)) {
                dispatch(_actions2.default.load(model, fieldValue.value, { clearIntents: intent }));
              }
              return;

            default:
              return;
          }
        });
      }
    }, {
      key: 'parse',
      value: function parse(value) {
        return this.props.parser ? this.props.parser(value) : value;
      }
    }, {
      key: 'format',
      value: function format(value) {
        return this.props.formatter ? this.props.formatter(value) : value;
      }
    }, {
      key: 'handleChange',
      value: function handleChange(event) {
        if (event && event.persist) event.persist();

        this.setViewValue(this.getValue(event));
        this.handleUpdate(event);
      }
    }, {
      key: 'handleKeyPress',
      value: function handleKeyPress(event) {
        var _props6 = this.props,
            onKeyPress = _props6.controlProps.onKeyPress,
            updateOnEnter = _props6.updateOnEnter;


        if (onKeyPress) onKeyPress(event);

        if (updateOnEnter && event.key === 'Enter') {
          this.forceHandleUpdate(event);
        }
      }
    }, {
      key: 'handleLoad',
      value: function handleLoad() {
        var _props7 = this.props,
            model = _props7.model,
            modelValue = _props7.modelValue,
            fieldValue = _props7.fieldValue,
            controlProps = _props7.controlProps,
            onLoad = _props7.onLoad,
            dispatch = _props7.dispatch,
            changeAction = _props7.changeAction,
            parser = _props7.parser;

        var defaultValue = undefined;

        if (controlProps.hasOwnProperty('defaultValue')) {
          defaultValue = controlProps.defaultValue;
        } else if (controlProps.hasOwnProperty('defaultChecked')) {
          defaultValue = controlProps.defaultChecked;
        } else if (this.props.hasOwnProperty('defaultValue')) {
          defaultValue = this.props.defaultValue;
        }

        var loadActions = [this.getValidateAction(defaultValue)];

        if (typeof defaultValue !== 'undefined') {
          loadActions.push(changeAction(model, defaultValue));
        } else {
          if (parser) {
            var parsedValue = parser(modelValue);

            if (parsedValue !== modelValue) {
              loadActions.push(changeAction(model, parsedValue));
            }
          }
        }

        (0, _batchActions.dispatchBatchIfNeeded)(model, loadActions, dispatch);

        if (onLoad) onLoad(modelValue, fieldValue, this.node);
      }
    }, {
      key: 'createEventHandler',
      value: function createEventHandler(eventName) {
        var _this4 = this;

        var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var eventAction = {
          focus: _actions2.default.silentFocus,
          blur: _actions2.default.blur
        }[eventName];

        var dispatchBatchActions = function dispatchBatchActions(persistedEvent) {
          var _props8 = _this4.props,
              dispatch = _props8.dispatch,
              model = _props8.model,
              updateOn = _props8.updateOn,
              _props8$validateOn = _props8.validateOn,
              validateOn = _props8$validateOn === undefined ? updateOn : _props8$validateOn,
              asyncValidateOn = _props8.asyncValidateOn;


          var eventActions = [eventAction && eventAction(model), (forceUpdate || (0, _containsEvent2.default)(validateOn, eventName)) && _this4.getValidateAction(persistedEvent, eventName, forceUpdate), (forceUpdate || (0, _containsEvent2.default)(asyncValidateOn, eventName)) && _this4.getAsyncValidateAction(persistedEvent, eventName), (forceUpdate || (0, _containsEvent2.default)(updateOn, eventName)) && _this4.getChangeAction(persistedEvent)];

          (0, _batchActions.dispatchBatchIfNeeded)(model, eventActions, dispatch);

          return persistedEvent;
        };

        return function (event) {
          var _props9 = _this4.props,
              controlProps = _props9.controlProps,
              parser = _props9.parser,
              ignore = _props9.ignore,
              withField = _props9.withField,
              fieldValue = _props9.fieldValue;


          var controlEventHandler = {
            focus: controlProps.onFocus,
            blur: controlProps.onBlur,
            change: controlProps.onChange
          }[eventName];

          if ((0, _containsEvent2.default)(ignore, eventName)) {
            return controlEventHandler ? controlEventHandler(event) : event;
          }

          if (_this4.props.isToggle) {
            return (0, _redux.compose)(dispatchBatchActions, (0, _persistEventWithCallback2.default)(controlEventHandler || _identity2.default))(event);
          }

          return (0, _redux.compose)(dispatchBatchActions, parser, function (e) {
            return _this4.getValue(e);
          }, (0, _persistEventWithCallback2.default)(controlEventHandler || _identity2.default))(event, withField ? fieldValue : undefined);
        };
      }
    }, {
      key: 'attachNode',
      value: function attachNode() {
        var node = s.findDOMNode && s.findDOMNode(this);

        if (node) {
          this.node = node;
          this.willValidate = node.willValidate;
        }
      }
    }, {
      key: 'validate',
      value: function validate(options) {
        var _props10 = this.props,
            model = _props10.model,
            modelValue = _props10.modelValue,
            fieldValue = _props10.fieldValue,
            validators = _props10.validators,
            errorValidators = _props10.errors,
            dispatch = _props10.dispatch;


        if (!validators && !errorValidators && !this.willValidate || !fieldValue) {
          return;
        }

        var fieldValidity = (0, _getValidity2.default)(validators, modelValue);
        var fieldErrors = (0, _getValidity2.default)(errorValidators, modelValue);
        var nodeErrors = this.getNodeErrors();

        var errors = validators ? (0, _merge2.default)((0, _invertValidity2.default)(fieldValidity), fieldErrors) : fieldErrors;

        if (this.willValidate) {
          errors = (0, _merge2.default)(errors, nodeErrors);
        }

        if (!(0, _shallowEqual2.default)(errors, fieldValue.errors)) {
          dispatch(mergeOrSetErrors(model, errors, options));
        } else if (options.clearIntents) {
          dispatch(_actions2.default.clearIntents(model, options.clearIntents));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props11 = this.props,
            render = _props11.render,
            controlProps = _props11.controlProps,
            component = _props11.component,
            control = _props11.control,
            getRef = _props11.getRef,
            fieldValue = _props11.fieldValue;


        if (render) {
          return render(this.getRenderProps());
        }

        var mappedProps = (0, _omit2.default)(this.getMappedProps(), disallowedProps);

        if (getRef) {
          mappedProps.getRef = getRef;
        }

        if (controlProps.withFieldValue) {
          mappedProps.fieldValue = fieldValue;
        }

        // If there is an existing control, clone it
        if (control) {
          return (0, _react.cloneElement)(control, _extends({}, mappedProps, {
            defaultValue: undefined,
            defaultChecked: undefined
          }), controlProps.children);
        }
        return (0, _react.createElement)(_controlStripDefaultsComponent2.default, _extends({
          component: component
        }, controlProps, mappedProps));
      }
    }]);

    return Control;
  }(_react.Component);

  Control.displayName = 'Control';

   false ? Control.propTypes = propTypes : void 0;

  Control.defaultProps = {
    changeAction: s.actions.change,
    updateOn: 'change',
    asyncValidateOn: 'blur',
    parser: _identity2.default,
    controlProps: emptyControlProps,
    ignore: [],
    dynamic: false,
    component: 'input',
    withField: true,
    persist: false,
    getValue: _getValue3.default,
    isToggle: false,
    updateOnEnter: true
  };

  function mapStateToProps(state, props) {
    var model = props.model,
        controlProps = props.controlProps;


    var finalControlProps = _extends({}, controlProps, (0, _omit2.default)(props, disallowedPropTypeKeys));

    var modelString = (0, _getModel2.default)(model, state);
    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;
    var modelValue = s.get(state, modelString);

    return {
      model: modelString,
      modelValue: modelValue,
      fieldValue: fieldValue,
      controlProps: finalControlProps
    };
  }

  var ConnectedControl = (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps, null, null, {
    areOwnPropsEqual: function areOwnPropsEqual(nextOwnProps, ownProps) {
      return (0, _shallowEqual2.default)(nextOwnProps, ownProps, {
        omitKeys: ['mapProps']
      });
    },
    areStatePropsEqual: function areStatePropsEqual(nextStateProps, stateProps) {
      return (0, _shallowEqual2.default)(nextStateProps, stateProps, {
        deepKeys: ['controlProps']
      });
    }
  })(Control));

  /* eslint-disable react/prop-types */
  /* eslint-disable react/no-multi-comp */

  var DefaultConnectedControl = function (_React$Component) {
    _inherits(DefaultConnectedControl, _React$Component);

    function DefaultConnectedControl() {
      _classCallCheck(this, DefaultConnectedControl);

      return _possibleConstructorReturn(this, (DefaultConnectedControl.__proto__ || Object.getPrototypeOf(DefaultConnectedControl)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControl, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
        return !(0, _shallowEqual2.default)(this.context, nextContext) || !(0, _shallowEqual2.default)(this.props, nextProps, {
          deepKeys: ['controlProps'],
          omitKeys: ['mapProps']
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({}, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.default, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControl;
  }(_react2.default.Component);

  // Copy the context types so that we can properly implement shouldComponentUpdate


  DefaultConnectedControl.contextTypes = ConnectedControl.contextTypes;

  DefaultConnectedControl.custom = ConnectedControl;

  var DefaultConnectedControlInput = function (_DefaultConnectedCont) {
    _inherits(DefaultConnectedControlInput, _DefaultConnectedCont);

    function DefaultConnectedControlInput() {
      _classCallCheck(this, DefaultConnectedControlInput);

      return _possibleConstructorReturn(this, (DefaultConnectedControlInput.__proto__ || Object.getPrototypeOf(DefaultConnectedControlInput)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlInput, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'input'
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.default, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlInput;
  }(DefaultConnectedControl);

  DefaultConnectedControl.input = DefaultConnectedControlInput;

  var DefaultConnectedControlText = function (_DefaultConnectedCont2) {
    _inherits(DefaultConnectedControlText, _DefaultConnectedCont2);

    function DefaultConnectedControlText() {
      _classCallCheck(this, DefaultConnectedControlText);

      return _possibleConstructorReturn(this, (DefaultConnectedControlText.__proto__ || Object.getPrototypeOf(DefaultConnectedControlText)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlText, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'input'
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.text, {
            type: this.props.type || 'text'
          }, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlText;
  }(DefaultConnectedControl);

  DefaultConnectedControl.text = DefaultConnectedControlText;

  var DefaultConnectedControlPassword = function (_DefaultConnectedCont3) {
    _inherits(DefaultConnectedControlPassword, _DefaultConnectedCont3);

    function DefaultConnectedControlPassword() {
      _classCallCheck(this, DefaultConnectedControlPassword);

      return _possibleConstructorReturn(this, (DefaultConnectedControlPassword.__proto__ || Object.getPrototypeOf(DefaultConnectedControlPassword)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlPassword, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'input'
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.text, {
            type: this.props.type || 'password'
          }, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlPassword;
  }(DefaultConnectedControl);

  DefaultConnectedControl.password = DefaultConnectedControlPassword;

  var DefaultConnectedControlTextArea = function (_DefaultConnectedCont4) {
    _inherits(DefaultConnectedControlTextArea, _DefaultConnectedCont4);

    function DefaultConnectedControlTextArea() {
      _classCallCheck(this, DefaultConnectedControlTextArea);

      return _possibleConstructorReturn(this, (DefaultConnectedControlTextArea.__proto__ || Object.getPrototypeOf(DefaultConnectedControlTextArea)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlTextArea, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'textarea',
          updateOnEnter: false
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.textarea, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlTextArea;
  }(DefaultConnectedControl);

  DefaultConnectedControl.textarea = DefaultConnectedControlTextArea;

  var DefaultConnectedControlRadio = function (_DefaultConnectedCont5) {
    _inherits(DefaultConnectedControlRadio, _DefaultConnectedCont5);

    function DefaultConnectedControlRadio() {
      _classCallCheck(this, DefaultConnectedControlRadio);

      return _possibleConstructorReturn(this, (DefaultConnectedControlRadio.__proto__ || Object.getPrototypeOf(DefaultConnectedControlRadio)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlRadio, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'input',
          type: 'radio',
          isToggle: true
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.radio, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlRadio;
  }(DefaultConnectedControl);

  DefaultConnectedControl.radio = DefaultConnectedControlRadio;

  var DefaultConnectedControlCheckbox = function (_DefaultConnectedCont6) {
    _inherits(DefaultConnectedControlCheckbox, _DefaultConnectedCont6);

    function DefaultConnectedControlCheckbox() {
      _classCallCheck(this, DefaultConnectedControlCheckbox);

      return _possibleConstructorReturn(this, (DefaultConnectedControlCheckbox.__proto__ || Object.getPrototypeOf(DefaultConnectedControlCheckbox)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlCheckbox, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'input',
          type: 'checkbox',
          isToggle: true
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.checkbox, this.props.mapProps),
          getValue: _getValue2.getCheckboxValue,
          changeAction: this.props.changeAction || s.actions.checkWithValue
        }));
      }
    }]);

    return DefaultConnectedControlCheckbox;
  }(DefaultConnectedControl);

  DefaultConnectedControl.checkbox = DefaultConnectedControlCheckbox;

  var DefaultConnectedControlFile = function (_DefaultConnectedCont7) {
    _inherits(DefaultConnectedControlFile, _DefaultConnectedCont7);

    function DefaultConnectedControlFile() {
      _classCallCheck(this, DefaultConnectedControlFile);

      return _possibleConstructorReturn(this, (DefaultConnectedControlFile.__proto__ || Object.getPrototypeOf(DefaultConnectedControlFile)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlFile, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'input',
          type: 'file'
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.file, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlFile;
  }(DefaultConnectedControl);

  DefaultConnectedControl.file = DefaultConnectedControlFile;

  var DefaultConnectedControlSelect = function (_DefaultConnectedCont8) {
    _inherits(DefaultConnectedControlSelect, _DefaultConnectedCont8);

    function DefaultConnectedControlSelect() {
      _classCallCheck(this, DefaultConnectedControlSelect);

      return _possibleConstructorReturn(this, (DefaultConnectedControlSelect.__proto__ || Object.getPrototypeOf(DefaultConnectedControlSelect)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlSelect, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'select'
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.select, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlSelect;
  }(DefaultConnectedControl);

  DefaultConnectedControl.select = DefaultConnectedControlSelect;

  var DefaultConnectedControlButton = function (_DefaultConnectedCont9) {
    _inherits(DefaultConnectedControlButton, _DefaultConnectedCont9);

    function DefaultConnectedControlButton() {
      _classCallCheck(this, DefaultConnectedControlButton);

      return _possibleConstructorReturn(this, (DefaultConnectedControlButton.__proto__ || Object.getPrototypeOf(DefaultConnectedControlButton)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlButton, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'button'
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.button, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlButton;
  }(DefaultConnectedControl);

  DefaultConnectedControl.button = DefaultConnectedControlButton;

  var DefaultConnectedControlReset = function (_DefaultConnectedCont10) {
    _inherits(DefaultConnectedControlReset, _DefaultConnectedCont10);

    function DefaultConnectedControlReset() {
      _classCallCheck(this, DefaultConnectedControlReset);

      return _possibleConstructorReturn(this, (DefaultConnectedControlReset.__proto__ || Object.getPrototypeOf(DefaultConnectedControlReset)).apply(this, arguments));
    }

    _createClass(DefaultConnectedControlReset, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ConnectedControl, _extends({
          component: 'button',
          type: 'reset'
        }, this.props, {
          mapProps: _extends({}, _controlPropsMap2.default.reset, this.props.mapProps)
        }));
      }
    }]);

    return DefaultConnectedControlReset;
  }(DefaultConnectedControl);

  DefaultConnectedControl.reset = DefaultConnectedControlReset;

  return DefaultConnectedControl;
}

exports.createControlClass = createControlClass;
exports.default = createControlClass;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mergeDeep;

var _icepick = __webpack_require__(33);

var _icepick2 = _interopRequireDefault(_icepick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeDeep(target, source) {
  return _icepick2.default.merge(target, source);
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, delay) {
  var timeout = void 0;
  var laterFunc = void 0;

  var createLaterFunc = function createLaterFunc(args) {
    return function () {
      timeout = null;
      func.apply(null, args);

      // Only run the deferred function once
      laterFunc = undefined;
    };
  };

  var debouncedFunc = function debouncedFunc() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout);
    laterFunc = createLaterFunc(args);
    timeout = setTimeout(laterFunc, delay);
  };

  debouncedFunc.flush = function () {
    clearTimeout(timeout);
    if (laterFunc) laterFunc();
  };

  debouncedFunc.cancel = function () {
    clearTimeout(timeout);
    laterFunc = undefined;
  };

  return debouncedFunc;
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = persistEventWithCallback;
function persistEventWithCallback(callback) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (event && event.persist) {
      event.persist();
    }

    callback.apply(undefined, [event].concat(args));
    return event;
  };
}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var validityKeys = ['badInput', 'customError', 'patternMismatch', 'rangeOverflow', 'rangeUnderflow', 'stepMismatch', 'tooLong', 'tooShort', 'typeMismatch', 'valueMissing'];

exports.default = validityKeys;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

exports.default = isReactNative;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Prevents the defaultValue/defaultChecked fields from rendering with value/checked
var ComponentWrapper = function (_Component) {
  _inherits(ComponentWrapper, _Component);

  function ComponentWrapper() {
    _classCallCheck(this, ComponentWrapper);

    return _possibleConstructorReturn(this, (ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).apply(this, arguments));
  }

  _createClass(ComponentWrapper, [{
    key: 'render',
    value: function render() {
      /* eslint-disable no-unused-vars */
      var _props = this.props,
          defaultValue = _props.defaultValue,
          defaultChecked = _props.defaultChecked,
          component = _props.component,
          getRef = _props.getRef,
          otherProps = _objectWithoutProperties(_props, ['defaultValue', 'defaultChecked', 'component', 'getRef']);
      /* eslint-enable */

      if (getRef) {
        otherProps.ref = getRef;
      }
      var WrappedComponent = component;
      return _react2.default.createElement(WrappedComponent, otherProps);
    }
  }]);

  return ComponentWrapper;
}(_react.Component);

 false ? ComponentWrapper.propTypes = {
  component: _propTypes2.default.any,
  defaultValue: _propTypes2.default.any,
  defaultChecked: _propTypes2.default.any,
  getRef: _propTypes2.default.func
} : void 0;
exports.default = ComponentWrapper;

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) return true;
  }for (var _i in b) {
    if (a[_i] !== b[_i]) return true;
  }return false;
}

/* harmony default export */ __webpack_exports__["default"] = (function (instance, nextProps, nextState) {
  return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shallowCompareWithoutChildren;

var _react = __webpack_require__(0);

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shallowCompareWithoutChildren(instance, nextProps) {
  return !(0, _shallowEqual2.default)(instance.props, nextProps, { omitKeys: ['children'] }) || _react.Children.count(instance.props.children) !== _react.Children.count(nextProps.children);
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(24);

var _getModel = __webpack_require__(59);

var _getModel2 = _interopRequireDefault(_getModel);

var _omit = __webpack_require__(49);

var _omit2 = _interopRequireDefault(_omit);

var _resolveModel = __webpack_require__(81);

var _resolveModel2 = _interopRequireDefault(_resolveModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  model: _propTypes2.default.string.isRequired,
  component: _propTypes2.default.any,
  dispatch: _propTypes2.default.func,
  store: _propTypes2.default.shape({
    subscribe: _propTypes2.default.func,
    dispatch: _propTypes2.default.func,
    getState: _propTypes2.default.func
  }),
  storeSubscription: _propTypes2.default.any
};

var Fieldset = function (_Component) {
  _inherits(Fieldset, _Component);

  function Fieldset() {
    _classCallCheck(this, Fieldset);

    return _possibleConstructorReturn(this, (Fieldset.__proto__ || Object.getPrototypeOf(Fieldset)).apply(this, arguments));
  }

  _createClass(Fieldset, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { model: this.props.model };
    }
  }, {
    key: 'render',
    value: function render() {
      var component = this.props.component;


      var allowedProps = (0, _omit2.default)(this.props, Object.keys(propTypes));

      return _react2.default.createElement(component, allowedProps);
    }
  }]);

  return Fieldset;
}(_react.Component);

Fieldset.displayName = 'Fieldset';

Fieldset.childContextTypes = {
  model: _propTypes2.default.any
};

 false ? Fieldset.propTypes = propTypes : void 0;

Fieldset.defaultProps = {
  component: 'div'
};

function mapStateToProps(state, _ref) {
  var model = _ref.model;

  var modelString = (0, _getModel2.default)(model, state);

  return {
    model: modelString
  };
}

exports.default = (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Fieldset));

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invertValidators;

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _invertValidity = __webpack_require__(107);

var _invertValidity2 = _interopRequireDefault(_invertValidity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function invertValidators(validators) {
  if (typeof validators === 'function') {
    return function (val) {
      return (0, _invertValidity2.default)(validators(val));
    };
  }

  return (0, _mapValues2.default)(validators, invertValidators);
}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getField;

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _initialFieldState = __webpack_require__(34);

var _initialFieldState2 = _interopRequireDefault(_initialFieldState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getField(state, path) {
  if (false) {
    if (!(0, _isPlainObject2.default)(state)) {
      throw new Error('Could not retrieve field \'' + path + '\' ' + 'from an invalid/empty form state.');
    }
  }

  var result = (0, _get2.default)(state, path, _initialFieldState2.default);

  if ('$form' in result) return result.$form;

  return result;
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formComponent = __webpack_require__(191);

var _formComponent2 = _interopRequireDefault(_formComponent);

var _formsReducer = __webpack_require__(193);

var _formsReducer2 = _interopRequireDefault(_formsReducer);

var _redux = __webpack_require__(40);

var _omit = __webpack_require__(49);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocalForm = function (_React$Component) {
  _inherits(LocalForm, _React$Component);

  function LocalForm(props) {
    _classCallCheck(this, LocalForm);

    var _this = _possibleConstructorReturn(this, (LocalForm.__proto__ || Object.getPrototypeOf(LocalForm)).call(this, props));

    _this.store = props.store || (0, _redux.createStore)((0, _formsReducer2.default)(_defineProperty({}, props.model, props.initialState)));

    _this.dispatch = function (action) {
      if (typeof action === 'function') {
        return action(_this.store.dispatch, _this.store.getState);
      }

      return _this.store.dispatch(action);
    };
    return _this;
  }

  _createClass(LocalForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.getDispatch) {
        this.props.getDispatch(this.dispatch);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var allowedProps = (0, _omit2.default)(this.props, ['store', 'initialState']);

      return _react2.default.createElement(_formComponent2.default, _extends({ store: this.store }, allowedProps));
    }
  }]);

  return LocalForm;
}(_react2.default.Component);

LocalForm.displayName = 'LocalForm';

 false ? LocalForm.propTypes = {
  store: _propTypes2.default.shape({
    subscribe: _propTypes2.default.func,
    dispatch: _propTypes2.default.func,
    getState: _propTypes2.default.func
  }),

  // provided props
  initialState: _propTypes2.default.any,
  model: _propTypes2.default.string.isRequired,
  getDispatch: _propTypes2.default.func
} : void 0;

LocalForm.defaultProps = {
  initialState: {},
  model: 'local'
};

exports.default = LocalForm;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compose;
function compose() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (state, action) {
    return reducers.reduceRight(function (prevState, reducer) {
      return reducer(prevState, action);
    }, state);
  };
}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = changeActionReducer;

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _icepick = __webpack_require__(33);

var _icepick2 = _interopRequireDefault(_icepick);

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _formReducer = __webpack_require__(82);

var _initialFieldState = __webpack_require__(34);

var _initialFieldState2 = _interopRequireDefault(_initialFieldState);

var _assocIn = __webpack_require__(61);

var _assocIn2 = _interopRequireDefault(_assocIn);

var _getFormValue = __webpack_require__(196);

var _getFormValue2 = _interopRequireDefault(_getFormValue);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateFieldValue(field, action) {
  var parentModel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var value = action.value,
      removeKeys = action.removeKeys,
      silent = action.silent,
      load = action.load,
      model = action.model,
      external = action.external;


  var fieldState = field && field.$form ? field.$form : field;

  var changedFieldProps = {
    validated: false,
    retouched: fieldState.submitted ? true : fieldState.retouched,
    // If change originated from Control component (not externally),
    // then there is no need to remind Control to validate itself.
    intents: external ? [{ type: 'validate' }] : [],
    pristine: silent ? fieldState.pristine : false,
    value: value,
    loadedValue: load ? value : fieldState.loadedValue
  };

  if ((0, _shallowEqual2.default)(field.value, value)) {
    return _icepick2.default.merge(field, changedFieldProps);
  }

  if (removeKeys) {
    (0, _invariant2.default)(field && field.$form, 'Unable to remove keys. ' + 'Field for "%s" in store is not an array/object.', model);

    var valueIsArray = Array.isArray(field.$form.value);
    var removeKeysArray = Array.isArray(removeKeys) ? removeKeys : [removeKeys];

    var result = void 0;

    if (valueIsArray) {
      result = [];

      Object.keys(field).forEach(function (key) {
        if (!!~removeKeysArray.indexOf(+key) || key === '$form') return;

        result[key] = _extends({}, field[key]);
      });

      var finalResult = _extends({}, result.filter(function (f) {
        return f;
      }).map(function (subField, index) {
        return _extends({}, subField, {
          model: model + '.' + index
        });
      }));

      finalResult.$form = field.$form;

      return finalResult;
    }

    result = _extends({}, field);

    Object.keys(field).forEach(function (key) {
      if (!!~removeKeysArray.indexOf(key)) {
        delete result['' + key];
      }
    });

    return result;
  }

  if (!Array.isArray(value) && !(0, _isPlainObject2.default)(value)) {
    return _icepick2.default.merge(field, _icepick2.default.set(changedFieldProps, 'value', value));
  }

  var updatedField = (0, _mapValues2.default)(value, function (subValue, index) {
    // TODO: refactor
    var subField = field[index] || (0, _formReducer.createInitialState)('' + (parentModel ? parentModel + '.' : '') + model + '.' + index, subValue);

    if (Object.hasOwnProperty.call(subField, '$form')) {
      return updateFieldValue(subField, {
        model: index,
        value: subValue,
        external: external,
        silent: silent,
        load: load
      }, parentModel ? parentModel + '.' + model : model);
    }

    if ((0, _shallowEqual2.default)(subValue, subField.value)) {
      return subField;
    }

    return _icepick2.default.merge(subField, _icepick2.default.assign(changedFieldProps, {
      value: subValue,
      loadedValue: load ? subValue : subField.loadedValue
    }));
  });

  var dirtyFormState = _icepick2.default.merge(field.$form || _initialFieldState2.default, _icepick2.default.set(changedFieldProps, 'retouched', field.submitted || field.$form && field.$form.retouched));

  return _icepick2.default.set(updatedField, '$form', dirtyFormState);
}

function changeActionReducer(state, action, localPath) {
  if (action.type !== _actionTypes2.default.CHANGE) return state;

  var field = (0, _get2.default)(state, localPath, (0, _formReducer.createInitialState)(action.model, action.value));

  var updatedField = updateFieldValue(field, action);

  if (!localPath.length) return updatedField;

  var updatedState = (0, _assocIn2.default)(state, localPath, updatedField, function (form) {
    if (!form.$form) return form;

    var formValue = (0, _getFormValue2.default)(form);

    var formUpdates = _extends({}, form.$form, {
      value: formValue
    });

    if (action.silent) {
      formUpdates.loadedValue = formValue;
    } else {
      formUpdates.pristine = false;
    }

    return _extends({}, form, {
      $form: formUpdates
    });
  });

  return updatedState;
}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;
function toArray(object) {
  var result = [];
  Object.keys(object).forEach(function (key) {
    if (object.hasOwnProperty(key)) {
      result.push(object[key]);
    }
  });
  return result;
}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createFormActionsReducer = createFormActionsReducer;

var _actionTypes = __webpack_require__(28);

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _updateField = __webpack_require__(357);

var _updateField2 = _interopRequireDefault(_updateField);

var _updateParentForms = __webpack_require__(358);

var _updateParentForms2 = _interopRequireDefault(_updateParentForms);

var _updateSubFields = __webpack_require__(359);

var _updateSubFields2 = _interopRequireDefault(_updateSubFields);

var _getFieldForm = __webpack_require__(360);

var _getFieldForm2 = _interopRequireDefault(_getFieldForm);

var _isPristine = __webpack_require__(361);

var _isPristine2 = _interopRequireDefault(_isPristine);

var _map = __webpack_require__(197);

var _map2 = _interopRequireDefault(_map);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _inverse = __webpack_require__(362);

var _inverse2 = _interopRequireDefault(_inverse);

var _mergeValidity = __webpack_require__(192);

var _mergeValidity2 = _interopRequireDefault(_mergeValidity);

var _isValid = __webpack_require__(60);

var _isValid2 = _interopRequireDefault(_isValid);

var _isValidityValid = __webpack_require__(186);

var _isValidityValid2 = _interopRequireDefault(_isValidityValid);

var _isValidityInvalid = __webpack_require__(106);

var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);

var _fieldActions = __webpack_require__(185);

var _fieldActions2 = _interopRequireDefault(_fieldActions);

var _toPath = __webpack_require__(80);

var _toPath2 = _interopRequireDefault(_toPath);

var _initialFieldState = __webpack_require__(34);

var _initialFieldState2 = _interopRequireDefault(_initialFieldState);

var _createField = __webpack_require__(83);

var _assocIn = __webpack_require__(61);

var _assocIn2 = _interopRequireDefault(_assocIn);

var _getFormValue = __webpack_require__(196);

var _getFormValue2 = _interopRequireDefault(_getFormValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var resetFieldState = function resetFieldState(field, customInitialFieldState) {
  if (!(0, _isPlainObject2.default)(field)) return field;

  var intents = [{ type: 'reset' }];
  var resetValue = (0, _createField.getMeta)(field, 'initialValue');
  var loadedValue = (0, _createField.getMeta)(field, 'loadedValue');

  if (loadedValue && resetValue !== loadedValue) {
    intents.push({ type: 'load' });
    resetValue = loadedValue;
  }
  return (0, _createField.fieldOrForm)((0, _createField.getMeta)(field, 'model'), resetValue, _extends({}, customInitialFieldState, { intents: intents }));
};

var setInitialFieldState = function setInitialFieldState(customInitialFieldState) {
  return function (field) {
    if (!(0, _isPlainObject2.default)(field)) return field;

    if (field.$form) {
      // eslint-disable-next-line arrow-body-style
      return (0, _mapValues2.default)(field, function (fieldState, key) {
        return key === '$form' ? (0, _createField.updateFieldState)(customInitialFieldState, {
          value: field.value,
          model: field.model
        }) : resetFieldState(fieldState, customInitialFieldState);
      });
    }

    return (0, _createField.updateFieldState)(customInitialFieldState, {
      value: field.value,
      model: field.model
    });
  };
};

var addIntent = function addIntent(intents, newIntent) {
  if (!intents) return [newIntent];
  if (intents.some(function (intent) {
    return intent.type === newIntent.type;
  })) return intents;

  return intents.concat(newIntent);
};

var clearIntents = function clearIntents(intents, oldIntent) {
  if (!intents || typeof oldIntent === 'undefined') return [];
  return intents.filter(function (intent) {
    return intent.type !== oldIntent.type;
  });
};

var defaultOptions = {
  initialFieldState: _initialFieldState2.default
};

function createFormActionsReducer(options) {
  var formOptions = options ? _extends({}, defaultOptions, options, {
    initialFieldState: _extends({}, defaultOptions.initialFieldState, options.initialFieldState)
  }) : defaultOptions;

  var customInitialFieldState = formOptions.initialFieldState;

  return function formActionsReducer(state, action, localPath) {
    var _getFieldAndForm = (0, _updateField.getFieldAndForm)(state, localPath),
        _getFieldAndForm2 = _slicedToArray(_getFieldAndForm, 1),
        field = _getFieldAndForm2[0];

    var fieldState = field && field.$form ? field.$form : field;

    var intents = fieldState.intents;


    var fieldUpdates = {};
    var subFieldUpdates = {};
    var parentFormUpdates = void 0;

    switch (action.type) {
      case _actionTypes2.default.FOCUS:
        {
          fieldUpdates = {
            focus: true,
            intents: action.silent ? intents : addIntent(intents, action)
          };

          break;
        }

      case _actionTypes2.default.BLUR:
      case _actionTypes2.default.SET_TOUCHED:
        {
          var fieldForm = (0, _getFieldForm2.default)(state, localPath).$form;

          fieldUpdates = {
            focus: action.type === _actionTypes2.default.BLUR ? false : field.focus,
            touched: true,
            retouched: fieldForm ? !!(fieldForm.submitted || fieldForm.submitFailed) : false
          };

          parentFormUpdates = {
            touched: true,
            retouched: fieldUpdates.retouched
          };

          break;
        }

      case _actionTypes2.default.SET_UNTOUCHED:
        {
          fieldUpdates = {
            focus: false,
            touched: false
          };

          break;
        }

      case _actionTypes2.default.SET_PRISTINE:
      case _actionTypes2.default.SET_DIRTY:
        {
          var pristine = action.type === _actionTypes2.default.SET_PRISTINE;

          fieldUpdates = {
            pristine: pristine
          };

          subFieldUpdates = {
            pristine: pristine
          };

          parentFormUpdates = function parentFormUpdates(form) {
            return { pristine: (0, _isPristine2.default)(form) };
          };

          break;
        }

      case _actionTypes2.default.SET_VALIDATING:
        {
          fieldUpdates = {
            validating: action.validating,
            validated: !action.validating
          };

          break;
        }

      case _actionTypes2.default.SET_VALIDITY:
      case _actionTypes2.default.SET_ERRORS:
        {
          var _fieldUpdates;

          var isErrors = action.type === _actionTypes2.default.SET_ERRORS;
          var validity = void 0;
          if (isErrors) {
            validity = action.merge ? (0, _mergeValidity2.default)(fieldState.errors, action.errors) : action.errors;
          } else {
            validity = action.merge ? (0, _mergeValidity2.default)(fieldState.validity, action.validity) : action.validity;
          }

          var inverseValidity = (0, _isPlainObject2.default)(validity) ? (0, _mapValues2.default)(validity, _inverse2.default) : !validity;

          // If the field is a form, its validity is
          // also based on whether its fields are all valid.
          var areFieldsValid = field && field.$form ? (0, _isValid.fieldsValid)(field, { async: false }) : true;

          fieldUpdates = (_fieldUpdates = {}, _defineProperty(_fieldUpdates, isErrors ? 'errors' : 'validity', validity), _defineProperty(_fieldUpdates, isErrors ? 'validity' : 'errors', inverseValidity), _defineProperty(_fieldUpdates, 'validating', false), _defineProperty(_fieldUpdates, 'validated', true), _defineProperty(_fieldUpdates, 'valid', areFieldsValid && (isErrors ? !(0, _isValidityInvalid2.default)(validity) : (0, _isValidityValid2.default)(validity))), _fieldUpdates);

          if (action.async) {
            var actionValidity = isErrors ? action.errors : action.validity;

            fieldUpdates.asyncKeys = (0, _isPlainObject2.default)(actionValidity) || Array.isArray(actionValidity) ? Object.keys(actionValidity) : true;
          }

          parentFormUpdates = function parentFormUpdates(form) {
            return { valid: (0, _isValid2.default)(form) };
          };

          break;
        }

      case _actionTypes2.default.SET_FIELDS_VALIDITY:
        {
          return (0, _map2.default)(action.fieldsValidity, function (fieldValidity, subField) {
            return _fieldActions2.default.setValidity(subField, fieldValidity, action.options);
          }).reduce(function (accState, subAction) {
            return formActionsReducer(accState, subAction, localPath.concat((0, _toPath2.default)(subAction.model)));
          }, state);
        }

      case _actionTypes2.default.RESET_VALIDITY:
        {
          var _validity = _extends({}, fieldState.validity);
          var errors = void 0;
          var valid = void 0;

          if (action.omitKeys && typeof fieldState.errors !== 'string') {
            errors = _extends({}, fieldState.errors);
            action.omitKeys.forEach(function (key) {
              delete _validity[key];
              delete errors[key];
            });
            valid = (0, _isValidityValid2.default)(_validity);
          } else {
            _validity = customInitialFieldState.validity;
            errors = customInitialFieldState.errors;
            valid = customInitialFieldState.valid;
          }

          fieldUpdates = {
            valid: valid,
            validity: _validity,
            errors: errors
          };

          subFieldUpdates = {
            valid: customInitialFieldState.valid,
            validity: customInitialFieldState.validity,
            errors: customInitialFieldState.errors
          };

          break;
        }

      case _actionTypes2.default.SET_PENDING:
        {
          fieldUpdates = {
            pending: action.pending,
            submitted: false,
            submitFailed: false,
            retouched: false
          };

          subFieldUpdates = {
            pending: action.pending,
            submitted: false,
            submitFailed: false,
            retouched: false
          };

          parentFormUpdates = { pending: action.pending };

          break;
        }

      case _actionTypes2.default.SET_SUBMITTED:
        {
          var submitted = !!action.submitted;

          fieldUpdates = {
            pending: false,
            submitted: submitted,
            submitFailed: submitted ? false : fieldState && fieldState.submitFailed,
            touched: true,
            retouched: false
          };

          subFieldUpdates = {
            pending: false,
            submitted: submitted,
            submitFailed: submitted ? false : fieldUpdates.submitFailed,
            retouched: false
          };

          break;
        }

      case _actionTypes2.default.SET_SUBMIT_FAILED:
        {
          fieldUpdates = {
            pending: false,
            submitted: fieldState.submitted && !action.submitFailed,
            submitFailed: !!action.submitFailed,
            touched: true,
            retouched: false
          };

          subFieldUpdates = {
            pending: false,
            submitted: !action.submitFailed,
            submitFailed: !!action.submitFailed,
            touched: true,
            retouched: false
          };

          break;
        }

      case _actionTypes2.default.RESET:
        {
          return localPath.length ? (0, _assocIn2.default)(state, localPath, resetFieldState(field, customInitialFieldState)) : resetFieldState(field, customInitialFieldState);
        }

      case _actionTypes2.default.SET_INITIAL:
        {
          var setCustomInitialFieldState = setInitialFieldState(customInitialFieldState);

          return (0, _updateField2.default)(state, localPath, setCustomInitialFieldState, setCustomInitialFieldState);
        }

      case _actionTypes2.default.ADD_INTENT:
        {
          fieldUpdates = {
            intents: addIntent(intents, action.intent)
          };

          break;
        }

      case _actionTypes2.default.CLEAR_INTENTS:
        {
          fieldUpdates = {
            intents: clearIntents(intents, action.intent)
          };

          break;
        }

      case _actionTypes2.default.CHANGE:
        {
          return (0, _updateParentForms2.default)(state, localPath, function (parentForm) {
            var formModelValue = (0, _getFormValue2.default)(parentForm);

            if (!parentForm.$form) {
              return _extends({}, customInitialFieldState, {
                value: formModelValue,
                initialValue: formModelValue
              });
            }

            // If the form is invalid (due to async validity)
            // but its fields are valid and the value has changed,
            // the form should be "valid" again.
            if ((!parentForm.$form.validity || typeof parentForm.$form.validity === 'boolean' || !Object.keys(parentForm.$form.validity).length) && !parentForm.$form.valid && (0, _isValid2.default)(parentForm, { async: false })) {
              return {
                value: formModelValue,
                validity: true,
                errors: false,
                valid: true
              };
            }

            return {
              value: formModelValue
            };
          });
        }

      default:
        return state;
    }

    if (action.clearIntents) {
      fieldUpdates.intents = clearIntents(intents, action.clearIntents);
    }

    var updatedField = (0, _updateField2.default)(state, localPath, fieldUpdates);
    var updatedSubFields = Object.keys(subFieldUpdates).length ? (0, _updateSubFields2.default)(updatedField, localPath, subFieldUpdates) : updatedField;
    var updatedParentForms = parentFormUpdates ? (0, _updateParentForms2.default)(updatedSubFields, localPath, parentFormUpdates) : updatedSubFields;

    return updatedParentForms;
  };
}

exports.default = createFormActionsReducer();

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getFieldAndForm = getFieldAndForm;
exports.default = updateField;

var _icepick = __webpack_require__(33);

var _icepick2 = _interopRequireDefault(_icepick);

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _mapValues = __webpack_require__(25);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _formReducer = __webpack_require__(82);

var _createField = __webpack_require__(83);

var _assocIn = __webpack_require__(61);

var _assocIn2 = _interopRequireDefault(_assocIn);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function tempInitialState(path) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (path.length === 1) return _defineProperty({}, path[0], initialValue);

  return _defineProperty({}, path[0], tempInitialState(path.slice(1), initialValue));
}

function getFieldAndForm(formState, modelPath) {
  var field = (0, _get2.default)(formState, modelPath);
  var form = formState;

  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', modelPath);

  if (!field) {
    var initialValue = (0, _get2.default)(formState.$form.initialValue, modelPath);

    form = _icepick2.default.merge((0, _formReducer.createInitialState)(formState.$form.model, tempInitialState(modelPath, initialValue)), formState);

    field = (0, _get2.default)(form, modelPath);
  }

  return [field, form];
}

function updateField(state, path, newState, newSubState, updater) {
  var _getFieldAndForm = getFieldAndForm(state, path),
      _getFieldAndForm2 = _slicedToArray(_getFieldAndForm, 2),
      field = _getFieldAndForm2[0],
      fullState = _getFieldAndForm2[1];

  if (!field) return state;

  var isForm = field.hasOwnProperty('$form');
  var fieldPath = isForm ? [].concat(_toConsumableArray(path), ['$form']) : path;

  var fieldState = isForm ? field.$form : field;

  var updatedFieldState = typeof newState === 'function' ? newState(fieldState) : newState;

  if (isForm && newSubState) {
    var formState = (0, _mapValues2.default)(field, function (subState, key) {
      if (key === '$form') {
        return (0, _createField.updateFieldState)(fieldState, updatedFieldState);
      }

      var updatedSubState = typeof newSubState === 'function' ? newSubState(subState, updatedFieldState) : newSubState;

      return (0, _createField.updateFieldState)(subState, updatedSubState);
    });

    if (!path.length) return formState;

    return (0, _assocIn2.default)(fullState, path, formState, updater);
  }

  return (0, _assocIn2.default)(fullState, fieldPath, (0, _createField.updateFieldState)(fieldState, updatedFieldState), updater);
}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateParentForms;

var _icepick = __webpack_require__(33);

var _icepick2 = _interopRequireDefault(_icepick);

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _assocIn = __webpack_require__(61);

var _assocIn2 = _interopRequireDefault(_assocIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// import { updateFieldState } from './create-field';

function updateParentForms(state, localPath, updater) {
  var parentLocalPath = localPath.slice(0, -1);

  var value = parentLocalPath.length ? (0, _get2.default)(state, parentLocalPath) : state;

  if (!value) return state;

  var form = value.$form;

  var updatedValue = typeof updater === 'function' ? updater(value) : updater;

  // const updatedForm = updateFieldState(form, updatedValue);

  var newState = (0, _assocIn2.default)(state, [].concat(_toConsumableArray(parentLocalPath), ['$form']), _icepick2.default.merge(form, updatedValue));

  if (!parentLocalPath.length) return newState;

  return updateParentForms(newState, parentLocalPath, updater);
}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateSubFields;

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _assocIn = __webpack_require__(61);

var _assocIn2 = _interopRequireDefault(_assocIn);

var _createField = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateSubField(subField, newSubState) {
  // Form
  if (subField && subField.$form) {
    // intermediate value - not mutated outside function
    var result = {};

    Object.keys(subField).forEach(function (key) {
      if (key === '$form') {
        result.$form = (0, _createField.updateFieldState)(subField.$form, newSubState);
      } else {
        result[key] = updateSubField(subField[key], newSubState);
      }
    });

    return result;
  }

  // Field
  return (0, _createField.updateFieldState)(subField, newSubState);
}

function updateSubFields(state, localPath, newState) {
  var field = (0, _get2.default)(state, localPath);

  // only forms can have fields -
  // skip if field is not a form
  if (!field || !field.$form) return state;

  // intermediate value - not mutated outside function
  var updatedField = {};

  Object.keys(field).forEach(function (key) {
    if (key === '$form') {
      updatedField.$form = field.$form;
    } else {
      updatedField[key] = updateSubField(field[key], newState);
    }
  });

  if (!localPath.length) return updatedField;

  return (0, _assocIn2.default)(state, localPath, updatedField);
}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFieldForm;

var _get = __webpack_require__(18);

var _get2 = _interopRequireDefault(_get);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFieldForm(state, path) {
  var formPath = path.slice(0, -1);

  if (!formPath.length) return state;

  var form = (0, _get2.default)(state, formPath);

  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', formPath.join('.'));

  return form;
}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPristine;
function isPristine(formState) {
  if (!formState) return false;

  // Form is pristine
  if (!formState.$form) {
    return formState.pristine;
  }

  // Every field in form is pristine
  return Object.keys(formState).every(function (key) {
    if (key === '$form') return true;

    return isPristine(formState[key]);
  });
}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inverse;
function inverse(value) {
  return !value;
}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorsClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(24);

var _get2 = __webpack_require__(18);

var _get3 = _interopRequireDefault(_get2);

var _map = __webpack_require__(197);

var _map2 = _interopRequireDefault(_map);

var _iteratee = __webpack_require__(104);

var _iteratee2 = _interopRequireDefault(_iteratee);

var _isPlainObject = __webpack_require__(21);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _omit = __webpack_require__(49);

var _omit2 = _interopRequireDefault(_omit);

var _getForm = __webpack_require__(79);

var _getForm2 = _interopRequireDefault(_getForm);

var _getFieldFromState = __webpack_require__(58);

var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);

var _getModel = __webpack_require__(59);

var _getModel2 = _interopRequireDefault(_getModel);

var _isValid = __webpack_require__(60);

var _isValid2 = _interopRequireDefault(_isValid);

var _resolveModel = __webpack_require__(81);

var _resolveModel2 = _interopRequireDefault(_resolveModel);

var _initialFieldState = __webpack_require__(34);

var _initialFieldState2 = _interopRequireDefault(_initialFieldState);

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultStrategy = {
  get: _get3.default,
  getForm: _getForm2.default,
  getFieldFromState: _getFieldFromState2.default
};

var propTypes = {
  // Computed props
  modelValue: _propTypes2.default.any,
  formValue: _propTypes2.default.object,
  fieldValue: _propTypes2.default.object,

  // Provided props
  model: _propTypes2.default.string.isRequired,
  messages: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func, _propTypes2.default.bool])),
  show: _propTypes2.default.any,
  wrapper: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object]),
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
  dispatch: _propTypes2.default.func,
  dynamic: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  store: _propTypes2.default.shape({
    subscribe: _propTypes2.default.func,
    dispatch: _propTypes2.default.func,
    getState: _propTypes2.default.func
  }),
  storeSubscription: _propTypes2.default.any
};

function showErrors(field, form) {
  var show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (typeof show === 'function') {
    return show(field, form);
  }

  if (!Array.isArray(show) && (typeof show === 'undefined' ? 'undefined' : _typeof(show)) !== 'object' && typeof show !== 'string') {
    return !!show;
  }

  return (0, _iteratee2.default)(show)(field);
}

function createErrorsClass() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;

  var Errors = function (_Component) {
    _inherits(Errors, _Component);

    function Errors() {
      _classCallCheck(this, Errors);

      return _possibleConstructorReturn(this, (Errors.__proto__ || Object.getPrototypeOf(Errors)).apply(this, arguments));
    }

    _createClass(Errors, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var fieldValue = nextProps.fieldValue,
            formValue = nextProps.formValue;
        var dynamic = this.props.dynamic;


        if (dynamic) {
          return !(0, _shallowEqual2.default)(this.props, nextProps);
        }

        return fieldValue !== this.props.fieldValue || formValue !== this.props.formValue;
      }
    }, {
      key: 'mapErrorMessages',
      value: function mapErrorMessages(errors) {
        var _this2 = this;

        var messages = this.props.messages;


        if (typeof errors === 'string') {
          return this.renderError(errors, 'error');
        }

        if (!errors) return null;

        return (0, _map2.default)(errors, function (error, key) {
          var message = messages[key];

          if (error) {
            if (message || typeof error === 'string') {
              return _this2.renderError(message || error, key);
            } else if ((0, _isPlainObject2.default)(error)) {
              return _this2.mapErrorMessages(error);
            }
          }

          return false;
        }).reduce(function (a, b) {
          return b ? a.concat(b) : a;
        }, []);
      }
    }, {
      key: 'renderError',
      value: function renderError(message, key) {
        var _props = this.props,
            component = _props.component,
            model = _props.model,
            modelValue = _props.modelValue,
            fieldValue = _props.fieldValue,
            errors = _props.fieldValue.errors;


        var errorProps = {
          key: key,
          model: model,
          modelValue: modelValue,
          fieldValue: fieldValue
        };

        var messageString = typeof message === 'function' ? message(modelValue, errors[key]) : message;

        if (!messageString) return null;

        var allowedProps = typeof component === 'function' ? errorProps : { key: key };

        return _react2.default.createElement(component, allowedProps, messageString);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            fieldValue = _props2.fieldValue,
            formValue = _props2.formValue,
            show = _props2.show,
            wrapper = _props2.wrapper;


        var allowedProps = typeof wrapper === 'function' ? this.props : (0, _omit2.default)(this.props, Object.keys(propTypes));

        if (!showErrors(fieldValue, formValue, show)) {
          return null;
        }

        var errorMessages = (0, _isValid2.default)(fieldValue) ? null : this.mapErrorMessages(fieldValue.errors);

        if (!errorMessages) return null;

        return _react2.default.createElement(wrapper, allowedProps, errorMessages);
      }
    }]);

    return Errors;
  }(_react.Component);

   false ? Errors.propTypes = propTypes : void 0;

  Errors.defaultProps = {
    wrapper: 'div',
    component: 'span',
    messages: {},
    show: true,
    dynamic: true
  };

  function mapStateToProps(state, _ref) {
    var model = _ref.model;

    var modelString = (0, _getModel2.default)(model, state);

    var form = s.getForm(state, modelString);
    (0, _invariant2.default)(form, 'Unable to retrieve errors. ' + 'Could not find form for "%s" in the store.', modelString);

    var formValue = form.$form;
    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;

    return {
      model: modelString,
      modelValue: s.get(state, modelString),
      formValue: formValue,
      fieldValue: fieldValue
    };
  }

  return (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Errors));
}

exports.createErrorsClass = createErrorsClass;
exports.default = createErrorsClass();

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRetouched = exports.isTouched = exports.isPending = exports.isValid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = formSelector;

var _isValid = __webpack_require__(60);

var _isValid2 = _interopRequireDefault(_isValid);

var _isPending = __webpack_require__(365);

var _isPending2 = _interopRequireDefault(_isPending);

var _isTouched = __webpack_require__(366);

var _isTouched2 = _interopRequireDefault(_isTouched);

var _isRetouched = __webpack_require__(367);

var _isRetouched2 = _interopRequireDefault(_isRetouched);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formSelector(formState) {
  return _extends({}, formState, {
    get valid() {
      return (0, _isValid2.default)(formState);
    },
    get pending() {
      return (0, _isPending2.default)(formState);
    },
    get touched() {
      return (0, _isTouched2.default)(formState);
    },
    get retouched() {
      return (0, _isRetouched2.default)(formState);
    }
  });
}

exports.isValid = _isValid2.default;
exports.isPending = _isPending2.default;
exports.isTouched = _isTouched2.default;
exports.isRetouched = _isRetouched2.default;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPending;
function isPending(formState) {
  if (!formState) return false;

  // Field is pending
  if (!formState.$form) {
    return formState.pending;
  }

  // Any field in form is pending
  return Object.keys(formState).some(function (key) {
    return isPending(formState[key]);
  });
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTouched;
function isTouched(formState) {
  if (!formState) return false;

  // Field is touched
  if (!formState.$form) {
    return formState.touched;
  }

  // Any field in form is touched
  return Object.keys(formState).some(function (key) {
    return isTouched(formState[key]);
  });
}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRetouched;
function isRetouched(formState) {
  if (!formState) return false;

  // Field is pending
  if (!formState.$form) {
    return formState.retouched;
  }

  // Any field in form is pending
  return Object.keys(formState).some(function (key) {
    return isRetouched(formState[key]);
  });
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notifications__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__project__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__agreements__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dispersions__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__projects__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__profile__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__versions__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__version_groups_phases__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__phases__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__groups_phases__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__documents_types__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__goals__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__permissions__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__roles__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__users__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__status__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__objectives__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__strategies__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__axis__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lines__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__activities__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__concepts__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__units__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modal__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__verification_media__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__activity_groups__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__entities__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__municipalities__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__agencies__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__amounts_agencies__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__directories__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modalities__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__resource_concept__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__revision__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__notification_messages__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__notifications_types__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__surveys__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__reports__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__register__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__menu__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__cdms__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_react_redux_form__);
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])(Object.assign({session:__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionReducer"],menu:__WEBPACK_IMPORTED_MODULE_43__menu__["a" /* default */],userLogin:__WEBPACK_IMPORTED_MODULE_3__login__["a" /* default */],register:__WEBPACK_IMPORTED_MODULE_42__register__["a" /* default */],notifications:__WEBPACK_IMPORTED_MODULE_4__notifications__["a" /* default */],profile:__WEBPACK_IMPORTED_MODULE_9__profile__["a" /* default */],project:__WEBPACK_IMPORTED_MODULE_5__project__["a" /* default */],projects:__WEBPACK_IMPORTED_MODULE_8__projects__["a" /* default */],cdms:__WEBPACK_IMPORTED_MODULE_44__cdms__["a" /* default */],agreements:__WEBPACK_IMPORTED_MODULE_6__agreements__["a" /* default */],dispersions:__WEBPACK_IMPORTED_MODULE_7__dispersions__["a" /* default */],revision:__WEBPACK_IMPORTED_MODULE_37__revision__["a" /* default */],reports:__WEBPACK_IMPORTED_MODULE_41__reports__["a" /* default */],notification_messages:__WEBPACK_IMPORTED_MODULE_38__notification_messages__["a" /* default */],notifications_types:__WEBPACK_IMPORTED_MODULE_39__notifications_types__["a" /* default */],surveys:__WEBPACK_IMPORTED_MODULE_40__surveys__["a" /* default */],entities:__WEBPACK_IMPORTED_MODULE_30__entities__["a" /* default */],municipalities:__WEBPACK_IMPORTED_MODULE_31__municipalities__["a" /* default */],versions:__WEBPACK_IMPORTED_MODULE_10__versions__["a" /* default */],version_groups_phases:__WEBPACK_IMPORTED_MODULE_11__version_groups_phases__["a" /* default */],phases:__WEBPACK_IMPORTED_MODULE_12__phases__["a" /* default */],groupsPhases:__WEBPACK_IMPORTED_MODULE_13__groups_phases__["a" /* default */],documents_types:__WEBPACK_IMPORTED_MODULE_14__documents_types__["a" /* default */],goals:__WEBPACK_IMPORTED_MODULE_15__goals__["a" /* default */],permissions:__WEBPACK_IMPORTED_MODULE_16__permissions__["a" /* default */],roles:__WEBPACK_IMPORTED_MODULE_17__roles__["a" /* default */],users:__WEBPACK_IMPORTED_MODULE_18__users__["a" /* default */],status:__WEBPACK_IMPORTED_MODULE_19__status__["a" /* default */],objectives:__WEBPACK_IMPORTED_MODULE_20__objectives__["a" /* default */],strategies:__WEBPACK_IMPORTED_MODULE_21__strategies__["a" /* default */],axis:__WEBPACK_IMPORTED_MODULE_22__axis__["a" /* default */],lines:__WEBPACK_IMPORTED_MODULE_23__lines__["a" /* default */],activities:__WEBPACK_IMPORTED_MODULE_24__activities__["a" /* default */],concepts:__WEBPACK_IMPORTED_MODULE_25__concepts__["a" /* default */],units:__WEBPACK_IMPORTED_MODULE_26__units__["a" /* default */],agencies:__WEBPACK_IMPORTED_MODULE_32__agencies__["a" /* default */],amounts_agencies:__WEBPACK_IMPORTED_MODULE_33__amounts_agencies__["a" /* default */],modal:__WEBPACK_IMPORTED_MODULE_27__modal__["a" /* default */],verificationMedia:__WEBPACK_IMPORTED_MODULE_28__verification_media__["a" /* default */],activityGroup:__WEBPACK_IMPORTED_MODULE_29__activity_groups__["a" /* default */],directories:__WEBPACK_IMPORTED_MODULE_34__directories__["a" /* default */],modalities:__WEBPACK_IMPORTED_MODULE_35__modalities__["a" /* default */],resource_concepts:__WEBPACK_IMPORTED_MODULE_36__resource_concept__["a" /* default */]},Object(__WEBPACK_IMPORTED_MODULE_45_react_redux_form__["createForms"])({profile:__WEBPACK_IMPORTED_MODULE_9__profile__["a" /* default */],roles:__WEBPACK_IMPORTED_MODULE_17__roles__["a" /* default */],objectives:__WEBPACK_IMPORTED_MODULE_20__objectives__["a" /* default */],strategies:__WEBPACK_IMPORTED_MODULE_21__strategies__["a" /* default */],lines:__WEBPACK_IMPORTED_MODULE_23__lines__["a" /* default */],axis:__WEBPACK_IMPORTED_MODULE_22__axis__["a" /* default */],activities:__WEBPACK_IMPORTED_MODULE_24__activities__["a" /* default */],goals:__WEBPACK_IMPORTED_MODULE_15__goals__["a" /* default */],users:__WEBPACK_IMPORTED_MODULE_18__users__["a" /* default */],concepts:__WEBPACK_IMPORTED_MODULE_25__concepts__["a" /* default */],units:__WEBPACK_IMPORTED_MODULE_26__units__["a" /* default */],project:__WEBPACK_IMPORTED_MODULE_5__project__["a" /* default */],projects:__WEBPACK_IMPORTED_MODULE_8__projects__["a" /* default */],cdms:__WEBPACK_IMPORTED_MODULE_44__cdms__["a" /* default */],agreements:__WEBPACK_IMPORTED_MODULE_6__agreements__["a" /* default */],dispersions:__WEBPACK_IMPORTED_MODULE_7__dispersions__["a" /* default */],permissions:__WEBPACK_IMPORTED_MODULE_16__permissions__["a" /* default */],entities:__WEBPACK_IMPORTED_MODULE_30__entities__["a" /* default */],municipalities:__WEBPACK_IMPORTED_MODULE_31__municipalities__["a" /* default */],agencies:__WEBPACK_IMPORTED_MODULE_32__agencies__["a" /* default */],amounts_agencies:__WEBPACK_IMPORTED_MODULE_33__amounts_agencies__["a" /* default */],revision:__WEBPACK_IMPORTED_MODULE_37__revision__["a" /* default */],notification_messages:__WEBPACK_IMPORTED_MODULE_38__notification_messages__["a" /* default */],notifications_types:__WEBPACK_IMPORTED_MODULE_39__notifications_types__["a" /* default */],surveys:__WEBPACK_IMPORTED_MODULE_40__surveys__["a" /* default */],groupsPhases:__WEBPACK_IMPORTED_MODULE_13__groups_phases__["a" /* default */],phases:__WEBPACK_IMPORTED_MODULE_12__phases__["a" /* default */],versions:__WEBPACK_IMPORTED_MODULE_10__versions__["a" /* default */],version_groups_phases:__WEBPACK_IMPORTED_MODULE_11__version_groups_phases__["a" /* default */],reports:__WEBPACK_IMPORTED_MODULE_41__reports__["a" /* default */],register:__WEBPACK_IMPORTED_MODULE_42__register__["a" /* default */]}),{routing:__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["routerReducer"]}));/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(198);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(199);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(370);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(371);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(198);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(199);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_SESSION = exports.USER_SESSION = 'USER-SESSION';
var USER_DATA = exports.USER_DATA = 'USER_DATA';

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invalidSession = exports.getUserSessionError = exports.getUserSessionSuccess = exports.getSessionError = exports.getSessionSuccess = undefined;

var _actionTypes = __webpack_require__(200);

var getSessionSuccess = exports.getSessionSuccess = function getSessionSuccess() {
  return { type: _actionTypes.GET_SESSION_SUCCESS };
};

var getSessionError = exports.getSessionError = function getSessionError() {
  return { type: _actionTypes.GET_SESSION_ERROR };
};

var getUserSessionSuccess = exports.getUserSessionSuccess = function getUserSessionSuccess(user) {
  return {
    user: user,
    type: _actionTypes.GET_USER_SESSION_SUCCESS
  };
};

var getUserSessionError = exports.getUserSessionError = function getUserSessionError() {
  return { type: _actionTypes.GET_USER_SESSION_ERROR };
};

var invalidSession = exports.invalidSession = function invalidSession() {
  return { type: _actionTypes.INVALID_SESSION };
};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(200);

var initialState = exports.initialState = {
  authenticated: false,
  checked: false,
  invalid: false,
  user: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.GET_SESSION_SUCCESS:
      {
        return {
          user: _extends({}, state.user),
          authenticated: true,
          checked: true,
          invalid: false
        };
      }
    case _actionTypes.GET_SESSION_ERROR:
      {
        return _extends({}, state, {
          user: _extends({}, state.user),
          authenticated: false,
          checked: true
        });
      }
    case _actionTypes.GET_USER_SESSION_SUCCESS:
      {
        return _extends({}, state, { user: action.user });
      }
    case _actionTypes.GET_USER_SESSION_ERROR:
      {
        return _extends({}, state, { user: {} });
      }
    case _actionTypes.INVALID_SESSION:
      {
        return {
          user: {},
          checked: true,
          authenticated: false,
          invalid: true
        };
      }
    default:
      {
        return state;
      }
  }
};

exports.default = reducer;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.7.3
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support (#5572)
        // since Safari 10.1 shipped with fetch, we can use that to detect it
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback retuns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = req.onblocked = function (err) {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(err);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var loginInit={isFetching:false,data:{profile:{},menu:[],agencies:[],cdms:[],version:{},timestamp:undefined},error:undefined,message:undefined,timestamp:undefined};function userLogin(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:loginInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_30" /* LOGIN_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,message:action.message,error:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_28" /* LOGIN_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,message:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_26" /* LOGIN_AGENCIES */]:return Object.assign({},state,{data:Object.assign({},state.data,{agencies:action.payload}),message:action.message});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_27" /* LOGIN_CDMS */]:return Object.assign({},state,{data:Object.assign({},state.data,{cdms:action.payload}),message:action.message});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_31" /* LOGIN_USER */]:return Object.assign({},state,{data:Object.assign({},state.data,{profile:action.payload}),message:action.message});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_29" /* LOGIN_OK */]:return Object.assign({},state,{isFetching:action.isFetching,data:Object.assign({},state.data,{//menu: action.payload,
version:action.version//timestamp: action.timestamp
}),message:action.message,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_32" /* LOGOUT */]:return Object.assign({},loginInit,{timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_5" /* FORGOT_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,message:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_4" /* FORGOT_OK */]:return Object.assign({},state,{isFetching:action.isFetching,message:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_188" /* RESET_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,message:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_187" /* RESET_OK */]:return Object.assign({},state,{isFetching:action.isFetching,message:action.payload,timestamp:action.timestamp});default:return Object.assign({},state);}}/* harmony default export */ __webpack_exports__["a"] = (userLogin);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var notificationInit={data:{title:null,content:null,type:null},active:false,timestamp:null};var notifications=function notifications(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:notificationInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_54" /* NOTIFICATION_SET */]:return Object.assign({},state,{data:action.data,active:action.active,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_48" /* NOTIFICATION_CLEAR */]:return Object.assign({},state,{data:action.data,active:action.active,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (notifications);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var projectInit={isFetching:false,owner:{isFetching:false,editable:false,data:{},revision:{},documents_items:[]},instance:{isFetching:false,editable:false,data:{},list:[],revision:{},documents_items:[]},registry:{isFetching:false,editable:false,data:{isFetching:false,error:undefined,project_goals:[],amounts:{}},revision:{},revisions:[],documents_items:[]},goals:{isFetching:false,editable:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},edit:{}},expenses:{isFetching:false,editable:false,edit:{},data:{},revision:{}},profiles:{isFetching:false,editable:false,data:{employees:[],roles:[]},edit:{isFetching:false},revision:{}},conclusion:{isFetching:false,finished:false,editable:false,data:{},revision:{},documents_items:[],version:{}},agreements:{isFetching:false,admin:{isFetching:false,data:{}},legal:{isFetching:false,data:{}}},dispersions:{isFetching:false,list:[],data:[],budgets:{},permissions:{}},phase:{},version:{},//activity:{},
permissions:[],error:undefined,timestamp:undefined};var project=function project(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:projectInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_149" /* PROJECT_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_105" /* PROJECT_CLEAR */]:return Object.assign({},state,action.payload,{timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_125" /* PROJECT_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_131" /* PROJECT_LOADED */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_132" /* PROJECT_OWNER */]:return Object.assign({},state,{owner:Object.assign({},state.owner,{isFetching:action.isFetching,editable:action.editable,data:action.payload,revision:action.revision,documents_items:action.documents_items,timestamp:action.timestamp}),phase:action.phase,version:action.version,permissions:action.permissions});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_135" /* PROJECT_OWNER_REQUEST */]:return Object.assign({},state,{owner:Object.assign({},state.owner,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_134" /* PROJECT_OWNER_FAIL */]:return Object.assign({},state,{owner:Object.assign({},state.owner,{isFetching:action.isFetching,error:action.error}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_133" /* PROJECT_OWNER_CLEAR */]:return Object.assign({},state,{owner:Object.assign({},state.owner,{data:action.payload,timestamp:action.timestamp}),phase:action.payload});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_126" /* PROJECT_INSTANCE */]:return Object.assign({},state,{instance:Object.assign({},state.instance,{isFetching:action.isFetching,editable:action.editable,data:action.payload,revision:action.revision,documents_items:action.documents_items,timestamp:action.timestamp}),phase:action.phase,version:action.version,permissions:action.permissions});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_130" /* PROJECT_INSTANCE_REQUEST */]:return Object.assign({},state,{instance:Object.assign({},state.instance,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_129" /* PROJECT_INSTANCE_LOADED */]:return Object.assign({},state,{instance:Object.assign({},state.instance,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_128" /* PROJECT_INSTANCE_FAIL */]:return Object.assign({},state,{instance:Object.assign({},state.instance,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_127" /* PROJECT_INSTANCE_CLEAR */]:return Object.assign({},state,{instance:Object.assign({},state.instance,{data:action.payload}),phase:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_147" /* PROJECT_REGISTRY_LOADED */]:return Object.assign({},state,{registry:Object.assign({},state.registry,{isFetching:action.isFetching,complete:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_148" /* PROJECT_REGISTRY_REQUEST */]:return Object.assign({},state,{registry:Object.assign({},state.registry,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_146" /* PROJECT_REGISTRY_FAIL */]:return Object.assign({},state,{registry:Object.assign({},state.registry,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_142" /* PROJECT_REGISTRY_CLEAR */]:return Object.assign({},state,{registry:Object.assign({},state.registry,{data:action.payload}),phase:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_145" /* PROJECT_REGISTRY_DATA_REQUEST */]:return Object.assign({},state,{registry:Object.assign({},state.registry,{data:Object.assign({},state.registry.data,{isFetching:action.isFetching})}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_144" /* PROJECT_REGISTRY_DATA_FAIL */]:return Object.assign({},state,{registry:Object.assign({},state.registry,{data:Object.assign({},state.registry.data,{isFetching:action.isFetching})}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_143" /* PROJECT_REGISTRY_DATA */]:return Object.assign({},state,{registry:Object.assign({},state.registry,{editable:action.editable,data:Object.assign({},state.registry.data,{isFetching:action.isFetching},action.payload),revision:action.revision,revisions:action.revisions,documents_items:action.documents_items}),phase:action.phase,version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_141" /* PROJECT_PROIGUALDAD_GOALS_REQUEST */]:return Object.assign({},state,{goals:Object.assign({},state.goals,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_138" /* PROJECT_PROIGUALDAD_GOALS_COMPLETE */]:return Object.assign({},state,{goals:Object.assign({},state.goals,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_136" /* PROJECT_PROIGUALDAD_GOALS */]:return Object.assign({},state,{goals:Object.assign({},state.goals,{isFetching:action.isFetching,list:action.payload,pages:action.pages}),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_139" /* PROJECT_PROIGUALDAD_GOALS_EDIT */]:return Object.assign({},state,{goals:Object.assign({},state.goals,{isFetching:action.isFetching,edit:action.payload}),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_137" /* PROJECT_PROIGUALDAD_GOALS_CLEAR */]:return Object.assign({},state,{goals:Object.assign({},state.goals,{edit:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_140" /* PROJECT_PROIGUALDAD_GOALS_FAIL */]:return Object.assign({},state,{goals:Object.assign({},state.goals,{isFetching:action.isFetching,error:action.error}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_124" /* PROJECT_EXPENSES_REQUEST */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_123" /* PROJECT_EXPENSES_FAIL */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_122" /* PROJECT_EXPENSES_CLEAR */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{edit:action.payload,data:action.payload}),phase:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_121" /* PROJECT_EXPENSES */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{isFetching:action.isFetching,editable:action.editable,data:action.payload,revision:action.revision}),phase:action.phase,version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_116" /* PROJECT_EMPLOYEES */]:return Object.assign({},state,{profiles:Object.assign({},state.profiles,{isFetching:action.isFetching,editable:action.editable,data:Object.assign({},state.profiles.data,action.payload),edit:Object.assign({},state.profiles.edit,{isFetching:action.isFetching}),revision:action.revision}),phase:action.phase,version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_120" /* PROJECT_EMPLOYEES_REQUEST */]:return Object.assign({},state,{profiles:Object.assign({},state.profiles,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_118" /* PROJECT_EMPLOYEES_EDIT_REQUEST */]:return Object.assign({},state,{profiles:Object.assign({},state.profiles,{edit:Object.assign({},state.profiles.edit,{isFetching:action.isFetching})}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_119" /* PROJECT_EMPLOYEES_FAIL */]:return Object.assign({},state,{profiles:Object.assign({},state.profiles,{isFetching:action.isFetching,edit:Object.assign({},state.profiles.edit,{isFetching:action.isFetching})}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_117" /* PROJECT_EMPLOYEES_CLEAR */]:return Object.assign({},state,{profiles:Object.assign({},state.profiles,action.payload),phase:action.phase,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_106" /* PROJECT_CONCLUSION */]:return Object.assign({},state,{conclusion:Object.assign({},state.conclusion,{isFetching:action.isFetching,editable:action.editable,finished:action.payload.finished,data:Object.assign({},state.conclusion.data,action.payload),revision:action.revision,documents_items:action.documents_items}),phase:action.phase,version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_107" /* PROJECT_CONCLUSION_CLEAR */]:return Object.assign({},state,{conclusion:Object.assign({},state.conclusion,action.payload),phase:action.phase,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_110" /* PROJECT_CONCLUSION_REQUEST */]:return Object.assign({},state,{conclusion:Object.assign({},state.conclusion,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_109" /* PROJECT_CONCLUSION_LOADED */]:return Object.assign({},state,{conclusion:Object.assign({},state.conclusion,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_108" /* PROJECT_CONCLUSION_FAIL */]:return Object.assign({},state,{conclusion:Object.assign({},state.conclusion,{isFetching:action.isFetching,error:action.error}),timestamp:action.timestamp});default:return Object.assign({},state);}//deepFreeze(project);
};/* harmony default export */ __webpack_exports__["a"] = (project);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var agreementsInit={isFetching:false,data:{},documents_items:[],revisions:[],permissions:[],version:{},error:undefined,timestamp:undefined};var agreements=function agreements(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:agreementsInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_104" /* PROJECT_AGREEMENTS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_100" /* PROJECT_AGREEMENTS */]:return Object.assign({},state,{isFetching:action.isFetching,data:action.payload,documents_items:action.documents_items,editable:action.editable,revisions:action.revisions,permissions:action.permissions,version:action.version,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_103" /* PROJECT_AGREEMENTS_LOADED */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_101" /* PROJECT_AGREEMENTS_CLEAR */]:return Object.assign({},state,{data:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_102" /* PROJECT_AGREEMENTS_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (agreements);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var dispersionsInit={isFetching:false,data:{list:[],budgets:[]},documents_items:[],editable:false,revision:{},permissions:{},error:undefined,timestamp:undefined};var dispersions=function dispersions(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:dispersionsInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_115" /* PROJECT_DISPERSIONS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_111" /* PROJECT_DISPERSIONS */]:return Object.assign({},state,{isFetching:action.isFetching,data:Object.assign({},state.data,action.payload),documents_items:action.documents_items,editable:action.editable,revision:action.revision,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_114" /* PROJECT_DISPERSIONS_LOADED */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_112" /* PROJECT_DISPERSIONS_CLEAR */]:return Object.assign({},state,{data:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_113" /* PROJECT_DISPERSIONS_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (dispersions);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var projectsInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:'',type:'',modality_id:'',state_id:'',version_id:''},options:[],project:{},goals:[],expenses:[],phases_groups:[],employees:{},roles:[],folios:[],edit:{isFetching:false},codes_assigned:false,version:{},permissions:[],search:undefined,error:undefined,message:undefined};var projects=function projects(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:projectsInit;var action=arguments[1];//console.log('action', action);
switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_99" /* PROJECTS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_93" /* PROJECTS_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_96" /* PROJECTS_LIST */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_87" /* PROJECTS_EDIT */]:return Object.assign({},state,{project:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_95" /* PROJECTS_GOALS */]:return Object.assign({},state,{goals:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_91" /* PROJECTS_EXPENSES */]:return Object.assign({},state,{expenses:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_85" /* PROJECTS_COMMISSIONS */]:return Object.assign({},state,{isFetching:action.isFetching,project:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_97" /* PROJECTS_PHASES_GROUPS */]:return Object.assign({},state,{phases_groups:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_98" /* PROJECTS_PHASES_GROUPS_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{isFetching:action.isFetching},action.payload),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_89" /* PROJECTS_EMPLOYEES */]:return Object.assign({},state,{employees:action.payload,roles:action.roles,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_90" /* PROJECTS_EMPLOYEES_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{isFetching:action.isFetching},action.payload),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_150" /* PROJECT_SET_SEARCH */]:return Object.assign({},state,{search:action.search,timestamp:action.timestamp/*
		case PROJECTS_DELETE:
			return{
				...state,
				message:'',
				data:action.responseData,
				timestamp:action.timestamp
			};
			*//*
		case PROJECT_CHANGE_TAB_DATA:
			return {
				...state,
				currentTab: action.currentTab,
				timestamp: action.timestamp
			}
			*/});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_88" /* PROJECTS_EDIT_REQUEST */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_94" /* PROJECTS_FOLIOS */]:return Object.assign({},state,{isFetching:action.isFetching,folios:action.payload,codes_assigned:action.codes_assigned,version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_86" /* PROJECTS_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_84" /* PROJECTS_CLEAR */]:return Object.assign({},state,action.payload,{timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_92" /* PROJECTS_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,edit:Object.assign({},state.edit,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (projects);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var profileInit={isFetching:false,edit:{},error:undefined,timestamp:undefined};var profile=function profile(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:profileInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_82" /* PROFILE_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_83" /* PROFILE_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_80" /* PROFILE_AGENCIES */]:return Object.assign({},state,{isFetching:action.isFetching,agencies:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_81" /* PROFILE_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (profile);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var versionsDefault={isFetching:false,list:{},edit:{phases_groups:[]},pages:{current:0,per_page:0,total:0},permissions:[],error:undefined,timestamp:undefined};var versions=function versions(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:versionsDefault;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_258" /* VERSIONS_REQUEST */]:{return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});}case __WEBPACK_IMPORTED_MODULE_0__store_config__["_259" /* VERSIONS_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_257" /* VERSIONS_LIST */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_261" /* VERSION_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:Object.assign({},state.edit,action.payload),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_260" /* VERSION_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_256" /* VERSIONS_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (versions);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var versionGroupsPhasesInit={isFetching:false,list:{},edit:{all_projects:true,phases:[]},pages:{current:0,per_page:0,total:0},permissions:[],error:undefined,timestamp:undefined};var version_groups_phases=function version_groups_phases(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:versionGroupsPhasesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_265" /* VERSION_GROUPS_PHASES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_263" /* VERSION_GROUPS_PHASES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:Object.assign({},state.edit,action.payload),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_262" /* VERSION_GROUPS_PHASES_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_264" /* VERSION_GROUPS_PHASES_FAIL */]:{return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});}default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (version_groups_phases);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var phaseInit={isFetching:false,list:{},pages:{current:undefined,per_page:undefined,total:undefined},edit:{},permissions:[],error:undefined};var phases=function phases(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:phaseInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_77" /* PHASES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_78" /* PHASES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_76" /* PHASES_LIST */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_79" /* PHASE_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_75" /* PHASES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (phases);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var groupsInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},edit:{},permissions:[],error:undefined,timestamp:undefined};var groupsPhases=function groupsPhases(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:groupsInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_19" /* GROUPS_PHASES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_18" /* GROUPS_PHASES_LIST */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_16" /* GROUPS_PHASES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_15" /* GROUPS_PHASES_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_17" /* GROUPS_PHASES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (groupsPhases);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var documentsTypesInit={isFetching:false,list:[],permissions:[],error:undefined,timestamp:undefined};var documents_types=function documents_types(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:documentsTypesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["Y" /* DOCUMENTS_TYPES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["W" /* DOCUMENTS_TYPES */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,permissions:action.permissions,timestamp:action.permissions});case __WEBPACK_IMPORTED_MODULE_0__store_config__["X" /* DOCUMENTS_TYPES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (documents_types);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var goalInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:'',type:'',modality_id:'',state_id:''},edit:{activities:[]},permissions:[],error:undefined,message:null};var goals=function goals(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:goalInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_7" /* GOALS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_8" /* GOALS_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_6" /* GOALS_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_13" /* GOAL_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,action.payload),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_9" /* GOAL_ACTIVITIES */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{activities:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_11" /* GOAL_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_12" /* GOAL_DELETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_10" /* GOAL_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_14" /* GOAL_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (goals);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var permissionInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},edit:{},permissions:[],error:undefined};var permissions=function permissions(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:permissionInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_74" /* PERMISSION_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_72" /* PERMISSIONS_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_71" /* PERMISSIONS_LIST */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_70" /* PERMISSIONS_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_68" /* PERMISSIONS_CLEAR */]:return Object.assign({},state,{edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_69" /* PERMISSIONS_DELETE */]:return Object.assign({},state,{isFetching:action.isFetching,delete:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_73" /* PERMISSION_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (permissions);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var roleInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},edit:{permissions:[]},permissions:[],error:undefined};var roles=function roles(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:roleInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_216" /* ROLES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_217" /* ROLES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_215" /* ROLES_LIST */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_218" /* ROLE_EDIT */]:return Object.assign({},state,{edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_220" /* ROLE_PERMISSIONS */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{permissions:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_214" /* ROLES_DELETE */]:return Object.assign({},state,{isFetching:action.isFetching,data:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_213" /* ROLES_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_212" /* ROLES_CLEAR */]:return Object.assign({},state,{edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_219" /* ROLE_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (roles);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var usersInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:'',role_id:'',status_id:''},edit:{roles:[]},agencies:[],permissions:[],search:undefined,error:null,timestamp:null};var users=function users(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:usersInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_245" /* USERS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_244" /* USERS_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_252" /* USER_SET_SEARCH */]:return Object.assign({},state,{search:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_246" /* USERS_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:Object.assign({},state.pages,action.pages),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_250" /* USER_EDIT */]:return Object.assign({},state,{edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_251" /* USER_ROLE */]:return Object.assign({},state,{edit:Object.assign({},state.edit,action.payload),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_247" /* USER_AGENCIES */]:return Object.assign({},state,{agencies:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_249" /* USER_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_248" /* USER_CLEAR */]:return Object.assign({},state,{edit:action.payload,agencies:action.payload,permissions:action.permissions,timestamp:action.payload});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (users);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var statusInit={data:[],error:null,isFetching:false};var status=function status(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:statusInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_224" /* STATUS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_222" /* STATUS_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,data:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_223" /* STATUS_GROUP */]:return Object.assign({},state,{isFetching:action.isFetching,data:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_221" /* STATUS_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (status);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var objectivesInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:''},edit:{},permissions:[],error:undefined};var objectives=function objectives(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:objectivesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_66" /* OBJECTIVES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_67" /* OBJECTIVES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_64" /* OBJECTIVES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_63" /* OBJECTIVES_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_65" /* OBJECTIVES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (objectives);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var strategiesInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:''},edit:{},permissions:[],error:undefined};var strategies=function strategies(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:strategiesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_228" /* STRATEGIES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_229" /* STRATEGIES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_226" /* STRATEGIES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_225" /* STRATEGIES_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_227" /* STRATEGIES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (strategies);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var axisInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:''},edit:{},permissions:[],error:undefined};var axis=function axis(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:axisInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["E" /* AXIS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["F" /* AXIS_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["C" /* AXIS_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["B" /* AXIS_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["D" /* AXIS_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (axis);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var linesInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:''},edit:{},permissions:[],error:undefined};var lines=function lines(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:linesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_24" /* LINES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_25" /* LINES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_22" /* LINES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_20" /* LINES_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_23" /* LINES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_21" /* LINES_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (lines);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var activityInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:''},edit:{},permissions:[],error:null,message:null};var activities=function activities(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:activityInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["k" /* ACTIVITY_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["c" /* ACTIVITIES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["b" /* ACTIVITIES_LIST */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["f" /* ACTIVITY_EDIT */]:return Object.assign({},state,{edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["l" /* ACTIVITY_VERIFICATION_MEDIA */]:return Object.assign({},state,{edit:Object.assign({},state.edit,action.payload),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["e" /* ACTIVITY_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["d" /* ACTIVITY_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["g" /* ACTIVITY_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (activities);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var conceptInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:''},edit:{units:[]},permissions:[],error:undefined,message:undefined};var concepts=function concepts(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:conceptInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["L" /* CONCEPTS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["K" /* CONCEPTS_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["M" /* CONCEPTS_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["O" /* CONCEPT_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,action.payload),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["Q" /* CONCEPT_UNITS */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{units:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["N" /* CONCEPT_CLEAR */]:{return Object.assign({},state,action.payload,{timestamp:action.timestamp});}case __WEBPACK_IMPORTED_MODULE_0__store_config__["P" /* CONCEPT_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (concepts);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var unitInit={isFetching:false,list:[],edit:{},error:null};var units=function units(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:unitInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_243" /* UNIT_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.edit,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_240" /* UNITS_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.list,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_241" /* UNIT_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.edit,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_242" /* UNIT_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (units);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var modalInit={show:false,data:{},active:false,timestamp:null};var modal=function modal(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:modalInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_41" /* MODAL_SHOW */]:return Object.assign({},state,{show:action.show,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_38" /* MODAL_HIDE */]:return Object.assign({},state,{show:action.show,data:action.data,active:action.active,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_40" /* MODAL_NOTIFICATION_SET */]:return Object.assign({},state,{data:action.data,active:action.active,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_39" /* MODAL_NOTIFICATION_CLEAR */]:return Object.assign({},state,{data:action.data,active:action.active,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (modal);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var mediaInit={isFetching:false,list:[],error:null};var verificationMedia=function verificationMedia(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:mediaInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_254" /* VERIFICATION_MEDIA_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_255" /* VERIFICATION_MEDIA_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_253" /* VERIFICATION_MEDIA_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.error});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (verificationMedia);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var activityGroupInit={isFetching:false,list:[],error:undefined,timestamp:undefined};var activityGroup=function activityGroup(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:activityGroupInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["i" /* ACTIVITY_GROUP_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["j" /* ACTIVITY_GROUP_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["h" /* ACTIVITY_GROUP_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (activityGroup);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var statesInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:''},edit:{},permissions:[],detail:{},error:undefined,timestamp:null};var entities=function entities(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:statesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_2" /* ENTITIES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["Z" /* ENTITIES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_3" /* ENTITIES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_1" /* ENTITIES_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_0" /* ENTITIES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (entities);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var municipalityInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:''},filtered:{isFetching:false,list:[]},edit:{},permissions:[],error:null,timestamp:null};var municipalities=function municipalities(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:municipalityInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_46" /* MUNICIPALITIES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_47" /* MUNICIPALITIES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_44" /* MUNICIPALITIES_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_42" /* MUNICIPALITIES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_43" /* MUNICIPALITIES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_45" /* MUNICIPALITIES_FILTERED */]:return Object.assign({},state,{filtered:Object.assign({},state.filtered,{isFetching:action.isFetching,list:action.payload}),timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (municipalities);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var agenciesInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:'',state_id:'',agenciable_type:'',version_id:''},municipalities:{isFetching:false,list:[]},permissions:[],edit:{},detail:{},user:{},error:undefined,timestamp:undefined};var agencies=function agencies(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:agenciesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["r" /* AGENCIES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["s" /* AGENCIES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["n" /* AGENCIES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["m" /* AGENCIES_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["o" /* AGENCIES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["q" /* AGENCIES_MUNICIPALITIES_REQUEST */]:{return Object.assign({},state,{municipalities:Object.assign({},state.municipalities,{isFetching:action.isFetching}),timestamp:action.timestamp});}case __WEBPACK_IMPORTED_MODULE_0__store_config__["p" /* AGENCIES_MUNICIPALITIES_FETCH */]:{return Object.assign({},state,{municipalities:Object.assign({},state.municipalities,{isFetching:action.isFetching,list:action.payload}),timestamp:action.timestamp});}default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (agencies);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var amountsAgenciesInit={isFetching:false,list:[],pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:'',modality_id:'',version_id:''},permissions:[],edit:{},error:undefined,timestamp:undefined};var amounts_agencies=function amounts_agencies(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:amountsAgenciesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["w" /* AMOUNTS_AGENCIES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["x" /* AMOUNTS_AGENCIES_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["u" /* AMOUNTS_AGENCIES_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["t" /* AMOUNTS_AGENCIES_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["v" /* AMOUNTS_AGENCIES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (amounts_agencies);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var directoriesInit={isFetching:false,conago:[],actors:[],actors_groups:[],error:null,timestamp:null};var directories=function directories(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:directoriesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["V" /* DIRECTORIES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["T" /* DIRECTORIES_CONAGO_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,conago:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["R" /* DIRECTORIES_ACTORS_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,actors:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["S" /* DIRECTORIES_ACTORS_GROUPS_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,actors_groups:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["U" /* DIRECTORIES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (directories);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var modalitiesInit={isFetching:false,list:[],error:null,timestamp:null};var modalities=function modalities(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:modalitiesInit;var actions=arguments[1];switch(actions.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_37" /* MODALITIES_REQUEST */]:return Object.assign({},state,{isFetching:actions.isFetching,timestamp:actions.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_36" /* MODALITIES_FETCH */]:return Object.assign({},state,{isFetching:actions.isFetching,list:actions.payload,timestamp:actions.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_35" /* MODALITIES_FAIL */]:return Object.assign({},state,{isFetching:actions.isFetching,error:actions.error,timestamp:actions.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (modalities);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var resourceConceptInit={isFetching:false,list:[],pages:{current:0,per_page:0,total:0},edit:{},error:null,timestamp:null};var resource_concepts=function resource_concepts(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:resourceConceptInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_190" /* RESOURCE_CONCEPT_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_191" /* RESOURCE_CONCEPT_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_189" /* RESOURCE_CONCEPT_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (resource_concepts);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var revisionInit={isFetching:false,owner:{body:undefined,phase_slug:undefined},instance:{body:[],phase_slug:undefined,notification_type_id:undefined},registry:{body:{},phase_slug:undefined},expenses:{body:{},phase_slug:undefined},profiles:{body:{},phase_slug:undefined},conclusion:{body:{},phase_slug:undefined,notification_type_id:undefined},commission:{spvpu:{},projects:{},project:{},answers:[],finished:false,comments:undefined,revision:undefined},agreements:{admin:{body:{},phase_slug:undefined,notification_type_id:undefined},legal:{body:{},phase_slug:undefined,notification_type_id:undefined}},reports:{financial:{notification_type_id:undefined,body:{},phase_slug:undefined,agency:[]},expenses:{notification_type_id:undefined,body:{},phase_slug:undefined,agency:[]},summary:{notification_type_id:undefined,body:{},phase_slug:undefined}},phase_group:{},notifications_types:[],permissions:[],surveyShow:false,error:undefined,timestamp:undefined};var revision=function revision(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:revisionInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_205" /* REVISION_OWNER */]:return Object.assign({},state,{owner:Object.assign({},state.owner,action.payload),phase_group:action.phase_group,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_204" /* REVISION_INSTANCE */]:return Object.assign({},state,{instance:Object.assign({},state.instance,action.payload),phase_group:action.phase_group,notifications_types:action.notifications_types,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_207" /* REVISION_REGISTRY */]:return Object.assign({},state,{//isFetching: action.isFetching,
registry:Object.assign({},state.registry,action.payload),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_206" /* REVISION_PROFILES */]:{return Object.assign({},state,{//isFetching: action.isFetching,
profiles:Object.assign({},state.profiles,action.payload),permissions:action.permissions,timestamp:action.timestamp});}case __WEBPACK_IMPORTED_MODULE_0__store_config__["_202" /* REVISION_EXPENSES */]:return Object.assign({},state,{//isFetching: action.isFetching,
expenses:Object.assign({},state.expenses,action.payload),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_200" /* REVISION_CONCLUSION */]:return Object.assign({},state,{//isFetching: action.isFetching,
conclusion:Object.assign({},state.conclusion,action.payload),phase_group:action.phase_group,notifications_types:action.notifications_types,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_201" /* REVISION_CONCLUSION_EDIT */]:return Object.assign({},state,{//isFetching: action.isFetching,
conclusion:Object.assign({},state.conclusion,action.payload),phase_group:action.phase_group,notifications_types:action.notifications_types,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_192" /* REVISION_AGREEMENTS_ADMIN */]:return Object.assign({},state,{isFetching:action.isFetching,agreements:Object.assign({},state.agreements,{admin:Object.assign({},state.agreements.admin,action.payload)}),phase_group:action.phase_group,notifications_types:action.notifications_types,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_193" /* REVISION_AGREEMENTS_ADMIN_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,agreements:Object.assign({},state.agreements,{admin:Object.assign({},state.agreements.admin,action.payload)}),phase_group:action.phase_group,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_194" /* REVISION_AGREEMENTS_LEGAL */]:return Object.assign({},state,{isFetching:action.isFetching,agreements:Object.assign({},state.agreements,{legal:Object.assign({},state.agreements.legal,action.payload)}),phase_group:action.phase_group,notifications_types:action.notifications_types,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_195" /* REVISION_AGREEMENTS_LEGAL_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,agreements:Object.assign({},state.agreements,{legal:Object.assign({},state.agreements.legal,action.payload)}),phase_group:action.phase_group,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_209" /* REVISION_REPORTS_FINANCIAL */]:return Object.assign({},state,{reports:Object.assign({},state.reports,{financial:Object.assign({},state.reports.financial,action.payload)}),phase_group:action.phase_group,notifications_types:action.notifications_types,isFetching:action.isFetching,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_208" /* REVISION_REPORTS_EXPENSES */]:return Object.assign({},state,{reports:Object.assign({},state.reports,{expenses:Object.assign({},state.reports.expenses,action.payload)}),phase_group:action.phase_group,notifications_types:action.notifications_types,isFetching:action.isFetching,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_210" /* REVISION_REPORTS_SUMMARY */]:return Object.assign({},state,{reports:Object.assign({},state.reports,{summary:Object.assign({},state.reports.summary,action.payload)}),phase_group:action.phase_group,notifications_types:action.notifications_types,isFetching:action.isFetching,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_197" /* REVISION_COMMISSION */]:return Object.assign({},state,{isFetching:action.isFetching,commission:Object.assign({},state.commission,action.payload),permissions:action.permissions,timestamp:action.timestamp/*case REVISION_COMMISSION_SAVE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}*/});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_198" /* REVISION_COMMISSION_CLEAR */]:return Object.assign({},state,{isFetching:action.isFetching,commission:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_211" /* REVISION_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_199" /* REVISION_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_203" /* REVISION_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_196" /* REVISION_CLEAR */]:return Object.assign({},state,action.payload,{timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (revision);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var notificationMessagesInit={isFetching:false,list:[],edit:{states:[],entity:{isFetching:false,id:1}},notifications_types:[],permissions:[],types:[],error:undefined,timestamp:undefined};var notification_messages=function notification_messages(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:notificationMessagesInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_53" /* NOTIFICATION_MESSAGES_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_50" /* NOTIFICATION_MESSAGES_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_55" /* NOTIFICATION_STATES_REQUEST */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{entity:Object.assign({},state.edit.entity,{isFetching:action.isFetching})}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_56" /* NOTIFICATION_STATES_SAVE */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{entity:Object.assign({},state.edit.entity,{isFetching:action.isFetching})}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_52" /* NOTIFICATION_MESSAGES_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload.list,edit:Object.assign({},state.edit,{states:action.payload.states,finished:action.payload.finished}),notifications_types:action.payload.notifications_types,permissions:action.payload.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_51" /* NOTIFICATION_MESSAGES_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_49" /* NOTIFICATION_MESSAGES_CLEAR */]:return Object.assign({},state,{list:[],edit:{states:[],entity:{isFetching:false,id:1}},notifications_types:[],permissions:[],timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_57" /* NOTIFICATION_TYPES_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,types:action.payload,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (notification_messages);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var notificationTypiInit={isFetching:false,list:[],edit:{},pages:{current:undefined,per_page:undefined,total:undefined},filters:{q:'',role_id:'',status_id:''},permissions:[],error:undefined,timestamp:undefined};var notifications_types=function notifications_types(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:notificationTypiInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_61" /* NOTIFICATION_TYPE_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_62" /* NOTIFICATION_TYPE_SHOW */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_59" /* NOTIFICATION_TYPE_EDIT */]:return Object.assign({},state,{isFetching:action.isFetching,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_58" /* NOTIFICATION_TYPE_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_60" /* NOTIFICATION_TYPE_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (notifications_types);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var surveysInit={isFetching:false,list:[],types:{isFetching:false,list:[]},pages:{current:undefined,per_page:undefined,total:undefined},edit:{children_questions:[]},permissions:[],error:null,message:null};var surveys=function surveys(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:surveysInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_238" /* SURVEYS_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_239" /* SURVEYS_TYPES_REQUEST */]:return Object.assign({},state,{types:Object.assign({},state.types,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_234" /* SURVEYS_FETCH */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,pages:action.pages,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_235" /* SURVEYS_FETCH_LIST */]:return Object.assign({},state,{isFetching:action.isFetching,list:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_236" /* SURVEYS_FETCH_TYPES */]:return Object.assign({},state,{types:Object.assign({},state.types,{isFetching:action.isFetching,list:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_232" /* SURVEYS_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,action.payload),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_237" /* SURVEYS_QUESTIONS_EDIT */]:return Object.assign({},state,{edit:Object.assign({},state.edit,{questions:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_230" /* SURVEYS_CLEAR */]:return Object.assign({},state,{edit:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_231" /* SURVEYS_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_233" /* SURVEYS_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.isFetching,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (surveys);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var reportsInit={isFetching:false,project_name:undefined,financial:{isFetching:false,data:{},edit:{isFetching:false,action:undefined},revision:{}},expenses:{isFetching:false,data:{},edit:{isFetching:false,action:undefined},agency:[],revision:{}},employees:{isFetching:false,data:{},edit:{isFetching:false,action:undefined},revision:{}},surveys:{isFetching:false,data:{}},summary:{isFetching:false,data:{},edit:{},revision:{}},phase_group:{},version:{},permissions:[],error:undefined,timestamp:undefined};var reports=function reports(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:reportsInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_177" /* REPORTS_FINANCIAL_REQUEST */]:return Object.assign({},state,{financial:Object.assign({},state.financial,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_170" /* REPORTS_FINANCIAL */]:return Object.assign({},state,{project_name:action.payload.name,financial:Object.assign({},state.financial,{isFetching:action.isFetching,data:action.payload,revision:action.revision}),version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_174" /* REPORTS_FINANCIAL_EDIT_REQUEST */]:return Object.assign({},state,{financial:Object.assign({},state.financial,{edit:Object.assign({},state.financial.edit,{isFetching:action.isFetching})}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_176" /* REPORTS_FINANCIAL_GOAL */]:return Object.assign({},state,{project_name:action.payload.name,financial:Object.assign({},state.financial,{data:action.payload,edit:Object.assign({},state.financial.edit,action.edit,{isFetching:action.isFetching})}),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_171" /* REPORTS_FINANCIAL_ACTIVITY */]:return Object.assign({},state,{project_name:action.payload.name,financial:Object.assign({},state.financial,{data:action.payload,edit:Object.assign({},state.financial.edit,action.edit,{isFetching:action.isFetching})}),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_173" /* REPORTS_FINANCIAL_EDIT_FAIL */]:return Object.assign({},state,{financial:Object.assign({},state.financial,{edit:Object.assign({},state.financial.edit,{isFetching:action.isFetching})}),error:action.error,timestamp:action.timestamp/*case REPORTS_FINANCIAL_EDIT_INVOICE_FAIL:
			return{
				...state,
				financial:{
					...state.financial,
					edit: {
						...state.financial.edit,
						xmlForm: action.show
					}
				},
				timestamp: action.timestamp
			}*/});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_172" /* REPORTS_FINANCIAL_CLEAR */]:return Object.assign({},state,{financial:Object.assign({},state.financial,{data:action.payload,edit:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_175" /* REPORTS_FINANCIAL_FAIL */]:return Object.assign({},state,{financial:Object.assign({},state.financial,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_169" /* REPORTS_EXPENSES_REQUEST */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_163" /* REPORTS_EXPENSES */]:return Object.assign({},state,{project_name:action.payload.name,expenses:Object.assign({},state.expenses,{isFetching:action.isFetching,data:action.payload,revision:action.revision}),version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_164" /* REPORTS_EXPENSES_CLEAR */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{data:action.payload,edit:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_168" /* REPORTS_EXPENSES_FAIL */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_167" /* REPORTS_EXPENSES_EDIT_REQUEST */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{edit:Object.assign({},state.expenses.edit,{isFetching:action.isFetching})}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_165" /* REPORTS_EXPENSES_EDIT */]:return Object.assign({},state,{project_name:action.payload.name,expenses:Object.assign({},state.expenses,{data:action.payload,edit:Object.assign({},state.expenses.edit,action.edit,{isFetching:action.isFetching})}),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_166" /* REPORTS_EXPENSES_EDIT_FAIL */]:return Object.assign({},state,{expenses:Object.assign({},state.expenses,{edit:Object.assign({},state.expenses.edit,{isFetching:action.isFetching})}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_162" /* REPORTS_EMPLOYEES_REQUEST */]:return Object.assign({},state,{employees:Object.assign({},state.employees,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_156" /* REPORTS_EMPLOYEES */]:return Object.assign({},state,{project_name:action.payload.name,employees:Object.assign({},state.employees,{isFetching:action.isFetching,data:action.payload,revision:action.revision}),version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_157" /* REPORTS_EMPLOYEES_CLEAR */]:return Object.assign({},state,{employees:Object.assign({},state.employees,{data:action.payload,edit:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_161" /* REPORTS_EMPLOYEES_FAIL */]:return Object.assign({},state,{employees:Object.assign({},state.employees,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_160" /* REPORTS_EMPLOYEES_EDIT_REQUEST */]:return Object.assign({},state,{employees:Object.assign({},state.employees,{edit:Object.assign({},state.employees.edit,{isFetching:action.isFetching})}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_158" /* REPORTS_EMPLOYEES_EDIT */]:return Object.assign({},state,{project_name:action.payload.name,employees:Object.assign({},state.employees,{data:action.payload,edit:Object.assign({},state.employees.edit,action.edit,{isFetching:action.isFetching})}),permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_159" /* REPORTS_EMPLOYEES_EDIT_FAIL */]:return Object.assign({},state,{employees:Object.assign({},state.employees,{edit:Object.assign({},state.employees.edit,{isFetching:action.isFetching})}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_182" /* REPORTS_SUMMARY_REQUEST */]:return Object.assign({},state,{summary:Object.assign({},state.summary,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_180" /* REPORTS_SUMMARY_COMPLETE */]:return Object.assign({},state,{summary:Object.assign({},state.summary,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_178" /* REPORTS_SUMMARY */]:return Object.assign({},state,{project_name:action.payload.name,summary:Object.assign({},state.summary,{isFetching:action.isFetching,data:action.payload,edit:Object.assign({},state.summary.edit,action.edit),revision:action.revision}),phase_group:action.phase_group,permissions:action.permissions,version:action.version,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_179" /* REPORTS_SUMMARY_CLEAR */]:return Object.assign({},state,{summary:Object.assign({},state.summary,{data:action.payload,edit:action.payload,revision:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_181" /* REPORTS_SUMMARY_FAIL */]:return Object.assign({},state,{summary:Object.assign({},state.summary,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_186" /* REPORTS_SURVEYS_REQUEST */]:return Object.assign({},state,{surveys:Object.assign({},state.surveys,{isFetching:action.isFetching}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_183" /* REPORTS_SURVEYS */]:return Object.assign({},state,{surveys:Object.assign({},state.surveys,{isFetching:action.isFetching,data:action.payload}),version:action.version,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_184" /* REPORTS_SURVEYS_CLEAR */]:return Object.assign({},state,{surveys:Object.assign({},state.surveys,{data:action.payload}),timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_185" /* REPORTS_SURVEYS_FAIL */]:return Object.assign({},state,{surveys:Object.assign({},state.surveys,{isFetching:action.isFetching}),error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (reports);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var registerInit={isFetching:false,data:{},modalities:[],state:'close',style:'is-one-third',action:undefined,error:undefined,status:undefined,message:undefined,timestamp:undefined//is-8 para registro validado
//is-one-third para validar
//is-9 para registro nuevo
};var register=function register(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:registerInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_154" /* REGISTER_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,status:action.status,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_155" /* REGISTER_VALIDATE */]:return Object.assign({},state,{isFetching:action.isFetching,status:action.status,data:action.payload.data,modalities:action.payload.modalities,state:action.payload.state,action:action.payload.action,style:action.payload.style,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_153" /* REGISTER_NOT_VALIDATE */]:return Object.assign({},state,{isFetching:action.isFetching,status:action.status,message:action.message,data:action.payload.data,modalities:action.payload.modalities,state:action.payload.state,action:action.payload.action,style:action.payload.style,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_151" /* REGISTER_COMPLETE */]:return Object.assign({},state,{isFetching:action.isFetching,status:action.status,message:action.message,data:action.payload.data,modalities:action.payload.modalities,state:action.payload.state,action:action.payload.action,style:action.payload.style,error:action.error,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_152" /* REGISTER_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,status:action.status,message:action.message,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (register);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var menuInit={view:true,timestamp:undefined};var menu=function menu(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:menuInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["_34" /* MENU_SHOW */]:return Object.assign({},state,{view:action.payload,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["_33" /* MENU_HIDE */]:return Object.assign({},state,{view:action.payload,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (menu);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var cdmsInit={isFetching:false,data:{},edit:{},permissions:[],error:undefined,timestamp:undefined};var cdms=function cdms(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:cdmsInit;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__store_config__["J" /* CDM_REQUEST */]:return Object.assign({},state,{isFetching:action.isFetching,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["H" /* CDM_EMPLOYEES */]:return Object.assign({},state,{isFetching:action.isFetching,data:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["G" /* CDM_CLEAR */]:return Object.assign({},state,{data:action.payload,edit:action.payload,permissions:action.permissions,timestamp:action.timestamp});case __WEBPACK_IMPORTED_MODULE_0__store_config__["I" /* CDM_FAIL */]:return Object.assign({},state,{isFetching:action.isFetching,error:action.error,timestamp:action.timestamp});default:return Object.assign({},state);}};/* harmony default export */ __webpack_exports__["a"] = (cdms);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var logger=function logger(store){return function(next){return function(action){console.group(action.type);console.info('dispatching',action);var result=next(action);console.log('next state',store.getState());console.groupEnd();return result;};};};/* unused harmony default export */ var _unused_webpack_default_export = (logger);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(40).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var round=function round(number){return Math.round(number*100)/100;};var monitorReducerEnhancer=function monitorReducerEnhancer(createStore){return function(reducer,initialState,enhancer){var monitoredReducer=function monitoredReducer(state,action){var start=performance.now();var newState=reducer(state,action);var end=performance.now();var diff=round(end-start);//console.log('reducer process time:', diff)
return newState;};return createStore(monitoredReducer,initialState,enhancer);};};/* harmony default export */ __webpack_exports__["a"] = (monitorReducerEnhancer);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserReset=function(_Component){_inherits(UserReset,_Component);function UserReset(){_classCallCheck(this,UserReset);return _possibleConstructorReturn(this,(UserReset.__proto__||Object.getPrototypeOf(UserReset)).apply(this,arguments));}_createClass(UserReset,[{key:"render",value:function render(){var _this2=this;var required=function required(val){return val&&val.length;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-5 has-text-centered"},"Restablecer Contrase\xF1a"),this.props.message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-success"},this.props.message),this.props.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-danger"},this.props.error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["LocalForm"],{model:"reset",onSubmit:function onSubmit(val){return _this2._handleSubmit(val);},validators:{'':{passwordsMatch:function passwordsMatch(vals){return vals.password===vals.password_confirmation;}}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icon has-icon-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{type:"email",model:".username",className:"input",placeholder:"Usuario",autoFocus:true,validators:{required:required}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-envelope"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".username",show:"touched",messages:{required:'Tu usuario es requerido',typeMismatch:'El usuario que ingresaste es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icon has-icon-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].password,{model:".password",className:"input",placeholder:"Contrase\xF1a",validators:{required:required}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lock"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".password",show:"touched",messages:{required:'Tu contraseña es requerida'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icon has-icon-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].password,{model:".password_confirmation",className:"input",placeholder:"Confirmar Contrase\xF1a",validators:{required:required}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lock"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".password_confirmation",show:"touched",messages:{required:'La confirmación de tu contraseña es requerida'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"reset",show:"touched",messages:{passwordsMatch:'La confirmación de la contraseña no coincide'},wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-danger"},props.children);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Restablecer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-sign-in"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.props.setActionType('login');},className:"button is-small is-link"},"Regresar")));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.userReset(values,this.props.query);this.props.setActionType('login');}}]);return UserReset;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserReset);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserForgot=function(_Component){_inherits(UserForgot,_Component);function UserForgot(){_classCallCheck(this,UserForgot);return _possibleConstructorReturn(this,(UserForgot.__proto__||Object.getPrototypeOf(UserForgot)).apply(this,arguments));}_createClass(UserForgot,[{key:"render",value:function render(){var _this2=this;var required=function required(val){return val&&val.length;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-5 has-text-centered"},"Recuperar Contrase\xF1a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered"},"Ingresa tu e-mail y haz clic en ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"recuperar")," para recibir las instrucciones y recuperar tu contrase\xF1a."),this.props.message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-success"},this.props.message),this.props.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-danger"},this.props.error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["LocalForm"],{onSubmit:function onSubmit(val){return _this2._handleSubmit(val);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icon has-icon-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{type:"email",model:".username",className:"input",placeholder:"Usuario",autoFocus:true,validators:{required:required}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-envelope"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".username",show:"touched",messages:{required:'Debes ingresar tu usuario',typeMismatch:'El usuario que ingresaste es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.props.setActionType('login');},className:"button is-small"},"Regresar a iniciar sesi\xF3n"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Recuperar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-paper-plane"}))))))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.userRecover(values);}}]);return UserForgot;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserForgot);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WelcomeBox=function(_Component){_inherits(WelcomeBox,_Component);function WelcomeBox(){_classCallCheck(this,WelcomeBox);return _possibleConstructorReturn(this,(WelcomeBox.__proto__||Object.getPrototypeOf(WelcomeBox)).apply(this,arguments));}_createClass(WelcomeBox,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns login-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-5 has-text-centered"},"\xA1Hola ",this.props.userLogin.name,"!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/inicio',className:"button is-inm-purple",style:{margin:'30px auto 0 auto',display:'block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Ingresar a e-trans"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-sign-in"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1 has-text-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:"/logout",className:"link is-black"},"Cambiar usuario")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"login-box--notification",href:"/version2017.html",target:"_blank"},"Acceder a versi\xF3n 2017 ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-external-link"})));}}]);return WelcomeBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WelcomeBox);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_login__ = __webpack_require__(111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginLayout=function(_Component){_inherits(LoginLayout,_Component);function LoginLayout(){_classCallCheck(this,LoginLayout);return _possibleConstructorReturn(this,(LoginLayout.__proto__||Object.getPrototypeOf(LoginLayout)).apply(this,arguments));}_createClass(LoginLayout,[{key:'render',value:function render(){return'';}},{key:'componentWillMount',value:function componentWillMount(){this.props.logout();}}]);return LoginLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var userLogin=state.userLogin;return{userLogin:userLogin};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{logout:function logout(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_login__["b" /* logout */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(LoginLayout)));

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_register__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_gobmxlogo_svg__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_gobmxlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_gobmxlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_inm_svg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_inm_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_logo_inm_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_register_register__ = __webpack_require__(430);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from "lodash";
//import Loading from "./elements/loading";
var RegisterLayout=function(_Component){_inherits(RegisterLayout,_Component);function RegisterLayout(){_classCallCheck(this,RegisterLayout);return _possibleConstructorReturn(this,(RegisterLayout.__proto__||Object.getPrototypeOf(RegisterLayout)).apply(this,arguments));}_createClass(RegisterLayout,[{key:'render',value:function render(){var register=this.props.register;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'hero is-fullheight is-black login-layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'nav',style:{backgroundColor:'#393c3e'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'nav-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_gobmxlogo_svg___default.a,alt:'Logo'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},register.style!=='is-10'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-one-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_logo_inm_svg___default.a,alt:'Instituto Nacional de la Mujer',className:'logo-inm'}))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered is-gapless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column '+register.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_register_register__["a" /* default */],this.props))))));}},{key:'componentWillMount',value:function componentWillMount(){var state=this.props.register.state;if(state==='close'){this.props.validateRegister();}}}]);return RegisterLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;var mapStateToProps=function mapStateToProps(state){var register=state.register;return{register:register};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{validateRegister:function validateRegister(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_register__["d" /* validateRegister */])());},validateEmail:function validateEmail(email){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_register__["c" /* validateEmail */])(email));},registerUser:function registerUser(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_register__["b" /* registerUser */])(values));},registerEmail:function registerEmail(values){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_register__["a" /* registerEmail */])(values));},change:function change(model,value){dispatch(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["actions"].change(model,value));},reset:function reset(){dispatch(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["actions"].reset('register'));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_register__["d" /* validateRegister */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(RegisterLayout)));

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__registerValidate__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registerUser__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registerEmail__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_loading__ = __webpack_require__(201);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterBox=function(_Component){_inherits(RegisterBox,_Component);function RegisterBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RegisterBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterBox.__proto__||Object.getPrototypeOf(RegisterBox)).call.apply(_ref,[this].concat(args))),_this),_this._actionPane=function(action){switch(action){case'register_not_validate':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__registerUser__["a" /* default */],_this.props);case'register_validate':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__registerEmail__["a" /* default */],_this.props);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__registerValidate__["a" /* default */],_this.props);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterBox,[{key:'render',value:function render(){var register=this.props.register;var content=this._actionPane(register.action);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns login-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},register.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__login_loading__["a" /* default */],{message:register.status}):content))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'login-box--notification',href:'/version2017.html',target:'_blank'},'Acceder a versi\xF3n 2017 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'})));}}]);return RegisterBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegisterBox);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterValidate=function(_Component){_inherits(RegisterValidate,_Component);function RegisterValidate(){_classCallCheck(this,RegisterValidate);return _possibleConstructorReturn(this,(RegisterValidate.__proto__||Object.getPrototypeOf(RegisterValidate)).apply(this,arguments));}_createClass(RegisterValidate,[{key:"render",value:function render(){var _this2=this;//const required = (val) => val && val.length;
var register=this.props.register;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-5 has-text-centered"},"Registro"),register.state==='open'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered"},"Ingresa tu e-mail para comenzar."):'',register.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-danger"},register.error),register.message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-success"},register.message),register.state==='open'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["LocalForm"],{onSubmit:function onSubmit(val){return _this2._handleSubmit(val);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icon has-icon-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{type:"email",model:".email",className:"input",placeholder:"E-mail",autoFocus:true,errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */],isEmail:__WEBPACK_IMPORTED_MODULE_2__field_validations__["c" /* isEmail */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-envelope"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".email",show:"touched",messages:{required:'Debes ingresar tu e-mail',isEmail:'El email es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2.props.history.push('/');},className:"button is-small"},"Regresar a iniciar sesi\xF3n"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"submit",className:"button is-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Validar")))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-1 has-text-black has-text-centered"},"Registro cerrado"));}},{key:"_handleSubmit",value:function _handleSubmit(values){//console.log('email===>', values.email);
this.props.validateEmail(values.email);}}]);return RegisterValidate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegisterValidate);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterUser=function(_Component){_inherits(RegisterUser,_Component);function RegisterUser(){_classCallCheck(this,RegisterUser);return _possibleConstructorReturn(this,(RegisterUser.__proto__||Object.getPrototypeOf(RegisterUser)).apply(this,arguments));}_createClass(RegisterUser,[{key:"render",value:function render(){var _this2=this;var register=this.props.register;var listData=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(register.data)&&register.data.modality_id?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(register.modalities,{id:register.data.modality_id}):undefined;var roleList=listData?listData.roles:[];var statesList=listData?listData.states:[];var stateData=listData&&listData.id===2&&register.data.state_id?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(statesList,{id:register.data.state_id}):undefined;var municipalitiesList=stateData?stateData.municipalities:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-5 has-text-left"},"Registro de usuario"),register.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-danger"},register.error),register.message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-success"},register.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"register.data",onSubmit:function onSubmit(val){return _this2._handleSubmit(val);},validators:{'':{passwordsMatch:function passwordsMatch(vals){return vals&&vals.password===vals.password_confirmation?'La confirmación de la contraseña no coincide':undefined;}}},onSubmitFailed:function onSubmitFailed(error){console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre(s) ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".name",className:"input",id:"name",autoFocus:true,errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El nombre es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"last_name",className:"label"},"Primer Apellido ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".last_name",className:"input",id:"last_name",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".last_name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El apellido es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"slast_name",className:"label"},"Segundo Apellido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".slast_name",className:"input",id:"slast_name"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"rfc",className:"label"},"RFC ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".rfc",className:"input",id:"rfc",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],isRfc:__WEBPACK_IMPORTED_MODULE_2__field_validations__["e" /* isRfc */]},validateOn:"change",parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".rfc",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Debes ingresar tu RFC',isRfc:'RFC inválido. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"curp",className:"label"},"CURP ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".curp",className:"input",id:"curp",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],maxLength:Object(__WEBPACK_IMPORTED_MODULE_2__field_validations__["g" /* maxLength */])(18),isCurp:__WEBPACK_IMPORTED_MODULE_2__field_validations__["b" /* isCurp */]},validateOn:"change",parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".curp",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Debes ingresar tu CURP',isCurp:'CURP inválida.',maxLength:'CURP inválida.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"email",className:"label"},"Email ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"has-text-grey"},"(para ingresar a la plataforma)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control has-icon has-icon-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{type:"email",model:".email",className:"input",placeholder:"E-mail",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */],isEmail:__WEBPACK_IMPORTED_MODULE_2__field_validations__["c" /* isEmail */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small is-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-envelope"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".email",show:"touched",messages:{isRequired:'Debes ingresar tu e-mail',isEmail:'El email es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"password",className:"label"},"Contrase\xF1a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].password,{model:".password",id:"password",name:"password",className:"input",placeholder:"Contrase\xF1a",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".password",show:"touched",messages:{isRequired:'Tu contraseña es requerida'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"password_confirmation",className:"label"},"Contrase\xF1a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].password,{model:".password_confirmation",id:"password_confirmation",name:"password_confirmation",className:"input",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:".password_confirmation",show:"touched",messages:{isRequired:'La confirmación de tu contraseña es requerida'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{className:"help is-danger",model:"register.data",show:"touched",messages:{passwordsMatch:'La confirmación de la contraseña no coincide'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"modality_id",className:"label"},"Modalidad ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".modality_id",id:"modality_id",changeAction:function changeAction(model,value){return _this2._changeMod(model,value);},errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Modalidad ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(register.modalities,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:option.id,key:k},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".modality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes seleccionar una modalidad.'}})),listData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"roles",className:"label"},"Perfil ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"roles",model:".role_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Perfil ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(roleList,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.display?row.display:row.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".role_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El perfil es obligatorio'}})):'',listData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"state_id",className:"label"},"Instancia ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"state_id",model:".state_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Instancia ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(statesList,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".state_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'La instancia es obligatoria'}})):''),stateData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"municipality_id",className:"label"},"Municipio ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"municipality_id",model:".municipality_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Municipio ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(municipalitiesList,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".municipality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El municipio es obligatorio'}}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2.props.reset();},className:"button"},"Regresar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"register.data",className:"button is-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Registrar")))))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.registerUser(values);//console.log('values===>', values);
}},{key:"_changeMod",value:function _changeMod(model,value){if(value==='1'||value==='3'){this._getConfirm(model,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(value));}else{this.props.change(model,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(value));}}},{key:"_getConfirm",value:function _getConfirm(model,value){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro/segura?',message:"\xBFEstas seguro/segura de ser titular de IMEF?",confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.change(model,value);},onCancel:function onCancel(){return _this3.props.change('register.data.modality_id','');}});}}]);return RegisterUser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegisterUser);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterEmail=function(_Component){_inherits(RegisterEmail,_Component);function RegisterEmail(){_classCallCheck(this,RegisterEmail);return _possibleConstructorReturn(this,(RegisterEmail.__proto__||Object.getPrototypeOf(RegisterEmail)).apply(this,arguments));}_createClass(RegisterEmail,[{key:"render",value:function render(){var _this2=this;var register=this.props.register;var listData=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(register.data)&&register.data.modality_id?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(register.modalities,{id:register.data.modality_id}):undefined;var roleList=listData?listData.roles:[];var statesList=listData?listData.states:[];var stateData=listData&&listData.id===2&&register.data.state_id?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(statesList,{id:register.data.state_id}):undefined;var municipalitiesList=stateData?stateData.municipalities:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"is-size-5 has-text-left"},"Registro de instancia"),register.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-danger"},register.error),register.message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-centered help is-success"},register.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"register.data",onSubmit:function onSubmit(val){return _this2._handleSubmit(val);},onSubmitFailed:function onSubmitFailed(error){console.log('error',error);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"has-text-grey"},register.data.name+" "+register.data.last_name+" "+register.data.slast_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"email",className:"label"},"Email: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"has-text-grey"},register.data.email)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"modality_id",className:"label"},"Modalidad ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".modality_id",id:"modality_id",changeAction:function changeAction(model,value){return _this2._changeMod(model,value);},errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:0,defaultValue:true},"--- Modalidad ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(register.modalities,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:option.id,key:k},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".modality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'Debes seleccionar una modalidad.'}})),listData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"roles",className:"label"},"Perfil ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"roles",model:".role_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Perfil ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(roleList,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.display?row.display:row.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".role_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El perfil es obligatorio'}})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},listData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"state_id",className:"label"},"Instancia ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"state_id",model:".state_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Instancia ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(statesList,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".state_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'La instancia es obligatoria'}})):'',stateData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"municipality_id",className:"label"},"Municipio ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"municipality_id",model:".municipality_id",errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Municipio ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(municipalitiesList,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".municipality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El municipio es obligatorio'}})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.props.reset();},className:"button"},"Regresar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"register.data",className:"button is-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Registrar")))))));}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.registerEmail(values);//console.log('values===>', values);
}},{key:"_changeMod",value:function _changeMod(model,value){if(value==='1'||value==='3'){this._getConfirm(model,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(value));}else{this.props.change(model,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(value));}}},{key:"_getConfirm",value:function _getConfirm(model,value){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro/segura?',message:"\xBFEstas seguro/segura de ser titular de IMEF?",confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.change(model,value);},onCancel:function onCancel(){return _this3.props.change('register.data.modality_id','');}});}}]);return RegisterEmail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegisterEmail);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_inmujeres_gray_svg__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_inmujeres_gray_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_inmujeres_gray_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_escudo_01_svg__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_escudo_01_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_escudo_01_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import {NavLink} from 'react-router-dom';
var Welcome=function(_Component){_inherits(Welcome,_Component);function Welcome(){_classCallCheck(this,Welcome);return _possibleConstructorReturn(this,(Welcome.__proto__||Object.getPrototypeOf(Welcome)).apply(this,arguments));}_createClass(Welcome,[{key:'render',value:function render(){var profile=this.props.session.user.profile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10 is-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_inmujeres_gray_svg___default.a,alt:'INMUJERES',style:{width:'auto',height:'120px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-itemgit '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_escudo_01_svg___default.a,alt:'INMUJERES',style:{width:'auto',height:'120px'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10 is-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,profile.sex==='M'?'Bienvenida':'Bienvenido',' ',profile.title?profile.title+'. '+profile.name:profile.name,','),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'El ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Instituto Nacional de las Mujeres'),' y en especial la ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Direcci\xF3n de la Pol\xEDtica Nacional de Igualdad en el \xC1mbito Pol\xEDtico y Social'),' responsable de la operaci\xF3n del Programa Proequidad, pone a disposici\xF3n de las Instancias de las Mujeres en las Entidades Federativas (IMEF), la Plataforma e-proequidad para el registro de la informaci\xF3n y documentaci\xF3n solicitada en las etapas del proceso y recibir notificaciones refrentes al Programa.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La cobertura del Proequidad es nacional; las 32 entidades federativas, los municipios y las alcald\xEDas de la Ciudad de M\xE9xico.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'La invitamos a consultar la secci\xF3n de "Ayuda\u201D donde encontrar\xE1 diferentes documentos normativos, de apoyo, as\xED como el calendario con las fechas m\xE1s relevantes de las etapas operativas del Programa.'))));}}]);return Welcome;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(Welcome));

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(163);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(166);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(167);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(98);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(72);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(168);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(169);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(99);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(73);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return usersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return usersFind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchUsersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return usersExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return userSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__);
var usersList=function usersList(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){dispatch(usersRequest());return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users?include[0]=roles&include[1]=status&page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(usersListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var usersFind=function usersFind(value){return function(dispatch){dispatch(usersRequest());return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users?q="+value+"&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(usersListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var fetchUsersList=function fetchUsersList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(usersRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(usersListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var usersExport=function usersExport(){var filters=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};//const token = sessionStorage.getItem('etrans_user');
return function(dispatch){dispatch(usersRequest());return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','Content-Type':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});var fileName=undefined;return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users?include[0]=roles&include[1]=status&export=1"+params,options).then(function(result){if(result.status>=200&&result.status<300){var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){//let today = new Date();
//let date = today.getFullYear() + ((today.getMonth() + 1) <10 ? `0${today.getMonth() + 1}`:today.getMonth() + 1) + (today.getDate()<10 ? `0${today.getDate()}`:today.getDate()) + today.getHours() + today.getMinutes() + today.getSeconds();
//FileSaver.saveAs(blob,`reporte_usuarios_${date}.xls`);
__WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(blob,fileName);dispatch(userComplete());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};/*Fetch User Edit*/var fetchUser=function fetchUser(id){return function(dispatch){dispatch(usersRequest());dispatch(userClear());return dispatch(userDetail(id)).then(function(user){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(user.payload)){if(user.payload.role_id){return dispatch(userAgencies(id)).then(function(agencies){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(agencies.payload)){return dispatch(userComplete());}else{return dispatch(usersFail(agencies.error));}});}else{return dispatch(userComplete());}}else{return dispatch(usersFail(user.error));}});};};var userDetail=function userDetail(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(userData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var userAgencies=function userAgencies(user){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users/"+user+"/agencies",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(userAgenciesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};/*User Save*/var userSave=function userSave(data){return function(dispatch){var agencies=data.agencies;var body=new FormData();if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(agencies)){if((__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(agencies)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(agencies))&&agencies.id&&agencies.state_id){body.append('municipality_id',agencies.id);}else if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(agencies)&&agencies.id&&!agencies.state_id){body.append('state_id',agencies.id);}else if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(agencies)){console.log('is many agencies');__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(agencies,function(o,i){if(o===true||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(o)){body.append("states["+i+"]",i);}});}else{body=false;}}else{body=false;}dispatch(usersRequest());return dispatch(userEditSave(data)).then(function(user){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(user.payload)){if(data.edit.id){return dispatch(userSaveRole(data,user.payload.id)).then(function(role){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(role.payload)){if(body){return dispatch(userAgencySave(user.payload.id,body)).then(function(agency){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(agency.payload)){return dispatch(userComplete());}else{return dispatch(usersFail(agency.error));}});}else{return dispatch(userComplete());}}else{return dispatch(usersFail(role.error));}});}else{return dispatch(userComplete());}}else{return dispatch(usersFail(user.error));}});};};var userEditSave=function userEditSave(data){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(data.edit)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users"+(data.edit.id?"/"+data.edit.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.edit.id)){__WEBPACK_IMPORTED_MODULE_4__store_store__["b" /* history */].push('/usuarios/editar/'+json.data.id);}return dispatch(userData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var userSaveRole=function userSaveRole(data,id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({role_id:data.edit.role_id})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users/"+id+"/roles",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.agencies)){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4__store_store__["b" /* history */].location.pathname==='/usuarios/crear'){__WEBPACK_IMPORTED_MODULE_4__store_store__["b" /* history */].push('/usuarios/editar/'+id);}}return dispatch(userRoleData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var userAgencySave=function userAgencySave(id,body){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users/"+id+"/agencies?_method=PUT",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Perfil de usuario actualizado correctamente',type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4__store_store__["b" /* history */].location.pathname==='/usuarios/crear'){__WEBPACK_IMPORTED_MODULE_4__store_store__["b" /* history */].push('/usuarios/editar/'+id);}return dispatch(userAgenciesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var userDelete=function userDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_6_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+"/users/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));dispatch(usersList());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(usersFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var usersRequest=function usersRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_245" /* USERS_REQUEST */],isFetching:true,timestamp:Date.now()};};var usersFail=function usersFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_244" /* USERS_FAIL */],error:error,isFetching:false,timestamp:Date.now()};};var usersListData=function usersListData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_246" /* USERS_SHOW */],isFetching:false,payload:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(json.data)?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(json.data,['id']):json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var userData=function userData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_250" /* USER_EDIT */],payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var userRoleData=function userRoleData(json){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_251" /* USER_ROLE */],payload:{role_id:json.data[0].id},timestamp:Date.now()};};var userAgenciesData=function userAgenciesData(json){var agencies=[];var data=void 0;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(json.data)){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapValues(json.data,function(o,k){agencies[o.id]=o;});data=agencies;}else{data=json.data;}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_247" /* USER_AGENCIES */],payload:data,timestamp:Date.now()};};var userComplete=function userComplete(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_249" /* USER_COMPLETE */],isFetching:false,timestamp:Date.now()};};var userClear=function userClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["_248" /* USER_CLEAR */],payload:{},permissions:[],timestamp:Date.now()};};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchProjectAgreementsWithRevision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return projectAgreements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return projectAgreementsExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return projectAgreementsSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__revision__ = __webpack_require__(207);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var fetchProjectAgreementsWithRevision=function fetchProjectAgreementsWithRevision(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var type=arguments[3];return function(dispatch){dispatch(projectAgreementsRequest());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__revision__["d" /* fetchRevisionAgreements */])(type,modality,state,mun)).then(function(revision){if(revision.error){return dispatch(projectAgreementsFail(revision.error));}else{return dispatch(projectAgreements(modality,state,mun));}});};};var projectAgreements=function projectAgreements(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectAgreementsRequest());dispatch(projectAgreementsClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/projects/agreements/agency/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectAgreementsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:'danger'}));return dispatch(projectAgreementsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var projectAgreementsExport=function projectAgreementsExport(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var fileName=undefined;dispatch(projectAgreementsRequest());return __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/projects/agreements/agency/bank-account-confirmation-pdf/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){__WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(blob,fileName);dispatch(projectAgreementsLoaded());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:'danger'}));return dispatch(projectAgreementsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var projectAgreementsSave=function projectAgreementsSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectAgreementsRequest());var body=new FormData();if(modality==='modalidad-i'){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(values.agency.fiscal_entity,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.startsWith(o,'http://')){body.append("fiscal_entity["+j+"]",o);}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append("fiscal_entity["+j+"]",o[0]);}}});__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(values.documents,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});}else{__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(values.documents,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});}if(values.finished){body.append('finished',values.finished);}var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/projects/agreements/agency/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Éxito!',content:json.message?json.message:'Se guardaron correctamente los cambios',type:'success'}));return dispatch(projectAgreementsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:'danger'}));return dispatch(projectAgreementsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var projectAgreementsData=function projectAgreementsData(json){var revisions=[];var documents={};if(json.data&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.documents)){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(json.data.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}if(json.data&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.agency)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.agency.documents)){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(json.data.agency.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.revisions)){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(json.revisions,function(data){revisions.push(Object.assign({},data,{body:JSON.parse(data.body)}));});}return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_100" /* PROJECT_AGREEMENTS */],isFetching:false,payload:Object.assign({},json.data,{finished:json.finished,documents:documents}),documents_items:json.documents_items,editable:json.editable,revisions:revisions,permissions:json.permissions,version:json.version,timestamp:Date.now()};};var projectAgreementsRequest=function projectAgreementsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_104" /* PROJECT_AGREEMENTS_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectAgreementsLoaded=function projectAgreementsLoaded(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_103" /* PROJECT_AGREEMENTS_LOADED */],isFetching:false,timestamp:Date.now()};};var projectAgreementsClear=function projectAgreementsClear(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_101" /* PROJECT_AGREEMENTS_CLEAR */],payload:{},timestamp:Date.now()};};var projectAgreementsFail=function projectAgreementsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_102" /* PROJECT_AGREEMENTS_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectDispersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return projectDispersionsExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return projectDispersionsSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var projectDispersions=function projectDispersions(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectDispersionsRequest());dispatch(projectDispersionsClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/projects/agreements/budgets/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(projectDispersionsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:'danger'}));return dispatch(projectDispersionsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var projectDispersionsExport=function projectDispersionsExport(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectDispersionsRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var fileName=undefined;return __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/projects/agreements/budgets/"+modality+"/"+state+(mun?'/'+mun:'')+"?export=1",options).then(function(result){if(result.status>=200&&result.status<300){var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){__WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(blob,fileName);dispatch(projectDispersionsLoaded());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:'danger'}));return dispatch(projectDispersionsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var projectDispersionsSave=function projectDispersionsSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){var budgets=[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(values.budgets,function(row){return budgets.push({project_id:row.project_id,dispersion_date:row.dispersion_date,method:row.method});});if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(budgets)){return dispatch(projectDispersionsEditSave(modality,state,mun,Object.assign({},values,{budgets:budgets})));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:'Agregar al menos una instancia para guardar',type:'danger'}));return dispatch(projectDispersionsFail('Agregar al menos una instancia para guardar'));}};};var projectDispersionsEditSave=function projectDispersionsEditSave(modality,state){var mun=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;var values=arguments[3];return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(projectDispersionsRequest());var body=new FormData();__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(values.budgets,function(o,j){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(o,function(item,k){if(item!==undefined){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(item)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.startsWith(item,'http://')){body.append("budgets["+j+"]["+k+"]",item);}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(item)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(item)&&item[0]!==undefined){body.append("budgets["+j+"]["+k+"]",item[0]);}}});});__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(values.documents,function(o,j){if(o!==undefined){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});/*if(values.tesofe_refound !== undefined){
				if(!_.isObject(values.tesofe_refound) &&  !_.startsWith(values.tesofe_refound, 'http://')){
					body.append(`tesofe_refound`,values.tesofe_refound);
				}else if(_.isObject(values.tesofe_refound) && !_.isEmpty(values.tesofe_refound) && values.tesofe_refound[0] !== undefined) {
					body.append(`tesofe_refound`,values.tesofe_refound[0]);
				}
			}

			if(values.budgets_dispersion_summary !== undefined){
				if(!_.isObject(values.budgets_dispersion_summary) &&  !_.startsWith(values.budgets_dispersion_summary, 'http://')){
					body.append(`budgets_dispersion_summary`,values.budgets_dispersion_summary);
				}else if(_.isObject(values.budgets_dispersion_summary) && !_.isEmpty(values.budgets_dispersion_summary) && values.budgets_dispersion_summary[0] !== undefined) {
					body.append(`budgets_dispersion_summary`,values.budgets_dispersion_summary[0]);
				}
			}*/var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};return __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_0__store_config__["y" /* API2_URL */]+"/projects/agreements/budgets/"+modality+"/"+state+(mun?'/'+mun:''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:"La información de la dispersion se ha guardado correctamente",type:"success"}));return dispatch(projectDispersionsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:'danger'}));return dispatch(projectDispersionsFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var projectDispersionsData=function projectDispersionsData(json){var documents={};var list=[];var responseData=[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(json.data.modalities,function(mods){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(mods.projects)){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(mods.projects,function(row){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(row.budget)){return list.push({modality_id:mods.id,modality_name:mods.name?mods.name:'---',project_id:row.id,agency_name:row.agency.name,agenciable_name:row.agency.agenciable.name,amount:row.amounts?row.amounts.total:0});}else{return responseData.push({modality_id:mods.id,modality_name:mods.name,project_id:row.id,agency_name:row.agency.name,agenciable_name:row.agency.agenciable.name,amount:row.amounts.total,dispersion_date:row.budget.dispersion_date,method:row.budget.method});}});}});if(json.data&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.project)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.project.documents)){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(json.data.project.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}if(json.data&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.agency)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.agency.documents)){__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(json.data.agency.documents,function(item){documents=Object.assign({},documents,_defineProperty({},item.documentable_subtype,item.file));});}return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_111" /* PROJECT_DISPERSIONS */],isFetching:false,payload:Object.assign({},json.data,{budgets:responseData,list:list,documents:documents}),documents_items:json.documents_items,editable:json.editable,revision:json.revision?Object.assign({},json.revision,{body:JSON.parse(json.revision.body)}):{},permissions:json.permissions,timestamp:Date.now()};};var projectDispersionsRequest=function projectDispersionsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_115" /* PROJECT_DISPERSIONS_REQUEST */],isFetching:true,timestamp:Date.now()};};var projectDispersionsLoaded=function projectDispersionsLoaded(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_114" /* PROJECT_DISPERSIONS_LOADED */],isFetching:false,timestamp:Date.now()};};var projectDispersionsClear=function projectDispersionsClear(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_112" /* PROJECT_DISPERSIONS_CLEAR */],payload:{list:[],budgets:[]},timestamp:Date.now()};};var projectDispersionsFail=function projectDispersionsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_113" /* PROJECT_DISPERSIONS_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return rolesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRolesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return roleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return roleDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
/*Roles Show*/var rolesShow=function rolesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(rolesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/roles?page="+page,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(rolesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(rolesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Roles List*/var fetchRolesList=function fetchRolesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(rolesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/roles?order_by[field]=display&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(rolesListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(rolesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Roles Edit*/var fetchRole=function fetchRole(id){return function(dispatch){dispatch(rolesRequest());dispatch(rolesClear());return dispatch(roleEdit(id)).then(function(role){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(role.payload)){return dispatch(rolesComplete());}else{return dispatch(rolesFail(role.error));}});};};var roleEdit=function roleEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/roles/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(roleEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(rolesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Roles Save*/var roleSave=function roleSave(values){return function(dispatch){dispatch(rolesRequest());var permissions=[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(values.permissions,function(item){return permissions.push(item.id);});if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(permissions)){return dispatch(roleEditSave(values)).then(function(role){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(role.payload)){return dispatch(rolePermissionsEditSave(values,role.payload.id,permissions)).then(function(permission){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(permission.payload)){return dispatch(rolesComplete());}else{return dispatch(rolesFail(permission.error));}});}else{return dispatch(rolesFail(role.error));}});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:"El perfil debe de contener mínimo un permiso",type:"danger"}));return dispatch(rolesFail("El perfil debe de contener mínimo un permiso"));}};};var roleEditSave=function roleEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({id:values.id,display:values.display,agenciable_type:values.agenciable_type})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/roles"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(roleEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(rolesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Roles/Permissions Save*/var rolePermissionsEditSave=function rolePermissionsEditSave(values,id,permissions){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({permissions:permissions})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/roles/"+id+"/permissions"+(values.id?"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/perfiles/editar/"+id);}return dispatch(permissionsRoleEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(rolesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Roles Delete*/var roleDelete=function roleDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'DELETE'};dispatch(rolesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/roles/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));dispatch(rolesShow());return dispatch(roleDeleteData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(rolesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/*Fetching*/var rolesRequest=function rolesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_216" /* ROLES_REQUEST */],isFetching:true,timestamp:Date.now()};};var rolesData=function rolesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_217" /* ROLES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var rolesListData=function rolesListData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_215" /* ROLES_LIST */],isFetching:false,payload:json.data,timestamp:Date.now()};};var roleEditData=function roleEditData(json){var response={};if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.permissions)){var permissions=[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(json.data.permissions,function(item){return permissions.push({id:item});});response=Object.assign({},json.data,{permissions:permissions});}else{response=json.data;}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_218" /* ROLE_EDIT */],payload:response,permissions:json.permissions,timestamp:Date.now()};};var permissionsRoleEditData=function permissionsRoleEditData(json){/*let permissions = [];
	_.mapKeys(json.data, (item) =>{permissions[item.id]=item.id});*/return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_220" /* ROLE_PERMISSIONS */],payload:json.data,timestamp:Date.now()};};var roleDeleteData=function roleDeleteData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_214" /* ROLES_DELETE */],isFetching:false,payload:json,timestamp:Date.now()};};var rolesComplete=function rolesComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_213" /* ROLES_COMPLETE */],isFetching:false,timestamp:Date.now()};};var rolesClear=function rolesClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_212" /* ROLES_CLEAR */],payload:{permissions:[]},permissions:[],timestamp:Date.now()};};/*Fails*/var rolesFail=function rolesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_219" /* ROLE_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return agenciesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return agencyEdit; });
/* unused harmony export fetchAgencyEdit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return agencyEditSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return agencyDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchAgencyMunicipalities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__versions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__municipalities__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__(15);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//import {fetchUserAgencies} from "./login";
var agenciesShow=function agenciesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){dispatch(agenciesRequest());return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/agencies?page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(agenciesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(agenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var agencyEdit=function agencyEdit(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(agenciesRequest());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__entities__["a" /* entitiesList */])());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__versions__["e" /* versionsList */])()).then(function(versions){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versions.payload)){if(id){return dispatch(fetchAgencyEdit(id));}else{return dispatch(agenciesComplete());}}else{return dispatch(agenciesFailed('Carga de instancia incompleta'));}});};};var fetchAgencyEdit=function fetchAgencyEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/agencies/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){if(json.data.agenciable_type==='imm'){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__municipalities__["d" /* municipalityEdit */])(json.data.agenciable_id)).then(function(municipality){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(municipality.payload)){//console.log('foundAgenciable===>');
var agenciable_state_id=municipality.payload.state_id;return dispatch(fetchAgencyMunicipalities(municipality.payload.state_id)).then(function(municipalities){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(municipalities.payload)){return dispatch(agenciesEditData(Object.assign({},json,{data:Object.assign({},json.data,{agenciable_state_id:agenciable_state_id})})));}else{return dispatch(agenciesFailed('Carga de instancia incompleta'));}});}else{return dispatch(agenciesFailed('Carga de instancia incompleta'));}});}else{return dispatch(agenciesEditData(json));}},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(agenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var agencyEditSave=function agencyEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(agenciesRequest());var body=Object.assign({},values,{agenciable_id:values.agenciable_type==='imef'?values.agenciable_state_id:values.agenciable_municipality_id});var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(body)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/agencies"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){//console.log('values===>', values);
//console.log('validate===>', _.isEmpty(values.id));
dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La instancia se ha guardado correctamente",type:"success"}));if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNumber(values.id)){//dispatch(fetchUserAgencies(sess.profile.access_token));
__WEBPACK_IMPORTED_MODULE_8__store_store__["b" /* history */].push("/instancias/editar/"+json.data.id);}else{//console.log('into else===>');
if(json.data.agenciable_type==='imm'){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__municipalities__["d" /* municipalityEdit */])(json.data.agenciable_id)).then(function(municipality){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(municipality.payload)){//console.log('foundAgenciable===>');
var agenciable_state_id=municipality.payload.state_id;return dispatch(fetchAgencyMunicipalities(municipality.payload.state_id)).then(function(municipalities){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(municipalities.payload)){return dispatch(agenciesEditData(Object.assign({},json,{data:Object.assign({},json.data,{agenciable_state_id:agenciable_state_id})})));}else{return dispatch(agenciesFailed('Carga de instancia incompleta'));}});}else{return dispatch(agenciesFailed('Carga de instancia incompleta'));}});}else{//console.log('advance here===>');
return dispatch(agenciesEditData(json));}}},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(agenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var agencyDelete=function agencyDelete(id){return function(dispatch){dispatch(agenciesRequest());return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/agencies/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La instancia se ha borrado exitosamente",type:"success"}));dispatch(agenciesShow());return dispatch(agenciesComplete());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(agenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var agenciesData=function agenciesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["s" /* AGENCIES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var agenciesEditData=function agenciesEditData(json){var response={};__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(json.data,function(item,key){response=Object.assign({},response,_defineProperty({},key,item?item:undefined));});if(json.data.agenciable_type==='imm'){response=Object.assign({},response,{agenciable_municipality_id:json.data.agenciable_id});}else{response=Object.assign({},response,{agenciable_state_id:json.data.agenciable_id});}response=Object.assign({},response,{state_id:!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(json.data.municipality)?json.data.municipality.state_id:undefined});return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["n" /* AGENCIES_EDIT */],isFetching:false,payload:response,permissions:json.permissions,timestamp:Date.now()};};var agenciesRequest=function agenciesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["r" /* AGENCIES_REQUEST */],isFetching:true,timestamp:Date.now()};};var agenciesComplete=function agenciesComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["m" /* AGENCIES_COMPLETE */],isFetching:false,timestamp:Date.now()};};var agenciesFailed=function agenciesFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["o" /* AGENCIES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var fetchAgencyMunicipalities=function fetchAgencyMunicipalities(entity){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(agencyMunicipalitiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/municipalities?state_id="+entity+"&order_by[field]=name&per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(agencyMunicipalitiesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(agenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var agencyMunicipalitiesRequest=function agencyMunicipalitiesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["q" /* AGENCIES_MUNICIPALITIES_REQUEST */],isFetching:true,timestamp:Date.now()};};var agencyMunicipalitiesData=function agencyMunicipalitiesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["p" /* AGENCIES_MUNICIPALITIES_FETCH */],isFetching:false,payload:json.data,timestamp:Date.now()};};

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return amountsAgenciesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return amountsAgenciesEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return amountsAgenciesEditSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return amountAgencyDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__versions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modalities__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__entities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__(15);
var amountsAgenciesShow=function amountsAgenciesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(amountsAgenciesRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/version-modality-agenciable?page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(amountsAgenciesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(amountsAgenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var amountsAgenciesEdit=function amountsAgenciesEdit(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:undefined;return function(dispatch){dispatch(amountsAgenciesRequest());dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__entities__["a" /* entitiesList */])());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__versions__["e" /* versionsList */])()).then(function(versions){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versions.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__modalities__["a" /* modalitiesList */])()).then(function(modalities){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(modalities.payload)){if(id){return dispatch(fetchAmountsAgenciesEdit(id));}else{dispatch(amountsAgenciesComplete());}}else{return dispatch(amountsAgenciesFailed('Carga de monto instancia incompleta'));}});}else{return dispatch(amountsAgenciesFailed('Carga de monto instancia incompleta'));}});};};var fetchAmountsAgenciesEdit=function fetchAmountsAgenciesEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/version-modality-agenciable/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(agenciesAmountsEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(amountsAgenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var amountsAgenciesEditSave=function amountsAgenciesEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(amountsAgenciesRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/version-modality-agenciable"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El monto se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_8__store_store__["b" /* history */].push("/instancias/montos/editar/"+json.data.id);}return dispatch(agenciesAmountsEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(amountsAgenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var amountAgencyDelete=function amountAgencyDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_2_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(amountsAgenciesRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/version-modality-agenciable/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El monto se ha eliminado correctamente",type:"success"}));dispatch(amountsAgenciesShow());return dispatch(amountsAgenciesComplete());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(amountsAgenciesFailed(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var amountsAgenciesData=function amountsAgenciesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["x" /* AMOUNTS_AGENCIES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var agenciesAmountsEditData=function agenciesAmountsEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["u" /* AMOUNTS_AGENCIES_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var amountsAgenciesRequest=function amountsAgenciesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["w" /* AMOUNTS_AGENCIES_REQUEST */],isFetching:true,timestamp:Date.now()};};var amountsAgenciesComplete=function amountsAgenciesComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["t" /* AMOUNTS_AGENCIES_COMPLETE */],isFetching:false,timestamp:Date.now()};};var amountsAgenciesFailed=function amountsAgenciesFailed(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["v" /* AMOUNTS_AGENCIES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchVersionGroupPhaseComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchVersionGroupsPhases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return versionGroupsPhasesEditSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalities__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__phases__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__groups_phases__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notifications_types__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__projects__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__entities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__surveys__ = __webpack_require__(212);
var fetchVersionGroupPhaseComplete=function fetchVersionGroupPhaseComplete(year,id){return function(dispatch){dispatch(versionGroupPhaseRequest());dispatch(versionGroupPhaseClear());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__modalities__["a" /* modalitiesList */])()).then(function(mod){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(mod.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__phases__["d" /* phasesList */])()).then(function(phases){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(phases.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__surveys__["b" /* fetchSurveysList */])()).then(function(surveys){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(surveys.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__groups_phases__["b" /* fetchGroupsPhasesList */])()).then(function(groups){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(groups.payload)){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__notifications_types__["b" /* fetchNotificationsTypesList */])()).then(function(types){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(types.payload)){return dispatch(fetchVersionGroupsPhases(year,id)).then(function(edit){if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(edit.payload)&&!edit.payload.all_projects){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__entities__["a" /* entitiesList */])());return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__projects__["h" /* fetchProjectsList */])(edit.payload.version_phase_group.version_id)).then(function(projects){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(projects.payload)){return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));}});}});}else{return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));}});}else{return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));}});}else{return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));}});}else{return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));}});}else{return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));}});};};var fetchVersionGroupsPhases=function fetchVersionGroupsPhases(year,id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};//dispatch(versionGroupPhaseRequest());
//dispatch(versionGroupPhaseClear());
//return fetch(`${API2_URL}/versions/${year}/phases-groups/${id}?include[0]=status&include[1]=phases.version_phase&include[2]=version_phase_group&include[3]=notifications_types_versions_phases.notification_type&include[4]=projects`, options)
return __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_3__store_config__["y" /* API2_URL */]+"/versions/"+year+"/phases-groups/"+id+"?include[0]=status&include[phases][version_phase][survey_version_phases][0]=survey&include[phases][version_phase][survey_version_phases][1]=modality&include[1]=version_phase_group&include[2]=notifications_types_versions_phases.notification_type&include[3]=projects",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(versionGroupPhaseEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(versionGroupPhaseFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var versionGroupsPhasesEditSave=function versionGroupsPhasesEditSave(year,values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_1_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(versionGroupPhaseRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};return __WEBPACK_IMPORTED_MODULE_2_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_3__store_config__["y" /* API2_URL */]+"/versions/"+year+"/phases-groups/"+values.id+"?include[0]=status&include[phases][version_phase][survey_version_phases][0]=survey&include[phases][version_phase][survey_version_phases][1]=modality&include[1]=version_phase_group&include[2]=notifications_types_versions_phases.notification_type&include[3]=projects&_method=PUT",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message,type:"success"}));return dispatch(versionGroupPhaseEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(versionGroupPhaseFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var versionGroupPhaseRequest=function versionGroupPhaseRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__store_config__["_265" /* VERSION_GROUPS_PHASES_REQUEST */],isFetching:true,timestamp:Date.now()};};var versionGroupPhaseEditData=function versionGroupPhaseEditData(json){var phases=[];var notifications_types=[];__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(json.data.notifications_types_versions_phases,function(item){return notifications_types.push({ntvp_id:item.id,id:item.notification_type_id,name:item.notification_type.name,body:item.body,modality_id:item.modality_id});});var response=Object.assign({},json.data,{notifications_types:notifications_types,all_projects:Boolean(json.data.version_phase_group.all_projects),assign_codes:Boolean(json.data.version_phase_group.assign_codes),show_current_revision:Boolean(json.data.version_phase_group.show_current_revision),start_date:json.data.version_phase_group.start_date,end_date:json.data.version_phase_group.end_date,report_start_date:json.data.version_phase_group.report_start_date,report_end_date:json.data.version_phase_group.report_end_date,is_closing:json.data.version_phase_group.is_closing});__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(json.data.phases,function(phase){if(phase){return phases.push({id:phase.id,name:phase.name,start_date:phase.version_phase.start_date,end_date:phase.version_phase.end_date,report_start_date:phase.version_phase.report_start_date,report_end_date:phase.version_phase.report_end_date,require_survey:phase.require_survey,survey_version_phases:phase.require_survey?phase.version_phase.survey_version_phases:[],type:phase.type});}});if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(phases)){response.phases=phases;}return{type:__WEBPACK_IMPORTED_MODULE_3__store_config__["_263" /* VERSION_GROUPS_PHASES_EDIT */],isFetching:false,payload:response,permissions:json.permissions,timestamp:Date.now()};};var versionGroupPhaseClear=function versionGroupPhaseClear(){return{type:__WEBPACK_IMPORTED_MODULE_3__store_config__["_262" /* VERSION_GROUPS_PHASES_CLEAR */],isFetching:false,payload:{all_projects:true,phases:[]},timestamp:Date.now()};};var versionGroupPhaseFail=function versionGroupPhaseFail(error){return{type:__WEBPACK_IMPORTED_MODULE_3__store_config__["_264" /* VERSION_GROUPS_PHASES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return permissionsShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return permissionsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return permissionEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return permissionSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return permissionDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__);
/* Permissions Show */var permissionsShow=function permissionsShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+sess.profile.access_token},method:'get'};dispatch(permissionRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+'/permissions?page='+page,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(permissionsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(permissionFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var permissionsList=function permissionsList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+sess.profile.access_token},method:'get'};dispatch(permissionRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+'/permissions-groups',options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(permissionsListData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(permissionFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Permissions Edit */var permissionEdit=function permissionEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+sess.profile.access_token},method:'get'};dispatch(permissionRequest());dispatch(permissionClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+'/permissions/'+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(permissionEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(permissionFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Permissions Save */var permissionSave=function permissionSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(permissionRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+'/permissions'+(values.id?'/'+values.id+'?_method=PUT':''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push('/permisos/editar/'+json.data.id);}return dispatch(permissionEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(permissionFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};/* Permissions Delete */var permissionDelete=function permissionDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_5_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+sess.profile.access_token},method:'delete'};dispatch(permissionRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+'/permissions/'+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message,type:"success"}));dispatch(permissionsShow());return dispatch(permissionDeleteData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(permissionFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var permissionRequest=function permissionRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_74" /* PERMISSION_REQUEST */],isFetching:true,timestamp:Date.now()};};var permissionsData=function permissionsData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_72" /* PERMISSIONS_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var permissionsListData=function permissionsListData(json){var p={};__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapValues(json.data,function(item){return p[item.id]=item;});return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_71" /* PERMISSIONS_LIST */],isFetching:false,payload:p,timestamp:Date.now()};};var permissionEditData=function permissionEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_70" /* PERMISSIONS_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var permissionClear=function permissionClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_68" /* PERMISSIONS_CLEAR */],payload:{},permissions:[],timestamp:Date.now()};};var permissionDeleteData=function permissionDeleteData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_69" /* PERMISSIONS_DELETE */],isFetching:false,payload:json,timestamp:Date.now()};};/*Fails*/var permissionFail=function permissionFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_73" /* PERMISSION_FAIL */],isFetching:false,data:{},error:error,timestamp:Date.now()};};

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchProfile;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return profileUpdate; });
/* unused harmony export profileAgencies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
function fetchProfile(){return function(dispatch){dispatch(profileRequest());return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/profile",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(profileData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(profileFail(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};}/*export const profileUpdate = (values, event) => (dispatch) => {
	return dispatch(profileEditUpdate(values,event))
}*/var profileUpdate=function profileUpdate(values,event){return function(dispatch){dispatch(profileRequest());return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var body=new FormData(event);var options={headers:{'Accept':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:body};__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(values,function(o,j){if(o!==null){if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.startsWith(o,'http://')){body.append(j,o);}else if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(o)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(o)&&o[0]!==undefined){body.append(j,o[0]);}}});return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/profile",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){var newsess=Object.assign({},sess,{profile:json.data});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:"El perfil se ha guardado correctamente",type:"success"}));//dispatch(loginUserProfile(json.data));
return __WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].saveUser(newsess).then(function(){return dispatch(profileData(json));}).catch(function(error){return profileFail(error);});},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(profileFail(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};/* @todo: esta función está despreciada, corroborar para su eliminación */var profileAgencies=function profileAgencies(){var storage=sessionStorage.getItem("etrans_agencies");if(storage===null){var token=sessionStorage.getItem('etrans_user');var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+JSON.parse(token).access_token},method:'get'};return function(dispatch){dispatch(profileRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/profile/agencies",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(profileAgenciesData(json.data));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:'¡Oh no!',content:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(error),type:'danger'}));dispatch(profileFail(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(error)));});};}else{storage=JSON.parse(storage);return function(dispatch){dispatch(profileAgenciesData(storage));};}};/* función depreciada */var profileData=function profileData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_83" /* PROFILE_SHOW */],isFetching:false,payload:json.data,timestamp:Date.now()};};var profileAgenciesData=function profileAgenciesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_80" /* PROFILE_AGENCIES */],isFetching:false,payload:json,timestamp:Date.now()};};var profileRequest=function profileRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_82" /* PROFILE_REQUEST */],isFetching:true,timestamp:Date.now()};};var profileFail=function profileFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_81" /* PROFILE_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return objectivesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return objectivesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return objectiveEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return objectiveEditSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return objectiveDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var objectivesShow=function objectivesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(objectivesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/objectives?page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(objectivesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(objectivesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var objectivesList=function objectivesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(objectivesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/objectives?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(objectivesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(objectivesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var objectiveEdit=function objectiveEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(objectivesRequest());dispatch(objectivesClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/objectives/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(objectivesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(objectivesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var objectiveEditSave=function objectiveEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(objectivesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/objectives"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El objetivo se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/proigualdad/objetivos/editar/"+json.data.id);}return dispatch(objectivesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(objectivesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var objectiveDelete=function objectiveDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(objectivesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/objectives/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"El objetivo se ha borrado correctamente",type:"success"}));dispatch(objectivesShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(objectivesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var objectivesData=function objectivesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_67" /* OBJECTIVES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var objectivesEditData=function objectivesEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_64" /* OBJECTIVES_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var objectivesRequest=function objectivesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_66" /* OBJECTIVES_REQUEST */],isFetching:true,timestamp:Date.now()};};var objectivesClear=function objectivesClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_63" /* OBJECTIVES_CLEAR */],payload:{},timestamp:Date.now()};};var objectivesFail=function objectivesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_65" /* OBJECTIVES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return strategiesShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return strategiesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strategieEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return strategieEditSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strategieDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var strategiesShow=function strategiesShow(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var params='';__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapKeys(filters,function(value,key){if(value){params=params+"&"+key+"="+value;}});dispatch(strategiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/strategies?page="+page+params,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(strategiesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(strategiesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var strategiesList=function strategiesList(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(strategiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/strategies?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(strategiesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(strategiesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var strategieEdit=function strategieEdit(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(strategiesRequest());dispatch(strategiesClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/strategies/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(strategiesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(strategiesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var strategieEditSave=function strategieEditSave(values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(strategiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/strategies"+(values.id?"/"+values.id+"?_method=PUT":''),options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La estrategia se ha guardado correctamente",type:"success"}));if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(values.id)){__WEBPACK_IMPORTED_MODULE_3__store_store__["b" /* history */].push("/proigualdad/estrategias/editar/"+json.data.id);}return dispatch(strategiesEditData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(strategiesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var strategieDelete=function strategieDelete(id){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'delete'};dispatch(strategiesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/proigualdad/strategies/"+id,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message?json.message:"La estrategia se ha borrado correctamente",type:"success"}));dispatch(strategiesShow());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error),type:"danger"}));return dispatch(strategiesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.values(error)));});});};};var strategiesData=function strategiesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_229" /* STRATEGIES_SHOW */],isFetching:false,payload:json.data,pages:{current:json.current_page,per_page:json.per_page,total:json.total},permissions:json.permissions,timestamp:Date.now()};};var strategiesEditData=function strategiesEditData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_226" /* STRATEGIES_EDIT */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var strategiesRequest=function strategiesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_228" /* STRATEGIES_REQUEST */],isFetching:true,timestamp:Date.now()};};var strategiesClear=function strategiesClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_225" /* STRATEGIES_CLEAR */],payload:{},timestamp:Date.now()};};var strategiesFail=function strategiesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_227" /* STRATEGIES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hideModal; });
/* unused harmony export newModalNotification */
/* unused harmony export setModalNotification */
/* unused harmony export clearModalNotification */
/* unused harmony export unsetModalNotification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var showModal=function showModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_41" /* MODAL_SHOW */],show:true,timestamp:Date.now()};};var hideModal=function hideModal(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_38" /* MODAL_HIDE */],show:false,data:{},active:false,timestamp:Date.now()};};var newModalNotification=function newModalNotification(data){return function(dispatch){return dispatch(setModalNotification(data));};};var setModalNotification=function setModalNotification(data){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_40" /* MODAL_NOTIFICATION_SET */],data:data,active:true,timestamp:Date.now()};};var clearModalNotification=function clearModalNotification(){return function(dispatch){return dispatch(unsetModalNotification());};};var unsetModalNotification=function unsetModalNotification(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_39" /* MODAL_NOTIFICATION_CLEAR */],data:{},active:false,timestamp:Date.now()};};

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return notificationMessagesFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notificationMessagesExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notificationMessagesSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return notificationStateReviewedSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notificationAssignFolios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return notificationTypesFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
var notificationMessagesFetch=function notificationMessagesFetch(modality){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(notificationMessagesRequest());dispatch(notificationMessagesClear());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/notifications/"+modality,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(notificationMessagesData(json,modality));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(notificationMessagesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var notificationMessagesExport=function notificationMessagesExport(modality){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(notificationMessagesRequest());var options={headers:{'Accept':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','Content-Type':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','Authorization':"Bearer "+sess.profile.access_token},method:'get'};var fileName=undefined;return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/notifications/"+modality+"?export=1",options).then(function(result){if(result.status>=200&&result.status<300){//fileName = result.headers.get('Content-Disposition','attachment')
var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];//console.log('contentDispositionHeader===>',fileName);
return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){//console.log('blob===>', blob);
//let today = new Date();
//let date = today.getFullYear() + ((today.getMonth() + 1) <10 ? `0${today.getMonth() + 1}`:today.getMonth() + 1) + (today.getDate()<10 ? `0${today.getDate()}`:today.getDate()) + today.getHours() + today.getMinutes() + today.getSeconds();
//FileSaver.saveAs(blob,`Notificaciones_${modality}_${date}.xls`);
__WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(blob,fileName);dispatch(notificationMessagesComplete());},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(notificationMessagesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var notificationMessagesSave=function notificationMessagesSave(values,modality){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(notificationMessagesRequest());//let messages=[];
//_.mapKeys(values.notifications_types, (msg) => messages.push({notification_type_id: msg.id,body: msg.body}));
var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({/*messages, */is_test:values.is_test,test_email:values.test_email/*,finished: values.finished*/})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/notifications/"+modality,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(notificationMessagesRequestSave());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:json.message,type:"success"}));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(notificationMessagesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var notificationStateReviewedSave=function notificationStateReviewedSave(value,modality,state){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){dispatch(notificationStatesRequest());var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post',body:JSON.stringify({reviewed:value})};return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/notifications/review/"+modality+"/"+state,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(notificationStatesSave());//dispatch(newNotification({title:"Éxito", content: json, type: "success"}))
},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(notificationMessagesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var notificationAssignFolios=function notificationAssignFolios(modality){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'post'};dispatch(notificationMessagesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["z" /* API_URL */]+"/notifications/review/"+modality+"/process-codes",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"Éxito",content:'Folios asignados correctamente',type:"success"}));return dispatch(notificationMessagesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(notificationMessagesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var notificationTypesFetch=function notificationTypesFetch(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(notificationMessagesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["z" /* API_URL */]+"/notifications/types/current",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(notificationTypesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(notificationMessagesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var notificationMessagesData=function notificationMessagesData(json,modality){var notifications_types=[];var states=[];__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(json.notifications_types_versions_phases,function(item){return notifications_types.push({ntvp_id:item.id,id:item.notification_type_id,name:item.notification_type.name,body:item.body,modality_id:item.modality_id});});if(modality==='modalidad-ii'){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(json.states,function(std){var review=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(std.notifications_agenciables_reviews,{state_id:std.id});var stateFind=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(json.data,{agency:{agenciable:{state:{id:std.id}}}});//console.log('state'+std.name+'====>', stateFind);
if(stateFind){return states.push(Object.assign({},std,{reviewed:review?review.reviewed:0}));}});}return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_52" /* NOTIFICATION_MESSAGES_FETCH */],isFetching:false,payload:{list:json.data,states:states,finished:json.finished,notifications_types:notifications_types,permissions:json.permissions},timestamp:Date.now()};};var notificationTypesData=function notificationTypesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_57" /* NOTIFICATION_TYPES_FETCH */],isFetching:false,payload:json,timestamp:Date.now()};};var notificationStatesSave=function notificationStatesSave(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_56" /* NOTIFICATION_STATES_SAVE */],isFetching:false,timestamp:Date.now()};};var notificationMessagesRequest=function notificationMessagesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_53" /* NOTIFICATION_MESSAGES_REQUEST */],isFetching:true,timestamp:Date.now()};};var notificationMessagesComplete=function notificationMessagesComplete(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_50" /* NOTIFICATION_MESSAGES_COMPLETE */],isFetching:false,timestamp:Date.now()};};var notificationMessagesRequestSave=function notificationMessagesRequestSave(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_53" /* NOTIFICATION_MESSAGES_REQUEST */],isFetching:false,timestamp:Date.now()};};var notificationStatesRequest=function notificationStatesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_55" /* NOTIFICATION_STATES_REQUEST */],isFetching:true,timestamp:Date.now()};};var notificationMessagesFail=function notificationMessagesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_51" /* NOTIFICATION_MESSAGES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};var notificationMessagesClear=function notificationMessagesClear(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["_49" /* NOTIFICATION_MESSAGES_CLEAR */],timestamp:Date.now()};};

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return documentsTypesShow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var documentsTypesShow=function documentsTypesShow(){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_3_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':"Bearer "+sess.profile.access_token},method:'get'};dispatch(documentsTypesRequest());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_1__store_config__["y" /* API2_URL */]+"/documents/types?per_page=all",options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(documentsTypesData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error),type:"danger"}));return dispatch(documentsTypesFail(error.message?error.errors?error.message+" - "+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.values(error)));});});};};var documentsTypesData=function documentsTypesData(json){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["W" /* DOCUMENTS_TYPES */],isFetching:false,payload:json.data,permissions:json.permissions,timestamp:Date.now()};};var documentsTypesRequest=function documentsTypesRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["Y" /* DOCUMENTS_TYPES_REQUEST */],isFetching:true,timestamp:Date.now()};};var documentsTypesFail=function documentsTypesFail(error){return{type:__WEBPACK_IMPORTED_MODULE_1__store_config__["X" /* DOCUMENTS_TYPES_FAIL */],isFetching:false,error:error,timestamp:Date.now()};};

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cdmEmployees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cdmEmployeesSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_react_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__);
//import { history } from "../store/store";
var cdmEmployees=function cdmEmployees(state){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+sess.profile.access_token},method:'get'};dispatch(cdmsRequest());dispatch(cdmsClear());return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+'/cdms/employees/'+state,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){return dispatch(cdmsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(cdmsFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var cdmEmployeesSave=function cdmEmployeesSave(state,values){return function(dispatch){return dispatch(__WEBPACK_IMPORTED_MODULE_4_redux_react_session__["sessionService"].loadUser).then(function(sess){var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+sess.profile.access_token},method:'post',body:JSON.stringify(values)};dispatch(cdmsRequest());//dispatch(cdmsClear());
return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(__WEBPACK_IMPORTED_MODULE_2__store_config__["y" /* API2_URL */]+'/cdms/employees/'+state,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(json){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Éxito!",content:json.message?json.message:'Perfil guardado con éxito',type:"success"}));return dispatch(cdmsData(json));},function(error){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__notifications__["b" /* newNotification */])({title:"¡Oh no!",content:error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error),type:"danger"}));return dispatch(cdmsFail(error.message?error.errors?error.message+' - '+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error.errors):error.message:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(error)));});});};};var cdmsRequest=function cdmsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["J" /* CDM_REQUEST */],isFetching:true,timestamp:Date.now()};};var cdmsData=function cdmsData(json){var employees=[];if(json.data&&json.data.project_goals){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(json.data.project_goals,function(item){if(item.project_goal_agencies){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item.project_goal_agencies,function(goal){if(goal.employees){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(goal.employees,function(emp){return employees.push(Object.assign({},emp,{agency_id:goal.agency_id}));});}});}});}return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["H" /* CDM_EMPLOYEES */],payload:Object.assign({},json.data,{roles:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(json.roles)?json.roles:[],employees:employees}),permissions:json.permissions,timestamp:Date.now()};};var cdmsClear=function cdmsClear(){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["G" /* CDM_CLEAR */],payload:{},permissions:[],timestamp:Date.now()};};var cdmsFail=function cdmsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_2__store_config__["I" /* CDM_FAIL */],error:error,isFetching:false,timestamp:Date.now()};};

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hideMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_config__ = __webpack_require__(3);
var hideMenu=function hideMenu(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_33" /* MENU_HIDE */],payload:false,timestamp:Date.now()};};var showMenu=function showMenu(){return{type:__WEBPACK_IMPORTED_MODULE_0__store_config__["_34" /* MENU_SHOW */],payload:true,timestamp:Date.now()};};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/proequidad_logo.0ee01d9c.svg";

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,actions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,stateNav:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,modality:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,filterChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,entity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,changeStates:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,changeMuns:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var Subnavigation=function(_Component){_inherits(Subnavigation,_Component);function Subnavigation(){_classCallCheck(this,Subnavigation);return _possibleConstructorReturn(this,(Subnavigation.__proto__||Object.getPrototypeOf(Subnavigation)).apply(this,arguments));}_createClass(Subnavigation,[{key:"render",value:function render(){var _this2=this;var _props=this.props,icon=_props.icon,name=_props.name,actions=_props.actions,stateNav=_props.stateNav,modality=_props.modality,agenciable=_props.agenciable,filter=_props.filter;var states=this.stateList();var municipalities=this.municipalityList();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnavigation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa "+icon+" has-text-inm-dark-purple"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,name))),actions&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(actions,function(slot,key){var item=_this2.subnavbarItem(slot);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item",key:"subnav-"+key},item);}),stateNav&&stateNav===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-states"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-grey"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"psn-projects",value:filter,onChange:function onChange(e){return _this2.props.filterChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{disabled:true},"--- Tipo de proyecto ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"all_projects",defaultValue:true},"Todas las instancias"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"registred"},"Proyectos registrados"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"code"},"Proyectos con folio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"benefited"},"Proyectos beneficiados")))),modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{ref:"stateNav-statesMun",value:agenciable.state,onChange:function onChange(field){return _this2.props.stateChange(field.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Estado ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(states,function(st,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:st.agenciable_state_short,key:key},st.agenciable_state_name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{ref:"stateNav-muns",onChange:function onChange(e){return _this2.props.changeMuns(e.target.value);},value:agenciable.municipality},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Municipios ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(municipalities,function(mun,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:mun.agenciable_slug,key:j},mun.agenciable_name);}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{ref:"stateNav-states",onChange:function onChange(e){return _this2.props.changeStates(e.target.value);},value:agenciable.state},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",null,"--- Estado ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(states,function(state,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:state.agenciable_short,key:key},state.agenciable_name);}))))))));}},{key:"subnavbarItem",value:function subnavbarItem(item){switch(item.type){case'button':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* NavLink */],{to:item.url,className:"button is-small is-inm-purple"},item.name)));case'search':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-actions"},item.element);case'element':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-actions"},item.element);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,item.name));}}},{key:"stateList",value:function stateList(){var _props2=this.props,modality=_props2.modality,filter=_props2.filter,agencies=_props2.agencies;switch(filter){case'registred':if(modality!=='modalidad-ii'){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_id;}),['agenciable_name']);}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_id;}),'agenciable_state_id'),['agenciable_state_name']);}case'code':if(modality!=='modalidad-ii'){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_code;}),['agenciable_name']);}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_code;}),'agenciable_state_id'),['agenciable_state_name']);}case'benefited':if(modality!=='modalidad-ii'){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_benefited===1;}),['agenciable_name']);}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_benefited===1;}),'agenciable_state_id'),['agenciable_state_name']);}default:if(modality!=='modalidad-ii'){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(agencies[modality],['agenciable_name']);}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(agencies[modality],'agenciable_state_id'),['agenciable_state_name']);}}}},{key:"municipalityList",value:function municipalityList(){var _props3=this.props,modality=_props3.modality,agencies=_props3.agencies,filter=_props3.filter,agenciable=_props3.agenciable;switch(filter){case'registred':return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_id;}),{agenciable_state_short:agenciable.state}),['agenciable_name']);case'code':return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_code;}),{agenciable_state_short:agenciable.state}),['agenciable_name']);case'benefited':return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],function(o){return o.project_benefited===1;}),{agenciable_state_short:agenciable.state}),['agenciable_name']);default:return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agencies[modality],{agenciable_state_short:agenciable.state}),['agenciable_name']);}}}]);return Subnavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Subnavigation.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (Subnavigation);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,actions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,stateNav:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,entity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,changeStates:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,changeMuns:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var SubCdmNavigation=function(_Component){_inherits(SubCdmNavigation,_Component);function SubCdmNavigation(){_classCallCheck(this,SubCdmNavigation);return _possibleConstructorReturn(this,(SubCdmNavigation.__proto__||Object.getPrototypeOf(SubCdmNavigation)).apply(this,arguments));}_createClass(SubCdmNavigation,[{key:"render",value:function render(){var _this2=this;var _props=this.props,icon=_props.icon,name=_props.name,actions=_props.actions,stateNav=_props.stateNav,agenciable=_props.agenciable;var states=this.stateList();var municipalities=this.municipalityList();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnavigation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa "+icon+" has-text-inm-dark-purple"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,name))),actions&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(actions,function(slot,key){var item=_this2.subnavbarItem(slot);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item",key:"subnav-"+key},item);}),stateNav&&stateNav===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-states"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{ref:"stateNav-statesMun",value:agenciable.state,onChange:function onChange(field){return _this2.props.changeStates(field.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Estado ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(states,function(st,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:st.agenciable_state_short,key:key},st.agenciable_state_name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-dark"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{ref:"stateNav-muns",onChange:function onChange(e){return _this2.props.changeMuns(agenciable.state,e.target.value);},value:agenciable.municipality},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Municipios ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(municipalities,function(mun,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:mun.agenciable_slug,key:j},mun.agenciable_name);})))))))));}},{key:"subnavbarItem",value:function subnavbarItem(item){switch(item.type){case'button':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* NavLink */],{to:item.url,className:"button is-small is-inm-purple"},item.name)));case'search':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-actions"},item.element);case'element':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-actions"},item.element);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnav-actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,item.name));}}},{key:"stateList",value:function stateList(){var cdms=this.props.cdms;return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(cdms,'agenciable_state_id'),['agenciable_state_name']);}},{key:"municipalityList",value:function municipalityList(){var _props2=this.props,cdms=_props2.cdms,agenciable=_props2.agenciable;return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(cdms,{agenciable_state_short:agenciable.state}),['agenciable_name']);}}]);return SubCdmNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubCdmNavigation.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (SubCdmNavigation);

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inmujeres_gray.4cbf024e.svg";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/escudo-01.ba5f23be.svg";

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dashboard=function(_Component){_inherits(Dashboard,_Component);function Dashboard(){_classCallCheck(this,Dashboard);return _possibleConstructorReturn(this,(Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).apply(this,arguments));}_createClass(Dashboard,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Dashboard');}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(Dashboard,{title:'Dashboard',subnav:{}}));

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Welcome=function(_Component){_inherits(Welcome,_Component);function Welcome(){_classCallCheck(this,Welcome);return _possibleConstructorReturn(this,(Welcome.__proto__||Object.getPrototypeOf(Welcome)).apply(this,arguments));}_createClass(Welcome,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered is-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-2 has-text-inm-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Documentos de ayuda')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_2__store_config__["A" /* AUTH_URL */]+'/storage/documentos-apoyo/ayuda/Acuerdo_montos_ROP_2019.pdf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{marginRight:'10px'},className:'fa fa-file-pdf-o fa-lg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Acuerdo ROP'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_2__store_config__["A" /* AUTH_URL */]+'/storage/documentos-apoyo/ayuda/2019_02_19_MAT_inm.pdf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{marginRight:'10px'},className:'fa fa-file-pdf-o fa-lg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'ROP DOF 261217'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_2__store_config__["A" /* AUTH_URL */]+'/storage/documentos-apoyo/ayuda/Formato_tramite_reintegro_recurso_PFTPG.xlsx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{marginRight:'10px'},className:'fa fa-file-excel-o fa-lg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Formato de tramite de reintegro de recurso PFTPG'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_2__store_config__["A" /* AUTH_URL */]+'/storage/documentos-apoyo/ayuda/Instructivo_registro_proyecto_19.pdf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{marginRight:'10px'},className:'fa fa-file-pdf-o fa-lg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Instructivo etransversalidad 2018 VCG VF'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__store_config__["A" /* AUTH_URL */]+'/storage/documentos-apoyo/ayuda/plataforma_e-transversalidad.pptx',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{marginRight:'10px'},className:'fa fa-file-powerpoint-o fa-lg'}),'Plataforma e-Transversalidad')))));}}]);return Welcome;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(Welcome));

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GoalsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_goals_widget_goals_add__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_goals_widget_goals_search__ = __webpack_require__(464);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProigualdadGoals=function(_Component){_inherits(ProigualdadGoals,_Component);function ProigualdadGoals(){_classCallCheck(this,ProigualdadGoals);return _possibleConstructorReturn(this,(ProigualdadGoals.__proto__||Object.getPrototypeOf(ProigualdadGoals)).apply(this,arguments));}_createClass(ProigualdadGoals,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalsList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchModalities();this.props.goalsShow(this.props.goals.pages.current);}}]);return ProigualdadGoals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var GoalsList=function(_Component2){_inherits(GoalsList,_Component2);_createClass(GoalsList,[{key:'render',value:function render(){var _this3=this;var goals=this.props.goals;var gu=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(goals.permissions,function(o){return o==='Update';});var gd=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(goals.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,goals.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Eje Tem\xE1tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estado'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(goals.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},gu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/metas/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',gd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.type==='RI'?'Rumbo a la Igualdad':row.type==='MT'?'Meta Tipo':'Meta IMEF')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:20+'%'}},row.axis.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.agenciable?row.agenciable.name:'---'));}))),goals.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'goals-pages',current:goals.pages.current,total:goals.pages.total,nextPage:this._handlePageChange}));}}]);function GoalsList(){_classCallCheck(this,GoalsList);var _this2=_possibleConstructorReturn(this,(GoalsList.__proto__||Object.getPrototypeOf(GoalsList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(GoalsList,[{key:'_handlePageChange',value:function _handlePageChange(value){var goals=this.props.goals;this.props.goalsShow(value,goals.filters);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la meta "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.deleteGoal(id);}});}}]);return GoalsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(ProigualdadGoals,{title:"Metas Proigualdad",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_goals_widget_goals_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_goals_widget_goals_add__["a" /* default */],null)}]}}));

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = Paginator;

// Paginator constructor
//
// `per_page` is the number of results per page, `length` is the number of
// pages to display. They default to `25` and `10` respectively.
function Paginator(per_page, length) {
  // You really should be calling this with `new Paginator`, but WHATEVER.
  if (!(this instanceof Paginator)) {
    return new Paginator(per_page, length);
  }

  // Woo, defaults!
  this.per_page = per_page || 25;
  this.length = length || 10;
}

// Build an object with all the necessary information for outputting pagination
// controls.
//
// (new Paginator(paginator.build(100, 2)
Paginator.prototype.build = function(total_results, current_page) {
  // We want the number of pages, rounded up to the nearest page.
  var total_pages = Math.ceil(total_results / this.per_page);

  // Ensure both total_results and current_page are treated as Numbers
  total_results = parseInt(total_results, 10);
  current_page  = parseInt(current_page, 10) || 1;

  // Obviously we can't be on a negative or 0 page.
  if (current_page < 1) { current_page = 1; }
  // If the user has done something like /page/99999 we want to clamp that back
  // down.
  if (current_page > total_pages) { current_page = total_pages; }

  // This is the first page to be displayed as a numbered link.
  var first_page = Math.max(1, current_page - Math.floor(this.length / 2));

  // And here's the last page to be displayed specifically.
  var last_page = Math.min(total_pages, current_page + Math.floor(this.length / 2));

  // This is triggered if we're at or near one of the extremes; we won't have
  // enough page links. We need to adjust our bounds accordingly.
  if (last_page - first_page + 1 < this.length) {
    if (current_page < (total_pages / 2)) {
      last_page = Math.min(total_pages, last_page + (this.length - (last_page - first_page)));
    } else {
      first_page = Math.max(1, first_page - (this.length - (last_page - first_page)));
    }
  }

  // This can be triggered if the user wants an odd number of pages.
  if (last_page - first_page + 1 > this.length) {
    // We want to move towards whatever extreme we're closest to at the time.
    if (current_page > (total_pages / 2)) {
      first_page++;
    } else {
      last_page--;
    }
  }

  // First result on the page. This, along with the field below, can be used to
  // do "showing x to y of z results" style things.
  var first_result = this.per_page * (current_page - 1);
  if (first_result < 0) { first_result = 0; }

  // Last result on the page.
  var last_result = (this.per_page * current_page) - 1;
  if (last_result < 0) { last_result = 0; }
  if (last_result > Math.max(total_results - 1, 0)) { last_result = Math.max(total_results - 1, 0); }

  // GIMME THAT OBJECT
  return {
    total_pages: total_pages,
    pages: Math.min(last_page - first_page + 1, total_pages),
    current_page: current_page,
    first_page: first_page,
    last_page: last_page,
    previous_page: current_page - 1,
    next_page: current_page + 1,
    has_previous_page: current_page > 1,
    has_next_page: current_page < total_pages,
    total_results: total_results,
    results: Math.min(last_result - first_result + 1, total_results),
    first_result: first_result,
    last_result: last_result,
  };
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var _createClass=function(){function e(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,r,a){return r&&e(t.prototype,r),a&&e(t,a),t}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(6),_propTypes2=_interopRequireDefault(_propTypes),_classnames=__webpack_require__(119),_classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _defineProperty(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}var Page=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return _inherits(t,_react.Component),_createClass(t,[{key:"handleClick",value:function(e){var t=this.props,r=t.isDisabled,a=t.pageNumber;e.preventDefault(),r||this.props.onClick(a)}},{key:"render",value:function(){var e,t=this.props,r=t.pageText,a=(t.pageNumber,t.activeClass),n=t.itemClass,s=t.linkClass,i=t.activeLinkClass,o=t.disabledClass,l=t.isActive,c=t.isDisabled,u=t.href,p=(0,_classnames2.default)(n,(_defineProperty(e={},a,l),_defineProperty(e,o,c),e)),f=(0,_classnames2.default)(s,_defineProperty({},i,l));return _react2.default.createElement("li",{className:p,onClick:this.handleClick.bind(this)},_react2.default.createElement("a",{className:f,href:u},r))}}]),t}();Page.defaultProps={activeClass:"active",disabledClass:"disabled",itemClass:void 0,linkClass:void 0,activeLinkCLass:void 0,isActive:!1,isDisabled:!1,href:"#"},exports.default=Page;

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalsSearch=function(_Component){_inherits(GoalsSearch,_Component);_createClass(GoalsSearch,[{key:"render",value:function render(){var _props=this.props,goals=_props.goals,modalities=_props.modalities,entities=_props.entities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"type",id:"type",value:goals.filters.type,onChange:this._typeChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Tipo de meta ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"RI"},"Rumbo a la Igualdad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"MT"},"Meta Tipo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"MI"},"Meta IMEF")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"+(modalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"modality_id",id:"modality_id",value:goals.filters.modality_id,onChange:this._modalityChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Modalidad ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(modalities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.name);})))),goals.filters.modality_id==='1'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"+(entities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"state_id",id:"state_id",value:goals.filters.state_id,onChange:this._entityChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Entidad ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(entities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.name);})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:goals.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function GoalsSearch(){_classCallCheck(this,GoalsSearch);var _this=_possibleConstructorReturn(this,(GoalsSearch.__proto__||Object.getPrototypeOf(GoalsSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._typeChange=_this._typeChange.bind(_this);_this._modalityChange=_this._modalityChange.bind(_this);_this._entityChange=_this._entityChange.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(GoalsSearch,[{key:"componentWillMount",value:function componentWillMount(){this.props.fetchEntities();}},{key:"_submitSearch",value:function _submitSearch(){var goals=this.props.goals;this.props.goalsShow(1,goals.filters);}},{key:"_typeChange",value:function _typeChange(event){this.props.change('goals.filters.type',event.target.value);}},{key:"_modalityChange",value:function _modalityChange(event){this.props.change('goals.filters.modality_id',event.target.value);this.props.change('goals.filters.state_id','');}},{key:"_entityChange",value:function _entityChange(event){this.props.change('goals.filters.state_id',event.target.value);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('goals.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('goals.filters');this.props.goalsShow(1);}}]);return GoalsSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(GoalsSearch));

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_goals_form__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_goals_widget_goals_add__ = __webpack_require__(120);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalEdit=function(_Component){_inherits(GoalEdit,_Component);function GoalEdit(){_classCallCheck(this,GoalEdit);return _possibleConstructorReturn(this,(GoalEdit.__proto__||Object.getPrototypeOf(GoalEdit)).apply(this,arguments));}_createClass(GoalEdit,[{key:'render',value:function render(){var goals=this.props.goals;return goals.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_goals_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetGoalActivities();this.props.fetchGoalComplete(this.props.match.params.id);}}]);return GoalEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(GoalEdit,{title:"Editar Meta",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_goals_widget_goals_add__["a" /* default */],null)}]}}));

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_goals_form__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_goals_widget_goals_add__ = __webpack_require__(120);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalCreate=function(_Component){_inherits(GoalCreate,_Component);function GoalCreate(){_classCallCheck(this,GoalCreate);return _possibleConstructorReturn(this,(GoalCreate.__proto__||Object.getPrototypeOf(GoalCreate)).apply(this,arguments));}_createClass(GoalCreate,[{key:'render',value:function render(){var goals=this.props.goals;return goals.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_goals_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetGoalActivities();this.props.fetchGoalComplete();}}]);return GoalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(GoalCreate,{title:"Crear Meta",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_goals_widget_goals_add__["a" /* default */],null)}]}}));

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ObjectivesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_objectives_widget_objectives_add__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_objectives_widget_objectives_search__ = __webpack_require__(468);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProigualdadObjectives=function(_Component){_inherits(ProigualdadObjectives,_Component);function ProigualdadObjectives(){_classCallCheck(this,ProigualdadObjectives);return _possibleConstructorReturn(this,(ProigualdadObjectives.__proto__||Object.getPrototypeOf(ProigualdadObjectives)).apply(this,arguments));}_createClass(ProigualdadObjectives,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ObjectivesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.objectivesShow(this.props.objectives.pages.current);}}]);return ProigualdadObjectives;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ObjectivesList=function(_Component2){_inherits(ObjectivesList,_Component2);_createClass(ObjectivesList,[{key:'render',value:function render(){var _this3=this;var objectives=this.props.objectives;var ou=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(objectives.permissions,function(o){return o==='Update';});var od=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(objectives.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,objectives.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(objectives.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},ou?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/objetivos/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',od?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)));}))),objectives.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'objectives-pages',current:objectives.pages.current,total:objectives.pages.total,nextPage:this._handlePageChange}));}}]);function ObjectivesList(){_classCallCheck(this,ObjectivesList);var _this2=_possibleConstructorReturn(this,(ObjectivesList.__proto__||Object.getPrototypeOf(ObjectivesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(ObjectivesList,[{key:'_handlePageChange',value:function _handlePageChange(value){var objectives=this.props.objectives;this.props.objectivesShow(value,objectives.filters);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el objetivo "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.objectiveDelete(id);}});}}]);return ObjectivesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(ProigualdadObjectives,{title:"Objetivos Proigualdad",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_objectives_widget_objectives_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_objectives_widget_objectives_add__["a" /* default */],null)}]}}));

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ObjectivesSearch=function(_Component){_inherits(ObjectivesSearch,_Component);_createClass(ObjectivesSearch,[{key:"render",value:function render(){var objectives=this.props.objectives;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:objectives.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function ObjectivesSearch(){_classCallCheck(this,ObjectivesSearch);var _this=_possibleConstructorReturn(this,(ObjectivesSearch.__proto__||Object.getPrototypeOf(ObjectivesSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(ObjectivesSearch,[{key:"_submitSearch",value:function _submitSearch(){var objectives=this.props.objectives;this.props.objectivesShow(1,objectives.filters);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('objectives.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('objectives.filters');this.props.objectivesShow(1);}}]);return ObjectivesSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(ObjectivesSearch));

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_objectives_form__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_objectives_widget_objectives_add__ = __webpack_require__(121);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ObjectiveEdit=function(_Component){_inherits(ObjectiveEdit,_Component);function ObjectiveEdit(){_classCallCheck(this,ObjectiveEdit);return _possibleConstructorReturn(this,(ObjectiveEdit.__proto__||Object.getPrototypeOf(ObjectiveEdit)).apply(this,arguments));}_createClass(ObjectiveEdit,[{key:'render',value:function render(){var objectives=this.props.objectives;return objectives.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_objectives_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.objectiveEdit(this.props.match.params.id);}}]);return ObjectiveEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(ObjectiveEdit,{title:"Editar objetivo",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_objectives_widget_objectives_add__["a" /* default */],null)}]}}));

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_objectives_form__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_objectives_widget_objectives_add__ = __webpack_require__(121);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ObjectiveEdit=function(_Component){_inherits(ObjectiveEdit,_Component);function ObjectiveEdit(){_classCallCheck(this,ObjectiveEdit);return _possibleConstructorReturn(this,(ObjectiveEdit.__proto__||Object.getPrototypeOf(ObjectiveEdit)).apply(this,arguments));}_createClass(ObjectiveEdit,[{key:'render',value:function render(){var objectives=this.props.objectives;return objectives.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_objectives_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('objectives.edit');}}]);return ObjectiveEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(ObjectiveEdit,{title:"Crear objetivo",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_objectives_widget_objectives_add__["a" /* default */],null)}]}}));

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_strategies_widget_strategies_add__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_strategies_widget_strategies_search__ = __webpack_require__(472);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProigualdadStrategies=function(_Component){_inherits(ProigualdadStrategies,_Component);function ProigualdadStrategies(){_classCallCheck(this,ProigualdadStrategies);return _possibleConstructorReturn(this,(ProigualdadStrategies.__proto__||Object.getPrototypeOf(ProigualdadStrategies)).apply(this,arguments));}_createClass(ProigualdadStrategies,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StrategiesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.strategiesShow(this.props.strategies.pages.current);}}]);return ProigualdadStrategies;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StrategiesList=function(_Component2){_inherits(StrategiesList,_Component2);_createClass(StrategiesList,[{key:'render',value:function render(){var _this3=this;var strategies=this.props.strategies;var su=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(strategies.permissions,function(o){return o==='Update';});var sd=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(strategies.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,strategies.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(strategies.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},su?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/estrategias/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',sd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)));}))),strategies.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'strategies-pages',current:strategies.pages.current,total:strategies.pages.total,nextPage:this._handlePageChange}));}}]);function StrategiesList(){_classCallCheck(this,StrategiesList);var _this2=_possibleConstructorReturn(this,(StrategiesList.__proto__||Object.getPrototypeOf(StrategiesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(StrategiesList,[{key:'_handlePageChange',value:function _handlePageChange(value){var strategies=this.props.strategies;this.props.strategiesShow(value,strategies.filters);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la estrategia "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.strategieDelete(id);}});}}]);return StrategiesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(ProigualdadStrategies,{title:"Estrategias Proigualdad",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_strategies_widget_strategies_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_strategies_widget_strategies_add__["a" /* default */],null)}]}}));

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StrategiesSearch=function(_Component){_inherits(StrategiesSearch,_Component);_createClass(StrategiesSearch,[{key:"render",value:function render(){var strategies=this.props.strategies;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:strategies.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function StrategiesSearch(){_classCallCheck(this,StrategiesSearch);var _this=_possibleConstructorReturn(this,(StrategiesSearch.__proto__||Object.getPrototypeOf(StrategiesSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(StrategiesSearch,[{key:"_submitSearch",value:function _submitSearch(){var strategies=this.props.strategies;this.props.strategiesShow(1,strategies.filters);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('strategies.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('strategies.filters');this.props.strategiesShow(1);}}]);return StrategiesSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(StrategiesSearch));

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_strategies_form__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_strategies_widget_strategies_add__ = __webpack_require__(122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StrategieEdit=function(_Component){_inherits(StrategieEdit,_Component);function StrategieEdit(){_classCallCheck(this,StrategieEdit);return _possibleConstructorReturn(this,(StrategieEdit.__proto__||Object.getPrototypeOf(StrategieEdit)).apply(this,arguments));}_createClass(StrategieEdit,[{key:'render',value:function render(){var _props=this.props,strategies=_props.strategies,objectives=_props.objectives;return strategies.isFetching||objectives.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_strategies_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.objectivesList();this.props.strategieEdit(this.props.match.params.id);}}]);return StrategieEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(StrategieEdit,{title:"Editar estrategia",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_strategies_widget_strategies_add__["a" /* default */],null)}]}}));

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_strategies_form__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_strategies_widget_strategies_add__ = __webpack_require__(122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StrategieEdit=function(_Component){_inherits(StrategieEdit,_Component);function StrategieEdit(){_classCallCheck(this,StrategieEdit);return _possibleConstructorReturn(this,(StrategieEdit.__proto__||Object.getPrototypeOf(StrategieEdit)).apply(this,arguments));}_createClass(StrategieEdit,[{key:'render',value:function render(){var _props=this.props,strategies=_props.strategies,objectives=_props.objectives;return strategies.isFetching||objectives.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_strategies_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('strategies.edit');this.props.objectivesList();}}]);return StrategieEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(StrategieEdit,{title:"Crear estrategia",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_strategies_widget_strategies_add__["a" /* default */],null)}]}}));

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LinesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_lines_widget_lines_add__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_lines_widget_lines_search__ = __webpack_require__(476);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProigualdadLines=function(_Component){_inherits(ProigualdadLines,_Component);function ProigualdadLines(){_classCallCheck(this,ProigualdadLines);return _possibleConstructorReturn(this,(ProigualdadLines.__proto__||Object.getPrototypeOf(ProigualdadLines)).apply(this,arguments));}_createClass(ProigualdadLines,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.linesShow(this.props.lines.pages.current);}}]);return ProigualdadLines;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var LinesList=function(_Component2){_inherits(LinesList,_Component2);_createClass(LinesList,[{key:'render',value:function render(){var _this3=this;var lines=this.props.lines;var lu=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(lines.permissions,function(o){return o==='Update';});var ld=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(lines.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,lines.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(lines.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},lu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/lineas/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',ld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)));}))),lines.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'lines-pages',current:lines.pages.current,total:lines.pages.total,nextPage:this._handlePageChange}));}}]);function LinesList(){_classCallCheck(this,LinesList);var _this2=_possibleConstructorReturn(this,(LinesList.__proto__||Object.getPrototypeOf(LinesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(LinesList,[{key:'_handlePageChange',value:function _handlePageChange(value){var lines=this.props.lines;this.props.linesShow(value,lines.filters);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la linea "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.lineDelete(id);}});}}]);return LinesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(ProigualdadLines,{title:"Lineas Proigualdad",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_lines_widget_lines_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_lines_widget_lines_add__["a" /* default */],null)}]}}));

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LinesSearch=function(_Component){_inherits(LinesSearch,_Component);_createClass(LinesSearch,[{key:"render",value:function render(){var lines=this.props.lines;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:lines.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function LinesSearch(){_classCallCheck(this,LinesSearch);var _this=_possibleConstructorReturn(this,(LinesSearch.__proto__||Object.getPrototypeOf(LinesSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(LinesSearch,[{key:"_submitSearch",value:function _submitSearch(){var lines=this.props.lines;this.props.linesShow(1,lines.filters);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('lines.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('lines.filters');this.props.linesShow(1);}}]);return LinesSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(LinesSearch));

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_lines_form__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_lines_widget_lines_add__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LineEdit=function(_Component){_inherits(LineEdit,_Component);function LineEdit(){_classCallCheck(this,LineEdit);return _possibleConstructorReturn(this,(LineEdit.__proto__||Object.getPrototypeOf(LineEdit)).apply(this,arguments));}_createClass(LineEdit,[{key:'render',value:function render(){var _props=this.props,lines=_props.lines,strategies=_props.strategies;return lines.isFetching||strategies.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_lines_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.strategiesList();this.props.fetchLineComplete(this.props.match.params.id);}}]);return LineEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(LineEdit,{title:"Editar linea",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_lines_widget_lines_add__["a" /* default */],null)}]}}));

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_lines_form__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_lines_widget_lines_add__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LineEdit=function(_Component){_inherits(LineEdit,_Component);function LineEdit(){_classCallCheck(this,LineEdit);return _possibleConstructorReturn(this,(LineEdit.__proto__||Object.getPrototypeOf(LineEdit)).apply(this,arguments));}_createClass(LineEdit,[{key:'render',value:function render(){var _props=this.props,lines=_props.lines,strategies=_props.strategies;return lines.isFetching||strategies.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_lines_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.strategiesList();//this.props.reset('lines.edit');
this.props.fetchLineComplete();}}]);return LineEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(LineEdit,{title:"Crear linea",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_lines_widget_lines_add__["a" /* default */],null)}]}}));

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AxisList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_axis_widget_axis_add__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_axis_widget_axis_search__ = __webpack_require__(480);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProigualdadAxis=function(_Component){_inherits(ProigualdadAxis,_Component);function ProigualdadAxis(){_classCallCheck(this,ProigualdadAxis);return _possibleConstructorReturn(this,(ProigualdadAxis.__proto__||Object.getPrototypeOf(ProigualdadAxis)).apply(this,arguments));}_createClass(ProigualdadAxis,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AxisList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.axisShow(this.props.axis.pages.current);}}]);return ProigualdadAxis;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AxisList=function(_Component2){_inherits(AxisList,_Component2);_createClass(AxisList,[{key:'render',value:function render(){var _this3=this;var axis=this.props.axis;var au=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(axis.permissions,function(o){return o==='Update';});var ad=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(axis.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,axis.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(axis.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},au?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/ejes/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',ad?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)));}))),axis.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'axis-pages',current:axis.pages.current,total:axis.pages.total,nextPage:this._handlePageChange}));}}]);function AxisList(){_classCallCheck(this,AxisList);var _this2=_possibleConstructorReturn(this,(AxisList.__proto__||Object.getPrototypeOf(AxisList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(AxisList,[{key:'_handlePageChange',value:function _handlePageChange(value){var axis=this.props.axis;this.props.axisShow(value,axis.filters);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el eje "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.axisDelete(id);}});}}]);return AxisList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(ProigualdadAxis,{title:"Ejes Proigualdad",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_axis_widget_axis_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_axis_widget_axis_add__["a" /* default */],null)}]}}));

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AxisSearch=function(_Component){_inherits(AxisSearch,_Component);_createClass(AxisSearch,[{key:"render",value:function render(){var axis=this.props.axis;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:axis.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function AxisSearch(){_classCallCheck(this,AxisSearch);var _this=_possibleConstructorReturn(this,(AxisSearch.__proto__||Object.getPrototypeOf(AxisSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(AxisSearch,[{key:"_submitSearch",value:function _submitSearch(){var axis=this.props.axis;this.props.axisShow(1,axis.filters);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('axis.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('axis.filters');this.props.axisShow(1);}}]);return AxisSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(AxisSearch));

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_axis_form__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_axis_widget_axis_add__ = __webpack_require__(124);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AxisEdit=function(_Component){_inherits(AxisEdit,_Component);function AxisEdit(){_classCallCheck(this,AxisEdit);return _possibleConstructorReturn(this,(AxisEdit.__proto__||Object.getPrototypeOf(AxisEdit)).apply(this,arguments));}_createClass(AxisEdit,[{key:'render',value:function render(){var axis=this.props.axis;return axis.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_axis_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.axisEdit(this.props.match.params.id);}}]);return AxisEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(AxisEdit,{title:"Editar eje",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_axis_widget_axis_add__["a" /* default */],null)}]}}));

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_axis_form__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_axis_widget_axis_add__ = __webpack_require__(124);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AxisEdit=function(_Component){_inherits(AxisEdit,_Component);function AxisEdit(){_classCallCheck(this,AxisEdit);return _possibleConstructorReturn(this,(AxisEdit.__proto__||Object.getPrototypeOf(AxisEdit)).apply(this,arguments));}_createClass(AxisEdit,[{key:'render',value:function render(){var axis=this.props.axis;return axis.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_axis_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('axis.edit');}}]);return AxisEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(AxisEdit,{title:"Crear eje",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_axis_widget_axis_add__["a" /* default */],null)}]}}));

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ActivitiesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_activities_widget_activity_add__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_activities_widget_activities_search__ = __webpack_require__(484);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Activities=function(_Component){_inherits(Activities,_Component);function Activities(){_classCallCheck(this,Activities);return _possibleConstructorReturn(this,(Activities.__proto__||Object.getPrototypeOf(Activities)).apply(this,arguments));}_createClass(Activities,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActivitiesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.activitiesShow();}}]);return Activities;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ActivitiesList=function(_Component2){_inherits(ActivitiesList,_Component2);_createClass(ActivitiesList,[{key:'render',value:function render(){var _this3=this;var activities=this.props.activities;var au=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(activities.permissions,function(o){return o==='Update';});var ad=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(activities.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,activities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(activities.list)?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(activities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},au?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/proigualdad/actividades/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',ad?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7_accounting_js__["formatMoney"])(row.amount)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},'No hay actividades')))),activities.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:activities.pages.current,total:activities.pages.total,nextPage:this._handlePageChange}));}}]);function ActivitiesList(){_classCallCheck(this,ActivitiesList);var _this2=_possibleConstructorReturn(this,(ActivitiesList.__proto__||Object.getPrototypeOf(ActivitiesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(ActivitiesList,[{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la actividad "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.deleteActivity(id);}});}},{key:'_handlePageChange',value:function _handlePageChange(value){var activities=this.props.activities;this.props.activitiesShow(value,activities.filters);}}]);return ActivitiesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(Activities,{title:'Administrar Actividades',subnav:{icon:'fa-calendar-check-o',name:'Proigualdad',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_activities_widget_activities_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_activities_widget_activity_add__["a" /* default */],null)}]}}));

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivitiesSearch=function(_Component){_inherits(ActivitiesSearch,_Component);_createClass(ActivitiesSearch,[{key:"render",value:function render(){var activities=this.props.activities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:activities.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function ActivitiesSearch(){_classCallCheck(this,ActivitiesSearch);var _this=_possibleConstructorReturn(this,(ActivitiesSearch.__proto__||Object.getPrototypeOf(ActivitiesSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(ActivitiesSearch,[{key:"_submitSearch",value:function _submitSearch(){var activities=this.props.activities;this.props.activitiesShow(1,activities.filters);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('activities.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('activities.filters');this.props.activitiesShow(1);}}]);return ActivitiesSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(ActivitiesSearch));

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_activities_form__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_activities_widget_activity_add__ = __webpack_require__(125);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivityEdit=function(_Component){_inherits(ActivityEdit,_Component);function ActivityEdit(){_classCallCheck(this,ActivityEdit);return _possibleConstructorReturn(this,(ActivityEdit.__proto__||Object.getPrototypeOf(ActivityEdit)).apply(this,arguments));}_createClass(ActivityEdit,[{key:'render',value:function render(){var activities=this.props.activities;return activities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_activities_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchActivityComplete(this.props.match.params.id);}}]);return ActivityEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(ActivityEdit,{title:'Editar Actividad',subnav:{icon:'fa-calendar-check-o',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_activities_widget_activity_add__["a" /* default */],null)}]}}));

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_activities_form__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_activities_widget_activity_add__ = __webpack_require__(125);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivityCreate=function(_Component){_inherits(ActivityCreate,_Component);function ActivityCreate(){_classCallCheck(this,ActivityCreate);return _possibleConstructorReturn(this,(ActivityCreate.__proto__||Object.getPrototypeOf(ActivityCreate)).apply(this,arguments));}_createClass(ActivityCreate,[{key:'render',value:function render(){var activities=this.props.activities;return activities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_activities_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchActivityComplete();}}]);return ActivityCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(ActivityCreate,{title:'Crear Actividad',subnav:{icon:'fa-calendar-check-o',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_activities_widget_activity_add__["a" /* default */],null)}]}}));

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConceptsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_concepts_widget_concepts_add__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_concepts_widget_concepts_search__ = __webpack_require__(488);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Concepts=function(_Component){_inherits(Concepts,_Component);function Concepts(){_classCallCheck(this,Concepts);return _possibleConstructorReturn(this,(Concepts.__proto__||Object.getPrototypeOf(Concepts)).apply(this,arguments));}_createClass(Concepts,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptsList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){var concepts=this.props.concepts;this.props.conceptsShow(concepts.pages.current,concepts.filters);}}]);return Concepts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ConceptsList=function(_Component2){_inherits(ConceptsList,_Component2);_createClass(ConceptsList,[{key:'render',value:function render(){var _this3=this;var concepts=this.props.concepts;var isFetching=concepts.isFetching,pages=concepts.pages,list=concepts.list,permissions=concepts.permissions;var cu=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(permissions,function(o){return o==='Update';});var cd=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table',key:'concepts-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,list.map(function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},cu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/gastos/conceptos/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',cd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:50+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'has-text-'+row.status.style},row.status.name)));}))),pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:pages.current,total:pages.total,nextPage:this._handlePageChange})]);}}]);function ConceptsList(){_classCallCheck(this,ConceptsList);var _this2=_possibleConstructorReturn(this,(ConceptsList.__proto__||Object.getPrototypeOf(ConceptsList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(ConceptsList,[{key:'_conceptDelete',value:function _conceptDelete(id){this.props.deleteConcept(id);}},{key:'_handlePageChange',value:function _handlePageChange(value){var concepts=this.props.concepts;this.props.conceptsShow(value,concepts.filters);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el concepto "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4._conceptDelete(id);}});}}]);return ConceptsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(Concepts, {title: `Conceptos de Gastos`, subnav: {icon: 'fa-list-alt', name: 'Administración', actions: {url: '/gastos/conceptos/crear', name: 'Agregar Concepto'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(Concepts,{title:'Conceptos de Gastos',subnav:{icon:'fa-list-alt',name:'Administración',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_concepts_widget_concepts_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_concepts_widget_concepts_add__["a" /* default */],null)}]}}));

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from 'lodash';
var ConceptsSearch=function(_Component){_inherits(ConceptsSearch,_Component);_createClass(ConceptsSearch,[{key:"render",value:function render(){var concepts=this.props.concepts;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:concepts.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function ConceptsSearch(){_classCallCheck(this,ConceptsSearch);var _this=_possibleConstructorReturn(this,(ConceptsSearch.__proto__||Object.getPrototypeOf(ConceptsSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(ConceptsSearch,[{key:"_submitSearch",value:function _submitSearch(){var concepts=this.props.concepts;this.props.conceptsShow(1,concepts.filters);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('concepts.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('concepts.filters');this.props.conceptsShow(1);}}]);return ConceptsSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(ConceptsSearch));

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_concepts_form__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_concepts_widget_concepts_add__ = __webpack_require__(126);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConceptEdit=function(_Component){_inherits(ConceptEdit,_Component);function ConceptEdit(){_classCallCheck(this,ConceptEdit);return _possibleConstructorReturn(this,(ConceptEdit.__proto__||Object.getPrototypeOf(ConceptEdit)).apply(this,arguments));}_createClass(ConceptEdit,[{key:'render',value:function render(){var _props=this.props,concepts=_props.concepts,status=_props.status;return concepts.isFetching||status.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_concepts_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchConcept(this.props.match.params.id);}}]);return ConceptEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(ConceptEdit,{title:'Editar Concepto',subnav:{icon:'fa-list-alt',name:'Conceptos',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_concepts_widget_concepts_add__["a" /* default */],null)}]}}));

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_concepts_form__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_concepts_widget_concepts_add__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConceptCreate=function(_Component){_inherits(ConceptCreate,_Component);function ConceptCreate(){_classCallCheck(this,ConceptCreate);return _possibleConstructorReturn(this,(ConceptCreate.__proto__||Object.getPrototypeOf(ConceptCreate)).apply(this,arguments));}_createClass(ConceptCreate,[{key:'render',value:function render(){var _props=this.props,concepts=_props.concepts,status=_props.status;return concepts.isFetching||status.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_concepts_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetConcepts();//this.props.fetchStatus(1);
}}]);return ConceptCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(ConceptCreate, {title: "Crear Concepto", subnav: {icon: 'fa-list-alt', name: 'Conceptos', actions: {url: '/gastos/conceptos/crear', name: 'Agregar Concepto'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(ConceptCreate,{title:'Crear Concepto',subnav:{icon:'fa-list-alt',name:'Conceptos',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_concepts_widget_concepts_add__["a" /* default */],null)}]}}));

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_profile_form__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Profile=function(_Component){_inherits(Profile,_Component);function Profile(){_classCallCheck(this,Profile);return _possibleConstructorReturn(this,(Profile.__proto__||Object.getPrototypeOf(Profile)).apply(this,arguments));}_createClass(Profile,[{key:'render',value:function render(){return this.props.profile.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_profile_form__["a" /* default */],Object.assign({profileSave:this.props.profileSave,loadFormData:this.props.loadFormData},this.props.profile));}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchProfile();}}]);return Profile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(Profile,{title:'Mi perfil',subnav:{icon:'fa-address-card',name:'Mi Perfil',actions:[{type:null,url:null,name:'',element:null}]}}));

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_user_profile_male_jpg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_user_profile_male_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_user_profile_male_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_greeting_select__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProfileForm=function(_Component){_inherits(ProfileForm,_Component);function ProfileForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProfileForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProfileForm.__proto__||Object.getPrototypeOf(ProfileForm)).call.apply(_ref,[this].concat(args))),_this),_this._handleSubmit=function(values,event){_this.props.profileSave(values,event.target);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProfileForm,[{key:'render',value:function render(){var _this2=this;var isFetching=this.props.isFetching;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Form"],{onSubmit:this._handleSubmit,model:'profile.edit',encType:'multipart/form-data',validators:{'':{passwordsMatch:function passwordsMatch(vals){return vals.password===vals.password_confirmation;}}},onSubmitFailed:function onSubmitFailed(error){return'Hay errores en el formulario';}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered is-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'profile.edit',messages:{passwordsMatch:'Las contraseñas no coinciden'},wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-danger'},props.children);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-3 has-text-centered'},this.props.edit.image?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(this.props.edit.image)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'image is-1by1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload fa-4x'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'image is-1by1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.edit.image+'?'+Date.now(),alt:this.props.edit.name})):this.props.edit.sex==='H'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'image is-1by1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_user_profile_male_jpg___default.a,alt:this.props.edit.name})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'image is-1by1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_user_profile_female_jpg___default.a,alt:this.props.edit.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'file-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].file,{className:'file-input',type:'file',name:'image',id:'image',model:'.image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-cta'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-label'},'Nueva imagen'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'title',className:'label'},'Saludo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"],{model:'.title',id:'title',component:__WEBPACK_IMPORTED_MODULE_6__forms_greeting_select__["a" /* default */],validateOn:'change',errors:{required:__WEBPACK_IMPORTED_MODULE_5__field_validations__["m" /* required */]}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.title',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded '+(isFetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre(s) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.name',id:'name',className:'input',disabled:isFetching,errors:{isRequired:__WEBPACK_IMPORTED_MODULE_5__field_validations__["d" /* isRequired */],minLength2:__WEBPACK_IMPORTED_MODULE_5__field_validations__["i" /* minLength2 */]},validateOn:'change',autoFocus:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Debes ingresar tu nombre',minLength2:'Tu nombre debe tener al menos 2 letras'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded '+(isFetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'last_name',className:'label'},'Primer Apellido ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.last_name',id:'last_name',className:'input',disabled:isFetching,errors:{isRequired:__WEBPACK_IMPORTED_MODULE_5__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.last_name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El apellido es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded '+(isFetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'slast_name',className:'label'},'Segundo Apellido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.slast_name',id:'slast_name',disabled:isFetching,className:'input'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'sex',className:'label'},'Sexo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Field"],{model:'.sex',id:'sex',disabled:isFetching,className:'select',errors:{required:__WEBPACK_IMPORTED_MODULE_5__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'sex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:true,disabled:true},'--- Sexo ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'M'},'Mujer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'H'},'Hombre'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.sex',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El sexo es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'scholarship',className:'label'},'Escolaridad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.scholarship',className:'input',id:'scholarship',disabled:isFetching})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email',className:'label'},'Email principal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'has-text-grey is-small'},'(este e-mail es tambi\xE9n tu usuario)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.email',id:'email',disabled:isFetching,className:'input',placeholder:'usuario@dominio.com',errors:{required:__WEBPACK_IMPORTED_MODULE_5__field_validations__["m" /* required */],isEmail:__WEBPACK_IMPORTED_MODULE_5__field_validations__["c" /* isEmail */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.email',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes ingresar un e-mail. ',isEmail:'El email es inválido.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email_2',className:'label'},'Email secundario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.email_2',id:'email_2',disabled:isFetching,className:'input',type:'email',placeholder:'usuario@dominio.com',errors:{notEqual:function notEqual(val){return val===_this2.props.edit.email;},isEmail:function isEmail(val){return!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(val)?Object(__WEBPACK_IMPORTED_MODULE_5__field_validations__["c" /* isEmail */])(val):false;}},show:'touched'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.email_2',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isEmail:'El email es inválido. ',notEqual:'El email secundario debe ser diferente al principal. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone',className:'label'},'Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.telephone',id:'telephone',disabled:isFetching,className:'input'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'extension',className:'label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.extension',className:'input',id:'extension',disabled:isFetching})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone_2',className:'label'},'Tel\xE9fono secundario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.telephone_2',id:'telephone_2',className:'input'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'password',className:'label'},'Contrase\xF1a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].password,{model:'.password',id:'password',name:'password',className:'input',placeholder:'Contrase\xF1a'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'password_confirmation',className:'label'},'Confirmar contrase\xF1a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].password,{model:'.password_confirmation',id:'password_confirmation',name:'password_confirmation',className:'input'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-dark is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},'Si no deseas alterar tu contrase\xF1a, deja en blanco los campos de contrase\xF1a.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this2.props.history.push('/usuarios');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].button,{model:'profile.edit',className:'button is-success',disabled:{pristine:true||isFetching}},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);return ProfileForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProfileForm);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_versions_widget_versions_add__ = __webpack_require__(127);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Versions=function(_Component){_inherits(Versions,_Component);_createClass(Versions,[{key:'render',value:function render(){var _this2=this;var versions=this.props.versions;var vu=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(versions.permissions,function(o){return o==='Update';});var vd=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(versions.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,versions.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'T\xEDtulo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'A\xF1o'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Inicia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Termina'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(versions.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},vu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/versiones/editar/'+row.year},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',vd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._getConfirm(row.year,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.year),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.start_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.end_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'has-text-'+(row.finished?'danger':'success')},row.finished?'Finalizado':'Activo')));}))),versions.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:versions.pages.current,total:versions.pages.total,nextPage:this._handlePageChange}));}}]);function Versions(){_classCallCheck(this,Versions);var _this=_possibleConstructorReturn(this,(Versions.__proto__||Object.getPrototypeOf(Versions)).call(this));_this._handlePageChange=_this._handlePageChange.bind(_this);return _this;}_createClass(Versions,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchVersionsShow();}},{key:'_handlePageChange',value:function _handlePageChange(value){this.props.fetchVersionsShow(value);}},{key:'_getConfirm',value:function _getConfirm(year,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la version "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.versionDelete(year);}});}}]);return Versions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(Versions,{title:'Administrar Versiones',subnav:{icon:'fa fa-calendar-check-o',name:'Versiones',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_versions_widget_versions_add__["a" /* default */],null)}]}}));

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_versions_form__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_versions_widget_versions_add__ = __webpack_require__(127);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VersionsForm=function(_Component){_inherits(VersionsForm,_Component);function VersionsForm(){_classCallCheck(this,VersionsForm);return _possibleConstructorReturn(this,(VersionsForm.__proto__||Object.getPrototypeOf(VersionsForm)).apply(this,arguments));}_createClass(VersionsForm,[{key:'render',value:function render(){var _props=this.props,versions=_props.versions,groupsPhases=_props.groupsPhases;return groupsPhases.isFetching||versions.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_versions_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchGroupsPhasesList();this.props.fetchVersion(this.props.match.params.year);}}]);return VersionsForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(VersionsForm,{title:'Editar Versi\xF3n',subnav:{icon:'fa fa-calendar-check-o',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_versions_widget_versions_add__["a" /* default */],null)}]}}));

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
// Public components



 // Public types

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* unused harmony export placements */
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_popper_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(227);










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !__WEBPACK_IMPORTED_MODULE_5_deep_equal___default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerReferenceNodeContext */].Consumer, null, function (referenceNode) {
    return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(223);
var isArguments = __webpack_require__(501);
var is = __webpack_require__(502);
var isRegex = __webpack_require__(503);
var flags = __webpack_require__(506);
var isDate = __webpack_require__(512);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(224); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr.call(value) !== '[object Array]' &&
		toStr.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://www.ecma-international.org/ecma-262/6.0/#sec-object.is

var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(504);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0; // eslint-disable-line no-param-reassign

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(132);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(133);
var callBind = __webpack_require__(507);

var implementation = __webpack_require__(225);
var getPolyfill = __webpack_require__(226);
var shim = __webpack_require__(511);

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(132);

var GetIntrinsic = __webpack_require__(508);

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

module.exports = function callBind() {
	return bind.apply($call, arguments);
};

module.exports.apply = function applyBind() {
	return bind.apply($apply, arguments);
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(509)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(132);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(510);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(133).supportsDescriptors;
var getPolyfill = __webpack_require__(226);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(515);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(516);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(517);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(227);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["b" /* ManagerReferenceNodeSetterContext */].Consumer, null, function (setReferenceNode) {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_versions_form__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_versions_widget_versions_add__ = __webpack_require__(127);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VersionsForm=function(_Component){_inherits(VersionsForm,_Component);function VersionsForm(){_classCallCheck(this,VersionsForm);return _possibleConstructorReturn(this,(VersionsForm.__proto__||Object.getPrototypeOf(VersionsForm)).apply(this,arguments));}_createClass(VersionsForm,[{key:'render',value:function render(){var _props=this.props,versions=_props.versions,groupsPhases=_props.groupsPhases;return groupsPhases.isFetching||versions.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_versions_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetVersions();this.props.fetchGroupsPhasesList();}}]);return VersionsForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(VersionsForm,{title:'Crear Versi\xF3n',subnav:{icon:'fa fa-calendar-check-o',name:'Versiones',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_versions_widget_versions_add__["a" /* default */],null)}]}}));

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_versions_version_group_phase__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VersionGroupPhaseEditForm=function(_Component){_inherits(VersionGroupPhaseEditForm,_Component);function VersionGroupPhaseEditForm(){_classCallCheck(this,VersionGroupPhaseEditForm);return _possibleConstructorReturn(this,(VersionGroupPhaseEditForm.__proto__||Object.getPrototypeOf(VersionGroupPhaseEditForm)).apply(this,arguments));}_createClass(VersionGroupPhaseEditForm,[{key:'render',value:function render(){var _props=this.props,version_groups_phases=_props.version_groups_phases,projects=_props.projects;return version_groups_phases.isFetching||projects.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_versions_version_group_phase__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,year=_props$match$params.year,id=_props$match$params.id;this.props.fetchVersionGroupPhaseComplete(year,id);}}]);return VersionGroupPhaseEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(VersionGroupPhaseEditForm,{title:'Editar Proceso',subnav:{icon:'fa fa-calendar-check-o',name:'Administración',actions:[{type:null,url:null,name:'',element:null}]}}));

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_wysiwyg_field__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_rating__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupPhaseEdit=function(_Component){_inherits(GroupPhaseEdit,_Component);_createClass(GroupPhaseEdit,[{key:'render',value:function render(){var _this2=this;var _props=this.props,phases=_props.phases,version_groups_phases=_props.version_groups_phases,notifications_types=_props.notifications_types,modalities=_props.modalities,match=_props.match,projects=_props.projects,entities=_props.entities,surveys=_props.surveys;var gpc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.permissions,function(o){return o==='Create';});var gpu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.permissions,function(o){return o==='Update';});var gpd=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.permissions,function(o){return o==='Delete';});var gpsa=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.permissions,function(o){return o==='SuperAdmin';});var phaseData=version_groups_phases.edit.temp_id_phase?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(phases.list,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(version_groups_phases.edit.temp_id_phase)}):undefined;console.log('GPC ==> ',version_groups_phases);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'version_groups_phases.edit',className:'column is-10',onSubmit:function onSubmit(values){return _this2._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title is-5'},version_groups_phases.edit&&version_groups_phases.edit.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'start_date',className:'label'},'Inicia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.start_date',name:'start_date',id:'start_date',component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change',disabled:gpu?false:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.start_date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'La fecha es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'end_date',className:'label'},'Termina ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.end_date',name:'end_date',id:'end_date',component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change',disabled:gpu?false:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.end_date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'La fecha es obligatorio'}}))),gpsa?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'report_start_date',className:'label'},'Inicia reporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.report_start_date',name:'report_start_date',id:'report_start_date',component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.report_start_date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'La fecha es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'report_end_date',className:'label'},'Termina reporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.report_end_date',name:'report_end_date',id:'report_end_date',component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.report_end_date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'La fecha es obligatorio'}}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'all_projects',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.all_projects',id:'all_projects',className:'checkbox',isToggle:true,disabled:gpu?false:true,changeAction:function changeAction(model,value){return _this2._changeAllProject(model,value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Aplica para todos los proyectos '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'show_current_revision',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.show_current_revision',id:'show_current_revision',className:'checkbox',disabled:gpu?false:true,isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Ver revisi\xF3n actual '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'assign_codes',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.assign_codes',id:'assign_codes',className:'checkbox',disabled:gpu?false:true,isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Proceso asignaci\xF3n de folios ')))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs is-boxed is-fullwidth is-centered no-margin-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.tabId===1?'is-active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2._changeTab(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-gear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Subproceso'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.tabId===2?'is-active':'',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2._changeTab(2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-square-o'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Revisiones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.tabId===3?'is-active':'',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2._changeTab(3);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-bell'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Notificaciones'))),!version_groups_phases.edit.all_projects&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(projects.list)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.tabId===4?'is-active':'',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2._changeTab(4);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-briefcase'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Proyectos'))):'')),this.state.tabId===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},gpc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'A\xF1adir Subproceso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_p_start_date',className:'label'},'Inicia Subproceso ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.temp_p_start_date',name:'temp_p_start_date',id:'temp_p_start_date',value:version_groups_phases.edit.temp_p_start_date?version_groups_phases.edit.temp_p_start_date:undefined,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'}),version_groups_phases.edit.temp_p_start_date?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Fecha requerida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_p_end_date',className:'label'},'Termina Subproceso ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.temp_p_end_date',name:'temp_p_end_date',id:'temp_p_end_date',value:version_groups_phases.edit.temp_p_end_date?version_groups_phases.edit.temp_p_end_date:undefined,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'}),version_groups_phases.edit.temp_p_end_date?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Fecha requerida'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'groups_phase',className:'label'},'Subproceso ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_id_phase',name:'temp_id_phase',id:'temp_id_phase',value:version_groups_phases.edit.temp_id_phase?version_groups_phases.edit.temp_id_phase:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Seleccionar Subproceso --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(phases.list,{type:'project'}),function(opt,k){var findPhase=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.edit.phases,{id:opt.id})?false:true;if(findPhase){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.id},opt.name);}}))),version_groups_phases.edit.temp_id_phase?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Subproceso requerido')),phaseData&&phaseData.require_survey?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){_this2._addPhase();},disabled:this._validPhase(version_groups_phases.edit.temp_id_phase)},'Agregar'))),phaseData&&phaseData.require_survey?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'A\xF1adir encuestas'),this._validSurvey()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_all_mods',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.temp_all_mods',id:'temp_all_mods',className:'checkbox',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Aplica para todas las modalidades ')))))))):'',this._validSurvey()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'groups_phase',className:'label'},'Encuesta ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_survey_id',name:'temp_survey_id',id:'temp_survey_id',value:version_groups_phases.edit.temp_survey_id?version_groups_phases.edit.temp_survey_id:"",parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Seleccionar Encuesta --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(surveys.list,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.id},opt.name);}))),version_groups_phases.edit.temp_survey_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Encuesta requerido')),!version_groups_phases.edit.temp_all_mods?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_modality_id',className:'label'},'Modalidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_modality_id',id:'temp_modality_id',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Modalidad ---'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(modalities.list,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:option.id,key:k},option.name);})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this2._addSurveys();},disabled:this._validMod(version_groups_phases.edit.temp_modality_id)},'Agregar'))):'',__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(version_groups_phases.edit.temp_survey_version_phases,function(row,s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-success is-medium',key:s},''+row.name+(row.modality_id?' - '+row.modality.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'delete',onClick:function onClick(){return _this2.props.remove('version_groups_phases.edit.temp_survey_version_phases',s);}}));})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),phaseData&&phaseData.require_survey?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-medium is-info',onClick:function onClick(){_this2._addPhase();},disabled:this._validPhase(version_groups_phases.edit.temp_id_phase)},'Agregar'))):''):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-danger'},'No tienes permiso para editar subprocesos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(version_groups_phases.edit.phases)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(version_groups_phases.edit.phases,{type:'project'}))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title is-5',style:{marginBottom:'-30px'}},'Listado de Subprocesos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acciones'))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(version_groups_phases.edit.phases,{type:'project'}),function(row,k){var phaseIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(version_groups_phases.edit.phases,{id:row.id});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{key:'phases-'+row.id,model:'.phases['+phaseIndex+']',component:'tbody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:'5%'},rowSpan:gpsa?3:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},_this2.state.modalSurveysShow&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModelSurveysEdit,Object.assign({active:_this2.state.modalSurveysShow,data:row,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),row.require_survey?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editSurveys(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-dark'},'# Encuestas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag is-medium is-inm-purple'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(row.survey_version_phases)))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_start_date_'+row.id,className:'label'},'Inicia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.temp_start_date',name:'temp_start_date_'+row.id,id:'temp_start_date_'+row.id,defaultValue:version_groups_phases.edit.phases[phaseIndex].temp_start_date?version_groups_phases.edit.phases[phaseIndex].temp_start_date:version_groups_phases.edit.phases[phaseIndex].start_date,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Inicia'),row.start_date),_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_end_date_'+row.id,className:'label'},'Termina'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.temp_end_date',name:'temp_end_date_'+row.id,id:'temp_end_date_'+row.id,defaultValue:version_groups_phases.edit.phases[phaseIndex].temp_end_date?version_groups_phases.edit.phases[phaseIndex].temp_end_date:version_groups_phases.edit.phases[phaseIndex].end_date,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Termina'),row.end_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'10%'},rowSpan:gpsa?2:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},gpu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-success',onClick:function onClick(){return _this2._savePhase(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-save'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this2._editPhase(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._closePhase(row.id);},className:'button is-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'})):gpd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._getConfirm(row.id,row.name);},className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})):'')))),gpsa?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_report_start_date_'+row.id,className:'label'},'Inicia reporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.temp_report_start_date',name:'temp_report_start_date_'+row.id,id:'temp_report_start_date_'+row.id,defaultValue:version_groups_phases.edit.phases[phaseIndex].temp_report_start_date?version_groups_phases.edit.phases[phaseIndex].temp_report_start_date:version_groups_phases.edit.phases[phaseIndex].report_start_date,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Inicia reporte'),row.report_start_date),_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_report_end_date_'+row.id,className:'label'},'Termina reporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.temp_report_end_date',name:'temp_report_end_date_'+row.id,id:'temp_report_end_date_'+row.id,defaultValue:version_groups_phases.edit.phases[phaseIndex].temp_report_end_date?version_groups_phases.edit.phases[phaseIndex].temp_report_end_date:version_groups_phases.edit.phases[phaseIndex].report_end_date,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Termina reporte'),row.report_end_date)):null)];}))))),this.state.tabId===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},gpc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'A\xF1adir Revisiones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_p_start_date',className:'label'},'Inicia Revisi\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.temp_p_start_date',name:'temp_p_start_date',id:'temp_p_start_date',value:version_groups_phases.edit.temp_p_start_date?version_groups_phases.edit.temp_p_start_date:undefined,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'}),version_groups_phases.edit.temp_p_start_date?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Fecha requerida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_p_end_date',className:'label'},'Termina Revisi\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.temp_p_end_date',name:'temp_p_end_date',id:'temp_p_end_date',value:version_groups_phases.edit.temp_p_end_date?version_groups_phases.edit.temp_p_end_date:undefined,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'}),version_groups_phases.edit.temp_p_end_date?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Fecha requerida'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'groups_phase',className:'label'},'Revisi\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_id_phase',name:'temp_id_phase',id:'temp_id_phase',value:version_groups_phases.edit.temp_id_phase?version_groups_phases.edit.temp_id_phase:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Seleccionar Revisi\xF3n --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(phases.list,{type:'revision'}),function(opt,k){var findPhase=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.edit.phases,{id:opt.id})?false:true;if(findPhase){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.id},opt.name);}}))),version_groups_phases.edit.temp_id_phase?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Revisi\xF3n requerida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){_this2._addPhase();},disabled:this._validPhase(version_groups_phases.edit.temp_id_phase)},'Agregar'))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-danger'},'No tienes permisos para editar revisiones')),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(version_groups_phases.edit.phases)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(version_groups_phases.edit.phases,{type:'revision'}))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Listado de revisiones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acciones'))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(version_groups_phases.edit.phases,{type:'revision'}),function(row,k){var phaseIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(version_groups_phases.edit.phases,{id:row.id});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{key:'phases_r_'+row.id,model:'.phases['+phaseIndex+']',component:'tbody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:'5%'},rowSpan:gpsa?3:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},_this2.state.modalSurveysShow&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModelSurveysEdit,Object.assign({active:_this2.state.modalSurveysShow,data:row,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),row.require_survey?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editSurveys(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-dark'},'# Encuestas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag is-medium is-inm-purple'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(row.survey_version_phases)))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_start_date_'+row.id,className:'label'},'Inicia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.temp_start_date',name:'temp_start_date_'+row.id,id:'temp_start_date_'+row.id,defaultValue:version_groups_phases.edit.phases[phaseIndex].temp_start_date?version_groups_phases.edit.phases[phaseIndex].temp_start_date:version_groups_phases.edit.phases[phaseIndex].start_date,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Inicia'),row.start_date),_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_end_date_'+row.id,className:'label'},'Termina'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.temp_end_date',name:'temp_end_date_'+row.id,id:'temp_end_date_'+row.id,defaultValue:version_groups_phases.edit.phases[phaseIndex].temp_end_date?version_groups_phases.edit.phases[phaseIndex].temp_end_date:version_groups_phases.edit.phases[phaseIndex].end_date,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Termina'),row.end_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'10%'},rowSpan:gpsa?2:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},gpu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-success',onClick:function onClick(){return _this2._savePhase(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-save'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this2._editPhase(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._closePhase(row.id);},className:'button is-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'})):gpd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._getConfirm(row.id,row.name);},className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})):'')))),gpsa?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_report_start_date_'+row.id,className:'label'},'Inicia reporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.temp_report_start_date',name:'temp_report_start_date_'+row.id,id:'temp_report_start_date_'+row.id,defaultValue:version_groups_phases.edit.phases[k].temp_report_start_date?version_groups_phases.edit.phases[k].temp_report_start_date:version_groups_phases.edit.phases[k].report_start_date,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Inicia reporte'),row.report_start_date),_this2.state.editPhase===true&&_this2.state.phaseId===row.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_report_end_date_'+row.id,className:'label'},'Termina reporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.temp_report_end_date',name:'temp_report_end_date_'+row.id,id:'temp_report_end_date_'+row.id,defaultValue:version_groups_phases.edit.phases[k].temp_report_end_date?version_groups_phases.edit.phases[k].temp_report_end_date:version_groups_phases.edit.phases[k].report_end_date,component:__WEBPACK_IMPORTED_MODULE_5__forms_datetimepicker__["a" /* default */],className:'input'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Termina reporte'),row.report_end_date)):null)];}))))),this.state.tabId===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},gpc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'A\xF1adir Notificaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_modality_id',className:'label'},'Modalidad ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_modality_id',id:'temp_modality_id',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Modalidad ---'),modalities.list.map(function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:option.id,key:k},option.name);}))),version_groups_phases.edit.temp_modality_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Modalidad requerida'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Claves'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Las siguientes claves pueden ser escritas en la edici\xF3n mensaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'{#asesor_name#} ',' = Nombre Asesor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'{#asesor_email#} ',' = Email Asesor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'{#asesor_extension#} ',' = Extensi\xF3n Asesor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_body',className:'label'},'Mensaje para notificacion ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.temp_body',id:'.temp_body',component:__WEBPACK_IMPORTED_MODULE_6__forms_wysiwyg_field__["a" /* default */]}),version_groups_phases.edit.temp_body&&version_groups_phases.edit.temp_body!=="<p><br></p>"?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Mensaje requerido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'groups_phase',className:'label'},'Notificaci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_notification_id',name:'temp_notification_id',id:'temp_notification_id',value:version_groups_phases.edit.temp_notification_id?version_groups_phases.edit.temp_notification_id:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Seleccionar Notificaci\xF3n --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(notifications_types.list,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.id},opt.name);}))),version_groups_phases.edit.temp_notification_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Notificaci\xF3n requerida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){_this2._addNotification();}},'Agregar'))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-danger'},'No tienes permisos para editar notificaciones')),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(version_groups_phases.edit.notifications_types)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Listado de Notificaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Modalidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(version_groups_phases.edit.notifications_types,function(row,k){var modality=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(modalities.list,{id:row.modality_id});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:'5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'15%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,modality?modality.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'10%'}},_this2.state.modalNotificationShow&&_this2.state.notificationIndex===k?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalNotificationEdit,Object.assign({active:_this2.state.modalNotificationShow,notificationIndex:k,data:row,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},gpu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this2._editNotification(k,row.modality_id,row.body);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))):'',gpd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._getConfirmNotification(k,row.name);},className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))):'')))];})))))),this.state.tabId===4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'A\xF1adir proyectos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_modality_id',className:'label'},'Modalidad ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_modality_id',id:'temp_modality_id',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Modalidad ---'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(modalities.list,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:option.id,key:k},option.name);})))),version_groups_phases.edit.temp_modality_id===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_state_id',className:'label'},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_state_id',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Estados --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(entities.list,function(state,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:state.id,key:k},state.name);})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-primary is-large'},'Proyectos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-inm-purple is-large'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(version_groups_phases.edit.projects)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),version_groups_phases.edit.temp_modality_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Listado de proyectos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'.projects',component:'tbody'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this._projectsList(version_groups_phases.edit.temp_modality_id,version_groups_phases.edit.temp_state_id),function(item,k){var initial=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findKey(version_groups_phases.edit.projects,{id:item.id})!==undefined?1:0;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'project-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Agregar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',onClick:function onClick(){return _this2._addProject(item.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_rating__["a" /* default */],{ref:'project-add-'+item.id,id:'project-add-'+item.id,initialRating:initial,start:0,stop:1,step:1,emptySymbol:'fa fa-square-o fa-2x',fullSymbol:'fa fa-check-square-o fa-2x',className:'has-text-white'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency?item.agency.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:'30%'}},version_groups_phases.edit.temp_modality_id!==2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Estado'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Municipio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency?item.agency.agenciable.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'general-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Proyecto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.name?item.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Titular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency&&item.agency.owner?item.agency.owner.name+' '+item.agency.owner.last_name+' '+item.agency.owner.slast_name:'---')))];})))):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/versiones/editar/'+match.params.year);}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'version_groups_phases.edit',className:'button is-large is-inm-purple',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.')))));}}]);function GroupPhaseEdit(props){_classCallCheck(this,GroupPhaseEdit);var _this=_possibleConstructorReturn(this,(GroupPhaseEdit.__proto__||Object.getPrototypeOf(GroupPhaseEdit)).call(this,props));_this.state={editPhase:false,modalPhaseShow:false,modalNotificationShow:false,modalSurveysShow:false,phaseId:undefined,phaseIndex:undefined,notificationIndex:undefined,tabId:1};_this._changeTab=_this._changeTab.bind(_this);return _this;}_createClass(GroupPhaseEdit,[{key:'_submitForm',value:function _submitForm(values){//console.log('values: ',values);
var year=this.props.match.params.year;this.props.versionGroupsPhasesEditSave(year,values);}},{key:'_changeTab',value:function _changeTab(id){return this.setState({tabId:id});}},{key:'_addSurveys',value:function _addSurveys(){var _props2=this.props,version_groups_phases=_props2.version_groups_phases,surveys=_props2.surveys,modalities=_props2.modalities;var surveysData=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(surveys.list,{id:version_groups_phases.edit.temp_survey_id});if(version_groups_phases.edit.temp_all_mods){this.props.add('version_groups_phases.edit.temp_survey_version_phases',Object.assign({},surveysData,{survey_id:version_groups_phases.edit.temp_survey_id}));}else{var modality=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(modalities.list,{id:version_groups_phases.edit.temp_modality_id});this.props.add('version_groups_phases.edit.temp_survey_version_phases',Object.assign({},surveysData,{survey_id:version_groups_phases.edit.temp_survey_id,modality_id:version_groups_phases.edit.temp_modality_id,modality:modality}));}this.props.change('version_groups_phases.edit.temp_survey_id',undefined);this.props.change('version_groups_phases.edit.temp_modality_id',undefined);this.props.change('version_groups_phases.edit.temp_all_mods',undefined);}},{key:'_validSurvey',value:function _validSurvey(){var _props3=this.props,version_groups_phases=_props3.version_groups_phases,phases=_props3.phases;var response=true;var phaseData=version_groups_phases.edit.temp_id_phase?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(phases.list,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(version_groups_phases.edit.temp_id_phase)}):undefined;if(phaseData&&phaseData.require_survey&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(version_groups_phases.edit.temp_survey_version_phases)){var validMods=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.edit.temp_survey_version_phases,function(o){return o.modality_id===undefined;});//console.log('validMods', validMods);
if(validMods){response=false;}else{var mod1=this._validMod(1);var mod2=this._validMod(2);var mod3=this._validMod(3);if(mod1&&mod2&&mod3){response=false;}else{response=true;}}}else{response=true;}return response;}},{key:'_validMod',value:function _validMod(id){var version_groups_phases=this.props.version_groups_phases;var response=false;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.edit.temp_survey_version_phases,{modality_id:id})){response=true;}else{response=false;}return response;}},{key:'_validPhase',value:function _validPhase(id){var version_groups_phases=this.props.version_groups_phases;var response=false;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.edit.phases,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(id)})){response=true;}else{response=false;}return response;}},{key:'_addPhase',value:function _addPhase(){var _props4=this.props,version_groups_phases=_props4.version_groups_phases,phases=_props4.phases;if(version_groups_phases.edit.temp_p_start_date!==undefined&&version_groups_phases.edit.temp_p_end_date!==undefined&&version_groups_phases.edit.temp_id_phase!==undefined){var phase=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(phases.list,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toInteger(version_groups_phases.edit.temp_id_phase)});if(phase.require_survey&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(version_groups_phases.edit.temp_survey_version_phases)){this.props.add('version_groups_phases.edit.phases',Object.assign({},phase,{start_date:version_groups_phases.edit.temp_p_start_date,end_date:version_groups_phases.edit.temp_p_end_date,survey_version_phases:version_groups_phases.edit.temp_survey_version_phases}));this.props.change('version_groups_phases.edit.temp_id_phase',undefined);this.props.change('version_groups_phases.edit.temp_p_start_date',undefined);this.props.change('version_groups_phases.edit.temp_p_end_date',undefined);this.props.change('version_groups_phases.edit.temp_survey_version_phases',undefined);}else{this.props.add('version_groups_phases.edit.phases',Object.assign({},phase,{start_date:version_groups_phases.edit.temp_p_start_date,end_date:version_groups_phases.edit.temp_p_end_date}));this.props.change('version_groups_phases.edit.temp_id_phase',undefined);this.props.change('version_groups_phases.edit.temp_p_start_date',undefined);this.props.change('version_groups_phases.edit.temp_p_end_date',undefined);}}}},{key:'_editPhase',value:function _editPhase(id){this.setState({editPhase:true,phaseId:id});}},{key:'_savePhase',value:function _savePhase(phaseId){var version_groups_phases=this.props.version_groups_phases;var phaseIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(version_groups_phases.edit.phases,{id:phaseId});this.setState({editPhase:false,phaseId:undefined});this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].start_date',version_groups_phases.edit.phases[phaseIndex].temp_start_date);this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].end_date',version_groups_phases.edit.phases[phaseIndex].temp_end_date);this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].temp_start_date',undefined);this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].temp_end_date',undefined);this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].report_start_date',version_groups_phases.edit.phases[phaseIndex].temp_report_start_date);this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].report_end_date',version_groups_phases.edit.phases[phaseIndex].temp_report_end_date);this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].temp_report_start_date',undefined);this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].temp_report_end_date',undefined);}},{key:'_getConfirm',value:function _getConfirm(phaseId,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la fase "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3._removePhase(phaseId);}});}},{key:'_removePhase',value:function _removePhase(phaseId){var version_groups_phases=this.props.version_groups_phases;var phaseIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(version_groups_phases.edit.phases,{id:phaseId});this.props.remove('version_groups_phases.edit.phases',phaseIndex);}},{key:'_closePhase',value:function _closePhase(phaseId){var version_groups_phases=this.props.version_groups_phases;var phaseIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(version_groups_phases.edit.phases,{id:phaseId});this.setState({editPhase:false,phaseId:undefined});this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].temp_start_date',undefined);this.props.change('version_groups_phases.edit.phases['+phaseIndex+'].temp_end_date',undefined);}},{key:'_addNotification',value:function _addNotification(){var _props5=this.props,version_groups_phases=_props5.version_groups_phases,notifications_types=_props5.notifications_types;if(version_groups_phases.edit.temp_notification_id!==undefined&&version_groups_phases.edit.temp_modality_id!==undefined&&(version_groups_phases.edit.temp_body!==undefined||version_groups_phases.edit.temp_body!==null)){var notification=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(notifications_types.list,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toInteger(version_groups_phases.edit.temp_notification_id)});this.props.add('version_groups_phases.edit.notifications_types',Object.assign({},notification,{id:version_groups_phases.edit.temp_notification_id,modality_id:version_groups_phases.edit.temp_modality_id,body:version_groups_phases.edit.temp_body}));this.props.change('version_groups_phases.edit.temp_notification_id',undefined);this.props.change('version_groups_phases.edit.temp_modality_id',undefined);this.props.change('version_groups_phases.edit.temp_body',null);}}},{key:'_editNotification',value:function _editNotification(index,modalityId,body){this.props.change('version_groups_phases.edit.notifications_types['+index+'].temp_modality_id',undefined);this.props.change('version_groups_phases.edit.notifications_types['+index+'].temp_body',null);this.props.change('version_groups_phases.edit.notifications_types['+index+'].temp_modality_id',modalityId);this.props.change('version_groups_phases.edit.notifications_types['+index+'].temp_body',body);this.setState({modalNotificationShow:true,notificationIndex:index});}},{key:'_getConfirmNotification',value:function _getConfirmNotification(index,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_4_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la notificaci\xF3n "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4._removeNotification(index);}});}},{key:'_removeNotification',value:function _removeNotification(index){this.props.remove('version_groups_phases.edit.notifications_types',index);}},{key:'_editSurveys',value:function _editSurveys(id){var version_groups_phases=this.props.version_groups_phases;var index=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(version_groups_phases.edit.phases,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(id)});this.props.change('version_groups_phases.edit.phases['+index+']',Object.assign({},version_groups_phases.edit.phases[index],{phaseIndex:index,temp_survey_version_phases:version_groups_phases.edit.phases[index].survey_version_phases}));this.setState({modalSurveysShow:true,phaseId:id});}},{key:'_toggleModal',value:function _toggleModal(){this.setState({modalNotificationShow:false,modalSurveysShow:false,notificationIndex:undefined,phaseId:undefined});}},{key:'_projectsList',value:function _projectsList(mod,state){var projects=this.props.projects;var list=[];if(mod&&mod!==2){list=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(projects.list,{modality_id:mod});}else if(mod&&state){list=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(projects.list,{modality_id:mod,agency:{agenciable:{state_id:state}}});}return list;}},{key:'_changeAllProject',value:function _changeAllProject(model,value){var edit=this.props.version_groups_phases.edit;var list=this.props.projects.list;this.props.change(model,value);if(!value){if(edit.version_phase_group.version_id&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(list)){this.props.fetchEntities();this.props.fetchProjectsList(edit.version_phase_group.version_id);}}else{this._changeTab(1);this.props.change('version_groups_phases.edit.projects',[]);}}},{key:'_addProject',value:function _addProject(projectId){var projects=this.props.version_groups_phases.edit.projects;var projectsIndex=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(projects,{id:projectId});if(this.refs['project-add-'+projectId].state.value===0){if(projectsIndex===-1){this.props.add('version_groups_phases.edit.projects',{id:projectId});}else{this.props.change('version_groups_phases.edit.projects['+projectsIndex+']',{id:projectId});}}else{if(projectsIndex!==-1){this.props.remove('version_groups_phases.edit.projects',projectsIndex);}}}},{key:'_validateSave',value:function _validateSave(){var version_groups_phases=this.props.version_groups_phases;var gpc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.permissions,function(o){return o==='Create';});var gpu=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.permissions,function(o){return o==='Update';});var gpd=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(version_groups_phases.permissions,function(o){return o==='Delete';});if(gpc||gpu||gpd){return false;}else{return true;}}}]);return GroupPhaseEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GroupPhaseEdit);var ModalNotificationEdit=function(_Component2){_inherits(ModalNotificationEdit,_Component2);function ModalNotificationEdit(){_classCallCheck(this,ModalNotificationEdit);return _possibleConstructorReturn(this,(ModalNotificationEdit.__proto__||Object.getPrototypeOf(ModalNotificationEdit)).apply(this,arguments));}_createClass(ModalNotificationEdit,[{key:'render',value:function render(){var _this6=this;var _props6=this.props,data=_props6.data,version_groups_phases=_props6.version_groups_phases,modalities=_props6.modalities,notificationIndex=_props6.notificationIndex;var index=notificationIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'version_groups_phases.edit.notifications_types['+index+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_modality_id',className:'label'},'Modalidad ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_modality_id',id:'temp_modality_id',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Modalidad ---'),modalities.list.map(function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:option.id,key:k},option.name);}))),version_groups_phases.edit.notifications_types[index].temp_modality_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Mensaje requerido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Claves'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Las siguientes claves pueden ser escritas en la edici\xF3n mensaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'{#asesor_name#} ',' = Nombre Asesor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'{#asesor_email#} ',' = Email Asesor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'{#asesor_extension#} ',' = Extensi\xF3n Asesor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_body',className:'label'},'Mensaje para notificacion ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.temp_body',id:'.temp_body',component:__WEBPACK_IMPORTED_MODULE_6__forms_wysiwyg_field__["a" /* default */]}),version_groups_phases.edit.notifications_types[index].temp_body?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Mensaje requerido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-success',onClick:function onClick(){return _this6._saveNotification();}},'Guardar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'_saveNotification',value:function _saveNotification(){var _props7=this.props,data=_props7.data,version_groups_phases=_props7.version_groups_phases,notificationIndex=_props7.notificationIndex;var index=notificationIndex;this.props.change('version_groups_phases.edit.notifications_types['+index+']',Object.assign({},data,{modality_id:version_groups_phases.edit.notifications_types[index].temp_modality_id,body:version_groups_phases.edit.notifications_types[index].temp_body}));this.props.change('version_groups_phases.edit.notifications_types['+index+'].temp_modality_id',undefined);this.props.change('version_groups_phases.edit.notifications_types['+index+'].temp_body',null);this.props.closeModal();}}]);return ModalNotificationEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModelSurveysEdit=function(_Component3){_inherits(ModelSurveysEdit,_Component3);function ModelSurveysEdit(){_classCallCheck(this,ModelSurveysEdit);return _possibleConstructorReturn(this,(ModelSurveysEdit.__proto__||Object.getPrototypeOf(ModelSurveysEdit)).apply(this,arguments));}_createClass(ModelSurveysEdit,[{key:'render',value:function render(){var _this8=this;var _props8=this.props,data=_props8.data,surveys=_props8.surveys,modalities=_props8.modalities;var validMods=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(data.temp_survey_version_phases,function(o){return o.modality_id!==undefined||o.modality_id!==null;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:function onClick(){return _this8._closeSurveyModal();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this8._closeSurveyModal();},className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},this._validSurvey()&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(validMods)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_all_mods',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.temp_all_mods',id:'temp_all_mods',className:'checkbox',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Aplica para todas las modalidades ')))))))):'',this._validSurvey()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'groups_phase',className:'label'},'Encuesta ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_survey_id',name:'temp_survey_id',id:'temp_survey_id',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Seleccionar Encuesta --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(surveys.list,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.id},opt.name);}))),data.temp_survey_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Encuesta requerido')),!data.temp_all_mods?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_modality_id',className:'label'},'Modalidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.temp_modality_id',id:'temp_modality_id',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Modalidad ---'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(modalities.list,function(option,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:option.id,key:k},option.name);})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this8._addSurveys();},disabled:this._validMod(data.temp_modality_id)},'Agregar'))):'',__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data.temp_survey_version_phases,function(row,s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-success is-medium',key:s},''+(row.survey?row.survey.name:row.name)+(row.modality_id?' - '+row.modality.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'delete',onClick:function onClick(){return _this8.props.remove('version_groups_phases.edit.phases['+data.phaseIndex+'].temp_survey_version_phases',s);}}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this8._closeSurveyModal();}},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-success',onClick:function onClick(){return _this8._saveSurveys();}},'Guardar'))))));}},{key:'_validSurvey',value:function _validSurvey(){var data=this.props.data;var response=true;if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.temp_survey_version_phases)){var validMods=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(data.temp_survey_version_phases,function(o){return o.modality_id===undefined||o.modality_id===null;});//console.log('validMods', validMods);
if(validMods){response=false;}else{var mod1=this._validMod(1);var mod2=this._validMod(2);var mod3=this._validMod(3);if(mod1&&mod2&&mod3){response=false;}else{response=true;}}}else{response=true;}return response;}},{key:'_validMod',value:function _validMod(id){var data=this.props.data;var response=false;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(data.temp_survey_version_phases,{modality_id:id})){response=true;}else{response=false;}return response;}},{key:'_addSurveys',value:function _addSurveys(){var _props9=this.props,data=_props9.data,surveys=_props9.surveys,modalities=_props9.modalities;var surveysData=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(surveys.list,{id:data.temp_survey_id});if(data.temp_all_mods){this.props.add('version_groups_phases.edit.phases['+data.phaseIndex+'].temp_survey_version_phases',Object.assign({},surveysData,{survey_id:data.temp_survey_id}));}else{var modality=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(modalities.list,{id:data.temp_modality_id});this.props.add('version_groups_phases.edit.phases['+data.phaseIndex+'].temp_survey_version_phases',Object.assign({},surveysData,{survey_id:data.temp_survey_id,modality_id:data.temp_modality_id,modality:modality}));}this.props.change('version_groups_phases.edit.phases['+data.phaseIndex+'].temp_survey_id',undefined);this.props.change('version_groups_phases.edit.phases['+data.phaseIndex+'].temp_modality_id',undefined);this.props.change('version_groups_phases.edit.phases['+data.phaseIndex+'].temp_all_mods',undefined);}},{key:'_saveSurveys',value:function _saveSurveys(){var data=this.props.data;this.props.change('version_groups_phases.edit.phases['+data.phaseIndex+'].survey_version_phases',data.temp_survey_version_phases);this.props.change('version_groups_phases.edit.phases['+data.phaseIndex+'].temp_survey_version_phases',undefined);this.props.closeModal();}},{key:'_closeSurveyModal',value:function _closeSurveyModal(){var data=this.props.data;this.props.change('version_groups_phases.edit.phases['+data.phaseIndex+'].temp_survey_version_phases',undefined);this.props.closeModal();}}]);return ModelSurveysEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

/*
React-Quill v1.0.0
https://github.com/zenoamaro/react-quill
*/
var Quill = __webpack_require__(228);
var Component = __webpack_require__(528);

module.exports = Component;
module.exports.default = Component;
module.exports.Quill = Quill;
module.exports.Mixin = __webpack_require__(230);
module.exports.Toolbar = __webpack_require__(624);


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(525)
var ieee754 = __webpack_require__(526)
var isArray = __webpack_require__(527)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 526 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 527 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(32);
var createClass = __webpack_require__(229);
var QuillMixin = __webpack_require__(230);
var find = __webpack_require__(231);
var some = __webpack_require__(616);
var isEqual = __webpack_require__(245);
var T = __webpack_require__(6);
var DOM = __webpack_require__(246);

var QuillComponent = createClass({

	displayName: 'Quill',

	mixins: [ QuillMixin ],

	propTypes: {
		id: T.string,
		className: T.string,
		theme: T.string,
		style: T.object,
		readOnly: T.bool,
		value: T.oneOfType([T.string, T.shape({ops: T.array})]),
		defaultValue: T.oneOfType([T.string, T.shape({ops: T.array})]),
		placeholder: T.string,
		tabIndex: T.number,
		bounds: T.oneOfType([T.string, T.element]),
		onChange: T.func,
		onChangeSelection: T.func,
		onFocus: T.func,
		onBlur: T.func,
		onKeyPress: T.func,
		onKeyDown: T.func,
		onKeyUp: T.func,
		preserveWhitespace: T.bool,

		modules: function(props) {
			var isNotObject = T.object.apply(this, arguments);
			if (isNotObject) return isNotObject;

			if (
				props.modules && 
				props.modules.toolbar &&
				props.modules.toolbar[0] &&
				props.modules.toolbar[0].type
			) return new Error(
				'Since v1.0.0, React Quill will not create a custom toolbar for you ' +
				'anymore. Create a toolbar explictly, or let Quill create one. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
			);
		},

		toolbar: function(props) {
			if ('toolbar' in props) return new Error(
				'The `toolbar` prop has been deprecated. Use `modules.toolbar` instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
			);
		},

		formats: function(props) {
			var isNotArrayOfString = T.arrayOf(T.string).apply(this, arguments);

			if (isNotArrayOfString) return new Error(
				'You cannot specify custom `formats` anymore. Use Parchment instead.  ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
			);
		},

		styles: function(props) {
			if ('styles' in props) return new Error(
				'The `styles` prop has been deprecated. Use custom stylesheets instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
			);
		},

		pollInterval: function(props) {
			if ('pollInterval' in props) return new Error(
				'The `pollInterval` property does not have any effect anymore. ' +
				'You can safely remove it from your props.' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
			);
		},

		children: function(props) {
			// Validate that the editor has only one child element and it is not a <textarea>
			var isNotASingleElement = T.element.apply(this, arguments);
			if (isNotASingleElement) return new Error(
				'The Quill editing area can only be composed of a single React element.'
			);

			if (React.Children.count(props.children)) {
				var child = React.Children.only(props.children);
				if (child.type === 'textarea') return new Error(
					'Quill does not support editing on a <textarea>. Use a <div> instead.'
				);
			}
		}
	},
		
	/*
	Changing one of these props should cause a full re-render.
	*/
	dirtyProps: [
		'modules',
		'formats',
		'bounds',
		'theme',
		'children',
	],

	/*
	Changing one of these props should cause a regular update.
	*/
	cleanProps: [
		'id',
		'className',
		'style',
		'placeholder',
		'tabIndex',
		'onChange',
		'onChangeSelection',
		'onFocus',
		'onBlur',
		'onKeyPress',
		'onKeyDown',
		'onKeyUp',
	],

	getDefaultProps: function() {
		return {
			theme: 'snow',
			modules: {},
		};
	},

	/*
	We consider the component to be controlled if `value` is being sent in props.
	*/
	isControlled: function() {
		return 'value' in this.props;
	},

	getInitialState: function() {
		return {
			generation: 0,
			value: this.isControlled()
				? this.props.value
				: this.props.defaultValue
		};
	},

	componentWillReceiveProps: function(nextProps, nextState) {
		var editor = this.editor;

		// If the component is unmounted and mounted too quickly
		// an error is thrown in setEditorContents since editor is
		// still undefined. Must check if editor is undefined
		// before performing this call.
		if (!editor) return;
		
		// Update only if we've been passed a new `value`.
		// This leaves components using `defaultValue` alone.
		if ('value' in nextProps) {
			var currentContents = this.getEditorContents();
			var nextContents = nextProps.value;

			if (nextContents === this.lastDeltaChangeSet) throw new Error(
				'You are passing the `delta` object from the `onChange` event back ' +
				'as `value`. You most probably want `editor.getContents()` instead. ' +
				'See: https://github.com/zenoamaro/react-quill#using-deltas'
			);

			// NOTE: Seeing that Quill is missing a way to prevent
			//       edits, we have to settle for a hybrid between
			//       controlled and uncontrolled mode. We can't prevent
			//       the change, but we'll still override content
			//       whenever `value` differs from current state.
			// NOTE: Comparing an HTML string and a Quill Delta will always trigger 
			//       a change, regardless of whether they represent the same document.
			if (!this.isEqualValue(nextContents, currentContents)) {
				this.setEditorContents(editor, nextContents);
			}
		}
		
		// We can update readOnly state in-place.
		if ('readOnly' in nextProps) {
			if (nextProps.readOnly !== this.props.readOnly) {
				this.setEditorReadOnly(editor, nextProps.readOnly);
			}
		}

		// If we need to regenerate the component, we can avoid a detailed
		// in-place update step, and just let everything rerender.
		if (this.shouldComponentRegenerate(nextProps, nextState)) {
			return this.regenerate();
		}
	},

	componentDidMount: function() {
		this.editor = this.createEditor(
			this.getEditingArea(),
			this.getEditorConfig()
		);
		// Restore editor from Quill's native formats in regeneration scenario
		if (this.quillDelta) {
			this.editor.setContents(this.quillDelta);
			this.editor.setSelection(this.quillSelection);		
			this.editor.focus();
			this.quillDelta = this.quillSelection = null;
			return;
		}
		if (this.state.value) {
			this.setEditorContents(this.editor, this.state.value);
			return;
		}
	},

	componentWillUnmount: function() {
		var editor; if ((editor = this.getEditor())) {
			this.unhookEditor(editor);
			this.editor = null;
		}
	},

	shouldComponentUpdate: function(nextProps, nextState) {
		var self = this;

		// If the component has been regenerated, we already know we should update.
		if (this.state.generation !== nextState.generation) {
			return true;
		}
		
		// Compare props that require React updating the DOM.
		return some(this.cleanProps, function(prop) {
			// Note that `isEqual` compares deeply, making it safe to perform
			// non-immutable updates, at the cost of performance.
			return !isEqual(nextProps[prop], self.props[prop]);
		});
	},

	shouldComponentRegenerate: function(nextProps, nextState) {
		var self = this;
		// Whenever a `dirtyProp` changes, the editor needs reinstantiation.
		return some(this.dirtyProps, function(prop) {
			// Note that `isEqual` compares deeply, making it safe to perform
			// non-immutable updates, at the cost of performance.
			return !isEqual(nextProps[prop], self.props[prop]);
		});
	},

	/*
	If we could not update settings from the new props in-place, we have to tear
	down everything and re-render from scratch.
	*/
	componentWillUpdate: function(nextProps, nextState) {
		if (this.state.generation !== nextState.generation) {
			this.componentWillUnmount();
		}
	},

	componentDidUpdate: function(prevProps, prevState) {
		if (this.state.generation !== prevState.generation) {
			this.componentDidMount();
		}
	},

	getEditorConfig: function() {
		return {
			bounds:       this.props.bounds,
			formats:      this.props.formats,
			modules:      this.props.modules,
			placeholder:  this.props.placeholder,
			readOnly:     this.props.readOnly,
      			scrollingContainer: this.props.scrollingContainer,
			tabIndex:     this.props.tabIndex,
			theme:        this.props.theme,
		};
	},

	getEditor: function() {
		return this.editor;
	},

	getEditingArea: function () {
		return ReactDOM.findDOMNode(this.editingArea);
	},

	getEditorContents: function() {
		return this.state.value;
	},

	getEditorSelection: function() {
		return this.state.selection;
	},

	/*
	True if the value is a Delta instance or a Delta look-alike.
	*/
	isDelta: function(value) {
		return value && value.ops;
	},

	/*
	Special comparison function that knows how to compare Deltas.
	*/
	isEqualValue: function(value, nextValue) {
		if (this.isDelta(value) && this.isDelta(nextValue)) {
			return isEqual(value.ops, nextValue.ops);
		} else {
			return isEqual(value, nextValue);
		}
	},

	/*
	Regenerating the editor will cause the whole tree, including the container,
	to be cleaned up and re-rendered from scratch.
	*/
	regenerate: function() {
		// Cache selection and contents in Quill's native format to be restored later
		this.quillDelta = this.editor.getContents();
		this.quillSelection = this.editor.getSelection();
		this.setState({
			generation: this.state.generation + 1,
		});
	},

	/*
	Renders an editor area, unless it has been provided one to clone.
	*/
	renderEditingArea: function() {
		var self = this;
		var children = this.props.children;
		var preserveWhitespace = this.props.preserveWhitespace;

		var properties = {
			key: this.state.generation,
			tabIndex: this.props.tabIndex,
			ref: function(element) { self.editingArea = element },
		};

		var customElement = React.Children.count(children)
			? React.Children.only(children)
			: null;
		var defaultElement = preserveWhitespace ? DOM.pre : DOM.div;
		var editingArea = customElement
			? React.cloneElement(customElement, properties)
			: defaultElement(properties);

		return editingArea;
	},

	render: function() {
		return DOM.div({
			id: this.props.id,
			style: this.props.style,
			key: this.state.generation,
			className: ['quill'].concat(this.props.className).join(' '),
			onKeyPress: this.props.onKeyPress,
			onKeyDown: this.props.onKeyDown,
			onKeyUp: this.props.onKeyUp },
			this.renderEditingArea()
		);
	},

	onEditorChangeText: function(value, delta, source, editor) {
		var currentContents = this.getEditorContents();

		// We keep storing the same type of value as what the user gives us,
		// so that value comparisons will be more stable and predictable.
		var nextContents = this.isDelta(currentContents)
			? editor.getContents()
			: editor.getHTML();
		
		if (!this.isEqualValue(nextContents, currentContents)) {
			// Taint this `delta` object, so we can recognize whether the user
			// is trying to send it back as `value`, preventing a likely loop.
			this.lastDeltaChangeSet = delta;

			this.setState({ value: nextContents });

			if (this.props.onChange) {
				this.props.onChange(value, delta, source, editor);
			}
		}
	},

	onEditorChangeSelection: function(nextSelection, source, editor) {
		var currentSelection = this.getEditorSelection();
		var hasGainedFocus = !currentSelection && nextSelection;
		var hasLostFocus = currentSelection && !nextSelection;

		if (isEqual(nextSelection, currentSelection)) {
			return;
		}
		
		this.setState({ selection: nextSelection });
		
		if (this.props.onChangeSelection) {
			this.props.onChangeSelection(nextSelection, source, editor);
		}

		if (hasGainedFocus && this.props.onFocus) {
			this.props.onFocus(nextSelection, source, editor);
		} else if (hasLostFocus && this.props.onBlur) {
			this.props.onBlur(currentSelection, source, editor);
		}
	},

	focus: function() {
		this.editor.focus();
	},

	blur: function() {
		this.setEditorSelection(this.editor, null);
	}

});

module.exports = QuillComponent;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(57);

var emptyObject = __webpack_require__(530);
var _invariant = __webpack_require__(531);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(135),
    isArrayLike = __webpack_require__(93),
    keys = __webpack_require__(92);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(534),
    getMatchData = __webpack_require__(595),
    matchesStrictComparable = __webpack_require__(242);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(232),
    baseIsEqual = __webpack_require__(139);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(88);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(88);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(88);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(88);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(87);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 541 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 542 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 543 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(87),
    Map = __webpack_require__(137),
    MapCache = __webpack_require__(138);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(233),
    isMasked = __webpack_require__(548),
    isObject = __webpack_require__(67),
    toSource = __webpack_require__(235);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(549);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(29);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(552),
    ListCache = __webpack_require__(87),
    Map = __webpack_require__(137);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(553),
    hashDelete = __webpack_require__(554),
    hashGet = __webpack_require__(555),
    hashHas = __webpack_require__(556),
    hashSet = __webpack_require__(557);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(90);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 554 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(90);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(90);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(90);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(91);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 559 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(91);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(91);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(91);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(232),
    equalArrays = __webpack_require__(236),
    equalByTag = __webpack_require__(568),
    equalObjects = __webpack_require__(572),
    getTag = __webpack_require__(590),
    isArray = __webpack_require__(30),
    isBuffer = __webpack_require__(239),
    isTypedArray = __webpack_require__(240);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(138),
    setCacheAdd = __webpack_require__(565),
    setCacheHas = __webpack_require__(566);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 566 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 567 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89),
    Uint8Array = __webpack_require__(569),
    eq = __webpack_require__(136),
    equalArrays = __webpack_require__(236),
    mapToArray = __webpack_require__(570),
    setToArray = __webpack_require__(571);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(29);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 570 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 571 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(573);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(574),
    getSymbols = __webpack_require__(576),
    keys = __webpack_require__(92);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(575),
    isArray = __webpack_require__(30);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(577),
    stubArray = __webpack_require__(578);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(580),
    isArguments = __webpack_require__(238),
    isArray = __webpack_require__(30),
    isBuffer = __webpack_require__(239),
    isIndex = __webpack_require__(140),
    isTypedArray = __webpack_require__(240);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 580 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(66),
    isObjectLike = __webpack_require__(68);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(66),
    isLength = __webpack_require__(141),
    isObjectLike = __webpack_require__(68);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 584 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(234);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)(module)))

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(587),
    nativeKeys = __webpack_require__(588);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(589);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(591),
    Map = __webpack_require__(137),
    Promise = __webpack_require__(592),
    Set = __webpack_require__(593),
    WeakMap = __webpack_require__(594),
    baseGetTag = __webpack_require__(66),
    toSource = __webpack_require__(235);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(29);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(29);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(29);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(29);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(241),
    keys = __webpack_require__(92);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(139),
    get = __webpack_require__(597),
    hasIn = __webpack_require__(604),
    isKey = __webpack_require__(142),
    isStrictComparable = __webpack_require__(241),
    matchesStrictComparable = __webpack_require__(242),
    toKey = __webpack_require__(95);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(243);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(599);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(600);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(138);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(602);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89),
    arrayMap = __webpack_require__(603),
    isArray = __webpack_require__(30),
    isSymbol = __webpack_require__(94);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 603 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(605),
    hasPath = __webpack_require__(606);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 605 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(244),
    isArguments = __webpack_require__(238),
    isArray = __webpack_require__(30),
    isIndex = __webpack_require__(140),
    isLength = __webpack_require__(141),
    toKey = __webpack_require__(95);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 607 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(609),
    basePropertyDeep = __webpack_require__(610),
    isKey = __webpack_require__(142),
    toKey = __webpack_require__(95);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 609 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(243);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(612),
    baseIteratee = __webpack_require__(135),
    toInteger = __webpack_require__(613);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 612 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(614);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(615);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67),
    isSymbol = __webpack_require__(94);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(237),
    baseIteratee = __webpack_require__(135),
    baseSome = __webpack_require__(617),
    isArray = __webpack_require__(30),
    isIterateeCall = __webpack_require__(623);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(618);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(619),
    createBaseEach = __webpack_require__(622);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(620),
    keys = __webpack_require__(92);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(621);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(93);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(136),
    isArrayLike = __webpack_require__(93),
    isIndex = __webpack_require__(140),
    isObject = __webpack_require__(67);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
QuillToolbar is deprecated. Consider switching to the official Quill
toolbar format, or providing your own toolbar instead. 
See https://quilljs.com/docs/modules/toolbar
*/



var React = __webpack_require__(0);
var ReactDOMServer = __webpack_require__(247);
var createClass = __webpack_require__(229);
var find = __webpack_require__(231);
var isEqual = __webpack_require__(245);
var T = __webpack_require__(6);
var DOM = __webpack_require__(246);

var defaultColors = [
	'rgb(  0,   0,   0)', 'rgb(230,   0,   0)', 'rgb(255, 153,   0)',
	'rgb(255, 255,   0)', 'rgb(  0, 138,   0)', 'rgb(  0, 102, 204)',
	'rgb(153,  51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)',
	'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)',
	'rgb(204, 224, 245)', 'rgb(235, 214, 255)', 'rgb(187, 187, 187)',
	'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)',
	'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)',
	'rgb(136, 136, 136)', 'rgb(161,   0,   0)', 'rgb(178, 107,   0)',
	'rgb(178, 178,   0)', 'rgb(  0,  97,   0)', 'rgb(  0,  71, 178)',
	'rgb(107,  36, 178)', 'rgb( 68,  68,  68)', 'rgb( 92,   0,   0)',
	'rgb(102,  61,   0)', 'rgb(102, 102,   0)', 'rgb(  0,  55,   0)',
	'rgb(  0,  41, 102)', 'rgb( 61,  20,  10)',
].map(function(color){ return { value: color } });

var defaultItems = [

	{ label:'Formats', type:'group', items: [
		{ label:'Font', type:'font', items: [
			{ label:'Sans Serif',  value:'sans-serif', selected:true },
			{ label:'Serif',       value:'serif' },
			{ label:'Monospace',   value:'monospace' }
		]},
		{ label:'Size', type:'size', items: [
			{ label:'Small',  value:'10px' },
			{ label:'Normal', value:'13px', selected:true },
			{ label:'Large',  value:'18px' },
			{ label:'Huge',   value:'32px' }
		]},
		{ label:'Alignment', type:'align', items: [
			{ label:'', value:'', selected:true },
			{ label:'', value:'center' },
			{ label:'', value:'right' },
			{ label:'', value:'justify' }
		]}
	]},

	{ label:'Text', type:'group', items: [
		{ type:'bold', label:'Bold' },
		{ type:'italic', label:'Italic' },
		{ type:'strike', label:'Strike' },
		{ type:'underline', label:'Underline' },
		{ type:'color', label:'Color', items:defaultColors },
		{ type:'background', label:'Background color', items:defaultColors },
		{ type:'link', label:'Link' }
	]},

	{ label:'Blocks', type:'group', items: [
		{ type:'list', value:'bullet' },
		{ type:'list', value:'ordered' }
	]},

	{ label:'Blocks', type:'group', items: [
		{ type:'image', label:'Image' }
	]}

];

var QuillToolbar = createClass({

	displayName: 'Quill Toolbar',

	propTypes: {
		id:        T.string,
		className: T.string,
		style:     T.object,
		items:     T.array
	},

	getDefaultProps: function() {
		return {
			items: defaultItems
		};
	},

	componentDidMount: function() {
		console.warn(
			'QuillToolbar is deprecated. Consider switching to the official Quill ' +
			'toolbar format, or providing your own toolbar instead. ' +
			'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v1-0-0'
		);
	},

	shouldComponentUpdate: function(nextProps, nextState) {
		return !isEqual(nextProps, this.props);
	},

	renderGroup: function(item, key) {
		return DOM.span({
			key: item.label || key,
			className:'ql-formats' },
			item.items.map(this.renderItem)
		);
	},

	renderChoiceItem: function(item, key) {
		return DOM.option({
			key: item.label || item.value || key,
			value: item.value },
			item.label
		);
	},

	renderChoices: function(item, key) {
		var choiceItems = item.items.map(this.renderChoiceItem);
		var selectedItem = find(item.items, function(item){ return item.selected });
		var attrs = {
			key: item.label || key,
			title: item.label,
			className: 'ql-'+item.type,
			value: selectedItem.value,
		};
		return DOM.select(attrs, choiceItems);
	},

	renderButton: function(item, key) {
		return DOM.button({
			type: 'button',
			key: item.label || item.value || key,
			value: item.value,
			className: 'ql-'+item.type,
			title: item.label },
			item.children
		);
	},

	renderAction: function(item, key) {
		return DOM.button({
			key: item.label || item.value || key,
			className: 'ql-'+item.type,
			title: item.label },
			item.children
		);
	},

	/* jshint maxcomplexity: false */
	renderItem: function(item, key) {
		switch (item.type) {
			case 'group':
				return this.renderGroup(item, key);
			case 'font':
			case 'header':
			case 'align':
			case 'size':
			case 'color':
			case 'background':
				return this.renderChoices(item, key);
			case 'bold':
			case 'italic':
			case 'underline':
			case 'strike':
			case 'link':
			case 'list':
			case 'bullet':
			case 'ordered':
			case 'indent':
			case 'image':
			case 'video':
				return this.renderButton(item, key);
			default:
				return this.renderAction(item, key);
		}
	},

	getClassName: function() {
		return 'quill-toolbar ' + (this.props.className||'');
	},

	render: function() {
		var children = this.props.items.map(this.renderItem);
		var html = children.map(ReactDOMServer.renderToStaticMarkup).join('');
		return DOM.div({
			id: this.props.id,
			className: this.getClassName(),
			style: this.props.style,
			dangerouslySetInnerHTML: { __html:html }
		});
	},

});

module.exports = QuillToolbar;
QuillToolbar.defaultItems = defaultItems;
QuillToolbar.defaultColors = defaultColors;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(57),l=__webpack_require__(0);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,w=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
60116,ka=t?Symbol.for("react.fundamental"):60117,la=t?Symbol.for("react.scope"):60119,C=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;C.hasOwnProperty("ReactCurrentDispatcher")||(C.ReactCurrentDispatcher={current:null});C.hasOwnProperty("ReactCurrentBatchConfig")||(C.ReactCurrentBatchConfig={suspense:null});
function ma(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
function D(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case w:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ia:return D(a.type);case ja:if(a=1===a._status?a._result:null)return D(a)}return null}var na={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}function oa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=na;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var pa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,qa=Object.prototype.hasOwnProperty,ra={},sa={};
function ta(a){if(qa.call(sa,a))return!0;if(qa.call(ra,a))return!1;if(pa.test(a))return sa[a]=!0;ra[a]=!0;return!1}function ua(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function va(a,b,c,d){if(null===b||"undefined"===typeof b||ua(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var wa=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=wa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function xa(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||va(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+"="+('"'+N(b)+'"')}return ta(a)?a+"="+('"'+N(b)+'"'):""}function ya(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var za="function"===typeof Object.is?Object.is:ya,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Aa(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ba(){null===Q?null===P?(R=!1,P=Q=Aa()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Aa()):(R=!0,Q=Q.next);return Q}function Ca(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Da(a,b){return"function"===typeof b?b(a):b}
function Ea(a,b,c){O=W();Q=Ba();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Da?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Fa.bind(null,O,a);return[Q.memoizedState,a]}
function Fa(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ga(){}
var X=0,Ha={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ba();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!za(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Ea,useRef:function(a){O=W();Q=Ba();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Ea(Da,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ga,useEffect:Ga,useDebugValue:Ga,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ia={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Ka={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},La=k({menuitem:!0},Ka),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ma=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Ma.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Na=/([A-Z])/g,Oa=/^ms-/,Z=l.Children.toArray,Pa=C.ReactCurrentDispatcher,Qa={listing:!0,pre:!0,textarea:!0},Ra=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Sa={},Ta={};function Ua(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Va=Object.prototype.hasOwnProperty,Wa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Xa(a,b){if(void 0===a)throw Error(q(152,D(b)||"Component"));}
function Ya(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=oa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var v=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=v&&(e.state=k({},e.state,v))}}else if(O={},e=g(d.props,
f,m),e=Ca(g,d.props,e,f),null==e||null==e.render){a=e;Xa(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{v=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,v,d.props,f):p;null!=p&&(y?(y=!1,v=k({},v,p)):k(v,p))}e.state=v}}else x=null;a=e.render();Xa(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,D(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
typeof g)break;d(f,g)}return{child:a,context:b}}
var Za=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ia.html,children:a,childIndex:0,context:na,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Pa.current;Pa.current=Ha;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===w)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
v="";try{v+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=v}}return g[0]}finally{Pa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Ya(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Ca(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case w:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case ka:throw Error(q(338));case ja:switch(c=a.type,ma(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
}case la:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ia.html&&Ja(c);if(!Sa.hasOwnProperty(c)){if(!Ra.test(c))throw Error(q(65,c));Sa[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Ua(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
d,{selected:h,children:I})}}if(h=d){if(La[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Va.call(h,z)){var m=h[z];if(null!=m){if("style"===
z){n=void 0;var v="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ta.hasOwnProperty(A))A=Ta[A];else{var T=A.replace(Na,"-$1").toLowerCase().replace(Oa,"-ms-");A=Ta[A]=T}v+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";v+=y;r=";"}}m=v||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0}y?Wa.hasOwnProperty(z)||(n=z,n=ta(n)&&null!=m?n+"="+('"'+N(m)+'"'):""):n=xa(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";Ka.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Qa[c]&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?Ja(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),$a={renderToString:function(a){a=new Za(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Za(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
},version:"16.12.0"},ab={default:$a},bb=ab&&$a||ab;module.exports=bb.default||bb;


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhasesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import PhasesAdd from './../../elements/phases/widget/phases_add';
var Phases=function(_Component){_inherits(Phases,_Component);function Phases(){_classCallCheck(this,Phases);return _possibleConstructorReturn(this,(Phases.__proto__||Object.getPrototypeOf(Phases)).apply(this,arguments));}_createClass(Phases,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PhasesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.phasesShow(this.props.phases.current);}}]);return Phases;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PhasesList=function(_Component2){_inherits(PhasesList,_Component2);_createClass(PhasesList,[{key:'render',value:function render(){var _this3=this;var phases=this.props.phases;var pu=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(phases.permissions,function(o){return o==='Update';});var pd=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(phases.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,phases.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre de Subproceso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(phases.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},pu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/fases/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',pd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'has-text-'+row.status.style},row.status.name)));}))),phases.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:phases.pages.current,total:phases.pages.total,nextPage:this._handlePageChange}));}}]);function PhasesList(){_classCallCheck(this,PhasesList);var _this2=_possibleConstructorReturn(this,(PhasesList.__proto__||Object.getPrototypeOf(PhasesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(PhasesList,[{key:'_handlePageChange',value:function _handlePageChange(value){this.props.phasesShow(value);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el Sub-proceso "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.phaseDelete(id);}});}}]);return PhasesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(Phases, {title:`Administrar Fases`});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(Phases,{title:"Administrar Subprocesos",subnav:{icon:'fa-sliders',name:'Administración',actions:[{type:null,url:null,name:'',element:null}]}}));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_phases_form__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import PhasesAdd from './../../elements/phases/widget/phases_add';
var PhasesEdit=function(_Component){_inherits(PhasesEdit,_Component);function PhasesEdit(){_classCallCheck(this,PhasesEdit);return _possibleConstructorReturn(this,(PhasesEdit.__proto__||Object.getPrototypeOf(PhasesEdit)).apply(this,arguments));}_createClass(PhasesEdit,[{key:'render',value:function render(){var phases=this.props.phases;return phases.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_phases_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.phaseEdit(this.props.match.params.id);this.props.fetchModalities();this.props.documentsTypesShow();}}]);return PhasesEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(PhasesForm, {title: 'Editar etapa'});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(PhasesEdit,{title:'Editar Subproceso',subnav:{icon:'fa-user-secret',name:'Administración',actions:[{type:null,url:null,name:'',element:null}]}}));

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_phases_form__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import PhasesAdd from './../../elements/phases/widget/phases_add';
var PhasesCreate=function(_Component){_inherits(PhasesCreate,_Component);function PhasesCreate(){_classCallCheck(this,PhasesCreate);return _possibleConstructorReturn(this,(PhasesCreate.__proto__||Object.getPrototypeOf(PhasesCreate)).apply(this,arguments));}_createClass(PhasesCreate,[{key:'render',value:function render(){var phases=this.props.phases;return phases.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_phases_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('phases.edit');this.props.fetchModalities();this.props.documentsTypesShow();}}]);return PhasesCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(PhasesCreate, {title: 'Crear etapa'});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(PhasesCreate,{title:'Crear Subproceso',subnav:{icon:'fa-user-secret',name:'Administración',actions:[{type:null,url:null,name:'',element:null}]}}));

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_phases_widget_groups_add__ = __webpack_require__(143);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupsPhases=function(_Component){_inherits(GroupsPhases,_Component);function GroupsPhases(){_classCallCheck(this,GroupsPhases);return _possibleConstructorReturn(this,(GroupsPhases.__proto__||Object.getPrototypeOf(GroupsPhases)).apply(this,arguments));}_createClass(GroupsPhases,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GroupsList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchGroupsPhasesShow(this.props.groupsPhases.pages.current);}}]);return GroupsPhases;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var GroupsList=function(_Component2){_inherits(GroupsList,_Component2);_createClass(GroupsList,[{key:'render',value:function render(){var _this3=this;var groupsPhases=this.props.groupsPhases;var gu=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(groupsPhases.permissions,function(o){return o==='Update';});var gd=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(groupsPhases.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,groupsPhases.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(groupsPhases.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},gu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/fases/grupos/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',gd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'has-text-'+row.status.style},row.status.name)));}))),groupsPhases.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:groupsPhases.pages.current,total:groupsPhases.pages.total,nextPage:this._handlePageChange}));}}]);function GroupsList(){_classCallCheck(this,GroupsList);var _this2=_possibleConstructorReturn(this,(GroupsList.__proto__||Object.getPrototypeOf(GroupsList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(GroupsList,[{key:'_handlePageChange',value:function _handlePageChange(value){this.props.fetchGroupsPhasesShow(value);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el Grupo "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.groupPhaseDelete(id);}});}}]);return GroupsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(GroupsPhases,{title:"Administrar procesos",subnav:{icon:'fa-sliders',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_phases_widget_groups_add__["a" /* default */],null)}]}}));

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_phases_groups__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_phases_widget_groups_add__ = __webpack_require__(143);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupPhaseEdit=function(_Component){_inherits(GroupPhaseEdit,_Component);function GroupPhaseEdit(){_classCallCheck(this,GroupPhaseEdit);return _possibleConstructorReturn(this,(GroupPhaseEdit.__proto__||Object.getPrototypeOf(GroupPhaseEdit)).apply(this,arguments));}_createClass(GroupPhaseEdit,[{key:'render',value:function render(){var groupsPhases=this.props.groupsPhases;return groupsPhases.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_phases_groups__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchStatus();this.props.fetchGroupPhaseEdit(this.props.match.params.id);}}]);return GroupPhaseEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(GroupPhaseEdit,{title:"Editar proceso",subnav:{icon:'fa-sliders',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_phases_widget_groups_add__["a" /* default */],null)}]}}));

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_phases_groups__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_phases_widget_groups_add__ = __webpack_require__(143);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupPhaseEdit=function(_Component){_inherits(GroupPhaseEdit,_Component);function GroupPhaseEdit(){_classCallCheck(this,GroupPhaseEdit);return _possibleConstructorReturn(this,(GroupPhaseEdit.__proto__||Object.getPrototypeOf(GroupPhaseEdit)).apply(this,arguments));}_createClass(GroupPhaseEdit,[{key:'render',value:function render(){var groupsPhases=this.props.groupsPhases;return groupsPhases.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_phases_groups__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchStatus();this.props.resetGroupsPhases();}}]);return GroupPhaseEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(GroupPhaseEdit,{title:"Crear proceso",subnav:{icon:'fa-sliders',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_phases_widget_groups_add__["a" /* default */],null)}]}}));

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PermissionsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_permissions_widget_permissions_add__ = __webpack_require__(144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Permissions=function(_Component){_inherits(Permissions,_Component);function Permissions(){_classCallCheck(this,Permissions);return _possibleConstructorReturn(this,(Permissions.__proto__||Object.getPrototypeOf(Permissions)).apply(this,arguments));}_createClass(Permissions,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PermissionsList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){var permissions=this.props.permissions;this.props.permissionsShow(permissions.pages.current,permissions.filters);}}]);return Permissions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PermissionsList=function(_Component2){_inherits(PermissionsList,_Component2);_createClass(PermissionsList,[{key:'render',value:function render(){var _this3=this;var permissions=this.props.permissions;var pu=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(permissions.permissions,function(o){return o==='Update';});var pd=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(permissions.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,permissions.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre de Permiso'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(permissions.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},pu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/permisos/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',pd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.display));}))),permissions.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:permissions.pages.current,total:permissions.pages.total,nextPage:this._handlePageChange}));}}]);function PermissionsList(){_classCallCheck(this,PermissionsList);var _this2=_possibleConstructorReturn(this,(PermissionsList.__proto__||Object.getPrototypeOf(PermissionsList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(PermissionsList,[{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el permiso "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.deletePermission(id);}});}},{key:'_handlePageChange',value:function _handlePageChange(value){this.props.permissionsShow(value);}}]);return PermissionsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(Permissions, {title: 'Administrar permisos', subnav: {icon: 'fa-user-secret', name: 'Administración', actions: {url: '/permisos/crear', name: 'Agregar permiso'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(Permissions,{title:'Administrar permisos',subnav:{icon:'fa-user-secret',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_permissions_widget_permissions_add__["a" /* default */],null)}]}}));

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_permissions_form__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_permissions_widget_permissions_add__ = __webpack_require__(144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PermissionsForm=function(_Component){_inherits(PermissionsForm,_Component);function PermissionsForm(){_classCallCheck(this,PermissionsForm);return _possibleConstructorReturn(this,(PermissionsForm.__proto__||Object.getPrototypeOf(PermissionsForm)).apply(this,arguments));}_createClass(PermissionsForm,[{key:'render',value:function render(){var permissions=this.props.permissions;return permissions.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_permissions_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.permissionEdit(this.props.match.params.id);}}]);return PermissionsForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(PermissionsForm, {title: `Editar Permiso`, subnav: {icon: 'fa-user-secret', name: 'Administración', actions: {url: '/permisos/crear', name: 'Agregar Permiso'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(PermissionsForm,{title:'Editar Permiso',subnav:{icon:'fa-user-secret',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_permissions_widget_permissions_add__["a" /* default */],null)}]}}));

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_permissions_form__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_permissions_widget_permissions_add__ = __webpack_require__(144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PermissionsForm=function(_Component){_inherits(PermissionsForm,_Component);function PermissionsForm(){_classCallCheck(this,PermissionsForm);return _possibleConstructorReturn(this,(PermissionsForm.__proto__||Object.getPrototypeOf(PermissionsForm)).apply(this,arguments));}_createClass(PermissionsForm,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_permissions_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetPermissionEdit();}}]);return PermissionsForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(PermissionsForm, {title: `Crear Permiso`, subnav: {icon: 'fa-user-secret', name: 'Administración', actions: {url: '/permisos/crear', name: 'Agregar Permiso'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(PermissionsForm,{title:'Crear Permiso',subnav:{icon:'fa-user-secret',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_permissions_widget_permissions_add__["a" /* default */],null)}]}}));

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RolesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_roles_widget_roles_add__ = __webpack_require__(145);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Roles=function(_Component){_inherits(Roles,_Component);function Roles(){_classCallCheck(this,Roles);return _possibleConstructorReturn(this,(Roles.__proto__||Object.getPrototypeOf(Roles)).apply(this,arguments));}_createClass(Roles,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RolesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){var roles=this.props.roles;this.props.rolesShow(roles.pages.current,roles.filters);}}]);return Roles;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var RolesList=function(_Component2){_inherits(RolesList,_Component2);_createClass(RolesList,[{key:'render',value:function render(){var _this3=this;var roles=this.props.roles;var ru=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(roles.permissions,function(o){return o==='Update';});var rd=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(roles.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,roles.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_loading__["a" /* default */],null):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table',key:'roles-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Perfil'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tipo de perfil'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(roles.list,['id']),function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},ru?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/perfiles/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',rd&&Boolean(row.editable)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.display)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.upperCase(row.agenciable_type?row.agenciable_type:'')));}))),roles.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_widgets_inmPagination__["a" /* default */],{key:'roles-pages',current:roles.pages.current,total:roles.pages.total,nextPage:this._handlePageChange})]);}}]);function RolesList(){_classCallCheck(this,RolesList);var _this2=_possibleConstructorReturn(this,(RolesList.__proto__||Object.getPrototypeOf(RolesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(RolesList,[{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el perfil "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.deleteRole(id);}});}},{key:'_handlePageChange',value:function _handlePageChange(value){this.props.rolesShow(value);}}]);return RolesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__templates_base__["a" /* default */])(Roles,{title:'Administrar Perfiles',subnav:{icon:'fa-user-secret',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_roles_widget_roles_add__["a" /* default */],null)}]}}));

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_roles_form__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_roles_widget_roles_add__ = __webpack_require__(145);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoleEdit=function(_Component){_inherits(RoleEdit,_Component);function RoleEdit(){_classCallCheck(this,RoleEdit);return _possibleConstructorReturn(this,(RoleEdit.__proto__||Object.getPrototypeOf(RoleEdit)).apply(this,arguments));}_createClass(RoleEdit,[{key:'render',value:function render(){var _props=this.props,roles=_props.roles,permissions=_props.permissions;return roles.isFetching||permissions.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_roles_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchRole(this.props.match.params.id);this.props.fetchPermissions();}}]);return RoleEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(RoleEdit, {title: `Editar perfil`, subnav:{icon: 'fa-user-secret', name: 'Administración', actions: {url: '/perfiles/crear', name: 'Agregar perfil'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(RoleEdit,{title:'Editar perfil',subnav:{icon:'fa-user-secret',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_roles_widget_roles_add__["a" /* default */],null)}]}}));

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_roles_form__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_roles_widget_roles_add__ = __webpack_require__(145);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoleEdit=function(_Component){_inherits(RoleEdit,_Component);function RoleEdit(){_classCallCheck(this,RoleEdit);return _possibleConstructorReturn(this,(RoleEdit.__proto__||Object.getPrototypeOf(RoleEdit)).apply(this,arguments));}_createClass(RoleEdit,[{key:'render',value:function render(){var _props=this.props,roles=_props.roles,permissions=_props.permissions;return roles.isFetching||permissions.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_roles_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetRolesList();this.props.fetchPermissions();}}]);return RoleEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(RoleEdit, {title: `Crear Perfil`, subnav: {icon: 'fa-user-secret', name: 'Administración', actions: {url: '/perfiles/crear', name: 'Agregar perfil'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(RoleEdit,{title:'Crear perfil',subnav:{icon:'fa-user-secret',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_roles_widget_roles_add__["a" /* default */],null)}]}}));

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_users_usersTable__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_users_widget_users_search__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_users_widget_users_add__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_users_widget_users_export__ = __webpack_require__(641);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Users=function(_Component){_inherits(Users,_Component);function Users(){_classCallCheck(this,Users);return _possibleConstructorReturn(this,(Users.__proto__||Object.getPrototypeOf(Users)).apply(this,arguments));}_createClass(Users,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_users_usersTable__["a" /* default */],Object.assign({},this.props.users,{usersList:this.props.usersList,userDelete:this.props.userDelete}));}},{key:'componentWillMount',value:function componentWillMount(){var users=this.props.users;this.props.fetchStatus(1);this.props.fetchRolesList();this.props.usersList(users.pages.current,users.filters);}}]);return Users;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(Users,{title:'Administrar Usuarios',subnav:{icon:'fa-users',name:'Usuarios',actions:[{type:'search',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_users_widget_users_search__["a" /* default */],null)},{type:'element',url:null,name:'Exportar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_users_widget_users_export__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_users_widget_users_add__["a" /* default */],null)}]}}));

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersTable=function(_Component){_inherits(UsersTable,_Component);_createClass(UsersTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,isFetching=_props.isFetching,list=_props.list,pages=_props.pages,permissions=_props.permissions;var uu=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(permissions,function(o){return o==='Update';});var ud=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(permissions,function(o){return o==='Delete';});var table=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(list,function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},uu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/usuarios/editar/'+item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})),ud&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._getConfirm(item.id,item.name+' '+item.last_name+' '+(item.slast_name?item.slast_name:''));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))),item.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.name+' '+item.last_name+' '+(item.slast_name?item.slast_name:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(item.roles,function(tag,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:k,className:'tag is-dark'},tag.display?tag.display:tag.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'has-text-'+item.status.style},item.status.name)));});return[isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loading__["a" /* default */],{key:'users-loading',message:'Cargando usuarios...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table',key:'users-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'E-mail'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Perfil'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,table)),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(list)&&pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_inmPagination__["a" /* default */],{current:pages.current,total:pages.total,nextPage:this._handlePageChange,key:'users-pages'})];}}]);function UsersTable(){_classCallCheck(this,UsersTable);var _this=_possibleConstructorReturn(this,(UsersTable.__proto__||Object.getPrototypeOf(UsersTable)).call(this));_this._handlePageChange=_this._handlePageChange.bind(_this);return _this;}_createClass(UsersTable,[{key:'_handlePageChange',value:function _handlePageChange(value){//this.props.usersList(value);
var filters=this.props.filters;//console.log('?==>',pages.q);
this.props.usersList(value,filters);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el usuario "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.userDelete(id);}});}}]);return UsersTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UsersTable);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersSearch=function(_Component){_inherits(UsersSearch,_Component);_createClass(UsersSearch,[{key:"render",value:function render(){var _props=this.props,roles=_props.roles,status=_props.status,users=_props.users;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"role_id",id:"role_id",value:users.filters.role_id,onChange:this._roleChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Perfil ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(roles.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.display?row.display:row.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"status_id",name:"status_id",value:users.filters.status_id,onChange:this._statusChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" "},"--- Estatus ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:stat.id,key:k},stat.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:users.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function UsersSearch(){_classCallCheck(this,UsersSearch);var _this=_possibleConstructorReturn(this,(UsersSearch.__proto__||Object.getPrototypeOf(UsersSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._roleChange=_this._roleChange.bind(_this);_this._statusChange=_this._statusChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(UsersSearch,[{key:"_submitSearch",value:function _submitSearch(){//this.props.usersList(1, null, {q: ref.value});
var users=this.props.users;this.props.usersList(1,users.filters);}},{key:"_searchChange",value:function _searchChange(event){/*this.setState({
			q:event.target.value
		});*/this.props.change('users.filters.q',event.target.value);}},{key:"_statusChange",value:function _statusChange(event){//console.log('status==>', event.target.value)
/*this.setState({
			status_id:event.target.value
		});*/this.props.change('users.filters.status_id',event.target.value);}},{key:"_roleChange",value:function _roleChange(event){/*this.setState({
			role_id:event.target.value
		});*/this.props.change('users.filters.role_id',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('users.filters');this.props.usersList(1);}}]);return UsersSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(UsersSearch));

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersExport=function(_Component){_inherits(UsersExport,_Component);_createClass(UsersExport,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-small is-inm-purple',onClick:function onClick(){return _this2._getExport();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Exportar')));}}]);function UsersExport(){_classCallCheck(this,UsersExport);var _this=_possibleConstructorReturn(this,(UsersExport.__proto__||Object.getPrototypeOf(UsersExport)).call(this));_this._getExport=_this._getExport.bind(_this);return _this;}_createClass(UsersExport,[{key:'_getExport',value:function _getExport(){var users=this.props.users;this.props.usersExport(users.filters);}}]);return UsersExport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(UsersExport));

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_users_form__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_users_widget_users_add__ = __webpack_require__(146);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserEdit=function(_Component){_inherits(UserEdit,_Component);function UserEdit(){_classCallCheck(this,UserEdit);return _possibleConstructorReturn(this,(UserEdit.__proto__||Object.getPrototypeOf(UserEdit)).apply(this,arguments));}_createClass(UserEdit,[{key:'render',value:function render(){var _props=this.props,users=_props.users,status=_props.status,roles=_props.roles,entities=_props.entities;return users.isFetching||status.isFetching||roles.isFetching||entities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_users_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var match=this.props.match;this.props.resetUser();this.props.fetchStatus(1);this.props.fetchRolesList();this.props.fetchEntities();this.props.fetchUser(match.params.id);}}]);return UserEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(UserEdit,{title:'Editar usuario',subnav:{icon:'fa-users',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_users_widget_users_add__["a" /* default */],null)}]}}));

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_users_form__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_users_widget_users_add__ = __webpack_require__(146);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserEdit=function(_Component){_inherits(UserEdit,_Component);function UserEdit(){_classCallCheck(this,UserEdit);return _possibleConstructorReturn(this,(UserEdit.__proto__||Object.getPrototypeOf(UserEdit)).apply(this,arguments));}_createClass(UserEdit,[{key:'render',value:function render(){var _props=this.props,users=_props.users,status=_props.status,roles=_props.roles,entities=_props.entities;return users.isFetching||status.isFetching||roles.isFetching||entities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_users_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetUser();this.props.fetchStatus(1);this.props.fetchRolesList();this.props.fetchEntities();}}]);return UserEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(UserEdit,{title:'Crear usuario',subnav:{icon:'fa-users',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_users_widget_users_add__["a" /* default */],null)}]}}));

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_projects_index__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_projects_widgets_project_search__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_projects_widgets_projects_export__ = __webpack_require__(647);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Projects=function(_Component){_inherits(Projects,_Component);function Projects(){_classCallCheck(this,Projects);return _possibleConstructorReturn(this,(Projects.__proto__||Object.getPrototypeOf(Projects)).apply(this,arguments));}_createClass(Projects,[{key:'render',value:function render(){var projects=this.props.projects;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_projects_index__["a" /* default */],Object.assign({},projects,{fetchProjectsList:this.props.fetchProjects,filters:projects.filters,change:this.props.change,key:'projects-list'}));}},{key:'componentWillMount',value:function componentWillMount(){var projects=this.props.projects;this.props.fetchProjects(1,projects.filters);}}]);return Projects;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(Projects,{title:'Administrar Proyectos',subnav:{icon:'fa-briefcase',name:'Proyectos',actions:[{type:'search',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_projects_widgets_project_search__["a" /* default */],null)},{type:'element',url:null,name:'Exportar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_projects_widgets_projects_export__["a" /* default */],null)}]}}));

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Pagination from 'react-js-pagination';
var ProjectsList=function(_Component){_inherits(ProjectsList,_Component);_createClass(ProjectsList,[{key:"render",value:function render(){var _props=this.props,list=_props.list,isFetching=_props.isFetching,pages=_props.pages;var tableBody=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"project-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/proyectos/editar/datos/"+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.id)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.code?row.code:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-danger"},"N/D")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.agency.agenciable.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.spent)));});return[isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__loading__["a" /* default */],{key:"projects-loading"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table",key:"projects-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Folio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{width:'50%'}},"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Aprobado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Ejercido"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,tableBody)),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(list)&&pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:"projects-pages",current:pages.current,total:pages.total,nextPage:this._handlePageChange})];}}]);function ProjectsList(){_classCallCheck(this,ProjectsList);var _this=_possibleConstructorReturn(this,(ProjectsList.__proto__||Object.getPrototypeOf(ProjectsList)).call(this));_this._handlePageChange=_this._handlePageChange.bind(_this);return _this;}_createClass(ProjectsList,[{key:"_handlePageChange",value:function _handlePageChange(page){//console.log('page===>', page);
this.props.fetchProjectsList(page,this.props.filters);}},{key:"_handleFilters",value:function _handleFilters(modality){var newFilters=this.props.filters;__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.assign(newFilters,{modality_id:modality});//console.log('filters===>', newFilters);
this.props.change('projects.filters.modality_id',modality);//this._handlePageChange(1);
this.props.fetchProjectsList(1,newFilters);}}]);return ProjectsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectsList);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectsSearch=function(_Component){_inherits(ProjectsSearch,_Component);_createClass(ProjectsSearch,[{key:'render',value:function render(){var _this2=this;var _props=this.props,projects=_props.projects,modalities=_props.modalities,versions=_props.versions,entities=_props.entities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-inm-purple is-small',onClick:this._clearSearch},'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-ban'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'input is-small',type:'search',ref:'q',id:'q',placeholder:'Buscar',value:projects.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small'+(modalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'modality_id',id:'modality_id',value:projects.filters.modality_id,onChange:this._modalityChange,disabled:modalities.isFetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Categor\xEDa ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(modalities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:row.id},row.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small'+(entities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'state_id',id:'state_id',value:projects.filters.state_id,onChange:this._entityChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Entidad ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(entities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:row.id},row.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small'+(versions.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'version_id',id:'version_id',disabled:versions.isFetching,value:projects.filters.version_id,onChange:this._versionChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- A\xF1o ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(versions.list,function(version,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:version.id,key:k},version.year);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-inm-purple is-small',onClick:function onClick(){return _this2._submitSearch(_this2.refs.q);}},'Buscar')));}}]);function ProjectsSearch(){_classCallCheck(this,ProjectsSearch);var _this=_possibleConstructorReturn(this,(ProjectsSearch.__proto__||Object.getPrototypeOf(ProjectsSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._modalityChange=_this._modalityChange.bind(_this);_this._entityChange=_this._entityChange.bind(_this);_this._versionChange=_this._versionChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(ProjectsSearch,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchModalities();this.props.fetchEntities();this.props.versionsList();}},{key:'_submitSearch',value:function _submitSearch(){var projects=this.props.projects;this.props.fetchProjects(1,projects.filters);}},{key:'_searchChange',value:function _searchChange(event){this.props.change('projects.filters.q',event.target.value);}},{key:'_modalityChange',value:function _modalityChange(event){this.props.change('projects.filters.modality_id',event.target.value);}},{key:'_entityChange',value:function _entityChange(event){this.props.change('projects.filters.state_id',event.target.value);}},{key:'_versionChange',value:function _versionChange(event){this.props.change('projects.filters.version_id',event.target.value);}},{key:'_clearSearch',value:function _clearSearch(){this.props.reset('projects.filters');this.props.fetchProjects(1);}}]);return ProjectsSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(ProjectsSearch));

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectsExport=function(_Component){_inherits(ProjectsExport,_Component);_createClass(ProjectsExport,[{key:'render',value:function render(){var _this2=this;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:'export'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-small is-inm-purple',onClick:function onClick(){return _this2._showModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Exportar'))),this.state.optionsModalShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionsModal,Object.assign({key:'modal-export',active:this.state.optionsModalShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):''];}}]);function ProjectsExport(){_classCallCheck(this,ProjectsExport);var _this=_possibleConstructorReturn(this,(ProjectsExport.__proto__||Object.getPrototypeOf(ProjectsExport)).call(this));_this.state={optionsModalShow:false};return _this;}_createClass(ProjectsExport,[{key:'_showModal',value:function _showModal(){this.setState({optionsModalShow:true});}},{key:'_toggleModal',value:function _toggleModal(){this.props.reset('projects.options');this.setState({optionsModalShow:false});}}]);return ProjectsExport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var OptionsModal=function(_Component2){_inherits(OptionsModal,_Component2);_createClass(OptionsModal,[{key:'render',value:function render(){var _this4=this;var projects=this.props.projects;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Opciones para exportar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),projects.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'projects_data',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'projects_data',id:'projects_data',className:'checkbox',checked:this.state.projects_data,onChange:this._addOptions,disabled:this.state.all_options}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Datos proyecto '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'projects_agency',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'projects_agency',id:'projects_agency',className:'checkbox',checked:this.state.projects_agency,onChange:this._addOptions,disabled:this.state.all_options}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Datos Instancia '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'projects_owner',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'projects_owner',id:'projects_owner',className:'checkbox',checked:this.state.projects_owner,onChange:this._addOptions,disabled:this.state.all_options}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Datos Titular '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'projects_goals',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'projects_goals',id:'projects_goals',className:'checkbox',checked:this.state.projects_goals,onChange:this._addOptions,disabled:this.state.all_options}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Datos Metas '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'projects_expenses',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'projects_expenses',id:'projects_expenses',className:'checkbox',checked:this.state.projects_expenses,onChange:this._addOptions,disabled:this.state.all_options}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Datos Gastos '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'projects_version_phases_groups',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'projects_version_phases_groups',id:'projects_version_phases_groups',className:'checkbox',checked:this.state.projects_version_phases_groups,onChange:this._addOptions,disabled:this.state.all_options}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Procesos ')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-inm-purple',onClick:function onClick(){return _this4._getExport();},disabled:this._validExport()},'Exportar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},projects.filters.modality_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('control',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Modalidad requerida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'}),projects.filters.version_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('control',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Versi\xF3n requerida'))))));}},{key:'componentWillMount',value:function componentWillMount(){var options=[];__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.state,function(value,key){if(value===true)options.push(key);});this.props.change('projects.options',options);/*
		this.props.change('projects.options',[
			'projects_data',
			'projects_agency',
			'projects_owner',
			'projects_goals',
			'projects_expenses',
			'projects_version_phases_groups'
		])
		*/}}]);function OptionsModal(props){_classCallCheck(this,OptionsModal);var _this3=_possibleConstructorReturn(this,(OptionsModal.__proto__||Object.getPrototypeOf(OptionsModal)).call(this,props));_this3.state={projects_data:true,projects_agency:true,projects_owner:true,projects_goals:false,projects_expenses:false,projects_version_phases_groups:false};_this3._addOptions=_this3._addOptions.bind(_this3);return _this3;}_createClass(OptionsModal,[{key:'_getExport',value:function _getExport(){var projects=this.props.projects;this.props.projectsExport(projects.filters,projects.options);}},{key:'_addOptions',value:function _addOptions(event){var projects=this.props.projects;if(event.target.checked){this.props.add('projects.options',event.target.name);this.setState(_defineProperty({},event.target.name,true));}else{var optionIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(projects.options,function(o){return o===event.target.name;});this.props.remove('projects.options',optionIndex);this.setState(_defineProperty({},event.target.name,false));}}},{key:'_validExport',value:function _validExport(){var projects=this.props.projects;var response=false;if(projects.filters.modality_id&&projects.filters.version_id){/*if(this.state.all_options){
				response = false;
			}else */if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(projects.options)){response=false;}else{response=true;}}else{response=true;}return response;}}]);return OptionsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(ProjectsExport));

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_projects__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_projects_project__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectEdit=function(_Component){_inherits(ProjectEdit,_Component);function ProjectEdit(){_classCallCheck(this,ProjectEdit);return _possibleConstructorReturn(this,(ProjectEdit.__proto__||Object.getPrototypeOf(ProjectEdit)).apply(this,arguments));}_createClass(ProjectEdit,[{key:'render',value:function render(){var projects=this.props.projects;return projects.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_projects_project__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchProjectEdit(this.props.match.params.id);}}]);return ProjectEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_projects__["a" /* default */])(ProjectEdit,{subnav:1}));

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_config__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectsEditSubnav=function(_Component){_inherits(ProjectsEditSubnav,_Component);function ProjectsEditSubnav(){_classCallCheck(this,ProjectsEditSubnav);return _possibleConstructorReturn(this,(ProjectsEditSubnav.__proto__||Object.getPrototypeOf(ProjectsEditSubnav)).apply(this,arguments));}_createClass(ProjectsEditSubnav,[{key:"render",value:function render(){var _props=this.props,params=_props.params,projects=_props.projects;var currentStep=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3__store_config__["_267" /* projectsEditInitNav */],{step:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.props.step)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnavigation-projects crud"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,currentStep&&currentStep.title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-step"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},__WEBPACK_IMPORTED_MODULE_3__store_config__["_267" /* projectsEditInitNav */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level context-navigation"},__WEBPACK_IMPORTED_MODULE_3__store_config__["_267" /* projectsEditInitNav */].map(function(item,k){var projectLink=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(item.url,':id',params.id),'undefined','');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item",key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:"step",to:projectLink,activeClassName:"active",disabled:projects.isFetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,item.step),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.title)));}))))));}}]);return ProjectsEditSubnav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectsEditSubnav);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_wysiwyg_field__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parsers__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectEditForm=function(_Component){_inherits(ProjectEditForm,_Component);function ProjectEditForm(){_classCallCheck(this,ProjectEditForm);return _possibleConstructorReturn(this,(ProjectEditForm.__proto__||Object.getPrototypeOf(ProjectEditForm)).apply(this,arguments));}_createClass(ProjectEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,versions=_props.versions,modalities=_props.modalities,entities=_props.entities,municipalities=_props.municipalities,projects=_props.projects;var modData=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(modalities.list,{id:projects.project.modality_id});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'projects.project',onSubmit:function onSubmit(values){return _this2._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del proyecto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{rows:'2',model:'.name',id:'name',className:'textarea',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'version_id',className:'label'},'A\xF1o ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.agency.version_id',id:'version_id',className:'select',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_6__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- A\xF1o ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(versions.list,function(version,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:version.id,key:k},version.year);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.version_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir una año.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'modality_id',className:'label'},'Categor\xEDa ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.modality_id',id:'modality_id',className:'select',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_6__parsers__["c" /* toInt */],changeAction:function changeAction(model,value){return _this2._changeMod(model,value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Categor\xEDa ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(modalities.list,function(modality,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:modality.id,key:k},modality.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.modality_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir una modalidad.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'state_id',className:'label'},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(entities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'state',model:'.state_id',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_6__parsers__["c" /* toInt */],changeAction:function changeAction(model,value){return _this2._changeState(model,value,modData);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Estado ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(entities.list,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:item.id},item.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.state_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir una entidad.'}})),modData&&modData.agenciable_type==='imm'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'municipality',className:'label'},'Municipio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(municipalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'municipality_id',model:'.municipality_id',errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},parser:__WEBPACK_IMPORTED_MODULE_6__parsers__["c" /* toInt */],disabled:municipalities.isFetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Municipios ---'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(municipalities.list,function(mun,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:j,value:mun.id},mun.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.municipality_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes elegir un municipio.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'code',className:'label'},'Folio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.code',id:'code',type:'number',min:1,step:1,className:'input',changeAction:function changeAction(m,v){_this2._changeCode(m,v);},errors:{number:__WEBPACK_IMPORTED_MODULE_2__field_validations__["k" /* number */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.code',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{number:'El folio debe ser numérico'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'execution_start',className:'label'},'Fecha de ejecuci\xF3n inicial ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.execution_start',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change',component:__WEBPACK_IMPORTED_MODULE_3__forms_datepicker__["a" /* default */],className:'input'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.execution_start',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'execution_end',className:'label'},'Fecha de ejecuci\xF3n final ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.execution_end',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change',id:'end_date',component:__WEBPACK_IMPORTED_MODULE_3__forms_datepicker__["a" /* default */],className:'input'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.execution_end',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'benefited',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.benefited',id:'benefited',className:'checkbox',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Beneficiado ')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective',className:'label'},'Objetivos ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.objective',component:__WEBPACK_IMPORTED_MODULE_5__forms_wysiwyg_field__["a" /* default */],className:'',id:'objective',placeholder:'Objetivos del proyecto',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.objective',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Los objectivos del proyecto son obligatorios'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'justification',className:'label'},'Justificaci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.justification',component:__WEBPACK_IMPORTED_MODULE_5__forms_wysiwyg_field__["a" /* default */],className:'',id:'justification',placeholder:'Justificaci\xF3n del proyecto',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_2__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.justification',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La justificación del proyecto es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proyectos');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'projects.project.edit',className:'button is-large is-inm-purple',type:'submit',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'_submitForm',value:function _submitForm(values){this.props.projectSave(values);}},{key:'_changeCode',value:function _changeCode(model,value){if(value){this.props.change(model,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(value));}else{this.props.change(model,null);}}},{key:'_changeMod',value:function _changeMod(model,value){this.props.change(model,value);var _props2=this.props,projects=_props2.projects,modalities=_props2.modalities;var modData=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(modalities.list,{id:value});this.props.change('projects.project.modality',Object.assign({},modData));if(modData&&modData.agenciable_type==='imm'){if(projects.edit.state_id){this.props.fetchMunicipalities(projects.project.state_id);}}else{this.props.omit('projects.project','municipality_id');}}},{key:'_changeState',value:function _changeState(model,value,modData){this.props.change(model,value);if(modData&&modData.agenciable_type==='imm'){this.props.fetchMunicipalities(value);}}},{key:'_validateSave',value:function _validateSave(){var projects=this.props.projects;var pc=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(projects.permissions,function(o){return o==='Create';});var pu=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(projects.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(projects.project)&&projects.project.id){if(pu){return false;}else{return true;}}else if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(projects.project)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(projects.project.id)){if(pc){return false;}else{return true;}}else{return true;}}}]);return ProjectEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectEditForm);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_projects__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_projects_goals__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectEdit=function(_Component){_inherits(ProjectEdit,_Component);function ProjectEdit(){_classCallCheck(this,ProjectEdit);return _possibleConstructorReturn(this,(ProjectEdit.__proto__||Object.getPrototypeOf(ProjectEdit)).apply(this,arguments));}_createClass(ProjectEdit,[{key:'render',value:function render(){var projects=this.props.projects;return projects.isFetching||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(projects.goals)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_projects_goals__["a" /* default */],this.props);}},{key:'componentDidMount',value:function componentDidMount(){this.props.fetchProjectsGoalsEdit(this.props.match.params.id);}}]);return ProjectEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_projects__["a" /* default */])(ProjectEdit,{subnav:2}));

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_municipalities_modal__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_conago_modal__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_actors_modal__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__widgets_activities__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectGoalsEdit=function(_Component){_inherits(ProjectGoalsEdit,_Component);_createClass(ProjectGoalsEdit,[{key:'render',value:function render(){var _this2=this;var projects=this.props.projects;var totalGoals=0;var totalSpent=0;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(projects.goals,function(o){totalGoals+=o.total;totalSpent+=o.amounts?o.amounts.spent:0;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},this.state.modalShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalEditModal,Object.assign({selectedGoal:this.state.selectedGoal,active:this.state.modalShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):'',!this.state.modalShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'projects.goals',onSubmit:function onSubmit(values){return _this2._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium'},'Monto total de las metas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag is-medium is-primary'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(totalGoals)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium'},'Monto total ejercido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag is-medium is-primary'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(totalSpent))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-primary',onClick:function onClick(){return _this2._addGoal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Agregar meta')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table',style:{marginTop:'50px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Monto total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right',style:{paddingRight:'0'}},'Monto ejercido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(projects.goals,function(row,key){/*totalGoals += row.total;
								totalSpent += row.amounts ? row.amounts.spent : 0;*/return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'goal-'+key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._openGoalModal(row);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._removeGoal(row.proigualdad_goal_id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name,row.mandatory===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-primary is-small'},'Esta meta es obligatoria'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.spent)))];}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{type:'submit',model:'projects.goals',className:'button is-large is-inm-purple',disabled:this._validateSave()},'Guardar'))))):'');}}]);function ProjectGoalsEdit(){_classCallCheck(this,ProjectGoalsEdit);var _this=_possibleConstructorReturn(this,(ProjectGoalsEdit.__proto__||Object.getPrototypeOf(ProjectGoalsEdit)).call(this));_this.state={modalShow:false,munShow:false,conagoShow:false,actorsShow:false,goalMuns:[],goalConago:[],goalActors:[],selectedGoal:0,canEdit:false};return _this;}_createClass(ProjectGoalsEdit,[{key:'_submitForm',value:function _submitForm(values){this.props.projectGoalsSave(this.props.match.params.id,values);}},{key:'_addGoal',value:function _addGoal(){return this.setState({modalShow:true,selectedGoal:undefined});}},{key:'_removeGoal',value:function _removeGoal(goal){var _this3=this;var goals=this.props.projects.goals;var goalIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(goals,{proigualdad_goal_id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(goal)});if(goals[goalIndex].mandatory===0){Object(__WEBPACK_IMPORTED_MODULE_10_react_confirm_alert__["confirmAlert"])({title:'¿Esta seguro?',message:'Al eliminarse la meta, se eliminará toda información y actividades vinculadas.',confirmLabel:'Eliminar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.remove('projects.goals',goalIndex);}});}}},{key:'_openGoalModal',value:function _openGoalModal(row){this.props.change('projects.edit',Object.assign({},row));var editGoal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(this.props.projects.goals,{proigualdad_goal_id:row.proigualdad_goal_id});return this.setState({modalShow:true,selectedGoal:editGoal});}},{key:'_toggleModal',value:function _toggleModal(){this.props.reset('projects.edit');return this.setState({modalShow:!this.state.modalShow,selectedGoal:0});}},{key:'_validateSave',value:function _validateSave(){var projects=this.props.projects;var pc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(projects.permissions,function(o){return o==='Create';});var pu=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(projects.permissions,function(o){return o==='Update';});if(pu||pc){return false;}else{return true;}}}]);return ProjectGoalsEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectGoalsEdit);var GoalEditModal=function(_Component2){_inherits(GoalEditModal,_Component2);_createClass(GoalEditModal,[{key:'render',value:function render(){var _this5=this;var _props=this.props,projects=_props.projects,goals=_props.goals,resource_concepts=_props.resource_concepts;var edit=projects.edit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'projects.edit',className:'column'},this.state.munShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_municipalities_modal__["a" /* default */],{active:this.state.munShow,closeModal:function closeModal(){return _this5._toggleMunModal();},selectedMuns:projects.edit.municipalities,selectedGoal:this.state.selectedGoal,muns:this.props.municipalities,add:this.props.add,isMod:projects.project?projects.project.modality_id:undefined,remove:this.props.remove,conclusion:this.state.canEdit}):'',this.state.conagoShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_conago_modal__["a" /* default */],{active:this.state.conagoShow,closeModal:function closeModal(){return _this5._toggleConagoModal();},selectedConago:projects.edit.conago_clauses,selectedGoal:this.state.selectedGoal,conagoClauses:this.props.directories,add:this.props.add,remove:this.props.remove,conclusion:this.state.canEdit}):'',this.state.actorsShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets_actors_modal__["a" /* default */],{active:this.state.actorsShow,closeModal:function closeModal(){return _this5._toggleActorsModal();},selectedActors:projects.edit.actors,selectedGoal:this.state.selectedGoal,actors:this.props.directories,add:this.props.add,remove:this.props.remove,conclusion:this.state.canEdit}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium'},'Monto total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag is-medium is-primary'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(edit.total?edit.total:0)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium'},'Monto ejercido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag is-medium is-primary'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(edit.amounts?edit.amounts.spent:0)))),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.municipalities)>0&&projects.project.modality.slug==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-dark'},'Gasto por CDM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag is-medium is-inm-purple'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(edit.total/__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.municipalities))))):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'proigualdad_goal_id',className:'label'},'Meta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.proigualdad_goal_id',changeAction:function changeAction(m,v){return _this5._addGoal(m,v);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Selecciona una meta ---'),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goals.list)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(goals.list,['name']),function(o){return o.modality.slug===projects.project.modality.slug;}),function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.truncate(option.id+'.'+option.type+' - '+option.name,{'length':100}));}))),projects.edit&&projects.edit.proigualdad_goal_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Debes seleccionar una meta'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'goal-rc',className:'label'},'Conceptos de gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.resource_concept_id',id:'goal-rc',parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,defaultValue:true},'--- Conceptos de gasto ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(resource_concepts.list,function(res,t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:res.id,key:t},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.truncate(res.name,{'length':100}));}))),projects.edit&&projects.edit.resource_concept_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Debes indicar el concepto de gasto.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},projects.project.modality.slug==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'goal-ga',className:'label'},'Area geogr\xE1fica'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.geographic_area',id:'goal-ga',ref:'goal-ga'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Area geogr\xE1fica ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Estatal'},'Estatal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Municipios'},'Municipios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Todos los municipios'},'Todos los municipios'))),edit&&edit.geographic_area?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Seleccionar area geogr\xE1fica.')):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-small is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'.is_continuing',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.is_continuing',id:'.is_continuing',className:'checkbox',isToggle:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Meta de continuidad'))))))),projects.project.modality.slug==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this5._openConagoModal(edit.proigualdad_goal_id,edit.conagoClauses,false);}},'Metas CONAGO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.conago_clauses))),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.conago_clauses)<=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-danger'},'Debes elegir al menos una meta CONAGO'):''):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this5._openActorsModal(edit.proigualdad_goal_id,edit.actors,false);}},'Actores estrat\xE9gicos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.actors)))),edit.geographic_area==='Municipios'||projects.project.modality.slug==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this5._openMunModal(edit.proigualdad_goal_id,edit.municipalities,false);}},'Seleccionar municipios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.municipalities))),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.municipalities)===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-danger is-small'},'Seleccionar municipios participantes'):''):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__widgets_activities__["a" /* default */],Object.assign({goal:edit},this.props)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Listado de actividades'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-subsection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth is-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Medio de verificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(projects.edit.project_goal_activities,function(act,j){//goalTotal += act.total;
return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:j},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},act.proigualdad_activity_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,act.name,act.mandatory===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-primary'},'Esta actividad es obligatoria'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},act.allow_edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'projects.edit.project_goal_activities['+j+'].quantity',type:'number',min:0,step:1,className:'input',errors:{minValue:Object(__WEBPACK_IMPORTED_MODULE_8__field_validations__["j" /* minValue */])(0)},validateOn:'change',changeAction:function changeAction(model,value){return _this5._editActivity(j,model,value,act);},style:{width:'40%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'projects.edit.project_goal_activities['+j+'].quantity',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{minValue:'Minimo no admitido.'}})):act.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right amount'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(act.total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},act.verification_media?act.verification_media.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},act.allow_edit?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:function onClick(){return _this5.props.change('projects.edit.project_goal_activities['+j+']',Object.assign({},act,{allow_edit:true}));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),act.allow_edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-warning',type:'button',onClick:function onClick(){return _this5.props.change('projects.edit.project_goal_activities['+j+']',Object.assign({},act,{allow_edit:false}));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this5._removeActivity(act.proigualdad_activity_id,projects.edit.proigualdad_goal_id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))))))];})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this5.props.closeModal();}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large is-inm-purple',onClick:function onClick(){return _this5._validSave();},disabled:!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNumber(projects.edit.proigualdad_goal_id)},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'));}}]);function GoalEditModal(){_classCallCheck(this,GoalEditModal);var _this4=_possibleConstructorReturn(this,(GoalEditModal.__proto__||Object.getPrototypeOf(GoalEditModal)).call(this));_this4.state={modalShow:false,munShow:false,conagoShow:false,actorsShow:false,goalMuns:[],goalConago:[],goalActors:[],selectedGoal:0,canEdit:false};return _this4;}_createClass(GoalEditModal,[{key:'_validSave',value:function _validSave(){var projects=this.props.projects;var edit=projects.edit;//console.log('edit===>',edit);
if(edit.proigualdad_goal_id&&edit.resource_concept_id&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(edit.project_goal_activities)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.conago_clauses)>0){if(edit.geographic_area&&(edit.geographic_area==='Municipios'||projects.project.modality.slug==='modalidad-iii')&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(edit.municipalities)>0){this._saveChanges(edit);}else if(projects.project.modality.slug==='modalidad-i'&&edit.geographic_area){this._saveChanges(edit);}else if(projects.project.modality.slug==='modalidad-ii'){this._saveChanges(edit);}else{this.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}}else{this.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}}},{key:'_saveChanges',value:function _saveChanges(edit){if(this.props.selectedGoal){this.props.change('projects.goals['+this.props.selectedGoal+']',Object.assign({},edit));this.props.closeModal();}else{this.props.add('projects.goals',Object.assign({},edit));this.props.closeModal();}}},{key:'_addGoal',value:function _addGoal(model,value){var _props2=this.props,goals=_props2.goals,projects=_props2.projects;//let repeated = projects.goals && this.props.selectedGoal ? projects.goals[this.props.selectedGoal].proigualdad_goal_id:undefined;
var repeated=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(this.props.projects.goals,{proigualdad_goal_id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(value)});var goal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(goals.list,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(value)});if(value&&this.props.selectedGoal&&projects.goals[this.props.selectedGoal].proigualdad_goal_id===__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(value)){this.props.change('projects.edit',Object.assign({},projects.goals[this.props.selectedGoal]));}else{if(value&&goal&&repeated===undefined){this.props.change('projects.edit',Object.assign({},goal,{code:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join([goal.id,goal.type],'.'),geographic_area:undefined,proigualdad_goal_id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(goal.id),resource_concept_id:undefined,project_goal_activities:[],total:0,actors:[],conago_clauses:[],mandatory:goal.mandatory,amounts:{spent:0}}));//this.props.change(model,value);
}else{this.props.change('projects.edit',{proigualdad_goal_id:''});//alert('No se pueden agregar metas duplicadas');
this.props.setSystemNotification('¡Oh no!','No se pueden agregar metas duplicadas','danger');}}}},{key:'_removeActivity',value:function _removeActivity(activity){var edit=this.props.projects.edit;//let goalIndex = _.findKey(goals, {proigualdad_goal_id: _.toInteger(goal)});
var activityIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(edit.project_goal_activities,{proigualdad_activity_id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(activity)});if(edit.project_goal_activities[activityIndex].mandatory!==1){this.props.remove('projects.edit.project_goal_activities',activityIndex);this.props.change('projects.edit.total',edit.total-edit.project_goal_activities[activityIndex].total);}else{this.props.setSystemNotification('¡Oh no!','No se puede eliminar una actividad obligatoria','danger');//alert('No se puede eliminar una actividad obligatoria');
}}},{key:'_editActivity',value:function _editActivity(keyActivity,model,value,act){var quantity=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(value);var amount=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(act.amount);this.props.change(model,quantity);if(quantity>=0){this.props.change('projects.edit.project_goal_activities['+keyActivity+'].total',quantity*amount);}}},{key:'_openMunModal',value:function _openMunModal(goal,selected,disable){var projects=this.props.projects;//let entity = _.find(this.props.entities.list, {short:state});
var editGoal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(this.props.projects.goals,{proigualdad_goal_id:goal});this.props.fetchMunicipalities(projects.project.state_id);return this.setState({munShow:true,goalMuns:selected,selectedGoal:editGoal,canEdit:disable});}},{key:'_openConagoModal',value:function _openConagoModal(goal,selected,disable){var editGoal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(this.props.projects.goals,{proigualdad_goal_id:goal});return this.setState({conagoShow:true,goalConago:selected,selectedGoal:editGoal,canEdit:disable});}},{key:'_openActorsModal',value:function _openActorsModal(goal,selected,disable){var editGoal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(this.props.projects.goals,{proigualdad_goal_id:goal});return this.setState({actorsShow:true,goalActors:selected,selectedGoal:editGoal,canEdit:disable});}},{key:'_toggleMunModal',value:function _toggleMunModal(){return this.setState({munShow:!this.state.munShow});}},{key:'_toggleConagoModal',value:function _toggleConagoModal(){return this.setState({conagoShow:!this.state.conagoShow});}},{key:'_toggleActorsModal',value:function _toggleActorsModal(){return this.setState({actorsShow:!this.state.actorsShow});}}]);return GoalEditModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MunsModal=function(_Component){_inherits(MunsModal,_Component);function MunsModal(){_classCallCheck(this,MunsModal);return _possibleConstructorReturn(this,(MunsModal.__proto__||Object.getPrototypeOf(MunsModal)).apply(this,arguments));}_createClass(MunsModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,conclusion=_props.conclusion,isMod=_props.isMod,muns=_props.muns;var municipalities=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(muns.list,{modality_id:3});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Seleccione los municipios participantes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete is-medium','aria-label':'delete'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},this.props.muns.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__loading__["a" /* default */],{message:'Cargando municipios...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(isMod)===3?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(municipalities,function(mun,k){var shouldCheck=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(_this2.props.selectedMuns,{id:mun.id})!==undefined?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'mun-'+mun.id,className:'checkbox',disabled:conclusion},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'mun-'+mun.id,ref:'g-mun-'+mun.id,value:mun.id,type:'checkbox',checked:shouldCheck,className:'checkbox',onChange:function onChange(){return _this2._saveMuns(mun.id);},disabled:conclusion}),mun.name));}):__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.props.muns.list,function(mun,k){var shouldCheck=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(_this2.props.selectedMuns,{id:mun.id})!==undefined?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'mun-'+mun.id,className:'checkbox',disabled:conclusion},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'mun-'+mun.id,ref:'g-mun-'+mun.id,value:mun.id,type:'checkbox',checked:shouldCheck,className:'checkbox',onChange:function onChange(){return _this2._saveMuns(mun.id);},disabled:conclusion}),mun.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:this.props.closeModal},'Cerrar')))))));}},{key:'_saveMuns',value:function _saveMuns(mun){var munKey=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(this.props.selectedMuns,{id:mun});if(this.refs['g-mun-'+mun].checked){this.props.add('projects.edit.municipalities',{id:mun});}else{this.props.remove('projects.edit.municipalities',munKey);}}}]);return MunsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/*class MunsModal2 extends Component {
	render() {
		let {conclusion, isMod, muns} = this.props;
		let municipalities = _.filter(muns.list, {modality_id: 3});
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background"/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione los municipios participantes</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.muns.isFetching ? <Loading message="Cargando municipios..."/> :
								<div className="field is-grouped is-grouped-multiline">
									{_.toInteger(isMod) === 3 ?
										_.map(municipalities, (mun, k) => {
											let shouldCheck = _.findKey(this.props.selectedMuns, {id: mun.id}) !== undefined ? true : false;
											return (
												<div className="control" key={k}>
													<label htmlFor={`mun-${mun.id}`} className="checkbox"
													       disabled={conclusion}>
														<input id={`mun-${mun.id}`} ref={`g-mun-${mun.id}`}
														       value={mun.id} type="checkbox" checked={shouldCheck}
														       className="checkbox"
														       onChange={() => this._saveMuns(mun.id)}
														       disabled={conclusion}/>
														{mun.name}
													</label>
												</div>
											);
										})
										: this.props.muns.list.map((mun, k) => {
											let shouldCheck = _.findKey(this.props.selectedMuns, {id: mun.id}) !== undefined ? true : false;
											return (
												<div className="control" key={k}>
													<label htmlFor={`mun-${mun.id}`} className="checkbox"
													       disabled={conclusion}>
														<input id={`mun-${mun.id}`} ref={`g-mun-${mun.id}`}
														       value={mun.id} type="checkbox" checked={shouldCheck}
														       className="checkbox"
														       onChange={() => this._saveMuns(mun.id)}
														       disabled={conclusion}/>
														{mun.name}
													</label>
												</div>
											);
										})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveMuns(mun) {
		let munKey = _.findKey(this.props.selectedMuns, {id: mun});
		if (this.refs[`g-mun-${mun}`].checked) {
			this.props.add(`projects.goals[${this.props.selectedGoal}].municipalities`, {id: mun});
		} else {
			this.props.remove(`projects.goals[${this.props.selectedGoal}].municipalities`, munKey);
		}
	}
}*//* harmony default export */ __webpack_exports__["a"] = (MunsModal);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConagoModal=function(_Component){_inherits(ConagoModal,_Component);function ConagoModal(){_classCallCheck(this,ConagoModal);return _possibleConstructorReturn(this,(ConagoModal.__proto__||Object.getPrototypeOf(ConagoModal)).apply(this,arguments));}_createClass(ConagoModal,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Seleccione las metas que aplican'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete is-medium','aria-label':'delete'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},this.props.conagoClauses.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__loading__["a" /* default */],{message:'Cargando Metas CONAGO...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline conago-checkboxes'},this.props.conagoClauses.conago.map(function(conago,k){var shouldCheck=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(_this2.props.selectedConago,{id:conago.id})!==undefined?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'conago-'+conago.id,className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'conago-'+conago.id,ref:'g-conago-'+conago.id,value:conago.id,type:'checkbox',checked:shouldCheck,className:'checkbox',onChange:function onChange(){return _this2._saveConago(conago.id);}}),conago.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:this.props.closeModal},'Cerrar')))))));}},{key:'_saveConago',value:function _saveConago(conago){if(this.refs['g-conago-'+conago].checked){this.props.add('projects.edit.conago_clauses',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.props.conagoClauses.conago,{id:conago}));}else{var conagoKey=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.props.selectedConago,{id:conago});this.props.remove('projects.edit.conago_clauses',conagoKey);}}}]);return ConagoModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/*class ConagoModal2 extends Component {
	render() {
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background"/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione las metas que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.conagoClauses.isFetching ? <Loading message="Cargando Metas CONAGO..."/> :
								<div className="field is-grouped is-grouped-multiline conago-checkboxes">
									{this.props.conagoClauses.conago.map((conago, k) => {
										let shouldCheck = _.findKey(this.props.selectedConago, {id: conago.id}) !== undefined ? true : false;
										return (
											<div className="control" key={k}>
												<label htmlFor={`conago-${conago.id}`} className="checkbox">
													<input id={`conago-${conago.id}`} ref={`g-conago-${conago.id}`}
													       value={conago.id} type="checkbox" checked={shouldCheck}
													       className="checkbox"
													       onChange={() => this._saveConago(conago.id)}/>
													{conago.name}
												</label>
											</div>
										);
									})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveConago(conago) {
		if (this.refs[`g-conago-${conago}`].checked) {
			this.props.add(`projects.goals[${this.props.selectedGoal}].conago_clauses`, _.find(this.props.conagoClauses.conago, {id: conago}));
		} else {
			let conagoKey = _.findIndex(this.props.selectedConago, {id: conago});
			this.props.remove(`projects.goals[${this.props.selectedGoal}].conago_clauses`, conagoKey);
		}
	}
}*//* harmony default export */ __webpack_exports__["a"] = (ConagoModal);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActorsModal=function(_Component){_inherits(ActorsModal,_Component);function ActorsModal(){_classCallCheck(this,ActorsModal);return _possibleConstructorReturn(this,(ActorsModal.__proto__||Object.getPrototypeOf(ActorsModal)).apply(this,arguments));}_createClass(ActorsModal,[{key:'render',value:function render(){var _this2=this;var conclusion=this.props.conclusion;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Seleccione los actores estrat\xE9gicos que aplican'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete is-medium','aria-label':'delete'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},this.props.actors.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline conago-checkboxes'},this.props.actors.actors.map(function(actor,k){var shouldCheck=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(_this2.props.selectedActors,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(actor.id)})!==undefined?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'actor-'+actor.id,className:'checkbox',disabled:conclusion},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'actor-'+actor.id,ref:'g-actor-'+actor.id,value:actor.id,type:'checkbox',checked:shouldCheck,className:'checkbox',onChange:function onChange(){return _this2._saveActor(actor.id);},disabled:conclusion}),actor.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:this.props.closeModal},'Cerrar')))))));}},{key:'_saveActor',value:function _saveActor(actor){if(this.refs['g-actor-'+actor].checked){this.props.add('projects.edit.actors',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.props.actors.actors,{id:actor}));}else{var actorKey=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(this.props.selectedActors,{id:actor});this.props.remove('projects.edit.actors',actorKey);}}}]);return ActorsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/*class ActorsModal2 extends Component {
	render() {
		let {conclusion} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background"/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione los actores estratégicos que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.actors.isFetching ? <Loading/> :
								<div className="field is-grouped is-grouped-multiline conago-checkboxes">
									{this.props.actors.actors.map((actor, k) => {
										let shouldCheck = _.findKey(this.props.selectedActors, {id: _.toInteger(actor.id)}) !== undefined ? true : false;
										return (
											<div className="control" key={k}>
												<label htmlFor={`actor-${actor.id}`} className="checkbox"
												       disabled={conclusion}>
													<input id={`actor-${actor.id}`} ref={`g-actor-${actor.id}`}
													       value={actor.id} type="checkbox" checked={shouldCheck}
													       className="checkbox"
													       onChange={() => this._saveActor(actor.id)}
													       disabled={conclusion}/>
													{actor.name}
												</label>
											</div>
										);
									})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveActor(actor) {
		if (this.refs[`g-actor-${actor}`].checked) {
			this.props.add(`projects.goals[${this.props.selectedGoal}].actors`, _.find(this.props.actors.actors, {id: actor}));
		} else {
			let actorKey = _.findKey(this.props.selectedActors, {id: actor});
			this.props.remove(`projects.goals[${this.props.selectedGoal}].actors`, actorKey);
		}
	}
}*//* harmony default export */ __webpack_exports__["a"] = (ActorsModal);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActivityWidget=function(_Component){_inherits(ActivityWidget,_Component);function ActivityWidget(){_classCallCheck(this,ActivityWidget);return _possibleConstructorReturn(this,(ActivityWidget.__proto__||Object.getPrototypeOf(ActivityWidget)).apply(this,arguments));}_createClass(ActivityWidget,[{key:"render",value:function render(){var _this2=this;var _props=this.props,disabled=_props.disabled,goal=_props.goal,goals=_props.goals;var goalActivities=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goals.list,{id:goal.proigualdad_goal_id});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"activityAdd",className:"label"},"Seleccionar actividades"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{ref:"activitySelect",disabled:disabled,id:"activityAdd",onChange:function onChange(){return _this2._activityValue();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:0,defaultValue:true},"--- Actividades ---"),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goalActivities)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goalActivities.activities)?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(goalActivities.activities,function(item,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:item.id,key:j},item.name);}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",ref:"quantity",id:"quantity",placeholder:"Cantidad",className:"input",min:"0",step:"1",defaultValue:1,onChange:function onChange(){return _this2._activityValue();},disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",ref:"total",id:"total",placeholder:"$0.00",className:"input",readOnly:true,disabled:disabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-primary",onClick:function onClick(){return _this2._addActivity();},disabled:disabled},"Agregar"))));}},{key:"_addActivity",value:function _addActivity(){var _props2=this.props,goal=_props2.goal,goals=_props2.goals;//let selected = _.findKey(projects.goals, {proigualdad_goal_id: _.toInteger(goal.proigualdad_goal_id)});
var goalKey=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(goals.list,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(goal.proigualdad_goal_id)});var activity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goals.list[goalKey].activities,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.activitySelect.value)});var hasIt=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goal.project_goal_activities,{proigualdad_activity_id:activity.id});var activitySize=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.project_goal_activities);if(hasIt===undefined&&activitySize<=4){this.props.add("projects.edit.project_goal_activities",{proigualdad_activity_id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.activitySelect.value),name:activity.name,quantity:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.quantity.value),amount:activity.amount,total:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.quantity.value)*activity.amount,mandatory:activity.mandatory,verification_media:activity.verification_media[0]});var newTotal=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(goal.total)+__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.quantity.value)*activity.amount;//this.props.setProjectGoalTotal(goalKey, newTotal);
this.props.change("projects.edit.total",newTotal);this.refs.activitySelect.value=0;this.refs.quantity.value=1;this.refs.total.value='';}else if(activitySize>=5){//alert('Cada meta puede tener un máximo de 5 actividades');
this.props.setSystemNotification('¡Oh no!','Cada meta puede tener un máximo de 5 actividades','danger');}else{//alert('No se pueden duplicar actividades');
this.props.setSystemNotification('¡Oh no!','No se pueden duplicar actividades','danger');}}},{key:"_activityValue",value:function _activityValue(){var _props3=this.props,goal=_props3.goal,goals=_props3.goals;var goalActivities=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goals.list,{id:goal.proigualdad_goal_id});var activity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goalActivities.activities,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.refs.activitySelect.value)});if(activity){this.refs.total.value=Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.refs.quantity.value*activity.amount));}else{this.refs.total.value=Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(0);}}}]);return ActivityWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActivityWidget);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_projects__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_projects_expenses__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectEdit=function(_Component){_inherits(ProjectEdit,_Component);function ProjectEdit(){_classCallCheck(this,ProjectEdit);return _possibleConstructorReturn(this,(ProjectEdit.__proto__||Object.getPrototypeOf(ProjectEdit)).apply(this,arguments));}_createClass(ProjectEdit,[{key:'render',value:function render(){var projects=this.props.projects;return projects.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_projects_expenses__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchProjectsExpensesEdit(this.props.match.params.id);}}]);return ProjectEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_projects__["a" /* default */])(ProjectEdit,{subnav:3}));

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectExpensesEditForm=function(_Component){_inherits(ProjectExpensesEditForm,_Component);_createClass(ProjectExpensesEditForm,[{key:'render',value:function render(){var _this2=this;var projects=this.props.projects;var pc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(projects.permissions,function(o){return o==='Create';});var totalExpenses=0;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(projects.expenses,function(o){return totalExpenses+=o.total;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'projects.expenses',onSubmit:function onSubmit(values){return _this2._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},this.state.expenseEditShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExpenseEditModal,Object.assign({expenseIndex:this.state.expenseIndex,active:this.state.expenseEditShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):'',pc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-primary',onClick:function onClick(){return _this2._addExpense();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Agregar gasto')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Concepto del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Unidad de medida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Total'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(projects.expenses)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(projects.expenses,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'expenses-table-row-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editExpense(k,row);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._removeExpense(k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))),k+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.expense_concept.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.expense_unit.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(row.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(row.total)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'7',className:'has-text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'No hay gastos registrados')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5',className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2',className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(totalExpenses)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proyectos');}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'projects.expenses',className:'button is-large is-inm-purple',type:'submit',disabled:this._validateSave()},'Guardar'))));}}]);function ProjectExpensesEditForm(){_classCallCheck(this,ProjectExpensesEditForm);var _this=_possibleConstructorReturn(this,(ProjectExpensesEditForm.__proto__||Object.getPrototypeOf(ProjectExpensesEditForm)).call(this));_this.state={expenseIndex:undefined,expenseEditShow:false};return _this;}_createClass(ProjectExpensesEditForm,[{key:'_submitForm',value:function _submitForm(values){//console.log('values: ',values);
this.props.projectsExpensesSave(this.props.match.params.id,values);}},{key:'_editExpense',value:function _editExpense(expenseIndex,row){this.props.change('projects.edit',{temp_expense_concept_id:row.expense_concept_id,temp_expense_unit_id:row.expense_unit_id,temp_quantity:row.quantity,temp_amount:row.amount});this.setState({expenseIndex:expenseIndex,expenseEditShow:true});}},{key:'_addExpense',value:function _addExpense(){this.setState({expenseEditShow:true});}},{key:'_removeExpense',value:function _removeExpense(expenseIndex){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Esta seguro?',message:'¿Estás seguro/(a) de eliminar el gasto?',confirmLabel:'Eliminar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.remove('projects.expenses',expenseIndex);}});}},{key:'_toggleModal',value:function _toggleModal(){this.setState({expenseIndex:undefined,expenseEditShow:false});this.props.change('projects.edit',{});}},{key:'_validateSave',value:function _validateSave(){var projects=this.props.projects;var pc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(projects.permissions,function(o){return o==='Create';});var pu=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(projects.permissions,function(o){return o==='Update';});if(pu||pc){return false;}else{return true;}}}]);return ProjectExpensesEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectExpensesEditForm);var ExpenseEditModal=function(_Component2){_inherits(ExpenseEditModal,_Component2);function ExpenseEditModal(){_classCallCheck(this,ExpenseEditModal);return _possibleConstructorReturn(this,(ExpenseEditModal.__proto__||Object.getPrototypeOf(ExpenseEditModal)).apply(this,arguments));}_createClass(ExpenseEditModal,[{key:'render',value:function render(){var _this5=this;var _props=this.props,projects=_props.projects,concepts=_props.concepts;var conceptData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(concepts.list,{id:projects.edit.temp_expense_concept_id});var unitslist=conceptData?conceptData.units:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Gasto de coordinaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'projects.edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_expense_concept_id',className:'label'},'Concepto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'temp_expense_concept_id',model:'.temp_expense_concept_id',parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */],changeAction:function changeAction(model,value){return _this5._changeConcept(model,value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Concepto ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(concepts.list,function(st,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:st.id,key:k},st.name);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_expense_unit_id',className:'label'},'Unidad de medida ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'temp_expense_unit_id',model:'.temp_expense_unit_id',parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Unidad de medida ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(unitslist,function(st,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:st.id,key:k},st.name);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_quantity',className:'label'},'Cantidad ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{type:'number',min:'0',model:'.temp_quantity',id:'temp_quantity',className:'input'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'temp_amount',className:'label'},'Gasto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.temp_amount',className:'input',id:'temp_expense',type:'number',step:'0.01',min:'0',placeholder:'$'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-primary',onClick:function onClick(){return _this5._saveExpense();},disabled:this._getValidate(projects.edit.temp_expense_unit_id)},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.')))));}},{key:'_saveExpense',value:function _saveExpense(){var _props2=this.props,expenseIndex=_props2.expenseIndex,projects=_props2.projects,concepts=_props2.concepts;var edit=projects.edit;if(edit.temp_expense_concept_id&&edit.temp_expense_unit_id&&edit.temp_quantity&&edit.temp_amount){var total=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(edit.temp_quantity)*__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(edit.temp_amount);var conceptData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(concepts.list,{id:edit.temp_expense_concept_id});var unitData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(conceptData.units,{id:edit.temp_expense_unit_id});if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNumber(expenseIndex)&&projects.expenses[expenseIndex].id){this.props.change('projects.expenses['+expenseIndex+']',Object.assign({},projects.expenses[expenseIndex],{expense_concept_id:edit.temp_expense_concept_id,expense_unit_id:edit.temp_expense_unit_id,quantity:edit.temp_quantity,amount:edit.temp_amount,total:total,expense_concept:{name:conceptData.name},expense_unit:{name:unitData.name}}));}else{this.props.add('projects.expenses',{expense_concept_id:edit.temp_expense_concept_id,expense_unit_id:edit.temp_expense_unit_id,quantity:edit.temp_quantity,amount:edit.temp_amount,total:total,expense_concept:{name:conceptData?conceptData.name:''},expense_unit:{name:unitData?unitData.name:''}});}this.props.closeModal();}else{alert('Hay errores en el formulario');}}},{key:'_changeConcept',value:function _changeConcept(model,value){this.props.change(model,value);this.props.change('projects.edit.temp_expense_unit_id',undefined);}},{key:'_getValidate',value:function _getValidate(id){var _props3=this.props,projects=_props3.projects,expenseIndex=_props3.expenseIndex;var expenses=projects.expenses;var unit=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expenses,{expense_unit_id:id});if(expenseIndex!==undefined&&expenseIndex!==''&&expenseIndex!==null){if(projects.expenses[expenseIndex].expense_unit_id===id){return false;}else if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(unit)){return false;}else{return true;}}else{if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(unit)){return false;}else{return true;}}}}]);return ExpenseEditModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_projects__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_projects_commissions__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectEdit=function(_Component){_inherits(ProjectEdit,_Component);function ProjectEdit(){_classCallCheck(this,ProjectEdit);return _possibleConstructorReturn(this,(ProjectEdit.__proto__||Object.getPrototypeOf(ProjectEdit)).apply(this,arguments));}_createClass(ProjectEdit,[{key:'render',value:function render(){var projects=this.props.projects;return projects.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_projects_commissions__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchProjectCommission(this.props.match.params.id);}}]);return ProjectEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_projects__["a" /* default */])(ProjectEdit,{subnav:5}));

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectCommission=function(_Component){_inherits(ProjectCommission,_Component);function ProjectCommission(){_classCallCheck(this,ProjectCommission);return _possibleConstructorReturn(this,(ProjectCommission.__proto__||Object.getPrototypeOf(ProjectCommission)).apply(this,arguments));}_createClass(ProjectCommission,[{key:"render",value:function render(){var _this2=this;var project=this.props.projects.project;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-1"},"Comisiones"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(project.comissions_review)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(project.comissions_review.survey_version_phase)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(project.comissions_review.survey_version_phase.survey)?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(project.comissions_review.survey_version_phase.survey.children_questions,function(row,key){//console.log('row: ',row);
if(row.type==='group'){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"group-"+key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2,className:"has-text-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,key+1+". "+row.name))),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(row.children_questions,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowQuestion,Object.assign({key:k,row:row},_this2.props));})];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowQuestion,Object.assign({key:key,number:key+1,row:row},_this2.props));}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"}))," Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-left",style:{backgroundColor:'#a864a9'},colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{style:{color:'#fff'}},"Comentarios generales"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-left",colSpan:2},!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(project.comissions_review)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:project.comissions_review.comments&&project.comissions_review.comments!=='<p><br></p>'?project.comissions_review.comments:'Ninguno'}}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right",style:{backgroundColor:'#a864a9'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{style:{color:'#fff'}},"Puntuaci\xF3n total:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this._totalScore())))))));}},{key:"_totalScore",value:function _totalScore(){var project=this.props.projects.project;var total_score=project&&project.answers?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sum(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(project.answers,function(row){if(row){return row.answer_number;}else{return 0;}})):0;return total_score;}}]);return ProjectCommission;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectCommission);var RowQuestion=function(_Component2){_inherits(RowQuestion,_Component2);function RowQuestion(){_classCallCheck(this,RowQuestion);return _possibleConstructorReturn(this,(RowQuestion.__proto__||Object.getPrototypeOf(RowQuestion)).apply(this,arguments));}_createClass(RowQuestion,[{key:"render",value:function render(){var row=this.props.row;//let findValue = _.find(projects.commission.answers, {question_id: row.id});
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,this.props.number?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this.props.number+'. '+row.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,row.answer.answer_text)));}}]);return RowQuestion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_projects__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_projects_phases__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectPhasesEdit=function(_Component){_inherits(ProjectPhasesEdit,_Component);function ProjectPhasesEdit(){_classCallCheck(this,ProjectPhasesEdit);return _possibleConstructorReturn(this,(ProjectPhasesEdit.__proto__||Object.getPrototypeOf(ProjectPhasesEdit)).apply(this,arguments));}_createClass(ProjectPhasesEdit,[{key:'render',value:function render(){var projects=this.props.projects;return projects.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_projects_phases__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchProjectPhasesGroupsEdit(this.props.match.params.id);}}]);return ProjectPhasesEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_projects__["a" /* default */])(ProjectPhasesEdit,{subnav:6}));

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_datetimepicker__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectPhasesEditForm=function(_Component){_inherits(ProjectPhasesEditForm,_Component);_createClass(ProjectPhasesEditForm,[{key:'render',value:function render(){var _this2=this;var projects=this.props.projects;var phases_groups=projects.phases_groups;var pu=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(projects.permissions,function(o){return o==='Update';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},this.state.phaseEditShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PhaseEditModal,Object.assign({active:this.state.phaseEditShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proceso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sub-Proceso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha de inicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha de \xFAltima modificaci\xF3in'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(phases_groups,function(row,key){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,pu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editGroupPhase(row);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._getConfirm(row.id,row.version_phase.phase_group.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))):'',row.version_phase.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2',style:{align:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,row.version_phase.phase_group.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(row.documents)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(row.documents,function(item,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.file,target:'_blank',className:'has-text-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-link'})),item.name));})):'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'15%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,row.start_date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'15%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,row.end_date))),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(row.version_phase.project_version_phases,function(phase,k){//let document = _.find(row.documents,{documentable_subtype: phase.version_phase.phase.slug})
console.log('phase===>',phase.version_phase);//console.log('documents===>', row.documents);
//console.log('document===>', document);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'phases-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,pu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editPhase(phase,row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))):'',phase.version_phase.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,phase.version_phase.phase?phase.version_phase.phase.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,phase.start_date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,phase.end_date)));})];}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proyectos');}},'Regresar')))));}}]);function ProjectPhasesEditForm(){_classCallCheck(this,ProjectPhasesEditForm);var _this=_possibleConstructorReturn(this,(ProjectPhasesEditForm.__proto__||Object.getPrototypeOf(ProjectPhasesEditForm)).call(this));_this.state={phaseEditShow:false};return _this;}_createClass(ProjectPhasesEditForm,[{key:'_getConfirm',value:function _getConfirm(id,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el proceso "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.projectPhaseDelete(_this3.props.match.params.id,id);}});}},{key:'_editGroupPhase',value:function _editGroupPhase(data){this.props.change('projects.edit',{type:'group_phase',name:data.version_phase.phase_group.name,id:data.id,start_date:data.start_date,end_date:data.end_date});this.setState({phaseEditShow:true});}},{key:'_editPhase',value:function _editPhase(data,groupId){this.props.change('projects.edit',{type:'phase',group_id:groupId,name:data.version_phase.phase.name,id:data.id,start_date:data.start_date,end_date:data.end_date});this.setState({phaseEditShow:true});}},{key:'_toggleModal',value:function _toggleModal(){this.setState({phaseEditShow:false});this.props.reset('projects.edit');}}]);return ProjectPhasesEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectPhasesEditForm);var PhaseEditModal=function(_Component2){_inherits(PhaseEditModal,_Component2);function PhaseEditModal(){_classCallCheck(this,PhaseEditModal);return _possibleConstructorReturn(this,(PhaseEditModal.__proto__||Object.getPrototypeOf(PhaseEditModal)).apply(this,arguments));}_createClass(PhaseEditModal,[{key:'render',value:function render(){var _this5=this;var projects=this.props.projects;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,projects.edit&&projects.edit.type==='phase'?'Sub-Proceso - '+projects.edit.name:'Proceso - '+projects.edit.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),projects.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'projects.edit',className:'message-body',style:{height:'inherit'},onSubmit:function onSubmit(values){return _this5._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this5.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'start_date',className:'label'},'Fecha de inicio ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.start_date',name:'start_date',id:'start_date',component:__WEBPACK_IMPORTED_MODULE_4__forms_datetimepicker__["a" /* default */],className:'input',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.start_date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'La fecha es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'end_date',className:'label'},'Fecha de \xFAltima modificaci\xF3in '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.end_date',name:'end_date',id:'end_date',component:__WEBPACK_IMPORTED_MODULE_4__forms_datetimepicker__["a" /* default */],className:'input'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'projects.edit',type:'submit',className:'button is-primary',disabled:this._validateSave()},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.')))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.projects.edit;if(edit!==this.props.projects.edit){if(edit.action){if(edit.action==='close'){this._putInfo(edit);}}}}},{key:'_putInfo',value:function _putInfo(data){var projects=this.props.projects;var groupIndex=undefined;var phaseIndex=undefined;if(projects.edit.type==='group_phase'){groupIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(projects.phases_groups,{id:projects.edit.id});this.props.change('projects.phases_groups['+groupIndex+']',Object.assign({},projects.phases_groups[groupIndex],data));}else{var _groupIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(projects.phases_groups,{id:projects.edit.group_id});phaseIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(projects.phases_groups[_groupIndex].version_phase.project_version_phases,{id:projects.edit.id});this.props.change('projects.phases_groups['+_groupIndex+'].version_phase.project_version_phases['+phaseIndex+']',Object.assign({},projects.phases_groups[_groupIndex].version_phase.project_version_phases[phaseIndex],data));}this.props.closeModal();}},{key:'_submitForm',value:function _submitForm(values){//console.log('values: ',values);
this.props.projectPhaseSave(this.props.match.params.id,values);}},{key:'_validateSave',value:function _validateSave(){var projects=this.props.projects;var pu=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(projects.permissions,function(o){return o==='Update';});if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(projects.edit)&&projects.edit.id){if(pu){return false;}else{return true;}}else{return true;}}}]);return PhaseEditModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_projects__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_projects_employees__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectEmployeesEdit=function(_Component){_inherits(ProjectEmployeesEdit,_Component);function ProjectEmployeesEdit(){_classCallCheck(this,ProjectEmployeesEdit);return _possibleConstructorReturn(this,(ProjectEmployeesEdit.__proto__||Object.getPrototypeOf(ProjectEmployeesEdit)).apply(this,arguments));}_createClass(ProjectEmployeesEdit,[{key:'render',value:function render(){var projects=this.props.projects;return projects.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_projects_employees__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchStatus(1);this.props.fetchProjectEmployeesEdit(this.props.match.params.id);}}]);return ProjectEmployeesEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_projects__["a" /* default */])(ProjectEmployeesEdit,{subnav:4}));

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectEmployeesEditForm=function(_Component){_inherits(ProjectEmployeesEditForm,_Component);_createClass(ProjectEmployeesEditForm,[{key:'render',value:function render(){var _this2=this;var projects=this.props.projects;var list=this._getListEmployees(this.state.type_employees);var pu=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(projects.permissions,function(o){return o==='Update';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},this.state.employeeEditShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeeEditModal,Object.assign({active:this.state.employeeEditShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'type_employees',className:'label'},'Listar personal por:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'type_employees',id:'type_employees',ref:'type_employees',value:this.state.type_employees,onChange:function onChange(e){return _this2._changeType(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true},'-- Tipo de Personal --'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'agency'},'Instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'project'},'Proyecto'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'User ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'RFC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'CURP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Perfil'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(list,function(row,key){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:_this2.state.type_employees==='project'?2:1,style:{width:'10%'}},pu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editEmployee(row);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})),_this2.state.type_employees==='project'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._removeEmployee(row.id,''+(row.title?row.title+' ':'')+row.name+' '+row.last_name+(row.slast_name?' '+row.slast_name:''));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''):'',row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'10%'}},row.user_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'25%'}},''+(row.title?row.title+' ':'')+row.name+' '+row.last_name+(row.slast_name?' '+row.slast_name:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},row.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.rfc?row.rfc:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.curp?row.curp:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},row.role?row.role.display:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:row.status?'has-text-'+row.status.style:''},row.status?row.status.name:'---')),_this2.state.type_employees==='project'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'goal-'+key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#662d91'}},'META')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),row.project_goal?row.project_goal.code+' - '+row.project_goal.name:'---')):null];}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.push('/proyectos');}},'Regresar')))));}}]);function ProjectEmployeesEditForm(){_classCallCheck(this,ProjectEmployeesEditForm);var _this=_possibleConstructorReturn(this,(ProjectEmployeesEditForm.__proto__||Object.getPrototypeOf(ProjectEmployeesEditForm)).call(this));_this.state={type_employees:'agency',employeeEditShow:false};_this._changeType=_this._changeType.bind(_this);return _this;}_createClass(ProjectEmployeesEditForm,[{key:'_changeType',value:function _changeType(e){this.setState({type_employees:e.target.value});}},{key:'_getListEmployees',value:function _getListEmployees(type){var projects=this.props.projects;var response=[];if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(projects.employees)){if(type&&type==='project'){response=projects.employees.employees;}else if(type&&type==='agency'){response=projects.employees.agency.employees;}}return response;}},{key:'_editEmployee',value:function _editEmployee(data){var projects=this.props.projects;if(this.state.type_employees==='agency'){this.props.add('users.list',Object.assign({},data,{id:data.user_id}));}this.props.change('projects.edit',Object.assign({},projects.edit,{type:this.state.type_employees},data));this.setState({employeeEditShow:true});}},{key:'_removeEmployee',value:function _removeEmployee(employeeId,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({title:'¿Esta seguro?',message:'Al eliminar a '+name+', se eliminar\xE1 toda la informaci\xF3n vinculada.',confirmLabel:'Eliminar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.projectEmployeeDelete(_this3.props.match.params.id,employeeId);}});}},{key:'_toggleModal',value:function _toggleModal(){this.setState({employeeEditShow:false});this.props.reset('projects.edit');this.props.reset('users.list');}}]);return ProjectEmployeesEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectEmployeesEditForm);var EmployeeEditModal=function(_Component2){_inherits(EmployeeEditModal,_Component2);function EmployeeEditModal(){_classCallCheck(this,EmployeeEditModal);return _possibleConstructorReturn(this,(EmployeeEditModal.__proto__||Object.getPrototypeOf(EmployeeEditModal)).apply(this,arguments));}_createClass(EmployeeEditModal,[{key:'render',value:function render(){var _this5=this;var _props=this.props,projects=_props.projects,users=_props.users,status=_props.status;var edit=projects.edit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Personal contratado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'projects.edit',className:'message-body',style:{height:'inherit'},onSubmit:function onSubmit(values){return _this5._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this5.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},edit.type==='agency'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'search',className:'label'},'Buscar usuarios registrado'):'',edit.type==='agency'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.search',id:'search',className:'input'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this5._searchUser();},disabled:edit.search?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'})))):'',edit.type==='agency'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'user_id',className:'label'},'Usuario ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')):'',edit.type==='agency'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(users.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'user_id',model:'.user_id',parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change',disabled:users.isFetching||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(users.list),changeAction:function changeAction(model,value){return _this5._changeUser(model,value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Usuario ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(users.list,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.id},''+(opt.title?opt.title+' ':'')+opt.name+' '+opt.last_name+(opt.slast_name?' '+opt.slast_name:''));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.user_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El usuario es obligatorio'}}))):'',edit.type==='project'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Usuario actual'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,''+(edit.title?edit.title+' ':'')+edit.name+' '+edit.last_name+(edit.slast_name?' '+edit.slast_name:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Perfil'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,edit.role?edit.role.display:'---'))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},edit.type==='project'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Meta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,edit.project_goal?edit.project_goal.name:'---')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'role_id',className:'label'},'Perfil ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'role_id',model:'.role_id',parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:' ',defaultValue:true},'--- Perfil ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(projects.roles,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:k,value:opt.id},opt.display?opt.display:opt.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.role_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El perfil es obligatorio'}}))),edit.type==='project'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'job_function',className:'label'},'Funci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.job_function',id:'job_function',className:'input',placeholder:'Funci\xF3n',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.job_function',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El campo es obligatorio'}}))):'',edit.type==='project'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rfc_invoices',className:'label'},'RFC facturas expedidas '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.rfc_invoices',id:'rfc_invoices',className:'input',value:edit.rfc_invoices?edit.rfc_invoices:'',placeholder:'XXXX000000XX0',errors:{isRfc:__WEBPACK_IMPORTED_MODULE_3__field_validations__["e" /* isRfc */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.rfc_invoices',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRfc:'RFC inválido. '}})))):'',edit.type==='project'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'wage',className:'label'},'Ingreso mensual ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.wage',id:'wage',type:'number',step:'.01',min:'0',className:'input',placeholder:'0,000.00',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.wage',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Periodo de contrataci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{style:{margin:'0px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'period_start',className:'label'},'Inicia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.period_start',name:'period_start',component:__WEBPACK_IMPORTED_MODULE_4__forms_datepicker__["a" /* default */],className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.period_start',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'period_end',className:'label'},'Termina ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.period_end',name:'period_end',component:__WEBPACK_IMPORTED_MODULE_4__forms_datepicker__["a" /* default */],className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.period_end',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'status',className:'label'},'Estatus ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Field"],{model:'.status_id',className:'select',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:true},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(status.data,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.status_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'projects.edit',type:'submit',className:'button is-primary'},'Guardar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.')))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.projects.edit;if(edit!==this.props.projects.edit){if(edit.action){if(edit.action==='close'){this._putInfo(edit);}}}}},{key:'_putInfo',value:function _putInfo(data){var projects=this.props.projects;var employeeIndex=undefined;if(projects.edit.type==='agency'){employeeIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(projects.employees.agency.employees,{id:data.id});this.props.change('projects.employees.agency.employees['+employeeIndex+']',Object.assign({},data,{action:undefined}));}else{employeeIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(projects.employees.employees,{id:data.id});this.props.change('projects.employees.employees['+employeeIndex+']',Object.assign({},data,{action:undefined}));}this.props.closeModal();}},{key:'_searchUser',value:function _searchUser(){var projects=this.props.projects;this.props.change('projects.edit.user_id',undefined);this.props.change('projects.edit',{id:projects.edit.id,type:projects.edit.type,user_id:undefined,role_id:projects.edit.role_id});this.props.usersFind(projects.edit.search);}},{key:'_changeUser',value:function _changeUser(model,value){var _props2=this.props,projects=_props2.projects,users=_props2.users;var user=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(users.list,{id:value});this.props.change('projects.edit',Object.assign({},user,{id:projects.edit.id,type:projects.edit.type,user_id:value,role_id:projects.edit.role_id}));}},{key:'_submitForm',value:function _submitForm(values){//console.log('values====> ',values);
this.props.projectEmployeeEditSave(this.props.match.params.id,values);}}]);return EmployeeEditModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_projects_folios__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportFolios=function(_Component){_inherits(ReportFolios,_Component);function ReportFolios(){_classCallCheck(this,ReportFolios);return _possibleConstructorReturn(this,(ReportFolios.__proto__||Object.getPrototypeOf(ReportFolios)).apply(this,arguments));}_createClass(ReportFolios,[{key:'render',value:function render(){var projects=this.props.projects;return projects.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_projects_folios__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var modality=this.props.match.params.modality;this.props.projectsFolios(modality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextprops){if(nextprops.match.params!==this.props.match.params){var modality=nextprops.match.params.modality;this.props.projectsFolios(modality);}}}]);return ReportFolios;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(ReportFolios,{title:"Asignación de Folios",subnav:{icon:'fa-briefcase',name:'Proyectos',actions:[{type:null,url:null,name:'',element:null}]},stateNav:false}));

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_top__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FoliosTable=function(_Component){_inherits(FoliosTable,_Component);function FoliosTable(){_classCallCheck(this,FoliosTable);return _possibleConstructorReturn(this,(FoliosTable.__proto__||Object.getPrototypeOf(FoliosTable)).apply(this,arguments));}_createClass(FoliosTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,projects=_props.projects,entities=_props.entities;var modality=this.props.match.params.modality;var pc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(projects.permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__scroll_top__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Folios de proyectos',modality==='modalidad-i'?' - Modalidad I':modality==='modalidad-ii'?' - Modalidad II':' - Modalidad III'),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(projects.folios)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(projects.folios,function(item,k){var stateInfo=undefined;if(modality==='modalidad-ii'&&item.agency&&item.agency&&item.agency.agenciable){stateInfo=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(entities.list,{id:item.agency.agenciable.state_id});}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'instance-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Folio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.code?item.code:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:'70%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency&&item.agency.name?item.agency.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Estado'),modality!=='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency&&item.agency&&item.agency.agenciable?item.agency.agenciable.name:'---'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,stateInfo?stateInfo.name:'---'),modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Municipio'):'',modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency&&item.agency&&item.agency.agenciable?item.agency.agenciable.name:'---'):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'general-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Titular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency&&item.agency&&item.agency.owner?item.agency.owner.title+' '+item.agency.owner.name+' '+item.agency.owner.last_name+' '+item.agency.owner.slast_name:'---')))];}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon has-text-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lg fa-exclamation-triangle'})),' Sin informaci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-large',onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),pc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-large is-inm-purple',onClick:function onClick(){return _this2._handleClick();},disabled:projects.codes_assigned||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(projects.folios)},'Asignar Folios')):'')))));}},{key:'_handleClick',value:function _handleClick(){var _this3=this;var modality=this.props.match.params.modality;Object(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'Esta acción es irreversible. Una vez asignados los folios, no podrán ser restablecidos.',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){_this3.props.projectsFoliosAssign(modality);}});}/*_permissionSave() {
		const { projects } = this.props;
		//let agencies =_.filter(projects.list,(o) => {return o.project_precode});
		//console.log('agencies: ',agencies);
		if(_.isEmpty(agencies)){
			return true
		}else {
			return false
		}
	}*/}]);return FoliosTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FoliosTable);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_project__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_project_owner__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectOwner=function(_Component){_inherits(ProjectOwner,_Component);function ProjectOwner(){_classCallCheck(this,ProjectOwner);return _possibleConstructorReturn(this,(ProjectOwner.__proto__||Object.getPrototypeOf(ProjectOwner)).apply(this,arguments));}_createClass(ProjectOwner,[{key:'render',value:function render(){var _props=this.props,project=_props.project,modalities=_props.modalities;return project.owner.isFetching||modalities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_project_owner__["a" /* default */],{owner:project.owner,permissions:project.permissions,modalities:modalities,match:this.props.match,history:this.props.history,saveOwner:this.props.saveOwner,setSystemNotification:this.props.setSystemNotification});}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.fetchModalities();this.props.fetchOwner(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(this.props.location.pathname!==newprops.location.pathname){this.props.fetchOwner(modality,state,municipality);}}}]);return ProjectOwner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_project__["a" /* default */])(ProjectOwner,{subnav:1}));

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_config__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectControlNav=function(_Component){_inherits(ProjectControlNav,_Component);function ProjectControlNav(){_classCallCheck(this,ProjectControlNav);return _possibleConstructorReturn(this,(ProjectControlNav.__proto__||Object.getPrototypeOf(ProjectControlNav)).apply(this,arguments));}_createClass(ProjectControlNav,[{key:"render",value:function render(){var _props=this.props,params=_props.params,phase=_props.phase;var currentStep=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3__store_config__["_266" /* projectInitNav */],{step:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.props.step)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnavigation-projects"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(phase)&&phase.name?phase.name:currentStep?currentStep.title:''," - ",this.props.agency?this.props.agency:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,params.modality==='modalidad-i'?'Categoría A':params.modality==='modalidad-ii'?'Modalidad II':'Modalidad III'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-step"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},__WEBPACK_IMPORTED_MODULE_3__store_config__["_266" /* projectInitNav */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level context-navigation"},__WEBPACK_IMPORTED_MODULE_3__store_config__["_266" /* projectInitNav */].map(function(item,k){var projectLink=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(item.url,':modality',params.modality),':state?',params.state==='undefined'?params.municipalities[0].state.short:params.state),':municipality?',params.municipality===null?params.municipalities[0].slug:params.municipality),'undefined','');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item",key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:"step",to:projectLink,activeClassName:"active"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,item.step),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.title)));}))))));}}]);return ProjectControlNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectControlNav);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_greeting_select__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_big_file_upload__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={owner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,permissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,//loadFormData: PropTypes.func.isRequired,
saveOwner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired//revision: PropTypes.object
};var RegisterEditForm=function(_Component){_inherits(RegisterEditForm,_Component);_createClass(RegisterEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,owner=_props.owner,permissions=_props.permissions,modalities=_props.modalities,match=_props.match;var ownerRev=owner.revision?owner.revision.body:undefined;var modality=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(modalities.list,{slug:match.params.modality});var pc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Form"],{model:"project.owner.data",onSubmit:function onSubmit(project){return _this2.handleSubmit(project);},onSubmitFailed:function onSubmitFailed(error){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario.','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"title",className:"label"},"Saludo ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"+(owner.isFetching?' is-loading':'')+(ownerRev?' is-'+ownerRev.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"],{model:".title",id:"title",component:__WEBPACK_IMPORTED_MODULE_7__forms_greeting_select__["a" /* default */],validateOn:"change",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},disabled:this._blockField()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".title",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'Debes elegir un saludo'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre(s) ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".name",className:"input"+(ownerRev?' is-'+ownerRev.status:''),id:"name",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},placeholder:"Nombre(s)",validateOn:"change",disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El nombre es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"last_name",className:"label"},"Primer apellido ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".last_name",className:"input"+(ownerRev?' is-'+ownerRev.status:''),id:"last_name",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".last_name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El apellido es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"slast_name",className:"label"},"Segundo apellido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".slast_name",className:"input"+(ownerRev?' is-'+ownerRev.status:''),id:"slast_name",disabled:this._blockField()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"sex",className:"label"},"Sexo ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"+(owner.isFetching?' is-loading':'')+(ownerRev?' is-'+ownerRev.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].select,{model:".sex",id:"sex",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockField()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Sexo ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"M"},"Mujer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"H"},"Hombre"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".sex",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El sexo es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"rfc",className:"label"},"RFC ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".rfc",id:"rfc",className:"input"+(ownerRev?' is-'+ownerRev.status:''),placeholder:"RFC",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */],isRfc:__WEBPACK_IMPORTED_MODULE_4__field_validations__["e" /* isRfc */]},validateOn:"change",parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["b" /* allUpper */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".rfc",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El RFC es obligatorio. ',isRfc:'RFC inválido. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"curp",className:"label"},"CURP ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".curp",id:"curp",className:"input"+(ownerRev?' is-'+ownerRev.status:''),placeholder:"CURP",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */],maxLength:Object(__WEBPACK_IMPORTED_MODULE_4__field_validations__["g" /* maxLength */])(18),isCurp:__WEBPACK_IMPORTED_MODULE_4__field_validations__["b" /* isCurp */]},validateOn:"change",parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["b" /* allUpper */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".curp",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La CURP es obligatoria. ',isCurp:'CURP inválida. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"scholarship",className:"label"},"Escolaridad ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".scholarship",id:"scholarship",className:"input"+(ownerRev?' is-'+ownerRev.status:''),placeholder:"Escolaridad",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".scholarship",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La escolaridad es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"period_start",className:"label"},"Fecha en que asumi\xF3 cargo ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"],{model:".period_start",id:"period_start",value:owner.data&&owner.data.period_start?owner.data.period_start:'',className:"input"+(ownerRev?' is-'+ownerRev.status:''),errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},component:__WEBPACK_IMPORTED_MODULE_6__forms_datepicker__["a" /* default */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".period_start",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La fecha en la que asumió el cargo es obligatoria. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"email",className:"label"},"Email principal",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".email",className:"input"+(ownerRev?' is-'+ownerRev.status:''),placeholder:"Email principal *",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */],isEmail:__WEBPACK_IMPORTED_MODULE_4__field_validations__["c" /* isEmail */]},validateOn:"change",parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["a" /* allLower */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".email",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El email es obligatorio',isEmail:'El email es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"email_2",className:"label"},"Email secundario "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".email_2",id:"email_2",className:"input"+(ownerRev?' is-'+ownerRev.status:''),placeholder:"Email secundario",errors:{email:__WEBPACK_IMPORTED_MODULE_4__field_validations__["a" /* email */]},validateOn:"change",parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["a" /* allLower */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".email_2",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{email:'El email es inválido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"telephone",className:"label"},"Tel\xE9fono principal ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".telephone",id:"telephone",className:"input"+(ownerRev?' is-'+ownerRev.status:''),placeholder:"Tel\xE9fono principal",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */],phoneNumber:__WEBPACK_IMPORTED_MODULE_4__field_validations__["l" /* phoneNumber */]},validateOn:"change",disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".telephone",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El Teléfono es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(owner.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"telephone_2",className:"label"},"Tel\xE9fono alterno"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:".telephone_2",id:"telephone_2",className:"input"+(ownerRev?' is-'+ownerRev.status:''),placeholder:"Tel\xE9fono alterno",errors:{phoneNumber:__WEBPACK_IMPORTED_MODULE_4__field_validations__["l" /* phoneNumber */]},validateOn:"change",disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:".telephone_2",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{phoneNumber:__WEBPACK_IMPORTED_MODULE_4__field_validations__["l" /* phoneNumber */]}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"title is-5"},"Documentaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero is-light"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline is-grouped-left"},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(owner.documents_items,function(o){return o.modality_id===null||o.modality_id===(modality?modality.id:undefined);}),function(item,d){var documentRev=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(ownerRev)?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(ownerRev,{field:item.slug}):undefined;var accepts=undefined;__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item.documents_types,function(ext){accepts=accepts?accepts+","+ext.extensions:""+ext.extensions;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__widgets_big_file_upload__["a" /* default */],{key:d,model:"."+item.slug,name:item.name,file:owner.data&&owner.data[item.slug],file_format:item.file_format,accept:accepts,comment:documentRev&&documentRev.comment?documentRev.comment:undefined,status:documentRev&&documentRev.status,disabled:_this2._blockField()});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.push('/inicio');}},"Regresar")),pc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].button,{model:"project.register",className:"button is-large is-primary",disabled:this._blockField()},"Guardar")):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}}]);function RegisterEditForm(){_classCallCheck(this,RegisterEditForm);var _this=_possibleConstructorReturn(this,(RegisterEditForm.__proto__||Object.getPrototypeOf(RegisterEditForm)).call(this));_this.state={cleanForm:true};return _this;}/*componentWillReceiveProps(newprops) {
		if(!newprops.owner.isFetching){
			if(!_.isEmpty(newprops.owner.data) && newprops.owner.data !== this.props.owner.data && this.state.cleanForm) {
				this.props.loadFormData('project.owner.data', newprops.owner.data);
				return this.setState({cleanForm: false});
			}
		}
	}*/_createClass(RegisterEditForm,[{key:"handleSubmit",value:function handleSubmit(values,event){var params=this.props.match.params;this.props.saveOwner(params.modality,params.state,params.municipality,values,event);}},{key:"_blockField",value:function _blockField(){var owner=this.props.owner;var response=false;var editable=owner.editable;var ownerRevision=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(owner.revision)?owner.revision.body:undefined;if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(ownerRevision)&&!owner.isFetching){var allow=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(ownerRevision,{allow_edit:'true'})?true:false;if(editable&&allow){response=false;}else{response=true;}}else if(editable&&!owner.isFetching){response=false;}else{response=true;}return response;}}]);return RegisterEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RegisterEditForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (RegisterEditForm);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_project__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_project_instance__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectAgency=function(_Component){_inherits(ProjectAgency,_Component);_createClass(ProjectAgency,[{key:'render',value:function render(){var _props=this.props,entities=_props.entities,municipalities=_props.municipalities,modalities=_props.modalities,match=_props.match,revision=_props.revision,project=_props.project;return project.instance.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_project_instance__["a" /* default */],{fetching:project.instance.isFetching,owner:project.owner.data,instance:project.instance,entities:entities,municipalities:municipalities,modalities:modalities,match:match,revision:revision.instance,permissions:project.permissions,saveAgency:this.props.saveAgency,projectAgencyExport:this.props.projectAgencyExport,fetchMunicipalities:this.props.fetchMunicipalities,setSystemNotification:this.props.setSystemNotification,change:this.props.change,history:this.props.history,disabled:this.blockFields()});}}]);function ProjectAgency(){_classCallCheck(this,ProjectAgency);var _this=_possibleConstructorReturn(this,(ProjectAgency.__proto__||Object.getPrototypeOf(ProjectAgency)).call(this));_this.blockFields=_this.blockFields.bind(_this);return _this;}_createClass(ProjectAgency,[{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.fetchAgency(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(this.props.location.pathname!==newprops.location.pathname){this.props.fetchAgency(modality,state,municipality);}}},{key:'blockFields',value:function blockFields(){var instance=this.props.project.instance;var response=false;var editable=instance.editable;var instanceRevision=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(instance.revision)?instance.revision.body:undefined;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(instanceRevision)&&!instance.isFetching){var allow=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(instanceRevision,{allow_edit:'true'})?true:false;if(editable&&allow){response=false;}else{response=true;}}else if(editable&&!instance.isFetching){response=false;}else{response=true;}return response;}}]);return ProjectAgency;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_project__["a" /* default */])(ProjectAgency,{subnav:2}));

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={owner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,instance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,permissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,saveAgency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var InstanceEditForm=function(_Component){_inherits(InstanceEditForm,_Component);_createClass(InstanceEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,entities=_props.entities,municipalities=_props.municipalities,match=_props.match,owner=_props.owner,instance=_props.instance,fetching=_props.fetching,disabled=_props.disabled,permissions=_props.permissions,modalities=_props.modalities;var instanceRev=instance.revision?instance.revision.body:undefined;var modality=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(modalities.list,{slug:match.params.modality});var pc=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},instanceRev&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(instanceRev.comment)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message '+(instanceRev.status?'is-'+instanceRev.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},'Comentarios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,instanceRev.comment))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Form"],{model:'project.instance.data',onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');},encType:'multipart/form-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded '+(fetching&&' is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre de la instancia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.name',id:'name',autoFocus:true,className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Nombre de Instancia',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre de la instancia es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control '+(fetching&&' is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'creation_date',className:'label'},'Fecha de creaci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"],{model:'.creation_date',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',id:'creation_date',value:instance.data&&instance.data.creation_date?instance.data.creation_date:'',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),component:__WEBPACK_IMPORTED_MODULE_3__forms_datepicker__["a" /* default */],disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.creation_date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha de creación es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'legal_nature',className:'label'},'Naturaleza jur\xEDdica ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.legal_nature',id:'legal_nature',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Naturaleza jur\xEDdica',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.legal_nature',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La naturaleza jurídica de la instancia es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control '+(fetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'management_period_start',className:'label'},'Inicio de gesti\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"],{model:'.management_period_start',id:'management_period_start',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),value:instance.data&&instance.data.management_period_start?instance.data.management_period_start:'',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',component:__WEBPACK_IMPORTED_MODULE_3__forms_datepicker__["a" /* default */],disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.management_period_start',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha de inicio de gestión es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control '+(fetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'management_period_end',className:'label'},'Fin de gesti\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"],{model:'.management_period_end',id:'management_period_end',value:instance.data&&instance.data.management_period_end?instance.data.management_period_end:'',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',component:__WEBPACK_IMPORTED_MODULE_3__forms_datepicker__["a" /* default */],disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.management_period_end',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha de fin de gestión es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'street',className:'label'},'Direcci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.street',id:'street',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Calle',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.street',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La dirección es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'num_ext',className:'label'},'N\xFAmero ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.num_ext',id:'num_ext',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',placeholder:'N\xFAmero exterior',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.num_ext',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El número exterior es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'num_int',className:'label'},'Interior '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.num_int',type:'text',id:'num_int',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'N\xFAmero interior',disabled:fetching||disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'colony',className:'label'},'Colonia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.colony',id:'colony',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Colonia o Localidad',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.colony',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La colonia es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'cp',className:'label'},'C\xF3digo postal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.cp',id:'cp',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),type:'number',max:'99999',step:'1',min:'1',placeholder:'55555',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},validateOn:'change',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.cp',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El código postal es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'road_type',className:'label'},'Tipo de vialidad '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.road_type',id:'road_type',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Tipo de Vialidad',disabled:fetching||disabled}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'state',className:'label'},'Estado ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select '+(instanceRev&&'is-'+instanceRev.status)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].select,{model:'.state_id',id:'state',changeAction:function changeAction(model,value){return _this2.changeMuns(model,value);},parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},validateOn:'change',disabled:fetching||disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{defaultValue:entities.isFetching},'--- Estado ---'),entities.list.map(function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.state_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estado es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'municipality',className:'label'},'Municipio ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select '+((municipalities.isFetching||fetching)&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].select,{model:'.municipality_id',id:'municipality',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},validateOn:'change',disabled:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(municipalities.list)<0||fetching||disabled||municipalities.isFetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Municipio ---'),municipalities.list.map(function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.municipality_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El municipio o delegación es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone',className:'label'},'Tel\xE9fono principal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.telephone',id:'telephone',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Tel\xE9fono principal',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */],phoneNumber:__WEBPACK_IMPORTED_MODULE_6__field_validations__["l" /* phoneNumber */]},validateOn:'change',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.telephone',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El teléfono es obligatorio',phoneNumber:'El número de teléfono es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone_2',className:'label'},'Tel\xE9fono alterno'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.telephone_2',id:'telephone_2',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Tel\xE9fono alterno',errors:{phoneNumber:__WEBPACK_IMPORTED_MODULE_6__field_validations__["l" /* phoneNumber */]},validateOn:'change',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.telephone_2',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{phoneNumber:'El número de teléfono es inválido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded '+(fetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email',className:'label'},'Email principal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.email',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Email principal',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */],isEmail:__WEBPACK_IMPORTED_MODULE_6__field_validations__["c" /* isEmail */]},validateOn:'change',disabled:fetching||disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.email',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El email principal es obligatorio',isEmail:'El email es inválido'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded '+(fetching&&'is-loading')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email_2',className:'label'},'Email secundario '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.email_2',id:'email_2',className:'input '+(instanceRev!==undefined&&'is-'+instanceRev.status),placeholder:'Email secundario',errors:{email:__WEBPACK_IMPORTED_MODULE_6__field_validations__["a" /* email */]},validateOn:'change',disabled:disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.email_2',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{email:'El email es inválido'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title is-5'},'Documentaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},!fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},this.validateOwner(owner,instance.data.name)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.props.projectAgencyExport(match.params.modality,match.params.state,match.params.municipality);}},'Generar solicitud de participaci\xF3n',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link','aria-hidden':'true'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tag is-warning'},'Los datos del titular y el nombre de la Instancia no est\xE1n completos y son requeridos para generar la solicitud de participaci\xF3n.')),fetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline is-grouped-left'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(instance.documents_items,function(o){return o.agency_type===null&&(o.modality_id===null||o.modality_id===(modality?modality.id:undefined));}),function(item,d){var documentRev=!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(instanceRev)?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(instanceRev,{field:item.slug}):undefined;var accepts=undefined;__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(item.documents_types,function(ext){accepts=accepts?accepts+','+ext.extensions:''+ext.extensions;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__["a" /* default */],{key:d,model:'.'+item.slug,name:item.name,file:instance.data&&instance.data[item.slug],file_format:item.file_format,accept:accepts,comment:documentRev&&documentRev.comment?documentRev.comment:undefined,status:documentRev&&documentRev.status,disabled:_this2._blockFields(item.slug)});})))),match.params.modality==='modalidad-ii'&&[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{key:'extra-docs-bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5',style:{marginTop:'30px'},key:'extra-docs-title'},'Documentaci\xF3n adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light',key:'extra-docs-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'type',className:'label'},'Tipo de Instancia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].select,{model:'.type',id:'type',disabled:disabled||fetching,validateOn:'change',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},changeAction:function changeAction(model,value){return _this2._changeType(model,value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Tipo de Instancia ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'centralized'},'Centralizada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'decentralized'},'Descentralizada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'delegacy'},'Delegaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.type',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Favor de seleccionar el tipo de instancia'}}))),fetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline is-grouped-left'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(instance.documents_items,function(o){return o.agency_type===instance.data.type&&o.modality_id===(modality?modality.id:undefined);}),function(item,d){var documentRev=!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(instanceRev)?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(instanceRev,{field:item.slug}):undefined;var accepts=undefined;__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(item.documents_types,function(ext){accepts=accepts?accepts+','+ext.extensions:''+ext.extensions;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__["a" /* default */],{key:d,model:'.'+item.slug,name:item.name,file:instance.data&&instance.data[item.slug],file_format:item.file_format,accept:accepts,comment:documentRev&&documentRev.comment?documentRev.comment:undefined,status:documentRev&&documentRev.status,disabled:_this2._blockFields(item.slug)});}))))],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right',style:{marginTop:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',disabled:fetching,onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),pc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].button,{model:'project.instance',className:'button is-primary is-large',disabled:disabled},'Guardar')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);function InstanceEditForm(){_classCallCheck(this,InstanceEditForm);var _this=_possibleConstructorReturn(this,(InstanceEditForm.__proto__||Object.getPrototypeOf(InstanceEditForm)).call(this));_this.state={agencyType:null,cleanForm:true};return _this;}_createClass(InstanceEditForm,[{key:'_handleSubmit',value:function _handleSubmit(values){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality,modality=_props$match$params.modality;this.props.saveAgency(modality,state,municipality,values);}},{key:'validateOwner',value:function validateOwner(owner,instance){if(owner){if(owner.name&&owner.last_name&&owner.rfc&&owner.curp&&instance){return true;}else{return false;}}else{return false;}}},{key:'changeMuns',value:function changeMuns(model,value){if(value){this.props.fetchMunicipalities(value);this.props.change(model,value);}}},{key:'_changeType',value:function _changeType(model,value){var _this3=this;this.props.change(model,value);var _props2=this.props,instance=_props2.instance,modalities=_props2.modalities,match=_props2.match;var modality=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(modalities.list,{slug:match.params.modality});__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(instance.documents_items,function(o){return o.agency_type===instance.data.type&&o.modality_id===(modality?modality.id:undefined);}),function(item){_this3.props.change('project.instance.data.'+item.slug,undefined);});switch(value){case'decentralized':this.setState({agencyType:'decentralized'});break;case'centralized':this.setState({agencyType:'centralized'});break;case'delegacy':this.setState({agencyType:'delegacy'});break;default:this.setState({agencyType:null});break;}}},{key:'_blockFields',value:function _blockFields(field){var instance=this.props.instance;var response=false;var editable=instance.editable;var instanceRevision=!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(instance.revision)?instance.revision.body:undefined;if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(instanceRevision)&&!instance.isFetching){var allow=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(instanceRevision,{allow_edit:'true',field:field})?true:false;if(editable&&allow){response=false;}else{response=true;}}else if(editable&&!instance.isFetching){response=false;}else{response=true;}return response;}}]);return InstanceEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InstanceEditForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (InstanceEditForm);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_project__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_project_registry__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectGoal=function(_Component){_inherits(ProjectGoal,_Component);function ProjectGoal(){_classCallCheck(this,ProjectGoal);return _possibleConstructorReturn(this,(ProjectGoal.__proto__||Object.getPrototypeOf(ProjectGoal)).apply(this,arguments));}_createClass(ProjectGoal,[{key:'render',value:function render(){var _props=this.props,project=_props.project,goals=_props.goals,entities=_props.entities,municipalities=_props.municipalities,directories=_props.directories,resource_concepts=_props.resource_concepts,match=_props.match;return project.registry.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_project_registry__["a" /* default */],{fetching:project.registry.isFetching,modality:match.params.modality,state:match.params.state,municipality:match.params.municipality,registry:project.registry,goals:goals.list,proigualdadGoals:project.goals,entities:entities,municipalities:municipalities,directories:directories,resource_concepts:resource_concepts,permissions:project.permissions,match:this.props.match,change:this.props.change,fetchMunicipalities:this.props.fetchMunicipalities,add:this.props.add,remove:this.props.remove,projectProigualdadGoals:this.props.projectProigualdadGoals,history:this.props.history,setSystemNotification:this.props.setSystemNotification,saveRegistry:this.props.saveRegistry});}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.fetchRegistry(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextprops){var _nextprops$match$para=nextprops.match.params,modality=_nextprops$match$para.modality,state=_nextprops$match$para.state,municipality=_nextprops$match$para.municipality;if(nextprops.location.pathname!==this.props.location.pathname){this.props.fetchRegistry(modality,state,municipality);}}}]);return ProjectGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_project__["a" /* default */])(ProjectGoal,{subnav:3}));

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_project_data_form__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_goal_selector__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_project_goals_modal_widget__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_project_mod_i_goals_list_widget__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_project_mod_ii_goals_list_widget__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_project_mod_iii_goals_list_widget__ = __webpack_require__(680);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectGoalEditForm=function(_Component){_inherits(ProjectGoalEditForm,_Component);_createClass(ProjectGoalEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,registry=_props.registry,permissions=_props.permissions,modality=_props.modality,state=_props.state,municipality=_props.municipality,proigualdadGoals=_props.proigualdadGoals,municipalities=_props.municipalities,goals=_props.goals,fetching=_props.fetching,resource_concepts=_props.resource_concepts,directories=_props.directories;var rev=registry.revision?registry.revision.body:undefined;var registryDisabled=this._permissionField();var pc=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Form"],{model:'project.registry.data',onSubmit:function onSubmit(project){return _this2._handleSubmit(project);},onSubmitFailed:function onSubmitFailed(error){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_project_goals_modal_widget__["a" /* default */],{active:this.state.goalsShow,closeModal:this._toggleModal,modality:modality,state:state,municipality:municipality,fetching:proigualdadGoals.isFetching,proigualdad:proigualdadGoals.list,pages:proigualdadGoals.pages,pageChange:this._pageChange}),modality==='modalidad-i'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-primary',onClick:function onClick(){return _this2._openGoalsModal();}},'Metas personalizadas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__widgets_project_data_form__["a" /* default */],{revision:rev,fetching:registry.isFetching,data:registry.data,disabled:registryDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_goal_selector__["a" /* default */],{goals:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(goals,function(o){return o.modality.slug===modality;}),modality:modality,isDisabled:registryDisabled,fetching:fetching,canAdd:this._canAddActivities,goalAdd:this._addGoal}),modality==='modalidad-i'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets_project_mod_i_goals_list_widget__["a" /* default */],{editable:registry.editable,state:state,municipalities:municipalities,entities:this.props.entities.list,goals:registry.data.project_goals,directories:directories,allgoals:goals,change:this.props.change,add:this.props.add,remove:this.props.remove,fetchMunicipalities:this.props.fetchMunicipalities,revision:registry.revision&&registry.revision.body&&registry.revision.body.goals?registry.revision.body.goals:undefined,resources:resource_concepts,projectTotal:registry.data.amounts}),modality==='modalidad-ii'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__widgets_project_mod_ii_goals_list_widget__["a" /* default */],{editable:registry.editable,state:state,municipalities:municipalities,entities:this.props.entities.list,goals:registry.data.project_goals,directories:directories,allgoals:goals,change:this.props.change,add:this.props.add,remove:this.props.remove,fetchMunicipalities:this.props.fetchMunicipalities,revision:registry.revision&&registry.revision.body&&registry.revision.body.goals?registry.revision.body.goals:undefined,resources:resource_concepts,projectTotal:registry.data.amounts}),modality==='modalidad-iii'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__widgets_project_mod_iii_goals_list_widget__["a" /* default */],{editable:registry.editable,state:state,municipalities:municipalities,entities:this.props.entities.list,goals:registry.data.project_goals,directories:directories,allgoals:goals,change:this.props.change,add:this.props.add,remove:this.props.remove,fetchMunicipalities:this.props.fetchMunicipalities,revision:registry.revision&&registry.revision.body&&registry.revision.body.goals?registry.revision.body.goals:undefined,resources:resource_concepts,projectTotal:registry.data.amounts}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-borderless'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large',onClick:function onClick(){return _this2.props.history.goBack();}},' Regresar')),pc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].button,{model:'project.registry.data',className:'button is-large is-primary',disabled:!registry.editable},'Guardar'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);function ProjectGoalEditForm(props){_classCallCheck(this,ProjectGoalEditForm);var _this=_possibleConstructorReturn(this,(ProjectGoalEditForm.__proto__||Object.getPrototypeOf(ProjectGoalEditForm)).call(this,props));_this.state={canAdd:false,goalsShow:false};_this._canAddActivities=_this._canAddActivities.bind(_this);_this._addGoal=_this._addGoal.bind(_this);_this._openGoalsModal=_this._openGoalsModal.bind(_this);_this._toggleModal=_this._toggleModal.bind(_this);_this._pageChange=_this._pageChange.bind(_this);return _this;}_createClass(ProjectGoalEditForm,[{key:'_handleSubmit',value:function _handleSubmit(values){var _props2=this.props,modality=_props2.modality,state=_props2.state,municipality=_props2.municipality;this.props.saveRegistry(modality,state,municipality,values);}},{key:'_permissionField',value:function _permissionField(){var registry=this.props.registry;var response=false;var editable=registry.editable;var registryRevision=!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registry.revision)?registry.revision.body:undefined;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(registryRevision)&&!registry.isFetching){var allow=registryRevision.allow_edit==='true'?true:false;if(editable&&allow){response=false;}else{response=true;}}else if(editable&&!registry.isFetching){response=false;}else{response=true;}return response;}},{key:'_openGoalsModal',value:function _openGoalsModal(){this.props.projectProigualdadGoals(this.props.proigualdadGoals.pages.current,this.props.modality,this.props.state,this.props.municipality);return this.setState({goalsShow:true});}},{key:'_pageChange',value:function _pageChange(page){this.props.projectProigualdadGoals(page,this.props.modality,this.props.state,this.props.municipality);}},{key:'_toggleModal',value:function _toggleModal(){return this.setState({goalsShow:!this.state.goalsShow});}},{key:'_addGoal',value:function _addGoal(item){var goals=this.props.goals;var goal=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goals,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(item)});if(goal!==undefined){var repeated=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(this.props.registry.data.project_goals,{proigualdad_goal_id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(goal.id)});if(repeated===undefined){var goalObj={code:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.join([goal.id,goal.type],'.'),geographic_area:undefined,name:goal.name,proigualdad_goal_id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(goal.id),resource_concept_id:undefined,activities:[],total:0,actors:[],conagoClauses:[],mandatory:goal.mandatory};this.props.add('project.registry.data.project_goals',goalObj);return this._canAddActivities();}else{alert('No se pueden duplicar metas');}}else{alert('No pudimos encontrar la meta que deseas agregar');}}},{key:'_canAddActivities',value:function _canAddActivities(value){var goals=this.state.goals;if(goals){var currGoal=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(value!==0?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(value):undefined);var key=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(goals,function(o){return o.id===currGoal;});var canAdd=key===undefined||key<0?false:true;return this.setState({canAdd:canAdd});}}}]);return ProjectGoalEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectGoalEditForm);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_wysiwyg_field__ = __webpack_require__(36);
var ProjectDataForm=function ProjectDataForm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Datos del proyecto'),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.revision)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tag is-'+props.revision.status},props.revision.comment))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'amount',className:'label'},'Monto total de las metas'),props.fetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-spin fa-lg fa-spinner'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title is-5 has-text-right'},!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.data)?Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(props.data.amounts):'$ 0.00'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'+(props.fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del proyecto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{model:'.name',id:'name',className:'input'+(!props.fetching&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.revision)?' is-'+props.revision.status:''),value:props.data&&props.data.name?props.data.name:'',placeholder:'Nombre del Proyecto',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:props.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre del proyecto es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'version_id',className:'label'},'A\xF1o'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.data)&&props.data.agency&&props.data.agency.version?props.data.agency.version.year:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(props.fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'execution_start',className:'label'},'Fecha de ejecuci\xF3n inicial ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{model:'.execution_start',id:'execution_start',value:props.data&&props.data.execution_start?props.data.execution_start:'',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:'change',component:__WEBPACK_IMPORTED_MODULE_5__forms_datepicker__["a" /* default */],className:'input'+(!props.fetching&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.revision)?' is-'+props.revision.status:''),disabled:props.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'.execution_start',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(props.fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'execution_end',className:'label'},'Fecha de ejecuci\xF3n final ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{model:'.execution_end',value:props.data&&props.data.execution_end?props.data.execution_end:'',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:'change',id:'execution_end',component:__WEBPACK_IMPORTED_MODULE_5__forms_datepicker__["a" /* default */],className:'input'+(!props.fetching&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.revision)?' is-'+props.revision.status:''),disabled:props.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'.execution_end',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.data)&&props.data.code&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(props.fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'code',className:'label'},'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{model:'.code',type:'number',className:'input'+(!props.fetching&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.revision)?' is-'+props.revision.status:''),placeholder:'000',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(props.fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Entidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.data&&props.data.agency?props.data.agency.agenciable.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(props.fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.data)&&props.data.agency?props.data.agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'+(props.fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective',className:'label'},'Objetivos ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].textarea,{model:'.objective',component:__WEBPACK_IMPORTED_MODULE_6__forms_wysiwyg_field__["a" /* default */],className:!props.fetching&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.revision)?'is-'+props.revision.status:'',id:'objective',placeholder:'Objetivos del proyecto',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:'change',readOnly:props.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'.objective',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Los objectivos del proyecto son obligatorios'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'+(props.fetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'justification',className:'label'},'Justificaci\xF3n',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].textarea,{model:'.justification',component:__WEBPACK_IMPORTED_MODULE_6__forms_wysiwyg_field__["a" /* default */],className:!props.fetching&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(props.revision)?'is-'+props.revision.status:'',id:'justification',placeholder:'Justificaci\xF3n del proyecto',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:'change',readOnly:props.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'.justification',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La justificación del proyecto es obligatorio'}}))));};/* harmony default export */ __webpack_exports__["a"] = (ProjectDataForm);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={isDisabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,modality:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,goals:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,canAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,goalAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var defaultProps={isDisabled:true,fetching:false};var GoalSelectorWidget=function(_Component){_inherits(GoalSelectorWidget,_Component);function GoalSelectorWidget(){_classCallCheck(this,GoalSelectorWidget);return _possibleConstructorReturn(this,(GoalSelectorWidget.__proto__||Object.getPrototypeOf(GoalSelectorWidget)).apply(this,arguments));}_createClass(GoalSelectorWidget,[{key:'render',value:function render(){var _this2=this;var _props=this.props,isDisabled=_props.isDisabled,goals=_props.goals,fetching=_props.fetching;!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goals)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(goals,['name']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Selecci\xF3n de metas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-fullwidth project-goal-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'goal',ref:'goalsSelect',onChange:function onChange(){return _this2.updateAddGoalState();},disabled:isDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0',defaultValue:true},'--- Selecciona una meta ---'),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goals)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(goals,function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id},option.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'+fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this2.addGoalToList();},disabled:isDisabled},'Agregar Meta')))));}},{key:'updateAddGoalState',value:function updateAddGoalState(){this.props.canAdd(this.refs.goalsSelect.value);}},{key:'addGoalToList',value:function addGoalToList(){this.props.goalAdd(this.refs.goalsSelect.value);return this.refs.goalsSelect.value=0;}}]);return GoalSelectorWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GoalSelectorWidget.propTypes=propTypes;GoalSelectorWidget.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (GoalSelectorWidget);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_inmPagination__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalsModal=function(_Component){_inherits(GoalsModal,_Component);_createClass(GoalsModal,[{key:"render",value:function render(){var _props=this.props,proigualdad=_props.proigualdad,pages=_props.pages,active=_props.active,modality=_props.modality,state=_props.state,municipality=_props.municipality,fetching=_props.fetching,closeModal=_props.closeModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:function onClick(){return closeModal();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Metas de la instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return closeModal();},className:"delete is-medium","aria-label":"delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:"/proyecto/"+modality+"/proigualdad-meta/crear/"+state+(municipality?"/"+municipality:''),className:"button is-small is-inm-purple"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-plus"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Agregar Meta")))),fetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loading__["a" /* default */],{message:"Cargando..."}):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table",key:"proigualdad-goals-list-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"C\xF3digo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Meta"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(proigualdad)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(proigualdad,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell",style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.code?row.code:row.id+"."+row.type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.name));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2,className:"has-text-centered"},"No hay metas creadas")))),pages.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_inmPagination__["a" /* default */],{key:"concepts-pages",current:pages.current,total:pages.total,perPage:10,nextPage:this._handlePageChange})]))));}}]);function GoalsModal(props){_classCallCheck(this,GoalsModal);var _this=_possibleConstructorReturn(this,(GoalsModal.__proto__||Object.getPrototypeOf(GoalsModal)).call(this,props));_this._handlePageChange=_this._handlePageChange.bind(_this);return _this;}_createClass(GoalsModal,[{key:"_handlePageChange",value:function _handlePageChange(value){this.props.pageChange(value);}}]);return GoalsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GoalsModal);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__project_conago_modal_widget__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__project_muns_modal_widget__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__project_actors_modal_widget__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__activities__ = __webpack_require__(150);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={goals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired};var ModIProject=function(_Component){_inherits(ModIProject,_Component);_createClass(ModIProject,[{key:'render',value:function render(){var _this2=this;var _props=this.props,goals=_props.goals,allgoals=_props.allgoals,resources=_props.resources,revision=_props.revision,directories=_props.directories,municipalities=_props.municipalities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Fieldset"],{model:'project.registry.data.project_goals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__project_muns_modal_widget__["a" /* default */],{show:this.state.modalShow,active:this.state.modalShow,closeModal:this._toggleModal,selectedMuns:this.state.selectedGoal!==undefined?goals[this.state.selectedGoal].agencies:undefined,selectedGoal:this.state.selectedGoal,modality:1,muns:municipalities,add:this.props.add,remove:this.props.remove,conclusion:this.state.canEdit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__project_conago_modal_widget__["a" /* default */],{active:this.state.conagoShow,closeModal:this._toggleConagoModal,selectedConago:this.state.selectedGoal!==undefined?goals[this.state.selectedGoal].conago_clauses:undefined,selectedGoal:this.state.selectedGoal,conagoClauses:directories.conago,fetching:directories.isFetching,add:this.props.add,remove:this.props.remove,conclusion:this.state.canEdit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__project_actors_modal_widget__["a" /* default */],{fetching:directories.isFetching,active:this.state.actorsShow,closeModal:this._toggleActorsModal,selectedActors:this.state.selectedGoal!==undefined?goals[this.state.selectedGoal].actors:undefined,selectedGoal:this.state.selectedGoal,actors:directories.actors,add:this.props.add,remove:this.props.remove,conclusion:this.state.canEdit}),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goals)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Acciones'))),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(goals,function(goal,k){var goalRevision=revision?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(revision,{id:goal.proigualdad_goal_id}):undefined;var goalTrashDisabled=_this2._permissionField()&&goalRevision?Boolean(goal.mandatory)||(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goalRevision.activities,{allow_edit:'true'})===undefined?true:false)||(goalRevision.allow_edit==='true'?false:true):_this2._permissionField()?Boolean(goal.mandatory):true;var goalDisabled=_this2._permissionField()&&goalRevision?goalRevision.allow_edit==='true'?false:true:_this2._permissionField()?false:true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:3,className:'goal-cell'+(goalRevision?' is-'+goalRevision.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,goal.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,goal.name,goal.mandatory===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-primary is-small'},'Esta meta es obligatoria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),goalRevision&&goalRevision.comment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'tag is-'+goalRevision.status},goalRevision.comment)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'amount'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(goal.total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._removeGoal(goal,k,_this2.props.projectTotal);},disabled:goalTrashDisabled,className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small'+(goalRevision&&goalRevision.status?' is-'+goalRevision.status:' is-dark')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].select,{model:'['+k+'].resource_concept_id',id:'goal-rc-'+goal.proigualdad_goal_id,parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},validateOn:'change',disabled:goalDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,defaultValue:true},'--- Conceptos de gasto ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(resources.list,function(res,t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:res.id,key:t},res.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'['+k+'].resource_concept_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes indicar el concepto de gasto.'}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-small is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'.['+k+']is_continuing',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].checkbox,{model:'.['+k+']is_continuing',id:'.['+k+']is_continuing',className:'checkbox',isToggle:true,disabled:goalDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Meta de continuidad'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this2._openConagoModal(k,goal.conago_clauses,goalDisabled);}},'Metas CONAGO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.conago_clauses))),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.conago_clauses)<=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-danger'},'Debes elegir al menos una meta CONAGO'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this2._openActorsModal(k,goal.actors,goalDisabled);}},'Actores estrat\xE9gicos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.actors)))),goal.geographic_area==='Municipios'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this2._openMunModal(k,goal,goalDisabled);}},'Seleccionar municipios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.agencies))),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.agencies)===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-danger is-small'},'Seleccionar municipios participantes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-dark is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].select,{model:'['+k+'].geographic_area',id:'goal-ga-'+goal.proigualdad_goal_id,ref:'goal-ga-'+goal.proigualdad_goal_id,errors:{isRequired:__WEBPACK_IMPORTED_MODULE_6__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:goalDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Area geogr\xE1fica ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Estatal'},'Estatal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Municipios'},'Municipios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Todos los municipios'},'Todos los municipios'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'['+k+'].geographic_area',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Seleccionar area geográfica'}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__activities__["a" /* default */],{goal:goal,disabled:goalDisabled,goals:goals,add:_this2.props.add,change:_this2.props.change,activities:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(allgoals,{id:goal.proigualdad_goal_id})}))),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goal.project_goal_activities)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-activity-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Medio de verificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(goal.project_goal_activities,function(act,j){var actRevision=goalRevision?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goalRevision.activities,{id:act.proigualdad_activity_id}):undefined;var activityTrashDisabled=_this2._permissionField()&&actRevision?Boolean(act.mandatory)||(actRevision.allow_edit==='true'?false:true):_this2._permissionField()?Boolean(act.mandatory):true;var activityDisabled=_this2._permissionField()&&actRevision?actRevision.allow_edit==='true'?false:true:_this2._permissionField()?false:true;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:j},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:actRevision&&actRevision.comment?2:1,className:actRevision&&actRevision.status?'has-text-centered is-'+actRevision.status:'has-text-centered'},act.proigualdad_activity_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,act.name,act.mandatory===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-primary'},'Esta actividad es obligatoria')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},act.allow_edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{model:'project.registry.data.project_goals['+k+'].project_goal_activities['+j+'].quantity',type:'number',min:1,step:1,className:'input',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */],minValue:Object(__WEBPACK_IMPORTED_MODULE_6__field_validations__["j" /* minValue */])(1)},validateOn:'change',changeAction:function changeAction(model,value){return _this2._editActivity(k,j,value,act.amount,goal);},style:{width:'40%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'project.registry.data.project_goals['+k+'].project_goal_activities['+j+'].quantity',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Cantidad Obligatoria',minValue:'Minimo no admitido.'}})):act.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right amount'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(act.total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},act.verification_media?act.verification_media.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},act.allow_edit?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:function onClick(){return _this2.props.change('project.registry.data.project_goals['+k+'].project_goal_activities['+j+']',Object.assign({},act,{allow_edit:true}));},disabled:activityDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),act.allow_edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-success',type:'button',onClick:function onClick(){return _this2.props.change('project.registry.data.project_goals['+k+'].project_goal_activities['+j+']',Object.assign({},act,{allow_edit:false}));},disabled:activityDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this2._removeActivity(act,j,goal,k,_this2.props.projectTotal);},disabled:activityTrashDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})))))),actRevision&&actRevision.comment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'act-'+j+'-comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Comentarios: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag '+(actRevision&&actRevision.status?'is-'+actRevision.status:'')},actRevision.comment))))];}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4,className:'has-text-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Debes agregar por lo menos una actividad'))));})));}}]);function ModIProject(props){_classCallCheck(this,ModIProject);var _this=_possibleConstructorReturn(this,(ModIProject.__proto__||Object.getPrototypeOf(ModIProject)).call(this,props));_this.state={modalShow:false,conagoShow:false,actorsShow:false,goalMuns:[],goalConago:[],goalActors:[],selectedGoal:undefined,canEdit:false};_this._toggleModal=_this._toggleModal.bind(_this);_this._toggleConagoModal=_this._toggleConagoModal.bind(_this);_this._toggleActorsModal=_this._toggleActorsModal.bind(_this);return _this;}_createClass(ModIProject,[{key:'_toggleModal',value:function _toggleModal(){return this.setState({modalShow:!this.state.modalShow});}},{key:'_toggleConagoModal',value:function _toggleConagoModal(){return this.setState({conagoShow:!this.state.conagoShow});}},{key:'_toggleActorsModal',value:function _toggleActorsModal(){return this.setState({actorsShow:!this.state.actorsShow});}},{key:'_removeActivity',value:function _removeActivity(activity,activityIndex,goal,goalIndex,total){if(activity.mandatory===0){this.props.remove('project.registry.data.project_goals['+goalIndex+'].project_goal_activities',activityIndex);this.props.change('project.registry.data.project_goals['+goalIndex+'].total',goal.total-activity.total);this.props.change('project.registry.data.amounts',total-activity.total);}else{alert('Esta actividad es obligatoria y no se puede eliminar');}}},{key:'_removeGoal',value:function _removeGoal(goal,goalIndex,total){var _this3=this;if(goal.mandatory===0){Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({title:'¿Esta seguro?',message:'Al eliminarse la meta, se eliminará toda información y actividades vinculadas.',confirmLabel:'Eliminar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){_this3.props.change('project.registry.data.amounts',total-goal.total);_this3.props.remove('project.registry.data.project_goals',goalIndex);}});}}},{key:'_openMunModal',value:function _openMunModal(goalIndex,goal,disable){var _props2=this.props,state=_props2.state,entities=_props2.entities;var entity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(entities,{short:state});this.props.fetchMunicipalities(entity.id);return this.setState({modalShow:true,goalMuns:goal.agencies,selectedGoal:goalIndex,canEdit:disable});}},{key:'_openConagoModal',value:function _openConagoModal(index,conagoList,disable){return this.setState({conagoShow:true,goalConago:conagoList,selectedGoal:index,canEdit:disable});}},{key:'_openActorsModal',value:function _openActorsModal(index,actorsList,disable){return this.setState({actorsShow:true,goalActors:actorsList,selectedGoal:index,canEdit:disable});}},{key:'_editActivity',value:function _editActivity(goalIndex,activityIndex,quantity,amount,goal){if(quantity>0){this.props.change('project.registry.data.project_goals['+goalIndex+'].total',goal.total+quantity*amount);this.props.change('project.registry.data.project_goals['+goalIndex+'].project_goal_activities['+activityIndex+'].total',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(quantity*amount));this.props.change('project.registry.data.project_goals['+goalIndex+'].project_goal_activities['+activityIndex+'].quantity',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(quantity));}}},{key:'_permissionField',value:function _permissionField(){return this.props.editable;}}]);return ModIProject;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModIProject.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ModIProject);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConagoModal=function(_Component){_inherits(ConagoModal,_Component);function ConagoModal(){_classCallCheck(this,ConagoModal);return _possibleConstructorReturn(this,(ConagoModal.__proto__||Object.getPrototypeOf(ConagoModal)).apply(this,arguments));}_createClass(ConagoModal,[{key:"render",value:function render(){var _this2=this;var _props=this.props,conclusion=_props.conclusion,conagoClauses=_props.conagoClauses,closeModal=_props.closeModal,fetching=_props.fetching,selectedConago=_props.selectedConago,selectedGoal=_props.selectedGoal;console.log('GOAL =====> ',selectedGoal);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:function onClick(){return closeModal();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Seleccione las metas que aplican"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return closeModal();},className:"delete is-medium","aria-label":"delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},fetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__loading__["a" /* default */],{message:"Cargando Metas CONAGO..."}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline conago-checkboxes"},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(conagoClauses,function(conago,k){var selectedIndex=undefined;var shouldCheck=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findKey(selectedConago,function(o,sel){if(o.id===conago.id){selectedIndex=sel;return true;}})!==undefined?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"conago-"+conago.id,className:"checkbox",disabled:conclusion},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"conago-"+conago.id,ref:"g-conago-"+conago.id,value:conago.id,type:"checkbox",checked:shouldCheck,className:"checkbox",onChange:function onChange(){return _this2._saveConago(conago.id,conago,selectedIndex);},disabled:conclusion}),conago.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-info",type:"button",onClick:function onClick(){return _this2.props.closeModal;}},"Cerrar")))))));}},{key:"_saveConago",value:function _saveConago(id,conago,index){if(this.refs["g-conago-"+id].checked){this.props.add("project.registry.data.project_goals["+this.props.selectedGoal+"].conago_clauses",conago);}else{console.log('INDEX OF CONAGO ====>',index);this.props.remove("project.registry.data.project_goals["+this.props.selectedGoal+"].conago_clauses",index);}}}]);return ConagoModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ConagoModal);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__project_actors_modal_widget__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__activities__ = __webpack_require__(150);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={goals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired};var ModIIProject=function(_Component){_inherits(ModIIProject,_Component);_createClass(ModIIProject,[{key:'render',value:function render(){var _this2=this;var _props=this.props,goals=_props.goals,allgoals=_props.allgoals,resources=_props.resources,revision=_props.revision,directories=_props.directories;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Fieldset"],{model:'project.registry.data.project_goals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__project_actors_modal_widget__["a" /* default */],{fetching:directories.isFetching,active:this.state.actorsShow,closeModal:this._toggleActorsModal,selectedActors:this.state.selectedGoal!==undefined?goals[this.state.selectedGoal].actors:undefined,selectedGoal:this.state.selectedGoal,actors:directories.actors,add:this.props.add,remove:this.props.remove,conclusion:this.state.canEdit}),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goals)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Acciones'))),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(goals,function(goal,k){var goalRevision=revision?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(revision,{id:goal.proigualdad_goal_id}):undefined;var goalTrashDisabled=_this2._permissionField()&&goalRevision?Boolean(goal.mandatory)||(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goalRevision.activities,{allow_edit:'true'})===undefined?true:false)||(goalRevision.allow_edit==='true'?false:true):_this2._permissionField()?Boolean(goal.mandatory):true;var goalDisabled=_this2._permissionField()&&goalRevision?goalRevision.allow_edit==='true'?false:true:_this2._permissionField()?false:true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:3,className:'goal-cell'+(goalRevision?' is-'+goalRevision.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,goal.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,goal.name,goal.mandatory===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-primary is-small'},'Esta meta es obligatoria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),goalRevision&&goalRevision.comment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'tag is-'+goalRevision.status},goalRevision.comment)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'amount'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(goal.total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._removeGoal(goal,k,_this2.props.projectTotal);},disabled:goalTrashDisabled,className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small'+(goalRevision&&goalRevision.status?' is-'+goalRevision.status:' is-dark')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].select,{model:'['+k+'].resource_concept_id',id:'goal-rc-'+goal.proigualdad_goal_id,parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},validateOn:'change',disabled:goalDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,defaultValue:true},'--- Conceptos de gasto ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(resources.list,function(res,t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:res.id,key:t},res.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'['+k+'].resource_concept_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes indicar el concepto de gasto.'}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-small is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'.['+k+']is_continuing',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].checkbox,{model:'.['+k+']is_continuing',id:'.['+k+']is_continuing',className:'checkbox',isToggle:true,disabled:goalDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Meta de continuidad'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this2._openActorsModal(k,goal.actors,goalDisabled);}},'Actores estrat\xE9gicos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.actors))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__activities__["a" /* default */],{goal:goal,disabled:goalDisabled,goals:goals,add:_this2.props.add,change:_this2.props.change,activities:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(allgoals,{id:goal.proigualdad_goal_id})}))),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goal.project_goal_activities)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-activity-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Medio de verificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(goal.project_goal_activities,function(act,j){var actRevision=goalRevision?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goalRevision.activities,{id:act.proigualdad_activity_id}):undefined;var activityTrashDisabled=_this2._permissionField()&&actRevision?Boolean(act.mandatory)||(actRevision.allow_edit==='true'?false:true):_this2._permissionField()?Boolean(act.mandatory):true;var activityDisabled=_this2._permissionField()&&actRevision?actRevision.allow_edit==='true'?false:true:_this2._permissionField()?false:true;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:j},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:actRevision&&actRevision.comment?2:1,className:actRevision&&actRevision.status?'has-text-centered is-'+actRevision.status:'has-text-centered'},act.proigualdad_activity_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,act.name,act.mandatory===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-primary'},'Esta actividad es obligatoria')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},act.allow_edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{model:'project.registry.data.project_goals['+k+'].project_goal_activities['+j+'].quantity',type:'number',min:1,step:1,className:'input',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */],minValue:Object(__WEBPACK_IMPORTED_MODULE_6__field_validations__["j" /* minValue */])(1)},validateOn:'change',changeAction:function changeAction(model,value){return _this2._editActivity(k,j,value,act.amount,goal);},style:{width:'40%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'project.registry.data.project_goals['+k+'].project_goal_activities['+j+'].quantity',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Cantidad Obligatoria',minValue:'Minimo no admitido.'}})):act.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right amount'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(act.total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},act.verification_media?act.verification_media.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},act.allow_edit?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:function onClick(){return _this2.props.change('project.registry.data.project_goals['+k+'].project_goal_activities['+j+']',Object.assign({},act,{allow_edit:true}));},disabled:activityDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),act.allow_edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-success',type:'button',onClick:function onClick(){return _this2.props.change('project.registry.data.project_goals['+k+'].project_goal_activities['+j+']',Object.assign({},act,{allow_edit:false}));},disabled:activityDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this2._removeActivity(act,j,goal,k,_this2.props.projectTotal);},disabled:activityTrashDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})))))),actRevision&&actRevision.comment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'act-'+j+'-comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Comentarios: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag '+(actRevision&&actRevision.status?'is-'+actRevision.status:'')},actRevision.comment))))];}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4,className:'has-text-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Debes agregar por lo menos una actividad'))));})));}}]);function ModIIProject(props){_classCallCheck(this,ModIIProject);var _this=_possibleConstructorReturn(this,(ModIIProject.__proto__||Object.getPrototypeOf(ModIIProject)).call(this,props));_this.state={modalShow:false,conagoShow:false,actorsShow:false,goalMuns:[],goalConago:[],goalActors:[],selectedGoal:undefined,canEdit:false};_this._toggleModal=_this._toggleModal.bind(_this);_this._toggleConagoModal=_this._toggleConagoModal.bind(_this);_this._toggleActorsModal=_this._toggleActorsModal.bind(_this);return _this;}_createClass(ModIIProject,[{key:'_toggleModal',value:function _toggleModal(){return this.setState({modalShow:!this.state.modalShow});}},{key:'_toggleConagoModal',value:function _toggleConagoModal(){return this.setState({conagoShow:!this.state.conagoShow});}},{key:'_toggleActorsModal',value:function _toggleActorsModal(){return this.setState({actorsShow:!this.state.actorsShow});}},{key:'_removeActivity',value:function _removeActivity(activity,activityIndex,goal,goalIndex,total){if(activity.mandatory===0){this.props.remove('project.registry.data.project_goals['+goalIndex+'].project_goal_activities',activityIndex);this.props.change('project.registry.data.project_goals['+goalIndex+'].total',goal.total-activity.total);this.props.change('project.registry.data.amounts',total-activity.total);}else{alert('Esta actividad es obligatoria y no se puede eliminar');}}},{key:'_removeGoal',value:function _removeGoal(goal,goalIndex,total){var _this3=this;if(goal.mandatory===0){Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({title:'¿Esta seguro?',message:'Al eliminarse la meta, se eliminará toda información y actividades vinculadas.',confirmLabel:'Eliminar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){_this3.props.change('project.registry.data.amounts',total-goal.total);_this3.props.remove('project.registry.data.project_goals',goalIndex);}});}}},{key:'_openMunModal',value:function _openMunModal(goalIndex,goal,disable){var _props2=this.props,state=_props2.state,entities=_props2.entities;var entity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(entities,{short:state});this.props.fetchMunicipalities(entity.id);return this.setState({modalShow:true,goalMuns:goal.agencies,selectedGoal:goalIndex,canEdit:disable});}},{key:'_openConagoModal',value:function _openConagoModal(index,conagoList,disable){return this.setState({conagoShow:true,goalConago:conagoList,selectedGoal:index,canEdit:disable});}},{key:'_openActorsModal',value:function _openActorsModal(index,actorsList,disable){return this.setState({actorsShow:true,goalActors:actorsList,selectedGoal:index,canEdit:disable});}},{key:'_editActivity',value:function _editActivity(goalIndex,activityIndex,quantity,amount,goal){if(quantity>0){this.props.change('project.registry.data.project_goals['+goalIndex+'].total',goal.total+quantity*amount);this.props.change('project.registry.data.project_goals['+goalIndex+'].project_goal_activities['+activityIndex+'].total',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(quantity*amount));this.props.change('project.registry.data.project_goals['+goalIndex+'].project_goal_activities['+activityIndex+'].quantity',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(quantity));}}},{key:'_permissionField',value:function _permissionField(){return this.props.editable;}}]);return ModIIProject;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModIIProject.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ModIIProject);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__project_muns_modal_widget__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__project_actors_modal_widget__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__activities__ = __webpack_require__(150);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={goals:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired};var ModIIIProject=function(_Component){_inherits(ModIIIProject,_Component);_createClass(ModIIIProject,[{key:'render',value:function render(){var _this2=this;var _props=this.props,goals=_props.goals,allgoals=_props.allgoals,resources=_props.resources,revision=_props.revision,directories=_props.directories,municipalities=_props.municipalities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Fieldset"],{model:'project.registry.data.project_goals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__project_muns_modal_widget__["a" /* default */],{show:this.state.modalShow,active:this.state.modalShow,closeModal:this._toggleModal,selectedMuns:this.state.selectedGoal!==undefined?goals[this.state.selectedGoal].agencies:undefined,selectedGoal:this.state.selectedGoal,modality:1,muns:municipalities,add:this.props.add,remove:this.props.remove,conclusion:this.state.canEdit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__project_actors_modal_widget__["a" /* default */],{fetching:directories.isFetching,active:this.state.actorsShow,closeModal:this._toggleActorsModal,selectedActors:this.state.selectedGoal!==undefined?goals[this.state.selectedGoal].actors:undefined,selectedGoal:this.state.selectedGoal,actors:directories.actors,add:this.props.add,remove:this.props.remove,conclusion:this.state.canEdit}),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goals)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Acciones'))),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(goals,function(goal,k){var goalRevision=revision?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(revision,{id:goal.proigualdad_goal_id}):undefined;var goalTrashDisabled=_this2._permissionField()&&goalRevision?Boolean(goal.mandatory)||(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goalRevision.activities,{allow_edit:'true'})===undefined?true:false)||(goalRevision.allow_edit==='true'?false:true):_this2._permissionField()?Boolean(goal.mandatory):true;var goalDisabled=_this2._permissionField()&&goalRevision?goalRevision.allow_edit==='true'?false:true:_this2._permissionField()?false:true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:3,className:'goal-cell'+(goalRevision?' is-'+goalRevision.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,goal.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,goal.name,goal.mandatory===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-primary is-small'},'Esta meta es obligatoria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),goalRevision&&goalRevision.comment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'tag is-'+goalRevision.status},goalRevision.comment)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'amount'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(goal.total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._removeGoal(goal,k,_this2.props.projectTotal);},disabled:goalTrashDisabled,className:'button is-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-small'+(goalRevision&&goalRevision.status?' is-'+goalRevision.status:' is-dark')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].select,{model:'['+k+'].resource_concept_id',id:'goal-rc-'+goal.proigualdad_goal_id,parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["c" /* toInt */],errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},validateOn:'change',disabled:goalDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,defaultValue:true},'--- Conceptos de gasto ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(resources.list,function(res,t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:res.id,key:t},res.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'['+k+'].resource_concept_id',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debes indicar el concepto de gasto.'}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-small is-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'.['+k+']is_continuing',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].checkbox,{model:'.['+k+']is_continuing',id:'.['+k+']is_continuing',className:'checkbox',isToggle:true,disabled:goalDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},' Meta de continuidad'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this2._openActorsModal(k,goal.actors,goalDisabled);}},'Actores estrat\xE9gicos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.actors)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer'},className:'tag is-medium is-light',onClick:function onClick(){return _this2._openMunModal(k,goal,goalDisabled);}},'Seleccionar municipios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-white'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.agencies))),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.agencies)===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-danger is-small'},'Seleccionar municipios participantes')),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.agencies)>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-dark'},'Gasto por CDM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag is-medium is-inm-purple'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(goal.total/__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(goal.agencies)))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__activities__["a" /* default */],{goal:goal,disabled:goalDisabled,goals:goals,add:_this2.props.add,change:_this2.props.change,activities:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(allgoals,{id:goal.proigualdad_goal_id})}))),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(goal.project_goal_activities)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-activity-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Medio de verificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-right'},'Acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(goal.project_goal_activities,function(act,j){var actRevision=goalRevision?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(goalRevision.activities,{id:act.proigualdad_activity_id}):undefined;var activityTrashDisabled=_this2._permissionField()&&actRevision?Boolean(act.mandatory)||(actRevision.allow_edit==='true'?false:true):_this2._permissionField()?Boolean(act.mandatory):true;var activityDisabled=_this2._permissionField()&&actRevision?actRevision.allow_edit==='true'?false:true:_this2._permissionField()?false:true;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:j},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:actRevision&&actRevision.comment?2:1,className:actRevision&&actRevision.status?'has-text-centered is-'+actRevision.status:'has-text-centered'},act.proigualdad_activity_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,act.name,act.mandatory===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help is-primary'},'Esta actividad es obligatoria')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},act.allow_edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{model:'project.registry.data.project_goals['+k+'].project_goal_activities['+j+'].quantity',type:'number',min:1,step:1,className:'input',errors:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */],minValue:Object(__WEBPACK_IMPORTED_MODULE_6__field_validations__["j" /* minValue */])(1)},validateOn:'change',changeAction:function changeAction(model,value){return _this2._editActivity(k,j,value,act.amount,goal);},style:{width:'40%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Errors"],{model:'project.registry.data.project_goals['+k+'].project_goal_activities['+j+'].quantity',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Cantidad Obligatoria',minValue:'Minimo no admitido.'}})):act.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right amount'},Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(act.total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},act.verification_media?act.verification_media.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},act.allow_edit?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:function onClick(){return _this2.props.change('project.registry.data.project_goals['+k+'].project_goal_activities['+j+']',Object.assign({},act,{allow_edit:true}));},disabled:activityDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),act.allow_edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-success',type:'button',onClick:function onClick(){return _this2.props.change('project.registry.data.project_goals['+k+'].project_goal_activities['+j+']',Object.assign({},act,{allow_edit:false}));},disabled:activityDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this2._removeActivity(act,j,goal,k,_this2.props.projectTotal);},disabled:activityTrashDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})))))),actRevision&&actRevision.comment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'act-'+j+'-comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Comentarios: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag '+(actRevision&&actRevision.status?'is-'+actRevision.status:'')},actRevision.comment))))];}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4,className:'has-text-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Debes agregar por lo menos una actividad'))));})));}}]);function ModIIIProject(props){_classCallCheck(this,ModIIIProject);var _this=_possibleConstructorReturn(this,(ModIIIProject.__proto__||Object.getPrototypeOf(ModIIIProject)).call(this,props));_this.state={modalShow:false,conagoShow:false,actorsShow:false,goalMuns:[],goalConago:[],goalActors:[],selectedGoal:undefined,canEdit:false};_this._toggleModal=_this._toggleModal.bind(_this);_this._toggleConagoModal=_this._toggleConagoModal.bind(_this);_this._toggleActorsModal=_this._toggleActorsModal.bind(_this);return _this;}_createClass(ModIIIProject,[{key:'_toggleModal',value:function _toggleModal(){return this.setState({modalShow:!this.state.modalShow});}},{key:'_toggleConagoModal',value:function _toggleConagoModal(){return this.setState({conagoShow:!this.state.conagoShow});}},{key:'_toggleActorsModal',value:function _toggleActorsModal(){return this.setState({actorsShow:!this.state.actorsShow});}},{key:'_removeActivity',value:function _removeActivity(activity,activityIndex,goal,goalIndex,total){if(activity.mandatory===0){this.props.remove('project.registry.data.project_goals['+goalIndex+'].project_goal_activities',activityIndex);this.props.change('project.registry.data.project_goals['+goalIndex+'].total',goal.total-activity.total);this.props.change('project.registry.data.amounts',total-activity.total);}else{alert('Esta actividad es obligatoria y no se puede eliminar');}}},{key:'_removeGoal',value:function _removeGoal(goal,goalIndex,total){var _this3=this;if(goal.mandatory===0){Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({title:'¿Esta seguro?',message:'Al eliminarse la meta, se eliminará toda información y actividades vinculadas.',confirmLabel:'Eliminar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){_this3.props.change('project.registry.data.amounts',total-goal.total);_this3.props.remove('project.registry.data.project_goals',goalIndex);}});}}},{key:'_openMunModal',value:function _openMunModal(goalIndex,goal,disable){var _props2=this.props,state=_props2.state,entities=_props2.entities;var entity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(entities,{short:state});this.props.fetchMunicipalities(entity.id);return this.setState({modalShow:true,goalMuns:goal.agencies,selectedGoal:goalIndex,canEdit:disable});}},{key:'_openConagoModal',value:function _openConagoModal(index,conagoList,disable){return this.setState({conagoShow:true,goalConago:conagoList,selectedGoal:index,canEdit:disable});}},{key:'_openActorsModal',value:function _openActorsModal(index,actorsList,disable){return this.setState({actorsShow:true,goalActors:actorsList,selectedGoal:index,canEdit:disable});}},{key:'_editActivity',value:function _editActivity(goalIndex,activityIndex,quantity,amount,goal){if(quantity>0){this.props.change('project.registry.data.project_goals['+goalIndex+'].total',goal.total+quantity*amount);this.props.change('project.registry.data.project_goals['+goalIndex+'].project_goal_activities['+activityIndex+'].total',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(quantity*amount));this.props.change('project.registry.data.project_goals['+goalIndex+'].project_goal_activities['+activityIndex+'].quantity',__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(quantity));}}},{key:'_permissionField',value:function _permissionField(){return this.props.editable;}}]);return ModIIIProject;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModIIIProject.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ModIIIProject);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_project_goal__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_project_widgets_goals_add__ = __webpack_require__(255);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalCreate=function(_Component){_inherits(GoalCreate,_Component);function GoalCreate(){_classCallCheck(this,GoalCreate);return _possibleConstructorReturn(this,(GoalCreate.__proto__||Object.getPrototypeOf(GoalCreate)).apply(this,arguments));}_createClass(GoalCreate,[{key:'render',value:function render(){var project=this.props.project;return project.goals.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_project_goal__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,goal=_props$match$params.goal,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.projectProigualdadGoalsEdit(goal,modality,state,municipality);}}]);return GoalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(GoalCreate,{title:"Crear Meta",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_project_widgets_goals_add__["a" /* default */],null)}]}}));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_project_goal__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_project_widgets_goals_add__ = __webpack_require__(255);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalCreate=function(_Component){_inherits(GoalCreate,_Component);function GoalCreate(){_classCallCheck(this,GoalCreate);return _possibleConstructorReturn(this,(GoalCreate.__proto__||Object.getPrototypeOf(GoalCreate)).apply(this,arguments));}_createClass(GoalCreate,[{key:'render',value:function render(){var project=this.props.project;return project.goals.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_project_goal__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,goal=_props$match$params.goal,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.projectProigualdadGoalsEdit(goal,modality,state,municipality);}}]);return GoalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(GoalCreate,{title:"Editar Meta",subnav:{icon:'fa-flag-checkered',name:'Proigualdad',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_project_widgets_goals_add__["a" /* default */],null)}]}}));

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_project__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_project_profiles__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Profiles=function(_Component){_inherits(Profiles,_Component);function Profiles(){_classCallCheck(this,Profiles);return _possibleConstructorReturn(this,(Profiles.__proto__||Object.getPrototypeOf(Profiles)).apply(this,arguments));}_createClass(Profiles,[{key:'render',value:function render(){var project=this.props.project;return project.profiles.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando Datos adicionales...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_project_profiles__["a" /* default */],{profiles:project.profiles,permissions:project.permissions,match:this.props.match,loadFormData:this.props.loadFormData,history:this.props.history,setSystemNotification:this.props.setSystemNotification,projectEmployeeSave:this.props.projectEmployeeSave});}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.projectEmployees(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.location.pathname!==this.props.location.pathname){this.props.projectEmployees(modality,state,municipality);}}}]);return Profiles;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_project__["a" /* default */])(Profiles,{subnav:5}));

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_greeting_select__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={profiles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,permissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,loadFormData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,projectEmployeeSave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var ProfilesEditForm=function(_Component){_inherits(ProfilesEditForm,_Component);function ProfilesEditForm(){_classCallCheck(this,ProfilesEditForm);return _possibleConstructorReturn(this,(ProfilesEditForm.__proto__||Object.getPrototypeOf(ProfilesEditForm)).apply(this,arguments));}_createClass(ProfilesEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,profiles=_props.profiles,permissions=_props.permissions,match=_props.match;var profileRev=profiles.revision?profiles.revision.body:undefined;var pc=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(permissions,function(o){return o==='Create';});var employeesAgency=!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(profiles.data.agency)?profiles.data.agency.employees:[];var employeesProject=!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(profiles.data.employees)?profiles.data.employees:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},profileRev&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(profileRev.comment)&&!profiles.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-'+profileRev.status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},'Comentarios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,profileRev.comment))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Form"],{model:'project.profiles.edit',onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'role_id',className:'label'},'Perfiles ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(profiles.isFetching?' is-loading':'')+(profileRev?' is-'+profileRev.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'roleSelect',id:'role_id',onChange:function onChange(){return _this2._handleChangeRole();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,defaultValue:true},'-- Perfiles --'),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(profiles.data.roles,function(option,key){var registred=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(employeesAgency,{role_id:option.id});if(option.agenciable_type==='cdm'&&match.params.modality==='modalidad-iii'){registred=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(employeesProject,{role_id:option.id,project_goal_agency:{agency_id:option.agency_id}});}//return <option key={key} value={option.id} data-agency={option.agency_id} className={option.registrable === 0 ? 'has-text-danger':''}>{`${option.display}${(option.agency.agenciable && option.agency.agenciable.name ? ` ${option.agency.agenciable.name}`:'')}`}</option>;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id,'data-type':option.agenciable_type,'data-agency':option.agency_id,className:registred===undefined?'has-text-danger':''},''+option.display+(match.params.modality==='modalidad-iii'&&option.agenciable_type==='cdm'&&option.agency.agenciable.name?' - '+option.agency.agenciable.name:''));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.roles.role',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debe seleccionar un perfil'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginBottom:'.5em'}},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium'},'Perfiles cargados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-primary'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(employeesAgency)+__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(employeesProject)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginBottom:'.5em'}},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium'},'Perfiles pendientes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-danger'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(profiles.data.roles)-(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(employeesAgency)+__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(employeesProject)))))),profiles.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_loading__["a" /* default */],{message:'Cargando perfil...'}):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'is-5 title',key:'profiles-title',style:{marginTop:'30px'}},'Datos generales'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light',key:'profiles-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'title',className:'label'},'Saludo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(profiles.isFetching?' is-loading':'')+(profileRev?' is-'+profileRev.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"],{model:'.title',id:'title',component:__WEBPACK_IMPORTED_MODULE_8__forms_greeting_select__["a" /* default */],value:profiles.edit&&profiles.edit.title?profiles.edit.title:'',validateOn:'change',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},disabled:this._blockField()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.title',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Debes elegir un saludo'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre(s) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.name',className:'input'+(profileRev?' is-'+profileRev.status:''),id:'name',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'last_name',className:'label'},'Primer apellido ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.last_name',className:'input'+(profileRev?' is-'+profileRev.status:''),id:'last_name',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.last_name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El apellido es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'slast_name',className:'label'},'Segundo apellido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.slast_name',className:'input'+(profileRev?' is-'+profileRev.status:''),id:'slast_name',disabled:this._blockField()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'scholarship',className:'label'},'Escolaridad ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.scholarship',id:'scholarship',className:'input'+(profileRev?' is-'+profileRev.status:''),placeholder:'Escolaridad',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.scholarship',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El Nombramiento es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'period_start',className:'label'},'Fecha en que asumi\xF3 cargo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.period_start',id:'period_start',className:'input'+(profileRev?' is-'+profileRev.status:''),errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},component:__WEBPACK_IMPORTED_MODULE_5__forms_datepicker__["a" /* default */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.period_start',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha en la que asumió el cargo es obligatoria. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'period_end',className:'label'},'Fin de gestion '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.period_end',id:'period_end',className:'input'+(profileRev?' is-'+profileRev.status:''),component:__WEBPACK_IMPORTED_MODULE_5__forms_datepicker__["a" /* default */],disabled:this._blockField()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'sex',className:'label'},'Sexo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(profiles.isFetching?' is-loading':'')+(profileRev?' is-'+profileRev.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].select,{model:'.sex',id:'sex',value:profiles.edit&&profiles.edit.sex?profiles.edit.sex:'',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:this._blockField()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Sexo ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'M'},'Mujer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'H'},'Hombre'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.sex',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El sexo es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rfc',className:'label'},'RFC ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.rfc',id:'rfc',className:'input'+(profileRev?' is-'+profileRev.status:''),placeholder:'RFC',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */],isRfc:__WEBPACK_IMPORTED_MODULE_4__field_validations__["e" /* isRfc */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["b" /* allUpper */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.rfc',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El RFC es obligatorio. ',isRfc:'RFC inválido. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'curp',className:'label'},'CURP ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.curp',id:'curp',className:'input'+(profileRev?' is-'+profileRev.status:''),placeholder:'CURP',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */],maxLength:Object(__WEBPACK_IMPORTED_MODULE_4__field_validations__["g" /* maxLength */])(18),isCurp:__WEBPACK_IMPORTED_MODULE_4__field_validations__["b" /* isCurp */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["b" /* allUpper */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.curp',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La CURP es obligatoria. ',maxLength:'CURP inválida. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email',className:'label'},'Email principal',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.email',className:'input'+(profileRev?' is-'+profileRev.status:''),placeholder:'Email principal *',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */],isEmail:__WEBPACK_IMPORTED_MODULE_4__field_validations__["c" /* isEmail */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["a" /* allLower */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.email',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El email es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email_2',className:'label'},'Email secundario '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.email_2',id:'email_2',className:'input'+(profileRev?' is-'+profileRev.status:''),placeholder:'Email secundario',errors:{email:__WEBPACK_IMPORTED_MODULE_4__field_validations__["a" /* email */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_3__parsers__["a" /* allLower */],disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.email_2',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{email:__WEBPACK_IMPORTED_MODULE_4__field_validations__["a" /* email */]}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone',className:'label'},'Tel\xE9fono principal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.telephone',value:profiles.edit&&profiles.edit.telephone?profiles.edit.telephone:'',id:'telephone',className:'input'+(profileRev?' is-'+profileRev.status:''),placeholder:'Tel\xE9fono principal',maxLength:10,errors:{isRequired:__WEBPACK_IMPORTED_MODULE_4__field_validations__["d" /* isRequired */],phoneNumber:__WEBPACK_IMPORTED_MODULE_4__field_validations__["l" /* phoneNumber */]},validateOn:'change',disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.telephone',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El Teléfono es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone_2',className:'label'},'Tel\xE9fono alterno'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].text,{model:'.telephone_2',id:'telephone_2',className:'input'+(profileRev?' is-'+profileRev.status:''),maxLength:10,placeholder:'Tel\xE9fono alterno',errors:{phoneNumber:__WEBPACK_IMPORTED_MODULE_4__field_validations__["l" /* phoneNumber */]},validateOn:'change',disabled:this._blockField()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Errors"],{model:'.telephone_2',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{phoneNumber:__WEBPACK_IMPORTED_MODULE_4__field_validations__["l" /* phoneNumber */]}})))))],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right',style:{marginTop:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',model:'project',className:'button is-large',onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),pc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_form__["Control"].button,{model:'project.profiles',className:'button is-large is-primary',disabled:this._blockField()},'Guardar')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'_handleSubmit',value:function _handleSubmit(values){var selector=this.refs['roleSelect'];var valuesPackage=Object.assign({},values,{role_id:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.toNumber(selector.value)});this.__sendSaveRequest(valuesPackage);}},{key:'__sendSaveRequest',value:function __sendSaveRequest(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.projectEmployeeSave(modality,state,municipality,values);}},{key:'_handleChangeRole',value:function _handleChangeRole(){var selector=this.refs['roleSelect'];if(selector.value){this._loadEmployee(selector.value,selector[selector.selectedIndex].dataset.type,selector[selector.selectedIndex].dataset.agency);}}},{key:'_loadEmployee',value:function _loadEmployee(roleId,type,agency){var _props2=this.props,profiles=_props2.profiles,match=_props2.match;var employee={};if(match.params.modality==='modalidad-iii'&&type==='cdm'){employee=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(profiles.data.employees,{role_id:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.toNumber(roleId),project_goal_agency:{agency_id:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.toNumber(agency)},status_id:1});}else{employee=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(profiles.data.agency.employees,{role_id:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.toNumber(roleId),status_id:1});}var response={agency_id:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.toNumber(agency)};if(employee){__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.mapKeys(employee,function(item,key){response=Object.assign({},response,_defineProperty({},key,item?item:undefined));});}else{response=Object.assign({},response,{title:undefined,name:undefined,last_name:undefined,slast_name:undefined,sex:undefined,curp:undefined,rfc:undefined,scholarship:undefined,email:undefined,email_2:undefined,telephone:undefined,telephone_2:undefined,period_start:undefined,period_end:undefined});}this.props.loadFormData('project.profiles.edit',Object.assign({},response));}},{key:'_blockField',value:function _blockField(){var profiles=this.props.profiles;var response=false;var editable=profiles.editable;var profilesRevision=!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(profiles.revision)?profiles.revision.body:undefined;if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(profilesRevision)&&!profiles.isFetching){var allow=profilesRevision.allow_edit==='true'?true:false;if(editable&&allow){response=false;}else{response=true;}}else if(editable&&!profiles.isFetching){response=false;}else{response=true;}return response;}}]);return ProfilesEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProfilesEditForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ProfilesEditForm);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_project__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_project_expenses__ = __webpack_require__(686);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectExpenses=function(_Component){_inherits(ProjectExpenses,_Component);function ProjectExpenses(){_classCallCheck(this,ProjectExpenses);return _possibleConstructorReturn(this,(ProjectExpenses.__proto__||Object.getPrototypeOf(ProjectExpenses)).apply(this,arguments));}_createClass(ProjectExpenses,[{key:'render',value:function render(){var _props=this.props,project=_props.project,concepts=_props.concepts;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_project_expenses__["a" /* default */],{expenses:project.expenses,concepts:concepts,permissions:project.permissions,match:this.props.match,add:this.props.add,change:this.props.change,remove:this.props.remove,history:this.props.history,setSystemNotification:this.props.setSystemNotification,projectExpensesSave:this.props.projectExpensesSave});}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.projectExpenses(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.location.pathname!==this.props.location.pathname){this.props.projectExpenses(modality,state,municipality);}}}]);return ProjectExpenses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_project__["a" /* default */])(ProjectExpenses,{subnav:4}));

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parsers__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={expenses:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,concepts:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,permissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,projectExpensesSave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var ProjectExpensesEditForm=function(_Component){_inherits(ProjectExpensesEditForm,_Component);_createClass(ProjectExpensesEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,expenses=_props.expenses,permissions=_props.permissions;var totalExpenses=0;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(expenses.data.project_expenses,function(o){return totalExpenses+=o.total;});var pc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Form"],{model:"project.expenses.data",className:"columns is-centered",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},this.state.expenseEditShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExpenseEditModal,Object.assign({expenseIndex:this.state.expenseIndex,active:this.state.expenseEditShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-primary",onClick:function onClick(){return _this2._addExpense();},disabled:expenses.editable&&!expenses.isFetching?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-plus"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Agregar gasto")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth no-margin project-goal-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Concepto del gasto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Unidad de medida"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"has-text-right"},"Valor"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"has-text-right"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Acciones"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,!expenses.isFetching?!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(expenses.data.project_expenses)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(expenses.data.project_expenses,function(row,k){var expensesRevision=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(expenses.revision.body)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expenses.revision.body,{id:row.id}):undefined;var expenseDisable=_this2._blockFields(row.id);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"expenses-table-row-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:expensesRevision?2:1,className:expensesRevision&&expensesRevision.status?"is-"+expensesRevision.status:''},k+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.expense_concept.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.expense_unit.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(row.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(row.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-info",type:"button",onClick:function onClick(){return _this2._editExpense(k,row);},disabled:expenseDisable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-danger",type:"button",onClick:function onClick(){return _this2._removeExpense(k);},disabled:expenseDisable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"})))))),expensesRevision?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"comment-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag "+(expensesRevision.status?"is-"+expensesRevision.status:'')},"Comentarios: "+expensesRevision.comment))):null];}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"7",className:"has-text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"No hay gastos registrados"))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__loading__["a" /* default */],{message:"Buscando..."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"has-text-right is-inm-purple",colSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-white-bis"},Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(totalExpenses))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"is-inm-purple"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.goBack();}},"Regresar")),pc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].button,{model:"project.expenses.data",className:"button is-large is-inm-purple",type:"submit"},"Guardar")):'')));}}]);function ProjectExpensesEditForm(){_classCallCheck(this,ProjectExpensesEditForm);var _this=_possibleConstructorReturn(this,(ProjectExpensesEditForm.__proto__||Object.getPrototypeOf(ProjectExpensesEditForm)).call(this));_this.state={expenseIndex:undefined,expenseEditShow:false};return _this;}_createClass(ProjectExpensesEditForm,[{key:"_handleSubmit",value:function _handleSubmit(values){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality,modality=_props$match$params.modality;this.props.projectExpensesSave(modality,state,municipality,values);}},{key:"_editExpense",value:function _editExpense(expenseIndex,row){this.props.change("project.expenses.edit",{temp_expense_id:row.id?row.id:undefined,temp_expense_concept_id:row.expense_concept_id,temp_expense_unit_id:row.expense_unit_id,temp_quantity:row.quantity,temp_amount:row.amount});this.setState({expenseIndex:expenseIndex,expenseEditShow:true});}},{key:"_addExpense",value:function _addExpense(){this.setState({expenseEditShow:true});}},{key:"_removeExpense",value:function _removeExpense(expenseIndex){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Esta seguro?',message:'¿Estás seguro/(a) de eliminar el gasto?',confirmLabel:'Eliminar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.remove('project.expenses.data.project_expenses',expenseIndex);}});}},{key:"_toggleModal",value:function _toggleModal(){this.setState({expenseIndex:undefined,expenseEditShow:false});this.props.change("project.expenses.edit",{});}},{key:"_blockFields",value:function _blockFields(id){var expenses=this.props.expenses;var response=false;var editable=expenses.editable;var expensesRevision=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(expenses.revision)?expenses.revision.body:undefined;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(expensesRevision)&&!expenses.isFetching){var allow=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expensesRevision,{allow_edit:'true',id:id})?true:false;if(editable&&allow){response=false;}else{response=true;}}else if(editable&&!expenses.isFetching){response=false;}else{response=true;}return response;}}]);return ProjectExpensesEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ExpenseEditModal=function(_Component2){_inherits(ExpenseEditModal,_Component2);function ExpenseEditModal(){_classCallCheck(this,ExpenseEditModal);return _possibleConstructorReturn(this,(ExpenseEditModal.__proto__||Object.getPrototypeOf(ExpenseEditModal)).apply(this,arguments));}_createClass(ExpenseEditModal,[{key:"render",value:function render(){var _this5=this;var _props2=this.props,expenses=_props2.expenses,concepts=_props2.concepts;var conceptData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(concepts.list,{id:expenses.edit.temp_expense_concept_id});var unitslist=conceptData?conceptData.units:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"modal-card-head"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"modal-card-title"},"Gasto de coordinaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:this.props.closeModal,className:"delete","aria-label":"close"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-card-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Fieldset"],{model:"project.expenses.edit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"temp_expense_concept_id",className:"label"},"Concepto ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].select,{id:"temp_expense_concept_id",model:".temp_expense_concept_id",parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */],changeAction:function changeAction(model,value){return _this5._changeConcept(model,value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Concepto ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(concepts.list,function(st,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:st.id,key:k},st.name);}))),expenses.edit&&expenses.edit.temp_expense_concept_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},"El concepto es obligatorio"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"temp_expense_unit_id",className:"label"},"Unidad de medida ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].select,{id:"temp_expense_unit_id",model:".temp_expense_unit_id",parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Unidad de medida ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(unitslist,function(st,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:st.id,key:k,className:!st.invoiceable?'has-text-primary':''},!st.invoiceable?st.name+" (No Facturable)":st.name);}))),expenses.edit&&expenses.edit.temp_expense_unit_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},"La unidad es obligatoria"),this._validUnit()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},"Unidad duplicada"):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"temp_quantity",className:"label"},"Cantidad ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{type:"number",min:"0",model:".temp_quantity",id:"temp_quantity",className:"input"}),expenses.edit&&expenses.edit.temp_quantity?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},"Cantidad es obligatoria")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"temp_amount",className:"label"},"Gasto ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].text,{model:".temp_amount",className:"input",id:"temp_expense",type:"number",step:"0.01",min:"0",placeholder:"$"}),expenses.edit&&expenses.edit.temp_quantity?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},"Gasto obligatorio"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button",onClick:this.props.closeModal},"Cerrar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-primary",onClick:function onClick(){return _this5._saveExpense();},disabled:this._validUnit()},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios.")))));}},{key:"_validUnit",value:function _validUnit(){var _props3=this.props,expenses=_props3.expenses,expenseIndex=_props3.expenseIndex;var edit=expenses.edit;var response=false;if(edit.temp_expense_unit_id){var foundUnit=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(expenses.data.project_expenses,{expense_unit_id:edit.temp_expense_unit_id});var validate=foundUnit?true:false;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNumber(expenseIndex)&&edit.temp_expense_unit_id===expenses.data.project_expenses[expenseIndex].expense_unit_id){response=false;}else{response=validate;}}else{response=false;}return response;}},{key:"_saveExpense",value:function _saveExpense(){var _props4=this.props,expenseIndex=_props4.expenseIndex,expenses=_props4.expenses,concepts=_props4.concepts;var edit=expenses.edit;if(edit.temp_expense_concept_id&&edit.temp_expense_unit_id&&edit.temp_quantity&&edit.temp_amount){var total=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(edit.temp_quantity)*__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(edit.temp_amount);var conceptData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(concepts.list,{id:edit.temp_expense_concept_id});var unitData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(conceptData.units,{id:edit.temp_expense_unit_id});if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNumber(expenseIndex)){this.props.change("project.expenses.data.project_expenses["+expenseIndex+"]",Object.assign({},expenses.data.project_expenses[expenseIndex],{expense_concept_id:edit.temp_expense_concept_id,expense_unit_id:edit.temp_expense_unit_id,quantity:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(edit.temp_quantity),amount:edit.temp_amount,total:total,expense_concept:{name:conceptData.name},expense_unit:{name:unitData.name}}));}else{this.props.add("project.expenses.data.project_expenses",{expense_concept_id:edit.temp_expense_concept_id,expense_unit_id:edit.temp_expense_unit_id,quantity:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(edit.temp_quantity),amount:edit.temp_amount,total:total,expense_concept:{name:conceptData?conceptData.name:''},expense_unit:{name:unitData?unitData.name:''}});}this.props.closeModal();}else{alert('Hay errores en el formulario');}}},{key:"_changeConcept",value:function _changeConcept(model,value){this.props.change(model,value);this.props.change('project.expenses.edit.temp_expense_unit_id',undefined);}}]);return ExpenseEditModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProjectExpensesEditForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ProjectExpensesEditForm);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_project__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_project_conclusion__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { history } from "../../store/store";
//import _ from "lodash";
var ProjectConclusion=function(_Component){_inherits(ProjectConclusion,_Component);function ProjectConclusion(){_classCallCheck(this,ProjectConclusion);return _possibleConstructorReturn(this,(ProjectConclusion.__proto__||Object.getPrototypeOf(ProjectConclusion)).apply(this,arguments));}_createClass(ProjectConclusion,[{key:'render',value:function render(){var project=this.props.project;return project.conclusion.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando Conclusi\xF3n...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_project_conclusion__["a" /* default */],{conclusion:project.conclusion,version:project.version,permissions:project.permissions,projectConclusionExport:this.props.projectConclusionExport,match:this.props.match,history:this.props.history,projectConclusionSave:this.props.projectConclusionSave});}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.projectConclusion(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.location.pathname!==this.props.location.pathname){this.props.projectConclusion(modality,state,municipality);}}}]);return ProjectConclusion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_project__["a" /* default */])(ProjectConclusion,{subnav:6}));

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_accounting_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={conclusion:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,version:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,permissions:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,projectConclusionExport:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,projectConclusionSave:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};var ConclusionEditForm=function(_Component){_inherits(ConclusionEditForm,_Component);function ConclusionEditForm(){_classCallCheck(this,ConclusionEditForm);return _possibleConstructorReturn(this,(ConclusionEditForm.__proto__||Object.getPrototypeOf(ConclusionEditForm)).apply(this,arguments));}_createClass(ConclusionEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,conclusion=_props.conclusion,match=_props.match,permissions=_props.permissions,version=_props.version;var agency=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)?conclusion.data.agency:undefined;var owner=agency?agency.owner:undefined;var conclusionRev=conclusion.revision&&conclusion.revision.body&&conclusion.revision.body?conclusion.revision.body:undefined;var conclusionDisabled=this._blockField();var pc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("blockquote",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6 has-text-weight-bold"},"INSTITUTO NACIONAL DE LAS MUJERES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"subtitle is-6"},"PRESENTE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"De acuerdo con lo se\xF1alado en la Convocatoria de ProEquidad ",version.year," anexo el Formato de presentaci\xF3n de proyecto."))),conclusionRev&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusionRev.comments)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message "+(conclusionRev.status?'is-'+conclusionRev.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},"Comentarios"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{dangerouslySetInnerHTML:{__html:conclusionRev.comments}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"DATOS GENERALES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Titular"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,owner?owner.title+" "+owner.name+" "+owner.last_name+" "+owner.slast_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Localidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,agency&&agency.agenciable?agency.agenciable.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,agency?agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)?conclusion.data.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)?conclusion.data.amounts.total:0))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Periodo de ejecuci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_1_moment___default()(conclusion.data.execution_start).format('MMMM YYYY'))," a ",__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_1_moment___default()(conclusion.data.execution_end).format('MMMM YYYY'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"DATOS DEL PROYECTO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table no-margin"},!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data.project_goals)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(conclusion.data.project_goals,function(o,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"C\xF3digo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,o.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,o.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Documento meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,o.goal_document))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(o.project_goal_activities)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-activity-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Actividad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(o.project_goal_activities,function(a,q){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:q},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,a.proigualdad_activity_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,a.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,a.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(a.total)));}))):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(o.total)))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Ninguna meta guardada")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"GASTOS DE COORDINACI\xD3N"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table project-goal-table no-margin"},!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(conclusion.data.project_expenses,function(ex,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Num."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto de gasto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,ex.expense_concept.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,ex.quantity.toFixed(0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(ex.amount)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(ex.total)))));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Ning\xFAn gasto de coordinaci\xF3n encontrado")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"RESUMEN DE GASTOS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto"),"Gasto total del proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)?conclusion.data.amounts.goals.total:0)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto"),"Gastos de coordinaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)?conclusion.data.amounts.expenses.total:0)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"Concepto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-white"},"Monto total del proyecto")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)?conclusion.data.amounts.total:0)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Form"],{model:"project.conclusion.data.documents",onSubmit:function onSubmit(project){return _this2._handleSubmit(project);},encType:"multipart/form-data"},conclusion.data&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data.last_document)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title is-6 is-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:conclusion.data.last_document.file,target:"_blank"},"Ver resumen anterior")):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline"},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(conclusion.documents_items,function(o){return o.modality_id===null||o.modality_id===(conclusion.data?conclusion.data.modality_id:undefined);}),function(item,d){var accepts=undefined;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(item.documents_types,function(ext){accepts=accepts?accepts+","+ext.extensions:""+ext.extensions;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"file"+(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data.document)&&conclusion.data.document[item.slug]?' is-success':' is-warning')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"file-label"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].file,{className:"file-input",model:"."+item.slug,id:"."+item.slug,accept:accepts,validateOn:"change",disabled:conclusionDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-cta"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-upload"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-label"},item.name)))),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data.documents)&&conclusion.data.documents[item.slug]?!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(conclusion.data.documents[item.slug])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:conclusion.data.documents[item.slug],className:"help is-success",target:"_blank"},"1 documento guardado ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-external-link","aria-hidden":"true"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"help is-info"},"Un nuevo archivo cargado"):'',item.file_format?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.file_format,className:"help is-info",target:"_blank"},"Descargar formato ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-external-link","aria-hidden":"true"})):'');}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this2.props.projectConclusionExport(match.params.modality,match.params.state,match.params.municipality);},disabled:conclusionDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Generar resumen")))),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.data.documents)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message is-success"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"finished",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].checkbox,{model:"project.conclusion.finished",id:"finished",className:"checkbox"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{whiteSpace:'normal'}},"He concluido el registro del proyecto y certifico que la informaci\xF3n proporcionada es correcta y completa; conozco las disposiciones establecidas en las Reglas de Operaci\xF3n del FEPAM "+(version?version.year:'----')+".")))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.goBack();}},"Regresar")),pc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].button,{model:"project.conclusion.data.documents",className:"button is-large is-primary",disabled:!conclusion.editable},"Guardar")):''))));}},{key:"_handleSubmit",value:function _handleSubmit(values,event){var _this3=this;var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;if(values&&this.props.conclusion.finished){Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Esta seguro?',message:'Si indicas que has terminado de guardar el proyecto, ya no lo podrás volver a editar. ¿Deseas continuar esta acción?',confirmLabel:'Guardar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.projectConclusionSave(modality,state,municipality,Object.assign({},values,{finished:_this3.props.conclusion.finished}),event);}});}else{this.props.projectConclusionSave(modality,state,municipality,values,event);}}},{key:"_blockField",value:function _blockField(){var conclusion=this.props.conclusion;var response=false;var editable=conclusion.editable;var conclusionRevision=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusion.revision)&&conclusion.revision.body&&conclusion.revision.body.document?conclusion.revision.body.document:undefined;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conclusionRevision)&&!conclusion.isFetching){var allow=conclusionRevision.allow_edit==='true'?true:false;if(editable&&allow&&!conclusion.finished){response=false;}else{response=true;}}else if(editable&&!conclusion.isFetching&&!conclusion.finished){response=false;}else{response=true;}return response;}}]);return ConclusionEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConclusionEditForm.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ConclusionEditForm);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_revision_project__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_revision_widget_revision_show__ = __webpack_require__(703);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from "lodash";
//import {history} from "../../store/store";
var RevisionProject=function(_Component){_inherits(RevisionProject,_Component);function RevisionProject(){_classCallCheck(this,RevisionProject);return _possibleConstructorReturn(this,(RevisionProject.__proto__||Object.getPrototypeOf(RevisionProject)).apply(this,arguments));}_createClass(RevisionProject,[{key:"render",value:function render(){var _props=this.props,revision=_props.revision,project=_props.project;return revision.isFetching||project.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_revision_project__["a" /* default */],this.props);}//Nueva Propuesta de Carga inicial AEH 30/04/2018
},{key:"componentWillMount",value:function componentWillMount(){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality,modality=_props$match$params.modality;this.props.fetchRevisionProject(modality,state,municipality);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextprops){var _nextprops$match$para=nextprops.match.params,modality=_nextprops$match$para.modality,state=_nextprops$match$para.state,municipality=_nextprops$match$para.municipality;if(nextprops.match.params!==this.props.match.params){this.props.fetchRevisionProject(modality,state,municipality);}}}]);return RevisionProject;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(RevisionProject,{title:'Revisión de proyecto',subnav:{icon:'fa-check-square-o',name:'Revisión',actions:[{type:'element',url:null,name:'Visualizar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_revision_widget_revision_show__["a" /* default */],null)}]},stateNav:true}));

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_revision_widget_project_revision_select__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_notification_status__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_edit_status__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_wysiwyg_field__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scroll_top__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__widget_actors_modal__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__widget_conago_modal__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__widget_row_widget__ = __webpack_require__(702);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProjectRevisionForm=function(_Component){_inherits(ProjectRevisionForm,_Component);_createClass(ProjectRevisionForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,resource_concepts=_props.resource_concepts,revision=_props.revision,project=_props.project,directories=_props.directories;var conclusion=project.conclusion,registry=project.registry,expenses=project.expenses,profiles=project.profiles,instance=project.instance;var modality=this.props.match.params.modality;var expensesTotal=0;var employeesAgency=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(profiles.data.agency)?profiles.data.agency.employees:[];var employeesProject=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(profiles.data.employees)?profiles.data.employees:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__scroll_top__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-"+(revision.surveyShow?'7':'10')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__widget_conago_modal__["a" /* default */],{closeModal:this._toggleConagoModal,active:this.state.conagoShow,conago:this.state.goalConago}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__widget_actors_modal__["a" /* default */],{closeModal:this._toggleActorsModal,active:this.state.actorsShow,actors:this.state.goalActors,fetching:directories.actors.isFetching}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"revision",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){console.log('error: ',error);_this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.phase_group)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"title is-3",dangerouslySetInnerHTML:{__html:"Revisi\xF3n - "+revision.phase_group.name}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"title is-5"},modality==='modalidad-i'?'Modalidad I':modality==='modalidad-ii'?'Modalidad II':'Modalidad III'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".registry.body",component:"fieldset",className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos del proyecto"),registry&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(registry.data)&&registry.data.name?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Fecha de ejecuci\xF3n inicial"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(registry.data.execution_start).format('DD/MMMM/YYYY'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Fecha de ejecuci\xF3n final"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(registry.data.execution_end).format('DD/MMMM/YYYY')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Nombre del proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,registry.data.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginBottom:'10px'},className:"help is-dark"},"Objetivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content",dangerouslySetInnerHTML:{__html:registry.data.objective}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginBottom:'10px'},className:"help is-dark"},"Justificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content",dangerouslySetInnerHTML:{__html:registry.data.justification}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n del proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".status",component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:revision.registry.body&&revision.registry.body.status?revision.registry.body.status:'success'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".comment",component:__WEBPACK_IMPORTED_MODULE_5__elements_revision_widget_project_revision_select__["a" /* default */],modality:modality,opts:"project",defaultValue:revision.registry.body&&revision.registry.body.comment?revision.registry.body.comment:'Ninguno'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".allow_edit",component:__WEBPACK_IMPORTED_MODULE_7__forms_edit_status__["a" /* default */],defaultValue:revision.registry.body&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.registry.body.allow_edit)?revision.registry.body.allow_edit:'false'})))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"})),"Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Metas del proyecto"),registry.data&&registry.data.project_goals&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(registry.data.project_goals)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{component:"table",model:"registry.body.goals",className:"table is-fullwidth project-goal-table"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(registry.data.project_goals,['axis.name','code']),function(goal,key){var muns=[];var goalRevision=revision.registry.body&&revision.registry.body.goals?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(revision.registry.body.goals,{id:goal.proigualdad_goal_id}):null;!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goal.agencies)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(goal.agencies,function(mun){return muns.push(mun.agenciable.name);}):muns=null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4,className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"Eje tem\xE1tico"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goal&&goal.axis?goal.axis.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"L\xEDnea de acci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goal&&goal.line?goal.line.name:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-inm-purple"},"C\xF3digo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-inm-purple"},goal.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goal.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(goal.total)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto de gasto"),goal.resource_concept_id&&resource_concepts&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(resource_concepts.list)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(resource_concepts.list,{id:goal.resource_concept_id}).name):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:1,rowSpan:modality==='modalidad-ii'?2:2,style:{width:'190px'}},modality==='modalidad-i'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons",style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-light",onClick:function onClick(){return _this2._openConagoModal(key,goal);}},"Metas CONAGO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-white"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(goal.conago_clauses))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons",style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-light",onClick:function onClick(){return _this2._openActorsModal(key,goal.actors);}},"Actores estrat\xE9gicos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-white"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(goal.actors))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Documento meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,goal.goal_document))),modality!=='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"\xC1rea geogr\xE1fica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,modality==='modalidad-iii'?'Municipios':goal.geographic_area?goal.geographic_area:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Municipios"),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(muns)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.join(muns,', ')):'---')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n de la meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+key+"].status",component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:goalRevision&&goalRevision.status?goalRevision.status:'success',changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{id:goal.proigualdad_goal_id,model:"revision.registry.body.goals["+key+"].id"});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+key+"].comment",component:__WEBPACK_IMPORTED_MODULE_5__elements_revision_widget_project_revision_select__["a" /* default */],modality:modality,opts:"goals",defaultValue:goalRevision&&goalRevision.comment?goalRevision.comment:'Ninguno'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+key+"].allow_edit",component:__WEBPACK_IMPORTED_MODULE_7__forms_edit_status__["a" /* default */],defaultValue:goalRevision&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goalRevision.allow_edit)?goalRevision.allow_edit:'false'})))))),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goal.project_goal_activities)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:"["+key+"].activities",component:"tr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-activity-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Actividad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Monto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Medio de verificaci\xF3n"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(goal.project_goal_activities,function(activity,j){var activityRevision=goalRevision?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(goalRevision.activities,{id:activity.proigualdad_activity_id}):null;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:j},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,activity.proigualdad_activity_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,activity.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,activity.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(activity.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,activity.verification_media?activity.verification_media.name:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"rev-"+j},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n de la actividad ",activity.proigualdad_activity_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+j+"].status",component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:activityRevision&&activityRevision.status?activityRevision.status:'success',changeAction:function changeAction(model,value){_this2._changeStatus(model,value,{id:activity.proigualdad_activity_id,model:"revision.registry.body.goals["+key+"].activities["+j+"].id"});_this2.props.change("revision.registry.body.goals["+key+"].id",goal.proigualdad_goal_id);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+j+"].comment",component:__WEBPACK_IMPORTED_MODULE_5__elements_revision_widget_project_revision_select__["a" /* default */],modality:modality,opts:"activity",defaultValue:activityRevision&&activityRevision.comment?activityRevision.comment:'Ninguno'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+j+"].allow_edit",component:__WEBPACK_IMPORTED_MODULE_7__forms_edit_status__["a" /* default */],defaultValue:activityRevision&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(activityRevision.allow_edit)?activityRevision.allow_edit:'false'}))))))];}))))):null);})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"}))," Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".expenses.body",className:"fieldset",component:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Gastos de coordinaci\xF3n"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(expenses.data)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"}))," Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(expenses.data.project_expenses,function(exp,p){var expenseRevision=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(revision.expenses.body,{id:exp.id});expensesTotal+=exp.total;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:p},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,p+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,exp.expense_concept?exp.expense_concept.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Unidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,exp.expense_unit?exp.expense_unit.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,exp.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Valor unitario"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(exp.amount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(exp.total))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"exp-rev-"+p},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n del gasto No. ",p+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+p+"].status",defaultValue:expenseRevision&&expenseRevision.status?expenseRevision.status:'success',component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{id:exp.id,model:"revision.expenses.body["+p+"].id"});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+p+"].comment",component:__WEBPACK_IMPORTED_MODULE_5__elements_revision_widget_project_revision_select__["a" /* default */],modality:modality,opts:"expenses",defaultValue:expenseRevision&&expenseRevision.comment?expenseRevision.comment:'Ninguno'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+p+"].allow_edit",component:__WEBPACK_IMPORTED_MODULE_7__forms_edit_status__["a" /* default */],defaultValue:expenseRevision&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(expenseRevision.allow_edit)?expenseRevision.allow_edit:'false'}))))))];}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:6,className:"goal-cell has-text-right has-text-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(expensesTotal))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".profiles.body",component:"fieldset",className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos adicionales"),profiles.data&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(profiles.data.roles)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"profiles-info"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Perfiles adicionales requeridos"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(profiles.data.roles)?'Ninguno':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(profiles.data.roles,function(profile,j){var registred=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(employeesAgency,{role_id:profile.id});if(profile.agenciable_type==='cdm'&&modality==='modalidad-iii'){registred=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(employeesProject,{role_id:profile.id,project_goal_agency:{agency_id:profile.agency_id}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:j,className:registred?'has-text-success':'has-text-danger'},profile.display);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Perfiles capturados"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(employeesAgency)+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(employeesProject))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Perfiles faltantes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(profiles.data.roles)-(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(employeesAgency)+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(employeesProject))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"profiles-fields"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n de datos adicionales"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".status",component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:revision.profiles.body&&revision.profiles.body.status?revision.profiles.body.status:'success'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".comment",component:__WEBPACK_IMPORTED_MODULE_5__elements_revision_widget_project_revision_select__["a" /* default */],modality:modality,opts:"profiles",defaultValue:revision.profiles.body&&revision.profiles.body.comment?revision.profiles.body.comment:'Ninguno'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".allow_edit",component:__WEBPACK_IMPORTED_MODULE_7__forms_edit_status__["a" /* default */],defaultValue:revision.profiles.body&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.profiles.body.allow_edit)?revision.profiles.body.allow_edit:'false'})))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"}))," Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".conclusion.body",component:"fieldset",className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Documentos"),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(conclusion.data)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concluy\xF3 la captura de su proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:conclusion.finished?'has-text-success':'has-text-danger'},conclusion.finished?'Concluida':'No concluida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buttons"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(conclusion.documents_items,function(item,k){var document=conclusion.data.documents[item.slug];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{key:k,target:"_blank",className:"button is-primary is-small",href:document,disabled:document?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.name));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n de resumen de proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".document.status",component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:revision.conclusion.body&&revision.conclusion.body.document&&revision.conclusion.body.document.status?revision.conclusion.body.document.status:'success'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".document.comment",component:__WEBPACK_IMPORTED_MODULE_5__elements_revision_widget_project_revision_select__["a" /* default */],modality:modality,opts:"conclusion",defaultValue:revision.conclusion.body&&revision.conclusion.body.document&&revision.conclusion.body.document.comment?revision.conclusion.body.document.comment:'Ninguno'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".document.allow_edit",component:__WEBPACK_IMPORTED_MODULE_7__forms_edit_status__["a" /* default */],defaultValue:revision.conclusion.body&&revision.conclusion.body.document&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.conclusion.body.document.allow_edit)?revision.conclusion.body.document.allow_edit:'false'})))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"}))," Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"title is-6"},"COMENTARIOS ADICIONALES"),revision.conclusion&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.conclusion.body)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table is-bordered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Comentarios y estatus general"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:".comments",component:__WEBPACK_IMPORTED_MODULE_8__forms_wysiwyg_field__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:".status",component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:revision.conclusion.body&&revision.conclusion.body.status?revision.conclusion.body.status:'success'})))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"}))," Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.notifications_types)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Notificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"",className:"label"},"Tipo de notificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".conclusion.notification_type_id",id:"status",parser:__WEBPACK_IMPORTED_MODULE_10__parsers__["c" /* toInt */],className:"select",validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Tipo ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(revision.notifications_types,function(opc,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:opc.id,key:k},opc.name);})))))))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.goBack();}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"revision",className:"button is-large is-primary"},"Guardar Comentarios"))))),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.commission.spvpu)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.commission.answers)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column",style:{display:revision.surveyShow?'block':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:'fixed',height:'85%',top:'17%',overflowY:'scroll'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Revisi\xF3n de Proyecto"))),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.commission.spvpu)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.commission.spvpu.survey_version_phase)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(revision.commission.spvpu.survey_version_phase.survey.children_questions,function(row,key){if(row.type==='group'){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"group-"+key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,key+1+'. '+row.name))),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(row.children_questions,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__widget_row_widget__["a" /* default */],{key:k,number:key+1,row:item,answer:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(revision.commission.answers,{question_id:item.id})});})];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__widget_row_widget__["a" /* default */],{key:key,number:key+1,row:row,answer:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(revision.commission.answers,{question_id:row.id})});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Comentarios generales"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:revision.commission.comments?revision.commission.comments:'Ninguno'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"level-left"},"Puntuaci\xF3n total:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"level-right"},this._totalScore()))))))))));}}]);function ProjectRevisionForm(props){_classCallCheck(this,ProjectRevisionForm);var _this=_possibleConstructorReturn(this,(ProjectRevisionForm.__proto__||Object.getPrototypeOf(ProjectRevisionForm)).call(this,props));_this.state={conagoShow:false,actorsShow:false,goalConago:[],goalActors:[],selectedGoal:undefined};_this._toggleActorsModal=_this._toggleActorsModal.bind(_this);_this._toggleConagoModal=_this._toggleConagoModal.bind(_this);return _this;}_createClass(ProjectRevisionForm,[{key:"_toggleConagoModal",value:function _toggleConagoModal(){return this.setState({conagoShow:!this.state.conagoShow});}},{key:"_toggleActorsModal",value:function _toggleActorsModal(){return this.setState({actorsShow:!this.state.actorsShow});}},{key:"_openConagoModal",value:function _openConagoModal(index,goal){return this.setState({conagoShow:true,goalConago:goal.conago_clauses,selectedGoal:index});}},{key:"_openActorsModal",value:function _openActorsModal(index,actors){return this.setState({actorsShow:true,goalActors:actors,selectedGoal:index});}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.id);}},{key:"_handleSubmit",value:function _handleSubmit(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.saveProjectRevision(modality,state,municipality,values);}},{key:"_totalScore",value:function _totalScore(){var commission=this.props.revision.commission;var total_score=commission&&commission.answers?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sum(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(commission.answers,function(row){if(row){return row.answer_number;}else{return 0;}})):0;return total_score;}}]);return ProjectRevisionForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProjectRevisionForm);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__activity_revision_json__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__activity_revision_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__activity_revision_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conclusion_revision_json__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conclusion_revision_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__conclusion_revision_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__expenses_revision_json__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__expenses_revision_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__expenses_revision_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__goal_revision_json__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__goal_revision_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__goal_revision_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__investigaton_revision_json__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__investigaton_revision_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__investigaton_revision_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__participation_request_revision_json__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__participation_request_revision_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__participation_request_revision_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profiles_revision_json__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profiles_revision_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__profiles_revision_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__project_revision_json__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__project_revision_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__project_revision_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var RevisionComment=function RevisionComment(props){var options=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.filter(_optsSwitch(props.opts),{'modality':props.modality});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",Object.assign({},props,{defaultValue:"Ninguno"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Comentario ---"),options.map(function(item,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:item.value,key:key},item.value);}));};var _optsSwitch=function _optsSwitch(opts){switch(opts){case'activity':return __WEBPACK_IMPORTED_MODULE_1__activity_revision_json__;case'conclusion':return __WEBPACK_IMPORTED_MODULE_2__conclusion_revision_json__;case'expenses':return __WEBPACK_IMPORTED_MODULE_3__expenses_revision_json__;case'goals':return __WEBPACK_IMPORTED_MODULE_4__goal_revision_json__;case'investigation':return __WEBPACK_IMPORTED_MODULE_5__investigaton_revision_json__;case'participation':return __WEBPACK_IMPORTED_MODULE_6__participation_request_revision_json__;case'profiles':return __WEBPACK_IMPORTED_MODULE_7__profiles_revision_json__;case'project':return __WEBPACK_IMPORTED_MODULE_8__project_revision_json__;default:return[];}};/* harmony default export */ __webpack_exports__["a"] = (RevisionComment);

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"modality":"modalidad-i","value":"Modificar las actividades planteadas, debido a que no contribuyen al logro de las metas y al cumplimiento de los objetivos."},{"id":2,"modality":"modalidad-i","value":"Ajustar las actividades planteadas, ya que son repetitivas y no visibilizan el cumplimento de la meta."},{"id":3,"modality":"modalidad-i","value":"Modificar las actividades planteadas, debido a que no son suficientes para asegurar el cumplimiento de la meta."},{"id":4,"modality":"modalidad-i","value":"Replantear la viabilidad de la actividad para su ejecución."},{"id":5,"modality":"modalidad-i","value":"Modificar el medio de verificación establecido, debido a que no es acorde con las acciones planteadas en la meta."},{"id":6,"modality":"modalidad-i","value":"Registrar el medio de verificación que corresponda de acuerdo a la actividad planteada."},{"id":7,"modality":"modalidad-i","value":"Ajustar los medios de verificación planteados, ya que no visibilizan el cumplimento de la actividad."},{"id":8,"modality":"modalidad-ii","value":"Modificar las actividades planteadas, debido a que no contribuyen al logro de las metas"},{"id":9,"modality":"modalidad-ii","value":"Ajustar las actividades planteadas, ya que son repetitivas y no visibilizan el cumplimento de la meta."},{"id":10,"modality":"modalidad-ii","value":"Modificar las actividades planteadas, debido a que no son suficientes para asegurar el cumplimiento de la meta."},{"id":11,"modality":"modalidad-ii","value":"Modificar la cantidad de la actividad"},{"id":12,"modality":"modalidad-ii","value":"Replantear la viabilidad de la actividad para su ejecución."},{"id":13,"modality":"modalidad-iii","value":"La contratación de 3 profesionistas para los CDM de continuidad debe ser por 10 meses"},{"id":14,"modality":"modalidad-iii","value":"La contratación de 3 profesionistas para los CDM de inicio debe ser por 7 meses"},{"id":15,"modality":"modalidad-iii","value":"La cantidad de la actividad de contratación de 3 profesionistas debe corresponder con el número de  CDM"},{"id":16,"modality":"modalidad-iii","value":"La meta Adquirir mobiliario y equipo de cómputo para el fortalecimiento de la IMM, aplica sólo para CDM de inicio"}]

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"modality":"modalidad-i","value":"Verificar que los datos de la instancia sean correctos"},{"id":2,"modality":"modalidad-i","value":"El proyecto considera el monto máximo o único asignado a la modalidad"},{"id":3,"modality":"modalidad-i","value":"Comprobar que el resumen del proyecto sea legible, esté firmado y rubricado."},{"id":4,"modality":"modalidad-i","value":"Adjuntar el resumen del proyecto"},{"id":5,"modality":"modalidad-i","value":"Ninguna"},{"id":6,"modality":"modalidad-ii","value":"Verificar que los datos de la instancia sean correctos"},{"id":7,"modality":"modalidad-ii","value":"El proyecto debe considerar el monto único asignado a la modalidad ($200, 000)"},{"id":8,"modality":"modalidad-ii","value":"Comprobar que el resumen del proyecto sea legible, esté firmado y rubricado."},{"id":9,"modality":"modalidad-ii","value":"Adjuntar el resumen del proyecto"},{"id":10,"modality":"modalidad-ii","value":"Ninguna"},{"id":11,"modality":"modalidad-iii","value":"Verificar que los datos de la instancia sean correctos"},{"id":12,"modality":"modalidad-iii","value":"El proyecto debe considerar el monto único asignado a cada CDM ($300, 000)"},{"id":13,"modality":"modalidad-iii","value":"Comprobar que el resumen del proyecto sea legible, esté firmado y rubricado."},{"id":14,"modality":"modalidad-iii","value":"Adjuntar el resumen del proyecto"},{"id":15,"modality":"modalidad-iii","value":"Ninguna"}]

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"modality":"modalidad-i","value":"Verificar que  la cantidad y el valor sea congruente con la unidad de medida."},{"id":2,"modality":"modalidad-i","value":"Se recomienda distribuir el monto solicitado en otros conceptos de gasto, tomando en cuenta las necesidades para la ejecución del proyecto."},{"id":3,"modality":"modalidad-i","value":"Se recomienda evaluar las cantidades solicitadas por cada unidad de medida."},{"id":4,"modality":"modalidad-i","value":"Ninguna"},{"id":5,"modality":"modalidad-ii","value":"Verificar que  la cantidad y el valor sea congruente con la unidad de medida."},{"id":6,"modality":"modalidad-ii","value":"Se recomienda distribuir el monto solicitado en otros conceptos de gasto, tomando en cuenta las necesidades para la ejecución del proyecto."},{"id":7,"modality":"modalidad-ii","value":"Se recomienda evaluar las cantidades solicitadas por cada unidad de medida."},{"id":8,"modality":"modalidad-ii","value":"Ninguna"},{"id":9,"modality":"modalidad-iii","value":"Verificar que  la cantidad y el valor sea congruente con la unidad de medida."},{"id":10,"modality":"modalidad-iii","value":"Se recomienda distribuir el monto solicitado en otros conceptos de gasto, tomando en cuenta las necesidades para la ejecución del proyecto."},{"id":11,"modality":"modalidad-iii","value":"Se recomienda evaluar las cantidades solicitadas por cada unidad de medida."},{"id":12,"modality":"modalidad-iii","value":"Ninguna"}]

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"modality":"modalidad-i","value":"Modificar el nombre de la meta procurando que ésta aluda al resultado que se quiere lograr y sea susceptible de ser alcanzada durante la ejecución del proyecto y con el recurso disponible."},{"id":2,"modality":"modalidad-i","value":"Modificar el nombre de la meta, porque es igual a alguna ejecutada en los dos últimos ejercicios fiscales, o bien indicar si se trata de una segunda etapa."},{"id":3,"modality":"modalidad-i","value":"Reformular la meta, ya que no se considera viable en el marco del Programa."},{"id":4,"modality":"modalidad-i","value":"Reformular la meta, ya que no se considera pertinente debido al cambio de gobierno y el periodo de veda electoral."},{"id":5,"modality":"modalidad-i","value":"Plantear otra meta ya que es igual o similar a alguna ejecutada en los dos últimos ejercicios fiscales"},{"id":6,"modality":"modalidad-i","value":"Plantear otra meta ya queno se considera pertinente debido al cambio de gobierno"},{"id":7,"modality":"modalidad-i","value":"El proyecto debe integrar al menos tres metas vinculadas a los temas incluidos en  la Plataforma México Rumbo a la Igualdad"},{"id":8,"modality":"modalidad-i","value":"Replantear el concepto de gasto para la ejecución de la meta, ya que éste no es pertinente."},{"id":9,"modality":"modalidad-i","value":"Alinear la meta con la (s) fracción (es) del Convenio suscrito entre el Inmujeres y la persona titular del ejecutivo estatal en el marco de la CONAGO, ya que no  es congruente con la seleccionada."},{"id":10,"modality":"modalidad-i","value":"Alinear la meta con la (s) fracción (es) del Convenio suscrito entre el Inmujeres y la persona titular del ejecutivo estatal en el marco de la CONAGO."},{"id":11,"modality":"modalidad-i","value":"Alinear la meta a los objetivos, estrategias y líneas de acción del Proigualdad, debido a que no es congruente la propuesta."},{"id":12,"modality":"modalidad-i","value":"Modificar los actores estratégicos establecidos, debido a que no son acordes con las acciones planteadas en la meta."},{"id":13,"modality":"modalidad-i","value":"Verificar los actores estratégicos registrados, ya que no aseguran el cumplimiento de la meta."},{"id":14,"modality":"modalidad-i","value":"Seleccionar los actores estratégicos con los que se vincularán para dar cumplimiento a la meta."},{"id":15,"modality":"modalidad-i","value":"Seleccionar el ámbito geográfico acorde con las acciones planteadas en la meta."},{"id":16,"modality":"modalidad-i","value":"Modificar el ámbito geográfico establecido, debido a que no es acorde con las acciones planteadas en la meta."},{"id":17,"modality":"modalidad-i","value":"Modificar el nombre del documento meta (producto) propuesto, debido a que no es congruente con la meta planteada."},{"id":18,"modality":"modalidad-i","value":"Modificar el documento meta (producto) propuesto, ya que no refleja los objetivos de la meta."},{"id":19,"modality":"modalidad-i","value":"Se recomienda evaluar y ajustar el monto planteado acorde con las actividades establecidas en las metas."},{"id":20,"modality":"modalidad-i","value":"Establecer los montos de las Certificaciones con base en la cotización con las instancias certificadoras correspondientes."},{"id":21,"modality":"modalidad-i","value":"Ninguna"},{"id":22,"modality":"modalidad-ii","value":"Plantear otra meta ya que es igual o similar a alguna ejecutada en los dos últimos ejercicios fiscales"},{"id":23,"modality":"modalidad-ii","value":"Plantear otra meta ya que no se considera pertinente debido al cambio de gobierno"},{"id":24,"modality":"modalidad-ii","value":"Se sugiere plantear 2 metas (adicionales a la contratación de la persona) que incluyan 3 actividades cada una"},{"id":25,"modality":"modalidad-ii","value":"Se sugiere plantear 2 metas que incluyan 3 actividades cada una"},{"id":26,"modality":"modalidad-ii","value":"No es necesario seleccionar 'Metas CONAGO'"},{"id":27,"modality":"modalidad-ii","value":"Replantear el concepto de gasto para la ejecución de la meta, ya que éste no es pertinente."},{"id":28,"modality":"modalidad-ii","value":"Modificar los actores estratégicos establecidos, debido a que no son acordes con las acciones planteadas en la meta."},{"id":29,"modality":"modalidad-ii","value":"Verificar los actores estratégicos registrados, ya que no aseguran el cumplimiento de la meta."},{"id":30,"modality":"modalidad-ii","value":"Seleccionar los actores estratégicos con los que se vincularán para dar cumplimiento a la meta."},{"id":31,"modality":"modalidad-ii","value":"Se recomienda evaluar y ajustar el monto planteado acorde con las actividades establecidas en las metas."},{"id":32,"modality":"modalidad-ii","value":"Ninguna"},{"id":33,"modality":"modalidad-iii","value":"Debe seleccionar los municipios en los cuales van a operar los Centros"},{"id":34,"modality":"modalidad-iii","value":"La  jornada de oferta de servicios para las mujeres del municipio, debe ser al menos una por CDM"},{"id":35,"modality":"modalidad-iii","value":"Replantear el concepto de gasto para la ejecución de la meta, ya que éste no es pertinente."},{"id":36,"modality":"modalidad-iii","value":"No es necesario seleccionar 'Metas CONAGO'"},{"id":37,"modality":"modalidad-iii","value":"Modificar los actores estratégicos establecidos, debido a que no son acordes con las acciones planteadas en la meta."},{"id":38,"modality":"modalidad-iii","value":"Verificar los actores estratégicos registrados, ya que no aseguran el cumplimiento de la meta."},{"id":39,"modality":"modalidad-iii","value":"Seleccionar los actores estratégicos con los que se vincularán para dar cumplimiento a la meta."},{"id":40,"modality":"modalidad-iii","value":"Se recomienda evaluar y ajustar el monto planteado acorde con las actividades establecidas en las metas."},{"id":41,"modality":"modalidad-iii","value":"Ninguna"}]

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"modality":"modalidad-i","value":"Verificar la información, ya que la información está incompleta y/o es errónea"},{"id":2,"modality":"modalidad-i","value":"Firmar el oficio"},{"id":3,"modality":"modalidad-i","value":"Escanear de manera correcta el oficio"},{"id":4,"modality":"modalidad-i","value":"Adjuntar el oficio"},{"id":5,"modality":"modalidad-i","value":"Ninguno"},{"id":6,"modality":"modalidad-ii","value":"Verificar la información, ya que la información está incompleta y/o es errónea"},{"id":7,"modality":"modalidad-ii","value":"Firmar el oficio"},{"id":8,"modality":"modalidad-ii","value":"Escanear de manera correcta el oficio"},{"id":9,"modality":"modalidad-ii","value":"Adjuntar el oficio"},{"id":10,"modality":"modalidad-ii","value":"Ninguna"}]

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"modality":"modalidad-i","value":"Verificar la información, ya que la información está incompleta y/o es errónea"},{"id":2,"modality":"modalidad-i","value":"Firmar la solicitud de participación"},{"id":3,"modality":"modalidad-i","value":"Escanear de manera correcta la solicitud"},{"id":4,"modality":"modalidad-i","value":"Adjuntar la solicitud de participación"},{"id":5,"modality":"modalidad-i","value":"Ninguno"}]

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"modality":"modalidad-i","value":"Registrar toda la información requerida en los perfiles solicitados."},{"id":2,"modality":"modalidad-i","value":"Completar la información en los perfiles."},{"id":3,"modality":"modalidad-i","value":"Verificar la información proporcionada en los perfiles."},{"id":4,"modality":"modalidad-i","value":"Ninguna"},{"id":5,"modality":"modalidad-ii","value":"Registrar toda la información requerida en los perfiles solicitados."},{"id":6,"modality":"modalidad-ii","value":"Completar la información en los perfiles."},{"id":7,"modality":"modalidad-ii","value":"Verificar la información proporcionada en los perfiles."},{"id":8,"modality":"modalidad-ii","value":"Ninguna"},{"id":9,"modality":"modalidad-iii","value":"Registrar toda la información requerida en los perfiles solicitados."},{"id":10,"modality":"modalidad-iii","value":"Completar la información en los perfiles."},{"id":11,"modality":"modalidad-iii","value":"Verificar la información proporcionada en los perfiles."},{"id":12,"modality":"modalidad-iii","value":"Ninguna"}]

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"modality":"modalidad-i","value":"Modificar el nombre del proyecto, porque es igual a alguno de los dos últimos ejercicios fiscales, o bien indicar si se trata de una segunda etapa."},{"id":2,"modality":"modalidad-i","value":"El nombre del proyecto no da cuenta del contenido del mismo de acuerdo a su pertinencia y temporalidad."},{"id":3,"modality":"modalidad-i","value":"Indicar el periodo de ejecución (inicio-conclusión)"},{"id":4,"modality":"modalidad-i","value":"Ajustar la fecha de conclusión del proyecto, con el fin de alinearlo con el cambio de gobierno."},{"id":5,"modality":"modalidad-i","value":"Modificar los objetivos del proyecto ya que no está vinculado a los objetivos del Programa, señalados en las ROP."},{"id":6,"modality":"modalidad-i","value":"Modificar los objetivos ya que no da cuenta de la integralidad del proyecto."},{"id":7,"modality":"modalidad-i","value":"Precisar el propósito del proyecto, debe responder a las preguntas ¿Cuál es la problemática? ¿Para qué? y ¿Cómo?"},{"id":9,"modality":"modalidad-ii","value":"Modificar el nombre del proyecto, porque es igual a alguno de los dos últimos ejercicios fiscales, o bien indicar si se trata de una segunda etapa."},{"id":10,"modality":"modalidad-ii","value":"El nombre del proyecto no da cuenta del contenido del mismo de acuerdo a su pertinencia y temporalidad."},{"id":11,"modality":"modalidad-ii","value":"Indicar el periodo de ejecución (inicio-conclusión)"},{"id":12,"modality":"modalidad-ii","value":"Ajustar la fecha de conclusión del proyecto, con el fin de alinearlo con el cambio de gobierno."},{"id":13,"modality":"modalidad-ii","value":"Modificar los objetivos del proyecto ya que no está vinculado a los objetivos del Programa, señalados en las ROP."},{"id":14,"modality":"modalidad-ii","value":"Modificar los objetivos ya que no da cuenta de la integralidad del proyecto."},{"id":15,"modality":"modalidad-ii","value":"Precisar el propósito del proyecto, debe responder a las preguntas ¿Cuál es la problemática? ¿Para qué? y ¿Cómo?"},{"id":16,"modality":"modalidad-iii","value":"Indicar en el nombre del proyecto el ejercicio fiscal."},{"id":17,"modality":"modalidad-iii","value":"Se recomienda como nombre del proyecto 'Centros para el Desarrollo de las Mujeres (nombre de la entidad), 2018'"},{"id":18,"modality":"modalidad-iii","value":"Indicar el periodo de ejecución (inicio-conclusión)"},{"id":19,"modality":"modalidad-iii","value":"Ajustar la fecha de conclusión del proyecto, con el fin de alinearlo con el cambio de gobierno."},{"id":20,"modality":"modalidad-iii","value":"Modificar los objetivos del proyecto ya que no está vinculado a los objetivos del Programa, señalados en las ROP."},{"id":21,"modality":"modalidad-iii","value":"Modificar los objetivos ya que no da cuenta de la integralidad del proyecto."},{"id":22,"modality":"modalidad-iii","value":"Precisar el propósito del proyecto, debe responder a las preguntas ¿Cuál es la problemática? ¿Para qué? y ¿Cómo?"}]

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var propTypes={active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,closeModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,actors:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};var ActorsReviewModal=function ActorsReviewModal(props){var active=props.active,closeModal=props.closeModal,actors=props.actors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Actores estrat\xE9gicos seleccionados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return closeModal();},className:'delete is-medium','aria-label':'delete'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(actors,function(actor,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:k},actor.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:function onClick(){return closeModal();}},'Cerrar')))))));};ActorsReviewModal.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ActorsReviewModal);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var propTypes={active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,closeModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,conago:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};var ConagoReviewModal=function ConagoReviewModal(props){var active=props.active,closeModal=props.closeModal,conago=props.conago;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Metas CONAGO seleccionadas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return closeModal();},className:'delete is-medium','aria-label':'delete'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(conago,function(clause,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:k},clause.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:function onClick(){return closeModal();}},'Cerrar')))))));};ConagoReviewModal.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ConagoReviewModal);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var propTypes={row:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,answer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};var RowQuestion=function RowQuestion(props){var row=props.row,answer=props.answer,number=props.number;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,number?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,number+'. '+row.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},row.type==='sum'&&answer?!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(answer.answer_text)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,answer.answer_number+' - '+answer.answer_text):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,answer.answer_text):'')));};RowQuestion.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (RowQuestion);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RevisionShow=function(_Component){_inherits(RevisionShow,_Component);function RevisionShow(){_classCallCheck(this,RevisionShow);return _possibleConstructorReturn(this,(RevisionShow.__proto__||Object.getPrototypeOf(RevisionShow)).apply(this,arguments));}_createClass(RevisionShow,[{key:'render',value:function render(){var _this2=this;var revision=this.props.revision;//let gc = _.find(goals.permissions, (o) => {return o==='Create'});
return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revision.commission.spvpu)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revision.commission.answers)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-small is-inm-purple',onClick:function onClick(){return _this2.props.change('revision.surveyShow',!revision.surveyShow);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Revisar encuesta'),'\xA0')):'';}}]);return RevisionShow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(RevisionShow));

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_revision_legal__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from "lodash";
//import {history} from "../../store/store";
var RevisionLegal=function(_Component){_inherits(RevisionLegal,_Component);function RevisionLegal(){_classCallCheck(this,RevisionLegal);return _possibleConstructorReturn(this,(RevisionLegal.__proto__||Object.getPrototypeOf(RevisionLegal)).apply(this,arguments));}_createClass(RevisionLegal,[{key:'render',value:function render(){var revision=this.props.revision;return revision.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_revision_legal__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality,modality=_props$match$params.modality;this.props.fetchRevisionLegal(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextprops){if(nextprops.match.params!==this.props.match.params){var _nextprops$match$para=nextprops.match.params,modality=_nextprops$match$para.modality,state=_nextprops$match$para.state,municipality=_nextprops$match$para.municipality;this.props.fetchRevisionLegal(modality,state,municipality);}}}]);return RevisionLegal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(RevisionLegal,{title:"Revisión Jurídica",subnav:{icon:'fa-check-square-o',name:'Revisión'},stateNav:true}));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_notification_status__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_edit_status__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parsers__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LegalEditForm=function(_Component){_inherits(LegalEditForm,_Component);function LegalEditForm(){_classCallCheck(this,LegalEditForm);return _possibleConstructorReturn(this,(LegalEditForm.__proto__||Object.getPrototypeOf(LegalEditForm)).apply(this,arguments));}_createClass(LegalEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,project=_props.project,revision=_props.revision,modalities=_props.modalities,match=_props.match;var owner=project.owner,instance=project.instance;var modality=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(modalities.list,{slug:match.params.modality});//console.log('modality===>', modality);
//let agency = !_.isEmpty(conclusion.data) ? conclusion.data.agency:undefined;
//let owner = agency ? agency.owner:undefined;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"revision",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);}},!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.phase_group)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"title is-3",dangerouslySetInnerHTML:{__html:"Revisi\xF3n - "+revision.phase_group.name}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"title is-5"},modality?modality.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos del titular"),owner&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(owner.data)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Titular"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,owner.data?owner.data.title+" "+owner.data.name+" "+owner.data.last_name+" "+owner.data.slast_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"RFC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,owner.data.rfc)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"CURP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,owner.data.curp)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".owner.body",component:"tbody"},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(owner.documents_items,function(item,d){var document=owner.data[item.slug]&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isObject(owner.data[item.slug])?owner.data[item.slug]:undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:document,disabled:document?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+item.id+"].status",id:"["+item.id+"].status",defaultValue:revision.owner.body&&revision.owner.body[item.id]&&revision.owner.body[item.id].status?revision.owner.body[item.id].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{field:item.slug,model:"revision.owner.body["+item.id+"].field"});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".owner.body.status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"["+item.id+"].comment",id:"["+item.id+"].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+item.id+"].allow_edit",id:"["+item.id+"].allow_edit",defaultValue:revision.owner.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.owner.body[item.id])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.owner.body[item.id].allow_edit)?revision.owner.body[item.id].allow_edit:'false',component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */]}))))));}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"}))," Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos de la instancia"),instance&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(instance.data)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Nombre de la instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Fecha de creaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_5_moment_moment___default()(instance.data.creation_date).format('MMMM YYYY'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Naturaleza jur\xEDdica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.legal_nature)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Periodo de Gesti\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_5_moment_moment___default()(instance.data.management_period_start).format('MMMM YYYY'))," a ",__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_5_moment_moment___default()(instance.data.management_period_end).format('MMMM YYYY'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Direcci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.street)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"N\xFAmero"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.num_ext)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Interior"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.num_int?instance.data.num_int:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Colonia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.colony)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"C\xF3digo postal"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.cp)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Tipo de vialidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.road_type?instance.data.road_type:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Estado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this._stateName())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Municipio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this._munName()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Tel\xE9fono principal "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.telephone)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Tel\xE9fono alterno"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.telephone_2?instance.data.telephone_2:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Email principal "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Email secundario"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.email_2?instance.data.email_2:'---'))),instance&&instance.data.type?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Tipo de Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,instance.data.type==='decentralized'?'Descentralizada':instance.data.type==='centralized'?'Centralizada':'Delegación'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".instance.body",component:"tbody"},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(instance.documents_items,function(o){return o.agency_type===null&&(o.modality_id===null||o.modality_id===(modality?modality.id:undefined));}),function(item,d){var document=instance.data[item.slug]&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isObject(instance.data[item.slug])?instance.data[item.slug]:undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:document,disabled:document?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+item.id+"].status",id:"["+item.id+"].status",defaultValue:revision.instance.body&&revision.instance.body[item.id]?revision.instance.body[item.id].status:'success',changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{field:item.slug,model:"revision.instance.body["+item.id+"].field"});},component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"["+item.id+"].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"["+item.id+"].comment",id:"["+item.id+"].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+item.id+"].allow_edit",id:"["+item.id+"].allow_edit",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[item.id])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[item.id].allow_edit)?revision.instance.body[item.id].allow_edit:'false'}))))));}),modality&&modality.id===2&&instance.data.type?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"DOCUMENTACI\xD3N ADICIONAL"))):null,modality&&modality.id===2&&instance.data.type?__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(instance.documents_items,function(o){return o.agency_type===instance.data.type&&o.modality_id===(modality?modality.id:undefined);}),function(item,d){var document=instance.data[item.slug]&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isObject(instance.data[item.slug])?instance.data[item.slug]:undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:document,disabled:document?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+item.id+"].status",id:"["+item.id+"].status",defaultValue:revision.instance.body&&revision.instance.body[item.id]?revision.instance.body[item.id].status:'success',changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{field:item.slug,model:"revision.instance.body["+item.id+"].field"});},component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"["+item.id+"].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"["+item.id+"].comment",id:"["+item.id+"].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+item.id+"].allow_edit",id:"["+item.id+"].allow_edit",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[item.id])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[item.id].allow_edit)?revision.instance.body[item.id].allow_edit:'false'}))))));}):null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon has-text-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-lg fa-exclamation-triangle"}))," Sin informaci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))),!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.notifications_types)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Notificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"",className:"label"},"Tipo de notificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".instance.notification_type_id",id:"status",parser:__WEBPACK_IMPORTED_MODULE_7__parsers__["c" /* toInt */],className:"select",validateOn:"change"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Tipo ---"),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(revision.notifications_types,function(opc,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:opc.id,key:k},opc.name);})))))))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.goBack();}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"revision",className:"button is-primary is-large"},"Guardar Comentarios"))))));}},{key:"componentWillMount",value:function componentWillMount(){var project=this.props.project;if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(project.instance.data)){this.props.fetchMunicipalities(project.instance.data.state_id);}}},{key:"_handleSubmit",value:function _handleSubmit(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.saveLegalRevision(modality,state,municipality,values);//console.log('values==>', values);
}},{key:"_renderExtraDocs",value:function _renderExtraDocs(){var _props2=this.props,project=_props2.project,match=_props2.match,change=_props2.change,revision=_props2.revision;if(project.instance.data&&project.instance.data.type==='decentralized'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecentralizedDocs,{project:Object.assign({},project),revision:revision,change:change})));}else if(project.instance.data&&project.instance.data.type==='centralized'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CentralizadDocs,{project:Object.assign({},project),revision:revision,state:match.params.state,change:change})));}else if(project.instance.data&&project.instance.data.type==='delegacy'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DelegacyDocs,{project:Object.assign({},project),revision:revision,change:change})));}else if(project.instance.data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AgencyDocs,{project:Object.assign({},project),revision:revision,change:change});}}},{key:"_stateName",value:function _stateName(){var _props3=this.props,entities=_props3.entities,project=_props3.project;var state=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(entities.list,{id:project.instance.data.state_id});return state?state.name:'---';}},{key:"_munName",value:function _munName(){var _props4=this.props,municipalities=_props4.municipalities,project=_props4.project;var mun=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(municipalities.list,{id:project.instance.data.municipality_id});return mun?mun.name:'---';}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.field);}}]);return LegalEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LegalEditForm);var AgencyDocs=function(_Component2){_inherits(AgencyDocs,_Component2);function AgencyDocs(){_classCallCheck(this,AgencyDocs);return _possibleConstructorReturn(this,(AgencyDocs.__proto__||Object.getPrototypeOf(AgencyDocs)).apply(this,arguments));}_createClass(AgencyDocs,[{key:"render",value:function render(){var _this4=this;var instance=this.props.project.instance;var revision=this.props.revision;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.agency_regulation,disabled:instance.data.agency_regulation?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Reglamento interno")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[5].status",component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],defaultValue:revision.instance.body&&revision.instance.body[5]?revision.instance.body[5].status:'success',changeAction:function changeAction(model,value){return _this4._changeStatus(model,value,{field:'agency_regulation',model:'revision.instance.body[5].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[5].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[5].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[5].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[5])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[5].allow_edit)?revision.instance.body[5].allow_edit:'false'}))))));}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.field);}}]);return AgencyDocs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var DecentralizedDocs=function(_Component3){_inherits(DecentralizedDocs,_Component3);function DecentralizedDocs(){_classCallCheck(this,DecentralizedDocs);return _possibleConstructorReturn(this,(DecentralizedDocs.__proto__||Object.getPrototypeOf(DecentralizedDocs)).apply(this,arguments));}_createClass(DecentralizedDocs,[{key:"render",value:function render(){var _this6=this;var instance=this.props.project.instance;var revision=this.props.revision;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"DOCUMENTACI\xD3N ADICIONAL"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.decentralized_agency_regulation,disabled:!instance.data.decentralized_agency_regulation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Reglamento interno")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[5].status",defaultValue:revision.instance.body&&revision.instance.body[5]?revision.instance.body[5].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this6._changeStatus(model,value,{field:'decentralized_agency_regulation',model:'revision.instance.body[5].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[5].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[5].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[5].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[5])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[5].allow_edit)?revision.instance.body[5].allow_edit:'false'}))))))));}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.field);}}]);return DecentralizedDocs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CentralizadDocs=function(_Component4){_inherits(CentralizadDocs,_Component4);function CentralizadDocs(){_classCallCheck(this,CentralizadDocs);return _possibleConstructorReturn(this,(CentralizadDocs.__proto__||Object.getPrototypeOf(CentralizadDocs)).apply(this,arguments));}_createClass(CentralizadDocs,[{key:"render",value:function render(){var _this8=this;var _props5=this.props,project=_props5.project,state=_props5.state,revision=_props5.revision;var instance=project.instance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"DOCUMENTACI\xD3N ADICIONAL"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.centralized_majority_votes_constancy,disabled:instance.data.centralized_majority_votes_constancy?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Constancia de mayor\xEDa de votos")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[5].status",defaultValue:revision.instance.body&&revision.instance.body[5]?revision.instance.body[5].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this8._changeStatus(model,value,{field:'centralized_majority_votes_constancy',model:'revision.instance.body[5].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[5].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[5].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[5].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[5])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[5].allow_edit)?revision.instance.body[5].allow_edit:'false'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.centralized_identification_presidency,disabled:instance.data.centralized_identification_presidency?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Identificaci\xF3n oficial del Presidente Municipal")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[6].status",defaultValue:revision.instance.body&&revision.instance.body[6]?revision.instance.body[6].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this8._changeStatus(model,value,{field:'centralized_identification_presidency',model:'revision.instance.body[6].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[6].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[6].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[6].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[6])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[6].allow_edit)?revision.instance.body[6].allow_edit:'false'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.centralized_designation_municipality,disabled:instance.data.centralized_designation_municipality?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Nombramiento del titular")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[7].status",defaultValue:revision.instance.body&&revision.instance.body[7]?revision.instance.body[7].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this8._changeStatus(model,value,{field:'centralized_designation_municipality',model:'revision.instance.body[7].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[7].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[7].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[7].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[7])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[7].allow_edit)?revision.instance.body[7].allow_edit:'false'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.centralized_identification_secretary,disabled:instance.data.centralized_identification_secretary?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Identificaci\xF3n oficial del titular de la Secretar\xEDa del Ayuntamiento")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[8].status",defaultValue:revision.instance.body&&revision.instance.body[8]?revision.instance.body[8].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this8._changeStatus(model,value,{field:'centralized_identification_secretary',model:'revision.instance.body[8].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[8].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[8].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[8].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[8])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[8].allow_edit)?revision.instance.body[8].allow_edit:'false'})))))),state==='JAL'||state==='GRO'||state==='NAY'||state==='SLP'||state==='NLE'||state==='TAB'||state==='VER'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.majority_votes_constancy_syndic,disabled:instance.data.majority_votes_constancy_syndic?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Constancia mayor\xEDa votos s\xEDndico")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[9].status",defaultValue:revision.instance.body&&revision.instance.body[9]?revision.instance.body[9].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this8._changeStatus(model,value,{field:'majority_votes_constancy_syndic',model:'revision.instance.body[9].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[9].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[9].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[9].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[9])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[9].allow_edit)?revision.instance.body[9].allow_edit:'false'})))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3})),state==='JAL'||state==='GRO'||state==='NAY'||state==='SLP'||state==='NLE'||state==='TAB'||state==='VER'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.official_identification_syndic,disabled:instance.data.official_identification_syndic?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Identificaci\xF3n oficial s\xEDndico")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[10].status",defaultValue:revision.instance.body&&revision.instance.body[10]?revision.instance.body[10].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this8._changeStatus(model,value,{field:'official_identification_syndic',model:'revision.instance.body[10].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[10].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[10].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[10].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[10])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[10].allow_edit)?revision.instance.body[10].allow_edit:'false'})))))):null));}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.field);}}]);return CentralizadDocs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var DelegacyDocs=function(_Component5){_inherits(DelegacyDocs,_Component5);function DelegacyDocs(){_classCallCheck(this,DelegacyDocs);return _possibleConstructorReturn(this,(DelegacyDocs.__proto__||Object.getPrototypeOf(DelegacyDocs)).apply(this,arguments));}_createClass(DelegacyDocs,[{key:"render",value:function render(){var _this10=this;var instance=this.props.project.instance;var revision=this.props.revision;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"DOCUMENTACI\xD3N ADICIONAL"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.delegacy_administrative_manual,disabled:instance.data.delegacy_administrative_manual?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Manual administrativo o estatuto org\xE1nico")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[5].status",defaultValue:revision.instance.body&&revision.instance.body[5]?revision.instance.body[5].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this10._changeStatus(model,value,{field:'delegacy_administrative_manual',model:'revision.instance.body[10].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[5].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[5].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[5].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[5])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[5].allow_edit)?revision.instance.body[5].allow_edit:'false'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.delegacy_majority_votes_constancy,disabled:instance.data.delegacy_majority_votes_constancy?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Constancia de mayor\xEDa de votos")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[6].status",defaultValue:revision.instance.body&&revision.instance.body[6]?revision.instance.body[6].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this10._changeStatus(model,value,{field:'delegacy_majority_votes_constancy',model:'revision.instance.body[6].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[6].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[6].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[6].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[6])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[6].allow_edit)?revision.instance.body[6].allow_edit:'false'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.delegacy_identification_owner,disabled:instance.data.delegacy_identification_owner?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Identificaci\xF3n del titular de la delegaci\xF3n")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[7].status",defaultValue:revision.instance.body&&revision.instance.body[7]?revision.instance.body[7].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this10._changeStatus(model,value,{field:'delegacy_identification_owner',model:'revision.instance.body[7].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[7].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[7].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[7].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[7])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[7].allow_edit)?revision.instance.body[7].allow_edit:'false'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.delegacy_agreement_subscription,disabled:instance.data.delegacy_agreement_subscription?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Acuerdo para suscripci\xF3n de convenios")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[8].status",component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this10._changeStatus(model,value,{field:'delegacy_agreement_subscription',model:'revision.instance.body[8].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[8].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[8].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[8].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[8])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[8].allow_edit)?revision.instance.body[8].allow_edit:'false'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.delegacy_designation_social,disabled:instance.data.delegacy_designation_social?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Nombramiento")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[9].status",defaultValue:revision.instance.body&&revision.instance.body[9]?revision.instance.body[9].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this10._changeStatus(model,value,{field:'delegacy_designation_social',model:'revision.instance.body[9].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[9].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[9].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[9].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[9])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[9].allow_edit)?revision.instance.body[9].allow_edit:'false'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-primary is-small",href:instance.data.delegacy_identification_social,disabled:instance.data.delegacy_identification_social?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Identificaci\xF3n oficial del titular de la Direcci\xF3n General de Desarrollo Social")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[10].status",defaultValue:revision.instance.body&&revision.instance.body[10]?revision.instance.body[10].status:'success',component:__WEBPACK_IMPORTED_MODULE_2__forms_notification_status__["a" /* default */],changeAction:function changeAction(model,value){return _this10._changeStatus(model,value,{field:'delegacy_identification_social',model:'revision.instance.body[10].field'});},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:"[10].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"[10].comment",className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"[10].allow_edit",id:"official_id",component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.instance.body&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[10])&&!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(revision.instance.body[10].allow_edit)?revision.instance.body[10].allow_edit:'false'})))))));}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.field);}}]);return DelegacyDocs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_revision_agreements__ = __webpack_require__(707);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RevisionAgreements=function(_Component){_inherits(RevisionAgreements,_Component);_createClass(RevisionAgreements,[{key:'render',value:function render(){var _props=this.props,agreements=_props.agreements,revision=_props.revision;return agreements.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_revision_agreements__["a" /* default */],{agreements:agreements,revision:revision,type:this.props.match.params.type,modality:this.props.match.params.modality,state:this.props.match.params.state,municipality:this.props.match.params.municipality,municipalities:this.props.municipalities,changeStatus:this._changeStatus,fetchMunicipalities:this.fetchMunicipalities,saveAgreements:this.saveAgreement});}}]);function RevisionAgreements(props){_classCallCheck(this,RevisionAgreements);var _this=_possibleConstructorReturn(this,(RevisionAgreements.__proto__||Object.getPrototypeOf(RevisionAgreements)).call(this,props));_this._changeStatus=_this._changeStatus.bind(_this);_this.saveAgreement=_this.saveAgreement.bind(_this);_this.fetchMunicipalities=_this.fetchMunicipalities.bind(_this);return _this;}_createClass(RevisionAgreements,[{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality,modality=_props$match$params.modality,type=_props$match$params.type;//this.props.notificationTypesFetch();
return this.props.fetchProjectAgreementsWithRevision(modality,state,municipality,type==='administrativo'?'admin':'legal');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextprops){if(nextprops.match.params!==this.props.match.params){var _nextprops$match$para=nextprops.match.params,modality=_nextprops$match$para.modality,state=_nextprops$match$para.state,municipality=_nextprops$match$para.municipality,type=_nextprops$match$para.type;//this.props.notificationTypesFetch();
return this.props.fetchProjectAgreementsWithRevision(modality,state,municipality,type==='administrativo'?'admin':'legal');}}},{key:'_changeStatus',value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.field);}},{key:'saveAgreement',value:function saveAgreement(type,modality,state,municipality,values){this.props.saveAgreements(type,modality,state,municipality,values);}},{key:'fetchMunicipalities',value:function fetchMunicipalities(agency){this.props.fetchMunicipalities(agency);}}]);return RevisionAgreements;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(RevisionAgreements,{title:'Revisión de Convenios',subnav:{icon:'fa-check-square-o',name:'Revisión'},stateNav:true}));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_notification_status__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_edit_status__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_config__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AgreementsEditForm=function(_Component){_inherits(AgreementsEditForm,_Component);function AgreementsEditForm(){_classCallCheck(this,AgreementsEditForm);return _possibleConstructorReturn(this,(AgreementsEditForm.__proto__||Object.getPrototypeOf(AgreementsEditForm)).apply(this,arguments));}_createClass(AgreementsEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,agreements=_props.agreements,revision=_props.revision,type=_props.type,modality=_props.modality,state=_props.state,municipality=_props.municipality,municipalities=_props.municipalities,changeStatus=_props.changeStatus;var fiscal_entity=!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data.agency)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data.agency.fiscal_entity)?agreements.data.agency.fiscal_entity:undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'revision',onSubmit:function onSubmit(values){return _this2._handleSubmit(values);}},!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.phase_group)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title is-3',dangerouslySetInnerHTML:{__html:'Revisi\xF3n - '+revision.phase_group.name}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},modality==='modalidad-i'?'Modalidad I':modality==='modalidad-ii'?'Modalidad II':'Modalidad III'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-6'},'DATOS DEL PROYECTO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Nombre de la instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data.agency)?agreements.data.agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Nombre del proyecto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data)?agreements.data.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'A\xF1o'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data.agency)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data.agency.version)?agreements.data.agency.version.year:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Entidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data.agency)?agreements.data.agency.agenciable.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Naturaleza jur\xEDdica'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data.agency)?agreements.data.agency.legal_nature:'---'))))),type==='administrativo'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-6'},'INFORMACI\xD3N'):'',type==='administrativo'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3,className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'ENTIDAD FISCAL DE LA INSTANCIA'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.name?fiscal_entity.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'RFC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.rfc?fiscal_entity.rfc:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Municipio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(municipalities.list,{id:fiscal_entity.municipality_id})!==undefined?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(municipalities.list,{id:fiscal_entity.municipality_id}).name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'C\xF3digo postal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.cp?fiscal_entity.cp:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Colonia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.colony?fiscal_entity.colony:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Direcci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.street?fiscal_entity.street:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'N\xFAmero exterior'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.num_ext?fiscal_entity.num_ext:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'N\xFAmero Interior'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.num_int?fiscal_entity.num_int:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'.agreements.admin.body',component:'tbody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'[0].status',defaultValue:revision.agreements.admin.body&&revision.agreements.admin.body[0]?revision.agreements.admin.body[0].status:'success',changeAction:function changeAction(model,value){return changeStatus(model,value,{field:'entity_fiscal',model:'revision.agreements.admin.body[0].field'});},component:__WEBPACK_IMPORTED_MODULE_3__forms_notification_status__["a" /* default */],errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'[0].status',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'[0].comment',className:'input',placeholder:'Comentario'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'[0].allow_edit',component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.agreements.admin.body&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.agreements.admin.body[0])&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.agreements.admin.body[0].allow_edit)?revision.agreements.admin.body[0].allow_edit:'false'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3,className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'DATOS BANCARIOS'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Nombre de banco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.bank_name?fiscal_entity.bank_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'N\xFAmero de cuenta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.bank_account?fiscal_entity.bank_account:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Clave bancaria estandarizada(CLABE 18 digitos)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.bank_clabe?fiscal_entity.bank_clabe:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Municipio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(municipalities.list,{id:fiscal_entity.municipality_id})!==undefined?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(municipalities.list,{id:fiscal_entity.municipality_id}).name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'C\xF3digo postal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.bank_cp?fiscal_entity.bank_cp:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Colonia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.bank_colony?fiscal_entity.bank_colony:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Direcci\xF3n de la sucursal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.bank_street?fiscal_entity.bank_street:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'N\xFAmero exterior'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.bank_num_ext?fiscal_entity.bank_num_ext:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'N\xFAmero Interior'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(fiscal_entity)&&fiscal_entity.bank_num_int?fiscal_entity.bank_num_int:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'.agreements.admin.body',component:'tbody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'[1].status',defaultValue:revision.agreements.admin.body&&revision.agreements.admin.body[1]?revision.agreements.admin.body[1].status:'success',changeAction:function changeAction(model,value){return changeStatus(model,value,{field:'bank_data',model:'revision.agreements.admin.body[1].field'});},component:__WEBPACK_IMPORTED_MODULE_3__forms_notification_status__["a" /* default */],errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'[1].status',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'[1].comment',className:'input',placeholder:'Comentario'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'[1].allow_edit',component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:revision.agreements.admin.body&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.agreements.admin.body[1])&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.agreements.admin.body[1].allow_edit)?revision.agreements.admin.body[1].allow_edit:'false'})))))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-6'},'DOCUMENTACI\xD3N'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:type==='juridica'?'.agreements.legal.body':'.agreements.admin.body',component:'tbody'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(agreements.documents_items,function(o){return o.documentable_type===(type==='juridica'?'projects':'agencies')&&(o.modality_id===null||o.modality_id===(agreements.data?agreements.data.modality_id:undefined));}),function(item,d){var document=agreements.data&&agreements.data.documents&&agreements.data.documents[item.slug]&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isObject(agreements.data.documents[item.slug])?agreements.data.documents[item.slug]:undefined;var status='success';var allow_edit='false';if(type==='juridica'){status=revision.agreements.legal.body&&revision.agreements.legal.body[item.id]?revision.agreements.legal.body[item.id].status:'success';allow_edit=revision.agreements.legal.body&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.agreements.legal.body[item.id])&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.agreements.legal.body[item.id].allow_edit)?revision.agreements.legal.body[item.id].allow_edit:'false';}else{status=revision.agreements.admin.body&&revision.agreements.admin.body[item.id]?revision.agreements.admin.body[item.id].status:'success';allow_edit=revision.agreements.admin.body&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.agreements.admin.body[item.id])&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.agreements.admin.body[item.id].allow_edit)?revision.agreements.admin.body[item.id].allow_edit:'false';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',className:'button is-info',href:document,disabled:document?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-link'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'['+item.id+'].status',id:'['+item.id+'].status',defaultValue:status,changeAction:function changeAction(model,value){return changeStatus(model,value,{field:item.slug,model:'revision.agreements.'+(type==='juridica'?'legal':'admin')+'.body['+item.id+'].field'});},component:__WEBPACK_IMPORTED_MODULE_3__forms_notification_status__["a" /* default */],errors:{required:__WEBPACK_IMPORTED_MODULE_2__field_validations__["m" /* required */]},validateOn:'change'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'['+item.id+'].status',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'['+item.id+'].comment',id:'['+item.id+'].comment',className:'input',placeholder:'Comentario'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'['+item.id+'].allow_edit',id:'['+item.id+'].allow_edit',component:__WEBPACK_IMPORTED_MODULE_4__forms_edit_status__["a" /* default */],defaultValue:allow_edit}))))));}))),!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.notifications_types)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'NOTIFICACI\xD3N'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'label'},'Tipo de notificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:type==='juridica'?'.agreements.legal.notification_type_id':'.agreements.admin.notification_type_id',id:'status',parser:__WEBPACK_IMPORTED_MODULE_6__parsers__["c" /* toInt */],className:'select',validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'--- Tipo ---'),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(revision.notifications_types,function(opc,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:opc.id,key:k},opc.name);})))),modality==='modalidad-i'&&revision.agreements.bank_check_show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',className:'button is-info',href:__WEBPACK_IMPORTED_MODULE_7__store_config__["A" /* AUTH_URL */]+'/projects/register/agencies/fiscalentity/bank-check-pdf/'+modality+'/'+state+(municipality?'/'+municipality:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-link'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Generar solicitud de cheque y/o transferencia'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'revision',className:'button is-success'},'Guardar Comentarios'))))));}},{key:'componentWillMount',value:function componentWillMount(){var _props2=this.props,modality=_props2.modality,agreements=_props2.agreements;if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(agreements.data.agency)){if(modality==='modalidad-i'||modality==='modalidad-iii'){this.props.fetchMunicipalities(agreements.data.agency.agenciable_id);}else{this.props.fetchMunicipalities(agreements.data.agency.agenciable.state_id);}}}},{key:'_handleSubmit',value:function _handleSubmit(values){var _props3=this.props,modality=_props3.modality,state=_props3.state,municipality=_props3.municipality,type=_props3.type;return this.props.saveAgreements(type==='administrativo'?'admin':'legal',modality,state,municipality,values);}}]);return AgreementsEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AgreementsEditForm);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_revision_reports__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_revision_reports_financial__ = __webpack_require__(710);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RevisionReportsFinancial=function(_Component){_inherits(RevisionReportsFinancial,_Component);function RevisionReportsFinancial(){_classCallCheck(this,RevisionReportsFinancial);return _possibleConstructorReturn(this,(RevisionReportsFinancial.__proto__||Object.getPrototypeOf(RevisionReportsFinancial)).apply(this,arguments));}_createClass(RevisionReportsFinancial,[{key:'render',value:function render(){var revision=this.props.revision;return revision.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_revision_reports_financial__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.reset('reports');this.props.fetchRevisionReports('project-report-goals',modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.match.params!==this.props.match.params){this.props.reset('revision.reports.financial.agency');this.props.fetchRevisionReports('project-report-goals',modality,state,municipality);}}}]);return RevisionReportsFinancial;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_revision_reports__["a" /* default */])(RevisionReportsFinancial,{subnav:1}));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_config__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RevisionReportsSubnav=function(_Component){_inherits(RevisionReportsSubnav,_Component);function RevisionReportsSubnav(){_classCallCheck(this,RevisionReportsSubnav);return _possibleConstructorReturn(this,(RevisionReportsSubnav.__proto__||Object.getPrototypeOf(RevisionReportsSubnav)).apply(this,arguments));}_createClass(RevisionReportsSubnav,[{key:"render",value:function render(){var params=this.props.params;var currentStep=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3__store_config__["_269" /* revisionReportsInitNav */],{step:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.props.step)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnavigation-projects"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,currentStep?currentStep.title:''," - ",this.props.agency?this.props.agency:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,params.modality==='modalidad-i'?'Categoría A':params.modality==='modalidad-ii'?'Modalidad II':'Modalidad III'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-step"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},__WEBPACK_IMPORTED_MODULE_3__store_config__["_269" /* revisionReportsInitNav */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level context-navigation"},__WEBPACK_IMPORTED_MODULE_3__store_config__["_269" /* revisionReportsInitNav */].map(function(item,k){var projectLink=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(item.url,':modality',params.modality),':state?',params.state==='undefined'?params.municipalities[0].state.short:params.state),':municipality?',params.municipality===null?params.municipalities[0].slug:params.municipality),'undefined','');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item",key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:"step",to:projectLink,activeClassName:"active"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,item.step),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.title)));})):''))));}}]);return RevisionReportsSubnav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RevisionReportsSubnav);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_edit_status__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_notification_status__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsFinancialEditForm=function(_Component){_inherits(ReportsFinancialEditForm,_Component);_createClass(ReportsFinancialEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,reports=_props.reports,revision=_props.revision;var modality=this.props.match.params.modality;var financial=reports.financial,summary=reports.summary;var styleActions={position:'relative',display:'inline',top:'1.7em',left:'-29px',width:'30px'};var styleActionsActivity={position:'relative',display:'inline',width:'30px'};var rc=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(revision.permissions,function(o){return o==='Create';})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-11"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"revision",onSubmit:function onSubmit(values){return _this2._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"DATOS DEL PROYECTO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2,style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Titular"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)?summary.data.agency.owner.name+" "+summary.data.agency.owner.last_name+" "+summary.data.agency.owner.slast_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:modality==='modalidad-ii'?1:2,style:{width:modality==='modalidad-ii'?'25%':'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Entidad"),modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this._stateName()):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.agenciable?summary.data.agency.agenciable.name:'---')),modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:1,style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Municipio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.agenciable?summary.data.agency.agenciable.name:'---')):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.name?summary.data.agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)&&summary.data.name?summary.data.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto aprobado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.goals?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.goals.total):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto ejercido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.goals?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.goals.spent):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto por ejercer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.goals?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.goals.missing):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Periodo de ejecuci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_moment_moment___default()(summary.data.execution_start).format('MMMM YYYY'))," a ",__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_moment_moment___default()(summary.data.execution_end).format('MMMM YYYY'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"METAS DEL PROYECTO"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(financial.data.proigualdad_axis,function(axis,key){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{key:"table-"+key,model:".reports.financial.body.goals",component:"table",className:"table is-fullwidth project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(axis.project_goals,function(row,k){var validCdm=false;var versionPhaseGoal=undefined;var agencyId=undefined;var findAgency=undefined;var goalDocument=undefined;var goalInvoices=undefined;var validGoalShow=undefined;var goalRevision=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.body)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.body.goals)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.body.goals[row.id])?revision.reports.financial.body.goals[row.id]:undefined;var goalRevisionAllowEdit=goalRevision&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goalRevision.allow_edit)?goalRevision.allow_edit:'false';var goalRevisionCdm=undefined;var goalRevisionCdmAllowEdit='false';var styleActionGoalButton={display:'inline',//marginBottom: '7px',
border:0,backgroundColor:'transparent',color:'#662d91',cursor:'pointer'};if(modality!=='modalidad-iii'){validGoalShow=true;versionPhaseGoal=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(row.project_version_phase_goal)?row.project_version_phase_goal:undefined;goalInvoices=versionPhaseGoal;goalDocument=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versionPhaseGoal)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versionPhaseGoal.documents)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(versionPhaseGoal.documents,{documentable_subtype:"goal_document"}):undefined;}else{validCdm=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.agency)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.agency[key])&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.agency[key][k])&&revision.reports.financial.agency[key][k].id!==''?true:false;agencyId=validCdm?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(revision.reports.financial.agency[key][k].id):undefined;versionPhaseGoal=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(row.project_version_phase_goal)&&validCdm?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(row.project_version_phase_goal,{agency_id:agencyId}):undefined;goalDocument=versionPhaseGoal&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versionPhaseGoal.documents)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(versionPhaseGoal.documents,{documentable_subtype:"goal_document"}):undefined;validGoalShow=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isNumber(agencyId)?true:false;goalRevisionCdm=agencyId&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.body)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.body.goals)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.body.goals[row.id])&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.financial.body.goals[row.id].agencies[agencyId])?revision.reports.financial.body.goals[row.id].agencies[agencyId]:undefined;goalRevisionCdmAllowEdit=goalRevisionCdm&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goalRevisionCdm.allow_edit)?goalRevisionCdm.allow_edit:'false';findAgency=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(row.agencies,{id:agencyId});if(Boolean(row.requires_employees)){goalInvoices=versionPhaseGoal;}else{goalInvoices=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(row.project_version_phase_goal)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(row.project_version_phase_goal,{agency_id:financial.data.agency_id}):undefined;}if(validGoalShow){styleActionGoalButton=Object.assign({},styleActionGoalButton);}else{styleActionGoalButton=Object.assign({},styleActionGoalButton,{color:'grey',cursor:'not-allowed'});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3,className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"Eje tem\xE1tico"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row&&row.axis?row.axis.name:'---'))),modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"agency_id_"+k,className:"label"},"CDM'S"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:"revision.reports.financial.agency["+key+"]["+k+"].id",name:"agency_id_"+k,id:"agency_id_"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""}," -- CDM'S --"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(row.agencies,function(cdm,o){var cdmStatus=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(row.project_version_phase_goal,{agency_id:cdm.id});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:o,value:cdm.id,className:cdmStatus&&cdmStatus.status?"has-text-"+cdmStatus.status.style:''},cdm.agenciable&&cdm.agenciable.name?cdm.agenciable.name:'---');})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notification is-info"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-info"}),"\xA0 Seleccionar CDM para llenar revisi\xF3n ")))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"L\xEDnea de acci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row&&row.line?row.line.name:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-inm-purple"},"C\xF3digo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-inm-purple"},row.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'70%',padding:'0em .5em 1em 30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",style:styleActions},validGoalShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"field-notification",style:{backgroundColor:'#fff',top:'-'+100+'%',transform:'translateY(-100%)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Estatus"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),versionPhaseGoal&&versionPhaseGoal.status_id!==0&&versionPhaseGoal.status_id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-"+versionPhaseGoal.status.style},versionPhaseGoal.status.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Sin estatus"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Motivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),versionPhaseGoal&&versionPhaseGoal.status_motive?versionPhaseGoal.status_motive.name:'N/A'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",style:styleActionGoalButton,disabled:validGoalShow?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:'0em .5em 1em 30px'}},_this2.state.modalMessageExpensesGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageExpenseGoal,Object.assign({active:_this2.state.modalMessageExpensesGoalShow,amounts:row.amounts,data:goalInvoices,findAgency:findAgency,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions",style:styleActions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",style:styleActionGoalButton,onClick:function onClick(){return _this2._showMessageExpensesGoal(key,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Gastos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-inm-purple"},"Monto ejercido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.amounts.spent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-inm-purple"},"Monto por ejercer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.amounts.missing)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto de gasto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.resource_concept?row.resource_concept.name:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:2},_this2.state.modalMessageActorsGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageActors,{active:_this2.state.modalMessageActorsGoalShow,actors:row.actors,closeModal:function closeModal(){return _this2._toggleModal();}}):'',_this2.state.modalMessageConagoGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageConago,{active:_this2.state.modalMessageConagoGoalShow,conago_clauses:row.conago_clauses,closeModal:function closeModal(){return _this2._toggleModal();}}):'',modality==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons",style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageConago(key,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-light"},"Metas CONAGO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-white"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(row.conago_clauses))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons",style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageActors(key,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-light"},"Actores estrat\xE9gicos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-white"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(row.actors))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:'0em .5em 1em 30px'}},_this2.state.modalMessageDocumentGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageDocumentGoal,Object.assign({active:_this2.state.modalMessageDocumentGoalShow,goalDocument:goalDocument,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",style:styleActions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",style:styleActionGoalButton,onClick:function onClick(){return _this2._showMessageDocument(key,k);},disabled:validGoalShow?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Documento meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.goal_document)))),validGoalShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n de la meta "+row.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+row.id+"].status",key:"status_"+row.id,id:"status_"+row.id,component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:goalRevision&&goalRevision.status?goalRevision.status:'success',changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{id:row.id,model:"revision.reports.financial.body.goals["+row.id+"].id"});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"["+row.id+"].comment",key:"comment_"+row.id,id:"comment_"+row.id,className:"input is-small is-fullwidth",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+row.id+"].allow_edit",key:"edit_status_"+row.id,id:"edit_status_"+row.id,component:__WEBPACK_IMPORTED_MODULE_5__forms_edit_status__["a" /* default */],defaultValue:goalRevisionAllowEdit})))))):null,modality==='modalidad-iii'?findAgency?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n de la meta "+row.code+" por CDM - "+findAgency.agenciable.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+row.id+"].agencies["+agencyId+"].status",key:"status_"+row.id+"_rev"+agencyId,id:"status_"+row.id+"_rev"+agencyId,component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:goalRevisionCdm&&goalRevisionCdm.status?goalRevisionCdm.status:'success',changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{id:row.id,model:"revision.reports.financial.body.goals["+row.id+"].agencies["+agencyId+"].id"});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"["+row.id+"].agencies["+agencyId+"].comment",key:"comment_"+row.id+"_rev"+agencyId,id:"comment_"+row.id+"_rev"+agencyId,className:"input is-small is-fullwidth",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+row.id+"].agencies["+agencyId+"].allow_edit",key:"edit_status_"+row.id+"_rev"+agencyId,id:"edit_status_"+row.id+"_rev"+agencyId,component:__WEBPACK_IMPORTED_MODULE_5__forms_edit_status__["a" /* default */],defaultValue:goalRevisionCdmAllowEdit})))))):null:null,validGoalShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:"["+row.id+"]"+(modality==='modalidad-iii'&&findAgency?".agencies["+agencyId+"]":'')+".activities",component:"tr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-activity-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Actividad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Medio de verificaci\xF3n"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(row.project_goal_activities,function(activity,o){var actRevision=undefined;var actRevisionAllowedit=undefined;var versionPhaseGoalActivity=undefined;var activityDocument=undefined;//goalRevisionCdm
if(modality!=='modalidad-iii'){actRevision=goalRevision&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goalRevision.activities)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goalRevision.activities[activity.id])?goalRevision.activities[activity.id]:undefined;actRevisionAllowedit=actRevision&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(actRevision.allow_edit)?actRevision.allow_edit:'false';versionPhaseGoalActivity=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(activity.project_version_phase_goal_activity)?activity.project_version_phase_goal_activity:undefined;activityDocument=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versionPhaseGoalActivity)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versionPhaseGoalActivity.documents)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(versionPhaseGoalActivity.documents,{documentable_subtype:"verification_media"}):undefined;}else{actRevision=goalRevisionCdm&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goalRevisionCdm.activities)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goalRevisionCdm.activities[activity.id])?goalRevisionCdm.activities[activity.id]:undefined;actRevisionAllowedit=actRevision&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(actRevision.allow_edit)?actRevision.allow_edit:'false';versionPhaseGoalActivity=validCdm?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(activity.project_version_phase_goal_activity,{agency_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(agencyId)}):undefined;activityDocument=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versionPhaseGoalActivity)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(versionPhaseGoalActivity.documents)?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(versionPhaseGoalActivity.documents,{documentable_subtype:"verification_media"}):undefined;}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,activity.proigualdad_activity_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:'0em .5em 1em 30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",style:styleActionsActivity},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"field-notification",style:{backgroundColor:'#fff',top:'-'+100+'%',transform:'translateY(-100%)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Estatus"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),versionPhaseGoalActivity&&versionPhaseGoalActivity.status_id!==0&&versionPhaseGoalActivity.status_id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-"+versionPhaseGoalActivity.status.style},versionPhaseGoalActivity.status.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Sin estatus"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Motivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),versionPhaseGoalActivity&&versionPhaseGoalActivity.status_motive?versionPhaseGoalActivity.status_motive.name:'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",style:styleActionGoalButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))),activity.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{padding:'0em .5em 1em 30px'}},_this2.state.modalMessageMediaActivityShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex&&o===_this2.state.activityIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageMediaActivity,Object.assign({active:_this2.state.modalMessageMediaActivityShow,activityDocument:activityDocument,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",style:styleActionsActivity},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",style:styleActionGoalButton,onClick:function onClick(){return _this2._showMessageMedia(key,k,o);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))),activity.verification_media?activity.verification_media.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"rev-"+o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n de la actividad "+activity.proigualdad_activity_id+(modality==='modalidad-iii'&&findAgency?" por CDM - "+findAgency.agenciable.name:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+activity.id+"].status",key:"status_"+row.id+(agencyId?"_rev"+agencyId:''),id:"status_"+row.id+(agencyId?"_rev"+agencyId:''),component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:actRevision&&actRevision.status?actRevision.status:'success',changeAction:function changeAction(model,value){_this2._changeStatus(model,value,{id:activity.id,model:"revision.reports.financial.body.goals["+row.id+"]"+(modality==='modalidad-iii'&&findAgency?".agencies["+__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(agencyId)+"]":'')+".activities["+activity.id+"].id"});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"["+activity.id+"].comment",key:"comment_"+row.id+(agencyId?"_rev"+agencyId:''),id:"comment_"+row.id+(agencyId?"_rev"+agencyId:''),className:"input is-small is-fullwidth",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+activity.id+"].allow_edit",key:"edit_status_"+row.id+(agencyId?"_rev"+agencyId:''),id:"edit_status_"+row.id+(agencyId?"_rev"+agencyId:''),defaultValue:actRevisionAllowedit,component:__WEBPACK_IMPORTED_MODULE_5__forms_edit_status__["a" /* default */]}))))))];}))))):null);}))];}),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.notifications_types)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"NOTIFICACI\xD3N"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"",className:"label"},"Tipo de notificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:"revision.reports.financial.notification_type_id",id:"notification_type_id"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Tipo ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(revision.notifications_types,function(opc,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:opc.id,key:k},opc.name);})))))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.goBack();}},"Regresar")),rc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"revision",className:"button is-large is-primary"},"Guardar")):''))));}}]);function ReportsFinancialEditForm(){_classCallCheck(this,ReportsFinancialEditForm);var _this=_possibleConstructorReturn(this,(ReportsFinancialEditForm.__proto__||Object.getPrototypeOf(ReportsFinancialEditForm)).call(this));_this.state={axisIndex:undefined,goalIndex:undefined,activityIndex:undefined,modalMessageExpensesGoalShow:false,modalMessageDocumentGoalShow:false,modalMessageMediaActivityShow:false,modalMessageActorsGoalShow:false,modalMessageConagoGoalShow:false};return _this;}_createClass(ReportsFinancialEditForm,[{key:"_submitForm",value:function _submitForm(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.saveRevisionReportsFinancial(modality,state,municipality,values);}},{key:"_stateName",value:function _stateName(){var _props2=this.props,entities=_props2.entities,reports=_props2.reports;if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(reports.summary.data)){var state=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(entities.list,{id:reports.summary.data.agency.agenciable.state_id});return state?state.name:'---';}}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.id);}},{key:"_showMessageExpensesGoal",value:function _showMessageExpensesGoal(indexAxis,indexGoal){this.setState({modalMessageExpensesGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:"_showMessageDocument",value:function _showMessageDocument(indexAxis,indexGoal){this.setState({modalMessageDocumentGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:"_showMessageMedia",value:function _showMessageMedia(indexAxis,indexGoal,indexActivity){this.setState({modalMessageMediaActivityShow:true,axisIndex:indexAxis,goalIndex:indexGoal,activityIndex:indexActivity});}},{key:"_showMessageActors",value:function _showMessageActors(indexAxis,indexGoal){this.setState({modalMessageActorsGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:"_showMessageConago",value:function _showMessageConago(indexAxis,indexGoal){this.setState({modalMessageConagoGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:"_toggleModal",value:function _toggleModal(){this.setState({modalMessageExpensesGoalShow:false,modalMessageDocumentGoalShow:false,modalMessageMediaActivityShow:false,modalMessageActorsGoalShow:false,modalMessageConagoGoalShow:false});}}]);return ReportsFinancialEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReportsFinancialEditForm);var ModalMessageExpenseGoal=function(_Component2){_inherits(ModalMessageExpenseGoal,_Component2);function ModalMessageExpenseGoal(){_classCallCheck(this,ModalMessageExpenseGoal);return _possibleConstructorReturn(this,(ModalMessageExpenseGoal.__proto__||Object.getPrototypeOf(ModalMessageExpenseGoal)).apply(this,arguments));}_createClass(ModalMessageExpenseGoal,[{key:"render",value:function render(){var _props3=this.props,data=_props3.data,amounts=_props3.amounts,match=_props3.match,findAgency=_props3.findAgency;var modality=match.params.modality;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content",style:{height:!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.invoices)||__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Gastos de la meta",modality==='modalidad-iii'&&findAgency?" por CDM - "+findAgency.agenciable.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"delete","aria-label":"delete",onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Monto aprobado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(amounts.total)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Monto ejercido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(amounts.spent))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},modality==='modalidad-iii'&&data&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.amounts)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Monto ejercido - "+findAgency.agenciable.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(data.amounts.spent_total)))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Monto por ejercer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(amounts.missing))))),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.invoices)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Facturas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Factura"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"PDF"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"XML"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"SAT"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data.invoices,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,item.date+" - "+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.pdf,className:"button is-info",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.xml,className:"button is-info",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.sat,className:"button is-info",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))))));})))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"modal-close is-large","aria-label":"close",onClick:this.props.closeModal}));}}]);return ModalMessageExpenseGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageDocumentGoal=function(_Component3){_inherits(ModalMessageDocumentGoal,_Component3);function ModalMessageDocumentGoal(){_classCallCheck(this,ModalMessageDocumentGoal);return _possibleConstructorReturn(this,(ModalMessageDocumentGoal.__proto__||Object.getPrototypeOf(ModalMessageDocumentGoal)).apply(this,arguments));}_createClass(ModalMessageDocumentGoal,[{key:"render",value:function render(){var goalDocument=this.props.goalDocument;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content",style:{height:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(goalDocument)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Documentos meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"delete","aria-label":"delete",onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"El documento generado da cumplimiento a los requerimientos de las Reglas de Operaci\xF3n y fue realizado a entera satisfacci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goalDocument?'Si':'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\xBFLas tem\xE1ticas abordadas y las aportaciones realizadas en los eventos desarrollados (talleres, mesas de trabajo y otros) fueron incluidas en el documento meta?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goalDocument?'Si':'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Archivos")),goalDocument?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(goalDocument,function(item,k){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.file,key:k,target:"_blank"},"Archivo - "+(k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",{key:'br_'+k})];}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"modal-close is-large","aria-label":"close",onClick:this.props.closeModal}));}}]);return ModalMessageDocumentGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageMediaActivity=function(_Component4){_inherits(ModalMessageMediaActivity,_Component4);function ModalMessageMediaActivity(){_classCallCheck(this,ModalMessageMediaActivity);return _possibleConstructorReturn(this,(ModalMessageMediaActivity.__proto__||Object.getPrototypeOf(ModalMessageMediaActivity)).apply(this,arguments));}_createClass(ModalMessageMediaActivity,[{key:"render",value:function render(){var activityDocument=this.props.activityDocument;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content",style:{height:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(activityDocument)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Medio de verificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"delete","aria-label":"delete",onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Archivos")),activityDocument?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(activityDocument,function(item,k){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.file,key:k,target:"_blank"},"Archivo - "+(k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",{key:'br_'+k})];}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"---"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"modal-close is-large","aria-label":"close",onClick:this.props.closeModal}));}}]);return ModalMessageMediaActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageActors=function(_Component5){_inherits(ModalMessageActors,_Component5);function ModalMessageActors(){_classCallCheck(this,ModalMessageActors);return _possibleConstructorReturn(this,(ModalMessageActors.__proto__||Object.getPrototypeOf(ModalMessageActors)).apply(this,arguments));}_createClass(ModalMessageActors,[{key:"render",value:function render(){var actors=this.props.actors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Actores estrat\xE9gicos que aplican"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:this.props.closeModal,className:"delete is-medium","aria-label":"delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(actors,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:k,type:"disc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},item.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-info",type:"button",onClick:this.props.closeModal},"Cerrar")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"modal-close is-large","aria-label":"close",onClick:this.props.closeModal}));}}]);return ModalMessageActors;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageConago=function(_Component6){_inherits(ModalMessageConago,_Component6);function ModalMessageConago(){_classCallCheck(this,ModalMessageConago);return _possibleConstructorReturn(this,(ModalMessageConago.__proto__||Object.getPrototypeOf(ModalMessageConago)).apply(this,arguments));}_createClass(ModalMessageConago,[{key:"render",value:function render(){var conago_clauses=this.props.conago_clauses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Metas conago que aplican"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:this.props.closeModal,className:"delete is-medium","aria-label":"delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(conago_clauses,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:k,type:"disc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},item.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-info",type:"button",onClick:this.props.closeModal},"Cerrar")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"modal-close is-large","aria-label":"close",onClick:this.props.closeModal}));}}]);return ModalMessageConago;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_revision_reports__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_revision_reports_expenses__ = __webpack_require__(712);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RevisionReportsExpenses=function(_Component){_inherits(RevisionReportsExpenses,_Component);function RevisionReportsExpenses(){_classCallCheck(this,RevisionReportsExpenses);return _possibleConstructorReturn(this,(RevisionReportsExpenses.__proto__||Object.getPrototypeOf(RevisionReportsExpenses)).apply(this,arguments));}_createClass(RevisionReportsExpenses,[{key:"render",value:function render(){var revision=this.props.revision;return revision.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_revision_reports_expenses__["a" /* default */],this.props);}},{key:"componentWillMount",value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.reset('reports');this.props.fetchRevisionReports('project-report-expenses',modality,state,municipality);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.match.params!==this.props.match.params){this.props.reset('revision.reports.expenses.agency');this.props.fetchRevisionReports('project-report-expenses',modality,state,municipality);}}}]);return RevisionReportsExpenses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_revision_reports__["a" /* default */])(RevisionReportsExpenses,{subnav:2}));

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_edit_status__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_notification_status__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsExpensesEditForm=function(_Component){_inherits(ReportsExpensesEditForm,_Component);_createClass(ReportsExpensesEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,reports=_props.reports,revision=_props.revision;var modality=this.props.match.params.modality;var summary=reports.summary;var styleActions={position:'relative',display:'inline',top:'1.7em',left:'-29px',width:'30px'};var styleActionButton={display:'inline',border:0,backgroundColor:'transparent',color:'#662d91',cursor:'pointer'};var rc=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(revision.permissions,function(o){return o==='Create';})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-11"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"revision",onSubmit:function onSubmit(values){return _this2._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"DATOS DEL PROYECTO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2,style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Titular"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)?summary.data.agency.owner.name+" "+summary.data.agency.owner.last_name+" "+summary.data.agency.owner.slast_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:modality==='modalidad-ii'?1:2,style:{width:modality==='modalidad-ii'?'25%':'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Entidad"),modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this._stateName()):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.agenciable?summary.data.agency.agenciable.name:'---')),modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:1,style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Municipio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.agenciable?summary.data.agency.agenciable.name:'---')):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.name?summary.data.agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data)&&summary.data.name?summary.data.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto aprobado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.expenses?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.expenses.total):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto ejercido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.expenses?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.expenses.spent):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto por ejercer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.expenses?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.expenses.missing):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Periodo de ejecuci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_moment_moment___default()(summary.data.execution_start).format('MMMM YYYY'))," a ",__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_moment_moment___default()(summary.data.execution_end).format('MMMM YYYY'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"GASTOS DE COORDINACI\xD3N"),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(summary.data.project_expenses)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".reports.expenses.body",component:"table",className:"is-fullwidth table project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(summary.data.project_expenses,function(row,k){var expenseRevision=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.expenses.body)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.expenses.body[row.id])?revision.reports.expenses.body[row.id]:undefined;var expenseRevisionAllowEdit=expenseRevision&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(expenseRevision.allow_edit)?expenseRevision.allow_edit:'false';var expenseRevisionCdm=undefined;//let expenseRevisionCdmAllowEdit = undefined;
var validCdm=false;var agencyId=undefined;var findAgency=undefined;if(modality==='modalidad-iii'){validCdm=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.expenses.agency)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.expenses.agency[k])&&revision.reports.expenses.agency[k].id!==''?true:false;agencyId=validCdm?__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(revision.reports.expenses.agency[k].id):undefined;findAgency=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(row.project_expense_agencies,{id:agencyId});expenseRevisionCdm=findAgency&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.expenses.body)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.expenses.body[row.id])&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.expenses.body[row.id].agencies)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.reports.expenses.body[row.id].agencies[findAgency.agency_id])?revision.reports.expenses.body[row.id].agencies[findAgency.agency_id]:undefined;//expenseRevisionCdmAllowEdit = expenseRevisionCdm && !_.isEmpty(expenseRevisionCdm.allow_edit) ? expenseRevisionCdm.allow_edit:'false';
}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"concept-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:modality!=='modalidad-iii'?6:8,className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"Concepto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.expense_concept?row.expense_concept.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"unit-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:modality!=='modalidad-iii'?6:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Unidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.expense_unit?row.expense_unit.name:'---')))),modality==='modalidad-iii'&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(row.project_expense_agencies)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"cdms-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"agency_id_"+k,className:"label"},"CDM'S"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:"revision.reports.expenses.agency["+k+"].id",name:"agency_id_"+k,id:"agency_id_"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""}," -- CDM'S --"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(row.project_expense_agencies,function(cdm,o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:o,value:cdm.id},cdm.agenciable&&cdm.agenciable.name?cdm.agenciable.name:'---');})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notification is-info"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-info"}),"\xA0 Seleccionar CDM para llenar revisi\xF3n ")))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'5%',padding:'0em .5em 1em 30px'}},_this2.state.modalMessageExpensesShow&&k===_this2.state.expenseIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageExpenses,Object.assign({active:_this2.state.modalMessageExpensesShow,amountTotal:row.total,data:row.project_version_phase_expense,findAgency:findAgency,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",style:styleActions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",style:styleActionButton,onClick:function onClick(){return _this2._showMessageExpenses(k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-inm-purple"},"No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-inm-purple"},k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right",style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Valor unitario"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.amount?row.amount:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,row.quantity)),modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,findAgency?findAgency.agenciable.name:'---')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto aprobado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.amounts.total)))),modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto ejercido desglosado"),Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(findAgency?findAgency.amounts.spent:0)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto ejercido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.amounts.spent)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto por ejercer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.amounts.missing))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"exp-rev-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:modality!=='modalidad-iii'?6:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n del gasto No. ",k+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+row.id+"].status",key:"status_"+row.id,id:"status_"+row.id,component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:expenseRevision&&expenseRevision.status?expenseRevision.status:'success',changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{id:row.id,model:"revision.reports.expenses.body["+row.id+"].id"});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"["+row.id+"].comment",key:"comment_"+row.id,id:"comment_"+row.id,className:"input is-small is-fullwidth",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+row.id+"].allow_edit",key:"edit_status_"+row.id,id:"edit_status_"+row.id,component:__WEBPACK_IMPORTED_MODULE_5__forms_edit_status__["a" /* default */],defaultValue:expenseRevisionAllowEdit})))))),modality==='modalidad-iii'&&findAgency?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"exp-rev-cdm-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:modality!=='modalidad-iii'?6:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Revisi\xF3n del gasto No. "+(k+1)+" por CDM - "+findAgency.agenciable.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:"["+row.id+"].agencies["+findAgency.agency_id+"].status",key:"status_"+row.id+"_rev"+findAgency.agency_id,id:"status_"+row.id+"_rev"+findAgency.agency_id,component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:expenseRevisionCdm&&expenseRevisionCdm.status?expenseRevisionCdm.status:'success',changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{id:row.id,model:"revision.reports.expenses.body["+row.id+"].agencies["+findAgency.agency_id+"].id"});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:"["+row.id+"].agencies["+findAgency.agency_id+"].comment",key:"comment_"+row.id+"_rev"+findAgency.agency_id,id:"comment_"+row.id+"_rev"+findAgency.agency_id,className:"input is-small is-fullwidth",placeholder:"Comentario"}))))):null];}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Ning\xFAn gasto de coordinaci\xF3n guardado"),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(revision.notifications_types)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"NOTIFICACI\xD3N"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"",className:"label"},"Tipo de notificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:"revision.reports.expenses.notification_type_id",id:"notification_type_id"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Tipo ---"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(revision.notifications_types,function(opc,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:opc.id,key:k},opc.name);})))))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.goBack();}},"Regresar")),rc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"revision",className:"button is-large is-primary"},"Guardar")):''))));}}]);function ReportsExpensesEditForm(){_classCallCheck(this,ReportsExpensesEditForm);var _this=_possibleConstructorReturn(this,(ReportsExpensesEditForm.__proto__||Object.getPrototypeOf(ReportsExpensesEditForm)).call(this));_this.state={expenseIndex:undefined,modalMessageExpensesShow:false};return _this;}_createClass(ReportsExpensesEditForm,[{key:"_submitForm",value:function _submitForm(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.saveRevisionReportsExpenses(modality,state,municipality,values);}},{key:"_stateName",value:function _stateName(){var _props2=this.props,entities=_props2.entities,reports=_props2.reports;if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(reports.summary.data)){var state=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(entities.list,{id:reports.summary.data.agency.agenciable.state_id});return state?state.name:'---';}else{return'---';}}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.id);}},{key:"_showMessageExpenses",value:function _showMessageExpenses(indexExpense){this.setState({modalMessageExpensesShow:true,expenseIndex:indexExpense});}},{key:"_toggleModal",value:function _toggleModal(){this.setState({modalMessageExpensesShow:false});}}]);return ReportsExpensesEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReportsExpensesEditForm);var ModalMessageExpenses=function(_Component2){_inherits(ModalMessageExpenses,_Component2);function ModalMessageExpenses(){_classCallCheck(this,ModalMessageExpenses);return _possibleConstructorReturn(this,(ModalMessageExpenses.__proto__||Object.getPrototypeOf(ModalMessageExpenses)).apply(this,arguments));}_createClass(ModalMessageExpenses,[{key:"render",value:function render(){var _props3=this.props,data=_props3.data,amountTotal=_props3.amountTotal,match=_props3.match,findAgency=_props3.findAgency;var modality=match.params.modality;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content",style:{height:!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data)&&__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.invoices)||__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Gastos de la meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"delete","aria-label":"delete",onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Monto aprobado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(amountTotal)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Monto ejercido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(data&&data.amounts.spent_total?data.amounts.spent_total:0))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},modality==='modalidad-iii'&&findAgency&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(findAgency.amounts)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Monto ejercido - "+findAgency.agenciable.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(findAgency.amounts.spent)))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Monto por ejercer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(data&&data.amounts.missing?data.amounts.missing:amountTotal))))),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.invoices)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Facturas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Factura"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"PDF"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"XML"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"SAT"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data.invoices,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,item.date+" - "+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.pdf,className:"button is-info",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.xml,className:"button is-info",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.sat,className:"button is-info",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))))));})))):'',!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.receipts)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Comprobantes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Comprobante"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Archivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Concepto"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data.receipts,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,item.date+" - "+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.file,className:"button is-info",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-eye"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,item.concepts));})))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"modal-close is-large","aria-label":"close",onClick:this.props.closeModal}));}}]);return ModalMessageExpenses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_revision_reports__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_revision_reports_summary__ = __webpack_require__(714);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RevisionReportsSummary=function(_Component){_inherits(RevisionReportsSummary,_Component);function RevisionReportsSummary(){_classCallCheck(this,RevisionReportsSummary);return _possibleConstructorReturn(this,(RevisionReportsSummary.__proto__||Object.getPrototypeOf(RevisionReportsSummary)).apply(this,arguments));}_createClass(RevisionReportsSummary,[{key:"render",value:function render(){var revision=this.props.revision;return revision.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_revision_reports_summary__["a" /* default */],this.props);}},{key:"componentWillMount",value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.reset('reports');this.props.fetchRevisionReports('project-report-summary',modality,state,municipality);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.match.params!==this.props.match.params){this.props.fetchRevisionReports('project-report-summary',modality,state,municipality);}}}]);return RevisionReportsSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_revision_reports__["a" /* default */])(RevisionReportsSummary,{subnav:3}));

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_notification_status__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_edit_status__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsSummaryEditForm=function(_Component){_inherits(ReportsSummaryEditForm,_Component);function ReportsSummaryEditForm(){_classCallCheck(this,ReportsSummaryEditForm);return _possibleConstructorReturn(this,(ReportsSummaryEditForm.__proto__||Object.getPrototypeOf(ReportsSummaryEditForm)).apply(this,arguments));}_createClass(ReportsSummaryEditForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,reports=_props.reports,revision=_props.revision;var modality=this.props.match.params.modality;var summary=reports.summary;var rc=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(revision.permissions,function(o){return o==='Create';})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-11"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Form"],{model:"revision",onSubmit:function onSubmit(values){return _this2._submitForm(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"DATOS DEL PROYECTO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2,style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Titular"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summary.data)?summary.data.agency.owner.name+" "+summary.data.agency.owner.last_name+" "+summary.data.agency.owner.slast_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:modality==='modalidad-ii'?1:2,style:{width:modality==='modalidad-ii'?'25%':'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Entidad"),modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this._stateName()):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.agenciable?summary.data.agency.agenciable.name:'---')),modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:1,style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Municipio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.agenciable?summary.data.agency.agenciable.name:'---')):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.name?summary.data.agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summary.data)&&summary.data.name?summary.data.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto aprobado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.goals?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.goals.total):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto ejercido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.goals?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.goals.spent):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto por ejercer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",summary.data.amounts&&summary.data.amounts.goals?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(summary.data.amounts.goals.missing):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Periodo de ejecuci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_moment___default()(summary.data.execution_start).format('MMMM YYYY'))," a ",__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_moment___default()(summary.data.execution_end).format('MMMM YYYY'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title is-6"},"DOCUMENTOS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"is-fullwidth table project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Fieldset"],{model:".reports.summary.body",component:"tbody"},summary.data?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(summary.data.documents_items,function(item,d){var summaryRevision=!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(revision.reports.summary.body)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(revision.reports.summary.body[item.id])?revision.reports.summary.body[item.id]:undefined;var summaryRevisionAllowEdit=summaryRevision&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(summaryRevision.allow_edit)?summaryRevision.allow_edit:'false';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",className:"button is-info",href:summary.edit[item.slug],disabled:summary.edit[item.slug]?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Ver \""+item.name+"\"")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"],{model:"["+item.id+"].status",key:"status_"+item.id,id:"status_"+item.id,component:__WEBPACK_IMPORTED_MODULE_6__forms_notification_status__["a" /* default */],defaultValue:summaryRevision&&summaryRevision.status?summaryRevision.status:'success',changeAction:function changeAction(model,value){return _this2._changeStatus(model,value,{id:item.id,model:"revision.reports.summary.body["+item.id+"].id"});},errors:{required:__WEBPACK_IMPORTED_MODULE_5__field_validations__["m" /* required */]},validateOn:"change"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Errors"],{model:"["+item.id+"].status",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El estatus es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].text,{model:"["+item.id+"].comment",key:"comment_"+item.id,id:"comment_"+item.id,className:"input",placeholder:"Comentario"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"],{model:"["+item.id+"].allow_edit",key:"edit_status_"+item.id,id:"edit_status_"+item.id,component:__WEBPACK_IMPORTED_MODULE_7__forms_edit_status__["a" /* default */],defaultValue:summaryRevisionAllowEdit}))))));}):'')),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(revision.notifications_types)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"NOTIFICACI\xD3N"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"",className:"label"},"Tipo de notificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].select,{model:".reports.summary.notification_type_id",id:"notification_type_id"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"",defaultValue:true},"--- Tipo ---"),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(revision.notifications_types,function(opc,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:opc.id,key:k},opc.name);})))))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.goBack();}},"Regresar")),rc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_form__["Control"].button,{model:"revision",className:"button is-large is-primary"},"Guardar")):''))));}},{key:"_submitForm",value:function _submitForm(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.saveRevisionReportsSummary(modality,state,municipality,values);}},{key:"_stateName",value:function _stateName(){var _props2=this.props,entities=_props2.entities,reports=_props2.reports;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(reports.summary.data)){var state=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(entities.list,{id:reports.summary.data.agency.agenciable.state_id});return state?state.name:'---';}else{return'---';}}},{key:"_changeStatus",value:function _changeStatus(model,values,field){this.props.change(model,values);this.props.change(field.model,field.id);}}]);return ReportsSummaryEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReportsSummaryEditForm);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EntitiesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_entities_widget_entity_add__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_entities_widget_entity_search__ = __webpack_require__(716);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Entities=function(_Component){_inherits(Entities,_Component);function Entities(){_classCallCheck(this,Entities);return _possibleConstructorReturn(this,(Entities.__proto__||Object.getPrototypeOf(Entities)).apply(this,arguments));}_createClass(Entities,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EntitiesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){var entities=this.props.entities;this.props.entitiesShow(entities.pages.current,entities.filters);}}]);return Entities;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var EntitiesList=function(_Component2){_inherits(EntitiesList,_Component2);_createClass(EntitiesList,[{key:'render',value:function render(){var _this3=this;var entities=this.props.entities;var eu=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(entities.permissions,function(o){return o==='Update';});var ed=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(entities.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,entities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Short'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(entities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},eu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/entidades/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',ed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.short));}))),entities.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:entities.pages.current,total:entities.pages.total,nextPage:this._handlePageChange}));}}]);function EntitiesList(){_classCallCheck(this,EntitiesList);var _this2=_possibleConstructorReturn(this,(EntitiesList.__proto__||Object.getPrototypeOf(EntitiesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(EntitiesList,[{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el estado "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.deleteEntity(id);}});}},{key:'_handlePageChange',value:function _handlePageChange(value){var entities=this.props.entities;this.props.entitiesShow(value,entities.filters);}}]);return EntitiesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(Entities, {title: `Administrar Entidades`, subnav: {icon: 'fa-map', name: 'Administración', actions: {url: '/entidades/crear', name: 'Agregar Entidad'}}, search:'entities'});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(Entities,{title:'Administrar Entidades',subnav:{icon:'fa-map',name:'Administración',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_entities_widget_entity_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_entities_widget_entity_add__["a" /* default */],null)}]}}));

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from 'lodash';
var EntitySearch=function(_Component){_inherits(EntitySearch,_Component);_createClass(EntitySearch,[{key:"render",value:function render(){var entities=this.props.entities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:entities.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function EntitySearch(){_classCallCheck(this,EntitySearch);var _this=_possibleConstructorReturn(this,(EntitySearch.__proto__||Object.getPrototypeOf(EntitySearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(EntitySearch,[{key:"_submitSearch",value:function _submitSearch(){var entities=this.props.entities;this.props.entitiesShow(1,entities.filters);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('entities.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('entities.filters');this.props.entitiesShow(1);}}]);return EntitySearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(EntitySearch));

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_entities_form__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_entities_widget_entity_add__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EntityEdit=function(_Component){_inherits(EntityEdit,_Component);function EntityEdit(){_classCallCheck(this,EntityEdit);return _possibleConstructorReturn(this,(EntityEdit.__proto__||Object.getPrototypeOf(EntityEdit)).apply(this,arguments));}_createClass(EntityEdit,[{key:'render',value:function render(){var _props=this.props,entities=_props.entities,municipalities=_props.municipalities,status=_props.status;return entities.isFetching||municipalities.isFetching||status.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_entities_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchEntity(this.props.match.params.id);}}]);return EntityEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(EntityEdit, {title: `Editar Entidad`, subnav: {icon: 'fa-map', name: 'Administración', actions: {url: '/entidades/crear', name: 'Agregar Entidad'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(EntityEdit,{title:'Editar Entidad',subnav:{icon:'fa-map',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_entities_widget_entity_add__["a" /* default */],null)}]}}));

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_entities_form__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_entities_widget_entity_add__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EntityCreate=function(_Component){_inherits(EntityCreate,_Component);function EntityCreate(){_classCallCheck(this,EntityCreate);return _possibleConstructorReturn(this,(EntityCreate.__proto__||Object.getPrototypeOf(EntityCreate)).apply(this,arguments));}_createClass(EntityCreate,[{key:'render',value:function render(){var _props=this.props,entities=_props.entities,status=_props.status;return entities.isFetching||status.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_entities_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetEntity();//this.props.fetchStatus(1);
}}]);return EntityCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(EntityCreate, {title: `Crear Entidad`, subnav: {icon: 'fa-map', name: 'Administración', actions: {url: '/entidades/crear', name: 'Agregar Entidad'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(EntityCreate,{title:'Crear Entidad',subnav:{icon:'fa-map',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_entities_widget_entity_add__["a" /* default */],null)}]}}));

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MunicipalitiesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_municipalities_widget_municipality_add__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_municipalities_widget_municipality_search__ = __webpack_require__(720);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Municipalities=function(_Component){_inherits(Municipalities,_Component);function Municipalities(){_classCallCheck(this,Municipalities);return _possibleConstructorReturn(this,(Municipalities.__proto__||Object.getPrototypeOf(Municipalities)).apply(this,arguments));}_createClass(Municipalities,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MunicipalitiesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){var municipalities=this.props.municipalities;this.props.municipalitiesShow(municipalities.pages.current,municipalities.filters);}}]);return Municipalities;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var MunicipalitiesList=function(_Component2){_inherits(MunicipalitiesList,_Component2);_createClass(MunicipalitiesList,[{key:'render',value:function render(){var _this3=this;var municipalities=this.props.municipalities;var mu=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(municipalities.permissions,function(o){return o==='Update';});var md=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(municipalities.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,municipalities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estado'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(municipalities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},mu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/municipios/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',md?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.state&&row.state.name?row.state.name:''));}))),municipalities.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:municipalities.pages.current,total:municipalities.pages.total,nextPage:this._handlePageChange}));}}]);function MunicipalitiesList(){_classCallCheck(this,MunicipalitiesList);var _this2=_possibleConstructorReturn(this,(MunicipalitiesList.__proto__||Object.getPrototypeOf(MunicipalitiesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(MunicipalitiesList,[{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el municipio "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.deleteMunicipality(id);}});}},{key:'_handlePageChange',value:function _handlePageChange(value){var municipalities=this.props.municipalities;this.props.municipalitiesShow(value,municipalities.filters);}}]);return MunicipalitiesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(Municipalities, {title: `Administrar Municipios`, subnav: {icon: 'fa-map-marker', name: 'Administración', actions: {url: '/municipios/crear', name: 'Agregar Municipio'}}, search:'municipalities'});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(Municipalities,{title:'Administrar Municipios',subnav:{icon:'fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_municipalities_widget_municipality_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_municipalities_widget_municipality_add__["a" /* default */],null)}]}}));

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from 'lodash';
var MunicipalitySearch=function(_Component){_inherits(MunicipalitySearch,_Component);_createClass(MunicipalitySearch,[{key:"render",value:function render(){var municipalities=this.props.municipalities;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:municipalities.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function MunicipalitySearch(){_classCallCheck(this,MunicipalitySearch);var _this=_possibleConstructorReturn(this,(MunicipalitySearch.__proto__||Object.getPrototypeOf(MunicipalitySearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(MunicipalitySearch,[{key:"_submitSearch",value:function _submitSearch(){var municipalities=this.props.municipalities;this.props.municipalitiesShow(1,municipalities.filters);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('municipalities.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('municipalities.filters');this.props.municipalitiesShow(1);}}]);return MunicipalitySearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(MunicipalitySearch));

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_municipalities_form__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_municipalities_widget_municipality_add__ = __webpack_require__(153);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MununicipalityEdit=function(_Component){_inherits(MununicipalityEdit,_Component);function MununicipalityEdit(){_classCallCheck(this,MununicipalityEdit);return _possibleConstructorReturn(this,(MununicipalityEdit.__proto__||Object.getPrototypeOf(MununicipalityEdit)).apply(this,arguments));}_createClass(MununicipalityEdit,[{key:'render',value:function render(){var _props=this.props,entities=_props.entities,municipalities=_props.municipalities,status=_props.status,modalities=_props.modalities;return entities.isFetching||municipalities.isFetching||status.isFetching||modalities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_municipalities_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchEntities();this.props.fetchMunicipality(this.props.match.params.id);this.props.fetchStatus(1);this.props.fetchModalities();}}]);return MununicipalityEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(MununicipalityEdit, {title: `Editar Municipio`, subnav: {icon: 'fa-map-marker', name: 'Administración', actions: {url: '/municipios/crear', name: 'Agregar Municipio'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(MununicipalityEdit,{title:'Editar Municipio',subnav:{icon:'fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_municipalities_widget_municipality_add__["a" /* default */],null)}]}}));

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_municipalities_form__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_municipalities_widget_municipality_add__ = __webpack_require__(153);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MununicipalityCreate=function(_Component){_inherits(MununicipalityCreate,_Component);function MununicipalityCreate(){_classCallCheck(this,MununicipalityCreate);return _possibleConstructorReturn(this,(MununicipalityCreate.__proto__||Object.getPrototypeOf(MununicipalityCreate)).apply(this,arguments));}_createClass(MununicipalityCreate,[{key:'render',value:function render(){var _props=this.props,entities=_props.entities,municipalities=_props.municipalities,status=_props.status,modalities=_props.modalities;return entities.isFetching||municipalities.isFetching||status.isFetching||modalities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_municipalities_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetMunicipalities();this.props.fetchEntities();this.props.fetchStatus(1);this.props.fetchModalities();}}]);return MununicipalityCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(MununicipalityCreate, {title: `Crear Municipio`, subnav: {icon: 'fa-map-marker', name: 'Administración', actions: {url: '/municipios/crear', name: 'Agregar Municipio'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(MununicipalityCreate,{title:'Crear Municipio',subnav:{icon:'fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_municipalities_widget_municipality_add__["a" /* default */],null)}]}}));

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AgenciesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_agencies_widget_agencies_add__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_agencies_widget_agencies_search__ = __webpack_require__(724);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Agencies=function(_Component){_inherits(Agencies,_Component);function Agencies(){_classCallCheck(this,Agencies);return _possibleConstructorReturn(this,(Agencies.__proto__||Object.getPrototypeOf(Agencies)).apply(this,arguments));}_createClass(Agencies,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AgenciesList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){var agencies=this.props.agencies;this.props.agenciesShow(agencies.pages.current,agencies.filters);}}]);return Agencies;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AgenciesList=function(_Component2){_inherits(AgenciesList,_Component2);_createClass(AgenciesList,[{key:'render',value:function render(){var _this3=this;var agencies=this.props.agencies;var au=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies.permissions,function(o){return o==='Update';});var ad=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agencies.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,agencies.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_loading__["a" /* default */],null):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table',key:'agencies-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tipo de instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Versi\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(agencies.list,['id']),function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},au?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/instancias/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',ad?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.agenciable&&row.agenciable.state?row.agenciable.state.name:row.agenciable?row.agenciable.name:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.upperCase(row.agenciable_type?row.agenciable_type:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.version?row.version.year:'---'));}))),agencies.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_widgets_inmPagination__["a" /* default */],{key:'agencies-pages',current:agencies.pages.current,total:agencies.pages.total,nextPage:this._handlePageChange})]);}}]);function AgenciesList(){_classCallCheck(this,AgenciesList);var _this2=_possibleConstructorReturn(this,(AgenciesList.__proto__||Object.getPrototypeOf(AgenciesList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(AgenciesList,[{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la instancia "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.agencyDelete(id);}});}},{key:'_handlePageChange',value:function _handlePageChange(value){var agencies=this.props.agencies;this.props.agenciesShow(value,agencies.filters);}}]);return AgenciesList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__templates_base__["a" /* default */])(Agencies,{title:'Administrar Instancias',subnav:{icon:'fa fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_agencies_widget_agencies_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_agencies_widget_agencies_add__["a" /* default */],null)}]}}));

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from 'lodash';
var AgenciesSearch=function(_Component){_inherits(AgenciesSearch,_Component);_createClass(AgenciesSearch,[{key:"render",value:function render(){var _props=this.props,agencies=_props.agencies,entities=_props.entities,versions=_props.versions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"type",id:"type",value:agencies.filters.agenciable_type,onChange:this._typeChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Tipo ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"federal"},"FEDERAL"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"imm"},"IMM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"imef"},"IMEF"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"cdm"},"CDM")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"+(versions.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"version_id",id:"version_id",disabled:versions.isFetching,value:agencies.filters.version_id,onChange:this._versionChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- A\xF1o ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(versions.list,function(version,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:version.id,key:k},version.year);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"+(entities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"state_id",id:"state_id",value:agencies.filters.state_id,onChange:this._entityChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Entidad ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(entities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:agencies.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function AgenciesSearch(){_classCallCheck(this,AgenciesSearch);var _this=_possibleConstructorReturn(this,(AgenciesSearch.__proto__||Object.getPrototypeOf(AgenciesSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._typeChange=_this._typeChange.bind(_this);_this._versionChange=_this._versionChange.bind(_this);_this._entityChange=_this._entityChange.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(AgenciesSearch,[{key:"componentWillMount",value:function componentWillMount(){this.props.fetchEntities();this.props.versionsList();}},{key:"_submitSearch",value:function _submitSearch(){var agencies=this.props.agencies;this.props.agenciesShow(1,agencies.filters);}},{key:"_typeChange",value:function _typeChange(event){this.props.change('agencies.filters.agenciable_type',event.target.value);}},{key:"_versionChange",value:function _versionChange(event){this.props.change('agencies.filters.version_id',event.target.value);}},{key:"_entityChange",value:function _entityChange(event){this.props.change('agencies.filters.state_id',event.target.value);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('agencies.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('agencies.filters');this.props.agenciesShow(1);}}]);return AgenciesSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(AgenciesSearch));

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_agencies_form__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_agencies_widget_agencies_add__ = __webpack_require__(154);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AgenciesEdit=function(_Component){_inherits(AgenciesEdit,_Component);function AgenciesEdit(){_classCallCheck(this,AgenciesEdit);return _possibleConstructorReturn(this,(AgenciesEdit.__proto__||Object.getPrototypeOf(AgenciesEdit)).apply(this,arguments));}_createClass(AgenciesEdit,[{key:'render',value:function render(){var _props=this.props,agencies=_props.agencies,entities=_props.entities;return agencies.isFetching||entities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_agencies_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('agencies.edit');this.props.agencyEdit(this.props.match.params.id);}}]);return AgenciesEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(AgenciesEdit,{title:"Editar Instancia",subnav:{icon:'fa fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_agencies_widget_agencies_add__["a" /* default */],null)}]}}));

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_agencies_form__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_agencies_widget_agencies_add__ = __webpack_require__(154);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoalEdit=function(_Component){_inherits(GoalEdit,_Component);function GoalEdit(){_classCallCheck(this,GoalEdit);return _possibleConstructorReturn(this,(GoalEdit.__proto__||Object.getPrototypeOf(GoalEdit)).apply(this,arguments));}_createClass(GoalEdit,[{key:'render',value:function render(){var _props=this.props,agencies=_props.agencies,entities=_props.entities;return agencies.isFetching||entities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_agencies_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('agencies.edit');this.props.agencyEdit();}}]);return GoalEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(GoalEdit,{title:"Crear Instancia",subnav:{icon:'fa fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_agencies_widget_agencies_add__["a" /* default */],null)}]}}));

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AgenciesAmountsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_agencies_widget_amounts_add__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_agencies_widget_amounts_search__ = __webpack_require__(728);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AgenciesAmounts=function(_Component){_inherits(AgenciesAmounts,_Component);function AgenciesAmounts(){_classCallCheck(this,AgenciesAmounts);return _possibleConstructorReturn(this,(AgenciesAmounts.__proto__||Object.getPrototypeOf(AgenciesAmounts)).apply(this,arguments));}_createClass(AgenciesAmounts,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AgenciesAmountsList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){var amounts_agencies=this.props.amounts_agencies;this.props.amountsAgenciesShow(amounts_agencies.pages.current,amounts_agencies.filters);}}]);return AgenciesAmounts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AgenciesAmountsList=function(_Component2){_inherits(AgenciesAmountsList,_Component2);_createClass(AgenciesAmountsList,[{key:'render',value:function render(){var _this3=this;var amounts_agencies=this.props.amounts_agencies;var au=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(amounts_agencies.permissions,function(o){return o==='Update';});var ad=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(amounts_agencies.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,amounts_agencies.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_loading__["a" /* default */],null):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table',key:'amounts-agencies-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Version'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto Maximo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(amounts_agencies.list,['id']),function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},au?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/instancias/montos/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',ad?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.state?row.state.name:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.version.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7_accounting_js__["formatMoney"])(row.amount_max)));}))),amounts_agencies.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_widgets_inmPagination__["a" /* default */],{key:'amounts-agencies-pages',current:amounts_agencies.pages.current,total:amounts_agencies.pages.total,nextPage:this._handlePageChange})]);}}]);function AgenciesAmountsList(){_classCallCheck(this,AgenciesAmountsList);var _this2=_possibleConstructorReturn(this,(AgenciesAmountsList.__proto__||Object.getPrototypeOf(AgenciesAmountsList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(AgenciesAmountsList,[{key:'_getConfirm',value:function _getConfirm(id){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el monto?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.amountAgencyDelete(id);}});}},{key:'_handlePageChange',value:function _handlePageChange(value){var amounts_agencies=this.props.amounts_agencies;this.props.amountsAgenciesShow(value,amounts_agencies.filters);}}]);return AgenciesAmountsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__templates_base__["a" /* default */])(AgenciesAmounts,{title:'Administrar Montos de las instancias',subnav:{icon:'fa fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Buscar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_agencies_widget_amounts_search__["a" /* default */],null)},{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_agencies_widget_amounts_add__["a" /* default */],null)}]}}));

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_secure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from 'lodash';
var AgenciesSearch=function(_Component){_inherits(AgenciesSearch,_Component);_createClass(AgenciesSearch,[{key:"render",value:function render(){var _props=this.props,amounts_agencies=_props.amounts_agencies,modalities=_props.modalities,versions=_props.versions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._clearSearch},"\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-ban"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"+(modalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"modality_id",id:"modality_id",value:amounts_agencies.filters.modality_id,onChange:this._modalityChange,disabled:modalities.isFetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"--- Modalidad ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(modalities.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:k,value:row.id},row.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-small"+(versions.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"version_id",id:"version_id",disabled:versions.isFetching,value:amounts_agencies.filters.version_id,onChange:this._versionChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- A\xF1o ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(versions.list,function(version,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:version.id,key:k},version.year);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"input is-small",type:"search",ref:"q",id:"q",placeholder:"Buscar",value:amounts_agencies.filters.q,onChange:this._searchChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button is-inm-purple is-small",onClick:this._submitSearch},"Buscar")));}}]);function AgenciesSearch(){_classCallCheck(this,AgenciesSearch);var _this=_possibleConstructorReturn(this,(AgenciesSearch.__proto__||Object.getPrototypeOf(AgenciesSearch)).call(this));_this._submitSearch=_this._submitSearch.bind(_this);_this._modalityChange=_this._modalityChange.bind(_this);_this._versionChange=_this._versionChange.bind(_this);_this._searchChange=_this._searchChange.bind(_this);_this._clearSearch=_this._clearSearch.bind(_this);return _this;}_createClass(AgenciesSearch,[{key:"componentWillMount",value:function componentWillMount(){this.props.fetchModalities();this.props.versionsList();}},{key:"_submitSearch",value:function _submitSearch(){var amounts_agencies=this.props.amounts_agencies;this.props.amountsAgenciesShow(1,amounts_agencies.filters);}},{key:"_modalityChange",value:function _modalityChange(event){this.props.change('amounts_agencies.filters.modality_id',event.target.value);}},{key:"_versionChange",value:function _versionChange(event){this.props.change('amounts_agencies.filters.version_id',event.target.value);}},{key:"_searchChange",value:function _searchChange(event){this.props.change('amounts_agencies.filters.q',event.target.value);}},{key:"_clearSearch",value:function _clearSearch(){this.props.reset('amounts_agencies.filters');this.props.amountsAgenciesShow(1);}}]);return AgenciesSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_secure__["a" /* default */])(AgenciesSearch));

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_agencies_amounts_form__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_agencies_widget_amounts_add__ = __webpack_require__(155);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AmountsAgenciesEdit=function(_Component){_inherits(AmountsAgenciesEdit,_Component);function AmountsAgenciesEdit(){_classCallCheck(this,AmountsAgenciesEdit);return _possibleConstructorReturn(this,(AmountsAgenciesEdit.__proto__||Object.getPrototypeOf(AmountsAgenciesEdit)).apply(this,arguments));}_createClass(AmountsAgenciesEdit,[{key:'render',value:function render(){var _props=this.props,amounts_agencies=_props.amounts_agencies,entities=_props.entities;return amounts_agencies.isFetching||entities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_agencies_amounts_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('amounts_agencies.edit');this.props.amountsAgenciesEdit(this.props.match.params.id);}}]);return AmountsAgenciesEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(AmountsAgenciesEdit,{title:"Editar monto de instancia",subnav:{icon:'fa fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_agencies_widget_amounts_add__["a" /* default */],null)}]}}));

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_agencies_amounts_form__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_agencies_widget_amounts_add__ = __webpack_require__(155);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AmountsAgenciesEdit=function(_Component){_inherits(AmountsAgenciesEdit,_Component);function AmountsAgenciesEdit(){_classCallCheck(this,AmountsAgenciesEdit);return _possibleConstructorReturn(this,(AmountsAgenciesEdit.__proto__||Object.getPrototypeOf(AmountsAgenciesEdit)).apply(this,arguments));}_createClass(AmountsAgenciesEdit,[{key:'render',value:function render(){var _props=this.props,amounts_agencies=_props.amounts_agencies,entities=_props.entities;return amounts_agencies.isFetching||entities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_agencies_amounts_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('amounts_agencies.edit');this.props.amountsAgenciesEdit();}}]);return AmountsAgenciesEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(AmountsAgenciesEdit,{title:"Crear monto de instancia",subnav:{icon:'fa fa-map-marker',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_agencies_widget_amounts_add__["a" /* default */],null)}]}}));

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_notifications_widget_notification_type_add__ = __webpack_require__(156);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notifications=function(_Component){_inherits(Notifications,_Component);_createClass(Notifications,[{key:'render',value:function render(){var _this2=this;var notifications_types=this.props.notifications_types;var nu=false;var nd=false;__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(notifications_types.permissions,function(o){if(o==='Update'){nu=true;}if(o==='Delete'){nd=true;}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,notifications_types.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(notifications_types.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},nu?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/notificaciones/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'',nd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})):''),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'has-text-'+row.status.style},row.status.name)));}))),notifications_types.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:notifications_types.pages.current,total:notifications_types.pages.total,nextPage:this._handlePageChange}));}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchNotificationsTypes(this.props.notifications_types.pages.current);}}]);function Notifications(){_classCallCheck(this,Notifications);var _this=_possibleConstructorReturn(this,(Notifications.__proto__||Object.getPrototypeOf(Notifications)).call(this));_this._handlePageChange=_this._handlePageChange.bind(_this);return _this;}_createClass(Notifications,[{key:'_handlePageChange',value:function _handlePageChange(value){this.props.fetchGroupsPhasesShow(value);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la notificaci\xF3n "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this3.props.groupPhaseDelete(id);}});}}]);return Notifications;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_base__["a" /* default */])(Notifications,{title:"Administrar notificaciones",subnav:{icon:'fa-sliders',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_notifications_widget_notification_type_add__["a" /* default */],null)}]}}));

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_notifications_form__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_notifications_widget_notification_type_add__ = __webpack_require__(156);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationTypeForm=function(_Component){_inherits(NotificationTypeForm,_Component);function NotificationTypeForm(){_classCallCheck(this,NotificationTypeForm);return _possibleConstructorReturn(this,(NotificationTypeForm.__proto__||Object.getPrototypeOf(NotificationTypeForm)).apply(this,arguments));}_createClass(NotificationTypeForm,[{key:'render',value:function render(){var _props=this.props,notifications_types=_props.notifications_types,status=_props.status;return notifications_types.isFetching||status.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_notifications_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('notifications_types.edit');this.props.notificationTypeEdit(this.props.match.params.id);this.props.fetchGroupsPhasesList();this.props.fetchStatus(1);}}]);return NotificationTypeForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(NotificationTypeForm,{title:'Editar notificati\xF3n',subnav:{icon:'fa fa-calendar-check-o',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_notifications_widget_notification_type_add__["a" /* default */],null)}]}}));

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_notifications_form__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_notifications_widget_notification_type_add__ = __webpack_require__(156);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationTypeForm=function(_Component){_inherits(NotificationTypeForm,_Component);function NotificationTypeForm(){_classCallCheck(this,NotificationTypeForm);return _possibleConstructorReturn(this,(NotificationTypeForm.__proto__||Object.getPrototypeOf(NotificationTypeForm)).apply(this,arguments));}_createClass(NotificationTypeForm,[{key:'render',value:function render(){var _props=this.props,notifications_types=_props.notifications_types,status=_props.status;return notifications_types.isFetching||status.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_notifications_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.reset('notifications_types.edit');this.props.fetchGroupsPhasesList();this.props.fetchStatus(1);}}]);return NotificationTypeForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(NotificationTypeForm,{title:'Crear notificati\xF3n',subnav:{icon:'fa fa-calendar-check-o',name:'Administración',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_notifications_widget_notification_type_add__["a" /* default */],null)}]}}));

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_notifications_messages__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationMessages=function(_Component){_inherits(NotificationMessages,_Component);function NotificationMessages(){_classCallCheck(this,NotificationMessages);return _possibleConstructorReturn(this,(NotificationMessages.__proto__||Object.getPrototypeOf(NotificationMessages)).apply(this,arguments));}_createClass(NotificationMessages,[{key:'render',value:function render(){var notification_messages=this.props.notification_messages;return notification_messages.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_notifications_messages__["a" /* default */],{messages:this.props.notification_messages,modality:this.props.match.params.modality,project:this.props.project});}},{key:'componentWillMount',value:function componentWillMount(){var modality=this.props.match.params.modality;this.props.fetchNotificationMessages(modality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var modality=newprops.match.params.modality;if(newprops.match.params!==this.props.match.params){this.props.fetchNotificationMessages(modality);}}}]);return NotificationMessages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(NotificationMessages,{title:'Mensajes de notificaci\xF3n',subnav:{icon:'fa-envelope',name:'Notificaciones',actions:[{type:null,url:null,name:'',element:null}]}}));

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroll_top__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MessagesEditForm=function(_Component){_inherits(MessagesEditForm,_Component);function MessagesEditForm(){_classCallCheck(this,MessagesEditForm);return _possibleConstructorReturn(this,(MessagesEditForm.__proto__||Object.getPrototypeOf(MessagesEditForm)).apply(this,arguments));}_createClass(MessagesEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,messages=_props.messages,modality=_props.modality,project=_props.project;var nmc=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(messages.permissions,function(o){return o==='Create';})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__scroll_top__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'messages.edit',onSubmit:function onSubmit(values){return _this2._handleSubmit(values);}},modality==='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'state',className:'label'},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.entity.id',defaultValue:messages.edit.entity.id,parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["c" /* toInt */],changeAction:function changeAction(model,value){return _this2._handleCheckState(model,value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Estados --'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(messages.edit.states,function(state,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:state.id,key:k},state.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-info has-text-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'reviewedState',className:'checkbox',disabled:this._permisionEdit()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.entity.reviewed',id:'reviewedState',className:'checkbox',changeAction:function changeAction(model,value){return _this2._handleCheckValidate(model,value);},disabled:this._permisionEdit()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},'He concluido con la validaci\xF3n de este estado')))),messages.edit.entity.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-spinner fa-pulse fa-fw'}))):''))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'.agencies'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-6'},'VALIDACION DE PARTICIPANTES'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this._listAgencies(),function(item,k){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'instance-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3,className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency?item.agency.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell'},modality!=='modalidad-ii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Estado'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Municipio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency?item.agency.agenciable.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'general-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Titular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency?item.agency.owner.name+' '+item.agency.owner.last_name+' '+item.agency.owner.slast_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Email de la instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency?item.agency.email:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Email de titular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.agency?item.agency.owner.email:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(item.project_version_phase_group)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(item.project_version_phase_group.revisions)?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item.project_version_phase_group.revisions,function(rev,o){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark',key:o},'Revisi\xF3n '+rev.project_version_phase.version_phase.phase.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{key:'status-'+o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-success'},'Revisado'))];}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-danger'},'No Revisado')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'notification-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Notificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.project_version_phase_group&&item.project_version_phase_group.notification&&item.project_version_phase_group.notification.notification_type?item.project_version_phase_group.notification.notification_type.name:'--Sin notificación--')))];})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-large is-info',onClick:function onClick(){return _this2.props.notificationMessagesExport(modality);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Exportar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Prueba de envio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-inm-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'checkbox',disabled:Boolean(messages.edit.finished)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.is_test',isToggle:true,defaultValue:true,disabled:Boolean(messages.edit.finished)}),'Prueba de envio'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'test_email',className:'label'},'E-mail'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{className:'input',type:'email',model:'.test_email',id:'test_email',placeholder:'usuario@dominio.com',errors:{email:__WEBPACK_IMPORTED_MODULE_4__field_validations__["a" /* email */]}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.test_email',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{email:'El email es inválido'}}),messages.edit.is_test?messages.edit.test_email?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'El email es obligatorio'):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Mensajes de notificaci\xF3n'),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(messages.notifications_types)?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(messages.notifications_types,function(msg,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'.notifications_types'+k,className:'label'},'Mensaje para notificacion ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-primary'},msg.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:msg.body?msg.body:''}})))));}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'finished',className:'checkbox',disabled:messages.edit.is_test},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.finished',id:'finished',className:'checkbox',disabled:messages.edit.is_test}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},'He concluido con la validaci\xF3n de las notificaciones y certifico que la informaci\xF3n proporcionada es correcta y completa; conozco las disposiciones establecidas en las Reglas de Operaci\xF3n de ProEquidad ',project.version.year,'.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),nmc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'messages.edit',className:'button is-success',disabled:this._permissionSave()},'Enviar notifiaciones')):''))));}},{key:'_handleSubmit',value:function _handleSubmit(values){var modality=this.props.modality;this.props.notificationMessagesSave(values,modality);}},{key:'_listAgencies',value:function _listAgencies(){var _props2=this.props,messages=_props2.messages,modality=_props2.modality;var listAgencies=[];if(modality!=='modalidad-ii'&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(messages.list)){listAgencies=messages.list;}else if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(messages.list)){listAgencies=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(messages.list,{agency:{agenciable:{state_id:messages.edit.entity.id}}});}return listAgencies;}},{key:'_handleCheckValidate',value:function _handleCheckValidate(model,value){var _props3=this.props,messages=_props3.messages,modality=_props3.modality;var state=messages.edit.entity.id;var index=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(messages.edit.states,{id:state});this.props.change(model,value);this.props.change('messages.edit.states['+index+'].reviewed',value?1:0);this.props.notificationStateReviewedSave(value?1:0,modality,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(messages.edit.states,{id:state}).short);}},{key:'_handleCheckState',value:function _handleCheckState(model,value){var messages=this.props.messages;var state=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(messages.edit.states,{id:value});this.props.change(model,value);this.props.change('messages.edit.entity.reviewed',state&&state.reviewed?true:false);}},{key:'_validateState',value:function _validateState(state){var states=this.props.messages.edit.states;return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get({body:Object.assign({},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(states,{id:state}))},'body.reviewed',false);}},{key:'_permisionEdit',value:function _permisionEdit(reviewed){var messages=this.props.messages;if(reviewed){return reviewed;}else{return Boolean(messages.edit.finished);}}},{key:'_permissionSave',value:function _permissionSave(){var _props4=this.props,messages=_props4.messages,modality=_props4.modality;var total=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(messages.edit.states);var validated=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(messages.edit.states,'reviewed'));if(modality==='modalidad-ii'){if(messages.edit.is_test&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(messages.edit.test_email)){return false;}else if(messages.edit.finished&&total===validated){return false;}else{return true;}}else{if(Boolean(messages.edit.finished)){return false;}else if(messages.edit.is_test&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(messages.edit.test_email)){return false;}else{return true;}}}}]);return MessagesEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MessagesEditForm);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_revision_commission__ = __webpack_require__(737);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Loading from "../../elements/loading";
var CommissionValidation=function(_Component){_inherits(CommissionValidation,_Component);function CommissionValidation(){_classCallCheck(this,CommissionValidation);return _possibleConstructorReturn(this,(CommissionValidation.__proto__||Object.getPrototypeOf(CommissionValidation)).apply(this,arguments));}_createClass(CommissionValidation,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_revision_commission__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.fetchResourseConcepts();this.props.fetchCommission();}}]);return CommissionValidation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(CommissionValidation,{title:"Revisión y validación de proyectos",subnav:{icon:'fa-check-square-o',name:'Validación de proyectos',actions:[{type:null,url:null,name:'',element:null}]},stateNav:false}));

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_wysiwyg_field__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CommissionValidationForm=function(_Component){_inherits(CommissionValidationForm,_Component);_createClass(CommissionValidationForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,resource_concepts=_props.resource_concepts,revision=_props.revision;var commission=revision.commission;var project=commission.project;//console.log('validaciones: ', _.isEmpty(revision.commission));
var projectRev=commission.revision?commission.revision.body:undefined;return revision.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:this.state.formShow===false?'block':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"A continuaci\xF3n se te asignar\xE1 un proyecto para su revisi\xF3n y validaci\xF3n, recuerda que al finalizar la revisi\xF3n tienes que marcar la casilla de verificaci\xF3n, en este paso no hay vuelta atr\xE1s y no podr\xE1s regresar al proyecto anterior.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-medium is-success",onClick:function onClick(){_this2._getSurvey();},disabled:this._permissionAssing()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.spvpu)?'¡ Asígname un proyecto !':'¡ Continuar revisión !'),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.spvpu)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-random"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon is-medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-play"}))))),!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.projects)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginBottom:'.5em'}},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-medium is-dark"},"Proyectos revisados"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-medium is-inm-purple"},commission.projects.assigned))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginBottom:'.5em'}},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-medium is-dark"},"Total disponibles"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-medium is-info"},commission.projects.available))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginBottom:'.5em'}},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-medium is-dark"},"Proyectos sin revisar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-medium is-warning"},commission.projects.missing>=0?commission.projects.missing:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{marginBottom:'.5em'}},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-medium is-dark"},"Total de proyectos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-medium is-success"},commission.projects.total)))))):''),this.state.conagoShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConagoModal,{active:this.state.conagoShow,closeModal:function closeModal(){return _this2._toggleConagoModal();},selectedConago:project.project_goals[this.state.selectedGoal].conago_clauses,selectedGoal:this.state.selectedGoal,conagoClauses:this.props.directories}):'',this.state.actorsShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActorsModal,{active:this.state.actorsShow,closeModal:function closeModal(){return _this2._toggleActorsModal();},selectedActors:project.project_goals[this.state.selectedGoal].actors,selectedGoal:this.state.selectedGoal,actors:this.props.directories}):'',!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.commission.project)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"revision.commission",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},style:{display:this.state.formShow?'block':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"4",className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},project&&project.modality.name?project.modality.name:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"DATOS GENERALES"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2",className:"goal-cell",style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Instrucciones")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2",className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Datos del proyecto"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"1. Seleccionar la valoraci\xF3n para cada rubro a calificar del proyecto, de acuerdo con lo establecido en los Criterios de Operaci\xF3n de la CVP."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"2. En su caso, emitir comentarios generales en cada secci\xF3n.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Folio de participaci\xF3n:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,project&&project.code?project.code:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Modalidad:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,project&&project.modality.name?project.modality.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-usd fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," ",project&&project.amounts?""+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(project.amounts.total):'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-calendar fa-2x"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Periodo de ejecuci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(project.execution_start).format('MMMM YYYY'))," a ",__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(project.execution_end).format('MMMM YYYY')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2",style:{verticalAlign:'top',padding:'0 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Preguntas"))),!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.commission.spvpu)&&!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(revision.commission.spvpu.survey_version_phase)?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(revision.commission.spvpu.survey_version_phase.survey.children_questions,function(row,key){//console.log('row: ',row);
if(row.type==='group'){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"group-"+key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,key+1+'. '+row.name))),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(row.children_questions,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowQuestion,Object.assign({key:k,model:"revision.commission.answers["+key+"]",row:item},_this2.props));})];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowQuestion,Object.assign({key:key,number:key+1,model:"revision.commission.answers["+key+"]",row:row},_this2.props));}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Comentarios generales"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:'top',padding:'0 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:".comments",component:__WEBPACK_IMPORTED_MODULE_7__forms_wysiwyg_field__["a" /* default */]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"level-left"},"Puntuaci\xF3n total:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"level-right"},this._totalScore()))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2",style:{verticalAlign:'top',padding:'0 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'70%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,project.agency.name?project.agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Localidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,project.agency&&project.agency.agenciable?project.agency.agenciable.name:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,project.name?project.name:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Objetivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:project.objective?project.objective:'---'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Justificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:project.justification?project.justification:'---'}}))))),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(project.project_goals,function(goal,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2,className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"Meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goal.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-inm-purple"},"C\xF3digo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-inm-purple"},goal.code))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Monto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(goal.total))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},project&&project.modality&&project.modality.slug==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons",style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-light",onClick:function onClick(){return _this2._openConagoModal(goal.proigualdad_goal_id,goal.conagoClauses);}},"Metas CONAGO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-white"},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(goal.conago_clauses)))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tags has-addons",style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-light",onClick:function onClick(){return _this2._openActorsModal(goal.proigualdad_goal_id,goal.actors);}},"Actores estrat\xE9gicos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"tag is-white"},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(goal.actors))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Eje tem\xE1tico"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goal.axis?goal.axis.name:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"L\xEDnea de acci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goal.line?goal.line.name:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto de gasto"),goal.resource_concept_id&&resource_concepts&&resource_concepts.list?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(resource_concepts.list,{id:goal.resource_concept_id}).name):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Documento meta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,goal.goal_document)))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2,className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"RESUMEN DE GASTOS")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Gasto total del proyecto")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,project.amounts&&project.amounts.goals?Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toNumber(project.amounts.goals.total)):'--')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Concepto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Gastos de coordinaci\xF3n")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-dark"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,project.amounts&&project.amounts.expenses?Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toNumber(project.amounts.expenses.total)):'--')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"Concepto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-white"},"Monto total del proyecto"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell has-text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help is-white"},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,project.amounts?Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toNumber(project.amounts.total)):'--')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2,className:"goal-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Comentarios de revisi\xF3n"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:projectRev&&projectRev.comments&&projectRev.comments!=='<p><br></p>'?projectRev.comments:'Ninguno'}})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message is-success"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"finished",className:"checkbox",disabled:this._permissionSave()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:".finished",id:"finished",className:"checkbox",disabled:this._permissionSave()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{whiteSpace:'normal'}},"He concluido y certifico que la informaci\xF3n proporcionada es correcta y completa; conozco las disposiciones establecidas en las Reglas de Operaci\xF3n del PFTPG 2018.")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",model:"validation",className:"button is-danger",onClick:function onClick(){return _this2.props.history.push('/inicio');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"validation.edit",className:"button is-success",disabled:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(revision.commission.answers)>0?false:true},"Guardar")))))):''));}}]);function CommissionValidationForm(){_classCallCheck(this,CommissionValidationForm);var _this=_possibleConstructorReturn(this,(CommissionValidationForm.__proto__||Object.getPrototypeOf(CommissionValidationForm)).call(this));_this.state={conagoShow:false,actorsShow:false,formShow:false,goalConago:[],goalActors:[],selectedGoal:0};return _this;}_createClass(CommissionValidationForm,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(props){if(this.state.formShow&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(props.revision.commission.spvpu)){this.setState({formShow:false});}}},{key:"_handleSubmit",value:function _handleSubmit(values){this.props.surveysSaveAnswer(values);if(values.finished){this.setState({formShow:!this.state.formShow});}//console.log('values: ', values)
}},{key:"_permissionAssing",value:function _permissionAssing(){var commission=this.props.revision.commission;if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.spvpu)){return false;}else if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.projects)&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.spvpu)&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toInteger(commission.projects.assigned)<__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toInteger(commission.projects.available)){return false;}else{return true;}}},{key:"_permissionSave",value:function _permissionSave(){var commission=this.props.revision.commission;var total=0;var answers=0;if(commission.spvpu&&commission.spvpu.survey_version_phase&&commission.spvpu.survey_version_phase.survey){__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(commission.spvpu.survey_version_phase.survey.children_questions,function(item){if(item.type==='group'){__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(item.children_questions,function(){total=total+1;});}else{total=total+1;}});}if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.answers)){__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(commission.answers,function(item){if(item.answer_text){answers=answers+1;}});}if(total>0){if(total!==answers){return true;}else{return false;}}else{return true;}}},{key:"_totalScore",value:function _totalScore(){var commission=this.props.revision.commission;var total_score=commission&&commission.answers?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sum(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(commission.answers,function(row){if(row){return row.answer_number;}else{return 0;}})):0;return total_score;}},{key:"_openConagoModal",value:function _openConagoModal(goal,selected){var editGoal=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.findKey(this.props.revision.commission.project.project_goals,{proigualdad_goal_id:goal});this.setState({conagoShow:true,goalConago:selected,selectedGoal:editGoal});}},{key:"_openActorsModal",value:function _openActorsModal(goal,selected){var editGoal=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.findKey(this.props.revision.commission.project.project_goals,{proigualdad_goal_id:goal});this.setState({actorsShow:true,goalActors:selected,selectedGoal:editGoal});}},{key:"_toggleConagoModal",value:function _toggleConagoModal(){this.setState({conagoShow:!this.state.conagoShow});}},{key:"_toggleActorsModal",value:function _toggleActorsModal(){this.setState({actorsShow:!this.state.actorsShow});}},{key:"_getSurvey",value:function _getSurvey(){var _this3=this;var commission=this.props.revision.commission;if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.spvpu)){if(!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(commission.projects)&&__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toInteger(commission.projects.assigned)<__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toInteger(commission.projects.available)){Object(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'Esta acción es irreversible. Una vez que te sea asignado un proyecto, debes revisarlo y marcar la casilla de finalización al terminar.',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){_this3.props.assignCommission();_this3.setState({formShow:true});}});}else{this.props.setSystemNotification("¡Oh no!","Ya no es posible asignar mas proyectos","danger");}}else{this.setState({formShow:true});}}},{key:"_changeOption",value:function _changeOption(model,valueNumber,valueText,questionId,index){var commission=this.props.revision.commission;this.props.change("revision.commission.answers["+index+"]",{spvpu_id:commission.spvpu.id,question_id:questionId,answer_number:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toInteger(valueNumber),answer_text:valueText});}}]);return CommissionValidationForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CommissionValidationForm);var RowQuestion=function(_Component2){_inherits(RowQuestion,_Component2);function RowQuestion(){_classCallCheck(this,RowQuestion);return _possibleConstructorReturn(this,(RowQuestion.__proto__||Object.getPrototypeOf(RowQuestion)).apply(this,arguments));}_createClass(RowQuestion,[{key:"render",value:function render(){var _this5=this;var _props2=this.props,row=_props2.row,revision=_props2.revision;var findValue=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(revision.commission.answers,{question_id:row.id});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,this.props.number?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,this.props.number+'. '+row.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline"},row.type==='sum'?__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(row.options,function(opc,k){//console.log('question: ', key, 'opcion: ', opc.option_number);
var check=findValue&&findValue.answer_number===opc.option_number?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"Q"+row.id+"-answers-"+opc.id,className:"radio"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio",checked:check,id:"Q"+row.id+"-answers-"+opc.id,value:opc.option_number,onChange:function onChange(e){return _this5._changeOption(e.target.value,opc.option_text,row.id);}}),opc.option_text));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{rows:2,className:"textarea",id:"question-"+row.id,ref:"question-"+row.id,value:findValue?findValue.answer_text:undefined,onChange:function onChange(e){return _this5._changeText(e.target.value,row.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)));}},{key:"_changeOption",value:function _changeOption(valueNumber,valueText,questionId){var commission=this.props.revision.commission;var findIndex=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.findIndex(commission.answers,{question_id:questionId});if(findIndex!==-1){this.props.change("revision.commission.answers["+findIndex+"]",{spvpu_id:commission.spvpu.id,question_id:questionId,answer_number:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toInteger(valueNumber),answer_text:valueText});}else{this.props.add('revision.commission.answers',{spvpu_id:commission.spvpu.id,question_id:questionId,answer_number:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toInteger(valueNumber),answer_text:valueText});}}},{key:"_changeText",value:function _changeText(value,questionId){var commission=this.props.revision.commission;var findIndex=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.findIndex(commission.answers,{question_id:questionId});if(findIndex!==-1){this.props.change("revision.commission.answers["+findIndex+"]",{spvpu_id:commission.spvpu.id,question_id:questionId,answer_text:value});}else{this.props.add('revision.commission.answers',{spvpu_id:commission.spvpu.id,question_id:questionId,answer_text:value});}}}]);return RowQuestion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ConagoModal=function(_Component3){_inherits(ConagoModal,_Component3);function ConagoModal(){_classCallCheck(this,ConagoModal);return _possibleConstructorReturn(this,(ConagoModal.__proto__||Object.getPrototypeOf(ConagoModal)).apply(this,arguments));}_createClass(ConagoModal,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Metas CONAGO seleccionadas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:this.props.closeModal,className:"delete is-medium","aria-label":"delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},this.props.conagoClauses.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.selectedConago,function(conago,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:k},conago.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-info",type:"button",onClick:this.props.closeModal},"Cerrar")))))));}}]);return ConagoModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ActorsModal=function(_Component4){_inherits(ActorsModal,_Component4);function ActorsModal(){_classCallCheck(this,ActorsModal);return _possibleConstructorReturn(this,(ActorsModal.__proto__||Object.getPrototypeOf(ActorsModal)).apply(this,arguments));}_createClass(ActorsModal,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-background",onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Actores estrat\xE9gicos seleccionados"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:this.props.closeModal,className:"delete is-medium","aria-label":"delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},this.props.actors.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.props.selectedActors,function(actor,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:k},actor.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-info",type:"button",onClick:this.props.closeModal},"Cerrar")))))));}}]);return ActorsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_reports_revisions__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import {history} from "../../store/store";
//import _ from "lodash";
var ReportRevisions=function(_Component){_inherits(ReportRevisions,_Component);function ReportRevisions(){_classCallCheck(this,ReportRevisions);return _possibleConstructorReturn(this,(ReportRevisions.__proto__||Object.getPrototypeOf(ReportRevisions)).apply(this,arguments));}_createClass(ReportRevisions,[{key:'render',value:function render(){var notification_messages=this.props.notification_messages;return notification_messages.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_reports_revisions__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var modality=this.props.match.params.modality;this.props.fetchNotificationMessages(modality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextprops){if(nextprops.match.params.modality!==this.props.match.params.modality){var modality=nextprops.match.params.modality;this.props.fetchNotificationMessages(modality);}}}]);return ReportRevisions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(ReportRevisions,{title:"Reporte de Revisiones",subnav:{icon:'fa-tasks',name:'Reportes'},stateNav:true}));

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RevisionsEditForm=function(_Component){_inherits(RevisionsEditForm,_Component);function RevisionsEditForm(){_classCallCheck(this,RevisionsEditForm);return _possibleConstructorReturn(this,(RevisionsEditForm.__proto__||Object.getPrototypeOf(RevisionsEditForm)).apply(this,arguments));}_createClass(RevisionsEditForm,[{key:'render',value:function render(){var modality=this.props.match.params.modality;var response=this._getAgencies();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3,className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},'Instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,response?response.agency.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2,className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-white'},modality!=='modalidad-ii'?'Estado':'Municipio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,response?response.agency.agenciable.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2,style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Titular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,response?response.agency.owner.name+' '+response.agency.owner.last_name+' '+response.agency.owner.slast_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Comentario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,response&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(response.comments)?response.comments:'Sin comentarios')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},response&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(response.project_version_phase_group)&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(response.project_version_phase_group.revisions)?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(response.project_version_phase_group.revisions,function(rev,o){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark',key:o},'Revisi\xF3n '+rev.project_version_phase.version_phase.phase.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{key:'status-'+o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-success'},'Revisado'))];}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-danger'},'No Revisado'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Tipo de notifiaci\xF3n'),this._renderNotificationType(response?response.notification_type:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Proyecto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,response?response.name:'---')))))));}},{key:'_getAgencies',value:function _getAgencies(){var list=this.props.notification_messages.list;var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;var agencies=this.props.session.user.agencies;var stateId=!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(agencies.states)?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(agencies.states,{short:state}).id:undefined;var munId=municipality&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(agencies.municipalities)?__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(agencies.municipalities,{slug:municipality}).id:undefined;var response=undefined;if(modality!=='modalidad-ii'&&stateId&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(list)){response=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(list,{agency:{agenciable:{id:stateId}}});}else if(modality==='modalidad-ii'&&stateId&&munId&&!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(list)){//return _.find(list,{state_id:stateId, municipality_id: munId});
response=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(list,{agency:{municipality_id:munId,agenciable:{state_id:stateId}}});}else{response=undefined;}return response;}},{key:'_renderNotificationType',value:function _renderNotificationType(notification_type){if(notification_type==='success'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-success'},notification_type));}else if(notification_type==='warning'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-warning'},notification_type));}else if(notification_type==='danger'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-danger'},notification_type));}else{return'';}}}]);return RevisionsEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RevisionsEditForm);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_reports__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_reports_financial__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsFinancial=function(_Component){_inherits(ReportsFinancial,_Component);function ReportsFinancial(){_classCallCheck(this,ReportsFinancial);return _possibleConstructorReturn(this,(ReportsFinancial.__proto__||Object.getPrototypeOf(ReportsFinancial)).apply(this,arguments));}_createClass(ReportsFinancial,[{key:'render',value:function render(){var _props=this.props,reports=_props.reports,revision=_props.revision,directories=_props.directories,status=_props.status;var financial=reports.financial;return directories.isFetching||status.isFetching||revision.isFetching||financial.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_reports_financial__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.reset('reports');this.props.fetchActorsList();this.props.actorsGroups();this.props.fetchConagoList();this.props.statusMotivesList();this.props.reportsFinancial(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.match.params!==this.props.match.params){this.props.reportsFinancial(modality,state,municipality);}}}]);return ReportsFinancial;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_reports__["a" /* default */])(ReportsFinancial,{subnav:1}));

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_config__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsSubnav=function(_Component){_inherits(ReportsSubnav,_Component);function ReportsSubnav(){_classCallCheck(this,ReportsSubnav);return _possibleConstructorReturn(this,(ReportsSubnav.__proto__||Object.getPrototypeOf(ReportsSubnav)).apply(this,arguments));}_createClass(ReportsSubnav,[{key:"render",value:function render(){var _props=this.props,params=_props.params,reports=_props.reports;var financial=reports.financial,expenses=reports.expenses,employees=reports.employees,summary=reports.summary;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"subnavigation-projects",style:{height:financial.isFetching||expenses.isFetching||employees.isFetching||summary.isFetching?'80px':'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,params.modality==='modalidad-i'?'Categoría A':params.modality==='modalidad-ii'?'Modalidad II':'Modalidad III'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item subnav-step"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},__WEBPACK_IMPORTED_MODULE_3__store_config__["_268" /* reportsInitNav */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level context-navigation"},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3__store_config__["_268" /* reportsInitNav */],function(item,k){var reportLink=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(item.url,':modality',params.modality),':state?',params.state==='undefined'?params.municipalities[0].state.short:params.state),':municipality?',params.municipality===null?params.municipalities[0].slug:params.municipality),'undefined','');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item",key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:"step",to:reportLink,activeClassName:"active"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,item.step),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.title)));})):''))));}}]);return ReportsSubnav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReportsSubnav);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_big_file_upload__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__forms_datepicker__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Financial=function(_Component){_inherits(Financial,_Component);_createClass(Financial,[{key:'render',value:function render(){var _this2=this;var _props=this.props,reports=_props.reports,status=_props.status,match=_props.match;var financial=reports.financial;var revision=financial.revision;var fc=!!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(reports.permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},this.state.modalStatusGoalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalStatusGoal,Object.assign({active:this.state.modalStatusGoalShow,axisIndex:this.state.axisIndex,goalIndex:this.state.goalIndex,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)),this.state.modalStatusActivityShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalStatusActivity,Object.assign({active:this.state.modalStatusActivityShow,axisIndex:this.state.axisIndex,goalIndex:this.state.goalIndex,activityIndex:this.state.activityIndex,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)),this.state.modalDocumentGoalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalDocumentGoal,Object.assign({active:this.state.modalDocumentGoalShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)),this.state.modalExpensesGoalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalExpensesGoal,Object.assign({active:this.state.modalExpensesGoalShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)),this.state.modalMediaActivityShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMediaActivity,Object.assign({active:this.state.modalMediaActivityShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)),this.state.modalActorsGoalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalActorsGoal,Object.assign({active:this.state.modalActorsGoalShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)),this.state.modalConagoGoalShow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalConagoGoal,Object.assign({active:this.state.modalConagoGoalShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(financial.data.proigualdad_axis,function(axis,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box is-radiusless',onClick:function onClick(){return _this2._showAxis(axis.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'heading has-text-primary'},'Eje tem\xE1tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title is-6 has-text-primary'},axis.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},_this2.state.axisId===axis.id&&_this2.state.showAxis?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-up fa-lg'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-down fa-lg'})))))),_this2.state.axisId===axis.id&&_this2.state.showAxis?!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(axis.project_goals)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(axis.project_goals,function(row,k){var revisionFinancial=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revision.body)?revision.body:undefined;var goalRevision=revisionFinancial&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals[row.id])?revisionFinancial.goals[row.id]:undefined;var goalRevisionAllowEdit=goalRevision&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalRevision.allow_edit)?goalRevision.allow_edit==='true'?true:false:undefined;var goalStatus=undefined;var goalMotive=undefined;var validActions=false;var goalDocument=undefined;var findAgency=undefined;var findCdm=undefined;var validCdm=false;var versionPhaseGoal=undefined;var agencyId=undefined;var validEditGoal=fc?revisionFinancial&&goalRevisionAllowEdit!==undefined?goalRevisionAllowEdit:revisionFinancial&&goalRevisionAllowEdit===undefined?false:fc:false;var goalRevisionCdm=undefined;var goalRevisionCdmAllowEdit='false';var validEditGoalCdm=fc;if(match.params.modality!=='modalidad-iii'){versionPhaseGoal=row.project_version_phase_goal;goalStatus=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoal)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(status.data,{id:2}).statuses,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(versionPhaseGoal.status_id)}):undefined;goalMotive=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoal)&&goalStatus?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(goalStatus.motives,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(versionPhaseGoal.status_motive_id)}):undefined;goalDocument=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoal)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(row.project_version_phase_goal.documents)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(versionPhaseGoal.documents,{documentable_subtype:'goal_document'}):undefined;validActions=goalStatus?goalStatus.actions==='delete'?false:true:false;}else{validCdm=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(financial.agency)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(financial.agency[k])&&financial.agency[k].id!==''?true:false;agencyId=validCdm?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(financial.agency[k].id):undefined;//versionPhaseGoal = !_.isEmpty(row.project_version_phase_goal) ? _.find(row.project_version_phase_goal, {agency_id: financial.data.agency_id}):undefined;
versionPhaseGoal=Boolean(row.requires_employees)?!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(row.project_version_phase_goal)&&agencyId?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(row.project_version_phase_goal,{agency_id:agencyId}):undefined:!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(row.project_version_phase_goal)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(row.project_version_phase_goal,{agency_id:financial.data.agency_id}):undefined;validActions=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(row.project_version_phase_goal)?true:false;findAgency=validCdm?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(row.project_version_phase_goal,{agency_id:agencyId}):undefined;findCdm=validCdm?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(row.agencies,{id:agencyId}):undefined;goalDocument=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(row.project_version_phase_goal)&&findAgency&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(findAgency.documents)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(findAgency.documents,{documentable_subtype:'goal_document'}):undefined;goalRevisionCdm=agencyId&&revisionFinancial&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals[row.id])&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals[row.id].agencies[agencyId])?revisionFinancial.goals[row.id].agencies[agencyId]:undefined;goalRevisionCdmAllowEdit=goalRevisionCdm&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalRevisionCdm.allow_edit)?goalRevisionCdm.allow_edit==='true'?true:false:undefined;validEditGoalCdm=fc?revisionFinancial&&goalRevisionCdmAllowEdit!==undefined?goalRevisionCdmAllowEdit:revisionFinancial&&goalRevisionCdmAllowEdit===undefined?false:fc:false;}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Meta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Concepto'),match.params.modality!=='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'):null,match.params.modality!=='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Documento Meta'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Gastos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actores'),match.params.modality==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'CONAGO'):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:match.params.modality!=='modalidad-iii'?'35%':'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'field-notification',style:{backgroundColor:'#fff',top:'-'+100+'%',transform:'translateY(-100%)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'L\xEDnea de acci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),row.line.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'('+row.code+')'),row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:match.params.modality!=='modalidad-iii'?'10%':'20%'}},row.resource_concept?row.resource_concept.name:''),match.params.modality!=='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%',padding:'1em .5em 1em 30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'field-notification',style:{backgroundColor:'#fff',top:'-'+100+'%',transform:'translateY(-100%)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Estatus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),versionPhaseGoal&&goalStatus&&goalStatus.id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-'+goalStatus.style},goalStatus.name):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin estatus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Motivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,versionPhaseGoal&&goalStatus&&goalMotive?goalMotive.name:'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),validEditGoal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._editStatusGoal(row.id,key,k,versionPhaseGoal);},style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),versionPhaseGoal&&goalStatus&&goalStatus.id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-'+goalStatus.style},goalStatus.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sin estatus')):null,match.params.modality!=='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%',padding:'1em .5em 1em 30px'}},_this2.state.modalMessageDocumentGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageDocumentGoal,Object.assign({active:_this2.state.modalMessageDocumentGoalShow,goalDocument:goalDocument,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageDocument(key,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),validEditGoal&&validActions?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editDocumentGoal(row.id,key,k,versionPhaseGoal);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):''),goalDocument&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalDocument)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,goalDocument.length,'\xA0- Documentos')):'Ningún documento'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:15+'%',padding:'1em .5em 1em 30px'}},_this2.state.modalMessageExpensesGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageExpenseGoal,Object.assign({active:_this2.state.modalMessageExpensesGoalShow,amounts:row.amounts,data:versionPhaseGoal,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageExpenses(key,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})),validEditGoal&&validActions?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editExpensesGoal(row.id,financial.data.agency_id,key,k,row.requires_employees,versionPhaseGoal,row.agencies);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-inm-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Monto ejercido')),Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(row.amounts.spent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-inm-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Monto por ejercer')),Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(row.amounts.missing)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'1em .5em 1em 30px'}},_this2.state.modalMessageActorsGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageActors,{active:_this2.state.modalMessageActorsGoalShow,actors:row.actors,closeModal:function closeModal(){return _this2._toggleModal();}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageActors(key,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})),validEditGoal&&validActions?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editActorsGoal(row.id,key,k,row.actors);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(row.actors)+' actores estrat\xE9gicos')),match.params.modality==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'1em .5em 1em 30px'}},_this2.state.modalMessageConagoGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageConago,{active:_this2.state.modalMessageConagoGoalShow,conago_clauses:row.conago_clauses,closeModal:function closeModal(){return _this2._toggleModal();}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageConago(key,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})),validEditGoal&&validActions?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editConagoClausesGoal(row.id,key,k,row.conago_clauses);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(row.conago_clauses)+' cl\xE1usulas CONAGO')):null),goalRevision&&goalRevision.comment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification '+(goalRevision.status?'is-'+goalRevision.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0',goalRevision.comment))):null,match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:validCdm?2:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-5'},'CDM\'S'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'reports.financial.agency['+k+'].id',name:'agency_id',id:'agency_id'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},' -- CDM\'S --'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(row.agencies,function(cdm,o){var cdmStatus=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(row.project_version_phase_goal,{agency_id:cdm.id});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:o,value:cdm.id,className:cdmStatus&&cdmStatus.status&&cdmStatus.status.id!==1?'has-text-'+cdmStatus.status.style:''},cdm.agenciable&&cdm.agenciable.name?cdm.agenciable.name:'---');})))))),validCdm?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'1em .5em 1em 30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'field-notification',style:{backgroundColor:'#fff',top:'-'+100+'%',transform:'translateY(-100%)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Estatus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),findAgency&&findAgency.status&&findAgency.status.id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-'+findAgency.status.style},findAgency.status.name):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin estatus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Motivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,findAgency&&findAgency.status_motive?findAgency.status_motive.name:'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),validEditGoalCdm?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._editStatusGoalMod(row.id,agencyId,key,k,findAgency,findCdm.agenciable.name);},style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{style:{fontSize:'1em'}},'ESTATUS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),findAgency&&findAgency.status&&findAgency.status.id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-'+findAgency.status.style},findAgency.status.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sin estatus')):null,validCdm?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'1em .5em 1em 30px'}},_this2.state.modalMessageDocumentGoalShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageDocumentGoal,Object.assign({active:_this2.state.modalMessageDocumentGoalShow,goalDocument:goalDocument,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageDocument(key,k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),validEditGoalCdm&&findAgency?findAgency.status&&findAgency.status.actions==='delete'?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editDocumentGoalMod(row.id,agencyId,key,k,findAgency,findCdm.agenciable.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{style:{fontSize:'1em'}},'DOCUMENTO META'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),goalDocument&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalDocument)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,goalDocument.length,'\xA0- Documentos')):'Ningún documento'):null):null,goalRevisionCdm&&goalRevisionCdm.comment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification '+(goalRevisionCdm.status?'is-'+goalRevisionCdm.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0',goalRevisionCdm.comment))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-primary is-small',onClick:function onClick(){return _this2._activityShow(row.id);},disabled:match.params.modality==='modalidad-iii'?validCdm?false:true:false},'Ver actividades'))),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this2.state.activitiesShow,{goal_id:row.id}))?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Medio de verificaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(row.project_goal_activities,function(item,o){var actRevision=undefined;var actRevisionAllowEdit=undefined;var activityStatus=undefined;var activityMotive=undefined;var activityDocument=undefined;var versionPhaseGoalActivity=undefined;var validActionsActivity=undefined;var validEditActivity=fc;if(match.params.modality!=='modalidad-iii'){actRevision=goalRevision&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalRevision.activities)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalRevision.activities[item.id])?goalRevision.activities[item.id]:undefined;actRevisionAllowEdit=actRevision&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(actRevision.allow_edit)?actRevision.allow_edit==='true'?true:false:undefined;validEditActivity=fc?revisionFinancial&&actRevisionAllowEdit!==undefined?actRevisionAllowEdit:revisionFinancial&&actRevisionAllowEdit===undefined?false:fc:false;validActionsActivity=validActions;versionPhaseGoalActivity=item.project_version_phase_goal_activity;activityStatus=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(status.data,{id:3}).statuses,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(versionPhaseGoalActivity.status_id)}):undefined;activityMotive=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity)&&activityStatus?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(activityStatus.motives,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(versionPhaseGoalActivity.status_motive_id)}):undefined;activityDocument=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity.documents)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(versionPhaseGoalActivity.documents,{documentable_subtype:'verification_media'}):undefined;}else{validActionsActivity=findAgency?findAgency.status&&findAgency.status.actions==='delete'?false:true:false;versionPhaseGoalActivity=validCdm?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(item.project_version_phase_goal_activity,{agency_id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(agencyId)}):undefined;activityStatus=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(status.data,{id:3}).statuses,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(versionPhaseGoalActivity.status_id)}):undefined;activityMotive=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity)&&activityStatus?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(activityStatus.motives,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(versionPhaseGoalActivity.status_motive_id)}):undefined;activityDocument=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity.documents)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(versionPhaseGoalActivity.documents,{documentable_subtype:'verification_media'}):undefined;actRevision=goalRevisionCdm&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalRevisionCdm.activities)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalRevisionCdm.activities[item.id])?goalRevisionCdm.activities[item.id]:undefined;actRevisionAllowEdit=actRevision&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(actRevision.allow_edit)?actRevision.allow_edit==='true'?true:false:undefined;validEditActivity=fc?revisionFinancial&&actRevisionAllowEdit!==undefined?actRevisionAllowEdit:revisionFinancial&&actRevisionAllowEdit===undefined?false:fc:false;}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:50+'%'}},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:20+'%',padding:'1em .5em 1em 30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'field-notification',style:{backgroundColor:'#fff',top:'-'+100+'%',transform:'translateY(-100%)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Estatus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),versionPhaseGoalActivity&&activityStatus&&activityStatus.id!==0&&activityStatus.id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-'+activityStatus.style},activityStatus.name):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin estatus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Motivos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,versionPhaseGoalActivity&&activityStatus&&activityMotive?activityMotive.name:'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),validEditActivity&&validActionsActivity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editStatusActivity(item.id,row.id,key,k,o,versionPhaseGoalActivity,agencyId,findCdm?findCdm.agenciable.name:undefined);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):''),versionPhaseGoalActivity&&activityStatus&&activityStatus.id!==0&&activityStatus.id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-'+activityStatus.style},activityStatus.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin estatus')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'1em .5em 1em 30px'}},_this2.state.modalMessageMediaActivityShow&&key===_this2.state.axisIndex&&k===_this2.state.goalIndex&&o===_this2.state.activityIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageMediaActivity,Object.assign({active:_this2.state.modalMessageMediaActivityShow,activityDocument:activityDocument,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageMedia(key,k,o);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})),validEditActivity&&validActionsActivity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editMediaActivity(item.id,row.id,key,k,o,versionPhaseGoalActivity,agencyId,findCdm?findCdm.agenciable.name:undefined);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):''),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(item.verification_media)?item.verification_media.name:'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),activityDocument&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(activityDocument)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,activityDocument.length,'\xA0- Archivos cargados')):'Ningún archivo cargado')),goalRevision&&actRevision&&actRevision.comment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'rev-'+o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification '+(actRevision.status?'is-'+actRevision.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0',actRevision.comment))):null];}))):''))))];}):'':'');})));}}]);function Financial(){_classCallCheck(this,Financial);var _this=_possibleConstructorReturn(this,(Financial.__proto__||Object.getPrototypeOf(Financial)).call(this));_this.state={axisId:undefined,axisIndex:undefined,showAxis:false,goalIndex:undefined,activityIndex:undefined,activitiesShow:[],modalStatusGoalShow:false,modalStatusActivityShow:false,modalDocumentGoalShow:false,modalExpensesGoalShow:false,modalMediaActivityShow:false,modalActorsGoalShow:false,modalConagoGoalShow:false,modalMessageDocumentGoalShow:false,modalMessageMediaActivityShow:false,modalMessageExpensesGoalShow:false,modalMessageActorsGoalShow:false,modalMessageConagoGoalShow:false};return _this;}_createClass(Financial,[{key:'_showAxis',value:function _showAxis(id){var modality=this.props.match.params.modality;if(modality==='modalidad-iii'){this.props.reset('reports.financial.agency');}if(id!==this.state.axisId){this.setState({axisId:id,showAxis:true});}else{this.setState({axisId:undefined,showAxis:false});}}},{key:'_activityShow',value:function _activityShow(id){var activities=this.state.activitiesShow;var foundShow=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(activities,{goal_id:id});if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(foundShow)){var indexShow=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(activities,{goal_id:id});activities.splice(indexShow,1);this.setState({activitiesShow:[].concat(_toConsumableArray(activities))});}else{this.setState({activitiesShow:[].concat(_toConsumableArray(activities),[{goal_id:id,show:true}])});}}},{key:'_editStatusGoal',value:function _editStatusGoal(id,indexAxis,indexGoal,versionPhaseGoal){this.props.reset('reports.financial.edit');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoal)){this.props.change('reports.financial.edit',Object.assign({},versionPhaseGoal,{indexAxis:indexAxis,indexGoal:indexGoal}));}else{this.props.change('reports.financial.edit',{project_goal_id:id,indexAxis:indexAxis,indexGoal:indexGoal});}this.setState({modalStatusGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_editStatusGoalMod',value:function _editStatusGoalMod(id,agencyId,indexAxis,indexGoal,versionPhaseGoal,agencyName){this.props.reset('reports.financial.edit');if(versionPhaseGoal!==undefined){this.props.change('reports.financial.edit',Object.assign({},versionPhaseGoal,{indexAxis:indexAxis,indexGoal:indexGoal,agencyName:agencyName}));}else{this.props.change('reports.financial.edit',{project_goal_id:id,agency_id:agencyId,indexAxis:indexAxis,indexGoal:indexGoal,agencyName:agencyName});}this.setState({modalStatusGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_editStatusActivity',value:function _editStatusActivity(id,goal_id,indexAxis,indexGoal,indexActivity,versionPhaseGoalActivity,agencyId,agencyName){this.props.reset('reports.financial.edit');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity)){this.props.change('reports.financial.edit',Object.assign({},versionPhaseGoalActivity,{project_goal_id:goal_id,indexAxis:indexAxis,indexGoal:indexGoal,indexActivity:indexActivity,agencyName:agencyName}));}else{this.props.change('reports.financial.edit',{project_goal_id:goal_id,pga_id:id,agency_id:agencyId,indexAxis:indexAxis,indexGoal:indexGoal,indexActivity:indexActivity,agencyName:agencyName});}this.setState({modalStatusActivityShow:true,axisIndex:indexAxis,goalIndex:indexGoal,activityIndex:indexActivity});}},{key:'_editDocumentGoal',value:function _editDocumentGoal(id,indexAxis,indexGoal,versionPhaseGoal){this.props.reset('reports.financial.edit');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoal)){this.props.change('reports.financial.edit',Object.assign({},versionPhaseGoal,{indexAxis:indexAxis,indexGoal:indexGoal}));}else{this.props.change('reports.financial.edit',{project_goal_id:id,indexAxis:indexAxis,indexGoal:indexGoal});}this.setState({modalDocumentGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_editDocumentGoalMod',value:function _editDocumentGoalMod(id,agencyId,indexAxis,indexGoal,versionPhaseGoal,agencyName){this.props.reset('reports.financial.edit');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoal)){this.props.change('reports.financial.edit',Object.assign({},versionPhaseGoal,{indexAxis:indexAxis,indexGoal:indexGoal,agencyName:agencyName}));}else{this.props.change('reports.financial.edit',{project_goal_id:id,agency_id:agencyId,indexAxis:indexAxis,indexGoal:indexGoal,agencyName:agencyName});}this.setState({modalDocumentGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_editExpensesGoal',value:function _editExpensesGoal(id,agencyId,indexAxis,indexGoal,requiresEmployees,versionPhaseGoal,agencies){this.props.reset('reports.financial.edit');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoal)){this.props.change('reports.financial.edit',Object.assign({},versionPhaseGoal,{agency_id:agencyId,indexAxis:indexAxis,indexGoal:indexGoal,requiresEmployees:requiresEmployees,agencies:agencies}));}else{this.props.change('reports.financial.edit',{project_goal_id:id,agency_id:agencyId,indexAxis:indexAxis,indexGoal:indexGoal,requiresEmployees:requiresEmployees,agencies:agencies});}this.setState({modalExpensesGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_editMediaActivity',value:function _editMediaActivity(id,goal_id,indexAxis,indexGoal,indexActivity,versionPhaseGoalActivity,agencyId,agencyName){this.props.reset('reports.financial.edit');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(versionPhaseGoalActivity)){this.props.change('reports.financial.edit',Object.assign({},versionPhaseGoalActivity,{project_goal_id:goal_id,indexAxis:indexAxis,indexGoal:indexGoal,indexActivity:indexActivity,agencyName:agencyName}));}else{this.props.change('reports.financial.edit',{project_goal_id:goal_id,pga_id:id,agency_id:agencyId,indexAxis:indexAxis,indexGoal:indexGoal,indexActivity:indexActivity,agencyName:agencyName});}this.setState({modalMediaActivityShow:true,axisIndex:indexAxis,goalIndex:indexGoal,activityIndex:indexActivity});}},{key:'_editActorsGoal',value:function _editActorsGoal(id,indexAxis,indexGoal,actors){this.props.reset('reports.financial.edit');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(actors)){this.props.change('reports.financial.edit',{actors:actors,project_goal_id:id,indexAxis:indexAxis,indexGoal:indexGoal});}else{this.props.change('reports.financial.edit',{project_goal_id:id,indexAxis:indexAxis,indexGoal:indexGoal});}this.setState({modalActorsGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_editConagoClausesGoal',value:function _editConagoClausesGoal(id,indexAxis,indexGoal,conago_clauses){this.props.reset('reports.financial.edit');if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(conago_clauses)){this.props.change('reports.financial.edit',{conago_clauses:conago_clauses,project_goal_id:id,indexAxis:indexAxis,indexGoal:indexGoal});}else{this.props.change('reports.financial.edit',{project_goal_id:id,indexAxis:indexAxis,indexGoal:indexGoal});}this.setState({modalConagoGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_showMessageDocument',value:function _showMessageDocument(indexAxis,indexGoal){this.setState({modalMessageDocumentGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_showMessageMedia',value:function _showMessageMedia(indexAxis,indexGoal,indexActivity){this.setState({modalMessageMediaActivityShow:true,axisIndex:indexAxis,goalIndex:indexGoal,activityIndex:indexActivity});}},{key:'_showMessageExpenses',value:function _showMessageExpenses(indexAxis,indexGoal){this.setState({modalMessageExpensesGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_showMessageActors',value:function _showMessageActors(indexAxis,indexGoal){this.setState({modalMessageActorsGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_showMessageConago',value:function _showMessageConago(indexAxis,indexGoal){this.setState({modalMessageConagoGoalShow:true,axisIndex:indexAxis,goalIndex:indexGoal});}},{key:'_toggleModal',value:function _toggleModal(){this.setState({modalStatusGoalShow:false,modalStatusActivityShow:false,modalDocumentGoalShow:false,modalExpensesGoalShow:false,modalMediaActivityShow:false,modalActorsGoalShow:false,modalConagoGoalShow:false,modalMessageDocumentGoalShow:false,modalMessageMediaActivityShow:false,modalMessageExpensesGoalShow:false,modalMessageActorsGoalShow:false,modalMessageConagoGoalShow:false});this.props.reset('reports.financial.edit');}}]);return Financial;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Financial);var ModalStatusGoal=function(_Component2){_inherits(ModalStatusGoal,_Component2);function ModalStatusGoal(){_classCallCheck(this,ModalStatusGoal);return _possibleConstructorReturn(this,(ModalStatusGoal.__proto__||Object.getPrototypeOf(ModalStatusGoal)).apply(this,arguments));}_createClass(ModalStatusGoal,[{key:'render',value:function render(){var _this4=this;var _props2=this.props,status=_props2.status,reports=_props2.reports,match=_props2.match;var financial=reports.financial;var goalsStatus=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(status.data,{id:2});var statusFound=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(goalsStatus.statuses,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(financial.edit.status_id)});var goalMotives=financial.edit.status_id?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(goalsStatus.statuses,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(financial.edit.status_id)}):undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Estatus de la meta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-5'},'CDM - '+financial.edit.agencyName):'',financial.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.financial.edit',onSubmit:function onSubmit(values){return _this4._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'label'},'Estatus ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'status_id_'+this.props.axisIndex+'_'+this.props.goalIndex,changeAction:function changeAction(model,value){return _this4._changeStatus(model,value);},parser:__WEBPACK_IMPORTED_MODULE_8__parsers__["c" /* toInt */],model:'.status_id',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(goalsStatus.statuses,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.status_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}}))),statusFound&&statusFound.actions==='delete'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0 Si seleccionas estatus\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,statusFound.name),'\xA0 se deshabilitar\xE1n las acciones asociadas a la meta. Si ya has cargado alg\xFAn dato, se eliminar\xE1.'):'',financial.edit.status_id&&goalMotives&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalMotives.motives)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'label'},'Motivo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'status_motive_id_'+this.props.axisIndex+'_'+this.props.goalIndex,parser:__WEBPACK_IMPORTED_MODULE_8__parsers__["c" /* toInt */],model:'.status_motive_id',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(goalMotives.motives,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.status_motive_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El motivo es obligatorio'}}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.financial.edit',className:'button is-success',disabled:financial.data.editable?false:true},'Guardar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.financial.edit;if(edit!==this.props.reports.financial.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}}}}},{key:'_changeStatus',value:function _changeStatus(model,value){this.props.change(model,value);this.props.change('reports.financial.edit.status_motive_id','');}},{key:'_submitForm',value:function _submitForm(values){var financial=this.props.reports.financial;var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.financialGoalStatusSave(values,financial.data,modality,state,municipality);}}]);return ModalStatusGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalStatusActivity=function(_Component3){_inherits(ModalStatusActivity,_Component3);function ModalStatusActivity(){_classCallCheck(this,ModalStatusActivity);return _possibleConstructorReturn(this,(ModalStatusActivity.__proto__||Object.getPrototypeOf(ModalStatusActivity)).apply(this,arguments));}_createClass(ModalStatusActivity,[{key:'render',value:function render(){var _this6=this;var _props3=this.props,status=_props3.status,reports=_props3.reports,match=_props3.match;var financial=reports.financial;var activityStatus=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(status.data,{id:3});var activityMotives=financial.edit.status_id?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(activityStatus.statuses,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(financial.edit.status_id)}):undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Estatus de la actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-5'},'CDM - '+financial.edit.agencyName):'',financial.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.financial.edit',onSubmit:function onSubmit(values){return _this6._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'label'},'Estatus ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'status_id_'+this.props.axisIndex+'_'+this.props.goalIndex,parser:__WEBPACK_IMPORTED_MODULE_8__parsers__["c" /* toInt */],model:'.status_id',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(activityStatus.statuses,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.status_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El estatus es obligatorio'}}))),financial.edit.status_id&&activityMotives&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(activityMotives.motives)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'label'},'Motivo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:'status_motive_id_'+this.props.axisIndex+'_'+this.props.goalIndex,parser:__WEBPACK_IMPORTED_MODULE_8__parsers__["c" /* toInt */],model:'.status_motive_id',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Estatus ---'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(activityMotives.motives,function(stat,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:stat.id,key:k},stat.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.status_motive_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'El motivo es obligatorio'}}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.financial.edit',className:'button is-success',disabled:financial.data.editable?false:true},'Guardar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.financial.edit;if(edit!==this.props.reports.financial.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}}}}},{key:'_submitForm',value:function _submitForm(values){var financial=this.props.reports.financial;var _props$match$params2=this.props.match.params,modality=_props$match$params2.modality,state=_props$match$params2.state,municipality=_props$match$params2.municipality;this.props.financialActivityStatusSave(values,financial.data,modality,state,municipality);}}]);return ModalStatusActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalDocumentGoal=function(_Component4){_inherits(ModalDocumentGoal,_Component4);function ModalDocumentGoal(){_classCallCheck(this,ModalDocumentGoal);return _possibleConstructorReturn(this,(ModalDocumentGoal.__proto__||Object.getPrototypeOf(ModalDocumentGoal)).apply(this,arguments));}_createClass(ModalDocumentGoal,[{key:'render',value:function render(){var _this8=this;var _props4=this.props,reports=_props4.reports,match=_props4.match;var financial=reports.financial;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Documentos meta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-5'},'CDM - '+financial.edit.agencyName):'',financial.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.financial.edit',onSubmit:function onSubmit(values){return _this8._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xBFEl documento generado da cumplimiento a los requerimientos de las Reglas de Operaci\xF3n y fue realizado a entera satisfacci\xF3n?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'comply_rules',className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.comply_rules',id:'comply_rules',isToggle:true}),'S\xED'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xBFLas tem\xE1ticas abordadas y las aportaciones realizadas en los eventos desarrollados (talleres, mesas de trabajo y otros) fueron incluidas en el documento meta?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'comply_topics',className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.comply_topics',id:'comply_topics',isToggle:true}),'S\xED'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_big_file_upload__["a" /* default */],{model:'.document',name:'DOCUMENTO',file:financial.edit.document?financial.edit.document:null,size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info is-large',onClick:function onClick(){return _this8._addDocument();},disabled:financial.edit.document?false:true,style:{height:' 2.55em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus fa-lg'}))))),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(financial.edit.documents)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Documentos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(financial.edit.documents,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Archivo - '+(k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},item.file?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.file,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button is-danger',onClick:function onClick(){return _this8._getConfirm(k);},disabled:financial.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})))))));})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.financial.edit',className:'button is-success',disabled:!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(financial.edit.documents)&&financial.data.editable?false:true},'Guardar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.financial.edit;if(edit!==this.props.reports.financial.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}else if(edit.action==='delete'&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(edit.documents)){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}}}}},{key:'_addDocument',value:function _addDocument(){var document=this.props.reports.financial.edit.document;if(document){this.props.add('reports.financial.edit.documents',document);this.props.change('reports.financial.edit.document',undefined);}}},{key:'_getConfirm',value:function _getConfirm(index){var _this9=this;Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el archivo?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this9._removeDocument(index);}});}},{key:'_removeDocument',value:function _removeDocument(index){var financial=this.props.reports.financial;var _props$match$params3=this.props.match.params,modality=_props$match$params3.modality,state=_props$match$params3.state,municipality=_props$match$params3.municipality;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(financial.edit.documents[index])){this.props.remove('reports.financial.edit.documents',index);}else{this.props.financialGoalDocumentDelete(financial.edit,financial.data,financial.edit.documents[index].id,modality,state,municipality);}}},{key:'_submitForm',value:function _submitForm(values){var financial=this.props.reports.financial;var _props$match$params4=this.props.match.params,modality=_props$match$params4.modality,state=_props$match$params4.state,municipality=_props$match$params4.municipality;this.props.financialGoalDocumentSave(values,financial.data,modality,state,municipality);}}]);return ModalDocumentGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalExpensesGoal=function(_Component5){_inherits(ModalExpensesGoal,_Component5);function ModalExpensesGoal(){_classCallCheck(this,ModalExpensesGoal);return _possibleConstructorReturn(this,(ModalExpensesGoal.__proto__||Object.getPrototypeOf(ModalExpensesGoal)).apply(this,arguments));}_createClass(ModalExpensesGoal,[{key:'render',value:function render(){var _this11=this;var _props5=this.props,reports=_props5.reports,match=_props5.match;var financial=reports.financial;var totalCdms=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Gastos de la meta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},financial.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.financial.edit',onSubmit:function onSubmit(values){return _this11._submitForm(values);}},Boolean(financial.edit.requiresEmployees)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-warning'}),'\xA0 Para agregar comprobantes a este eje tem\xE1tico, es necesario hacerlo en la secci\xF3n de ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'"Personas Contratadas"')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'AGREGAR CFDI'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_big_file_upload__["a" /* default */],{model:'.pdf',name:'PDF',file:financial.edit.pdf,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},message:{required:'Falta anexar PDF'}}),!financial.edit.xmlForm?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_big_file_upload__["a" /* default */],{model:'.xml',name:'XML',file:financial.edit.xml,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},message:{required:'Falta anexar XML'}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_big_file_upload__["a" /* default */],{model:'.sat',name:'Validaci\xF3n SAT',file:financial.edit.sat,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},message:{required:'Falta anexar Validación'}})),financial.edit.action==='xml'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:'.xml'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre(s) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.name',id:'name',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Debes ingresar tu nombre'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rfc',className:'label'},'RFC ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.rfc',id:'rfc',className:'input',placeholder:'RFC',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],isRfc:__WEBPACK_IMPORTED_MODULE_3__field_validations__["e" /* isRfc */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_8__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.rfc',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El RFC es obligatorio. ',isRfc:'RFC inválido. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'date',className:'label'},'Fecha facturaci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.date',id:'date',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},component:__WEBPACK_IMPORTED_MODULE_9__forms_datepicker__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha en la que asumió el cargo es obligatoria. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'concepts',className:'label'},'Concepto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.concepts',id:'concepts',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.concepts',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Debes ingresar el concepto'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'subtotal',className:'label'},'Subtotal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.subtotal',id:'subtotal',className:'input',type:'number',step:'.01',min:'0',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.subtotal',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'taxes_withheld',className:'label'},'Impuesto retenido ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.taxes_withheld',id:'taxes_withheld',className:'input',type:'number',step:'.01',min:'0',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.taxes_withheld',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'taxes_transferred',className:'label'},'Impuesto transferido ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.taxes_transferred',id:'taxes_transferred',className:'input',type:'number',step:'.01',min:'0',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.taxes_transferred',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'taxes_transferred',className:'label'},'Impuesto transferido ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.taxes_transferred',id:'taxes_transferred',className:'input',type:'number',step:'.01',min:'0',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.taxes_transferred',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'total_net',className:'label'},'Total Neto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.total_net',id:'total_net',className:'input',type:'number',step:'.01',min:'0',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.total_net',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'total',className:'label'},'Total ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.total',id:'total',className:'input',type:'number',step:'.01',min:'0',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.total',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}})))):''),match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'DESGLOSE POR CDM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Indica el monto gastado en cada instancia. Recuerda que el total debe ser igual al monto de la factura cargada.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(financial.edit.agencies,function(item,key){totalCdms+=financial.edit.agencies[key].amount?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(financial.edit.agencies[key].amount):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'agencies_amount_'+key,className:'label'},item.agenciable.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.agencies['+key+'].amount',id:'agencies_amount_'+key,className:'input',type:'number',step:'.01',min:'0',errors:{minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.agencies['+key+'].amount',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'is-size-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Total:'),'\xA0',Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(totalCdms)),totalCdms>0?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Se requiere una cantidad')))):'',!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(financial.edit.invoices)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Facturas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'PDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'XML'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'SAT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Accion'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(financial.edit.invoices,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.date+' - '+Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.pdf,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.xml,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.sat,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button is-danger',onClick:function onClick(){return _this11._getConfirm(k);},disabled:financial.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))))));})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.financial.edit',className:'button is-success',disabled:this._validSubmit(totalCdms)},'Guardar')))))),Boolean(financial.edit.requiresEmployees)?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.financial.edit;if(edit!==this.props.reports.financial.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}else if(edit.action==='delete'&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(edit.invoices)){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}}}}},{key:'_getConfirm',value:function _getConfirm(index){var _this12=this;Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la factura?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this12._removeInvoice(index);}});}},{key:'_removeInvoice',value:function _removeInvoice(index){var financial=this.props.reports.financial;var _props$match$params5=this.props.match.params,modality=_props$match$params5.modality,state=_props$match$params5.state,municipality=_props$match$params5.municipality;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(financial.edit.invoices[index])){this.props.remove('reports.financial.edit.invoices',index);}else{this.props.financialGoalInvoiceDelete(financial.edit,financial.data,financial.edit.invoices[index].id,modality,state,municipality);}}},{key:'_submitForm',value:function _submitForm(values){var financial=this.props.reports.financial;var _props$match$params6=this.props.match.params,modality=_props$match$params6.modality,state=_props$match$params6.state,municipality=_props$match$params6.municipality;this.props.financialGoalInvoicesSave(values,financial.data,modality,state,municipality);}},{key:'_validSubmit',value:function _validSubmit(totalCdms){var modality=this.props.match.params.modality;var financial=this.props.reports.financial;var valid=false;if(financial.data.editable){if(modality!=='modalidad-iii'){valid=false;}else{if(totalCdms>0){valid=false;}else{valid=true;}}}else{valid=true;}return valid;}}]);return ModalExpensesGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMediaActivity=function(_Component6){_inherits(ModalMediaActivity,_Component6);function ModalMediaActivity(){_classCallCheck(this,ModalMediaActivity);return _possibleConstructorReturn(this,(ModalMediaActivity.__proto__||Object.getPrototypeOf(ModalMediaActivity)).apply(this,arguments));}_createClass(ModalMediaActivity,[{key:'render',value:function render(){var _this14=this;var _props6=this.props,reports=_props6.reports,match=_props6.match;var financial=reports.financial;//verification_media
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Medio de verificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-5'},'CDM - '+financial.edit.agencyName):'',financial.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.financial.edit',className:'modal-card-body',onSubmit:function onSubmit(values){return _this14._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_big_file_upload__["a" /* default */],{model:'.file',name:'Archivo',file:financial.edit.file,size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info is-large',onClick:function onClick(){return _this14._addDocument();},disabled:financial.edit.file?false:true,style:{height:' 2.55em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus fa-lg'}))))),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(financial.edit.documents)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Documentos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(financial.edit.documents,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Documento - '+(k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},item.file?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.file,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button is-danger',onClick:function onClick(){return _this14._getConfirm(k);},disabled:financial.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'})))))));})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.financial.edit',className:'button is-success',type:'submit',disabled:!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(financial.edit.documents)&&financial.data.editable?false:true},'Guardar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.financial.edit;if(edit!==this.props.reports.financial.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}else if(edit.action==='delete'&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(edit.documents)){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}}}}},{key:'_addDocument',value:function _addDocument(){var file=this.props.reports.financial.edit.file;if(file){this.props.add('reports.financial.edit.documents',file);this.props.change('reports.financial.edit.file',undefined);}}},{key:'_getConfirm',value:function _getConfirm(index){var _this15=this;Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar el archivo?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this15._removeDocument(index);}});}},{key:'_removeDocument',value:function _removeDocument(index){var financial=this.props.reports.financial;var _props$match$params7=this.props.match.params,modality=_props$match$params7.modality,state=_props$match$params7.state,municipality=_props$match$params7.municipality;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(financial.edit.documents[index])){this.props.remove('reports.financial.edit.documents',index);}else{this.props.financialActivityMediaDelete(financial.edit,financial.data,financial.edit.documents[index].id,modality,state,municipality);}}},{key:'_submitForm',value:function _submitForm(values){var financial=this.props.reports.financial;var _props$match$params8=this.props.match.params,modality=_props$match$params8.modality,state=_props$match$params8.state,municipality=_props$match$params8.municipality;this.props.financialActivityMediaSave(values,financial.data,modality,state,municipality);}}]);return ModalMediaActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalActorsGoal=function(_Component7){_inherits(ModalActorsGoal,_Component7);_createClass(ModalActorsGoal,[{key:'render',value:function render(){var _this17=this;var _props7=this.props,directories=_props7.directories,reports=_props7.reports;var financial=reports.financial;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Seleccione los actores estrat\xE9gicos que aplican'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},financial.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.financial.edit',onSubmit:function onSubmit(values){return _this17._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(directories.actors_groups,function(group,key){var actors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(directories.actors,{group_id:group.id});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box',style:{marginBottom:'-0.6em',height:'auto',backgroundColor:'#aaa',cursor:'pointer'},onClick:function onClick(){return _this17._showGroup(group.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-left',style:{width:'90%',display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item',style:{display:'initial'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title is-5',style:{color:'#fff'}},group.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon',style:{color:'#fff'}},_this17.state.groupId===group.id&&_this17.state.showGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-up'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-down'})))))),_this17.state.groupId===group.id&&_this17.state.showGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline conago-checkboxes',style:{marginTop:'0.65em'}},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(actors,function(actor,k){var shouldCheck=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(financial.edit.actors,{id:actor.id})!==undefined?true:false;//console.log('shouldCheck==>',shouldCheck);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'actor-'+actor.id,className:'checkbox',disabled:financial.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',ref:'g-actor-'+actor.id,id:'actor-'+actor.id,value:actor.id,checked:shouldCheck,onChange:function onChange(){return _this17._changeCheckBox(actor.id);},className:'checkbox',disabled:financial.data.editable?false:true}),actor.name));})):'');}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.financial.edit',className:'button is-success',disabled:financial.data.editable?false:true},'Guardar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}}]);function ModalActorsGoal(){_classCallCheck(this,ModalActorsGoal);var _this16=_possibleConstructorReturn(this,(ModalActorsGoal.__proto__||Object.getPrototypeOf(ModalActorsGoal)).call(this));_this16.state={showGroup:false,groupId:undefined};return _this16;}_createClass(ModalActorsGoal,[{key:'_showGroup',value:function _showGroup(id){if(id!==this.state.groupId){this.setState({groupId:id,showGroup:true});}else{this.setState({groupId:undefined,showGroup:false});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.financial.edit;if(edit!==this.props.reports.financial.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}}}}},{key:'_changeCheckBox',value:function _changeCheckBox(actorId){var actors=this.props.reports.financial.edit.actors;var actorIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(actors,{id:actorId});if(this.refs['g-actor-'+actorId].checked){if(actorIndex===-1){this.props.add('reports.financial.edit.actors',{id:actorId});}}else{if(actorIndex!==-1){this.props.remove('reports.financial.edit.actors',actorIndex);}}}},{key:'_submitForm',value:function _submitForm(values){var financial=this.props.reports.financial;var _props$match$params9=this.props.match.params,modality=_props$match$params9.modality,state=_props$match$params9.state,municipality=_props$match$params9.municipality;this.props.financialGoalActorsSave(values,financial.data,modality,state,municipality);}}]);return ModalActorsGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalConagoGoal=function(_Component8){_inherits(ModalConagoGoal,_Component8);function ModalConagoGoal(){_classCallCheck(this,ModalConagoGoal);return _possibleConstructorReturn(this,(ModalConagoGoal.__proto__||Object.getPrototypeOf(ModalConagoGoal)).apply(this,arguments));}_createClass(ModalConagoGoal,[{key:'render',value:function render(){var _this19=this;var _props8=this.props,directories=_props8.directories,reports=_props8.reports;var financial=reports.financial;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Seleccione las metas que aplican'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},financial.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.financial.edit',onSubmit:function onSubmit(values){return _this19._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline conago-checkboxes'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(directories.conago,function(conago,k){var shouldCheck=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(financial.edit.conago_clauses,{id:conago.id})!==undefined?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'conago-'+conago.id,className:'checkbox',disabled:financial.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',ref:'g-conago-'+conago.id,id:'conago-'+conago.id,value:conago.id,checked:shouldCheck,onChange:function onChange(){return _this19._changeCheckBox(conago.id);},className:'checkbox',disabled:financial.data.editable?false:true}),conago.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.financial.edit',className:'button is-success',disabled:financial.data.editable?false:true},'Guardar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.financial.edit;if(edit!==this.props.reports.financial.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.financial.edit.action',undefined);}}}}},{key:'_changeCheckBox',value:function _changeCheckBox(conagoId){var conago_clauses=this.props.reports.financial.edit.conago_clauses;var conagoIndex=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(conago_clauses,{id:conagoId});if(this.refs['g-conago-'+conagoId].checked){if(conagoIndex===-1){this.props.add('reports.financial.edit.conago_clauses',{id:conagoId});}else{this.props.change('reports.financial.edit.conago_clauses['+conagoIndex+']',{id:conagoId});}}else{if(conagoIndex!==-1){this.props.remove('reports.financial.edit.conago_clauses',conagoIndex);}}}},{key:'_submitForm',value:function _submitForm(values){var financial=this.props.reports.financial;var _props$match$params10=this.props.match.params,modality=_props$match$params10.modality,state=_props$match$params10.state,municipality=_props$match$params10.municipality;this.props.financialGoalConagoSave(values,financial.data,modality,state,municipality);}}]);return ModalConagoGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageDocumentGoal=function(_Component9){_inherits(ModalMessageDocumentGoal,_Component9);function ModalMessageDocumentGoal(){_classCallCheck(this,ModalMessageDocumentGoal);return _possibleConstructorReturn(this,(ModalMessageDocumentGoal.__proto__||Object.getPrototypeOf(ModalMessageDocumentGoal)).apply(this,arguments));}_createClass(ModalMessageDocumentGoal,[{key:'render',value:function render(){var goalDocument=this.props.goalDocument;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content',style:{height:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalDocument)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Documentos meta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete','aria-label':'delete',onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'El documento generado da cumplimiento a los requerimientos de las Reglas de Operaci\xF3n y fue realizado a entera satisfacci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,goalDocument?'Si':'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xBFLas tem\xE1ticas abordadas y las aportaciones realizadas en los eventos desarrollados (talleres, mesas de trabajo y otros) fueron incluidas en el documento meta?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,goalDocument?'Si':'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Archivos')),goalDocument?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(goalDocument,function(item,k){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.file,key:k,target:'_blank'},'Archivo - '+(k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br_'+k})];}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'modal-close is-large','aria-label':'close',onClick:this.props.closeModal}));}}]);return ModalMessageDocumentGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageMediaActivity=function(_Component10){_inherits(ModalMessageMediaActivity,_Component10);function ModalMessageMediaActivity(){_classCallCheck(this,ModalMessageMediaActivity);return _possibleConstructorReturn(this,(ModalMessageMediaActivity.__proto__||Object.getPrototypeOf(ModalMessageMediaActivity)).apply(this,arguments));}_createClass(ModalMessageMediaActivity,[{key:'render',value:function render(){var activityDocument=this.props.activityDocument;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content',style:{height:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(activityDocument)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Medio de verificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete','aria-label':'delete',onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Archivos')),activityDocument?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(activityDocument,function(item,k){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.file,key:k,target:'_blank'},'Archivo - '+(k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br_'+k})];}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'modal-close is-large','aria-label':'close',onClick:this.props.closeModal}));}}]);return ModalMessageMediaActivity;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageExpenseGoal=function(_Component11){_inherits(ModalMessageExpenseGoal,_Component11);function ModalMessageExpenseGoal(){_classCallCheck(this,ModalMessageExpenseGoal);return _possibleConstructorReturn(this,(ModalMessageExpenseGoal.__proto__||Object.getPrototypeOf(ModalMessageExpenseGoal)).apply(this,arguments));}_createClass(ModalMessageExpenseGoal,[{key:'render',value:function render(){var _props9=this.props,data=_props9.data,amounts=_props9.amounts;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content',style:{height:!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data.invoices)||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Gastos de la meta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete','aria-label':'delete',onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Monto aprobado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(amounts.total)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Monto ejercido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(amounts.spent))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Monto por ejercer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(amounts.missing))))),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data.invoices)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Facturas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'PDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'XML'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'SAT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.invoices,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.date+' - '+Object(__WEBPACK_IMPORTED_MODULE_4_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.pdf,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.xml,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.sat,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))));})))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'modal-close is-large','aria-label':'close',onClick:this.props.closeModal}));}}]);return ModalMessageExpenseGoal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageActors=function(_Component12){_inherits(ModalMessageActors,_Component12);function ModalMessageActors(){_classCallCheck(this,ModalMessageActors);return _possibleConstructorReturn(this,(ModalMessageActors.__proto__||Object.getPrototypeOf(ModalMessageActors)).apply(this,arguments));}_createClass(ModalMessageActors,[{key:'render',value:function render(){var actors=this.props.actors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Actores estrat\xE9gicos que aplican'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete is-medium','aria-label':'delete'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(actors,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:k,type:'disc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},item.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:this.props.closeModal},'Cerrar')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'modal-close is-large','aria-label':'close',onClick:this.props.closeModal}));}}]);return ModalMessageActors;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageConago=function(_Component13){_inherits(ModalMessageConago,_Component13);function ModalMessageConago(){_classCallCheck(this,ModalMessageConago);return _possibleConstructorReturn(this,(ModalMessageConago.__proto__||Object.getPrototypeOf(ModalMessageConago)).apply(this,arguments));}_createClass(ModalMessageConago,[{key:'render',value:function render(){var conago_clauses=this.props.conago_clauses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Metas conago que aplican'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete is-medium','aria-label':'delete'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(conago_clauses,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:k,type:'disc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},item.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-info',type:'button',onClick:this.props.closeModal},'Cerrar')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'modal-close is-large','aria-label':'close',onClick:this.props.closeModal}));}}]);return ModalMessageConago;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_reports__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_reports_expenses__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsExpenses=function(_Component){_inherits(ReportsExpenses,_Component);function ReportsExpenses(){_classCallCheck(this,ReportsExpenses);return _possibleConstructorReturn(this,(ReportsExpenses.__proto__||Object.getPrototypeOf(ReportsExpenses)).apply(this,arguments));}_createClass(ReportsExpenses,[{key:'render',value:function render(){var _props=this.props,reports=_props.reports,revision=_props.revision;var expenses=reports.expenses;return revision.isFetching||expenses.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_reports_expenses__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;//this.props.fetchRevisions(modality, state, municipality);
this.props.reportsExpenses(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.match.params!==this.props.match.params){//this.props.fetchRevisions(modality, state, municipality);
this.props.reportsExpenses(modality,state,municipality);}}}]);return ReportsExpenses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_reports__["a" /* default */])(ReportsExpenses,{subnav:2}));

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_datepicker__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Expenses=function(_Component){_inherits(Expenses,_Component);_createClass(Expenses,[{key:'render',value:function render(){var _this2=this;var _props=this.props,reports=_props.reports,match=_props.match;var expenses=reports.expenses;var revision=expenses.revision;var modality=match.params.modality;var ec=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(reports.permissions,function(o){return o==='Create';})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},this.state.modalExpenseShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalExpensesInvoices,Object.assign({active:this.state.modalExpenseShow,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table',style:{fontSize:'.85em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Concepto del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Unidad de medida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Costo unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto ejercido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(expenses.data.project_expenses,function(row,k){var revisionExpenses=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revision.body)?revision.body:undefined;var expRevision=revisionExpenses&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revisionExpenses[row.id])?revisionExpenses[row.id]:undefined;var expRevisionAllowEdit=expRevision&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(expRevision.allow_edit)?expRevision.allow_edit==='true'?true:false:undefined;var validEditExp=ec?revisionExpenses&&expRevisionAllowEdit!==undefined?expRevisionAllowEdit:revisionExpenses&&expRevisionAllowEdit===undefined?false:ec:false;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'},rowSpan:revisionExpenses&&expRevision&&expRevision.comment?2:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:30+'%'}},row.expense_concept?row.expense_concept.name:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.expense_unit?row.expense_unit.name:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),!row.expense_unit.invoiceable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'has-text-danger'},'No facturable'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right',style:{width:10+'%'}},Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.amount?row.amount:0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},row.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:15+'%',padding:'1em .5em 1em 30px'}},_this2.state.modalMessageExpensesShow&&k===_this2.state.expenseIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageExpenses,Object.assign({active:_this2.state.modalMessageExpensesShow,unit:row.expense_unit,amountTotal:row.total,data:row.project_version_phase_expense,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageExpenses(k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})),validEditExp?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editExpenseDocuments(row.id,k,row.project_version_phase_expense,expenses.data.agencies,row.expense_unit);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-inm-purple'},'Monto ejercido'),Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.project_version_phase_expense&&row.project_version_phase_expense.amounts?row.project_version_phase_expense.amounts.spent_total:0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-inm-purple'},'Monto por ejercer'),Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(row.project_version_phase_expense&&row.project_version_phase_expense.amounts?row.project_version_phase_expense.amounts.missing:row.total))),expRevision&&expRevision.comment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'exp-rev-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification '+(expRevision.status?'is-'+expRevision.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0',expRevision.comment),modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(expenses.data.agencies,function(rev,o){var expenseRevisionCdm=revisionExpenses&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revisionExpenses[row.id])&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revisionExpenses[row.id].agencies)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revisionExpenses[row.id].agencies[rev.id])?revisionExpenses[row.id].agencies[rev.id]:undefined;if(expenseRevisionCdm&&expenseRevisionCdm.comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Revisi\xF3n del gasto No. '+(k+1)+' por CDM - '+rev.agenciable.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification '+(expenseRevisionCdm.status?'is-'+expenseRevisionCdm.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0',expenseRevisionCdm.comment));}}):'')):null];}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:6,className:'has-text-centered',style:{backgroundColor:'#a864a9'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{style:{color:'#fff'}},'Total Aprobado / Ejercido / Por ejercer\xA0','              '+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(expenses.data)?expenses.data.amounts.expenses.total:0)+' / '+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(expenses.data)?expenses.data.amounts.expenses.spent:0)+' / '+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(expenses.data)?expenses.data.amounts.expenses.missing:0))))))));}}]);function Expenses(){_classCallCheck(this,Expenses);var _this=_possibleConstructorReturn(this,(Expenses.__proto__||Object.getPrototypeOf(Expenses)).call(this));_this.state={modalExpenseShow:false,expenseIndex:undefined,modalMessageExpensesShow:false};return _this;}_createClass(Expenses,[{key:'_editExpenseDocuments',value:function _editExpenseDocuments(id,indexExpense,versionPhaseGoal,agencies,unit){this.props.reset('reports.expenses.edit');if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(versionPhaseGoal)){this.props.change('reports.expenses.edit',Object.assign({},versionPhaseGoal,{indexExpense:indexExpense,agencies:agencies,invoiceable:unit.invoiceable,unit_name:unit.name}));}else{this.props.change('reports.expenses.edit',{project_expense_id:id,indexExpense:indexExpense,agencies:agencies,invoiceable:unit.invoiceable,unit_name:unit.name});}this.setState({modalExpenseShow:true,expenseIndex:indexExpense});}},{key:'_showMessageExpenses',value:function _showMessageExpenses(indexExpense){this.setState({modalMessageExpensesShow:true,expenseIndex:indexExpense});}},{key:'_toggleModal',value:function _toggleModal(){this.setState({modalExpenseShow:false,modalMessageExpensesShow:false});this.props.reset('reports.expenses.edit');}}]);return Expenses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Expenses);var ModalExpensesInvoices=function(_Component2){_inherits(ModalExpensesInvoices,_Component2);function ModalExpensesInvoices(){_classCallCheck(this,ModalExpensesInvoices);return _possibleConstructorReturn(this,(ModalExpensesInvoices.__proto__||Object.getPrototypeOf(ModalExpensesInvoices)).apply(this,arguments));}_createClass(ModalExpensesInvoices,[{key:'render',value:function render(){var _this4=this;var _props2=this.props,reports=_props2.reports,match=_props2.match,revision=_props2.revision;var expenses=reports.expenses;var totalCdms=0;var revisionExpenses=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revision.body)?revision.body:undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Gastos de coordinaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},expenses.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.expenses.edit',onSubmit:function onSubmit(values){return _this4._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},''+expenses.edit.unit_name)),expenses.edit.invoiceable?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'has-text-danger'},'No facturable')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'AGREGAR CFDI'),expenses.edit.invoiceable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__["a" /* default */],{model:'.pdf',name:'PDF',file:expenses.edit.pdf,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_5__field_validations__["m" /* required */]},message:{required:'Falta anexar PDF'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__["a" /* default */],{model:'.xml',name:'XML',file:expenses.edit.xml,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_5__field_validations__["m" /* required */]},message:{required:'Falta anexar XML'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__["a" /* default */],{model:'.sat',name:'Validaci\xF3n SAT',file:expenses.edit.sat,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_5__field_validations__["m" /* required */]},message:{required:'Falta anexar Validación'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__["a" /* default */],{model:'.file',name:'Comprobante',file:expenses.edit.file,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_5__field_validations__["m" /* required */]},message:{required:'Falta anexar Comprobante'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'amount',className:'label'},'Monto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.total',id:'total',className:'input',type:'number',step:'.01',min:'0',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_5__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_5__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.total',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'date',className:'label'},'Fecha de recibo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.date',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_5__field_validations__["d" /* isRequired */]},validateOn:'change',id:'date',component:__WEBPACK_IMPORTED_MODULE_8__forms_datepicker__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.date',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'label'},'Concepto ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].textarea,{model:'.concepts',id:'concepts',className:'textarea',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_5__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.concepts',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El concepto es obligatorio'}}))))),match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'DESGLOSE POR CDM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Indica el monto gastado en cada instancia. Recuerda que el total debe ser igual al monto de la factura cargada.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-multiline'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(expenses.edit.agencies,function(item,key){totalCdms+=expenses.edit.agencies[key].amount?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(expenses.edit.agencies[key].amount):0;var expenseRevisionCdm=revisionExpenses&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revisionExpenses[expenses.edit.project_expense_id])&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revisionExpenses[expenses.edit.project_expense_id].agencies)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(revisionExpenses[expenses.edit.project_expense_id].agencies[item.id])?revisionExpenses[expenses.edit.project_expense_id].agencies[item.id]:undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control',key:key},expenseRevisionCdm&&expenseRevisionCdm.comment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'field-notification is-'+expenseRevisionCdm.status},expenseRevisionCdm.comment):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'agencies_amount_'+key,className:'label'},item.agenciable.name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.agencies['+key+'].amount',id:'agencies_amount_'+key,className:'input'+(expenseRevisionCdm?' is-'+expenseRevisionCdm.status:''),type:'number',step:'.01',min:'0',errors:{minValue:Object(__WEBPACK_IMPORTED_MODULE_5__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.agencies['+key+'].amount',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'is-size-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Total:'),'\xA0',Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(totalCdms)),totalCdms>0?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},'Se requiere una cantidad')))):'',!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(expenses.edit.invoices)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Facturas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'PDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'XML'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'SAT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Accion'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(expenses.edit.invoices,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.date+' - '+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.pdf,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.xml,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.sat,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button is-danger',onClick:function onClick(){return _this4._getConfirm(k,expenses.edit.invoiceable);},disabled:expenses.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))))));})))):'',!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(expenses.edit.receipts)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Comprobantes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Comprobante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Archivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Concepto'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(expenses.edit.receipts,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.date+' - '+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.file,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.concepts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button is-danger',onClick:function onClick(){return _this4._getConfirm(k,expenses.edit.invoiceable);},disabled:expenses.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))))));})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.expenses.edit',className:'button is-success',disabled:this._validSubmit(totalCdms)},'Guardar')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.expenses.edit;if(edit!==this.props.reports.expenses.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.expenses.edit.action',undefined);}else if(edit.action==='delete'&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(edit.invoices)){this.props.closeModal();this.props.change('reports.expenses.edit.action',undefined);}}}}},{key:'_getConfirm',value:function _getConfirm(index,invoiceable){var _this5=this;Object(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar '+(invoiceable?'la factura':'el comprobante')+'?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){if(invoiceable){_this5._removeInvoice(index);}else{_this5._removeReceipts(index);}}});}},{key:'_removeInvoice',value:function _removeInvoice(index){var expenses=this.props.reports.expenses;var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(expenses.edit.invoices[index])){this.props.remove('reports.expenses.edit.invoices',index);}else{this.props.expensesInvoiceDelete(expenses.edit,expenses.edit.invoices[index].id,modality,state,municipality);}}},{key:'_removeReceipts',value:function _removeReceipts(index){var expenses=this.props.reports.expenses;var _props$match$params2=this.props.match.params,modality=_props$match$params2.modality,state=_props$match$params2.state,municipality=_props$match$params2.municipality;if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(expenses.edit.receipts[index])){this.props.remove('reports.expenses.edit.receipts',index);}else{this.props.expensesReceiptDelete(expenses.edit,expenses.edit.receipts[index].id,modality,state,municipality);}}},{key:'_submitForm',value:function _submitForm(values){var expenses=this.props.reports.expenses;var _props$match$params3=this.props.match.params,modality=_props$match$params3.modality,state=_props$match$params3.state,municipality=_props$match$params3.municipality;if(expenses.edit.invoiceable){this.props.expenseInvoicesSave(modality,state,municipality,values);}else{this.props.expenseReceiptsSave(modality,state,municipality,values);}}},{key:'_validSubmit',value:function _validSubmit(totalCdms){var modality=this.props.match.params.modality;var expenses=this.props.reports.expenses;var valid=false;if(expenses.data.editable){if(modality!=='modalidad-iii'){valid=false;}else{if(totalCdms>0){valid=false;}else{valid=true;}}}else{valid=true;}return valid;}}]);return ModalExpensesInvoices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageExpenses=function(_Component3){_inherits(ModalMessageExpenses,_Component3);function ModalMessageExpenses(){_classCallCheck(this,ModalMessageExpenses);return _possibleConstructorReturn(this,(ModalMessageExpenses.__proto__||Object.getPrototypeOf(ModalMessageExpenses)).apply(this,arguments));}_createClass(ModalMessageExpenses,[{key:'render',value:function render(){var _props3=this.props,data=_props3.data,amountTotal=_props3.amountTotal,unit=_props3.unit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content',style:{height:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data)&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.invoices)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Gastos de coordinaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete','aria-label':'delete',onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},''+unit.name+(unit.invoiceable?'':' - No facturable')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Monto aprobado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(amountTotal)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Monto ejercido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(data&&data.amounts&&!isNaN(data.amounts.spent_total)?data.amounts.spent_total:0))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Monto por ejercer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(data&&data.amounts&&!isNaN(data.amounts.missing)?data.amounts.missing:amountTotal))))),!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.invoices)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Facturas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'PDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'XML'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'SAT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data.invoices,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.date+' - '+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.pdf,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.xml,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.sat,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))));})))):'',!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data)&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(data.receipts)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Comprobantes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Comprobante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Archivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Concepto'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data.receipts,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.date+' - '+Object(__WEBPACK_IMPORTED_MODULE_2_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.file,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.concepts));})))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'modal-close is-large','aria-label':'close',onClick:this.props.closeModal}));}}]);return ModalMessageExpenses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_reports__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_reports_employees__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsEmployees=function(_Component){_inherits(ReportsEmployees,_Component);function ReportsEmployees(){_classCallCheck(this,ReportsEmployees);return _possibleConstructorReturn(this,(ReportsEmployees.__proto__||Object.getPrototypeOf(ReportsEmployees)).apply(this,arguments));}_createClass(ReportsEmployees,[{key:'render',value:function render(){var _props=this.props,reports=_props.reports,revision=_props.revision;var employees=reports.employees;return revision.isFetching||employees.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_reports_employees__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;//this.props.fetchRevisions(modality, state, municipality);
this.props.reportsEmployees(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.match.params!==this.props.match.params){//this.props.fetchRevisions(modality, state, municipality);
this.props.reportsEmployees(modality,state,municipality);}}}]);return ReportsEmployees;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_reports__["a" /* default */])(ReportsEmployees,{subnav:3}));

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_big_file_upload__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Employees=function(_Component){_inherits(Employees,_Component);_createClass(Employees,[{key:'render',value:function render(){var _this2=this;var _props=this.props,reports=_props.reports,match=_props.match;var modality=match.params.modality;var employees=reports.employees;var revision=employees.revision;var ec=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(reports.permissions,function(o){return o==='Create';})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},this.state.modalPeopleAddShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalPeopleAdd,Object.assign({active:this.state.modalPeopleAddShow,peopleIndex:this.state.peopleIndex,closeModal:function closeModal(){return _this2._toggleModal();}},this.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},/*match.params.modality !== 'modalidad-iii'*/true?// Se deshabilito la validación hasta que se cree la versión 2019 de eTrans
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},ec?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-success',onClick:function onClick(){return _this2._addPeople();},disabled:employees.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-circle'}),'\xA0Agregar persona'):'')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Formaci\xF3n acad\xE9mica'),match.params.modality!=='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Funciones'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Perfil'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'RFC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Instancia'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(employees.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(employees.data.employees)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(employees.data.employees,function(row,k){//let projectGoalAgency = !_.isEmpty(row.project_goal_agency) ? row.project_goal_agency:undefined;
var revisionFinancial=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revision)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revision.body)?revision.body:undefined;var findGoal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(employees.data.project_goals,{id:row.project_goal_id});var goalRevision=undefined;var goalRevisionAllowEdit=undefined;if(modality!=='modalidad-iii'){goalRevision=revisionFinancial&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals[findGoal.id])?revisionFinancial.goals[findGoal.id]:undefined;goalRevisionAllowEdit=goalRevision&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalRevision.allow_edit)?goalRevision.allow_edit==='true'?true:false:undefined;}else{goalRevision=findGoal&&revisionFinancial&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals[findGoal.id])&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(revisionFinancial.goals[findGoal.id].agencies[row.agency_id])?revisionFinancial.goals[findGoal.id].agencies[row.agency_id]:undefined;goalRevisionAllowEdit=goalRevision&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(goalRevision.allow_edit)?goalRevision.allow_edit==='true'?true:false:undefined;}var validEditGoal=ec?revisionFinancial&&goalRevisionAllowEdit!==undefined?goalRevisionAllowEdit:revisionFinancial&&goalRevisionAllowEdit===undefined?false:ec:false;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'},rowSpan:revisionFinancial&&goalRevision&&goalRevision.comment?3:2},_this2.state.modalMessageExpensesShow&&k===_this2.state.employeesIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalMessageExpenses,Object.assign({active:_this2.state.modalMessageExpensesShow,data:row,closeModal:function closeModal(){return _this2._toggleModal();}},_this2.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{cursor:'pointer'},onClick:function onClick(){return _this2._showMessageExpenses(k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'})),validEditGoal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',style:{cursor:'pointer'},onClick:function onClick(){return _this2._editPeopleHired(k);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):''),k+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name+' '+row.last_name+' '+(row.slast_name?row.slast_name:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.scholarship),match.params.modality!=='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.job_function):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.role.display),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.rfc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.agency&&row.agency.agenciable?row.agency.agenciable.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'meta-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-inm-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'META')),findGoal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'('+findGoal.code+')'),findGoal.name):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'---'))),goalRevision&&goalRevision.comment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'rev-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification '+(goalRevision.status?'is-'+goalRevision.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0',goalRevision.comment))):null];}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:6,className:'has-text-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Sin personas contratadas')))))));}}]);function Employees(){_classCallCheck(this,Employees);var _this=_possibleConstructorReturn(this,(Employees.__proto__||Object.getPrototypeOf(Employees)).call(this));_this.state={modalPeopleAddShow:false,employeesIndex:undefined,modalMessageExpensesShow:false};return _this;}_createClass(Employees,[{key:'_addPeople',value:function _addPeople(){this.props.reset('reports.employees.edit');this.setState({modalPeopleAddShow:true});}},{key:'_editPeopleHired',value:function _editPeopleHired(indexEmployees){var employees=this.props.reports.employees;this.props.reset('reports.employees.edit');this.props.change('reports.employees.edit',Object.assign({},employees.data.employees[indexEmployees],{indexEmployees:indexEmployees,project_goal_id:employees.data.employees[indexEmployees].project_goal_id,agency_id:employees.data.employees[indexEmployees].agency_id}));this.setState({modalPeopleAddShow:true,employeesIndex:indexEmployees});}},{key:'_showMessageExpenses',value:function _showMessageExpenses(indexEmployees){this.setState({modalMessageExpensesShow:true,employeesIndex:indexEmployees});}},{key:'_toggleModal',value:function _toggleModal(){this.setState({modalPeopleAddShow:false,modalMessageExpensesShow:false});this.props.reset('reports.employees.edit');}}]);return Employees;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Employees);var ModalPeopleAdd=function(_Component2){_inherits(ModalPeopleAdd,_Component2);function ModalPeopleAdd(){_classCallCheck(this,ModalPeopleAdd);return _possibleConstructorReturn(this,(ModalPeopleAdd.__proto__||Object.getPrototypeOf(ModalPeopleAdd)).apply(this,arguments));}_createClass(ModalPeopleAdd,[{key:'render',value:function render(){var _this4=this;var _props2=this.props,reports=_props2.reports,match=_props2.match,session=_props2.session;var employees=reports.employees;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},'Persona contratada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.props.closeModal,className:'delete','aria-label':'close'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card-body'},employees.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.employees.edit',onSubmit:function onSubmit(values){return _this4._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'DATOS PERSONALES'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre(s) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.name',className:'input',id:'name',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},placeholder:'Nombre(s)',validateOn:'change',readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'last_name',className:'label'},'Primer apellido ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.last_name',className:'input',id:'last_name',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change',readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.last_name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El apellido es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'slast_name',className:'label'},'Segundo apellido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.slast_name',className:'input',id:'slast_name',readOnly:employees.edit.id?true:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'scholarship',className:'label'},'Formaci\xF3n acad\xE9mica ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.scholarship',id:'scholarship',className:'input',placeholder:'Formaci\xF3n acad\xE9mica',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change',readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.scholarship',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El campo es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email',className:'label'},'Email ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.email',className:'input',placeholder:'Email',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],isEmail:__WEBPACK_IMPORTED_MODULE_3__field_validations__["c" /* isEmail */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["a" /* allLower */],readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.email',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El email es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'curp',className:'label'},'CURP ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.curp',id:'curp',className:'input',placeholder:'XXXX000000XXXXXX00',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],maxLength:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["g" /* maxLength */])(18),isCurp:__WEBPACK_IMPORTED_MODULE_3__field_validations__["b" /* isCurp */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["b" /* allUpper */],readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.curp',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La CURP es obligatoria. ',isCurp:'CURP inválida. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rfc',className:'label'},'RFC ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.rfc',id:'rfc',className:'input',placeholder:'XXXX000000XX0',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],isRfc:__WEBPACK_IMPORTED_MODULE_3__field_validations__["e" /* isRfc */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["b" /* allUpper */],readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.rfc',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El RFC es obligatorio. ',isRfc:'RFC inválido. '}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'DATOS DE CONTRATACI\xD3N'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},// Se realiza esta validación porque en 2018 no existía módulo de CDMs (que es donde se registra este dato por medio del perfil del usuario)
match.params.modality!=='modalidad-iii'||session.user.version.year===2018?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'job_function',className:'label'},'Funci\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.job_function',id:'job_function',className:'input',placeholder:'Funci\xF3n',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change',readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.job_function',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El campo es obligatorio'}})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'wage',className:'label'},'Ingreso mensual'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.wage',id:'wage',type:'number',step:'.01',min:'0',className:'input',placeholder:'0,000.00',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change',readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.wage',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label'},'Periodo de contrataci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{style:{margin:'0px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'period_start',className:'label'},'Inicia ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.period_start',name:'period_start',component:__WEBPACK_IMPORTED_MODULE_4__forms_datepicker__["a" /* default */],className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.period_start',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'period_end',className:'label'},'Termina ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.period_end',name:'period_end',component:__WEBPACK_IMPORTED_MODULE_4__forms_datepicker__["a" /* default */],className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change',disabled:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.period_end',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha es obligatorio'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0 Si las facturas son expedidas con otro RFC que no es el de la persona contratada, agregalo aqu\xED. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Recuerda que no podr\xE1s cambiarlo una vez que lo guardes.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rfc_invoices',className:'label'},'RFC facturas expedidas '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.rfc_invoices',id:'rfc_invoices',className:'input',placeholder:'XXXX000000XX0',errors:{isRfc:__WEBPACK_IMPORTED_MODULE_3__field_validations__["e" /* isRfc */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_5__parsers__["b" /* allUpper */],readOnly:employees.edit.id?true:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.rfc_invoices',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRfc:'RFC inválido. '}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'META RELACIONADA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.project_goal_id',id:'project_goal_id',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change',disabled:employees.edit.id?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Meta --'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(employees.data.project_goals,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:opt.id,key:k},opt.code+' - '+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.truncate(opt.name,{'length':60}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.project_goal_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'La meta es obligatoria'}})))),match.params.modality==='modalidad-iii'?employees.edit.project_goal_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'CDM RELACIONADO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.agency_id',id:'agency_id',errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change',disabled:employees.edit.id?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- CDM --'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(employees.data.agencies,function(opt,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:opt.id,key:k},opt.agenciable.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.agency_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'La meta es obligatoria'}})))):'':'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'AGREGAR CFDI'),employees.edit.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets_big_file_upload__["a" /* default */],{model:'.pdf',name:'PDF',file:employees.edit.pdf,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},message:{required:'Falta anexar PDF'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets_big_file_upload__["a" /* default */],{model:'.xml',name:'XML',file:employees.edit.xml,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},message:{required:'Falta anexar XML'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets_big_file_upload__["a" /* default */],{model:'.sat',name:'Validaci\xF3n SAT',file:employees.edit.sat,size:'small',validators:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},message:{required:'Falta anexar Validación'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-exclamation-triangle'}),'\xA0 Para poder agregar facturas, es necesario que primero se registren los datos de la persona contratada, revisa cuidadosamente que sean correctos. Recuerda que el RFC  debe corresponder con el de la factura  que se adjunta.')),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(employees.edit.invoices)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Facturas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'PDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'XML'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'SAT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Accion'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(employees.edit.invoices,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.date+' - '+Object(__WEBPACK_IMPORTED_MODULE_7_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.pdf,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.xml,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.sat,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button is-danger',onClick:function onClick(){return _this4._getConfirm(k);},disabled:employees.data.editable?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))))));})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-danger',onClick:this.props.closeModal},'Cerrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.expenses.edit',className:'button is-success',disabled:employees.data.editable?false:true},'Guardar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var edit=newprops.reports.employees.edit;if(edit!==this.props.reports.employees.edit){if(edit.action){if(edit.action==='close'){this.props.closeModal();this.props.change('reports.employees.edit.action',undefined);}else if(edit.action==='delete'&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(edit.invoices)){this.props.closeModal();this.props.change('reports.employees.edit.action',undefined);}}}}},{key:'_getConfirm',value:function _getConfirm(index){var _this5=this;Object(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la factura?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this5._removeInvoice(index);}});}},{key:'_removeInvoice',value:function _removeInvoice(index){var employees=this.props.reports.employees;var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(employees.edit.invoices[index])){this.props.remove('reports.employee.edit.invoices',index);}else{this.props.reportsEmployeeInvoiceDelete(employees.edit,employees.edit.invoices[index].id,modality,state,municipality);}}},{key:'_submitForm',value:function _submitForm(values){var _props3=this.props,match=_props3.match,reports=_props3.reports;var _match$params=match.params,modality=_match$params.modality,state=_match$params.state,municipality=_match$params.municipality;var employees=reports.employees;if(employees.edit.id){this.props.reportsEmployeeInvoicesSave(values,modality,state,municipality);}else{this.props.reportsEmployeeAdd(values,modality,state,municipality);}}}]);return ModalPeopleAdd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalMessageExpenses=function(_Component3){_inherits(ModalMessageExpenses,_Component3);function ModalMessageExpenses(){_classCallCheck(this,ModalMessageExpenses);return _possibleConstructorReturn(this,(ModalMessageExpenses.__proto__||Object.getPrototypeOf(ModalMessageExpenses)).apply(this,arguments));}_createClass(ModalMessageExpenses,[{key:'render',value:function render(){var data=this.props.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'+(this.props.active?' is-active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background',onClick:this.props.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content',style:{height:!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data)&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data.invoices)||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data)?'auto':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Facturas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete','aria-label':'delete',onClick:this.props.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'CURP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.curp))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Periodo de contrataci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.period_start&&data.period_end?data.period_start+' - '+data.period_end:data.period_start?data.period_start:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sueldo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_7_accounting_js__["formatMoney"])(data.wage?data.wage:0))))),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(data.invoices)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Facturas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'PDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'XML'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'SAT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.invoices,function(item,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.date+' - '+Object(__WEBPACK_IMPORTED_MODULE_7_accounting_js__["formatMoney"])(item.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.pdf,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.xml,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.sat,className:'button is-info',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))))));})))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'modal-close is-large','aria-label':'close',onClick:this.props.closeModal}));}}]);return ModalMessageExpenses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_reports__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_reports_surveys__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsSurveys=function(_Component){_inherits(ReportsSurveys,_Component);function ReportsSurveys(){_classCallCheck(this,ReportsSurveys);return _possibleConstructorReturn(this,(ReportsSurveys.__proto__||Object.getPrototypeOf(ReportsSurveys)).apply(this,arguments));}_createClass(ReportsSurveys,[{key:'render',value:function render(){var reports=this.props.reports;var expenses=reports.expenses,surveys=reports.surveys;return surveys.isFetching||expenses.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_reports_surveys__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;//this.props.reportsExpenses(modality, state, municipality);
this.props.reportsSurvey(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.match.params!==this.props.match.params){//this.props.reportsExpenses(modality, state, municipality);
this.props.reportsSurvey(modality,state,municipality);}}}]);return ReportsSurveys;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_reports__["a" /* default */])(ReportsSurveys,{subnav:4}));

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_rating__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Surveys=function(_Component){_inherits(Surveys,_Component);function Surveys(){_classCallCheck(this,Surveys);return _possibleConstructorReturn(this,(Surveys.__proto__||Object.getPrototypeOf(Surveys)).apply(this,arguments));}_createClass(Surveys,[{key:'render',value:function render(){var _this2=this;var reports=this.props.reports;var surveys=reports.surveys;var sc=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(reports.permissions,function(o){return o==='Create';})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Form"],{model:'reports.surveys.data',onSubmit:function onSubmit(values){return _this2._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-1'},surveys.data.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(surveys.data.children_questions,function(item,key){if(item.type==='group'){if(item.name!=="-"){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'group-'+key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2,className:'has-text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,key+1+'. '+item.name))),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(item.children_questions,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowQuestion,Object.assign({key:k,model:'reports.surveys.data.children_questions['+key+'].children_questions['+k+'].answer'+(row.type==='rating'?'.answer_number':'.answer_text'),groupIndex:key,questionIndex:k,row:row},_this2.props));})];}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowQuestion,Object.assign({key:key,number:key+1,model:'reports.surveys.data.children_questions['+key+'].answer'+(item.type==='rating'?'.answer_number':'.answer_text'),groupIndex:key,questionIndex:undefined,row:item},_this2.props));}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-large',onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),sc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].button,{model:'reports.surveys.data',className:'button is-large is-primary',disabled:surveys.data.editable?false:true},'Guardar')):''))));}},{key:'_submitForm',value:function _submitForm(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.reportsSurveySave(values,modality,state,municipality);}}]);return Surveys;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Surveys);var RowQuestion=function(_Component2){_inherits(RowQuestion,_Component2);function RowQuestion(){_classCallCheck(this,RowQuestion);return _possibleConstructorReturn(this,(RowQuestion.__proto__||Object.getPrototypeOf(RowQuestion)).apply(this,arguments));}_createClass(RowQuestion,[{key:'render',value:function render(){var _props=this.props,row=_props.row,model=_props.model,groupIndex=_props.groupIndex,questionIndex=_props.questionIndex,reports=_props.reports;var surveys=reports.surveys;var answer=undefined;var initialValue=undefined;if(questionIndex!==undefined){answer=surveys.data.children_questions[groupIndex].children_questions[questionIndex].answer;initialValue=answer?answer.answer_number:0;}else{answer=surveys.data.children_questions[groupIndex].answer;initialValue=answer?answer.answer_number:0;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:70+'%'},className:'has-text-left'},this.props.number?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.number+'. '+row.name):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.type==='rating'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"],{model:model,id:'question-'+row.id,ref:'question-'+row.id,component:__WEBPACK_IMPORTED_MODULE_2_react_rating__["a" /* default */],start:0,stop:5,step:1,initialRating:initialValue,emptySymbol:'fa fa-square-o fa-2x',fullSymbol:'fa fa-check-square-o fa-2x',className:'has-text-inm-purple'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux_form__["Control"].textarea,{model:model,className:'textarea',id:'question-'+row.id,ref:'question-'+row.id})));}}]);return RowQuestion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_reports__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_reports_summary__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportsSummary=function(_Component){_inherits(ReportsSummary,_Component);function ReportsSummary(){_classCallCheck(this,ReportsSummary);return _possibleConstructorReturn(this,(ReportsSummary.__proto__||Object.getPrototypeOf(ReportsSummary)).apply(this,arguments));}_createClass(ReportsSummary,[{key:'render',value:function render(){var _props=this.props,reports=_props.reports,modalities=_props.modalities;var summary=reports.summary;return summary.isFetching||modalities.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],{message:'Cargando Resumen...'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_reports_summary__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.fetchModalities();this.props.reportsSummary(modality,state,municipality);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newprops){var _newprops$match$param=newprops.match.params,modality=_newprops$match$param.modality,state=_newprops$match$param.state,municipality=_newprops$match$param.municipality;if(newprops.match.params!==this.props.match.params){this.props.reportsSummary(modality,state,municipality);}}}]);return ReportsSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_reports__["a" /* default */])(ReportsSummary,{subnav:5}));

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_big_file_upload__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__field_validations__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Summary=function(_Component){_inherits(Summary,_Component);function Summary(){_classCallCheck(this,Summary);return _possibleConstructorReturn(this,(Summary.__proto__||Object.getPrototypeOf(Summary)).apply(this,arguments));}_createClass(Summary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,match=_props.match,modalities=_props.modalities,reports=_props.reports;var summary=reports.summary;var mod=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(modalities.list,{slug:match.params.modality});var sc=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(reports.permissions,function(o){return o==='Create';})?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title is-3'},'PROEQUIDAD'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'subtitle is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,mod?mod.name+' - '+(reports.phase_group?reports.phase_group.name:''):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{style:{backgroundColor:'#000'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-6'},'DATOS GENERALES'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Titular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(summary.data)?summary.data.agency.owner.name+' '+summary.data.agency.owner.last_name+' '+summary.data.agency.owner.slast_name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Entidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.agenciable?summary.data.agency.agenciable.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(summary.data)&&summary.data.agency.name?summary.data.agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd fa-2x'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Monto aprobado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',summary.data.amounts&&summary.data.amounts.total?''+Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data.amounts.total):'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-calendar fa-2x'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help is-dark'},'Periodo de ejecuci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(summary.data.execution_start).format('MMMM YYYY')),' a ',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(summary.data.execution_end).format('MMMM YYYY'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'subtitle is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'AVANCE F\xCDSICO FINANCIERO')),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(summary.data.proigualdad_axis,function(axis,k){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'title-'+k,className:'box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Eje Tem\xE1tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'subtitle is-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,axis.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-fullwidth project-goal-table no-margin',key:'table-'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Clave'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Meta'),match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Instancia'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto aprobado'),match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto ejercido desglosado'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto ejercido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto por ejercer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(axis.project_goals,function(row,k){var cdmsQuantity=match.params.modality==='modalidad-iii'?row.project_goal_agencies.length:undefined;if(match.params.modality!=='modalidad-iii'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',style:{width:5+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:40+'%'}},row.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.project_version_phase_goal&&row.project_version_phase_goal.status_id!==0&&row.project_version_phase_goal.status_id!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-'+row.project_version_phase_goal.status.style},row.project_version_phase_goal.status.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin estatus')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right',style:{width:15+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right',style:{width:15+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.spent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right',style:{width:15+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.missing)));}else{return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(row.project_goal_agencies,function(item,o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:o},o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',rowSpan:cdmsQuantity,style:{width:5+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.code)):null,o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:cdmsQuantity,style:{width:25+'%'}},row.name):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.agenciable&&item.agenciable.name?item.agenciable.name:'---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.project_version_phase_goal&&item.project_version_phase_goal.status_id!==1&&item.project_version_phase_goal.status_id!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'has-text-'+item.project_version_phase_goal.status.style},item.project_version_phase_goal.status.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin estatus')),o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:cdmsQuantity,className:'has-text-right',style:{width:10+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.total)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right',style:{width:10+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(item.amounts.spent)),o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:cdmsQuantity,className:'has-text-right',style:{width:10+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.spent)):null,o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:cdmsQuantity,className:'has-text-right',style:{width:10+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amounts.missing)):null);});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell',colSpan:match.params.modality==='modalidad-iii'?4:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(axis.amounts.total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell',colSpan:match.params.modality==='modalidad-iii'?2:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(axis.amounts.spent))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(axis.amounts.missing))))))];}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'subtitle is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'GASTOS DE COORDINACI\xD3N Y SEGUIMIENTO DEL PROYECTO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Concepto de gasto '),match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Instancia'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto aprobado'),match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto ejercido desglosado'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto ejercido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto por ejercer'))),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(summary.data)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(summary.data.project_expenses,function(ex,k){var cdmsQuantity=match.params.modality==='modalidad-iii'?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(ex.project_expense_agencies):undefined;if(match.params.modality!=='modalidad-iii'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,ex.expense_concept.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.spent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.missing)));}else{if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(ex.project_expense_agencies)){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(ex.project_expense_agencies,function(item,o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:o},o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell',rowSpan:cdmsQuantity},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)):null,o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:cdmsQuantity},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,ex.expense_concept.name)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.agenciable.name)),o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:cdmsQuantity,className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.total)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(item.amounts.spent)),o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:cdmsQuantity,className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.spent)):null,o===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:cdmsQuantity,className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.missing)):null);});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,ex.expense_concept.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.spent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(ex.amounts.missing)));}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell',colSpan:match.params.modality==='modalidad-iii'?3:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data?summary.data.amounts.expenses.total:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell',colSpan:match.params.modality==='modalidad-iii'?2:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data?summary.data.amounts.expenses.spent:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data?summary.data.amounts.expenses.missing:0))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Ning\xFAn gasto de coordinaci\xF3n encontrado')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'subtitle is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'RESUMEN DE AVANCE F\xCDSICO FINANCIERO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'is-fullwidth table project-goal-table no-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Eje tem\xE1tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Metas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto aprobado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto ejercido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Monto por ejercer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(summary.data.proigualdad_axis,function(axis,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:50+'%'}},axis.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,axis.project_goals.length),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right',style:{width:15+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(axis.amounts.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right',style:{width:15+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(axis.amounts.spent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right',style:{width:15+'%'}},Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(axis.amounts.missing)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell',colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Subtotal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.goals.total:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.goals.spent:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.goals.missing:0)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Gastos de Coordinaci\xF3n')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Subtotal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.expenses.total:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.expenses.spent:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.expenses.missing:0)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell',colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Total del proyecto')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.total:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.spent:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right goal-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(summary.data&&summary.data.amounts?summary.data.amounts.missing:0)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'reports.summary.edit',onSubmit:function onSubmit(values){return _this2._submitForm(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message is-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'finished',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:'.finished',id:'finished',value:summary.edit.finished?true:false,className:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'normal'}},'\u201CCertifico que cuento con los Comprobantes Fiscales Digitales por Internet (CFDI) correspondientes al ejercicio del gasto y que la informaci\xF3n que he proporcionado a trav\xE9s de este instrumento es correcta y se encuentra completa; que conozco las disposiciones establecidas por el que se emiten las Bases de Participaci\xF3n del Proequidad, para el ejercicio fiscal '+(reports.version?reports.version.year:'----')+', respecto a la Auditor\xEDa, Control y Seguimiento del mismo, proyectos y recursos. Que he le\xEDdo apartado \u201C16. Obligaciones de las IMEF para la ejecuci\xF3n de los proyectos beneficiados\u201D')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Titular de la instancia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-5'},!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(summary.data)?summary.data.agency.owner.name+' '+summary.data.agency.owner.last_name+' '+summary.data.agency.owner.slast_name:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'button is-info',onClick:function onClick(){return _this2._getExport();},disabled:summary.edit.finished?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-link'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Generar documento para impresi\xF3n')))))))),summary.data?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(summary.data.documents_items,function(item,d){var summaryRevision=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(reports.summary.revision.body)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(reports.summary.revision.body[item.id])?reports.summary.revision.body[item.id]:undefined;var summaryRevisionAllowEdit=summaryRevision&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(summaryRevision.allow_edit)?summaryRevision.allow_edit==='true'?true:false:undefined;var validEditSummary=sc?summaryRevision&&summaryRevisionAllowEdit!==undefined?summaryRevisionAllowEdit:summaryRevision&&summaryRevisionAllowEdit===undefined?false:sc:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box',key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title is-5'},item.name),summary.edit.finished?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-right'},item.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),item.file_format?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',className:'button is-info',href:item.file_format,disabled:summary.edit.finished?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-link'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Descargar formato')))):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_big_file_upload__["a" /* default */],{model:'.'+item.slug,name:'Guardar '+item.name,file:summary.edit[item.slug],status:'primary',validators:{required:__WEBPACK_IMPORTED_MODULE_6__field_validations__["m" /* required */]},disabled:validEditSummary?false:true,message:{required:'Falta anexar documento'}}))):'',summary.edit.finished&&summaryRevision&&summaryRevision.comment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification '+(summaryRevision.status?'is-'+summaryRevision.status:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0',summaryRevision.comment):'');}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-large',onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),sc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'reports.summary.edit',className:'button is-large is-primary',disabled:summary.data.editable?false:true},'Guardar')):''))));}},{key:'_submitForm',value:function _submitForm(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.reportsSummarySave(values,modality,state,municipality);}},{key:'_getExport',value:function _getExport(){var _props$match$params2=this.props.match.params,modality=_props$match$params2.modality,state=_props$match$params2.state,municipality=_props$match$params2.municipality;this.props.reportsSummaryExport(modality,state,municipality);}}]);return Summary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Summary);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_widgets_inmPagination__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_surveys_widget_surveys_add__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Surveys=function(_Component){_inherits(Surveys,_Component);function Surveys(){_classCallCheck(this,Surveys);return _possibleConstructorReturn(this,(Surveys.__proto__||Object.getPrototypeOf(Surveys)).apply(this,arguments));}_createClass(Surveys,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SurveysList,this.props);}},{key:'componentWillMount',value:function componentWillMount(){var surveys=this.props.surveys;this.props.surveysShow(surveys.pages.current);}}]);return Surveys;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SurveysList=function(_Component2){_inherits(SurveysList,_Component2);_createClass(SurveysList,[{key:'render',value:function render(){var _this3=this;var surveys=this.props.surveys;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,surveys.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'inm-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Encuesta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estatus'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(surveys.list,function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:10+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/encuestas/editar/'+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._getConfirm(row.id,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}))),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,row.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:row.status&&row.status.style?'has-text-'+row.status.style:''},row.status&&row.status.name?row.status.name:'---')));}))),surveys.pages.total>20&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_widgets_inmPagination__["a" /* default */],{key:'concepts-pages',current:surveys.pages.current,total:surveys.pages.total,nextPage:this._handlePageChange}));}}]);function SurveysList(){_classCallCheck(this,SurveysList);var _this2=_possibleConstructorReturn(this,(SurveysList.__proto__||Object.getPrototypeOf(SurveysList)).call(this));_this2._handlePageChange=_this2._handlePageChange.bind(_this2);return _this2;}_createClass(SurveysList,[{key:'_handlePageChange',value:function _handlePageChange(value){this.props.surveysShow(value);}},{key:'_getConfirm',value:function _getConfirm(id,name){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_7_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:'\xBFEst\xE1s seguro/(a) de eliminar la version "'+name+'"?',confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return _this4.props.surveyDelete(id);}});}}]);return SurveysList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(Surveys, {title: `Administrar Encuestas`, subnav: {icon: 'fa-clipboard', name: 'Encuestas', actions: {url: '/encuestas/crear', name: 'Agregar encuesta'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__templates_base__["a" /* default */])(Surveys,{title:'Administrar Encuestas',subnav:{icon:'fa-clipboard',name:'Administracion',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_surveys_widget_surveys_add__["a" /* default */],null)}]}}));

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_surveys_form__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_surveys_widget_surveys_add__ = __webpack_require__(157);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SurveyCreate=function(_Component){_inherits(SurveyCreate,_Component);function SurveyCreate(){_classCallCheck(this,SurveyCreate);return _possibleConstructorReturn(this,(SurveyCreate.__proto__||Object.getPrototypeOf(SurveyCreate)).apply(this,arguments));}_createClass(SurveyCreate,[{key:'render',value:function render(){var _props=this.props,surveys=_props.surveys,status=_props.status;return surveys.isFetching||surveys.types.isFetching||status.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_surveys_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.surveysClear();this.props.surveysFetchTypes();this.props.fetchStatus(1);}}]);return SurveyCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(SurveyCreate, {title: `Crear Encuesta`, subnav: {icon: 'fa-clipboard', name: 'Encuestas', actions: {url: '/encuestas/crear', name: 'Agregar encuesta'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(SurveyCreate,{title:'Crear Encuesta',subnav:{icon:'fa-clipboard',name:'Administracion',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_surveys_widget_surveys_add__["a" /* default */],null)}]}}));

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_surveys_form__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_surveys_widget_surveys_add__ = __webpack_require__(157);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SurveyEdit=function(_Component){_inherits(SurveyEdit,_Component);function SurveyEdit(){_classCallCheck(this,SurveyEdit);return _possibleConstructorReturn(this,(SurveyEdit.__proto__||Object.getPrototypeOf(SurveyEdit)).apply(this,arguments));}_createClass(SurveyEdit,[{key:'render',value:function render(){var _props=this.props,surveys=_props.surveys,status=_props.status;return surveys.isFetching||surveys.types.isFetching||status.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_surveys_form__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){this.props.surveysFetchTypes();this.props.fetchStatus(1);this.props.fetchSurvey(this.props.match.params.id);}}]);return SurveyEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default BaseLayout(SurveyEdit, {title: `Editar Encuesta`, subnav: {icon: 'fa-clipboard', name: 'Encuestas', actions: {url: '/encuestas/crear', name: 'Agregar encuesta'}}});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(SurveyEdit,{title:'Editar Encuesta',subnav:{icon:'fa-clipboard',name:'Administracion',actions:[{type:'element',url:null,name:'Agregar',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_surveys_widget_surveys_add__["a" /* default */],null)}]}}));

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_tracing_agreements__ = __webpack_require__(755);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import _ from "lodash";
//import {history} from "../../store/store";
var TracingAgreements=function(_Component){_inherits(TracingAgreements,_Component);function TracingAgreements(){_classCallCheck(this,TracingAgreements);return _possibleConstructorReturn(this,(TracingAgreements.__proto__||Object.getPrototypeOf(TracingAgreements)).apply(this,arguments));}_createClass(TracingAgreements,[{key:"render",value:function render(){var agreements=this.props.agreements;return agreements.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_tracing_agreements__["a" /* default */],this.props);}},{key:"componentWillMount",value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.projectAgreements(modality,state,municipality);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextprops){if(nextprops.match.params!==this.props.match.params){var _nextprops$match$para=nextprops.match.params,modality=_nextprops$match$para.modality,state=_nextprops$match$para.state,municipality=_nextprops$match$para.municipality;this.props.projectAgreements(modality,state,municipality);}}}]);return TracingAgreements;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(TracingAgreements,{title:'Seguimiento de Convenios',subnav:{icon:'fa-exchange',name:'Seguimientos'},stateNav:true}));

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TracingAgreementsForm=function(_Component){_inherits(TracingAgreementsForm,_Component);function TracingAgreementsForm(){_classCallCheck(this,TracingAgreementsForm);return _possibleConstructorReturn(this,(TracingAgreementsForm.__proto__||Object.getPrototypeOf(TracingAgreementsForm)).apply(this,arguments));}_createClass(TracingAgreementsForm,[{key:"render",value:function render(){var _this2=this;var _props=this.props,match=_props.match,municipalities=_props.municipalities,agreements=_props.agreements;var agreementsRevAdmin=agreements.revisions?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agreements.revisions,{version_phase:{phase:{slug:'revision-project-agreements-agency-admin'}},project_version_phase:{version_phase:{phase:{slug:'project-agreements-agency'}}}}):undefined;var agreementsRevLegal=agreements.revisions?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agreements.revisions,{version_phase:{phase:{slug:'revision-project-agreements-agency-legal'}},project_version_phase:{version_phase:{phase:{slug:'project-agreements-agency'}}}}):undefined;var ef=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreementsRevAdmin)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agreementsRevAdmin.body,{field:'entity_fiscal'}):undefined;var bd=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreementsRevAdmin)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agreementsRevAdmin.body,{field:'bank_data'}):undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"agreements.data",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos del proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre de la instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data.agency)?agreements.data.agency.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre del proyecto"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data)?agreements.data.name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"version_id",className:"label"},"A\xF1o"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data.agency)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data.agency.version)?agreements.data.agency.version.year:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(agreements.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"Entidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data.agency)?agreements.data.agency.agenciable.name:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"+(agreements.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"Naturaleza jur\xEDdica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data.agency)?agreements.data.agency.legal_nature:'---')))),match.params.modality==='modalidad-i'?ef&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(ef.comment)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message is-"+ef.status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},"Comentarios"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,ef.comment))):'':'',match.params.modality==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".agency.fiscal_entity",className:"fieldset",component:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos de la tesorer\xEDa o dependencia hom\xF3loga de la entidad federetica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".name",id:"name",className:"input"+(ef&&ef.status?" is-"+ef.status:''),placeholder:"Nombre",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockFields(ef&&ef.allow_edit?ef.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El campo es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"rfc",className:"label"},"RFC",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".rfc",id:"rfc",className:"input"+(ef&&ef.status?" is-"+ef.status:''),errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],isRfcMoral:__WEBPACK_IMPORTED_MODULE_3__field_validations__["f" /* isRfcMoral */]},validateOn:"change",placeholder:"RFC",disabled:this._blockFields(ef&&ef.allow_edit?ef.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".rfc",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El RFC es obligatorio. ',isRfc:'RFC inválido. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"municipality_id",className:"label"},"Municipio ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"+(ef&&ef.status?" is-"+ef.status:'')+(municipalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".municipality_id",id:"municipality_id",className:"select",errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change",disabled:this._blockFields(ef&&ef.allow_edit?ef.allow_edit:undefined,agreements.editable)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- Municipio ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(municipalities.list,function(mun,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:mun.id,key:k},mun.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".municipality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El municipio es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"cp",className:"label"},"C\xF3digo postal ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".cp",type:"text",id:"cp",className:"input"+(ef&&ef.status?" is-"+ef.status:''),placeholder:"C\xF3digo postal",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockFields(ef&&ef.allow_edit?ef.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".cp",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El código postal es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"colony",className:"label"},"Colonia ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".colony",id:"colony",className:"input"+(ef&&ef.status?" is-"+ef.status:''),placeholder:"Colonia",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockFields(ef&&ef.allow_edit?ef.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".colony",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La colonia es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"street",className:"label"},"Direcci\xF3n ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".street",id:"street",className:"input"+(ef&&ef.status?" is-"+ef.status:''),placeholder:"Calle",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockFields(ef&&ef.allow_edit?ef.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".street",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La dirección es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"num_ext",className:"label"},"N\xFAmero exterior",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".num_ext",id:"num_ext",className:"input"+(ef&&ef.status?" is-"+ef.status:''),errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change",placeholder:"N\xFAmero exterior",disabled:this._blockFields(ef&&ef.allow_edit?ef.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".num_ext",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El número exterior es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"num_int",className:"label"},"N\xFAmero Interior "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".num_int",type:"text",id:"num_int",className:"input"+(ef&&ef.status?" is-"+ef.status:''),placeholder:"N\xFAmero interior",disabled:this._blockFields(ef&&ef.allow_edit?ef.allow_edit:undefined,agreements.editable)})))):'',match.params.modality==='modalidad-i'?bd&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(bd.comment)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message is-"+bd.status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-header"},"Comentarios"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,bd.comment))):'':'',match.params.modality==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".agency.fiscal_entity",className:"fieldset",component:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Datos bancarios"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_name",className:"label"},"Nombre de banco ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_name",id:"bank_name",className:"input"+(bd&&bd.status?" is-"+bd.status:''),placeholder:"Nombre de banco",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_name",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El campo es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_account",className:"label"},"N\xFAmero de cuenta ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_account",id:"bank_account",className:"input"+(bd&&bd.status?" is-"+bd.status:''),placeholder:"N\xFAmero de cuenta",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],maxLength:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["g" /* maxLength */])(12)},validateOn:"change",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_account",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El campo es obligatoria',maxLength:'La cuenta no debe ser mayor a 12 caracteres'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_office_num",className:"label"},"N\xFAmero de sucursal ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_office_num",id:"bank_office_num",className:"input"+(bd&&bd.status?" is-"+bd.status:''),placeholder:"N\xFAmero de sucursal",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],maxLength:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["g" /* maxLength */])(5)},validateOn:"change",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_office_num",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El campo es obligatoria',maxLength:'El numero no debe ser mayor a 5 caracteres'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_clabe",className:"label"},"Clave bancaria estandarizada(CLABE 18 digitos) ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_clabe",id:"bank_clabe",className:"input"+(bd&&bd.status?" is-"+bd.status:''),placeholder:"CLABE 18 digitos",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],maxLength:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["g" /* maxLength */])(18),number:__WEBPACK_IMPORTED_MODULE_3__field_validations__["k" /* number */]},validateOn:"change",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_clabe",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El campo es obligatoria',maxLength:'La CLABE debe ser de 18 digitos',number:'Solo son permitidos numeros'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_municipality_id",className:"label"},"Municipio ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"+(bd&&bd.status?" is-"+bd.status:'')+(municipalities.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:".bank_municipality_id",id:"bank_municipality_id",className:"select",errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:" ",defaultValue:true},"--- Municipio ---"),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(municipalities.list,function(mun,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:mun.id,key:k},mun.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_municipality_id",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El municipio es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_cp",className:"label"},"C\xF3digo postal ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_cp",type:"text",id:"bank_cp",className:"input"+(bd&&bd.status?" is-"+bd.status:''),placeholder:"C\xF3digo postal",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_cp",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'El código postal es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_colony",className:"label"},"Colonia ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_colony",id:"bank_colony",className:"input"+(bd&&bd.status?" is-"+bd.status:''),placeholder:"Colonia",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_colony",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La colonia es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_street",className:"label"},"Direcci\xF3n de la sucursal ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_street",id:"bank_street",className:"input"+(bd&&bd.status?" is-"+bd.status:''),placeholder:"Calle",errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:"change",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_street",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{isRequired:'La dirección es obligatoria'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_num_ext",className:"label"},"N\xFAmero exterior ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_num_ext",id:"bank_num_ext",className:"input"+(bd&&bd.status?" is-"+bd.status:''),errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:"change",placeholder:"N\xFAmero exterior",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:".bank_num_ext",show:"touched",wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},props.children);},messages:{required:'El número exterior es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"bank_num_int",className:"label"},"N\xFAmero Interior "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:".bank_num_int",type:"text",id:"bank_num_int",className:"input"+(bd&&bd.status?" is-"+bd.status:''),placeholder:"N\xFAmero interior",disabled:this._blockFields(bd&&bd.allow_edit?bd.allow_edit:undefined,agreements.editable)})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".documents",className:"fieldset",component:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Documentaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline is-grouped-left"},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(agreements.documents_items,function(o){return o.modality_id===null||o.modality_id===(agreements.data?agreements.data.modality_id:undefined);}),function(item,d){var documentRev=undefined;documentRev=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreementsRevAdmin)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agreementsRevAdmin.body,{field:item.slug}):undefined;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(documentRev)){documentRev=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreementsRevLegal)?__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(agreementsRevLegal.body,{field:item.slug}):undefined;}var accepts=undefined;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(item.documents_types,function(ext){accepts=accepts?accepts+","+ext.extensions:""+ext.extensions;});//console.log(`document: ${item.slug}===>`, agreements.data && agreements.data.documents && agreements.data.documents[item.slug]);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_big_file_upload__["a" /* default */],{key:d,model:"."+item.slug,name:item.name,file:agreements.data&&agreements.data.documents&&agreements.data.documents[item.slug],file_format:item.file_format,accept:accepts,comment:documentRev&&documentRev.comment?documentRev.comment:undefined,status:documentRev&&documentRev.status,disabled:_this2._blockFields(documentRev&&documentRev.allow_edit?documentRev.allow_edit:undefined,agreements.editable)});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message is-primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"finished",className:"checkbox",disabled:this._permissionSave()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].checkbox,{model:".finished",id:"finished",className:"checkbox",disabled:this._permissionSave()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{whiteSpace:'normal'}},"He concluido y certifico que la informaci\xF3n proporcionada es correcta y completa; conozco las disposiciones establecidas en las Reglas de Operaci\xF3n del FEPAM "+(agreements.version?agreements.version.year:'----')+" y su Acuerdo Modificatorio.")))))),match.params.modality==='modalidad-i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button is-info",type:"button",onClick:function onClick(){return _this2.props.projectAgreementsExport(match.params.modality,match.params.state,match.params.municipality);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Generar carta de confirmaci\xF3n de datos bancarios")))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.push('/inicio');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"agreements.data",className:"button is-large is-primary",disabled:this._permissionSave()},"Guardar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"has-text-grey has-text-right is-small"},"Los campos indicados con ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"small has-text-danger"},"*")," son obligatorios."))));}},{key:"componentWillMount",value:function componentWillMount(){var _props2=this.props,match=_props2.match,agreements=_props2.agreements;var modality=match.params.modality;if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data)&&!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(agreements.data.agency)){if(modality==='modalidad-i'||modality==='modalidad-iii'){this.props.fetchMunicipalities(agreements.data.agency.agenciable_id);}else{this.props.fetchMunicipalities(agreements.data.agency.agenciable.state_id);}}}},{key:"_handleSubmit",value:function _handleSubmit(values){var _props$match$params=this.props.match.params,state=_props$match$params.state,municipality=_props$match$params.municipality,modality=_props$match$params.modality;this.props.projectAgreementsSave(modality,state,municipality,values);//console.log('values: ',values);
}},{key:"_blockFields",value:function _blockFields(allow,editable){if(allow){if(allow==='true'&&editable){return false;}else{return true;}}else{return!editable;}}},{key:"_permissionSave",value:function _permissionSave(){var agreements=this.props.agreements;if(agreements.editable){return false;}else{return true;}}}]);return TracingAgreementsForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TracingAgreementsForm);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_tracing_dispersions__ = __webpack_require__(757);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TracingDispersions=function(_Component){_inherits(TracingDispersions,_Component);function TracingDispersions(){_classCallCheck(this,TracingDispersions);return _possibleConstructorReturn(this,(TracingDispersions.__proto__||Object.getPrototypeOf(TracingDispersions)).apply(this,arguments));}_createClass(TracingDispersions,[{key:"render",value:function render(){var dispersions=this.props.dispersions;return dispersions.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_tracing_dispersions__["a" /* default */],this.props);}},{key:"componentWillMount",value:function componentWillMount(){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;this.props.projectDispersions(modality,state,municipality);//this.props.fetchAgency(modality, state, municipality);
//this.props.fetchOwner(modality, state, municipality);
//this.props.projectRegistryData(modality, state, municipality);
//this.props.fetchRevisions(modality, state, municipality);
}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextprops){if(nextprops.match.params!==this.props.match.params){var _nextprops$match$para=nextprops.match.params,modality=_nextprops$match$para.modality,state=_nextprops$match$para.state,municipality=_nextprops$match$para.municipality;this.props.projectDispersions(modality,state,municipality);//this.props.fetchAgency(modality, state, municipality);
//this.props.fetchOwner(modality, state, municipality);
//this.props.projectRegistryData(modality, state, municipality);
//this.props.fetchRevisions(modality, state, municipality);
}}}]);return TracingDispersions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(TracingDispersions,{title:'Seguimiento Convenio Gubernatura',subnav:{icon:'fa-exchange',name:'Convenios'},stateNav:true}));

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_accounting_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TracingDispersions=function(_Component){_inherits(TracingDispersions,_Component);_createClass(TracingDispersions,[{key:"render",value:function render(){var _this2=this;var _props=this.props,dispersions=_props.dispersions,match=_props.match;var data=dispersions.data;var mod1=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(data.budgets,{modality_id:1});var mod2=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(data.budgets,{modality_id:2});var mod3=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(data.budgets,{modality_id:3});var de=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(dispersions.permissions,function(o){return o==='Create'||o==='Update';});var dd=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(dispersions.permissions,function(o){return o==='Delete';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:"dispersions.data",onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(error){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Seguimiento de la dispersi\xF3n del recurso"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"RESPONSABLE DEL SEGUIMIENTO, EVALUACI\xD3N Y CUMPLIMIENTO DE LA DISPERSI\xD3N DE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"RECURSOS OTORGADOS:\xA0"),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project.agency)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project.agency.owner)?data.project.agency.owner.name+" "+data.project.agency.owner.last_name+" "+data.project.agency.owner.slast_name:'---'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"version_id",className:"label"},"A\xF1o"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project.agency)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project.agency.version)?data.project.agency.version.year:'---')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"Entidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project.agency)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data.project.agency.agenciable)?data.project.agency.agenciable.name:'---')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"version_id",className:"label"},"Recurso asignado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data.budget)?dispersions.data.budget.total:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"Recurso transferido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data.budget)?dispersions.data.budget.transfered:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"Recurso por transferir"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data.budget)?dispersions.data.budget.pending:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"Reintegro TESOFE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data.budget)?dispersions.data.budget.tesofe:0))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"project_id",className:"label"},"Instancia / proyecto:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"project_id",model:".project_id",ref:"instance_id",value:dispersions.data.project_id?dispersions.data.project_id:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-- Seleccionar Instancia/proyecto --"),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(dispersions.data.list,['modality_id'],['asc']),function(row,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:row.project_id,key:k},row.modality_name+" - "+row.agency_name+" - "+row.agenciable_name);}))),dispersions.data.project_id?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},"El proyecto es obligatorio"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"dispersion_date",className:"label"},"Fecha de dispersion:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{id:"dispersion_date",model:".dispersion_date",component:__WEBPACK_IMPORTED_MODULE_2__forms_datepicker__["a" /* default */],className:"input"}),dispersions.data.dispersion_date?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},"La fecha es obligatoria")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"amount",className:"label"},"Cantidad: "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"amount",type:"text",className:"input",readOnly:true,value:this._showAmount()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"method",className:"label"},"M\xE9todo de dispersi\xF3n:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"method",model:".method",value:dispersions.data.method?dispersions.data.method:'',changeAction:function changeAction(model,value){return _this2._changeMethod(model,value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-- Seleccionar metodo --"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"cheque"},"Cheque"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"transferencia electr\xF3nica"},"Transferencia electr\xF3nica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"efectivo"},"Efectivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"reintegro tesofe"},"Reintegro TESOFE"))),dispersions.data.method?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"help has-text-danger"},"El metodo es obligatorio"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info is-medium",onClick:function onClick(){return _this2._addDispersion();},disabled:de?this._validAddDispersion():true},"Agregar")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset",{className:"fieldset"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Documentos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".documents",className:"field is-grouped is-multiline"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(dispersions.documents_items,function(o){return o.modality_id===null||o.modality_id===(dispersions.data?dispersions.data.modality_id:undefined);}),function(item,d){var accepts=undefined;__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(item.documents_types,function(ext){accepts=accepts?accepts+","+ext.extensions:""+ext.extensions;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control",key:d},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"file"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"file-label"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].file,{className:"file-input",model:"."+item.slug,id:"."+item.slug,accept:accepts,validateOn:"change"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-cta"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-upload"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"file-label"},item.name)))),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data.documents)&&dispersions.data.documents[item.slug]?!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isObject(dispersions.data.documents[item.slug])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:dispersions.data.documents[item.slug],className:"help is-success",target:"_blank"},"1 documento guardado ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-external-link","aria-hidden":"true"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"help is-info"},"Un nuevo archivo cargado"):'',item.file_format?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:item.file_format,className:"help is-info",target:"_blank"},"Descargar formato ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-external-link","aria-hidden":"true"})):'');}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this2.props.projectDispersionsExport(match.params.modality,match.params.state,match.params.municipality);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-link"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Generar Resumen"))))),!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(mod1)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title is-6"},"Listado de proyectos - Modalidad I"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"#"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Fecha de dispersi\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Acciones"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".data",component:"tbody"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(mod1,['dispersion_date']),function(row,k){var rowIndex=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(data.budgets,{project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(row.project_id)});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"row_1-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell",style:{width:'10%'},rowSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.agency_name+" - "+row.agenciable_name),_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{id:"dispersion_date_"+row.projectId,model:"["+rowIndex+"].dispersion_date",component:__WEBPACK_IMPORTED_MODULE_2__forms_datepicker__["a" /* default */],className:"input"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.dispersion_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'10%'},rowSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2._closeEdit();},className:"button is-warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-times"}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this2._editDispersion(row.project_id);},disabled:de?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"}))),dd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2._removeBudget(row.project_id);},className:"button is-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash"}))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"row_2-"+k},_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:/*row.method === 'reintegro tesofe' ? 2:*/3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"method_"+row.projectId,className:"label"},"M\xE9todo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"method_"+row.projectId,model:"["+rowIndex+"].method"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-- Seleccionar metodo --"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"cheque"},"Cheque"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"transferencia electr\xF3nica"},"Transferencia electr\xF3nica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"efectivo"},"Efectivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"reintegro tesofe"},"Reintegro TESOFE")))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:/*row.method === 'reintegro tesofe' ? 2:*/3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"M\xE9todo"),row.method))];}))))):'',!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(mod2)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title is-6"},"Listado de proyectos - Modalidad II"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"#"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Fecha de dispersi\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Acciones"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".data",component:"tbody"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(mod2,['dispersion_date']),function(row,k){var rowIndex=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(data.budgets,{project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(row.project_id)});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"row_1-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell",style:{width:'10%'},rowSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.agency_name+" - "+row.agenciable_name),_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{id:"dispersion_date_"+row.projectId,model:"["+rowIndex+"].dispersion_date",component:__WEBPACK_IMPORTED_MODULE_2__forms_datepicker__["a" /* default */],className:"input"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.dispersion_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'10%'},rowSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2._closeEdit();},className:"button is-warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-times"}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this2._editDispersion(row.project_id);},disabled:de?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"}))),dd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2._removeBudget(row.project_id);},className:"button is-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash"}))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"row_2-"+k},_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:/*row.method === 'reintegro tesofe' ? 2:*/3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"method_"+row.projectId,className:"label"},"M\xE9todo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"method_"+row.projectId,model:"["+rowIndex+"].method"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-- Seleccionar metodo --"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"cheque"},"Cheque"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"transferencia electr\xF3nica"},"Transferencia electr\xF3nica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"efectivo"},"Efectivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"reintegro tesofe"},"Reintegro TESOFE")))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:/*row.method === 'reintegro tesofe' ? 2:*/3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"M\xE9todo"),row.method))];}))))):'',!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(mod3)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"title is-6"},"Listado de proyectos - Modalidad III"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table is-fullwidth project-goal-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"#"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Instancia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Fecha de dispersi\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Acciones"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Fieldset"],{model:".data",component:"tbody"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(mod3,['dispersion_date']),function(row,k){var rowIndex=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(data.budgets,{project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(row.project_id)});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"row_1-"+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"goal-cell",style:{width:'10%'},rowSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,k+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.agency_name+" - "+row.agenciable_name),_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{id:"dispersion_date_"+row.projectId,model:"["+rowIndex+"].dispersion_date",component:__WEBPACK_IMPORTED_MODULE_2__forms_datepicker__["a" /* default */],className:"input"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.dispersion_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(row.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{width:'10%'},rowSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2._closeEdit();},className:"button is-warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-times"}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-info",onClick:function onClick(){return _this2._editDispersion(row.project_id);},disabled:de?false:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"}))),dd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:function onClick(){return _this2._removeBudget(row.project_id);},className:"button is-danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash"}))):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"row_2-"+k},_this2.state.editDispersion&&_this2.state.projectId===row.project_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:/*row.method === 'reintegro tesofe' ? 2:*/3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"method_"+row.projectId,className:"label"},"M\xE9todo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{id:"method_"+row.projectId,model:"["+rowIndex+"].method"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"-- Seleccionar metodo --"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"cheque"},"Cheque"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"transferencia electr\xF3nica"},"Transferencia electr\xF3nica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"efectivo"},"Efectivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"reintegro tesofe"},"Reintegro TESOFE")))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:/*row.method === 'reintegro tesofe' ? 2:*/3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"label"},"M\xE9todo"),row.method))];}))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"button is-large",onClick:function onClick(){return _this2.props.history.push('/inicio');}},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:"dispersions.data",className:"button is-large is-primary",disabled:de||dd?false:true},"Guardar"))))));}}]);function TracingDispersions(){_classCallCheck(this,TracingDispersions);var _this=_possibleConstructorReturn(this,(TracingDispersions.__proto__||Object.getPrototypeOf(TracingDispersions)).call(this));_this.state={projectId:undefined,editDispersion:false};return _this;}_createClass(TracingDispersions,[{key:"_handleSubmit",value:function _handleSubmit(values){var _props$match$params=this.props.match.params,modality=_props$match$params.modality,state=_props$match$params.state,municipality=_props$match$params.municipality;//console.log('values', values);
this.props.projectDispersionsSave(modality,state,municipality,values);}},{key:"_changeMethod",value:function _changeMethod(model,value){this.props.change(model,value);if(value!=='reintegro tesofe'){this.props.change('dispersions.data.tesofe_refound',undefined);}}},{key:"_validAddDispersion",value:function _validAddDispersion(){var dispersions=this.props.dispersions;var response=true;if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data.project_id)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data.dispersion_date)&&!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dispersions.data.method)){response=false;}return response;}},{key:"_addDispersion",value:function _addDispersion(){var dispersions=this.props.dispersions;var find=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(dispersions.data.list,{project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(dispersions.data.project_id)});var index=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(dispersions.data.list,{project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(dispersions.data.project_id)});this.props.add('dispersions.data.budgets',{modality_id:find.modality_id,modality_name:find.modality_name,project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(dispersions.data.project_id),agency_name:find.agency_name,agenciable_name:find.agenciable_name,amount:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(find.amount),dispersion_date:dispersions.data.dispersion_date,method:dispersions.data.method/*,
			tesofe_refound: budgets.tesofe_refound*/});this.props.remove('dispersions.data.list',index);this.props.change('dispersions.data.project_id',undefined);this.props.change('dispersions.data.dispersion_date',undefined);//this.props.change('project.budgets.amount', undefined);
/*if(budgets.method === 'reintegro tesofe'){
			this.props.change('project.budgets.tesofe_refound',undefined);
		}*/this.props.change('dispersions.data.method',undefined);}},{key:"_removeBudget",value:function _removeBudget(id){var dispersions=this.props.dispersions;var find=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(dispersions.data.budgets,{project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(id)});this.props.add('dispersions.data.list',{modality_id:find.modality_id,modality_name:find.modality_name,project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(find.project_id),agency_name:find.agency_name,agenciable_name:find.agenciable_name,amount:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(find.amount)});var index=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(dispersions.data.budgets,{project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(id)});this.props.remove('dispersions.data.budgets',index);}},{key:"_showAmount",value:function _showAmount(){var dispersions=this.props.dispersions;var find=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(dispersions.data.list,{project_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toNumber(dispersions.data.project_id)});if(find){return Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(find.amount);}else{return Object(__WEBPACK_IMPORTED_MODULE_3_accounting_js__["formatMoney"])(0);}}},{key:"_editDispersion",value:function _editDispersion(id){this.setState({projectId:id,editDispersion:true});}},{key:"_closeEdit",value:function _closeEdit(){this.setState({projectId:undefined,editDispersion:false});}/*_validDispersionTesofe(){
		let { dispersions } = this.props.project;
		let valid = false;
		let tesofe = _.filter(dispersions.data, {method: 'reintegro tesofe'})

		if(!_.isEmpty(tesofe)){
			_.map(tesofe, (row) => {
				_.mapKeys(row, (item, k) => {
					if(k ==='tesofe_refound' && _.isEmpty(item)){
						valid = true;
					}
				})
			})
		}

		return valid;

	}*/}]);return TracingDispersions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TracingDispersions);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_base__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_cdms_employees__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_loading__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EmployeesEdit=function(_Component){_inherits(EmployeesEdit,_Component);function EmployeesEdit(){_classCallCheck(this,EmployeesEdit);return _possibleConstructorReturn(this,(EmployeesEdit.__proto__||Object.getPrototypeOf(EmployeesEdit)).apply(this,arguments));}_createClass(EmployeesEdit,[{key:'render',value:function render(){var cdms=this.props.cdms;return cdms.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_loading__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_cdms_employees__["a" /* default */],this.props);}},{key:'componentWillMount',value:function componentWillMount(){var state=this.props.match.params.state;this.props.cdmEmployees(state);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextprops){var response={role_id:undefined,title:undefined,name:undefined,last_name:undefined,slast_name:undefined,sex:undefined,curp:undefined,rfc:undefined,rfc_invoices:undefined,scholarship:undefined,email:undefined,email_2:undefined,telephone:undefined,telephone_2:undefined,period_start:undefined,period_end:undefined};if(nextprops.match.params.state!==this.props.match.params.state){var state=nextprops.match.params.state;this.props.cdmEmployees(state);}if(nextprops.match.params.municipality!==this.props.match.params.municipality){this.props.loadFormData('cdms.edit',Object.assign({},response));}}}]);return EmployeesEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_base__["a" /* default */])(EmployeesEdit,{title:"Registro personal cdm",subcdmnav:{icon:'fa fa-user-times',name:'CDM'},stateNav:true}));

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_validations__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_loading__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_greeting_select__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import PropTypes from "prop-types";
var EmployeesEditForm=function(_Component){_inherits(EmployeesEditForm,_Component);function EmployeesEditForm(){_classCallCheck(this,EmployeesEditForm);return _possibleConstructorReturn(this,(EmployeesEditForm.__proto__||Object.getPrototypeOf(EmployeesEditForm)).apply(this,arguments));}_createClass(EmployeesEditForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,cdms=_props.cdms,session=_props.session,match=_props.match;var agency=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(session.user.cdms,{agenciable_slug:match.params.municipality});var employeesAgency=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(cdms.data.employees,{agency_id:agency.agency_id,status_id:1});var ec=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(cdms.permissions,function(o){return o==='Create';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Form"],{model:'cdms.edit',onSubmit:function onSubmit(values){return _this2._handleSubmit(values);},onSubmitFailed:function onSubmitFailed(){return _this2.props.setSystemNotification('¡Oh no!','Hay errores en el formulario','danger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'role_id',className:'label'},'Perfiles ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(cdms.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.role_id',ref:'roleSelect',id:'role_id',value:cdms.edit&&cdms.edit.role_id?cdms.edit.role_id:"",changeAction:function changeAction(m,v){return _this2._handleChangeRole(m,v);},errors:{required:__WEBPACK_IMPORTED_MODULE_3__field_validations__["m" /* required */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',defaultValue:true},'-- Perfiles --'),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(cdms.data.roles,function(option,key){var registred=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(cdms.data.employees,{role_id:option.id,agency_id:agency.agency_id,status_id:1});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.id,className:registred===undefined?'has-text-danger':''},''+option.display);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.role_id',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{required:'Debe seleccionar un perfil'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginBottom:'.5em'}},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-dark'},'Perfiles cargados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-inm-purple'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(employeesAgency)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginBottom:'.5em'}},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tags has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-dark'},'Perfiles pendientes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag is-medium is-danger'},__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(cdms.data.roles)-__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.size(employeesAgency))))),cdms.edit.isFetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_loading__["a" /* default */],{message:'Cargando perfil...'}):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'is-5 title',key:'cdms-title',style:{marginTop:'30px'}},'Datos generales'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero is-light',key:'cdms-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hero-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'title',className:'label'},'Saludo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(cdms.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"],{model:'.title',id:'title',component:__WEBPACK_IMPORTED_MODULE_7__forms_greeting_select__["a" /* default */],value:cdms.edit&&cdms.edit.title?cdms.edit.title:'',validateOn:'change',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.title',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Debes elegir un saludo'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre(s) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.name',className:'input',id:'name',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El nombre es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'last_name',className:'label'},'Primer apellido ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.last_name',className:'input',id:'last_name',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.last_name',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El apellido es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'slast_name',className:'label'},'Segundo apellido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.slast_name',className:'input',id:'slast_name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'scholarship',className:'label'},'Escolaridad ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.scholarship',id:'scholarship',className:'input',placeholder:'Escolaridad',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.scholarship',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El Nombramiento es obligatoria'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'wage',className:'label'},'Ingreso mensual'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control has-icons-left is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.wage',id:'wage',type:'number',step:'.01',min:'0',className:'input',placeholder:'0,000.00',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],minValue:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["j" /* minValue */])(0)},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small is-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-usd'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.wage',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'Se requiere una cantidad',minValue:'Cantidad minima no admitida.'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'period_start',className:'label'},'Fecha en que asumi\xF3 cargo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.period_start',id:'period_start',className:'input',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},component:__WEBPACK_IMPORTED_MODULE_4__forms_datepicker__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.period_start',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha en la que asumió el cargo es obligatoria. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'period_end',className:'label'},'Fin de gestion ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.period_end',id:'period_end',className:'input',component:__WEBPACK_IMPORTED_MODULE_4__forms_datepicker__["a" /* default */],errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.period_end',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La fecha fin de gestion es obligatoria. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'sex',className:'label'},'Sexo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'+(cdms.isFetching?' is-loading':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].select,{model:'.sex',id:'sex',value:cdms.edit&&cdms.edit.sex?cdms.edit.sex:'',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */]},validateOn:'change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Sexo ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'M'},'Mujer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'H'},'Hombre'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.sex',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El sexo es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rfc',className:'label'},'RFC ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.rfc',id:'rfc',className:'input',placeholder:'RFC',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],isRfc:__WEBPACK_IMPORTED_MODULE_3__field_validations__["e" /* isRfc */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_2__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.rfc',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El RFC es obligatorio. ',isRfc:'RFC inválido. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'curp',className:'label'},'CURP ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.curp',id:'curp',className:'input',placeholder:'CURP',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],maxLength:Object(__WEBPACK_IMPORTED_MODULE_3__field_validations__["g" /* maxLength */])(18),isCurp:__WEBPACK_IMPORTED_MODULE_3__field_validations__["b" /* isCurp */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_2__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.curp',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'La CURP es obligatoria. ',maxLength:'CURP inválida. '}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'rfc_invoices',className:'label'},'RFC facturas expedidas '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.rfc_invoices',id:'rfc_invoices',className:'input',placeholder:'XXXX000000XX0',errors:{isRfc:__WEBPACK_IMPORTED_MODULE_3__field_validations__["e" /* isRfc */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_2__parsers__["b" /* allUpper */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.rfc_invoices',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRfc:'RFC inválido. '}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}),'\xA0 Si las facturas son expedidas con otro RFC que no es el de la persona contratada, agregalo aqu\xED.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email',className:'label'},'Email principal',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.email',className:'input',placeholder:'Email principal *',errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],isEmail:__WEBPACK_IMPORTED_MODULE_3__field_validations__["c" /* isEmail */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_2__parsers__["a" /* allLower */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.email',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El email es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email_2',className:'label'},'Email secundario '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.email_2',id:'email_2',className:'input',placeholder:'Email secundario',errors:{email:__WEBPACK_IMPORTED_MODULE_3__field_validations__["a" /* email */]},validateOn:'change',parser:__WEBPACK_IMPORTED_MODULE_2__parsers__["a" /* allLower */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.email_2',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{email:__WEBPACK_IMPORTED_MODULE_3__field_validations__["a" /* email */]}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone',className:'label'},'Tel\xE9fono principal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.telephone',value:cdms.edit&&cdms.edit.telephone?cdms.edit.telephone:'',id:'telephone',className:'input',placeholder:'Tel\xE9fono principal',maxLength:10,errors:{isRequired:__WEBPACK_IMPORTED_MODULE_3__field_validations__["d" /* isRequired */],phoneNumber:__WEBPACK_IMPORTED_MODULE_3__field_validations__["l" /* phoneNumber */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.telephone',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{isRequired:'El Teléfono es obligatorio'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'telephone_2',className:'label'},'Tel\xE9fono alterno'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].text,{model:'.telephone_2',id:'telephone_2',className:'input',maxLength:10,placeholder:'Tel\xE9fono alterno',errors:{phoneNumber:__WEBPACK_IMPORTED_MODULE_3__field_validations__["l" /* phoneNumber */]},validateOn:'change'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Errors"],{model:'.telephone_2',show:'touched',wrapper:function wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'help has-text-danger'},props.children);},messages:{phoneNumber:__WEBPACK_IMPORTED_MODULE_3__field_validations__["l" /* phoneNumber */]}})))))],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right',style:{marginTop:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',model:'project',className:'button is-large',onClick:function onClick(){return _this2.props.history.goBack();}},'Regresar')),ec?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_form__["Control"].button,{model:'cdms.edit',className:'button is-large is-primary',disabled:false},'Guardar')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-grey has-text-right is-small'},'Los campos indicados con ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small has-text-danger'},'*'),' son obligatorios.'))));}},{key:'_handleSubmit',value:function _handleSubmit(values){var match=this.props.match;this.props.cdmEmployeesSave(match.params.state,values);}},{key:'_handleChangeRole',value:function _handleChangeRole(model,value){//let selector = this.refs['roleSelect'];
if(value){//this._loadEmployee(selector.value,selector[selector.selectedIndex].dataset.type,selector[selector.selectedIndex].dataset.agency);
this._loadEmployee(value);}}},{key:'_loadEmployee',value:function _loadEmployee(roleId){var _props2=this.props,cdms=_props2.cdms,match=_props2.match,session=_props2.session;var employee={};var agency=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(session.user.cdms,{agenciable_slug:match.params.municipality});employee=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(cdms.data.employees,{role_id:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toNumber(roleId),agency_id:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toNumber(agency.agency_id),status_id:1});var response={role_id:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toNumber(roleId),agency_id:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toNumber(agency?agency.agency_id:undefined)};if(employee){__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapKeys(employee,function(item,key){response=Object.assign({},response,_defineProperty({},key,item?item:undefined));});}else{response=Object.assign({},response,{title:undefined,name:undefined,last_name:undefined,slast_name:undefined,sex:undefined,curp:undefined,rfc:undefined,scholarship:undefined,rfc_invoices:undefined,email:undefined,email_2:undefined,telephone:undefined,telephone_2:undefined,period_start:undefined,period_end:undefined});}this.props.loadFormData('cdms.edit',Object.assign({},response));}}]);return EmployeesEditForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EmployeesEditForm);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_status__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__json_status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_current_tasks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_current_tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__json_current_tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_widgets_task_card__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_widgets_task_navigation__ = __webpack_require__(763);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import profiles from "./../json/profiles";
var CdmHome=function(_Component){_inherits(CdmHome,_Component);_createClass(CdmHome,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_widgets_task_navigation__["a" /* default */],{setFilters:this.setFilters,statusList:__WEBPACK_IMPORTED_MODULE_3__json_status___default.a.data,selected:this.state.filters.status})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"task-cards columns is-multiline"},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4__json_current_tasks___default.a.data,function(task,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_widgets_task_card__["a" /* default */],Object.assign({filter:_this2.state.filters.status,category:_this2.state.category,statusList:__WEBPACK_IMPORTED_MODULE_3__json_status___default.a.data,key:key},task));}))));}}]);function CdmHome(){_classCallCheck(this,CdmHome);var _this=_possibleConstructorReturn(this,(CdmHome.__proto__||Object.getPrototypeOf(CdmHome)).call(this));_this.setFilters=function(filter){return _this.setState({filters:Object.assign({},_this.state.filters,{status:filter===_this.state.filters.status?undefined:filter})});};_this.state={filters:{status:undefined,category:undefined}};_this.setFilters=_this.setFilters.bind(_this);return _this;}return CdmHome;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_cdm__["a" /* default */])(CdmHome,{title:'Dashboard',subnav:{icon:'fa-briefcase',name:'Mis Tareas',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = {"data":[{"id":1,"title":"Sin iniciar","slug":"sin-iniciar","style":"info"},{"id":2,"title":"Iniciado","slug":"iniciado","style":"success"},{"id":3,"title":"Atrasado","slug":"atrasado","style":"danger"},{"id":4,"title":"Cancelado","slug":"cancelado","style":"danger"},{"id":5,"title":"Concluido","slug":"concluido","style":"success"}]}

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_bar__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={date_finish:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,category:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,duration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,steps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var TaskCard=function(_Component){_inherits(TaskCard,_Component);function TaskCard(){_classCallCheck(this,TaskCard);return _possibleConstructorReturn(this,(TaskCard.__proto__||Object.getPrototypeOf(TaskCard)).apply(this,arguments));}_createClass(TaskCard,[{key:"render",value:function render(){var stat=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.props.statusList,{id:this.props.status});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"task-card "+(stat.slug===this.props.filter||this.props.filter===undefined?'show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"task-card--dates"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"date"},this.props.date_finish),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"progress-bar small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__progress_bar__["a" /* default */],{total:stat.slug==='sin-iniciar'?0:25}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* NavLink */],{to:"/cdm/tarea/"+this.props.id,className:"task-card--details "+this.props.category.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"header--category"},this.props.category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"header--duration"},this.props.duration," d\xEDas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content--info"},this.props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer--item"},this.props.steps," pasos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer--item has-text-"+stat.style},stat.title))));}}]);return TaskCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TaskCard.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TaskCard);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={statusList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,setFilters:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var TaskNavigation=function(_Component){_inherits(TaskNavigation,_Component);function TaskNavigation(){_classCallCheck(this,TaskNavigation);return _possibleConstructorReturn(this,(TaskNavigation.__proto__||Object.getPrototypeOf(TaskNavigation)).apply(this,arguments));}_createClass(TaskNavigation,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level tasks"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"title is-cdm-title"},"Tareas"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.props.statusList,function(status,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item",key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"task-button",onClick:function onClick(){return _this2.props.setFilters(status.slug);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-"+(_this2.props.selected===status.slug?'circle':'circle-o')})," ",status.title));})));}}]);return TaskNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TaskNavigation.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TaskNavigation);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_current_tasks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_current_tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__json_current_tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_widgets_progress_bar__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_task_detail__ = __webpack_require__(765);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CdmDetail=function(_Component){_inherits(CdmDetail,_Component);function CdmDetail(){_classCallCheck(this,CdmDetail);return _possibleConstructorReturn(this,(CdmDetail.__proto__||Object.getPrototypeOf(CdmDetail)).apply(this,arguments));}_createClass(CdmDetail,[{key:'render',value:function render(){var activity=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3__json_current_tasks___default.a.data,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(this.props.match.params.id)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-multiline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10 is-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* NavLink */],{to:'/cdm/inicio',className:'button is-cdm-blue is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-left',style:{marginRight:'10px'}}),' Volver a mis tareas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level cdm-header--dates'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'due-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fecha l\xEDmite'),activity.date_finish))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-item progress-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_widgets_progress_bar__["a" /* default */],{total:25,detect:100})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cdm-header '+activity.category.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cdm-header--details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'category'},activity.category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,activity.duration,' d\xEDas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cdm-header--title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,activity.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modified'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xDAltima modificaci\xF3n'),'2018-08-01'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_task_detail__["a" /* default */],{data:activity.tasks,category:activity.category.style,parent:activity.id})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activity-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Objetivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:activity.purpose}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activity-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Pol\xEDticas / Lineamientos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:activity.rules}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activity-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},'Datos a reportar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:activity.report_info}})))));}}]);return CdmDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(CdmDetail,{title:null,subnav:{icon:'fa-briefcase',name:'Mis Tareas',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaskDetail=function(_Component){_inherits(TaskDetail,_Component);_createClass(TaskDetail,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'task-steps'},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.props.data,function(task,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'step-'+key,className:'task-steps--details '+(task.finished?'complete':'')+' '+(task.locked?'locked':'')+' '+(_this2.state.step===task.step?'selected':''),onClick:function onClick(){return _this2.showTaskDetail(task.step);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step '+_this2.props.category},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,task.step)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,task.title)));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-5 is-offset-1'},!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.state.data)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'task-info'},!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.state.data.role)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'role'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.data.role.name,' ',this.state.data.role.slug==='promotora'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'has-text-success'},'(\xA1eres t\xFA!)'):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc content',dangerouslySetInnerHTML:{__html:this.state.data.description}}),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.state.data.output)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'output'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.state.data.output,function(out,o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'task-output-'+o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:_this2.props.parent+'/'+out.type+'/'+_this2.state.data.id,className:''+(out.finished?'complete':'')},out.name));}))),!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.state.data.files)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'files'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.state.data.files,function(file,f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'task-file-'+f},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:file.file,download:file.name},file.name));}))))));}}]);function TaskDetail(){_classCallCheck(this,TaskDetail);var _this=_possibleConstructorReturn(this,(TaskDetail.__proto__||Object.getPrototypeOf(TaskDetail)).call(this));_this.state={step:undefined,data:{}};return _this;}_createClass(TaskDetail,[{key:'showTaskDetail',value:function showTaskDetail(step){return this.setState({step:step,data:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.props.data,{step:step})});}}]);return TaskDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TaskDetail);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_widgets_progress_bar__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_current_tasks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_current_tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__json_current_tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_places__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_places___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__json_places__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_directory_directory_item__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_directory_place_form__ = __webpack_require__(262);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CdmPlacesDirectory=function(_Component){_inherits(CdmPlacesDirectory,_Component);_createClass(CdmPlacesDirectory,[{key:"render",value:function render(){var activity=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_5__json_current_tasks___default.a.data,{id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toInteger(this.props.match.params.id)});var step=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(activity.tasks,{id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toInteger(this.props.match.params.step)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/tarea/"+activity.id,className:"button is-cdm-blue is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-arrow-left",style:{marginRight:'10px'}})," Volver a la tarea"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level cdm-header--dates"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Fecha l\xEDmite"),step.date_finish))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item progress-detail"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_widgets_progress_bar__["a" /* default */],{total:100,detect:100})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header "+activity.category.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"category"},activity.category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,step.duration," d\xEDas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,step.step+". "+step.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modified"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\xDAltima modificaci\xF3n"),"2018-08-16"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_directory_place_form__["a" /* default */],{addEntry:this.addEntry,entities:this.props.entities,changeMuns:this.props.changeMuns,nextId:this.state.directory.detail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"finished",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"checkbox",id:"finished",value:"1",checked:step.finished?'checked':false,onChange:function onChange(){return true;}}),"He concluido esta tarea")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-directory"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.state.directory.list,function(dir,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_directory_directory_item__["a" /* default */],Object.assign({},dir,{key:d}));})))));}}]);function CdmPlacesDirectory(){_classCallCheck(this,CdmPlacesDirectory);var _this=_possibleConstructorReturn(this,(CdmPlacesDirectory.__proto__||Object.getPrototypeOf(CdmPlacesDirectory)).call(this));_this.addEntry=_this.addEntry.bind(_this);_this.state={directory:{list:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__json_places___default.a.data)),detail:3}};return _this;}_createClass(CdmPlacesDirectory,[{key:"addEntry",value:function addEntry(directory){var id=this.state.directory.detail+1;return this.setState({directory:Object.assign({},this.state.directory,{detail:id,list:[].concat(_toConsumableArray(this.state.directory.list),[directory])})});}}]);return CdmPlacesDirectory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(CdmPlacesDirectory,{title:'Directorio de instituciones',subnav:{icon:'fa-building',name:'Directorio',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,owner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,area:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,address2:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,zipcode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,city:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,state:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,phone:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var DirectoryItem=function DirectoryItem(_ref){var id=_ref.id,name=_ref.name,owner=_ref.owner,area=_ref.area,address=_ref.address,address2=_ref.address2,zipcode=_ref.zipcode,city=_ref.city,state=_ref.state,url=_ref.url,phone=_ref.phone,email=_ref.email;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-directory--detail",key:"dir-entry-"+id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"title is-5"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Titular"),owner),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\xC1rea de incidencia"),area),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Direcci\xF3n"),address," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),address2," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),zipcode," ",city,", ",state),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"P\xE1gina web"),url),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Tel\xE9fono"),phone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"E-mail"),email));};DirectoryItem.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (DirectoryItem);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_widgets_progress_bar__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_current_tasks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_current_tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__json_current_tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_places__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_places___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__json_places__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_directory_directory_service_item__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_directory_service_form__ = __webpack_require__(770);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CdmServicesDirectory=function(_Component){_inherits(CdmServicesDirectory,_Component);_createClass(CdmServicesDirectory,[{key:"render",value:function render(){var activity=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_5__json_current_tasks___default.a.data,{id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toInteger(this.props.match.params.id)});var step=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(activity.tasks,{id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toInteger(this.props.match.params.step)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/tarea/"+activity.id,className:"button is-cdm-blue is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-arrow-left",style:{marginRight:'10px'}})," Volver a la tarea"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level cdm-header--dates"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Fecha l\xEDmite"),step.date_finish))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item progress-detail"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_widgets_progress_bar__["a" /* default */],{total:100,detect:100})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header "+activity.category.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"category"},activity.category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,step.duration," d\xEDas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,step.step+". "+step.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modified"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\xDAltima modificaci\xF3n"),"2018-08-16"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_directory_service_form__["a" /* default */],{addEntry:this.addEntry,places:this.state.directory.list,nextId:this.state.directory.detail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-directory"},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.state.directory.list,function(dir){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(dir.services)?'':__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(dir.services,function(service,s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_directory_directory_service_item__["a" /* default */],Object.assign({},service,{place:dir,key:s}));});})))));}}]);function CdmServicesDirectory(){_classCallCheck(this,CdmServicesDirectory);var _this=_possibleConstructorReturn(this,(CdmServicesDirectory.__proto__||Object.getPrototypeOf(CdmServicesDirectory)).call(this));_this.addEntry=_this.addEntry.bind(_this);_this.state={directory:{list:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__json_places___default.a.data)),detail:3}};return _this;}_createClass(CdmServicesDirectory,[{key:"addEntry",value:function addEntry(place,service){var id=this.state.directory.detail+1;return this.setState({directory:Object.assign({},this.state.directory,{detail:id,list:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.state.directory.list,function(dir){if(dir.id===__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toInteger(place)){var newDir=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(dir.services);newDir.push(service);return Object.assign({},dir,{services:newDir});}else{return dir;}})})});}}]);return CdmServicesDirectory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(CdmServicesDirectory,{title:'Directorio de instituciones',subnav:{icon:'fa-building',name:'Directorio',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,end_date:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,start_date:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,offers:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,objective:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,description:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,level:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,place:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};var DirectoryServiceItem=function DirectoryServiceItem(_ref){var id=_ref.id,name=_ref.name,start_date=_ref.start_date,end_date=_ref.end_date,offers=_ref.offers,objective=_ref.objective,type=_ref.type,description=_ref.description,level=_ref.level,place=_ref.place;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cdm-directory--detail',key:'dir-entry-'+id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title is-5'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Instituci\xF3n'),place.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Tipo'),type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Vigencia'),start_date,' a ',end_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Poblaci\xF3n objetivo'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(objective,function(item,i){return[item.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'break-'+i})];})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content desc',dangerouslySetInnerHTML:{__html:description}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content offers',dangerouslySetInnerHTML:{__html:offers}}));};DirectoryServiceItem.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (DirectoryServiceItem);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_forms_wysiwyg_field__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceDirectoryForm=function(_Component){_inherits(ServiceDirectoryForm,_Component);_createClass(ServiceDirectoryForm,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'directory-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'placeForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'place',className:'label'},'Instituci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'place',id:'place'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,selected:true,disabled:true},'--- Instituci\xF3n ---'),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.props.places,function(place,p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:place.id,key:p},place.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'level',className:'label'},'Nivel de gobierno'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'level',ref:'level',id:'level'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,selected:true,disabled:true},'--- Nivel de gobierno ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Federal'},'Federal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Estatal'},'Estatal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Municipal'},'Municipal')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'type',className:'label'},'Tipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'type',id:'type'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,selected:true,disabled:true},'--- Tipo ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Programa'},'Programa'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Servicio'},'Servicio'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title is-6'},'Poblaci\xF3n Objetivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective1',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.setCheckbox(e);},id:'objective1',ref:'objective1',value:'Mujeres'}),'Mujeres')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective2',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.setCheckbox(e);},id:'objective2',ref:'objective2',value:'Madres solteras'}),'Madres solteras')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective3',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.setCheckbox(e);},id:'objective3',ref:'objective3',value:'Migrantes'}),'Migrantes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective4',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.setCheckbox(e);},id:'objective4',ref:'objective4',value:'Adultos mayores'}),'Adultos mayores')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective5',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.setCheckbox(e);},id:'objective5',ref:'objective5',value:'Mujeres con discapacidad'}),'Mujeres con discapacidad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'objective6',className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.setCheckbox(e);},id:'objective6',ref:'objective6',value:'Poblaci\xF3n Objetivo'}),'Mujeres'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'label'},'Nombre del programa / servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'name',ref:'name',className:'input',placeholder:'Nombre del programa o servicio'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'start_date',className:'label'},'Vigente desde'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_datepicker__["a" /* default */],{className:'input',name:'start_date',ref:'start_date',dateFormat:'YYYY-MM-DD',selected:this.state.dates.start_date,placeholderText:__WEBPACK_IMPORTED_MODULE_4_moment__().format('YYYY-MM-DD'),onChange:function onChange(value){return _this2.setInput('start_date',__WEBPACK_IMPORTED_MODULE_4_moment__(value).format('YYYY-MM-DD'));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'end_date',className:'label'},'Vigente Hasta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_datepicker__["a" /* default */],{className:'input',name:'end_date',ref:'end_date',dateFormat:'YYYY-MM-DD',selected:this.state.dates.end_date,placeholderText:__WEBPACK_IMPORTED_MODULE_4_moment__().format('YYYY-MM-DD'),onChange:function onChange(value){return _this2.setInput('end_date',__WEBPACK_IMPORTED_MODULE_4_moment__(value).format('YYYY-MM-DD'));}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'description',className:'label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_forms_wysiwyg_field__["a" /* default */],{ref:'description',id:'descirption',placeholder:'Descripci\xF3n del programa o servicio',value:this.state.description,onChange:function onChange(value){return _this2.setDescription(value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'offers',className:'label'},'Apoyos que ofrece'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_forms_wysiwyg_field__["a" /* default */],{id:'offers',ref:'offers',placeholder:'Apoyos que ofrece',value:this.state.offers,onChange:function onChange(value){return _this2.setOffers(value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field is-grouped is-grouped-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(e){return _this2.saveEntry(e);},className:'button is-cdm-blue',type:'button'},'Guardar')))));}}]);function ServiceDirectoryForm(){_classCallCheck(this,ServiceDirectoryForm);var _this=_possibleConstructorReturn(this,(ServiceDirectoryForm.__proto__||Object.getPrototypeOf(ServiceDirectoryForm)).call(this));_this.state={dates:{start_date:undefined,end_date:undefined},offers:'',description:'',objective:[]};_this.setInput=_this.setInput.bind(_this);_this.setOffers=_this.setOffers.bind(_this);_this.setDescription=_this.setDescription.bind(_this);_this.setCheckbox=_this.setCheckbox.bind(_this);return _this;}_createClass(ServiceDirectoryForm,[{key:'setCheckbox',value:function setCheckbox(el){var newArr=this.state.objective;if(el.target.checked){newArr.push({name:el.target.value});}else{newArr.filter(function(o){return o===el.target.value;});}return this.setState({objective:newArr});}},{key:'setOffers',value:function setOffers(value){return this.setState({offers:value});}},{key:'setDescription',value:function setDescription(value){return this.setState({description:value});}},{key:'setInput',value:function setInput(field,value){var newvalues={};if(field==='start_date'){newvalues={start_date:__WEBPACK_IMPORTED_MODULE_4_moment__(value),end_date:this.state.dates.end_date};}else{newvalues={start_date:this.state.dates.start_date,end_date:__WEBPACK_IMPORTED_MODULE_4_moment__(value)};}return this.setState({dates:newvalues});}},{key:'saveEntry',value:function saveEntry(e){e.preventDefault();this.props.addEntry(this.refs.place.value,{id:this.props.nextId,type:this.refs.type.value,name:this.refs.name.value,level:this.refs.level.value,start_date:__WEBPACK_IMPORTED_MODULE_4_moment__(this.state.dates.start_date).format('YYYY-MM-DD'),end_date:__WEBPACK_IMPORTED_MODULE_4_moment__(this.state.dates.end_date).format('YYYY-MM-DD'),description:this.state.description,offers:this.state.offers,objective:this.state.objective});__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.refs,function(el){switch(el.type){case'checkbox':return el.checked=false;case'select-one':return el.value=0;default:return el.value='';}});return this.setState({dates:{start_date:undefined,end_date:undefined},offers:'',description:'',objective:[]});}}]);return ServiceDirectoryForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ServiceDirectoryForm);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_current_tasks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_current_tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__json_current_tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_widgets_progress_bar__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_calendar_calendar_item__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__json_places__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__json_places___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__json_places__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__json_calendar__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__json_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__json_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_calendar_calendar_form__ = __webpack_require__(775);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CdmActivitiesCalendar=function(_Component){_inherits(CdmActivitiesCalendar,_Component);_createClass(CdmActivitiesCalendar,[{key:"render",value:function render(){var activity=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3__json_current_tasks___default.a.data,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(this.props.match.params.id)});var step=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(activity.tasks,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(this.props.match.params.step)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* NavLink */],{to:"/cdm/tarea/"+activity.id,className:"button is-cdm-blue is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-arrow-left",style:{marginRight:'10px'}})," Volver a la tarea"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level cdm-header--dates"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Fecha l\xEDmite"),step.date_finish))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item progress-detail"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_widgets_progress_bar__["a" /* default */],{total:100,detect:100})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header "+activity.category.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"category"},activity.category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,step.duration," d\xEDas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,step.step+". "+step.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modified"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\xDAltima modificaci\xF3n"),"2018-08-16"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_calendar_calendar_form__["a" /* default */],{places:__WEBPACK_IMPORTED_MODULE_7__json_places___default.a.data,nextId:this.state.calendar.detail,addEntry:this.addEntry})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"finished",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"checkbox",id:"finished",value:"1",checked:step.finished?'checked':false,onChange:function onChange(){return true;}}),"He concluido esta tarea")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-calendar-activities"},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.state.calendar.list,function(cal,c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_calendar_calendar_item__["a" /* default */],Object.assign({},cal,{place:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_7__json_places___default.a.data,{id:cal.place.id}),key:"calendar-item-"+c}));})))));}}]);function CdmActivitiesCalendar(){_classCallCheck(this,CdmActivitiesCalendar);var _this=_possibleConstructorReturn(this,(CdmActivitiesCalendar.__proto__||Object.getPrototypeOf(CdmActivitiesCalendar)).call(this));_this.state={calendar:{list:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__json_calendar___default.a.data)),detail:3}};_this.addEntry=_this.addEntry.bind(_this);return _this;}_createClass(CdmActivitiesCalendar,[{key:"addEntry",value:function addEntry(event){console.log('EVENT',event);return this.setState(Object.assign({},this.state,{calendar:Object.assign({},this.state.calendar,{list:[].concat(_toConsumableArray(this.state.calendar.list),[event])})}));}}]);return CdmActivitiesCalendar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(CdmActivitiesCalendar,{title:'Calendario de actividades',subnav:{icon:'fa-calendar',name:'Calendario',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_calendar_date__ = __webpack_require__(773);
var CalendarItem=function CalendarItem(_ref){var start_date=_ref.start_date,name=_ref.name,start_time=_ref.start_time,end_time=_ref.end_time,description=_ref.description,place=_ref.place;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("article",{className:"calendar-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"date-details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__widgets_calendar_date__["a" /* default */],{date:start_date})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"time"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Horario:")," ",start_time,"hrs a ",end_time,"hrs"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content description",dangerouslySetInnerHTML:{__html:description}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"place"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,place.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"address"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,place.address," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),place.address2," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),place.zipcode," ",place.city,", ",place.state," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),place.phone," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),place.email)))));};/* harmony default export */ __webpack_exports__["a"] = (CalendarItem);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CalendarDate=function CalendarDate(_ref){var date=_ref.date;var month='';switch(date.substr(5,2)){case"01":month="Ene";break;case"02":month="Feb";break;case"03":month="Mar";break;case"04":month="Abr";break;case"05":month="May";break;case"06":month="Jun";break;case"07":month="Jul";break;case"08":month="Ago";break;case"09":month="Sep";break;case"10":month="Oct";break;case"11":month="Nov";break;case"12":month="Dic";break;default:month="Ene";break;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"calendar-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"month"},month),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"day"},date.substr(8,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"year"},date.substr(0,4))));};/* harmony default export */ __webpack_exports__["a"] = (CalendarDate);

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = {"data":[{"id":1,"name":"Visita guiada","start_date":"2018-09-10","start_time":"10:00","end_time":"12:00","duration":1,"description":"<p>Visitar las instalaciones en una visita guiada por la títular de la institución.</p>","place":{"id":1},"status":{"id":1,"title":"Sin iniciar","slug":"sin-iniciar","style":"info"}},{"id":1,"name":"Visita planeada","start_date":"2018-09-10","start_time":"12:00","end_time":"13:00","duration":1,"description":"<p>Visitar las instalaciones en una visita calendarizada para solicitar informes.</p>","place":{"id":2},"status":{"id":1,"title":"Sin iniciar","slug":"sin-iniciar","style":"info"}}]}

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datepicker__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_forms_wysiwyg_field__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CalendarForm=function(_Component){_inherits(CalendarForm,_Component);_createClass(CalendarForm,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"calendar-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"calendarForm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",id:"name",ref:"name",className:"input",placeholder:"Nombre del evento"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"start_date",className:"label"},"Fecha"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datepicker__["a" /* default */],{onChange:this.changeDate,className:"input",selected:this.state.start_date,placeholderText:__WEBPACK_IMPORTED_MODULE_2_moment__().format('YYYY-MM-DD'),dateFormat:"YYYY-MM-DD"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"start_time",className:"label"},"Inicia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datepicker__["a" /* default */],{onChange:this.changeStartTime,className:"input",selected:this.state.start_time,placeholderText:__WEBPACK_IMPORTED_MODULE_2_moment__().format('hh:mm'),timeIntervals:15,dateFormat:"LT",timeCaption:"Hora",showTimeSelect:true,showTimeSelectOnly:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"end_time",className:"label"},"Termina"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datepicker__["a" /* default */],{onChange:this.changeEndTime,className:"input",selected:this.state.end_time,placeholderText:__WEBPACK_IMPORTED_MODULE_2_moment__().format('hh:mm'),timeIntervals:15,dateFormat:"LT",timeCaption:"Hora",showTimeSelect:true,showTimeSelectOnly:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"place",className:"label"},"Ubicaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{ref:"place",id:"place"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:0,defaultValue:0},"--- Ubicaci\xF3n ---"),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.props.places,function(place,p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:place.id,key:"place-option-"+p},place.name);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"description",className:"label"},"Descripci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_forms_wysiwyg_field__["a" /* default */],{id:"description",ref:"description",placeholder:"Descripci\xF3n de la actividad",value:this.state.description,onChange:function onChange(value){return _this2.setDescription(value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",onClick:this.addEntry,className:"button is-medium is-cdm-blue"},"Guardar"))));}}]);function CalendarForm(){_classCallCheck(this,CalendarForm);var _this=_possibleConstructorReturn(this,(CalendarForm.__proto__||Object.getPrototypeOf(CalendarForm)).call(this));_this.state={start_date:undefined,start_time:undefined,end_time:undefined,description:''};_this.changeDate=_this.changeDate.bind(_this);_this.changeStartTime=_this.changeStartTime.bind(_this);_this.changeEndTime=_this.changeEndTime.bind(_this);_this.setDescription=_this.setDescription.bind(_this);_this.addEntry=_this.addEntry.bind(_this);return _this;}_createClass(CalendarForm,[{key:"changeDate",value:function changeDate(date){return this.setState({start_date:__WEBPACK_IMPORTED_MODULE_2_moment__(date)});}},{key:"changeStartTime",value:function changeStartTime(time){return this.setState({start_time:__WEBPACK_IMPORTED_MODULE_2_moment__(time)});}},{key:"changeEndTime",value:function changeEndTime(time){return this.setState({end_time:__WEBPACK_IMPORTED_MODULE_2_moment__(time)});}},{key:"setDescription",value:function setDescription(desc){return this.setState({description:desc});}},{key:"addEntry",value:function addEntry(){this.props.addEntry({id:this.props.nextId,name:this.refs.name.value,place:{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toInteger(this.refs.place.value)},start_date:__WEBPACK_IMPORTED_MODULE_2_moment__(this.state.start_date).format('YYYY-MM-DD'),start_time:__WEBPACK_IMPORTED_MODULE_2_moment__(this.state.start_time).format('HH:MM'),end_time:__WEBPACK_IMPORTED_MODULE_2_moment__(this.state.end_time).format('HH:MM'),description:this.state.description});__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.refs,function(el){switch(el.type){case'checkbox':return el.checked=false;case'select-one':return el.value=0;default:return el.value='';}});return this.setState({start_date:undefined,start_time:undefined,end_time:undefined,description:''});}}]);return CalendarForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CalendarForm);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_widgets_progress_bar__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_current_tasks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_current_tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__json_current_tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_polygons__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_polygons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__json_polygons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_maps_area_maps__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_maps_zone_item__ = __webpack_require__(790);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CdmZonesDirectory=function(_Component){_inherits(CdmZonesDirectory,_Component);_createClass(CdmZonesDirectory,[{key:"render",value:function render(){var _this2=this;var activity=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_5__json_current_tasks___default.a.data,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.props.match.params.id)});var step=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(activity.tasks,{id:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toInteger(this.props.match.params.step)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* NavLink */],{to:"/cdm/tarea/"+activity.id,className:"button is-cdm-blue is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-arrow-left",style:{marginRight:'10px'}})," Volver a la tarea"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level cdm-header--dates"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Fecha l\xEDmite"),step.date_finish))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item progress-detail"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_widgets_progress_bar__["a" /* default */],{total:100,detect:100})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header "+activity.category.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"category"},activity.category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,step.duration," d\xEDas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,step.step+". "+step.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modified"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\xDAltima modificaci\xF3n"),"2018-08-16"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12 map-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_maps_area_maps__["a" /* default */],{coords:this.state.polygons.detail.coordinates,color:this.state.polygons.detail.color})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"finished",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"checkbox",id:"finished",value:"1",checked:step.finished?'checked':false,onChange:function onChange(){return true;}}),"He concluido esta tarea")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-map-zones"},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.state.polygons.list,function(poly,p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_maps_zone_item__["a" /* default */],Object.assign({},poly,{selected:poly.id===_this2.state.polygons.detail.id&&true,key:"zone-item-"+p,setCoords:_this2.setCoords}));})))));}}]);function CdmZonesDirectory(){_classCallCheck(this,CdmZonesDirectory);var _this=_possibleConstructorReturn(this,(CdmZonesDirectory.__proto__||Object.getPrototypeOf(CdmZonesDirectory)).call(this));_this.state={polygons:{list:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__json_polygons___default.a.data)),detail:{id:0,color:undefined,coordinates:undefined}}};_this.setCoords=_this.setCoords.bind(_this);return _this;}_createClass(CdmZonesDirectory,[{key:"setCoords",value:function setCoords(poly){return this.setState({polygons:Object.assign({},this.state.polygons,{detail:poly.props})});}}]);return CdmZonesDirectory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_cdm__["a" /* default */])(CdmZonesDirectory,{title:'Directorio de zonas identificadas',subnav:{icon:'fa-map',name:'Mapa',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = {"data":[{"id":1,"code":1,"name":"Zona 1","color":"#57597f","description":"<p>Lorem ipsum dolor sit amet consectetur adipiscing elit risus maecenas, bibendum hendrerit commodo condimentum aliquet sociosqu congue convallis aliquam, sodales praesent varius vel metus arcu id molestie.</p>","coordinates":[{"lat":19.45494,"lng":-99.15101},{"lat":19.45073,"lng":-99.1232},{"lat":19.49378,"lng":-99.1196}]},{"id":2,"code":2,"name":"Zona 2","color":"#aaa666","description":"<p>Lorem ipsum dolor sit amet consectetur adipiscing elit risus maecenas, bibendum hendrerit commodo condimentum aliquet sociosqu congue convallis aliquam, sodales praesent varius vel metus arcu id molestie.</p>","coordinates":[{"lat":19.45494,"lng":-99.16},{"lat":19.45073,"lng":-99.13},{"lat":19.49378,"lng":-99.1}]}]}

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps_react__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_google_maps_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,coords:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};var AreaMap=function(_Component){_inherits(AreaMap,_Component);function AreaMap(){_classCallCheck(this,AreaMap);return _possibleConstructorReturn(this,(AreaMap.__proto__||Object.getPrototypeOf(AreaMap)).apply(this,arguments));}_createClass(AreaMap,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_google_maps_react__["Map"],{google:this.props.google,className:"map-square",initialCenter:{lat:19.46,lng:-99.15},zoom:13},this.props.coords&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_google_maps_react__["Polygon"],{paths:this.props.coords,strokeColor:this.props.color,strokeOpacity:1,strokeWeight:2,fillColor:this.props.color,fillOpacity:0.35}));}}]);return AreaMap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AreaMap.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_google_maps_react__["GoogleApiWrapper"])({apiKey:'AIzaSyBnmueHJLnp1vFFDs_GopXL_VdHPecHFXQ'})(AreaMap));

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(780), __webpack_require__(784), __webpack_require__(785), __webpack_require__(786), __webpack_require__(787), __webpack_require__(789), __webpack_require__(0), __webpack_require__(6), __webpack_require__(32), __webpack_require__(70), __webpack_require__(788)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./GoogleApiComponent'), require('./components/Marker'), require('./components/InfoWindow'), require('./components/HeatMap'), require('./components/Polygon'), require('./components/Polyline'), require('react'), require('prop-types'), require('react-dom'), require('./lib/String'), require('./lib/cancelablePromise'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.GoogleApiComponent, global.Marker, global.InfoWindow, global.HeatMap, global.Polygon, global.Polyline, global.react, global.propTypes, global.reactDom, global.String, global.cancelablePromise);
    global.index = mod.exports;
  }
})(this, function (exports, _GoogleApiComponent, _Marker, _InfoWindow, _HeatMap, _Polygon, _Polyline, _react, _propTypes, _reactDom, _String, _cancelablePromise) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Map = exports.Polyline = exports.Polygon = exports.HeatMap = exports.InfoWindow = exports.Marker = exports.GoogleApiWrapper = undefined;
  Object.defineProperty(exports, 'GoogleApiWrapper', {
    enumerable: true,
    get: function () {
      return _GoogleApiComponent.wrapper;
    }
  });
  Object.defineProperty(exports, 'Marker', {
    enumerable: true,
    get: function () {
      return _Marker.Marker;
    }
  });
  Object.defineProperty(exports, 'InfoWindow', {
    enumerable: true,
    get: function () {
      return _InfoWindow.InfoWindow;
    }
  });
  Object.defineProperty(exports, 'HeatMap', {
    enumerable: true,
    get: function () {
      return _HeatMap.HeatMap;
    }
  });
  Object.defineProperty(exports, 'Polygon', {
    enumerable: true,
    get: function () {
      return _Polygon.Polygon;
    }
  });
  Object.defineProperty(exports, 'Polyline', {
    enumerable: true,
    get: function () {
      return _Polyline.Polyline;
    }
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var mapStyles = {
    container: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    },
    map: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0
    }
  };

  var evtNames = ['ready', 'click', 'dragend', 'recenter', 'bounds_changed', 'center_changed', 'dblclick', 'dragstart', 'heading_change', 'idle', 'maptypeid_changed', 'mousemove', 'mouseout', 'mouseover', 'projection_changed', 'resize', 'rightclick', 'tilesloaded', 'tilt_changed', 'zoom_changed'];

  var Map = exports.Map = function (_React$Component) {
    _inherits(Map, _React$Component);

    function Map(props) {
      _classCallCheck(this, Map);

      var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

      if (!props.hasOwnProperty('google')) {
        throw new Error('You must include a `google` prop');
      }

      _this.listeners = {};
      _this.state = {
        currentLocation: {
          lat: _this.props.initialCenter.lat,
          lng: _this.props.initialCenter.lng
        }
      };
      return _this;
    }

    _createClass(Map, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (this.props.centerAroundCurrentLocation) {
          if (navigator && navigator.geolocation) {
            this.geoPromise = (0, _cancelablePromise.makeCancelable)(new Promise(function (resolve, reject) {
              navigator.geolocation.getCurrentPosition(resolve, reject);
            }));

            this.geoPromise.promise.then(function (pos) {
              var coords = pos.coords;
              _this2.setState({
                currentLocation: {
                  lat: coords.latitude,
                  lng: coords.longitude
                }
              });
            }).catch(function (e) {
              return e;
            });
          }
        }
        this.loadMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevProps.google !== this.props.google) {
          this.loadMap();
        }
        if (this.props.visible !== prevProps.visible) {
          this.restyleMap();
        }
        if (this.props.zoom !== prevProps.zoom) {
          this.map.setZoom(this.props.zoom);
        }
        if (this.props.center !== prevProps.center) {
          this.setState({
            currentLocation: this.props.center
          });
        }
        if (prevState.currentLocation !== this.state.currentLocation) {
          this.recenterMap();
        }
        if (this.props.bounds !== prevProps.bounds) {
          this.map.fitBounds(this.props.bounds);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var google = this.props.google;

        if (this.geoPromise) {
          this.geoPromise.cancel();
        }
        Object.keys(this.listeners).forEach(function (e) {
          google.maps.event.removeListener(_this3.listeners[e]);
        });
      }
    }, {
      key: 'loadMap',
      value: function loadMap() {
        var _this4 = this;

        if (this.props && this.props.google) {
          var google = this.props.google;

          var maps = google.maps;

          var mapRef = this.refs.map;
          var node = _reactDom2.default.findDOMNode(mapRef);
          var curr = this.state.currentLocation;
          var center = new maps.LatLng(curr.lat, curr.lng);

          var mapTypeIds = this.props.google.maps.MapTypeId || {};
          var mapTypeFromProps = String(this.props.mapType).toUpperCase();

          var mapConfig = Object.assign({}, {
            mapTypeId: mapTypeIds[mapTypeFromProps],
            center: center,
            zoom: this.props.zoom,
            maxZoom: this.props.maxZoom,
            minZoom: this.props.minZoom,
            clickableIcons: !!this.props.clickableIcons,
            disableDefaultUI: this.props.disableDefaultUI,
            zoomControl: this.props.zoomControl,
            mapTypeControl: this.props.mapTypeControl,
            scaleControl: this.props.scaleControl,
            streetViewControl: this.props.streetViewControl,
            panControl: this.props.panControl,
            rotateControl: this.props.rotateControl,
            fullscreenControl: this.props.fullscreenControl,
            scrollwheel: this.props.scrollwheel,
            draggable: this.props.draggable,
            keyboardShortcuts: this.props.keyboardShortcuts,
            disableDoubleClickZoom: this.props.disableDoubleClickZoom,
            noClear: this.props.noClear,
            styles: this.props.styles,
            gestureHandling: this.props.gestureHandling
          });

          Object.keys(mapConfig).forEach(function (key) {
            // Allow to configure mapConfig with 'false'
            if (mapConfig[key] === null) {
              delete mapConfig[key];
            }
          });

          this.map = new maps.Map(node, mapConfig);

          evtNames.forEach(function (e) {
            _this4.listeners[e] = _this4.map.addListener(e, _this4.handleEvent(e));
          });
          maps.event.trigger(this.map, 'ready');
          this.forceUpdate();
        }
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evtName) {
        var _this5 = this;

        var timeout = void 0;
        var handlerName = 'on' + (0, _String.camelize)(evtName);

        return function (e) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          timeout = setTimeout(function () {
            if (_this5.props[handlerName]) {
              _this5.props[handlerName](_this5.props, _this5.map, e);
            }
          }, 0);
        };
      }
    }, {
      key: 'recenterMap',
      value: function recenterMap() {
        var map = this.map;

        var google = this.props.google;


        if (!google) return;
        var maps = google.maps;

        if (map) {
          var center = this.state.currentLocation;
          if (!(center instanceof google.maps.LatLng)) {
            center = new google.maps.LatLng(center.lat, center.lng);
          }
          // map.panTo(center)
          map.setCenter(center);
          maps.event.trigger(map, 'recenter');
        }
      }
    }, {
      key: 'restyleMap',
      value: function restyleMap() {
        if (this.map) {
          var google = this.props.google;

          google.maps.event.trigger(this.map, 'resize');
        }
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var _this6 = this;

        var children = this.props.children;


        if (!children) return;

        return _react2.default.Children.map(children, function (c) {
          if (!c) return;
          return _react2.default.cloneElement(c, {
            map: _this6.map,
            google: _this6.props.google,
            mapCenter: _this6.state.currentLocation
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var style = Object.assign({}, mapStyles.map, this.props.style, {
          display: this.props.visible ? 'inherit' : 'none'
        });

        var containerStyles = Object.assign({}, mapStyles.container, this.props.containerStyle);

        return _react2.default.createElement(
          'div',
          { style: containerStyles, className: this.props.className },
          _react2.default.createElement(
            'div',
            { style: style, ref: 'map' },
            'Loading map...'
          ),
          this.renderChildren()
        );
      }
    }]);

    return Map;
  }(_react2.default.Component);

  Map.propTypes = {
    google: _propTypes2.default.object,
    zoom: _propTypes2.default.number,
    centerAroundCurrentLocation: _propTypes2.default.bool,
    center: _propTypes2.default.object,
    initialCenter: _propTypes2.default.object,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    containerStyle: _propTypes2.default.object,
    visible: _propTypes2.default.bool,
    mapType: _propTypes2.default.string,
    maxZoom: _propTypes2.default.number,
    minZoom: _propTypes2.default.number,
    clickableIcons: _propTypes2.default.bool,
    disableDefaultUI: _propTypes2.default.bool,
    zoomControl: _propTypes2.default.bool,
    mapTypeControl: _propTypes2.default.bool,
    scaleControl: _propTypes2.default.bool,
    streetViewControl: _propTypes2.default.bool,
    panControl: _propTypes2.default.bool,
    rotateControl: _propTypes2.default.bool,
    fullscreenControl: _propTypes2.default.bool,
    scrollwheel: _propTypes2.default.bool,
    draggable: _propTypes2.default.bool,
    keyboardShortcuts: _propTypes2.default.bool,
    disableDoubleClickZoom: _propTypes2.default.bool,
    noClear: _propTypes2.default.bool,
    styles: _propTypes2.default.array,
    gestureHandling: _propTypes2.default.string,
    bounds: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Map.propTypes[(0, _String.camelize)(e)] = _propTypes2.default.func;
  });

  Map.defaultProps = {
    zoom: 14,
    initialCenter: {
      lat: 37.774929,
      lng: -122.419416
    },
    center: {},
    centerAroundCurrentLocation: false,
    style: {},
    containerStyle: {},
    visible: true
  };

  exports.default = Map;
});

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(32), __webpack_require__(781), __webpack_require__(783)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-dom'), require('./lib/ScriptCache'), require('./lib/GoogleApi'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactDom, global.ScriptCache, global.GoogleApi);
    global.GoogleApiComponent = mod.exports;
  }
})(this, function (exports, _react, _reactDom, _ScriptCache, _GoogleApi) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.wrapper = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _GoogleApi2 = _interopRequireDefault(_GoogleApi);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var defaultMapConfig = {};

  var serialize = function serialize(obj) {
    return JSON.stringify(obj);
  };
  var isSame = function isSame(obj1, obj2) {
    return obj1 === obj2 || serialize(obj1) === serialize(obj2);
  };

  var defaultCreateCache = function defaultCreateCache(options) {
    options = options || {};
    var apiKey = options.apiKey;
    var libraries = options.libraries || ['places'];
    var version = options.version || '3';
    var language = options.language || 'en';
    var url = options.url;
    var client = options.client;

    return (0, _ScriptCache.ScriptCache)({
      google: (0, _GoogleApi2.default)({
        apiKey: apiKey,
        language: language,
        libraries: libraries,
        version: version,
        url: url,
        client: client
      })
    });
  };

  var DefaultLoadingContainer = function DefaultLoadingContainer(props) {
    return _react2.default.createElement(
      'div',
      null,
      'Loading...'
    );
  };

  var wrapper = exports.wrapper = function wrapper(input) {
    return function (WrappedComponent) {
      var Wrapper = function (_React$Component) {
        _inherits(Wrapper, _React$Component);

        function Wrapper(props, context) {
          _classCallCheck(this, Wrapper);

          // Build options from input
          var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

          var options = typeof input === 'function' ? input(props) : input;

          // Initialize required Google scripts and other configured options
          _this.initialize(options);

          _this.state = {
            loaded: false,
            map: null,
            google: null,
            options: options
          };
          return _this;
        }

        _createClass(Wrapper, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            // Do not update input if it's not dynamic
            if (typeof input !== 'function') {
              return;
            }

            // Get options to compare
            var prevOptions = this.state.options;
            var options = typeof input === 'function' ? input(props) : input;

            // Ignore when options are not changed
            if (isSame(options, prevOptions)) {
              return;
            }

            // Initialize with new options
            this.initialize(options);

            // Save new options in component state,
            // and remove information about previous API handlers
            this.setState({
              options: options,
              loaded: false,
              google: null
            });
          }
        }, {
          key: 'initialize',
          value: function initialize(options) {
            // Avoid race condition: remove previous 'load' listener
            if (this.unregisterLoadHandler) {
              this.unregisterLoadHandler();
              this.unregisterLoadHandler = null;
            }

            // Load cache factory
            var createCache = options.createCache || defaultCreateCache;

            // Build script
            this.scriptCache = createCache(options);
            this.unregisterLoadHandler = this.scriptCache.google.onLoad(this.onLoad.bind(this));

            // Store information about loading container
            this.LoadingContainer = options.LoadingContainer || DefaultLoadingContainer;
          }
        }, {
          key: 'onLoad',
          value: function onLoad(err, tag) {
            this._gapi = window.google;

            this.setState({ loaded: true, google: this._gapi });
          }
        }, {
          key: 'render',
          value: function render() {
            var LoadingContainer = this.LoadingContainer;

            if (!this.state.loaded) {
              return _react2.default.createElement(LoadingContainer, null);
            }

            var props = Object.assign({}, this.props, {
              loaded: this.state.loaded,
              google: window.google
            });

            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(WrappedComponent, props),
              _react2.default.createElement('div', { ref: 'map' })
            );
          }
        }]);

        return Wrapper;
      }(_react2.default.Component);

      return Wrapper;
    };
  };

  exports.default = wrapper;
});

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(782)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('./windowOrGlobal'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.windowOrGlobal);
        global.ScriptCache = mod.exports;
    }
})(this, function (exports, window) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var counter = 0;
    var scriptMap = typeof window !== 'undefined' && window._scriptMap || new Map();
    var ScriptCache = exports.ScriptCache = function (global) {
        global._scriptMap = global._scriptMap || scriptMap;
        return function ScriptCache(scripts) {
            var Cache = {};

            Cache._onLoad = function (key) {
                return function (cb) {
                    var registered = true;

                    function unregister() {
                        registered = false;
                    }

                    var stored = scriptMap.get(key);

                    if (stored) {
                        stored.promise.then(function () {
                            if (registered) {
                                stored.error ? cb(stored.error) : cb(null, stored);
                            }

                            return stored;
                        });
                    } else {
                        // TODO:
                    }

                    return unregister;
                };
            };

            Cache._scriptTag = function (key, src) {
                if (!scriptMap.has(key)) {
                    // Server side rendering environments don't always have access to the `document` global.
                    // In these cases, we're not going to be able to return a script tag, so just return null.
                    if (typeof document === 'undefined') return null;

                    var tag = document.createElement('script');
                    var promise = new Promise(function (resolve, reject) {
                        var resolved = false,
                            errored = false,
                            body = document.getElementsByTagName('body')[0];

                        tag.type = 'text/javascript';
                        tag.async = false; // Load in order

                        var cbName = 'loaderCB' + counter++ + Date.now();
                        var cb = void 0;

                        var handleResult = function handleResult(state) {
                            return function (evt) {
                                var stored = scriptMap.get(key);
                                if (state === 'loaded') {
                                    stored.resolved = true;
                                    resolve(src);
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = []
                                } else if (state === 'error') {
                                    stored.errored = true;
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = [];
                                    reject(evt);
                                }
                                stored.loaded = true;

                                cleanup();
                            };
                        };

                        var cleanup = function cleanup() {
                            if (global[cbName] && typeof global[cbName] === 'function') {
                                global[cbName] = null;
                                delete global[cbName];
                            }
                        };

                        tag.onload = handleResult('loaded');
                        tag.onerror = handleResult('error');
                        tag.onreadystatechange = function () {
                            handleResult(tag.readyState);
                        };

                        // Pick off callback, if there is one
                        if (src.match(/callback=CALLBACK_NAME/)) {
                            src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
                            cb = window[cbName] = tag.onload;
                        } else {
                            tag.addEventListener('load', tag.onload);
                        }
                        tag.addEventListener('error', tag.onerror);

                        tag.src = src;
                        body.appendChild(tag);

                        return tag;
                    });
                    var initialState = {
                        loaded: false,
                        error: false,
                        promise: promise,
                        tag: tag
                    };
                    scriptMap.set(key, initialState);
                }
                return scriptMap.get(key);
            };

            // let scriptTags = document.querySelectorAll('script')
            //
            // NodeList.prototype.filter = Array.prototype.filter;
            // NodeList.prototype.map = Array.prototype.map;
            // const initialScripts = scriptTags
            //   .filter(s => !!s.src)
            //   .map(s => s.src.split('?')[0])
            //   .reduce((memo, script) => {
            //     memo[script] = script;
            //     return memo;
            //   }, {});

            Object.keys(scripts).forEach(function (key) {
                var script = scripts[key];

                var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);

                Cache[key] = {
                    tag: tag,
                    onLoad: Cache._onLoad(key)
                };
            });

            return Cache;
        };
    }(window);

    exports.default = ScriptCache;
});

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.windowOrGlobal = mod.exports;
  }
})(this, function (module) {
  'use strict';

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  module.exports = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || undefined;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.GoogleApi = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var GoogleApi = exports.GoogleApi = function GoogleApi(opts) {
    opts = opts || {};

    if (!opts.hasOwnProperty('apiKey')) {
      throw new Error('You must pass an apiKey to use GoogleApi');
    }

    var apiKey = opts.apiKey;
    var libraries = opts.libraries || ['places'];
    var client = opts.client;
    var URL = opts.url || 'https://maps.googleapis.com/maps/api/js';

    var googleVersion = opts.version || '3.31';

    var script = null;
    var google = typeof window !== 'undefined' && window.google || null;
    var loading = false;
    var channel = null;
    var language = opts.language;
    var region = opts.region || null;

    var onLoadEvents = [];

    var url = function url() {
      var url = URL;
      var params = {
        key: apiKey,
        callback: 'CALLBACK_NAME',
        libraries: libraries.join(','),
        client: client,
        v: googleVersion,
        channel: channel,
        language: language,
        region: region
      };

      var paramStr = Object.keys(params).filter(function (k) {
        return !!params[k];
      }).map(function (k) {
        return k + '=' + params[k];
      }).join('&');

      return url + '?' + paramStr;
    };

    return url();
  };

  exports.default = GoogleApi;
});

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(6), __webpack_require__(70)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.String);
    global.Marker = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Marker = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'dblclick', 'dragend', 'mousedown', 'mouseout', 'mouseover', 'mouseup', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Marker = exports.Marker = function (_React$Component) {
    _inherits(Marker, _React$Component);

    function Marker() {
      _classCallCheck(this, Marker);

      return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
    }

    _createClass(Marker, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.markerPromise = wrappedPromise();
        this.renderMarker();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
          if (this.marker) {
            this.marker.setMap(null);
          }
          this.renderMarker();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.marker) {
          this.marker.setMap(null);
        }
      }
    }, {
      key: 'renderMarker',
      value: function renderMarker() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            position = _props.position,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            label = _props.label,
            draggable = _props.draggable,
            title = _props.title,
            props = _objectWithoutProperties(_props, ['map', 'google', 'position', 'mapCenter', 'icon', 'label', 'draggable', 'title']);

        if (!google) {
          return null;
        }

        var pos = position || mapCenter;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = new google.maps.LatLng(pos.lat, pos.lng);
        }

        var pref = _extends({
          map: map,
          position: pos,
          icon: icon,
          label: label,
          title: title,
          draggable: draggable
        }, props);
        this.marker = new google.maps.Marker(pref);

        evtNames.forEach(function (e) {
          _this2.marker.addListener(e, _this2.handleEvent(e));
        });

        this.markerPromise.resolve(this.marker);
      }
    }, {
      key: 'getMarker',
      value: function getMarker() {
        return this.markerPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.marker, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Marker;
  }(_react2.default.Component);

  Marker.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Marker.propTypes[e] = _propTypes2.default.func;
  });

  Marker.defaultProps = {
    name: 'Marker'
  };

  exports.default = Marker;
});

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(6), __webpack_require__(32), __webpack_require__(247)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-dom/server'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.server);
    global.InfoWindow = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _server) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.InfoWindow = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _server2 = _interopRequireDefault(_server);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InfoWindow = exports.InfoWindow = function (_React$Component) {
    _inherits(InfoWindow, _React$Component);

    function InfoWindow() {
      _classCallCheck(this, InfoWindow);

      return _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).apply(this, arguments));
    }

    _createClass(InfoWindow, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.renderInfoWindow();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            google = _props.google,
            map = _props.map;


        if (!google || !map) {
          return;
        }

        if (map !== prevProps.map) {
          this.renderInfoWindow();
        }

        if (this.props.position !== prevProps.position) {
          this.updatePosition();
        }

        if (this.props.children !== prevProps.children) {
          this.updateContent();
        }

        if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker || this.props.position !== prevProps.position) {
          this.props.visible ? this.openWindow() : this.closeWindow();
        }
      }
    }, {
      key: 'renderInfoWindow',
      value: function renderInfoWindow() {
        var _props2 = this.props,
            map = _props2.map,
            google = _props2.google,
            mapCenter = _props2.mapCenter,
            props = _objectWithoutProperties(_props2, ['map', 'google', 'mapCenter']);

        if (!google || !google.maps) {
          return;
        }

        var iw = this.infowindow = new google.maps.InfoWindow(_extends({
          content: ''
        }, props));

        google.maps.event.addListener(iw, 'closeclick', this.onClose.bind(this));
        google.maps.event.addListener(iw, 'domready', this.onOpen.bind(this));
      }
    }, {
      key: 'onOpen',
      value: function onOpen() {
        if (this.props.onOpen) {
          this.props.onOpen();
        }
      }
    }, {
      key: 'onClose',
      value: function onClose() {
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    }, {
      key: 'openWindow',
      value: function openWindow() {
        this.infowindow.open(this.props.map, this.props.marker);
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition() {
        var pos = this.props.position;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = pos && new google.maps.LatLng(pos.lat, pos.lng);
        }
        this.infowindow.setPosition(pos);
      }
    }, {
      key: 'updateContent',
      value: function updateContent() {
        var content = this.renderChildren();
        this.infowindow.setContent(content);
      }
    }, {
      key: 'closeWindow',
      value: function closeWindow() {
        this.infowindow.close();
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var children = this.props.children;

        return _server2.default.renderToString(children);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return InfoWindow;
  }(_react2.default.Component);

  InfoWindow.propTypes = {
    children: _propTypes2.default.element.isRequired,
    map: _propTypes2.default.object,
    marker: _propTypes2.default.object,
    position: _propTypes2.default.object,
    visible: _propTypes2.default.bool,

    // callbacks
    onClose: _propTypes2.default.func,
    onOpen: _propTypes2.default.func
  };

  InfoWindow.defaultProps = {
    visible: false
  };

  exports.default = InfoWindow;
});

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(6), __webpack_require__(70)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.String);
    global.HeatMap = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.HeatMap = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseover', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var HeatMap = exports.HeatMap = function (_React$Component) {
    _inherits(HeatMap, _React$Component);

    function HeatMap() {
      _classCallCheck(this, HeatMap);

      return _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).apply(this, arguments));
    }

    _createClass(HeatMap, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.heatMapPromise = wrappedPromise();
        this.renderHeatMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
          if (this.heatMap) {
            this.heatMap.setMap(null);
            this.renderHeatMap();
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.heatMap) {
          this.heatMap.setMap(null);
        }
      }
    }, {
      key: 'renderHeatMap',
      value: function renderHeatMap() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            positions = _props.positions,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            gradient = _props.gradient,
            _props$radius = _props.radius,
            radius = _props$radius === undefined ? 20 : _props$radius,
            _props$opacity = _props.opacity,
            opacity = _props$opacity === undefined ? 0.2 : _props$opacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'positions', 'mapCenter', 'icon', 'gradient', 'radius', 'opacity']);

        if (!google) {
          return null;
        }

        var data = positions.map(function (pos) {
          return new google.maps.LatLng(pos.lat, pos.lng);
        });

        var pref = _extends({
          map: map,
          gradient: gradient,
          radius: radius,
          opacity: opacity,
          data: data
        }, props);

        this.heatMap = new google.maps.visualization.HeatmapLayer(pref);

        this.heatMap.set('radius', radius === undefined ? 20 : radius);

        this.heatMap.set('opacity', opacity === undefined ? 0.2 : opacity);

        evtNames.forEach(function (e) {
          _this2.heatMap.addListener(e, _this2.handleEvent(e));
        });

        this.heatMapPromise.resolve(this.heatMap);
      }
    }, {
      key: 'getHeatMap',
      value: function getHeatMap() {
        return this.heatMapPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.heatMap, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return HeatMap;
  }(_react2.default.Component);

  HeatMap.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object,
    icon: _propTypes2.default.string
  };

  evtNames.forEach(function (e) {
    return HeatMap.propTypes[e] = _propTypes2.default.func;
  });

  HeatMap.defaultProps = {
    name: 'HeatMap'
  };

  exports.default = HeatMap;
});

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(6), __webpack_require__(263), __webpack_require__(70)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Polygon = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polygon = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polygon = exports.Polygon = function (_React$Component) {
    _inherits(Polygon, _React$Component);

    function Polygon() {
      _classCallCheck(this, Polygon);

      return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
    }

    _createClass(Polygon, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polygonPromise = wrappedPromise();
        this.renderPolygon();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.paths, prevProps.paths)) {
          if (this.polygon) {
            this.polygon.setMap(null);
          }
          this.renderPolygon();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polygon) {
          this.polygon.setMap(null);
        }
      }
    }, {
      key: 'renderPolygon',
      value: function renderPolygon() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            paths = _props.paths,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            fillColor = _props.fillColor,
            fillOpacity = _props.fillOpacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'paths', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          paths: paths,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: fillColor,
          fillOpacity: fillOpacity
        }, props);

        this.polygon = new google.maps.Polygon(params);

        evtNames.forEach(function (e) {
          _this2.polygon.addListener(e, _this2.handleEvent(e));
        });

        this.polygonPromise.resolve(this.polygon);
      }
    }, {
      key: 'getPolygon',
      value: function getPolygon() {
        return this.polygonPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polygon, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polygon;
  }(_react2.default.Component);

  Polygon.propTypes = {
    paths: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polygon.propTypes[e] = _propTypes2.default.func;
  });

  Polygon.defaultProps = {
    name: 'Polygon'
  };

  exports.default = Polygon;
});

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.cancelablePromise = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html

  var makeCancelable = exports.makeCancelable = function makeCancelable(promise) {
    var hasCanceled_ = false;

    var wrappedPromise = new Promise(function (resolve, reject) {
      promise.then(function (val) {
        return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
      });
      promise.catch(function (error) {
        return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
      });
    });

    return {
      promise: wrappedPromise,
      cancel: function cancel() {
        hasCanceled_ = true;
      }
    };
  };
});

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(6), __webpack_require__(263), __webpack_require__(70)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Polyline = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polyline = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polyline = exports.Polyline = function (_React$Component) {
    _inherits(Polyline, _React$Component);

    function Polyline() {
      _classCallCheck(this, Polyline);

      return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
    }

    _createClass(Polyline, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polylinePromise = wrappedPromise();
        this.renderPolyline();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.path, prevProps.path)) {
          if (this.polyline) {
            this.polyline.setMap(null);
          }
          this.renderPolyline();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polyline) {
          this.polyline.setMap(null);
        }
      }
    }, {
      key: 'renderPolyline',
      value: function renderPolyline() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            path = _props.path,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            props = _objectWithoutProperties(_props, ['map', 'google', 'path', 'strokeColor', 'strokeOpacity', 'strokeWeight']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          path: path,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight
        }, props);

        this.polyline = new google.maps.Polyline(params);

        evtNames.forEach(function (e) {
          _this2.polyline.addListener(e, _this2.handleEvent(e));
        });

        this.polylinePromise.resolve(this.polyline);
      }
    }, {
      key: 'getPolyline',
      value: function getPolyline() {
        return this.polylinePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polyline, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polyline;
  }(_react2.default.Component);

  Polyline.propTypes = {
    path: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polyline.propTypes[e] = _propTypes2.default.func;
  });

  Polyline.defaultProps = {
    name: 'Polyline'
  };

  exports.default = Polyline;
});

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,setCoords:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,code:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var ZoneItem=function(_Component){_inherits(ZoneItem,_Component);function ZoneItem(){_classCallCheck(this,ZoneItem);return _possibleConstructorReturn(this,(ZoneItem.__proto__||Object.getPrototypeOf(ZoneItem)).apply(this,arguments));}_createClass(ZoneItem,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"zone-item "+(this.props.selected&&'selected'),onClick:function onClick(){return _this2.props.setCoords(_this2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,this.props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"code"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"C\xF3digo: "),this.props.code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content",dangerouslySetInnerHTML:{__html:this.props.description}}));}}]);return ZoneItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ZoneItem.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ZoneItem);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CdmInfrastructureDirectory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_current_tasks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_current_tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__json_current_tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_widgets_progress_bar__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_places__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_places___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__json_places__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_directory_place_form__ = __webpack_require__(262);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CdmInfrastructureDirectory=function(_Component){_inherits(CdmInfrastructureDirectory,_Component);_createClass(CdmInfrastructureDirectory,[{key:"render",value:function render(){var activity=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3__json_current_tasks___default.a.data,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(this.props.match.params.id)});var step=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(activity.tasks,{id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toInteger(this.props.match.params.step)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10 is-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* NavLink */],{to:"/cdm/tarea/"+activity.id,className:"button is-cdm-blue is-small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-arrow-left",style:{marginRight:'10px'}})," Volver a la tarea"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level cdm-header--dates"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Fecha l\xEDmite"),step.date_finish))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"level-item progress-detail"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_widgets_progress_bar__["a" /* default */],{total:100,detect:100})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header "+activity.category.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"category"},activity.category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,step.duration," d\xEDas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-header--title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,step.step+". "+step.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modified"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\xDAltima modificaci\xF3n"),"2018-08-16"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_directory_place_form__["a" /* default */],{addEntry:this.addEntry,entities:this.props.entities,changeMuns:this.props.changeMuns,nextId:this.state.directory.detail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"finished",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",className:"checkbox",id:"finished",value:"1",checked:step.finished?'checked':false,onChange:function onChange(){return true;}}),"He concluido esta tarea")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cdm-directory"},"[list here]"))));}}]);function CdmInfrastructureDirectory(){_classCallCheck(this,CdmInfrastructureDirectory);var _this=_possibleConstructorReturn(this,(CdmInfrastructureDirectory.__proto__||Object.getPrototypeOf(CdmInfrastructureDirectory)).call(this));_this.addEntry=_this.addEntry.bind(_this);_this.state={directory:{list:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__json_places___default.a.data)),detail:3}};return _this;}_createClass(CdmInfrastructureDirectory,[{key:"addEntry",value:function addEntry(directory){var id=this.state.directory.detail+1;return this.setState({directory:Object.assign({},this.state.directory,{detail:id,list:[].concat(_toConsumableArray(this.state.directory.list),[directory])})});}}]);return CdmInfrastructureDirectory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(CdmInfrastructureDirectory,{title:'Directorio de infraestructura',subnav:{icon:'fa-building',name:'Directorio',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_acervo__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sections_Home_ActionResults__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Sections_Home_SearchProjects__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Sections_Home_TableProjects__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UI_Paginator_Paginator__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_config__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Acervo=function(_Component){_inherits(Acervo,_Component);function Acervo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Acervo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Acervo.__proto__||Object.getPrototypeOf(Acervo)).call.apply(_ref,[this].concat(args))),_this),_this.state={projects:[],years:[],modalities:[],states:[],municipalities:[],dataForm:{},pagination:{itemsCountPerPage:10,activePage:1,totalItemsCount:0},wasFormSubmited:false,loadForm:false},_this.getMunicipalities=function(id){var access_token=_this.props.session.user.profile.access_token;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+access_token},method:'get'};var url=new URL(__WEBPACK_IMPORTED_MODULE_7__store_config__["a" /* ACERVO_URL */]+'/municipalities'),params={state_id:id};Object.keys(params).forEach(function(key){return url.searchParams.append(key,params[key]);});__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(response){var municipalities={};response.map(function(municipality){return municipalities[municipality.id]=municipality.name;});_this.setState({municipalities:municipalities});}).catch(console.log);},_this.updateDataForm=function(input){var object=Object.assign({},_this.state.dataForm);object[input.name]=input.value;_this.setState({dataForm:object});},_this.handlerFormSubmit=function(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;_this.setState({loadForm:true});var access_token=_this.props.session.user.profile.access_token;var _this$state$paginatio=_this.state.pagination,itemsCountPerPage=_this$state$paginatio.itemsCountPerPage,activePage=_this$state$paginatio.activePage;var dataForm=_this.state.dataForm;var params={limit:itemsCountPerPage,page:activePage};var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+access_token},method:'get'};var url=new URL(__WEBPACK_IMPORTED_MODULE_7__store_config__["a" /* ACERVO_URL */]+'/acervo/search');Object.keys(params).forEach(function(key){return url.searchParams.append(key,params[key]);});Object.keys(dataForm).forEach(function(key){return url.searchParams.append(key,dataForm[key]);});__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(response){var projects=response.data;var _response$meta=response.meta,current_page=_response$meta.current_page,total=_response$meta.total;var pagination=Object.assign({},_this.state.pagination);pagination['activePage']=current_page;pagination['totalItemsCount']=total;_this.setState({projects:projects,pagination:pagination,wasFormSubmited:true,loadForm:false});}).catch(console.log);},_this.handlerChangePage=function(page){var pagination=Object.assign({},_this.state.pagination);pagination['activePage']=page;_this.setState({pagination:pagination},function(){this.handlerFormSubmit(page);});},_this.handlerChangeAction=function(input){switch(input.name){case'itemsCountPerPage':var pagination=Object.assign({},_this.state.pagination);pagination['itemsCountPerPage']=parseInt(input.value,10);_this.setState({pagination:pagination},function(){this.handlerFormSubmit();});break;case'actionDownload':var selectedProjects=document.getElementsByClassName('checkbox');var listProjects=[];Array.prototype.forEach.call(selectedProjects,function(item){if(item.checked){listProjects.push(item.value);}});_this.hanlderDownloadProjects(listProjects,input.value);break;default:break;}},_this.handlerDownloadSingleProject=function(id,type){var access_token=_this.props.session.user.profile.access_token;var options={headers:{'Accept':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','Content-Type':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','Authorization':'Bearer '+access_token},method:'get'};var params={id:id,type:type};var url=new URL(__WEBPACK_IMPORTED_MODULE_7__store_config__["a" /* ACERVO_URL */]+'/acervo/getProjectReport');Object.keys(params).forEach(function(key){return url.searchParams.append(key,params[key]);});var fileName=undefined;var a=document.createElement("a");var objectURL=void 0;document.body.appendChild(a);a.style="display: none";__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){objectURL=URL.createObjectURL(blob);a.href=objectURL;a.download=fileName;a.click();window.URL.revokeObjectURL(objectURL);}).catch(console.log);},_this.hanlderDownloadProjects=function(ids,type){var access_token=_this.props.session.user.profile.access_token;var url=new URL(__WEBPACK_IMPORTED_MODULE_7__store_config__["a" /* ACERVO_URL */]+'/acervo/getReport');var params={ids:ids.toString(),type:type};var options={headers:{'Authorization':'Bearer '+access_token},method:'get',responseType:'blob'};Object.keys(params).forEach(function(key){return url.searchParams.append(key,params[key]);});var fileName=undefined;var a=document.createElement("a");var objectURL=void 0;document.body.appendChild(a);a.style="display: none";__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){var header=result.headers.get('Content-Disposition','attachment');fileName=header.match(/filename="(.+)"/)[1];return result.blob();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(blob){objectURL=URL.createObjectURL(blob);a.href=objectURL;a.download=fileName;a.click();window.URL.revokeObjectURL(objectURL);}).catch(console.log);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Acervo,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props$session$user$p=this.props.session.user.profile,email=_props$session$user$p.email,access_token=_props$session$user$p.access_token;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+access_token},method:'get'};var url=new URL(__WEBPACK_IMPORTED_MODULE_7__store_config__["a" /* ACERVO_URL */]+'/acervo/getSearchFilters'),params={user_email:email};Object.keys(params).forEach(function(key){return url.searchParams.append(key,params[key]);});__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(response){var years=response.years,modalities=response.modalities,states=response.states,municipalities=response.municipalities;_this2.setState({years:years,modalities:modalities,states:states,municipalities:municipalities});}).catch(console.log);}},{key:'render',value:function render(){var _state=this.state,projects=_state.projects,years=_state.years,modalities=_state.modalities,states=_state.states,municipalities=_state.municipalities,wasFormSubmited=_state.wasFormSubmited,loadForm=_state.loadForm;var _state$pagination=this.state.pagination,itemsCountPerPage=_state$pagination.itemsCountPerPage,totalItemsCount=_state$pagination.totalItemsCount,activePage=_state$pagination.activePage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-multiline is-centered is-home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'is-size-4'},'Busca tu proyecto')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Sections_Home_SearchProjects__["a" /* default */],{years:years,modalities:modalities,states:states,municipalities:municipalities,onChangeState:this.getMunicipalities,updateDataForm:this.updateDataForm,onSubmit:this.handlerFormSubmit,loadForm:loadForm})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Sections_Home_ActionResults__["a" /* default */],{onChange:this.handlerChangeAction,show:projects.length>0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Sections_Home_TableProjects__["a" /* default */],{projects:projects,onclickDownload:this.handlerDownloadSingleProject,wasFormSubmited:wasFormSubmited})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_UI_Paginator_Paginator__["a" /* default */],{itemsCountPerPage:itemsCountPerPage,totalItemsCount:totalItemsCount,activePage:activePage,onChange:this.handlerChangePage})));}}]);return Acervo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_acervo__["a" /* default */])(Acervo,{title:'Acervo',subnav:{icon:'fa-briefcase',name:'Acervo',actions:[]},stateNav:false,progress:false}));

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_Modal_Modal__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UI_Modal_ModalConfirm__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UI_Notifications_Notification__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_config__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Migrations=function(_Component){_inherits(Migrations,_Component);function Migrations(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Migrations);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Migrations.__proto__||Object.getPrototypeOf(Migrations)).call.apply(_ref,[this].concat(args))),_this),_this.state={migrations:[],deleteSuccess:'',migrationSuccess:'',failedMigrations:[],successMigration:[],showModalConfirm:false,yearToDelete:'',e:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef()},_this._getAllMigrations=function(){var access_token=_this.props.session.user.profile.access_token;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+access_token},method:'get'};var url=new URL(__WEBPACK_IMPORTED_MODULE_5__store_config__["a" /* ACERVO_URL */]+'/acervo-year-migrations?=year,asc'),params={orderBy:['year','asc']};Object.keys(params).forEach(function(key){return url.searchParams.append(key,params[key]);});__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(response){_this.setState({migrations:response});}).catch(console.log);},_this._deleteMigration=function(e,year){e.persist();var currentClassName=e.target.className,loaddingClassName=' is-loading';e.target.className=currentClassName+loaddingClassName;var access_token=_this.props.session.user.profile.access_token;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+access_token},method:'post'};var url=new URL(__WEBPACK_IMPORTED_MODULE_5__store_config__["a" /* ACERVO_URL */]+'/migrations/'+year+'/rollback');__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(response){e.target.className=currentClassName;var successMigration=_this.state.successMigration;successMigration.push('La migraci\xF3n del a\xF1o '+year+', se elimin\xF3 correctamente.');_this.setState({successMigration:successMigration},function(){return _this._getAllMigrations();});}).catch(function(error){console.error(error);e.target.className=currentClassName;var failedMigrations='Ocurri\xF3 un error.<br />Por favor int\xE9ntalo nuevamente m\xE1s tarde.';_this.setState({failedMigrations:failedMigrations});});},_this._makeMigration=function(e,year){var currentClassName=e.target.className,loaddingClassName=' is-loading';e.target.className=currentClassName+loaddingClassName;e.persist();var access_token=_this.props.session.user.profile.access_token;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+access_token},method:'post'};var url=new URL(__WEBPACK_IMPORTED_MODULE_5__store_config__["a" /* ACERVO_URL */]+'/migrations/'+year+'/migrate');__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(response){e.target.className=currentClassName;var successMigration=_this.state.successMigration;successMigration.push('La migraci\xF3n del a\xF1o '+year+', se realiz\xF3 correctamente.');_this.setState({successMigration:successMigration},function(){return _this._getAllMigrations();});}).catch(function(error){console.error(error);e.target.className=currentClassName;var failedMigrations=_this.state.failedMigrations;failedMigrations.push('La migraci\xF3n del a\xF1o '+year+', no se pudo completar.<br />Por favor int\xE9ntalo nuevamente m\xE1s tarde.');_this.setState({failedMigrations:failedMigrations});});},_this._closeConfirmModal=function(value){_this.setState({showModalConfirm:value,yearToDelete:''});},_this._successDeleteMigration=function(value){var _this$state=_this.state,e=_this$state.e,yearToDelete=_this$state.yearToDelete;e.persist();_this.setState({showModalConfirm:value},function(){_this._deleteMigration(e,yearToDelete);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Migrations,[{key:'componentDidMount',value:function componentDidMount(){this._getAllMigrations();}},{key:'render',value:function render(){var _this2=this;var _state=this.state,migrations=_state.migrations,successMigration=_state.successMigration,failedMigrations=_state.failedMigrations,showModalConfirm=_state.showModalConfirm;var _props=this.props,visible=_props.visible,closeModal=_props.closeModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UI_Modal_ModalConfirm__["a" /* default */],{title:'Eliminar migraci\xF3n',confirm:this._successDeleteMigration,close:this._closeConfirmModal,isActive:showModalConfirm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Se eliminar\xE1 la migraci\xF3n, \xBFDesea continuar?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Modal_Modal__["a" /* default */],{title:'Migrar Acervo',visible:visible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},successMigration.length>0?successMigration.map(function(element,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UI_Notifications_Notification__["a" /* default */],{key:key,text:element,color:'success'});}):'',failedMigrations.length>0?failedMigrations.map(function(element,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UI_Notifications_Notification__["a" /* default */],{key:key,text:element,color:'danger'});}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-bordered is-fullwidth is-acervo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'a\xF1o'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'has-text-centered'},'migrado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,migrations.map(function(migration,key){var isDisabledDelete=migration.status?'':'is-static';var isDisabledMigrate=migration.status?'is-static':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},key+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},migration.year),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:migration.status?'has-text-success fa fa-check':'has-text-danger fa fa-times'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{disabled:migration.status?'disabled':'',className:'button is-success is-small '+isDisabledMigrate,onClick:function onClick(e){return _this2._makeMigration(e,migration.year);}},'Migrar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{disabled:migration.status?'':'disabled',className:'button is-danger is-small '+isDisabledDelete,onClick:function onClick(e){return _this2.setState({yearToDelete:migration.year,showModalConfirm:true,e:e});}},'Eliminar'))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-pulled-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button',onClick:closeModal},'Cerrar')))));}}]);return Migrations;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Migrations);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_Component){_inherits(Modal,_Component);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:'render',value:function render(){var _props=this.props,title=_props.title,children=_props.children,visible=_props.visible;var isActive=visible?' is-active':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"modal"+isActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'modal-card-body'},children)));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalConfirm=function(_Component){_inherits(ModalConfirm,_Component);function ModalConfirm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalConfirm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalConfirm.__proto__||Object.getPrototypeOf(ModalConfirm)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalConfirm,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){this.setState({active:props.isActive});}},{key:'render',value:function render(){var _props=this.props,title=_props.title,children=_props.children,close=_props.close,confirm=_props.confirm;var active=this.state.active;var showModal=active?' is-active':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"modal"+showModal,style:{zIndex:41}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'modal-card-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'modal-card-title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete','aria-label':'close',onClick:function onClick(e){return close(false);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'modal-card-body'},children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'modal-card-foot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-success',onClick:function onClick(e){return confirm(false);}},'Aceptar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button',onClick:function onClick(e){return close(false);}},'Cancelar'))));}}]);return ModalConfirm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ModalConfirm);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notification=function(_Component){_inherits(Notification,_Component);function Notification(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Notification);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Notification.__proto__||Object.getPrototypeOf(Notification)).call.apply(_ref,[this].concat(args))),_this),_this.state={show:true},_this._closeNotification=function(){return _this.setState({show:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Notification,[{key:'render',value:function render(){var _this2=this;var show=this.state.show;var isInvisible=show?'':'is-invisible';var _props=this.props,text=_props.text,color=_props.color;return show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification is-'+color+' '+isInvisible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'delete',onClick:function onClick(e){return _this2._closeNotification();}}),text):'';}}]);return Notification;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Select_Select__ = __webpack_require__(265);
var Actionresults=function Actionresults(props){var _onChange=props.onChange,show=props.show;if(show)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-vertical-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'colum is-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'is-size-4'},'Resultados')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-2 is-offset-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:''},'MOSTRAR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-acervo-dark-green is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Select_Select__["a" /* default */],{placeholder:'Seleccionar',defaultValue:10,name:'itemsCountPerPage',items:{'10':10,'25':25,'50':50,'100':100},onChange:function onChange(e){return _onChange(e.target);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:''},'ACCIONES'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-acervo-dark-green is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Select_Select__["a" /* default */],{placeholder:'Seleccionar',name:'actionDownload',items:{'basic':'Generar reporte','detail':'Generar reporte detallado'},onChange:function onChange(e){return _onChange(e.target);}}))));else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);};/* harmony default export */ __webpack_exports__["a"] = (Actionresults);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Select_Select__ = __webpack_require__(265);
var SearchProjects=function SearchProjects(props){var onChangeState=props.onChangeState,updateDataForm=props.updateDataForm,onSubmit=props.onSubmit,loadForm=props.loadForm;var buttonIsLoading=loadForm?' is-loading':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field has-addons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'input is-acervo-green is-medium',placeholder:'Folio de proyecto, Estado, Municipio, etc...',type:'text',name:'folio',onChange:function onChange(e){return updateDataForm(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-medium is-acervo-dark-green'+buttonIsLoading,onClick:onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'is-acervo-dark-green fa fa-search'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'fieldset is-acervo-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,'Filtra tu b\xFAsqueda'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtitle-1'},'Entre m\xE1s espec\xEDfica sea tu b\xFAsqueda, mejores resultados obtendr\xE1s'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-acervo-dark-green is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Select_Select__["a" /* default */],{items:props.years,placeholder:'A\xF1o',name:'year',onChange:function onChange(e){return updateDataForm(e.target);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-acervo-dark-green is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Select_Select__["a" /* default */],{items:props.modalities,placeholder:'Modalidad',name:'modality_id',onChange:function onChange(e){return updateDataForm(e.target);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-acervo-dark-green is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Select_Select__["a" /* default */],{items:props.states,placeholder:'Estado',name:'state_id',onChange:function onChange(e){return onChangeState(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select is-acervo-dark-green is-fullwidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Select_Select__["a" /* default */],{items:props.municipalities,placeholder:'Municipio',name:'municipality_id',onChange:function onChange(e){return updateDataForm(e.target);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'project_name',className:'input is-acervo-green',placeholder:'Nombre del proyecto',onChange:function onChange(e){return updateDataForm(e.target);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-4.5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'agency_name',className:'input is-acervo-green',placeholder:'Nombre de la Instancia',onChange:function onChange(e){return updateDataForm(e.target);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-4.5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control is-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'titular_name',className:'input is-acervo-green',placeholder:'Titular de la Instancia',onChange:function onChange(e){return updateDataForm(e.target);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button is-button-acervo is-acervo-dark-green is-fullwidth'+buttonIsLoading,onClick:onSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'is-acervo-dark-green fa fa-search'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text'},'BUSCAR')))))));};/* harmony default export */ __webpack_exports__["a"] = (SearchProjects);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var TableProjects=function TableProjects(props){var projects=props.projects,onclickDownload=props.onclickDownload,wasFormSubmited=props.wasFormSubmited;function onSelectedAllProjects(e){var checkBoxes=document.getElementsByClassName('checkbox');var isChecked=e.checked;Array.prototype.forEach.call(checkBoxes,function(item){item.checked=isChecked;});}if(projects.length===0)if(wasFormSubmited)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'has-text-centered'},'No se encontraron resultados');else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-bordered is-fullwidth is-acervo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'checkbox-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return onSelectedAllProjects(e.target);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'a\xF1o'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'modalidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'municipio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'folio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'proyecto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'acciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,projects.map(function(project){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:project.project_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'checkbox-green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'checkbox',type:'checkbox',value:project.project_id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,project.year),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,project.modality_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,project.state_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,project.municipality_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,project.project_code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,project.project_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{'display':'flex-inline'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/acervo/proyectos/'+project.project_id,className:'button is-rounded is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-rounded is-small',onClick:function onClick(e){return onclickDownload(project.project_id,'');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button is-rounded is-small',onClick:function onClick(e){return onclickDownload(project.project_id,'detail');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon is-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-archive-o'}))))));})));};/* harmony default export */ __webpack_exports__["a"] = (TableProjects);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_acervo__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sections_Detail_Project__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Sections_Detail_Agency__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Sections_Detail_Headline__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Sections_Detail_Goals__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Sections_Detail_Expenses__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UI_Paginator_Paginator__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Sections_Detail_DetailHeader__ = __webpack_require__(808);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AcervoDetail=function(_Component){_inherits(AcervoDetail,_Component);function AcervoDetail(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AcervoDetail);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AcervoDetail.__proto__||Object.getPrototypeOf(AcervoDetail)).call.apply(_ref,[this].concat(args))),_this),_this.state={project:{},pagination:{itemsCountPerPage:1,activePage:1,totalItemsCount:5}},_this.handlerChangePage=function(page){var pagination=Object.assign({},_this.state.pagination);pagination['activePage']=page;_this.setState({pagination:pagination});},_this.renderPage=function(page){var project=_this.state.project;if(Object.keys(project).length===0)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No hay informaci\xF3n para mostrar');switch(page){case 1:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Sections_Detail_Project__["a" /* default */],{project:project});case 2:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Sections_Detail_Agency__["a" /* default */],{agency:project.agency});case 3:if(project.titular===undefined||project.titular===null)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No hay informaci\xF3n para mostrar');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Sections_Detail_Headline__["a" /* default */],{headline:project.titular});case 4:if(project.goals.length===0)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No hay informaci\xF3n para mostrar');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Sections_Detail_Goals__["a" /* default */],{goals:project.goals});case 5:if(project.expenses.length===0)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No hay informaci\xF3n para mostrar');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Sections_Detail_Expenses__["a" /* default */],{expenses:project.expenses});default:break;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AcervoDetail,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var access_token=this.props.session.user.profile.access_token,id=this.props.match.params.id;var options={headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+access_token},method:'get'};var url=new URL(__WEBPACK_IMPORTED_MODULE_9__store_config__["a" /* ACERVO_URL */]+'/projects/'+id);__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(url,options).then(function(result){if(result.status>=200&&result.status<300){return result.json();}else{return result.json().then(Promise.reject.bind(Promise));}}).then(function(response){_this2.setState({project:response});}).catch(console.log);}},{key:'render',value:function render(){var _state$pagination=this.state.pagination,itemsCountPerPage=_state$pagination.itemsCountPerPage,totalItemsCount=_state$pagination.totalItemsCount,activePage=_state$pagination.activePage;var TitlePage={1:'Detalles del proyecto',2:'Detalles de la agencia',3:'Detalles del titular',4:'Detalles de las metas',5:'Detalles de los gastos'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns is-multiline is-centered acervo-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Sections_Detail_DetailHeader__["a" /* default */],{title:TitlePage[activePage]}),this.renderPage(activePage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_UI_Paginator_Paginator__["a" /* default */],{itemsCountPerPage:itemsCountPerPage,totalItemsCount:totalItemsCount,activePage:activePage,onChange:this.handlerChangePage})));}}]);return AcervoDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__templates_acervo__["a" /* default */])(AcervoDetail,{title:'Acervo',subnav:{icon:'fa-briefcase',name:'Acervo',actions:[]},stateNav:false,progress:false}));

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_currency_format__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_currency_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_currency_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UI_Label_LabelDetailHtml__ = __webpack_require__(803);
var Project=function Project(props){var _props$project=props.project,year=_props$project.year,modality=_props$project.modality,inegi_code=_props$project.inegi_code,state=_props$project.state,municipality=_props$project.municipality,code=_props$project.code,name=_props$project.name,objective=_props$project.objective,justification=_props$project.justification,total_goals=_props$project.total_goals,total_expenses=_props$project.total_expenses,application_amount=_props$project.application_amount,approved_amount=_props$project.approved_amount,disbursed_amount=_props$project.disbursed_amount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-bordered is-fullwidth table-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'a\xF1o',description:year})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'modalidad',description:modality})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'clave inegi',description:inegi_code})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'entidad',description:state})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'municipio',description:municipality}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'folio',description:code})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'nombre',description:name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UI_Label_LabelDetailHtml__["a" /* default */],{title:'objetivo',description:objective}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UI_Label_LabelDetailHtml__["a" /* default */],{title:'justificaci\xF3n',description:justification}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',width:'50%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'total metas',description:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(total_goals)||0,displayType:'text',thousandSeparator:true,prefix:'$'})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2',width:'50%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'total gastos de operaci\xF3n',description:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(total_expenses)||0,displayType:'text',thousandSeparator:true,prefix:'$'})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'monto solicitado',description:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(application_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'monto aprobado',description:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(approved_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_Label_LabelDetail__["a" /* default */],{title:'monto ejercido',description:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(disbursed_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})})))))));};/* harmony default export */ __webpack_exports__["a"] = (Project);

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
exports.returnTrue = returnTrue;
exports.charIsNumber = charIsNumber;
exports.escapeRegExp = escapeRegExp;
exports.fixLeadingZero = fixLeadingZero;
exports.splitString = splitString;
exports.limitToScale = limitToScale;
exports.roundToPrecision = roundToPrecision;
exports.omit = omit;
exports.setCaretPosition = setCaretPosition;


// basic noop function
function noop() {}
function returnTrue() {
  return true;
}

function charIsNumber(char) {
  return !!(char || '').match(/\d/);
}

function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

function fixLeadingZero(numStr) {
  if (!numStr) return numStr;
  var isNegative = numStr[0] === '-';
  if (isNegative) numStr = numStr.substring(1, numStr.length);
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return '' + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? '.' + afterDecimal : '');
}

function splitString(str, index) {
  return [str.substring(0, index), str.substring(index)];
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr, scale, fixedDecimalScale) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr, scale, fixedDecimalScale) {
  var numberParts = numStr.split('.');
  var roundedDecimalParts = parseFloat('0.' + (numberParts[1] || '0')).toFixed(scale).split('.');
  var intPart = numberParts[0].split('').reverse().reduce(function (roundedStr, current, idx) {
    if (roundedStr.length > idx) {
      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
    }
    return current + roundedStr;
  }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(roundedDecimalParts[1] || '', (numberParts[1] || '').length, fixedDecimalScale);

  return intPart + (decimalPart ? '.' + decimalPart : '');
}

function omit(obj, keyMaps) {
  var filteredObj = {};
  Object.keys(obj).forEach(function (key) {
    if (!keyMaps[key]) filteredObj[key] = obj[key];
  });
  return filteredObj;
}

/** set the caret positon in an input field **/
function setCaretPosition(el, caretPos) {
  el.value = el.value;
  // ^ this is used to not only get "focus", but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

var thousandGroupSpacing = exports.thousandGroupSpacing = {
  two: '2',
  twoScaled: '2s',
  three: '3',
  four: '4'
};

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LabelDetailHtml=function LabelDetailHtml(props){var title=props.title,description=props.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:description},className:'description'}));};/* harmony default export */ __webpack_exports__["a"] = (LabelDetailHtml);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__ = __webpack_require__(159);
var Agency=function Agency(props){var agency=props.agency;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-bordered is-fullwidth table-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'inegi',description:agency.inegi_code})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'Entidad',description:agency.state})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'municipio',description:agency.municipality})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'tipo',description:agency.type}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'nombre',description:agency.name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'colonia',description:agency.suburb})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'calle',description:agency.street})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'two-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'n\xFAm. ext.',description:agency.num_ext}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'int',description:agency.num_int}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'c.p.',description:agency.zip_code}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'correo electr\xF3nico',description:agency.email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'correo electr\xF3nico 2',description:agency.email_2}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'tel\xE9fono',description:agency.phone})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'tel\xE9fono 2',description:agency.phone_2})))))));};/* harmony default export */ __webpack_exports__["a"] = (Agency);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__ = __webpack_require__(159);
var Headline=function Headline(props){var _props$headline=props.headline,name=_props$headline.name,last_name=_props$headline.last_name,second_surname=_props$headline.second_surname,rfc=_props$headline.rfc,curp=_props$headline.curp,email=_props$headline.email,email_2=_props$headline.email_2,phone=_props$headline.phone,phone_2=_props$headline.phone_2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-bordered is-fullwidth table-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'nombre',description:name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'apellido paterno',description:last_name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'apellido materno',description:second_surname})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'rfc',description:rfc}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'curp',description:curp})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'correo electr\xF3nico',description:email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'correo electr\xF3nico 2',description:email_2}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'tel\xE9fono',description:phone})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Label_LabelDetail__["a" /* default */],{title:'tel\xE9fono 2',description:phone_2})))))));};/* harmony default export */ __webpack_exports__["a"] = (Headline);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_currency_format__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_currency_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_currency_format__);
var Goals=function Goals(props){var goals=props.goals;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-bordered is-fullwidth table-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'l\xEDnea de acci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'eje tem\xE1tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'monto solicitado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'monto aprobado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'monto ejercido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,goals.map(function(goal,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,goal.proigualdad_line),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,goal.proigualdad_axis),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,goal.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(goal.application_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(goal.approved_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(goal.disbursed_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})));})))));};/* harmony default export */ __webpack_exports__["a"] = (Goals);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_currency_format__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_currency_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_currency_format__);
var Expenses=function Expenses(props){var expenses=props.expenses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table is-bordered is-fullwidth table-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'tipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'monto unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'monto solicitado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'monto aprobado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'monto ejercido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,expenses.map(function(expense,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,expense.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,expense.expense_type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-centered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(expense.quantity)||0,displayType:'text',thousandSeparator:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(expense.unit_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(expense.application_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(expense.approved_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_currency_format___default.a,{value:parseFloat(expense.disbursed_amount)||0,displayType:'text',thousandSeparator:true,prefix:'$'})));})))));};/* harmony default export */ __webpack_exports__["a"] = (Expenses);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UI_Buttons_ReturnButton__ = __webpack_require__(809);
var DetailHeader=function DetailHeader(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'is-size-4'},props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column is-2 is-pulled-right has-text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UI_Buttons_ReturnButton__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (DetailHeader);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var ReturnButton=function ReturnButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:'/acervo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button btn-return is-fullWidth'},'Regresar'));};/* harmony default export */ __webpack_exports__["a"] = (ReturnButton);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotFound=function(_Component){_inherits(NotFound,_Component);function NotFound(){_classCallCheck(this,NotFound);return _possibleConstructorReturn(this,(NotFound.__proto__||Object.getPrototypeOf(NotFound)).apply(this,arguments));}_createClass(NotFound,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero is-dark is-fullheight"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"title"},"404"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"subtitle"},"No pudimos encontrar la p\xE1gina que buscas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Puedes regresar al ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* NavLink */],{to:"/",className:"has-text-inm-purple"},"Inicio")," y volver a intentar."))));}}]);return NotFound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CdmPlanning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CdmPlanning=function(_Component){_inherits(CdmPlanning,_Component);function CdmPlanning(){_classCallCheck(this,CdmPlanning);return _possibleConstructorReturn(this,(CdmPlanning.__proto__||Object.getPrototypeOf(CdmPlanning)).apply(this,arguments));}_createClass(CdmPlanning,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column no-padding-column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table cdm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Proceso"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Tarea"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Inicia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Termina"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Responsable"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Estatus"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/planeacion/editar/1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2._getConfirm(1,"Identificar instituciones, programas y servicios");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"}))),"1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-detect"},"DETECTAR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Identificar instituciones, programs y servicios")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-10"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-21"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Promotor/a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-success"},"Concluido"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/planeacion/editar/1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2._getConfirm(1,"Establecer convenios");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"}))),"2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-coordinate"},"COORDINAR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Establecer convenios")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-21"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-10-01"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Coordinador/a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-info"},"Iniciado"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/planeacion/editar/1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2._getConfirm(1,"Coordinar alianzas locales");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"}))),"3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-coordinate"},"COORDINAR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Coordinar alianzas locales")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-10-01"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-10-05"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Coordinador/a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-info"},"Iniciado"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/planeacion/editar/1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2._getConfirm(1,"Solicitar materiales");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"}))),"4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-manage"},"GESTIONAR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Solicitar materiales")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-21"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-30"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Coordinador/a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-danger"},"Sin iniciar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/planeacion/editar/1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2._getConfirm(1,"Identificar actores/as sociales, usuarias/os con potencial de l\xEDder e infraestructura en el municipio");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"}))),"5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-detect"},"DETECTAR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Identificar actores/as sociales, usuarias/os con potencial de l\xEDder e infraestructura en el municipio")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-21"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-30"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Promotor/a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-danger"},"Sin iniciar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/planeacion/editar/1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2._getConfirm(1,"Administrar materiales");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"}))),"6"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-manage"},"GESTIONAR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Administrar materiales")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-21"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-30"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Coordinador/a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-danger"},"Sin iniciar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/planeacion/editar/1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2._getConfirm(1,"Incluir a la comunidad");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"}))),"7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",{className:"has-text-integrate"},"INTEGRAR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Incluir a la comunidad")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-21"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2018-09-30"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Promotor/a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"has-text-danger"},"Sin iniciar")))))));}},{key:"_getConfirm",value:function _getConfirm(id,name){Object(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:"\xBFEst\xE1s seguro/(a) de eliminar la actividad "+name+"?",confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return console.log('ELIMINAR ITEM',id);}});}}]);return CdmPlanning;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(CdmPlanning,{title:'Planeación',subnav:{icon:'fa-calendar-check-o',name:'Planear',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CdmPlanningEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_current_tasks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_current_tasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__json_current_tasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker_es__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_forms_wysiwyg_field__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_widgets_big_file_upload__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CdmPlanningEdit=function(_Component){_inherits(CdmPlanningEdit,_Component);_createClass(CdmPlanningEdit,[{key:"render",value:function render(){var _this2=this;var task=__WEBPACK_IMPORTED_MODULE_4__json_current_tasks___default.a.data[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"process-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"process",className:"label"},"Proceso"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:0,disabled:true,selected:true},"--- Proceso ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("optgroup",{label:"Procesos sustantivos"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{selected:true,value:1},"Detectar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:2},"Integrar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:3},"Formar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:4},"Acompa\xF1ar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:5},"Reconocer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("optgroup",{label:"Procesos de soporte"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:6},"Planear"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:7},"Coordinar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:8},"Gestionar"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Subproceso"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"name",id:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:0,selected:true,disabled:true},"--- Subproceso ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:1,selected:true},"Identificar instituciones, programas y servicios"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:2},"Identificar actores/as sociales, usuarias/os con potencial de l\xEDder e infraestructura en el municipio"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"objective",className:"label"},"Objetivo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_forms_wysiwyg_field__["a" /* default */],{ref:"objective",id:"objective",placeholder:"Pol\xEDticas y lineamientos",value:task.purpose,onChange:function onChange(value){return console.log(value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"rules",className:"label"},"Pol\xEDticas / Lineamientos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_forms_wysiwyg_field__["a" /* default */],{ref:"rules",id:"rules",placeholder:"Pol\xEDticas y lineamientos",value:task.rules,onChange:function onChange(value){return console.log(value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"report",className:"label"},"Datos a reportar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_forms_wysiwyg_field__["a" /* default */],{ref:"report",id:"report",placeholder:"Datos a reportar",value:task.report_info,onChange:function onChange(value){return console.log(value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"start_date",className:"label"},"Fecha inicio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_datepicker_es__["a" /* default */],{className:"input",name:"start_date",ref:"start_date",dateFormat:"YYYY-MM-DD",selected:this.state.start_date,placeholderText:__WEBPACK_IMPORTED_MODULE_5_moment__().format('YYYY-MM-DD'),onChange:function onChange(date){return console.log(date);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"end_date",className:"label"},"Fecha fin"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_datepicker_es__["a" /* default */],{className:"input",name:"end_date",ref:"end_date",dateFormat:"YYYY-MM-DD",selected:this.state.end_date,placeholderText:__WEBPACK_IMPORTED_MODULE_5_moment__().format('YYYY-MM-DD'),onChange:function onChange(date){return console.log(date);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"title is-5"},"Pasos")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-pulled-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/cdm",className:"button is-cdm-light-blue"},"Agregar paso"))))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(task.tasks,function(act,a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero is-light",style:{marginBottom:'10px'},key:"task-activity-"+a},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"step-"+a,className:"label"},"Paso ",a+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{value:act.title,type:"text",id:"step-"+a,name:"step-"+a,className:"input",onChange:function onChange(value){return console.log(value);},disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"responsible",className:"label"},"Responsable"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"input",value:act.role.name,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"days",className:"label"},"D\xEDas para completar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"number",name:"days",id:"days",className:"input",value:act.duration}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"desc",className:"label"},"Descripci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_forms_wysiwyg_field__["a" /* default */],{ref:"desc",id:"desc",placeholder:"Descripci\xF3n detallada",value:act.description,onChange:function onChange(value){return console.log(value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"title is-6"},"Entregables"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-multiline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"3",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"3"}),"Mapa con pol\xEDgonos")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"4",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"4"}),"Directorio usuarios/as con potencial de l\xEDder y actores sociales")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"1",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"1"}),"Directorio de instituciones")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"2",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"2"}),"Directorio de programas y servicios")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"5",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"5"}),"Lista de asistencia")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"6",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"6"}),"Inventario de materiales")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"7",className:"checkbox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"7"}),"Evidencia fotogr\xE1fica"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"file-name",className:"label"},"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",id:"file-name",name:"file-name",value:"Formato 1",className:"input"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"file",className:"label"},"Agregar descargable"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_widgets_big_file_upload__["a" /* default */],{name:"Descargable",model:"project.file"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"file-list",className:"label"},"Formatos vinculados"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-download",style:{marginRight:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"file.docx",download:"formato_descargable.docx"},"Formato 1"))))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"colmuns no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:"button is-large",to:"/cdm/planeacion"},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return console.log(_this2.state);},className:"button is-cdm-blue is-large",type:"button"},"Guardar"))))))));}}]);function CdmPlanningEdit(){_classCallCheck(this,CdmPlanningEdit);var _this=_possibleConstructorReturn(this,(CdmPlanningEdit.__proto__||Object.getPrototypeOf(CdmPlanningEdit)).call(this));_this.state={start_date:__WEBPACK_IMPORTED_MODULE_5_moment__('2018-09-10'),end_date:__WEBPACK_IMPORTED_MODULE_5_moment__('2018-09-21'),objective:'Conocer el universo de programas, servicios y recursos públicos disponibles a nivel municipal, estatal y nacional, particularmente dirigidos a las mujeres.',rules:'<p>Cada que se requiera, verificar que la información de las instituciones, programas y servicios siga vigente; en caso contrario se complementará y/o actualizará.</p> <p>Integrar al catálogo de instituciones, todos aquellos programas y servicios nuevos que se identifiquen.</p>',report:'<p>Programs y servicios disponibles para las mujeres en el municipio.</p><ul><li>Descripción general</li><li>Dirección</li><li>Responsables: nombre completo, cargo, número de teléfono y cuenta de correo</li><li>Requisitos para participar</li></ul>',step1:'<p>Revisar el mapa del municipio reconociendo sus características y lo dividirá en polígonos que le permitan trabajar en zonas más pequeñas, programar recorridos y actividades en cada uno.</p>'};return _this;}return CdmPlanningEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(CdmPlanningEdit,{title:'Editar subproceso',subnav:{icon:'fa-calendar-check-o',name:'Editar subproceso',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PersonsDirectory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_users__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__json_users__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PersonsDirectory=function(_Component){_inherits(PersonsDirectory,_Component);function PersonsDirectory(){_classCallCheck(this,PersonsDirectory);return _possibleConstructorReturn(this,(PersonsDirectory.__proto__||Object.getPrototypeOf(PersonsDirectory)).apply(this,arguments));}_createClass(PersonsDirectory,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column no-padding-column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"inm-table cdm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Clave"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Type"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Polygon"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Estatus"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5__json_users___default.a.data,function(row,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"user-directory-row-"+r},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{to:"/cdm/directorio/personas/editar/"+row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2._getConfirm(1,row.name);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-trash-o"}))),row.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,row.name+" "+row.last_name+" "+row.slast_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.polygon.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,row.status));})))));}},{key:"_getConfirm",value:function _getConfirm(id,name){Object(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert__["confirmAlert"])({title:'¿Está seguro?',message:"\xBFEst\xE1s seguro/(a) de eliminar la actividad "+name+"?",confirmLabel:'Aceptar',cancelLabel:'Cancelar',onConfirm:function onConfirm(){return console.log('ELIMINAR ITEM',id);}});}}]);return PersonsDirectory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(PersonsDirectory,{title:'Directorio de usuarios',subnav:{icon:'fa-calendar-check-o',name:'Planear',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PersonsDirectoryEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_cdm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_users__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__json_users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PersonsDirectoryEdit=function(_Component){_inherits(PersonsDirectoryEdit,_Component);_createClass(PersonsDirectoryEdit,[{key:"render",value:function render(){var _this2=this;var user=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_4__json_users___default.a.data,{id:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toInteger(this.props.match.params.id)});console.log('USER',user);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns is-centered"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column is-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"process-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"name",className:"label"},"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"input",name:"name",id:"name",value:user.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"last_name",className:"label"},"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"input",name:"last_name",id:"last_name",value:user.last_name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"slast_name",className:"label"},"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"input",name:"slast_name",id:"slast_name",value:user.slast_name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"job",className:"label"},"Ocupaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"input",id:"job",name:"job",value:user.job,placeholder:"Ocupaci\xF3n"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"code",className:"label"},"Clave"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",name:"code",id:"code",className:"input",value:user.code,placeholder:"Clave de usuaria/o"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"type",className:"label"},"Tipo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"type",id:"type"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"0",selected:true,disabled:true},"--- Tipo ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"1"},"Mujer l\xEDder"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"2",selected:true},"Actor/a social")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"polygon",className:"label"},"Pol\xEDgono"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"polygon",id:"polygon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"0",selected:true,disabled:true},"--- Pol\xEDgono ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"1"},"Zona 1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"2",selected:true},"Zona 2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"represents",className:"label"},"Representa a"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"input",id:"represents",name:"represents",placeholder:"Representa a",value:user.represents})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"influence",className:"label"},"Zona de influencia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"input",name:"influence",id:"influence",placeholder:"Zona de influencia",value:user.influence}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"title is-5"},"Domicilio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"address",className:"label"},"Calle y n\xFAmero"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",id:"address",name:"address",className:"input",placeholder:"Calle y n\xFAmero",value:user.address})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"address2",className:"label"},"Colonia / Localidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",id:"address2",name:"address2",className:"input",placeholder:"Colonia / Localidad",value:user.address2}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"zipcode",className:"label"},"C\xF3digo postal"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",name:"zipcode",id:"zipcode",className:"input",placeholder:"C\xF3digo postal",value:user.zipcode})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-fullwidth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"state",className:"label"},"Estado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{name:"state",id:"state"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"0",selected:true,disabled:true},"--- Estado ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"AGS"},"Aguascalientes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"BCN"},"Baja California"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"BCS"},"Baja California Sur"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"CAM"},"Campeche"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"CHP"},"Chiapas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"CHH"},"Chihuahua"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"COA"},"Coahuila de Zaragoza"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"COL",selected:true},"Colima"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"CMX"},"Distrito Federal"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"DUR"},"Durango"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"GUA"},"Guanajuato"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"GRO"},"Guerrero"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"HID"},"Hidalgo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"JAL"},"Jalisco"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"MIC"},"Michoac\xE1n de Ocampo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"MOR"},"Morelos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"MEX"},"M\xE9xico"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"NAY"},"Nayarit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"NLE"},"Nuevo Le\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"OAX"},"Oaxaca"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"PUE"},"Puebla"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"QTO"},"Quer\xE9taro"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"QRO"},"Quintana Roo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"SLP"},"San Luis Potos\xED"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"SIN"},"Sinaloa"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"SON"},"Sonora"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"TAB"},"Tabasco"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"TAM"},"Tamaulipas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"TLA"},"Tlaxcala"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"VER"},"Veracruz de Ignacio de la Llave"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"YUC"},"Yucat\xE1n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"ZAC"},"Zacatecas")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"municipality",className:"label"},"Municipio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{id:"municipality"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{disabled:""},"--- Municipios ---"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"coquimatlan-74"},"Coquimatl\xE1n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"manzanillo-77"},"Manzanillo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"minatitlan-78"},"Minatitl\xE1n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"tecoman-79"},"Tecom\xE1n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"villa-de-alvarez-80",selected:true},"Villa de \xC1lvarez"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"phone",className:"label"},"Tel\xE9fono"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"tel",id:"phone",name:"phone",className:"input",placeholder:"Tel\xE9fono",value:user.phone})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control is-expanded"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"email",className:"label"},"E-mail"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"email",id:"email",name:"email",className:"input",placeholder:"E-mail",value:user.email}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"colmuns no-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"field is-grouped is-grouped-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* NavLink */],{className:"button is-large",to:"/cdm/planeacion"},"Regresar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"control"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return console.log(_this2.state);},className:"button is-cdm-blue is-large",type:"button"},"Guardar"))))))));}}]);function PersonsDirectoryEdit(){_classCallCheck(this,PersonsDirectoryEdit);var _this=_possibleConstructorReturn(this,(PersonsDirectoryEdit.__proto__||Object.getPrototypeOf(PersonsDirectoryEdit)).call(this));_this.state={start_date:__WEBPACK_IMPORTED_MODULE_5_moment__('2018-09-10'),end_date:__WEBPACK_IMPORTED_MODULE_5_moment__('2018-09-21'),objective:'Conocer el universo de programas, servicios y recursos públicos disponibles a nivel municipal, estatal y nacional, particularmente dirigidos a las mujeres.',rules:'<p>Cada que se requiera, verificar que la información de las instituciones, programas y servicios siga vigente; en caso contrario se complementará y/o actualizará.</p> <p>Integrar al catálogo de instituciones, todos aquellos programas y servicios nuevos que se identifiquen.</p>',report:'<p>Programs y servicios disponibles para las mujeres en el municipio.</p><ul><li>Descripción general</li><li>Dirección</li><li>Responsables: nombre completo, cargo, número de teléfono y cuenta de correo</li><li>Requisitos para participar</li></ul>',step1:'<p>Revisar el mapa del municipio reconociendo sus características y lo dividirá en polígonos que le permitan trabajar en zonas más pequeñas, programar recorridos y actividades en cada uno.</p>'};return _this;}return PersonsDirectoryEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__templates_cdm__["a" /* default */])(PersonsDirectoryEdit,{title:'Editar persona',subnav:{icon:'fa-user',name:'Editar persona',actions:[]},stateNav:true,progress:true}));

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e0c1c177.js